webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_dist_logger__ = __webpack_require__(2649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_dist_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__content__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__contentState__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__contextMenu__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__data__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__discussion__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__explorer__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__file__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__findReplace__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__folder__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__layout__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modal__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__notification__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__queue__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__syncedContent__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__userInfo__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__workspace__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__locationTemplate__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__data_empties_emptyPublishLocation__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__data_empties_emptySyncLocation__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__data_constants__ = __webpack_require__(94);






























__WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vuex__["e" /* default */]);

var debug = "production" !== 'production';

var store = new __WEBPACK_IMPORTED_MODULE_7_vuex__["e" /* default */].Store({
  modules: {
    content: __WEBPACK_IMPORTED_MODULE_9__content__["a" /* default */],
    contentState: __WEBPACK_IMPORTED_MODULE_10__contentState__["a" /* default */],
    contextMenu: __WEBPACK_IMPORTED_MODULE_11__contextMenu__["a" /* default */],
    data: __WEBPACK_IMPORTED_MODULE_12__data__["a" /* default */],
    discussion: __WEBPACK_IMPORTED_MODULE_13__discussion__["a" /* default */],
    explorer: __WEBPACK_IMPORTED_MODULE_14__explorer__["a" /* default */],
    file: __WEBPACK_IMPORTED_MODULE_15__file__["a" /* default */],
    findReplace: __WEBPACK_IMPORTED_MODULE_16__findReplace__["a" /* default */],
    folder: __WEBPACK_IMPORTED_MODULE_17__folder__["a" /* default */],
    layout: __WEBPACK_IMPORTED_MODULE_18__layout__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_19__modal__["a" /* default */],
    notification: __WEBPACK_IMPORTED_MODULE_20__notification__["a" /* default */],
    publishLocation: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__locationTemplate__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_26__data_empties_emptyPublishLocation__["a" /* default */]),
    queue: __WEBPACK_IMPORTED_MODULE_21__queue__["a" /* default */],
    syncedContent: __WEBPACK_IMPORTED_MODULE_22__syncedContent__["a" /* default */],
    syncLocation: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__locationTemplate__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_27__data_empties_emptySyncLocation__["a" /* default */]),
    userInfo: __WEBPACK_IMPORTED_MODULE_23__userInfo__["a" /* default */],
    workspace: __WEBPACK_IMPORTED_MODULE_24__workspace__["a" /* default */]
  },
  state: {
    light: false,
    offline: false,
    lastOfflineCheck: 0,
    timeCounter: 0
  },
  mutations: {
    setLight: function setLight(state, value) {
      state.light = value;
    },
    setOffline: function setOffline(state, value) {
      state.offline = value;
    },
    updateLastOfflineCheck: function updateLastOfflineCheck(state) {
      state.lastOfflineCheck = Date.now();
    },
    updateTimeCounter: function updateTimeCounter(state) {
      state.timeCounter += 1;
    }
  },
  getters: {
    allItemsById: function allItemsById(state) {
      var result = {};
      __WEBPACK_IMPORTED_MODULE_28__data_constants__["a" /* default */].types.forEach(function (type) {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(result, state[type].itemsById);
      });
      return result;
    },
    pathsByItemId: function pathsByItemId(state, getters) {
      var result = {};
      var processNode = function processNode(node) {
        var parentPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        var path = parentPath;
        if (node.item.id) {
          path += node.item.name;
          if (node.isTrash) {
            path = '.stackedit-trash/';
          } else if (node.isFolder) {
            path += '/';
          }
          result[node.item.id] = path;
        }

        if (node.isFolder) {
          node.folders.forEach(function (child) {
            return processNode(child, path);
          });
          node.files.forEach(function (child) {
            return processNode(child, path);
          });
        }
      };

      processNode(getters['explorer/rootNode']);
      return result;
    },
    itemsByPath: function itemsByPath(state, _ref) {
      var allItemsById = _ref.allItemsById,
          pathsByItemId = _ref.pathsByItemId;

      var result = {};
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(pathsByItemId).forEach(function (_ref2) {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
            id = _ref3[0],
            path = _ref3[1];

        var items = result[path] || [];
        items.push(allItemsById[id]);
        result[path] = items;
      });
      return result;
    },
    gitPathsByItemId: function gitPathsByItemId(state, _ref4) {
      var allItemsById = _ref4.allItemsById,
          pathsByItemId = _ref4.pathsByItemId;

      var result = {};
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(allItemsById).forEach(function (_ref5) {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
            id = _ref6[0],
            item = _ref6[1];

        if (item.type === 'data') {
          result[id] = '.stackedit-data/' + id + '.json';
        } else if (item.type === 'file') {
          var filePath = pathsByItemId[id];
          result[id] = filePath + '.md';
          result[id + '/content'] = '/' + filePath + '.md';
        } else if (item.type === 'content') {
          var _id$split = id.split('/'),
              _id$split2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_id$split, 1),
              fileId = _id$split2[0];

          var _filePath = pathsByItemId[fileId];
          result[fileId] = _filePath + '.md';
          result[id] = '/' + _filePath + '.md';
        } else if (item.type === 'folder') {
          result[id] = pathsByItemId[id];
        } else if (item.type === 'syncLocation' || item.type === 'publishLocation') {
          var encodedItem = __WEBPACK_IMPORTED_MODULE_8__services_utils__["a" /* default */].encodeBase64(__WEBPACK_IMPORTED_MODULE_8__services_utils__["a" /* default */].serializeObject(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, {
            id: undefined,
            type: undefined,
            fileId: undefined,
            hash: undefined
          })), true);
          var extension = item.type === 'syncLocation' ? 'sync' : 'publish';
          result[id] = pathsByItemId[item.fileId] + '.' + encodedItem + '.' + extension;
        }
      });
      return result;
    },
    itemIdsByGitPath: function itemIdsByGitPath(state, _ref7) {
      var gitPathsByItemId = _ref7.gitPathsByItemId;

      var result = {};
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(gitPathsByItemId).forEach(function (_ref8) {
        var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref8, 2),
            id = _ref9[0],
            path = _ref9[1];

        result[path] = id;
      });
      return result;
    },
    itemsByGitPath: function itemsByGitPath(state, _ref10) {
      var allItemsById = _ref10.allItemsById,
          gitPathsByItemId = _ref10.gitPathsByItemId;

      var result = {};
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(gitPathsByItemId).forEach(function (_ref11) {
        var _ref12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref11, 2),
            id = _ref12[0],
            path = _ref12[1];

        var item = allItemsById[id];
        if (item) {
          result[path] = item;
        }
      });
      return result;
    },
    isSponsor: function isSponsor(_ref13, getters) {
      var light = _ref13.light;

      if (light) {
        return true;
      }
      if (!getters['data/serverConf'].allowSponsorship) {
        return true;
      }
      var sponsorToken = getters['workspace/sponsorToken'];
      return sponsorToken ? sponsorToken.isSponsor : false;
    }
  },
  actions: {
    setOffline: function setOffline(_ref14, value) {
      var state = _ref14.state,
          commit = _ref14.commit,
          dispatch = _ref14.dispatch;

      if (state.offline !== value) {
        commit('setOffline', value);
        if (state.offline) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('You are offline.'));
        }
        dispatch('notification/info', 'You are back online!');
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    }
  },
  strict: debug,
  plugins: debug ? [__WEBPACK_IMPORTED_MODULE_5_vuex_dist_logger___default()()] : []
});

setInterval(function () {
  store.commit('updateTimeCounter');
}, 30 * 1000);

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_js_yaml__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_js_yaml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_js_yaml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_clunderscore__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_presets__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_constants__ = __webpack_require__(94);












var uidLength = 16;
var crypto = window.crypto || window.msCrypto;
var alphabet = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
var radix = alphabet.length;
var array = new Uint32Array(uidLength);

var parseQueryParams = function parseQueryParams(params) {
  var result = {};
  params.split('&').forEach(function (param) {
    var _param$split$map = param.split('=').map(decodeURIComponent),
        _param$split$map2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_param$split$map, 2),
        key = _param$split$map2[0],
        value = _param$split$map2[1];

    if (key && value != null) {
      result[key] = value;
    }
  });
  return result;
};

var filterParams = function filterParams() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var result = {};
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default()(params).forEach(function (_ref) {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (key && value != null) {
      result[key] = value;
    }
  });
  return result;
};

var deepOverride = function deepOverride(obj, opt) {
  if (obj === undefined) {
    return opt;
  }
  var objType = Object.prototype.toString.call(obj);
  var optType = Object.prototype.toString.call(opt);
  if (objType !== optType) {
    return obj;
  }
  if (objType !== '[object Object]') {
    return opt === undefined ? obj : opt;
  }
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, obj, opt)).forEach(function (key) {
    obj[key] = deepOverride(obj[key], opt[key]);
  });
  return obj;
};

var urlParser = document.createElement('a');

var deepCopy = function deepCopy(obj) {
  if (obj == null) {
    return obj;
  }
  return JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(obj));
};

var computedPresets = {};
__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_9__data_presets__["a" /* default */]).forEach(function (key) {
  var preset = deepCopy(__WEBPACK_IMPORTED_MODULE_9__data_presets__["a" /* default */][key][0]);
  if (__WEBPACK_IMPORTED_MODULE_9__data_presets__["a" /* default */][key][1]) {
    preset = deepOverride(preset, __WEBPACK_IMPORTED_MODULE_9__data_presets__["a" /* default */][key][1]);
  }
  computedPresets[key] = preset;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  computedPresets: computedPresets,
  queryParams: parseQueryParams(window.location.hash.slice(1)),
  setQueryParams: function setQueryParams() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    this.queryParams = filterParams(params);
    var serializedParams = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default()(this.queryParams).map(function (_ref3) {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];

      return encodeURIComponent(key) + '=' + encodeURIComponent(value);
    }).join('&');
    var hash = '#' + serializedParams;
    if (window.location.hash !== hash) {
      window.location.replace(hash);
    }
  },
  sanitizeText: function sanitizeText(text) {
    var result = ('' + (text || '')).slice(0, __WEBPACK_IMPORTED_MODULE_10__data_constants__["a" /* default */].textMaxLength);

    return (result + '\n').replace(/\n\n$/, '\n');
  },
  sanitizeName: function sanitizeName(name) {
    return ('' + (name || '')).slice(0, 250) || __WEBPACK_IMPORTED_MODULE_10__data_constants__["a" /* default */].defaultName;
  },
  sanitizeFilename: function sanitizeFilename(name) {
    return this.sanitizeName(('' + (name || '')).replace(/[/\x00-\x1F\x7f-\xa0\s]+/g, ' ').trim()) || __WEBPACK_IMPORTED_MODULE_10__data_constants__["a" /* default */].defaultName;
  },

  deepCopy: deepCopy,
  serializeObject: function serializeObject(obj) {
    return obj === undefined ? obj : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(obj, function (key, value) {
      if (Object.prototype.toString.call(value) !== '[object Object]') {
        return value;
      }

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(value).sort().reduce(function (sorted, valueKey) {
        sorted[valueKey] = value[valueKey];
        return sorted;
      }, {});
    });
  },
  search: function search(items, criteria) {
    var result = void 0;
    items.some(function (item) {
      if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default()(criteria).every(function (_ref5) {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
            key = _ref6[0],
            value = _ref6[1];

        return value === item[key];
      })) {
        result = item;
      }
      return result;
    });
    return result;
  },
  uid: function uid() {
    crypto.getRandomValues(array);
    return array.cl_map(function (value) {
      return alphabet[value % radix];
    }).join('');
  },
  hash: function hash(str) {
    var hash = 0;
    if (!str) return hash;
    for (var i = 0; i < str.length; i += 1) {
      var char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash |= 0;
    }
    return hash;
  },
  getItemHash: function getItemHash(item) {
    return this.hash(this.serializeObject(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, item, {
      id: undefined,
      hash: undefined,
      history: undefined
    })));
  },
  addItemHash: function addItemHash(item) {
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, item, {
      hash: this.getItemHash(item)
    });
  },
  makeWorkspaceId: function makeWorkspaceId(params) {
    return Math.abs(this.hash(this.serializeObject(params))).toString(36);
  },
  getDbName: function getDbName(workspaceId) {
    var dbName = 'stackedit-db';
    if (workspaceId !== 'main') {
      dbName += '-' + workspaceId;
    }
    return dbName;
  },
  encodeBase64: function encodeBase64(str) {
    var urlSafe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var uriEncodedStr = encodeURIComponent(str);
    var utf8Str = uriEncodedStr.replace(/%([0-9A-F]{2})/g, function (match, p1) {
      return String.fromCharCode('0x' + p1);
    });
    var result = btoa(utf8Str);
    if (!urlSafe) {
      return result;
    }
    return result.replace(/\//g, '_').replace(/\+/g, '-').replace(/=+$/, '');
  },
  decodeBase64: function decodeBase64(str) {
    var sanitizedStr = str.replace(/_/g, '/').replace(/-/g, '+');
    var utf8Str = atob(sanitizedStr);
    var uriEncodedStr = utf8Str.split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join('');
    return decodeURIComponent(uriEncodedStr);
  },
  computeProperties: function computeProperties(yamlProperties) {
    var properties = {};
    try {
      properties = __WEBPACK_IMPORTED_MODULE_7_js_yaml___default.a.safeLoad(yamlProperties) || {};
    } catch (e) {}
    var extensions = properties.extensions || {};
    var computedPreset = deepCopy(computedPresets[extensions.preset] || computedPresets.default);
    var computedExtensions = deepOverride(computedPreset, properties.extensions);
    computedExtensions.preset = extensions.preset;
    properties.extensions = computedExtensions;
    return properties;
  },
  randomize: function randomize(value) {
    return Math.floor((1 + Math.random() * 0.2) * value);
  },
  setInterval: function (_setInterval) {
    function setInterval(_x4, _x5) {
      return _setInterval.apply(this, arguments);
    }

    setInterval.toString = function () {
      return _setInterval.toString();
    };

    return setInterval;
  }(function (func, interval) {
    return setInterval(function () {
      return func();
    }, this.randomize(interval));
  }),
  awaitSequence: function awaitSequence(values, asyncFunc) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var results, valuesLeft, runWithNextValue;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              results = [];
              valuesLeft = values.slice().reverse();

              runWithNextValue = function () {
                var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (valuesLeft.length) {
                            _context.next = 2;
                            break;
                          }

                          return _context.abrupt('return', results);

                        case 2:
                          _context.t0 = results;
                          _context.next = 5;
                          return asyncFunc(valuesLeft.pop());

                        case 5:
                          _context.t1 = _context.sent;

                          _context.t0.push.call(_context.t0, _context.t1);

                          return _context.abrupt('return', runWithNextValue());

                        case 8:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this);
                }));

                return function runWithNextValue() {
                  return _ref7.apply(this, arguments);
                };
              }();

              return _context2.abrupt('return', runWithNextValue());

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  },
  awaitSome: function awaitSome(asyncFunc) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return asyncFunc();

            case 2:
              if (!_context3.sent) {
                _context3.next = 4;
                break;
              }

              return _context3.abrupt('return', _this2.awaitSome(asyncFunc));

            case 4:
              return _context3.abrupt('return', null);

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }))();
  },
  someResult: function someResult(values, func) {
    var result = void 0;
    values.some(function (value) {
      result = func(value);
      return result;
    });
    return result;
  },

  parseQueryParams: parseQueryParams,
  addQueryParams: function addQueryParams() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var hash = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var keys = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(params).filter(function (key) {
      return params[key] != null;
    });
    urlParser.href = url;
    if (!keys.length) {
      return urlParser.href;
    }
    var serializedParams = keys.map(function (key) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
    if (hash) {
      if (urlParser.hash) {
        urlParser.hash += '&';
      } else {
        urlParser.hash = '#';
      }
      urlParser.hash += serializedParams;
    } else {
      if (urlParser.search) {
        urlParser.search += '&';
      } else {
        urlParser.search = '?';
      }
      urlParser.search += serializedParams;
    }
    return urlParser.href;
  },
  resolveUrl: function resolveUrl(baseUrl, path) {
    var oldBaseElt = document.getElementsByTagName('base')[0];
    var oldHref = oldBaseElt && oldBaseElt.href;
    var newBaseElt = oldBaseElt || document.head.appendChild(document.createElement('base'));
    newBaseElt.href = baseUrl;
    urlParser.href = path;
    var result = urlParser.href;
    if (oldBaseElt) {
      oldBaseElt.href = oldHref;
    } else {
      document.head.removeChild(newBaseElt);
    }
    return result;
  },
  getHostname: function getHostname(url) {
    urlParser.href = url;
    return urlParser.hostname;
  },
  encodeUrlPath: function encodeUrlPath(path) {
    return path ? path.split('/').map(encodeURIComponent).join('/') : '';
  },
  parseGithubRepoUrl: function parseGithubRepoUrl(url) {
    var parsedRepo = url && url.match(/([^/:]+)\/([^/]+?)(?:\.git|\/)?$/);
    return parsedRepo && {
      owner: parsedRepo[1],
      repo: parsedRepo[2]
    };
  },
  parseGitlabProjectPath: function parseGitlabProjectPath(url) {
    var parsedProject = url && url.match(/^https:\/\/[^/]+\/(.+?)(?:\.git|\/)?$/);
    return parsedProject && parsedProject[1];
  },
  createHiddenIframe: function createHiddenIframe(url) {
    var iframeElt = document.createElement('iframe');
    iframeElt.style.position = 'absolute';
    iframeElt.style.left = '-99px';
    iframeElt.style.width = '1px';
    iframeElt.style.height = '1px';
    iframeElt.src = url;
    return iframeElt;
  },
  wrapRange: function wrapRange(range, eltProperties) {
    var rangeLength = ('' + range).length;
    var wrappedLength = 0;
    var treeWalker = document.createTreeWalker(range.commonAncestorContainer, NodeFilter.SHOW_TEXT);
    var startOffset = range.startOffset;

    treeWalker.currentNode = range.startContainer;
    if (treeWalker.currentNode.nodeType === Node.TEXT_NODE || treeWalker.nextNode()) {
      do {
        if (treeWalker.currentNode.nodeValue !== '\n') {
          (function () {
            if (treeWalker.currentNode === range.endContainer && range.endOffset < treeWalker.currentNode.nodeValue.length) {
              treeWalker.currentNode.splitText(range.endOffset);
            }
            if (startOffset) {
              treeWalker.currentNode = treeWalker.currentNode.splitText(startOffset);
              startOffset = 0;
            }
            var elt = document.createElement('span');
            __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default()(eltProperties).forEach(function (_ref8) {
              var _ref9 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref8, 2),
                  key = _ref9[0],
                  value = _ref9[1];

              elt[key] = value;
            });
            treeWalker.currentNode.parentNode.insertBefore(elt, treeWalker.currentNode);
            elt.appendChild(treeWalker.currentNode);
          })();
        }
        wrappedLength += treeWalker.currentNode.nodeValue.length;
        if (wrappedLength >= rangeLength) {
          break;
        }
      } while (treeWalker.nextNode());
    }
  },
  unwrapRange: function unwrapRange(eltCollection) {
    Array.prototype.slice.call(eltCollection).forEach(function (elt) {
      for (var child = elt.firstChild; child; child = elt.firstChild) {
        if (child.nodeType === 3) {
          if (elt.previousSibling && elt.previousSibling.nodeType === 3) {
            child.nodeValue = elt.previousSibling.nodeValue + child.nodeValue;
            elt.parentNode.removeChild(elt.previousSibling);
          }
          if (!child.nextSibling && elt.nextSibling && elt.nextSibling.nodeType === 3) {
            child.nodeValue += elt.nextSibling.nodeValue;
            elt.parentNode.removeChild(elt.nextSibling);
          }
        }
        elt.parentNode.insertBefore(child, elt);
      }
      elt.parentNode.removeChild(elt);
    });
  }
});

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(2);




var lastEarnedFeatureIds = null;
var debounceTimeoutId = void 0;

var showInfo = function showInfo() {
  var earnedBadges = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters['data/allBadges'].filter(function (badge) {
    return badge.isEarned && !lastEarnedFeatureIds.has(badge.featureId);
  });
  if (earnedBadges.length) {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('notification/badge', earnedBadges.length > 1 ? 'You\'ve earned ' + earnedBadges.length + ' badges: ' + earnedBadges.map(function (badge) {
      return '"' + badge.name + '"';
    }).join(', ') + '.' : 'You\'ve earned 1 badge: "' + earnedBadges[0].name + '".');
  }
  lastEarnedFeatureIds = null;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  addBadge: function addBadge(featureId) {
    if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters['data/badgeCreations'][featureId]) {
      if (!lastEarnedFeatureIds) {
        var earnedFeatureIds = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters['data/allBadges'].filter(function (badge) {
          return badge.isEarned;
        }).map(function (badge) {
          return badge.featureId;
        });
        lastEarnedFeatureIds = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(earnedFeatureIds);
      }

      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('data/patchBadgeCreations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, featureId, {
        created: Date.now()
      }));

      clearTimeout(debounceTimeoutId);
      debounceTimeoutId = setTimeout(function () {
        return showInfo();
      }, 5000);
    }
  }
});

/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ModalInner__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormEntry__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(2);










var collator = new Intl.Collator(undefined, { sensitivity: 'base' });

/* harmony default export */ __webpack_exports__["a"] = (function (desc) {
  var component = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, desc, {
    data: function data() {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, desc.data ? desc.data() : {}, {
        errorTimeouts: {}
      });
    },
    components: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, desc.components || {}, {
      ModalInner: __WEBPACK_IMPORTED_MODULE_6__ModalInner__["a" /* default */],
      FormEntry: __WEBPACK_IMPORTED_MODULE_7__FormEntry__["a" /* default */]
    }),
    computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, desc.computed || {}, {
      config: function config() {
        return __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters['modal/config'];
      },
      currentFileName: function currentFileName() {
        return __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters['file/current'].name;
      }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, desc.methods || {}, {
      openFileProperties: function openFileProperties() {
        return __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].dispatch('modal/open', 'fileProperties');
      },
      setError: function setError(name) {
        clearTimeout(this.errorTimeouts[name]);
        var formEntry = this.$el.querySelector('.form-entry[error=' + name + ']');
        if (formEntry) {
          formEntry.classList.add('form-entry--error');
          this.errorTimeouts[name] = setTimeout(function () {
            formEntry.classList.remove('form-entry--error');
          }, 1000);
        }
      }
    })
  });
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(desc.computedLocalSettings || {}).forEach(function (_ref) {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
        key = _ref2[0],
        id = _ref2[1];

    component.computed[key] = {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters['data/localSettings'][id];
      },
      set: function set(value) {
        __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].dispatch('data/patchLocalSettings', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, id, value));
      }
    };
    if (key === 'selectedTemplate') {
      component.computed.allTemplatesById = function () {
        var allTemplatesById = __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters['data/allTemplatesById'];
        var sortedTemplatesById = {};
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(allTemplatesById).sort(function (_ref3, _ref4) {
          var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
              template1 = _ref6[1];

          var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref4, 2),
              template2 = _ref5[1];

          return collator.compare(template1.name, template2.name);
        }).forEach(function (_ref7) {
          var _ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
              templateId = _ref8[0],
              template = _ref8[1];

          sortedTemplatesById[templateId] = template;
        });
        return sortedTemplatesById;
      };

      component.methods.configureTemplates = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref10, selectedId;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].dispatch('modal/open', {
                  type: 'templates',
                  selectedId: this.selectedTemplate
                });

              case 2:
                _ref10 = _context.sent;
                selectedId = _ref10.selectedId;

                __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].dispatch('data/patchLocalSettings', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, id, selectedId));

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  });
  component.computedLocalSettings = null;
  return component;
});

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_diff_match_patch__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_diff_match_patch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_diff_match_patch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prismjs__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prismjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_markdown_it_pandoc_renderer__ = __webpack_require__(2143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_markdown_it_pandoc_renderer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_markdown_it_pandoc_renderer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__editor_cledit__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__libs_pagedown__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__libs_htmlSanitizer__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__markdownConversionSvc__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__markdownGrammarSvc__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__editor_sectionUtils__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__extensionSvc__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__editor_editorSvcDiscussions__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__editor_editorSvcUtils__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__store__ = __webpack_require__(2);


























var allowDebounce = function allowDebounce(action, wait) {
  var timeoutId = void 0;
  return function () {
    for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }

    var doDebounce = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    clearTimeout(timeoutId);
    if (doDebounce) {
      timeoutId = setTimeout(function () {
        return action.apply(undefined, params);
      }, wait);
    } else {
      action.apply(undefined, params);
    }
  };
};

var diffMatchPatch = new __WEBPACK_IMPORTED_MODULE_11_diff_match_patch___default.a();
var instantPreview = true;
var tokens = void 0;

var SectionDesc = function SectionDesc(section, previewElt, tocElt, html) {
  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_classCallCheck___default()(this, SectionDesc);

  this.section = section;
  this.editorElt = section.elt;
  this.previewElt = previewElt;
  this.tocElt = tocElt;
  this.html = html;
};

var editorSvc = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()(new __WEBPACK_IMPORTED_MODULE_10_vue__["a" /* default */](), __WEBPACK_IMPORTED_MODULE_21__editor_editorSvcDiscussions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__editor_editorSvcUtils__["a" /* default */], {
  editorElt: null,
  previewElt: null,
  tocElt: null,

  clEditor: null,
  pagedownEditor: null,
  options: null,
  prismGrammars: null,
  converter: null,
  parsingCtx: null,
  conversionCtx: null,
  previewCtx: {
    sectionDescList: []
  },
  previewCtxMeasured: null,
  previewCtxWithDiffs: null,
  sectionList: null,
  selectionRange: null,
  previewSelectionRange: null,
  previewSelectionStartOffset: null,

  initPrism: function initPrism() {
    var options = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, this.options, {
      insideFences: __WEBPACK_IMPORTED_MODULE_17__markdownConversionSvc__["a" /* default */].defaultOptions.insideFences
    });
    this.prismGrammars = __WEBPACK_IMPORTED_MODULE_18__markdownGrammarSvc__["a" /* default */].makeGrammars(options);
  },
  initConverter: function initConverter() {
    this.converter = __WEBPACK_IMPORTED_MODULE_17__markdownConversionSvc__["a" /* default */].createConverter(this.options, true);
  },
  initClEditor: function initClEditor() {
    var _this = this;

    this.previewCtxMeasured = null;
    editorSvc.$emit('previewCtxMeasured', null);
    this.previewCtxWithDiffs = null;
    editorSvc.$emit('previewCtxWithDiffs', null);
    var options = {
      sectionHighlighter: function sectionHighlighter(section) {
        return __WEBPACK_IMPORTED_MODULE_12_prismjs___default.a.highlight(section.text, _this.prismGrammars[section.data]);
      },
      sectionParser: function sectionParser(text) {
        _this.parsingCtx = __WEBPACK_IMPORTED_MODULE_17__markdownConversionSvc__["a" /* default */].parseSections(_this.converter, text);
        return _this.parsingCtx.sections;
      },
      getCursorFocusRatio: function getCursorFocusRatio() {
        if (__WEBPACK_IMPORTED_MODULE_24__store__["a" /* default */].getters['data/layoutSettings'].focusMode) {
          return 1;
        }
        return 0.15;
      }
    };
    this.initClEditorInternal(options);
    this.restoreScrollPosition();
  },
  convert: function convert() {
    this.conversionCtx = __WEBPACK_IMPORTED_MODULE_17__markdownConversionSvc__["a" /* default */].convert(this.parsingCtx, this.conversionCtx);
    this.$emit('conversionCtx', this.conversionCtx);
    tokens = this.parsingCtx.markdownState.tokens;
  },
  refreshPreview: function refreshPreview() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      var sectionDescList, sectionPreviewElt, sectionTocElt, sectionIdx, sectionDescIdx, insertBeforePreviewElt, insertBeforeTocElt, previewHtml, loadingImages, loadedPromises;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              sectionDescList = [];
              sectionPreviewElt = void 0;
              sectionTocElt = void 0;
              sectionIdx = 0;
              sectionDescIdx = 0;
              insertBeforePreviewElt = _this2.previewElt.firstChild;
              insertBeforeTocElt = _this2.tocElt.firstChild;
              previewHtml = '';
              loadingImages = [];

              _this2.conversionCtx.htmlSectionDiff.forEach(function (item) {
                for (var i = 0; i < item[1].length; i += 1) {
                  var section = _this2.conversionCtx.sectionList[sectionIdx];
                  if (item[0] === 0) {
                    var sectionDesc = _this2.previewCtx.sectionDescList[sectionDescIdx];
                    sectionDescIdx += 1;
                    if (sectionDesc.editorElt !== section.elt) {
                      sectionDesc = new SectionDesc(section, sectionDesc.previewElt, sectionDesc.tocElt, sectionDesc.html);
                    }
                    sectionDescList.push(sectionDesc);
                    previewHtml += sectionDesc.html;
                    sectionIdx += 1;
                    insertBeforePreviewElt = insertBeforePreviewElt.nextSibling;
                    insertBeforeTocElt = insertBeforeTocElt.nextSibling;
                  } else if (item[0] === -1) {
                    sectionDescIdx += 1;
                    sectionPreviewElt = insertBeforePreviewElt;
                    insertBeforePreviewElt = insertBeforePreviewElt.nextSibling;
                    _this2.previewElt.removeChild(sectionPreviewElt);
                    sectionTocElt = insertBeforeTocElt;
                    insertBeforeTocElt = insertBeforeTocElt.nextSibling;
                    _this2.tocElt.removeChild(sectionTocElt);
                  } else if (item[0] === 1) {
                    var html = __WEBPACK_IMPORTED_MODULE_16__libs_htmlSanitizer__["a" /* default */].sanitizeHtml(_this2.conversionCtx.htmlSectionList[sectionIdx]);
                    sectionIdx += 1;

                    sectionPreviewElt = document.createElement('div');
                    sectionPreviewElt.className = 'cl-preview-section';
                    sectionPreviewElt.innerHTML = html;
                    if (insertBeforePreviewElt) {
                      _this2.previewElt.insertBefore(sectionPreviewElt, insertBeforePreviewElt);
                    } else {
                      _this2.previewElt.appendChild(sectionPreviewElt);
                    }
                    __WEBPACK_IMPORTED_MODULE_20__extensionSvc__["a" /* default */].sectionPreview(sectionPreviewElt, _this2.options, true);
                    loadingImages = [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(loadingImages), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(Array.prototype.slice.call(sectionPreviewElt.getElementsByTagName('img'))));

                    sectionTocElt = document.createElement('div');
                    sectionTocElt.className = 'cl-toc-section';
                    var headingElt = sectionPreviewElt.querySelector('h1, h2, h3, h4, h5, h6');
                    if (headingElt) {
                      var clonedElt = headingElt.cloneNode(true);
                      clonedElt.removeAttribute('id');
                      sectionTocElt.appendChild(clonedElt);
                    }
                    if (insertBeforeTocElt) {
                      _this2.tocElt.insertBefore(sectionTocElt, insertBeforeTocElt);
                    } else {
                      _this2.tocElt.appendChild(sectionTocElt);
                    }

                    previewHtml += html;
                    sectionDescList.push(new SectionDesc(section, sectionPreviewElt, sectionTocElt, html));
                  }
                }
              });

              _this2.tocElt.classList[_this2.tocElt.querySelector('.cl-toc-section *') ? 'remove' : 'add']('toc-tab--empty');

              _this2.previewCtx = {
                markdown: _this2.conversionCtx.text,
                html: previewHtml.replace(/^\s+|\s+$/g, ''),
                text: _this2.previewElt.textContent,
                sectionDescList: sectionDescList
              };
              _this2.$emit('previewCtx', _this2.previewCtx);
              _this2.makeTextToPreviewDiffs();

              loadedPromises = loadingImages.map(function (imgElt) {
                return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve) {
                  if (!imgElt.src) {
                    resolve();
                    return;
                  }
                  var img = new window.Image();
                  img.onload = resolve;
                  img.onerror = resolve;
                  img.src = imgElt.src;
                });
              });
              _context.next = 17;
              return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all(loadedPromises);

            case 17:
              _this2.measureSectionDimensions(!!_this2.previewCtxMeasured);

            case 18:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },

  measureSectionDimensions: allowDebounce(function () {
    var restoreScrollPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (force || editorSvc.previewCtx !== editorSvc.previewCtxMeasured) {
      __WEBPACK_IMPORTED_MODULE_19__editor_sectionUtils__["a" /* default */].measureSectionDimensions(editorSvc);
      editorSvc.previewCtxMeasured = editorSvc.previewCtx;
      if (restoreScrollPosition) {
        editorSvc.restoreScrollPosition();
      }
      editorSvc.$emit('previewCtxMeasured', editorSvc.previewCtxMeasured);
    }
  }, 500),

  makeTextToPreviewDiffs: function makeTextToPreviewDiffs() {
    if (editorSvc.previewCtx !== editorSvc.previewCtxWithDiffs) {
      var makeOne = function makeOne() {
        var hasOne = false;
        var hasMore = editorSvc.previewCtx.sectionDescList.some(function (sectionDesc) {
          if (!sectionDesc.textToPreviewDiffs) {
            if (hasOne) {
              return true;
            }
            if (!sectionDesc.previewText) {
              sectionDesc.previewText = sectionDesc.previewElt.textContent;
            }
            sectionDesc.textToPreviewDiffs = diffMatchPatch.diff_main(sectionDesc.section.text, sectionDesc.previewText);
            hasOne = true;
          }
          return false;
        });
        if (hasMore) {
          setTimeout(function () {
            return makeOne();
          }, 10);
        } else {
          editorSvc.previewCtxWithDiffs = editorSvc.previewCtx;
          editorSvc.$emit('previewCtxWithDiffs', editorSvc.previewCtxWithDiffs);
        }
      };
      makeOne();
    }
  },

  saveContentState: allowDebounce(function () {
    var scrollPosition = editorSvc.getScrollPosition() || __WEBPACK_IMPORTED_MODULE_24__store__["a" /* default */].getters['contentState/current'].scrollPosition;
    __WEBPACK_IMPORTED_MODULE_24__store__["a" /* default */].dispatch('contentState/patchCurrent', {
      selectionStart: editorSvc.clEditor.selectionMgr.selectionStart,
      selectionEnd: editorSvc.clEditor.selectionMgr.selectionEnd,
      scrollPosition: scrollPosition
    });
  }, 100),

  saveSelection: allowDebounce(function () {
    var selection = window.getSelection();
    var range = selection.rangeCount && selection.getRangeAt(0);
    if (range) {
      if (!(editorSvc.previewElt.compareDocumentPosition(range.startContainer) & window.Node.DOCUMENT_POSITION_CONTAINED_BY) || !(editorSvc.previewElt.compareDocumentPosition(range.endContainer) & window.Node.DOCUMENT_POSITION_CONTAINED_BY)) {
          range = null;
        }
    }
    if (editorSvc.previewSelectionRange !== range) {
      var previewSelectionStartOffset = void 0;
      var previewSelectionEndOffset = void 0;
      if (range) {
        var startRange = document.createRange();
        startRange.setStart(editorSvc.previewElt, 0);
        startRange.setEnd(range.startContainer, range.startOffset);
        previewSelectionStartOffset = ('' + startRange).length;
        previewSelectionEndOffset = previewSelectionStartOffset + ('' + range).length;
        var editorStartOffset = editorSvc.getEditorOffset(previewSelectionStartOffset);
        var editorEndOffset = editorSvc.getEditorOffset(previewSelectionEndOffset);
        if (editorStartOffset != null && editorEndOffset != null) {
          editorSvc.clEditor.selectionMgr.setSelectionStartEnd(editorStartOffset, editorEndOffset);
        }
      }
      editorSvc.previewSelectionRange = range;
      editorSvc.$emit('previewSelectionRange', editorSvc.previewSelectionRange);
    }
  }, 50),

  getPandocAst: function getPandocAst() {
    return tokens && __WEBPACK_IMPORTED_MODULE_13_markdown_it_pandoc_renderer___default()(tokens, this.converter.options);
  },
  init: function init(editorElt, previewElt, tocElt) {
    var _this3 = this;

    this.editorElt = editorElt;
    this.previewElt = previewElt;
    this.tocElt = tocElt;

    this.createClEditor(editorElt);

    this.clEditor.on('contentChanged', function (content, diffs, sectionList) {
      _this3.parsingCtx = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, _this3.parsingCtx, {
        sectionList: sectionList
      });
    });
    this.clEditor.undoMgr.on('undoStateChange', function () {
      var canUndo = _this3.clEditor.undoMgr.canUndo();
      if (canUndo !== __WEBPACK_IMPORTED_MODULE_24__store__["a" /* default */].state.layout.canUndo) {
        __WEBPACK_IMPORTED_MODULE_24__store__["a" /* default */].commit('layout/setCanUndo', canUndo);
      }
      var canRedo = _this3.clEditor.undoMgr.canRedo();
      if (canRedo !== __WEBPACK_IMPORTED_MODULE_24__store__["a" /* default */].state.layout.canRedo) {
        __WEBPACK_IMPORTED_MODULE_24__store__["a" /* default */].commit('layout/setCanRedo', canRedo);
      }
    });
    this.pagedownEditor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__libs_pagedown__["a" /* default */])({
      input: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(this.clEditor)
    });
    this.pagedownEditor.run();
    this.pagedownEditor.hooks.set('insertLinkDialog', function (callback) {
      __WEBPACK_IMPORTED_MODULE_24__store__["a" /* default */].dispatch('modal/open', {
        type: 'link',
        callback: callback
      });
      return true;
    });
    this.pagedownEditor.hooks.set('insertImageDialog', function (callback) {
      __WEBPACK_IMPORTED_MODULE_24__store__["a" /* default */].dispatch('modal/open', {
        type: 'image',
        callback: callback
      });
      return true;
    });

    this.editorElt.parentNode.addEventListener('scroll', function () {
      return _this3.saveContentState(true);
    });
    this.previewElt.parentNode.addEventListener('scroll', function () {
      return _this3.saveContentState(true);
    });

    var refreshPreview = allowDebounce(function () {
      _this3.convert();
      if (instantPreview) {
        _this3.refreshPreview();
        _this3.measureSectionDimensions(false, true);
      } else {
        setTimeout(function () {
          return _this3.refreshPreview();
        }, 10);
      }
      instantPreview = false;
    }, 25);

    var newSectionList = void 0;
    var newSelectionRange = void 0;
    var onEditorChanged = allowDebounce(function () {
      if (_this3.sectionList !== newSectionList) {
        _this3.sectionList = newSectionList;
        _this3.$emit('sectionList', _this3.sectionList);
        refreshPreview(!instantPreview);
      }
      if (_this3.selectionRange !== newSelectionRange) {
        _this3.selectionRange = newSelectionRange;
        _this3.$emit('selectionRange', _this3.selectionRange);
      }
      _this3.saveContentState();
    }, 10);

    this.clEditor.selectionMgr.on('selectionChanged', function (start, end, selectionRange) {
      newSelectionRange = selectionRange;
      onEditorChanged(!instantPreview);
    });

    var imgCache = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(null);

    var hashImgElt = function hashImgElt(imgElt) {
      return imgElt.src + ':' + (imgElt.width || -1) + ':' + (imgElt.height || -1);
    };

    var addToImgCache = function addToImgCache(imgElt) {
      var hash = hashImgElt(imgElt);
      var entries = imgCache[hash];
      if (!entries) {
        entries = [];
        imgCache[hash] = entries;
      }
      entries.push(imgElt);
    };

    var getFromImgCache = function getFromImgCache(imgEltsToCache) {
      var hash = hashImgElt(imgEltsToCache);
      var entries = imgCache[hash];
      if (!entries) {
        return null;
      }
      var imgElt = void 0;
      return entries.some(function (entry) {
        if (_this3.editorElt.contains(entry)) {
          return false;
        }
        imgElt = entry;
        return true;
      }) && imgElt;
    };

    var triggerImgCacheGc = __WEBPACK_IMPORTED_MODULE_14__editor_cledit__["a" /* default */].Utils.debounce(function () {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(imgCache).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            src = _ref2[0],
            entries = _ref2[1];

        var filteredEntries = entries.filter(function (imgElt) {
          return _this3.editorElt.contains(imgElt);
        });
        if (filteredEntries.length) {
          imgCache[src] = filteredEntries;
        } else {
          delete imgCache[src];
        }
      });
    }, 100);

    var imgEltsToCache = [];
    if (__WEBPACK_IMPORTED_MODULE_24__store__["a" /* default */].getters['data/computedSettings'].editor.inlineImages) {
      this.clEditor.highlighter.on('sectionHighlighted', function (section) {
        section.elt.getElementsByClassName('token img').cl_each(function (imgTokenElt) {
          var srcElt = imgTokenElt.querySelector('.token.cl-src');
          if (srcElt) {
            var imgElt = document.createElement('img');
            imgElt.style.display = 'none';
            var uri = srcElt.textContent;
            if (!/^unsafe/.test(__WEBPACK_IMPORTED_MODULE_16__libs_htmlSanitizer__["a" /* default */].sanitizeUri(uri, true))) {
              imgElt.onload = function () {
                imgElt.style.display = '';
              };
              imgElt.src = uri;

              var sizeElt = imgTokenElt.querySelector('.token.cl-size');
              if (sizeElt) {
                var match = sizeElt.textContent.match(/=(\d*)x(\d*)/);
                if (match[1]) {
                  imgElt.width = parseInt(match[1], 10);
                }
                if (match[2]) {
                  imgElt.height = parseInt(match[2], 10);
                }
              }
              imgEltsToCache.push(imgElt);
            }
            var imgTokenWrapper = document.createElement('span');
            imgTokenWrapper.className = 'token img-wrapper';
            imgTokenElt.parentNode.insertBefore(imgTokenWrapper, imgTokenElt);
            imgTokenWrapper.appendChild(imgElt);
            imgTokenWrapper.appendChild(imgTokenElt);
          }
        });
      });
    }

    this.clEditor.highlighter.on('highlighted', function () {
      imgEltsToCache.forEach(function (imgElt) {
        var cachedImgElt = getFromImgCache(imgElt);
        if (cachedImgElt) {
          imgElt.parentNode.replaceChild(cachedImgElt, imgElt);
        } else {
          addToImgCache(imgElt);
        }
      });
      imgEltsToCache = [];

      triggerImgCacheGc();
    });

    this.clEditor.on('contentChanged', function (content, diffs, sectionList) {
      newSectionList = sectionList;
      onEditorChanged(!instantPreview);
    });

    var lastContentId = null;
    var lastProperties = void 0;
    __WEBPACK_IMPORTED_MODULE_24__store__["a" /* default */].watch(function () {
      return __WEBPACK_IMPORTED_MODULE_24__store__["a" /* default */].getters['content/currentChangeTrigger'];
    }, function () {
      var content = __WEBPACK_IMPORTED_MODULE_24__store__["a" /* default */].getters['content/current'];

      var initClEditor = false;
      if (content.id !== lastContentId) {
        instantPreview = true;
        lastContentId = content.id;
        initClEditor = true;
      }

      if (content.properties !== lastProperties) {
        lastProperties = content.properties;
        var options = __WEBPACK_IMPORTED_MODULE_20__extensionSvc__["a" /* default */].getOptions(__WEBPACK_IMPORTED_MODULE_24__store__["a" /* default */].getters['content/currentProperties']);
        if (__WEBPACK_IMPORTED_MODULE_23__utils__["a" /* default */].serializeObject(options) !== __WEBPACK_IMPORTED_MODULE_23__utils__["a" /* default */].serializeObject(_this3.options)) {
          _this3.options = options;
          _this3.initPrism();
          _this3.initConverter();
          initClEditor = true;
        }
      }
      if (initClEditor) {
        _this3.initClEditor();
      }

      _this3.applyContent();
    }, {
      immediate: true
    });

    __WEBPACK_IMPORTED_MODULE_24__store__["a" /* default */].watch(function () {
      return __WEBPACK_IMPORTED_MODULE_24__store__["a" /* default */].getters['content/isCurrentEditable'];
    }, function (editable) {
      return _this3.clEditor.toggleEditable(!!editable);
    }, {
      immediate: true
    });

    __WEBPACK_IMPORTED_MODULE_24__store__["a" /* default */].watch(function () {
      return __WEBPACK_IMPORTED_MODULE_23__utils__["a" /* default */].serializeObject(__WEBPACK_IMPORTED_MODULE_24__store__["a" /* default */].getters['layout/styles']);
    }, function () {
      return _this3.measureSectionDimensions(false, true, true);
    });

    this.initHighlighters();
    this.$emit('inited');
  }
});

/* harmony default export */ __webpack_exports__["a"] = (editorSvc);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_values__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__networkSvc__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__userSvc__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__badgeSvc__ = __webpack_require__(11);










var _this = this;







var appsDomain = null;
var tokenExpirationMargin = 5 * 60 * 1000;

var driveAppDataScopes = ['https://www.googleapis.com/auth/drive.appdata'];
var getDriveScopes = function getDriveScopes(token) {
  return [token.driveFullAccess ? 'https://www.googleapis.com/auth/drive' : 'https://www.googleapis.com/auth/drive.file', 'https://www.googleapis.com/auth/drive.install'];
};
var bloggerScopes = ['https://www.googleapis.com/auth/blogger'];
var photosScopes = ['https://www.googleapis.com/auth/photos'];

var checkIdToken = function checkIdToken(idToken) {
  try {
    var token = idToken.split('.');
    var payload = JSON.parse(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].decodeBase64(token[1]));
    var clientId = __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].getters['data/serverConf'].googleClientId;
    return payload.aud === clientId && Date.now() + tokenExpirationMargin < payload.exp * 1000;
  } catch (e) {
    return false;
  }
};

var driveState = void 0;
if (__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].queryParams.providerId === 'googleDrive') {
  try {
    driveState = JSON.parse(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].queryParams.state);
  } catch (e) {}
}

var getUser = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee(sub, token) {
    var apiKey, url, _ref2, body;

    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            apiKey = __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].getters['data/serverConf'].googleApiKey;
            url = 'https://people.googleapis.com/v1/people/' + sub + '?personFields=names,photos&key=' + apiKey;
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_10__networkSvc__["a" /* default */].request(sub === 'me' && token ? {
              method: 'GET',
              url: url,
              headers: {
                Authorization: 'Bearer ' + token.accessToken
              }
            } : {
              method: 'GET',
              url: url
            }, true);

          case 4:
            _ref2 = _context.sent;
            body = _ref2.body;
            return _context.abrupt('return', body);

          case 7:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function getUser(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var subPrefix = 'go';
__WEBPACK_IMPORTED_MODULE_12__userSvc__["a" /* default */].setInfoResolver('google', subPrefix, function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee2(sub) {
    var googleToken, body, name, photo;
    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            googleToken = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].getters['data/googleTokensBySub'])[0];
            _context2.next = 4;
            return getUser(sub, googleToken);

          case 4:
            body = _context2.sent;
            name = body.names && body.names[0] || {};
            photo = body.photos && body.photos[0] || {};
            return _context2.abrupt('return', {
              id: subPrefix + ':' + sub,
              name: name.displayName,
              imageUrl: (photo.url || '').replace(/\bsz?=\d+$/, 'sz=40')
            });

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2['catch'](0);

            if (!(_context2.t0.status !== 404)) {
              _context2.next = 14;
              break;
            }

            throw new Error('RETRY');

          case 14:
            throw _context2.t0;

          case 15:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this, [[0, 10]]);
  }));

  return function (_x3) {
    return _ref3.apply(this, arguments);
  };
}());

/* harmony default export */ __webpack_exports__["a"] = ({
  subPrefix: subPrefix,
  folderMimeType: 'application/vnd.google-apps.folder',
  driveState: driveState,
  driveActionFolder: null,
  driveActionFiles: [],
  $request: function $request(token, options) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var _ref4, reason, refreshedToken;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_10__networkSvc__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, options, {
                headers: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, options.headers || {}, {
                  Authorization: 'Bearer ' + token.accessToken
                })
              }), true);

            case 3:
              return _context3.abrupt('return', _context3.sent.body);

            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3['catch'](0);
              _ref4 = (((_context3.t0.body || {}).error || {}).errors || [])[0] || {}, reason = _ref4.reason;

              if (!(reason === 'authError')) {
                _context3.next = 15;
                break;
              }

              __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].dispatch('data/addGoogleToken', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, token, {
                expiresOn: 0
              }));
              _context3.next = 13;
              return _this2.refreshToken(token, token.scopes);

            case 13:
              refreshedToken = _context3.sent;
              return _context3.abrupt('return', _this2.$request(refreshedToken, options));

            case 15:
              throw _context3.t0;

            case 16:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2, [[0, 6]]);
    }))();
  },
  startOauth2: function startOauth2(scopes) {
    var _this3 = this;

    var sub = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var clientId, _ref5, accessToken, expiresIn, idToken, _ref6, body, existingToken, token, user, userId, name, photo, res;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              clientId = __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].getters['data/serverConf'].googleClientId;
              _context4.next = 3;
              return __WEBPACK_IMPORTED_MODULE_10__networkSvc__["a" /* default */].startOauth2('https://accounts.google.com/o/oauth2/v2/auth', {
                client_id: clientId,
                response_type: 'token id_token',
                scope: ['openid', 'profile'].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(scopes)).join(' '),
                hd: appsDomain,
                login_hint: sub,
                prompt: silent ? 'none' : null,
                nonce: __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].uid()
              }, silent);

            case 3:
              _ref5 = _context4.sent;
              accessToken = _ref5.accessToken;
              expiresIn = _ref5.expiresIn;
              idToken = _ref5.idToken;
              _context4.next = 9;
              return __WEBPACK_IMPORTED_MODULE_10__networkSvc__["a" /* default */].request({
                method: 'POST',
                url: 'https://www.googleapis.com/oauth2/v3/tokeninfo',
                params: {
                  access_token: accessToken
                }
              }, true);

            case 9:
              _ref6 = _context4.sent;
              body = _ref6.body;

              if (!(body.aud !== clientId)) {
                _context4.next = 13;
                break;
              }

              throw new Error('Client ID inconsistent.');

            case 13:
              if (!(sub && '' + body.sub !== sub)) {
                _context4.next = 15;
                break;
              }

              throw new Error('Google account ID not expected.');

            case 15:
              existingToken = __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].getters['data/googleTokensBySub'][body.sub];
              token = {
                scopes: scopes,
                accessToken: accessToken,
                expiresOn: Date.now() + expiresIn * 1000,
                idToken: idToken,
                sub: body.sub,
                name: (existingToken || {}).name || 'Someone',
                isLogin: !__WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].getters['workspace/mainWorkspaceToken'] && scopes.includes('https://www.googleapis.com/auth/drive.appdata'),
                isSponsor: false,
                isDrive: scopes.includes('https://www.googleapis.com/auth/drive') || scopes.includes('https://www.googleapis.com/auth/drive.file'),
                isBlogger: scopes.includes('https://www.googleapis.com/auth/blogger'),
                isPhotos: scopes.includes('https://www.googleapis.com/auth/photos'),
                driveFullAccess: scopes.includes('https://www.googleapis.com/auth/drive')
              };
              _context4.next = 19;
              return getUser('me', token);

            case 19:
              user = _context4.sent;
              userId = user.resourceName.split('/')[1];
              name = user.names[0] || {};
              photo = user.photos[0] || {};

              if (name.displayName) {
                token.name = name.displayName;
              }
              __WEBPACK_IMPORTED_MODULE_12__userSvc__["a" /* default */].addUserInfo({
                id: subPrefix + ':' + userId,
                name: name.displayName,
                imageUrl: (photo.url || '').replace(/\bsz?=\d+$/, 'sz=40')
              });

              if (existingToken) {
                __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(token, {
                  isLogin: existingToken.isLogin || token.isLogin,
                  isSponsor: existingToken.isSponsor,
                  isDrive: existingToken.isDrive || token.isDrive,
                  isBlogger: existingToken.isBlogger || token.isBlogger,
                  isPhotos: existingToken.isPhotos || token.isPhotos,
                  driveFullAccess: existingToken.driveFullAccess || token.driveFullAccess
                });
              }

              if (!token.isLogin) {
                _context4.next = 37;
                break;
              }

              _context4.prev = 27;
              _context4.next = 30;
              return __WEBPACK_IMPORTED_MODULE_10__networkSvc__["a" /* default */].request({
                method: 'GET',
                url: 'userInfo',
                params: {
                  idToken: token.idToken
                }
              });

            case 30:
              res = _context4.sent;

              token.isSponsor = res.body.sponsorUntil > Date.now();
              if (token.isSponsor) {
                __WEBPACK_IMPORTED_MODULE_13__badgeSvc__["a" /* default */].addBadge('sponsor');
              }
              _context4.next = 37;
              break;

            case 35:
              _context4.prev = 35;
              _context4.t0 = _context4['catch'](27);

            case 37:
              _context4.next = 39;
              return __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].dispatch('data/addGoogleToken', token);

            case 39:
              return _context4.abrupt('return', token);

            case 40:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this3, [[27, 35]]);
    }))();
  },
  refreshToken: function refreshToken(token) {
    var _this4 = this;

    var scopes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var sub, lastToken, mergedScopes;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              sub = token.sub;
              lastToken = __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].getters['data/googleTokensBySub'][sub];
              mergedScopes = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a([].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(scopes), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(lastToken.scopes)))));

              if (!(mergedScopes.length === lastToken.scopes.length && lastToken.expiresOn > Date.now() + tokenExpirationMargin && (!lastToken.isLogin || checkIdToken(lastToken.idToken)))) {
                _context5.next = 5;
                break;
              }

              return _context5.abrupt('return', lastToken);

            case 5:
              _context5.prev = 5;
              _context5.next = 8;
              return _this4.startOauth2(mergedScopes, sub, true);

            case 8:
              return _context5.abrupt('return', _context5.sent);

            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5['catch'](5);

              if (!__WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].state.offline) {
                _context5.next = 15;
                break;
              }

              throw _context5.t0;

            case 15:
              _context5.next = 17;
              return __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].dispatch('modal/open', {
                type: 'providerRedirection',
                name: 'Google'
              });

            case 17:
              return _context5.abrupt('return', _this4.startOauth2(mergedScopes, sub));

            case 18:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this4, [[5, 11]]);
    }))();
  },
  signin: function signin() {
    return this.startOauth2(driveAppDataScopes);
  },
  addDriveAccount: function addDriveAccount() {
    var _this5 = this;

    var fullAccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var sub = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var token;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this5.startOauth2(getDriveScopes({ driveFullAccess: fullAccess }), sub);

            case 2:
              token = _context6.sent;

              __WEBPACK_IMPORTED_MODULE_13__badgeSvc__["a" /* default */].addBadge('addGoogleDriveAccount');
              return _context6.abrupt('return', token);

            case 5:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this5);
    }))();
  },
  addBloggerAccount: function addBloggerAccount() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var token;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this6.startOauth2(bloggerScopes);

            case 2:
              token = _context7.sent;

              __WEBPACK_IMPORTED_MODULE_13__badgeSvc__["a" /* default */].addBadge('addBloggerAccount');
              return _context7.abrupt('return', token);

            case 5:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this6);
    }))();
  },
  addPhotosAccount: function addPhotosAccount() {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var token;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _this7.startOauth2(photosScopes);

            case 2:
              token = _context8.sent;

              __WEBPACK_IMPORTED_MODULE_13__badgeSvc__["a" /* default */].addBadge('addGooglePhotosAccount');
              return _context8.abrupt('return', token);

            case 5:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this7);
    }))();
  },
  $uploadFile: function $uploadFile(_ref7) {
    var _this8 = this;

    var refreshedToken = _ref7.refreshedToken,
        name = _ref7.name,
        parents = _ref7.parents,
        appProperties = _ref7.appProperties,
        _ref7$media = _ref7.media,
        media = _ref7$media === undefined ? null : _ref7$media,
        _ref7$mediaType = _ref7.mediaType,
        mediaType = _ref7$mediaType === undefined ? null : _ref7$mediaType,
        _ref7$fileId = _ref7.fileId,
        fileId = _ref7$fileId === undefined ? null : _ref7$fileId,
        _ref7$oldParents = _ref7.oldParents,
        oldParents = _ref7$oldParents === undefined ? null : _ref7$oldParents,
        _ref7$ifNotTooLate = _ref7.ifNotTooLate,
        ifNotTooLate = _ref7$ifNotTooLate === undefined ? function (cb) {
      return cb();
    } : _ref7$ifNotTooLate;
    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt('return', ifNotTooLate(function () {
                var options = {
                  method: 'POST',
                  url: 'https://www.googleapis.com/drive/v3/files'
                };
                var params = {
                  supportsTeamDrives: true
                };
                var metadata = { name: name, appProperties: appProperties };
                if (fileId) {
                  options.method = 'PATCH';
                  options.url = 'https://www.googleapis.com/drive/v3/files/' + fileId;
                  if (parents && oldParents) {
                    params.addParents = parents.filter(function (parent) {
                      return !oldParents.includes(parent);
                    }).join(',');
                    params.removeParents = oldParents.filter(function (parent) {
                      return !parents.includes(parent);
                    }).join(',');
                  }
                } else if (parents) {
                  metadata.parents = parents;
                }
                if (media) {
                  var boundary = '-------' + __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].uid();
                  var delimiter = '\r\n--' + boundary + '\r\n';
                  var closeDelimiter = '\r\n--' + boundary + '--';
                  var multipartRequestBody = '';
                  multipartRequestBody += delimiter;
                  multipartRequestBody += 'Content-Type: application/json; charset=UTF-8\r\n\r\n';
                  multipartRequestBody += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(metadata);
                  multipartRequestBody += delimiter;
                  multipartRequestBody += 'Content-Type: ' + (mediaType || 'text/plain') + '; charset=UTF-8\r\n\r\n';
                  multipartRequestBody += media;
                  multipartRequestBody += closeDelimiter;
                  options.url = options.url.replace('https://www.googleapis.com/', 'https://www.googleapis.com/upload/');
                  return _this8.$request(refreshedToken, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, options, {
                    params: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, params, {
                      uploadType: 'multipart'
                    }),
                    headers: {
                      'Content-Type': 'multipart/mixed; boundary="' + boundary + '"'
                    },
                    body: multipartRequestBody
                  }));
                }
                if (mediaType) {
                  metadata.mimeType = mediaType;
                }
                return _this8.$request(refreshedToken, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, options, {
                  body: metadata,
                  params: params
                }));
              }));

            case 1:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this8);
    }))();
  },
  uploadFile: function uploadFile(_ref8) {
    var _this9 = this;

    var token = _ref8.token,
        name = _ref8.name,
        parents = _ref8.parents,
        appProperties = _ref8.appProperties,
        media = _ref8.media,
        mediaType = _ref8.mediaType,
        fileId = _ref8.fileId,
        oldParents = _ref8.oldParents,
        ifNotTooLate = _ref8.ifNotTooLate;
    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee10() {
      var refreshedToken;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return _this9.refreshToken(token, getDriveScopes(token));

            case 2:
              refreshedToken = _context10.sent;
              return _context10.abrupt('return', _this9.$uploadFile({
                refreshedToken: refreshedToken,
                name: name,
                parents: parents,
                appProperties: appProperties,
                media: media,
                mediaType: mediaType,
                fileId: fileId,
                oldParents: oldParents,
                ifNotTooLate: ifNotTooLate
              }));

            case 4:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this9);
    }))();
  },
  uploadAppDataFile: function uploadAppDataFile(_ref9) {
    var _this10 = this;

    var token = _ref9.token,
        name = _ref9.name,
        media = _ref9.media,
        fileId = _ref9.fileId,
        ifNotTooLate = _ref9.ifNotTooLate;
    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee11() {
      var refreshedToken;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return _this10.refreshToken(token, driveAppDataScopes);

            case 2:
              refreshedToken = _context11.sent;
              return _context11.abrupt('return', _this10.$uploadFile({
                refreshedToken: refreshedToken,
                name: name,
                parents: ['appDataFolder'],
                media: media,
                fileId: fileId,
                ifNotTooLate: ifNotTooLate
              }));

            case 4:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this10);
    }))();
  },
  getFile: function getFile(token, id) {
    var _this11 = this;

    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee12() {
      var refreshedToken;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return _this11.refreshToken(token, getDriveScopes(token));

            case 2:
              refreshedToken = _context12.sent;
              return _context12.abrupt('return', _this11.$request(refreshedToken, {
                method: 'GET',
                url: 'https://www.googleapis.com/drive/v3/files/' + id,
                params: {
                  fields: 'id,name,mimeType,appProperties,teamDriveId',
                  supportsTeamDrives: true
                }
              }));

            case 4:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this11);
    }))();
  },
  $downloadFile: function $downloadFile(refreshedToken, id) {
    var _this12 = this;

    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee13() {
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt('return', _this12.$request(refreshedToken, {
                method: 'GET',
                url: 'https://www.googleapis.com/drive/v3/files/' + id + '?alt=media',
                raw: true
              }));

            case 1:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this12);
    }))();
  },
  downloadFile: function downloadFile(token, id) {
    var _this13 = this;

    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee14() {
      var refreshedToken;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return _this13.refreshToken(token, getDriveScopes(token));

            case 2:
              refreshedToken = _context14.sent;
              return _context14.abrupt('return', _this13.$downloadFile(refreshedToken, id));

            case 4:
            case 'end':
              return _context14.stop();
          }
        }
      }, _callee14, _this13);
    }))();
  },
  downloadAppDataFile: function downloadAppDataFile(token, id) {
    var _this14 = this;

    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee15() {
      var refreshedToken;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return _this14.refreshToken(token, driveAppDataScopes);

            case 2:
              refreshedToken = _context15.sent;
              return _context15.abrupt('return', _this14.$downloadFile(refreshedToken, id));

            case 4:
            case 'end':
              return _context15.stop();
          }
        }
      }, _callee15, _this14);
    }))();
  },
  $removeFile: function $removeFile(refreshedToken, id) {
    var _this15 = this;

    var ifNotTooLate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (cb) {
      return cb();
    };
    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee16() {
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              return _context16.abrupt('return', ifNotTooLate(function () {
                return _this15.$request(refreshedToken, {
                  method: 'DELETE',
                  url: 'https://www.googleapis.com/drive/v3/files/' + id,
                  params: {
                    supportsTeamDrives: true
                  }
                });
              }));

            case 1:
            case 'end':
              return _context16.stop();
          }
        }
      }, _callee16, _this15);
    }))();
  },
  removeFile: function removeFile(token, id, ifNotTooLate) {
    var _this16 = this;

    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee17() {
      var refreshedToken;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return _this16.refreshToken(token, getDriveScopes(token));

            case 2:
              refreshedToken = _context17.sent;
              return _context17.abrupt('return', _this16.$removeFile(refreshedToken, id, ifNotTooLate));

            case 4:
            case 'end':
              return _context17.stop();
          }
        }
      }, _callee17, _this16);
    }))();
  },
  removeAppDataFile: function removeAppDataFile(token, id) {
    var _this17 = this;

    var ifNotTooLate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (cb) {
      return cb();
    };
    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee18() {
      var refreshedToken;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return _this17.refreshToken(token, driveAppDataScopes);

            case 2:
              refreshedToken = _context18.sent;
              return _context18.abrupt('return', _this17.$removeFile(refreshedToken, id, ifNotTooLate));

            case 4:
            case 'end':
              return _context18.stop();
          }
        }
      }, _callee18, _this17);
    }))();
  },
  $getFileRevisions: function $getFileRevisions(refreshedToken, id) {
    var _this18 = this;

    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee20() {
      var allRevisions, getPage;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              allRevisions = [];

              getPage = function () {
                var _ref10 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee19(pageToken) {
                  var _ref11, revisions, nextPageToken;

                  return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
                    while (1) {
                      switch (_context19.prev = _context19.next) {
                        case 0:
                          _context19.next = 2;
                          return _this18.$request(refreshedToken, {
                            method: 'GET',
                            url: 'https://www.googleapis.com/drive/v3/files/' + id + '/revisions',
                            params: {
                              pageToken: pageToken,
                              pageSize: 1000,
                              fields: 'nextPageToken,revisions(id,modifiedTime,lastModifyingUser/permissionId,lastModifyingUser/displayName,lastModifyingUser/photoLink)'
                            }
                          });

                        case 2:
                          _ref11 = _context19.sent;
                          revisions = _ref11.revisions;
                          nextPageToken = _ref11.nextPageToken;

                          revisions.forEach(function (revision) {
                            __WEBPACK_IMPORTED_MODULE_12__userSvc__["a" /* default */].addUserInfo({
                              id: subPrefix + ':' + revision.lastModifyingUser.permissionId,
                              name: revision.lastModifyingUser.displayName,
                              imageUrl: revision.lastModifyingUser.photoLink || ''
                            });
                            allRevisions.push(revision);
                          });

                          if (!nextPageToken) {
                            _context19.next = 8;
                            break;
                          }

                          return _context19.abrupt('return', getPage(nextPageToken));

                        case 8:
                          return _context19.abrupt('return', allRevisions);

                        case 9:
                        case 'end':
                          return _context19.stop();
                      }
                    }
                  }, _callee19, _this18);
                }));

                return function getPage(_x11) {
                  return _ref10.apply(this, arguments);
                };
              }();

              return _context20.abrupt('return', getPage());

            case 3:
            case 'end':
              return _context20.stop();
          }
        }
      }, _callee20, _this18);
    }))();
  },
  getFileRevisions: function getFileRevisions(token, id) {
    var _this19 = this;

    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee21() {
      var refreshedToken;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return _this19.refreshToken(token, getDriveScopes(token));

            case 2:
              refreshedToken = _context21.sent;
              return _context21.abrupt('return', _this19.$getFileRevisions(refreshedToken, id));

            case 4:
            case 'end':
              return _context21.stop();
          }
        }
      }, _callee21, _this19);
    }))();
  },
  getAppDataFileRevisions: function getAppDataFileRevisions(token, id) {
    var _this20 = this;

    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee22() {
      var refreshedToken;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return _this20.refreshToken(token, driveAppDataScopes);

            case 2:
              refreshedToken = _context22.sent;
              return _context22.abrupt('return', _this20.$getFileRevisions(refreshedToken, id));

            case 4:
            case 'end':
              return _context22.stop();
          }
        }
      }, _callee22, _this20);
    }))();
  },
  $downloadFileRevision: function $downloadFileRevision(refreshedToken, id, revisionId) {
    var _this21 = this;

    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee23() {
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              return _context23.abrupt('return', _this21.$request(refreshedToken, {
                method: 'GET',
                url: 'https://www.googleapis.com/drive/v3/files/' + id + '/revisions/' + revisionId + '?alt=media',
                raw: true
              }));

            case 1:
            case 'end':
              return _context23.stop();
          }
        }
      }, _callee23, _this21);
    }))();
  },
  downloadFileRevision: function downloadFileRevision(token, fileId, revisionId) {
    var _this22 = this;

    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee24() {
      var refreshedToken;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              _context24.next = 2;
              return _this22.refreshToken(token, getDriveScopes(token));

            case 2:
              refreshedToken = _context24.sent;
              return _context24.abrupt('return', _this22.$downloadFileRevision(refreshedToken, fileId, revisionId));

            case 4:
            case 'end':
              return _context24.stop();
          }
        }
      }, _callee24, _this22);
    }))();
  },
  downloadAppDataFileRevision: function downloadAppDataFileRevision(token, fileId, revisionId) {
    var _this23 = this;

    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee25() {
      var refreshedToken;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              _context25.next = 2;
              return _this23.refreshToken(token, driveAppDataScopes);

            case 2:
              refreshedToken = _context25.sent;
              return _context25.abrupt('return', _this23.$downloadFileRevision(refreshedToken, fileId, revisionId));

            case 4:
            case 'end':
              return _context25.stop();
          }
        }
      }, _callee25, _this23);
    }))();
  },
  getChanges: function getChanges(token, startPageToken, isAppData) {
    var _this24 = this;

    var teamDriveId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee27() {
      var result, fileFields, refreshedToken, getPage;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              result = {
                changes: []
              };
              fileFields = 'file/name';

              if (!isAppData) {
                fileFields += ',file/parents,file/mimeType,file/appProperties';
              }
              _context27.next = 5;
              return _this24.refreshToken(token, isAppData ? driveAppDataScopes : getDriveScopes(token));

            case 5:
              refreshedToken = _context27.sent;

              getPage = function () {
                var _ref12 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee26() {
                  var pageToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '1';

                  var _ref13, changes, nextPageToken, newStartPageToken;

                  return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26) {
                    while (1) {
                      switch (_context26.prev = _context26.next) {
                        case 0:
                          _context26.next = 2;
                          return _this24.$request(refreshedToken, {
                            method: 'GET',
                            url: 'https://www.googleapis.com/drive/v3/changes',
                            params: {
                              pageToken: pageToken,
                              spaces: isAppData ? 'appDataFolder' : 'drive',
                              pageSize: 1000,
                              fields: 'nextPageToken,newStartPageToken,changes(fileId,' + fileFields + ')',
                              supportsTeamDrives: true,
                              includeTeamDriveItems: !!teamDriveId,
                              teamDriveId: teamDriveId
                            }
                          });

                        case 2:
                          _ref13 = _context26.sent;
                          changes = _ref13.changes;
                          nextPageToken = _ref13.nextPageToken;
                          newStartPageToken = _ref13.newStartPageToken;

                          result.changes = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(result.changes), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(changes.filter(function (item) {
                            return item.fileId;
                          })));

                          if (!nextPageToken) {
                            _context26.next = 9;
                            break;
                          }

                          return _context26.abrupt('return', getPage(nextPageToken));

                        case 9:
                          result.startPageToken = newStartPageToken;
                          return _context26.abrupt('return', result);

                        case 11:
                        case 'end':
                          return _context26.stop();
                      }
                    }
                  }, _callee26, _this24);
                }));

                return function getPage() {
                  return _ref12.apply(this, arguments);
                };
              }();

              return _context27.abrupt('return', getPage(startPageToken));

            case 8:
            case 'end':
              return _context27.stop();
          }
        }
      }, _callee27, _this24);
    }))();
  },
  uploadBlogger: function uploadBlogger(_ref14) {
    var _this25 = this;

    var token = _ref14.token,
        blogUrl = _ref14.blogUrl,
        blogId = _ref14.blogId,
        postId = _ref14.postId,
        title = _ref14.title,
        content = _ref14.content,
        labels = _ref14.labels,
        isDraft = _ref14.isDraft,
        published = _ref14.published,
        isPage = _ref14.isPage;
    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee28() {
      var refreshedToken, blog, path, options, post;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              _context28.next = 2;
              return _this25.refreshToken(token, bloggerScopes);

            case 2:
              refreshedToken = _context28.sent;
              blog = { id: blogId };

              if (blog.id) {
                _context28.next = 8;
                break;
              }

              _context28.next = 7;
              return _this25.$request(refreshedToken, {
                url: 'https://www.googleapis.com/blogger/v3/blogs/byurl',
                params: {
                  url: blogUrl
                }
              });

            case 7:
              blog.id = _context28.sent.id;

            case 8:
              path = isPage ? 'pages' : 'posts';
              options = {
                method: 'POST',
                url: 'https://www.googleapis.com/blogger/v3/blogs/' + blog.id + '/' + path + '/',
                body: {
                  kind: isPage ? 'blogger#page' : 'blogger#post',
                  blog: blog,
                  title: title,
                  content: content
                }
              };

              if (labels) {
                options.body.labels = labels;
              }
              if (published) {
                options.body.published = published.toISOString();
              }

              if (postId) {
                options.method = 'PUT';
                options.url += postId;
                options.body.id = postId;
              }
              _context28.next = 15;
              return _this25.$request(refreshedToken, options);

            case 15:
              post = _context28.sent;

              if (!isPage) {
                _context28.next = 18;
                break;
              }

              return _context28.abrupt('return', post);

            case 18:
              options = {
                method: 'POST',
                url: 'https://www.googleapis.com/blogger/v3/blogs/' + post.blog.id + '/posts/' + post.id + '/',
                params: {}
              };
              if (isDraft) {
                options.url += 'revert';
              } else {
                options.url += 'publish';
                if (published) {
                  options.params.publishDate = published.toISOString();
                }
              }
              return _context28.abrupt('return', _this25.$request(refreshedToken, options));

            case 21:
            case 'end':
              return _context28.stop();
          }
        }
      }, _callee28, _this25);
    }))();
  },
  openPicker: function openPicker(token) {
    var _this26 = this;

    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'doc';
    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee29() {
      var scopes, refreshedToken, _window, google;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              scopes = type === 'img' ? photosScopes : getDriveScopes(token);

              if (window.google) {
                _context29.next = 6;
                break;
              }

              _context29.next = 4;
              return __WEBPACK_IMPORTED_MODULE_10__networkSvc__["a" /* default */].loadScript('https://apis.google.com/js/api.js');

            case 4:
              _context29.next = 6;
              return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                return window.gapi.load('picker', {
                  callback: resolve,
                  onerror: reject,
                  timeout: 30000,
                  ontimeout: reject
                });
              });

            case 6:
              _context29.next = 8;
              return _this26.refreshToken(token, scopes);

            case 8:
              refreshedToken = _context29.sent;
              _window = window, google = _window.google;
              return _context29.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                var picker = void 0;
                var pickerBuilder = new google.picker.PickerBuilder().setOAuthToken(refreshedToken.accessToken).enableFeature(google.picker.Feature.SUPPORT_TEAM_DRIVES).hideTitleBar().setCallback(function (data) {
                  switch (data[google.picker.Response.ACTION]) {
                    case google.picker.Action.PICKED:
                    case google.picker.Action.CANCEL:
                      resolve(data.docs || []);
                      picker.dispose();
                      break;
                    default:
                  }
                });
                switch (type) {
                  default:
                  case 'doc':
                    {
                      var mimeTypes = ['text/plain', 'text/x-markdown', 'application/octet-stream'].join(',');

                      var view = new google.picker.DocsView(google.picker.ViewId.DOCS);
                      view.setMimeTypes(mimeTypes);
                      pickerBuilder.addView(view);

                      var teamDriveView = new google.picker.DocsView(google.picker.ViewId.DOCS);
                      teamDriveView.setMimeTypes(mimeTypes);
                      teamDriveView.setEnableTeamDrives(true);
                      pickerBuilder.addView(teamDriveView);

                      pickerBuilder.enableFeature(google.picker.Feature.MULTISELECT_ENABLED);
                      pickerBuilder.enableFeature(google.picker.Feature.SUPPORT_TEAM_DRIVES);
                      break;
                    }
                  case 'folder':
                    {
                      var folderView = new google.picker.DocsView(google.picker.ViewId.FOLDERS);
                      folderView.setSelectFolderEnabled(true);
                      folderView.setMimeTypes(_this26.folderMimeType);
                      pickerBuilder.addView(folderView);

                      var _teamDriveView = new google.picker.DocsView(google.picker.ViewId.FOLDERS);
                      _teamDriveView.setSelectFolderEnabled(true);
                      _teamDriveView.setEnableTeamDrives(true);
                      _teamDriveView.setMimeTypes(_this26.folderMimeType);
                      pickerBuilder.addView(_teamDriveView);
                      break;
                    }
                  case 'img':
                    {
                      var _view = new google.picker.PhotosView();
                      _view.setType('highlights');
                      pickerBuilder.addView(_view);
                      pickerBuilder.addView(google.picker.ViewId.PHOTO_UPLOAD);
                      break;
                    }
                }
                picker = pickerBuilder.build();
                picker.setVisible(true);
              }));

            case 11:
            case 'end':
              return _context29.stop();
          }
        }
      }, _callee29, _this26);
    }))();
  }
});

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_constants__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__badgeSvc__ = __webpack_require__(11);










var forbiddenFolderNameMatcher = /^\.stackedit-data$|^\.stackedit-trash$|\.md$|\.sync$|\.publish$/;

/* harmony default export */ __webpack_exports__["a"] = ({
  createFile: function createFile() {
    var _this = this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        name = _ref.name,
        parentId = _ref.parentId,
        text = _ref.text,
        properties = _ref.properties,
        discussions = _ref.discussions,
        comments = _ref.comments;

    var background = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      var id, item, content, workspaceUniquePaths, parentPath, path;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              id = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].uid();
              item = {
                id: id,
                name: __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].sanitizeFilename(name),
                parentId: parentId || null
              };
              content = {
                id: id + '/content',
                text: __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].sanitizeText(text || __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['data/computedSettings'].newFileContent),
                properties: __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].sanitizeText(properties || __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['data/computedSettings'].newFileProperties),
                discussions: discussions || {},
                comments: comments || {}
              };
              workspaceUniquePaths = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspaceHasUniquePaths'];

              if (background) {
                _context.next = 14;
                break;
              }

              if (!(item.name !== __WEBPACK_IMPORTED_MODULE_7__data_constants__["a" /* default */].defaultName && item.name !== name)) {
                _context.next = 8;
                break;
              }

              _context.next = 8;
              return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('modal/open', {
                type: 'stripName',
                item: item
              });

            case 8:
              if (!workspaceUniquePaths) {
                _context.next = 14;
                break;
              }

              parentPath = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.pathsByItemId[item.parentId] || '';
              path = parentPath + item.name;

              if (!__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.itemsByPath[path]) {
                _context.next = 14;
                break;
              }

              _context.next = 14;
              return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('modal/open', {
                type: 'pathConflict',
                item: item
              });

            case 14:
              __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('content/setItem', content);
              __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('file/setItem', item);
              if (workspaceUniquePaths) {
                _this.makePathUnique(id);
              }

              return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.file.itemsById[id]);

            case 18:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  storeItem: function storeItem(item) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var id, sanitizedName, parentPath, path, items;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              id = item.id || __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].uid();
              sanitizedName = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].sanitizeFilename(item.name);

              if (!(item.type === 'folder' && forbiddenFolderNameMatcher.exec(sanitizedName))) {
                _context2.next = 6;
                break;
              }

              _context2.next = 5;
              return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('modal/open', {
                type: 'unauthorizedName',
                item: item
              });

            case 5:
              throw new Error('Unauthorized name.');

            case 6:
              if (!(sanitizedName !== __WEBPACK_IMPORTED_MODULE_7__data_constants__["a" /* default */].defaultName && sanitizedName !== item.name)) {
                _context2.next = 9;
                break;
              }

              _context2.next = 9;
              return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('modal/open', {
                type: 'stripName',
                item: item
              });

            case 9:
              if (!__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspaceHasUniquePaths']) {
                _context2.next = 16;
                break;
              }

              parentPath = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.pathsByItemId[item.parentId] || '';
              path = parentPath + sanitizedName;
              items = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.itemsByPath[path] || [];

              if (!items.some(function (itemWithSamePath) {
                return itemWithSamePath.id !== id;
              })) {
                _context2.next = 16;
                break;
              }

              _context2.next = 16;
              return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('modal/open', {
                type: 'pathConflict',
                item: item
              });

            case 16:
              return _context2.abrupt('return', _this2.setOrPatchItem(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, item, {
                id: id
              })));

            case 17:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  setOrPatchItem: function setOrPatchItem(patch) {
    var item = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.allItemsById[patch.id] || patch);
    if (!item.id) {
      return null;
    }

    if (patch.parentId !== undefined) {
      item.parentId = patch.parentId || null;
    }
    if (patch.name) {
      var sanitizedName = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].sanitizeFilename(patch.name);
      if (item.type !== 'folder' || !forbiddenFolderNameMatcher.exec(sanitizedName)) {
        item.name = sanitizedName;
      }
    }

    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit(item.type + '/setItem', item);

    this.removeCircularReference(item);

    if (__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspaceHasUniquePaths']) {
      this.makePathUnique(item.id);
    }

    return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.allItemsById[item.id];
  },
  deleteFile: function deleteFile(fileId) {
    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('file/deleteItem', fileId);

    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('content/deleteItem', fileId + '/content');

    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('syncedContent/deleteItem', fileId + '/syncedContent');

    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('contentState/deleteItem', fileId + '/contentState');

    (__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['syncLocation/groupedByFileId'][fileId] || []).forEach(function (item) {
      return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('syncLocation/deleteItem', item.id);
    });

    (__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['publishLocation/groupedByFileId'][fileId] || []).forEach(function (item) {
      return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('publishLocation/deleteItem', item.id);
    });
  },
  sanitizeWorkspace: function sanitizeWorkspace(idsToKeep) {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['folder/items'].forEach(function (folder) {
      return _this3.removeCircularReference(folder);
    });

    this.ensureUniquePaths(idsToKeep);
    this.ensureUniqueLocations(idsToKeep);
  },
  removeCircularReference: function removeCircularReference(item) {
    var foldersById = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.folder.itemsById;
    for (var parentFolder = foldersById[item.parentId]; parentFolder; parentFolder = foldersById[parentFolder.parentId]) {
      if (parentFolder.id === item.id) {
        __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('folder/patchItem', {
          id: item.id,
          parentId: null
        });
        break;
      }
    }
  },
  ensureUniquePaths: function ensureUniquePaths() {
    var _this4 = this;

    var idsToKeep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspaceHasUniquePaths']) {
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.pathsByItemId).some(function (id) {
        return !idsToKeep[id] && _this4.makePathUnique(id);
      })) {
        this.ensureUniquePaths(idsToKeep);
      }
    }
  },
  makePathUnique: function makePathUnique(id) {
    var _store$getters = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters,
        itemsByPath = _store$getters.itemsByPath,
        allItemsById = _store$getters.allItemsById,
        pathsByItemId = _store$getters.pathsByItemId;

    var item = allItemsById[id];
    if (!item) {
      return false;
    }
    var path = pathsByItemId[id];
    if (itemsByPath[path].length === 1) {
      return false;
    }
    var isFolder = item.type === 'folder';
    if (isFolder) {
      path = path.slice(0, -1);
    }
    for (var suffix = 1;; suffix += 1) {
      var pathWithSuffix = path + '.' + suffix;
      if (isFolder) {
        pathWithSuffix += '/';
      }
      if (!itemsByPath[pathWithSuffix]) {
        __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit(item.type + '/patchItem', {
          id: item.id,
          name: item.name + '.' + suffix
        });
        return true;
      }
    }
  },
  addSyncLocation: function addSyncLocation(location) {
    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('syncLocation/setItem', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, location, {
      id: __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].uid()
    }));

    this.ensureUniqueLocations();

    if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['syncLocation/currentWithWorkspaceSyncLocation']).length > 1) {
      __WEBPACK_IMPORTED_MODULE_8__badgeSvc__["a" /* default */].addBadge('syncMultipleLocations');
    }
  },
  addPublishLocation: function addPublishLocation(location) {
    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('publishLocation/setItem', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, location, {
      id: __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].uid()
    }));

    this.ensureUniqueLocations();

    if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['publishLocation/current']).length > 1) {
      __WEBPACK_IMPORTED_MODULE_8__badgeSvc__["a" /* default */].addBadge('publishMultipleLocations');
    }
  },
  ensureUniqueLocations: function ensureUniqueLocations() {
    var idsToKeep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    ['syncLocation', 'publishLocation'].forEach(function (type) {
      __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters[type + '/items'].forEach(function (item) {
        if (!idsToKeep[item.id] && __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters[type + '/groupedByFileIdAndHash'][item.fileId][item.hash].length > 1) {
          __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit(item.type + '/deleteItem', item.id);
        }
      });
    });
  },
  removeWorkspace: function removeWorkspace(id) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('workspace/removeWorkspace', id);

              _context3.next = 3;
              return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                var dbName = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].getDbName(id);
                var request = indexedDB.deleteDatabase(dbName);
                request.onerror = resolve;
                request.onsuccess = resolve;
              });

            case 3:
              localStorage.removeItem(id + '/lastSyncActivity');
              localStorage.removeItem(id + '/lastWindowFocus');

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this5);
    }))();
  }
});

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__providerRegistry__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_empties_emptyContent__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__workspaceSvc__ = __webpack_require__(36);












var dataExtractor = /<!--stackedit_data:([A-Za-z0-9+/=\s]+)-->\s*$/;

var Provider = function () {
  function Provider(props) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Provider);

    this.prepareChanges = function (changes) {
      return changes;
    };

    this.onChangesApplied = function () {};

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(this, props);
    __WEBPACK_IMPORTED_MODULE_6__providerRegistry__["a" /* default */].register(this);
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Provider, null, [{
    key: 'serializeContent',
    value: function serializeContent(content) {
      var result = content.text;
      var data = {};
      if (content.properties.length > 1) {
        data.properties = content.properties;
      }
      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(content.discussions).length) {
        data.discussions = content.discussions;
      }
      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(content.comments).length) {
        data.comments = content.comments;
      }
      if (content.history && content.history.length) {
        data.history = content.history;
      }
      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).length) {
        var serializedData = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].encodeBase64(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data)).replace(/(.{50})/g, '$1\n');
        result += '<!--stackedit_data:\n' + serializedData + '\n-->';
      }
      return result;
    }
  }, {
    key: 'parseContent',
    value: function parseContent(serializedContent, id) {
      var text = serializedContent;
      var extractedData = dataExtractor.exec(serializedContent);
      var result = void 0;
      if (!extractedData) {
        result = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].deepCopy(__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].state.content.itemsById[id]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__data_empties_emptyContent__["a" /* default */])(id);
      } else {
        result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__data_empties_emptyContent__["a" /* default */])(id);
        try {
          var serializedData = extractedData[1].replace(/\s/g, '');
          var parsedData = JSON.parse(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].decodeBase64(serializedData));
          text = text.slice(0, extractedData.index);
          if (parsedData.properties) {
            result.properties = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].sanitizeText(parsedData.properties);
          }
          if (parsedData.discussions) {
            result.discussions = parsedData.discussions;
          }
          if (parsedData.comments) {
            result.comments = parsedData.comments;
          }
          result.history = parsedData.history;
        } catch (e) {}
      }
      result.text = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].sanitizeText(text);
      if (!result.history) {
        result.history = [];
      }
      return __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].addItemHash(result);
    }
  }, {
    key: 'openFileWithLocation',
    value: function openFileWithLocation(criteria) {
      var location = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].search(__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters['syncLocation/items'], criteria);
      if (location) {
        var item = __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].state.file.itemsById[location.fileId];
        if (item) {
          __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('file/setCurrentId', item.id);

          if (item.parentId === 'trash') {
            __WEBPACK_IMPORTED_MODULE_10__workspaceSvc__["a" /* default */].setOrPatchItem(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
              parentId: null
            }));
          }
          return true;
        }
      }
      return false;
    }
  }]);

  return Provider;
}();

/* harmony default export */ __webpack_exports__["a"] = (Provider);

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(4);





var _this = this;




var refreshUserInfoAfter = 60 * 60 * 1000;

var infoResolversByType = {};
var subPrefixesByType = {};
var typesBySubPrefix = {};

var lastInfosByUserId = {};
var infoPromisedByUserId = {};

var sanitizeUserId = function sanitizeUserId(userId) {
  var prefix = userId[2] === ':' && userId.slice(0, 2);
  if (typesBySubPrefix[prefix]) {
    return userId;
  }
  return 'go:' + userId;
};

var parseUserId = function parseUserId(userId) {
  return [typesBySubPrefix[userId.slice(0, 2)], userId.slice(3)];
};

var refreshUserInfos = function refreshUserInfos() {
  if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.offline) {
    return;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(lastInfosByUserId).filter(function (_ref) {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
        userId = _ref2[0],
        lastInfo = _ref2[1];

    return lastInfo === 0 && !infoPromisedByUserId[userId];
  }).forEach(function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref4) {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref4, 1),
          userId = _ref5[0];

      var _parseUserId, _parseUserId2, type, sub, infoResolver, userInfo;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _parseUserId = parseUserId(userId), _parseUserId2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_parseUserId, 2), type = _parseUserId2[0], sub = _parseUserId2[1];
              infoResolver = infoResolversByType[type];

              if (!infoResolver) {
                _context.next = 13;
                break;
              }

              _context.prev = 3;

              infoPromisedByUserId[userId] = true;
              _context.next = 7;
              return infoResolver(sub);

            case 7:
              userInfo = _context.sent;

              __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('userInfo/setItem', userInfo);

            case 9:
              _context.prev = 9;

              infoPromisedByUserId[userId] = false;
              lastInfosByUserId[userId] = Date.now();
              return _context.finish(9);

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[3,, 9, 13]]);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }());
};

/* harmony default export */ __webpack_exports__["a"] = ({
  setInfoResolver: function setInfoResolver(type, subPrefix, resolver) {
    infoResolversByType[type] = resolver;
    subPrefixesByType[type] = subPrefix;
    typesBySubPrefix[subPrefix] = type;
  },
  getCurrentUserId: function getCurrentUserId() {
    var loginToken = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['workspace/loginToken'];
    if (!loginToken) {
      return null;
    }
    var loginType = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['workspace/loginType'];
    var prefix = subPrefixesByType[loginType];
    return prefix ? prefix + ':' + loginToken.sub : loginToken.sub;
  },

  sanitizeUserId: sanitizeUserId,
  addUserInfo: function addUserInfo(userInfo) {
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('userInfo/setItem', userInfo);
    lastInfosByUserId[userInfo.id] = Date.now();
  },
  addUserId: function addUserId(userId) {
    if (userId) {
      var sanitizedUserId = sanitizeUserId(userId);
      var lastInfo = lastInfosByUserId[sanitizedUserId];
      if (lastInfo === undefined) {
        var _parseUserId3 = parseUserId(sanitizedUserId),
            _parseUserId4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_parseUserId3, 2),
            type = _parseUserId4[0],
            sub = _parseUserId4[1];

        var token = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['data/tokensByType'][type][sub];
        if (token) {
          __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('userInfo/setItem', {
            id: sanitizedUserId,
            name: token.name
          });
        }
      }

      if (lastInfo === undefined || lastInfo + refreshUserInfoAfter < Date.now()) {
        lastInfosByUserId[sanitizedUserId] = 0;
        refreshUserInfos();
      }
    }
  }
});

__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].setInterval(function () {
  return refreshUserInfos();
}, 60 * 1000);

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModalInner_vue_vue_type_template_id_5744d9d6___ = __webpack_require__(2429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalInner_vue_vue_type_script_lang_js___ = __webpack_require__(907);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ModalInner_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ModalInner_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ModalInner_vue_vue_type_template_id_5744d9d6___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ModalInner_vue_vue_type_template_id_5744d9d6___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "ModalInner.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 56 */,
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_promise__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_create__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__data_constants__ = __webpack_require__(94);















var scriptLoadingPromises = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_create___default()(null);
var authorizeTimeout = 6 * 60 * 1000;
var silentAuthorizeTimeout = 15 * 1000;
var networkTimeout = 30 * 1000;
var isConnectionDown = false;
var userInactiveAfter = 3 * 60 * 1000;
var lastActivity = 0;
var lastFocus = 0;
var isConfLoading = false;
var isConfLoaded = false;

function parseHeaders(xhr) {
  var pairs = xhr.getAllResponseHeaders().trim().split('\n');
  var headers = {};
  pairs.forEach(function (header) {
    var split = header.trim().split(':');
    var key = split.shift().trim().toLowerCase();
    var value = split.join(':').trim();
    headers[key] = value;
  });
  return headers;
}

function isRetriable(err) {
  if (err.status === 403) {
    var googleReason = ((((err.body || {}).error || {}).errors || [])[0] || {}).reason;
    return googleReason === 'rateLimitExceeded' || googleReason === 'userRateLimitExceeded';
  }
  return err.status === 429 || err.status >= 500 && err.status < 600;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  init: function init() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var setLastActivity, setLastFocus, checkOffline;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLastActivity = function setLastActivity() {
                lastActivity = Date.now();
              };

              window.document.addEventListener('mousedown', setLastActivity);
              window.document.addEventListener('keydown', setLastActivity);
              window.document.addEventListener('touchstart', setLastActivity);

              lastFocus = 0;

              setLastFocus = function setLastFocus() {
                lastFocus = Date.now();
                localStorage.setItem(__WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters['workspace/lastFocusKey'], lastFocus);
                setLastActivity();
              };

              if (document.hasFocus()) {
                setLastFocus();
              }
              window.addEventListener('focus', setLastFocus);

              checkOffline = function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee() {
                  var isBrowserOffline, script, timeout, offline;
                  return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          isBrowserOffline = window.navigator.onLine === false;

                          if (!(!isBrowserOffline && __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].state.lastOfflineCheck + networkTimeout + 5000 < Date.now() && _this.isUserActive())) {
                            _context.next = 18;
                            break;
                          }

                          __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].commit('updateLastOfflineCheck');
                          script = document.createElement('script');
                          timeout = void 0;
                          _context.prev = 5;
                          _context.next = 8;
                          return new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                            script.onload = resolve;
                            script.onerror = reject;
                            script.src = '/write/online.js?' + Date.now();
                            try {
                              document.head.appendChild(script);
                              timeout = setTimeout(reject, networkTimeout);
                            } catch (e) {
                              reject(e);
                            }
                          });

                        case 8:
                          isConnectionDown = false;
                          _context.next = 14;
                          break;

                        case 11:
                          _context.prev = 11;
                          _context.t0 = _context['catch'](5);

                          isConnectionDown = true;

                        case 14:
                          _context.prev = 14;

                          clearTimeout(timeout);
                          document.head.removeChild(script);
                          return _context.finish(14);

                        case 18:
                          offline = isBrowserOffline || isConnectionDown;

                          if (__WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].state.offline !== offline) {
                            __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].commit('setOffline', offline);
                            if (offline) {
                              __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].dispatch('notification/error', 'You are offline.');
                            } else {
                              __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].dispatch('notification/info', 'You are back online!');
                              _this.getServerConf();
                            }
                          }

                        case 20:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this, [[5, 11, 14, 18]]);
                }));

                return function checkOffline() {
                  return _ref.apply(this, arguments);
                };
              }();

              __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].setInterval(checkOffline, 1000);
              window.addEventListener('online', function () {
                isConnectionDown = false;
                checkOffline();
              });
              window.addEventListener('offline', checkOffline);
              _context2.next = 14;
              return checkOffline();

            case 14:
              _this.getServerConf();

            case 15:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  },
  getServerConf: function getServerConf() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(!__WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].state.offline && !isConfLoading && !isConfLoaded)) {
                _context3.next = 12;
                break;
              }

              _context3.prev = 1;

              isConfLoading = true;
              _context3.next = 5;
              return _this2.request({ url: 'conf' });

            case 5:
              res = _context3.sent;
              _context3.next = 8;
              return __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].dispatch('data/setServerConf', res.body);

            case 8:
              isConfLoaded = true;

            case 9:
              _context3.prev = 9;

              isConfLoading = false;
              return _context3.finish(9);

            case 12:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2, [[1,, 9, 12]]);
    }))();
  },
  isWindowFocused: function isWindowFocused() {
    var storedLastFocus = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters['workspace/lastFocusKey']);
    return parseInt(storedLastFocus, 10) === lastFocus;
  },
  isUserActive: function isUserActive() {
    return lastActivity > Date.now() - userInactiveAfter && this.isWindowFocused();
  },
  isConfLoaded: function isConfLoaded() {
    return !!__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters['data/serverConf']).length;
  },
  loadScript: function loadScript(url) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!scriptLoadingPromises[url]) {
                scriptLoadingPromises[url] = new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  var script = document.createElement('script');
                  script.onload = resolve;
                  script.onerror = function () {
                    scriptLoadingPromises[url] = null;
                    reject();
                  };
                  script.src = url;
                  document.head.appendChild(script);
                });
              }
              return _context4.abrupt('return', scriptLoadingPromises[url]);

            case 2:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this3);
    }))();
  },
  startOauth2: function startOauth2(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _this4 = this;

    var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var reattempt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var state, authorizeUrl, iframeElt, wnd, checkClosedInterval, closeTimeout, msgHandler;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              state = __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].uid();
              authorizeUrl = __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].addQueryParams(url, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, params, {
                state: state,
                redirect_uri: __WEBPACK_IMPORTED_MODULE_13__data_constants__["a" /* default */].oauth2RedirectUri
              }));
              iframeElt = void 0;
              wnd = void 0;

              if (!silent) {
                _context5.next = 11;
                break;
              }

              iframeElt = __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].createHiddenIframe(authorizeUrl);
              document.body.appendChild(iframeElt);
              wnd = iframeElt.contentWindow;
              _context5.next = 14;
              break;

            case 11:
              wnd = window.open(authorizeUrl);

              if (wnd) {
                _context5.next = 14;
                break;
              }

              throw new Error('The authorize window was blocked.');

            case 14:
              checkClosedInterval = void 0;
              closeTimeout = void 0;
              msgHandler = void 0;
              _context5.prev = 17;
              _context5.next = 20;
              return new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                if (silent) {
                  iframeElt.onerror = function () {
                    reject(new Error('Unknown error.'));
                  };
                  closeTimeout = setTimeout(function () {
                    if (!reattempt) {
                      reject(new Error('REATTEMPT'));
                    } else {
                      isConnectionDown = true;
                      __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].commit('setOffline', true);
                      __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].commit('updateLastOfflineCheck');
                      reject(new Error('You are offline.'));
                    }
                  }, silentAuthorizeTimeout);
                } else {
                  closeTimeout = setTimeout(function () {
                    reject(new Error('Timeout.'));
                  }, authorizeTimeout);
                }

                msgHandler = function msgHandler(event) {
                  if (event.source === wnd && event.origin === __WEBPACK_IMPORTED_MODULE_13__data_constants__["a" /* default */].origin) {
                    var data = __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].parseQueryParams(('' + event.data).slice(1));
                    if (data.error || data.state !== state) {
                      console.error(data);
                      reject(new Error('Could not get required authorization.'));
                    } else {
                      resolve({
                        accessToken: data.access_token,
                        code: data.code,
                        idToken: data.id_token,
                        expiresIn: data.expires_in
                      });
                    }
                  }
                };

                window.addEventListener('message', msgHandler);
                if (!silent) {
                  checkClosedInterval = setInterval(function () {
                    if (wnd.closed) {
                      reject(new Error('Authorize window was closed.'));
                    }
                  }, 250);
                }
              });

            case 20:
              return _context5.abrupt('return', _context5.sent);

            case 21:
              _context5.prev = 21;

              clearInterval(checkClosedInterval);
              if (!silent && !wnd.closed) {
                wnd.close();
              }
              if (iframeElt) {
                document.body.removeChild(iframeElt);
              }
              clearTimeout(closeTimeout);
              window.removeEventListener('message', msgHandler);
              return _context5.finish(21);

            case 28:
              _context5.next = 35;
              break;

            case 30:
              _context5.prev = 30;
              _context5.t0 = _context5['catch'](0);

              if (!(_context5.t0.message === 'REATTEMPT')) {
                _context5.next = 34;
                break;
              }

              return _context5.abrupt('return', _this4.startOauth2(url, params, silent, true));

            case 34:
              throw _context5.t0;

            case 35:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this4, [[0, 30], [17,, 21, 28]]);
    }))();
  },
  request: function request(config) {
    var _this5 = this;

    var offlineCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var retryAfter, maxRetryAfter, sanitizedConfig, attempt;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              retryAfter = 500;
              maxRetryAfter = 10 * 1000;
              sanitizedConfig = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, config);

              sanitizedConfig.timeout = sanitizedConfig.timeout || networkTimeout;
              sanitizedConfig.headers = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, sanitizedConfig.headers);
              if (sanitizedConfig.body && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(sanitizedConfig.body) === 'object') {
                sanitizedConfig.body = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(sanitizedConfig.body);
                sanitizedConfig.headers['Content-Type'] = 'application/json';
              }

              attempt = function () {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee6() {
                  return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          _context6.prev = 0;
                          _context6.next = 3;
                          return new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                            if (offlineCheck) {
                              __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].commit('updateLastOfflineCheck');
                            }

                            var xhr = new window.XMLHttpRequest();
                            xhr.withCredentials = sanitizedConfig.withCredentials || false;

                            var timeoutId = setTimeout(function () {
                              xhr.abort();
                              if (offlineCheck) {
                                isConnectionDown = true;
                                __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].commit('setOffline', true);
                                reject(new Error('You are offline.'));
                              } else {
                                reject(new Error('Network request timeout.'));
                              }
                            }, sanitizedConfig.timeout);

                            xhr.onload = function () {
                              if (offlineCheck) {
                                isConnectionDown = false;
                              }
                              clearTimeout(timeoutId);
                              var result = {
                                status: xhr.status,
                                headers: parseHeaders(xhr),
                                body: sanitizedConfig.blob ? xhr.response : xhr.responseText
                              };
                              if (!sanitizedConfig.raw && !sanitizedConfig.blob) {
                                try {
                                  result.body = JSON.parse(result.body);
                                } catch (e) {}
                              }
                              if (result.status >= 200 && result.status < 300) {
                                resolve(result);
                              } else {
                                reject(result);
                              }
                            };

                            xhr.onerror = function () {
                              clearTimeout(timeoutId);
                              if (offlineCheck) {
                                isConnectionDown = true;
                                __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].commit('setOffline', true);
                                reject(new Error('You are offline.'));
                              } else {
                                reject(new Error('Network request failed.'));
                              }
                            };

                            var url = __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].addQueryParams(sanitizedConfig.url, sanitizedConfig.params);
                            xhr.open(sanitizedConfig.method || 'GET', url);
                            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(sanitizedConfig.headers).forEach(function (_ref3) {
                              var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
                                  key = _ref4[0],
                                  value = _ref4[1];

                              if (value) {
                                xhr.setRequestHeader(key, '' + value);
                              }
                            });
                            if (sanitizedConfig.blob) {
                              xhr.responseType = 'blob';
                            }
                            xhr.send(sanitizedConfig.body || null);
                          });

                        case 3:
                          return _context6.abrupt('return', _context6.sent);

                        case 6:
                          _context6.prev = 6;
                          _context6.t0 = _context6['catch'](0);

                          if (!(isRetriable(_context6.t0) && retryAfter < maxRetryAfter)) {
                            _context6.next = 12;
                            break;
                          }

                          _context6.next = 11;
                          return new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_promise___default.a(function (resolve) {
                            setTimeout(resolve, retryAfter);

                            retryAfter *= 2;
                          });

                        case 11:
                          return _context6.abrupt('return', attempt());

                        case 12:
                          throw _context6.t0;

                        case 13:
                        case 'end':
                          return _context6.stop();
                      }
                    }
                  }, _callee6, _this5, [[0, 6]]);
                }));

                return function attempt() {
                  return _ref2.apply(this, arguments);
                };
              }();

              return _context7.abrupt('return', attempt());

            case 8:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this5);
    }))();
  }
});

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_clunderscore__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cleditCore__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cleditHighlighter__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cleditKeystroke__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cleditMarker__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cleditSelectionMgr__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cleditUndoMgr__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cleditUtils__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cleditWatcher__ = __webpack_require__(997);










/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__cleditCore__["a" /* default */]);

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var origin = window.location.protocol + '//' + window.location.host;

/* harmony default export */ __webpack_exports__["a"] = ({
  cleanTrashAfter: 7 * 24 * 60 * 60 * 1000,
  origin: origin,
  oauth2RedirectUri: origin + '/write/oauth2/callback',
  types: ['contentState', 'syncedContent', 'content', 'file', 'folder', 'syncLocation', 'publishLocation', 'data'],
  localStorageDataIds: ['workspaces', 'settings', 'layoutSettings', 'tokens', 'badgeCreations', 'serverConf'],
  textMaxLength: 250000,
  defaultName: 'Untitled'
});

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MenuEntry_vue_vue_type_template_id_7a3c52ac___ = __webpack_require__(2412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MenuEntry_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}



/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__MenuEntry_vue_vue_type_template_id_7a3c52ac___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__MenuEntry_vue_vue_type_template_id_7a3c52ac___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "MenuEntry.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_diff_match_patch__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_diff_match_patch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_diff_match_patch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_turndown_lib_turndown_browser_umd__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_turndown_lib_turndown_browser_umd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_turndown_lib_turndown_browser_umd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_htmlSanitizer__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(2);





function cledit(contentElt, scrollEltOpt) {
  var isMarkdown = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollElt = scrollEltOpt || contentElt;
  var editor = {
    $contentElt: contentElt,
    $scrollElt: scrollElt,
    $keystrokes: [],
    $markers: {}
  };
  cledit.Utils.createEventHooks(editor);
  var debounce = cledit.Utils.debounce;


  contentElt.setAttribute('tabindex', '0');
  editor.toggleEditable = function (isEditable) {
    contentElt.contentEditable = isEditable == null ? !contentElt.contentEditable : isEditable;
  };
  editor.toggleEditable(true);

  function getTextContent() {
    var textContent = contentElt.textContent.replace(/\r[\n\u0085]?|[\u2424\u2028\u0085]/g, '\n');
    if (textContent.slice(-1) !== '\n') {
      textContent += '\n';
    }
    return textContent;
  }

  var lastTextContent = getTextContent();
  var highlighter = new cledit.Highlighter(editor);

  var diffMatchPatch = new __WEBPACK_IMPORTED_MODULE_0_diff_match_patch___default.a();

  var selectionMgr = new cledit.SelectionMgr(editor);

  function adjustCursorPosition(force) {
    selectionMgr.saveSelectionState(true, true, force);
  }

  function replaceContent(selectionStart, selectionEnd, replacement) {
    var min = Math.min(selectionStart, selectionEnd);
    var max = Math.max(selectionStart, selectionEnd);
    var range = selectionMgr.createRange(min, max);
    var rangeText = '' + range;

    if (rangeText.length === max - min && rangeText === replacement) {
      return null;
    }
    range.deleteContents();
    range.insertNode(document.createTextNode(replacement));
    return range;
  }

  var ignoreUndo = false;
  var noContentFix = false;

  function setContent(value, noUndo, maxStartOffsetOpt) {
    var textContent = getTextContent();
    var maxStartOffset = maxStartOffsetOpt != null && maxStartOffsetOpt < textContent.length ? maxStartOffsetOpt : textContent.length - 1;
    var startOffset = Math.min(diffMatchPatch.diff_commonPrefix(textContent, value), maxStartOffset);
    var endOffset = Math.min(diffMatchPatch.diff_commonSuffix(textContent, value), textContent.length - startOffset, value.length - startOffset);
    var replacement = value.substring(startOffset, value.length - endOffset);
    var range = replaceContent(startOffset, textContent.length - endOffset, replacement);
    if (range) {
      ignoreUndo = noUndo;
      noContentFix = true;
    }
    return {
      start: startOffset,
      end: value.length - endOffset,
      range: range
    };
  }

  var undoMgr = new cledit.UndoMgr(editor);

  function replace(selectionStart, selectionEnd, replacement) {
    undoMgr.setDefaultMode('single');
    replaceContent(selectionStart, selectionEnd, replacement);
    var startOffset = Math.min(selectionStart, selectionEnd);
    var endOffset = startOffset + replacement.length;
    selectionMgr.setSelectionStartEnd(endOffset, endOffset);
    selectionMgr.updateCursorCoordinates(true);
  }

  function replaceAll(search, replacement) {
    var startOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    undoMgr.setDefaultMode('single');
    var text = getTextContent();
    var subtext = getTextContent().slice(startOffset);
    var value = subtext.replace(search, replacement);
    if (value !== subtext) {
      var offset = editor.setContent(text.slice(0, startOffset) + value);
      selectionMgr.setSelectionStartEnd(offset.end, offset.end);
      selectionMgr.updateCursorCoordinates(true);
    }
  }

  function focus() {
    selectionMgr.restoreSelection();
    contentElt.focus();
  }

  function addMarker(marker) {
    editor.$markers[marker.id] = marker;
  }

  function removeMarker(marker) {
    delete editor.$markers[marker.id];
  }

  var triggerSpellCheck = debounce(function () {
    var selection = window.getSelection();
    if (selectionMgr.hasFocus() && !highlighter.isComposing && selectionMgr.selectionStart === selectionMgr.selectionEnd && selection.modify) {
      if (selectionMgr.selectionStart) {
        selection.modify('move', 'backward', 'character');
        selection.modify('move', 'forward', 'character');
      } else {
        selection.modify('move', 'forward', 'character');
        selection.modify('move', 'backward', 'character');
      }
    }
  }, 10);

  var watcher = void 0;
  var skipSaveSelection = void 0;
  function checkContentChange(mutations) {
    watcher.noWatch(function () {
      var removedSections = [];
      var modifiedSections = [];

      function markModifiedSection(node) {
        var currentNode = node;
        while (currentNode && currentNode !== contentElt) {
          if (currentNode.section) {
            var array = currentNode.parentNode ? modifiedSections : removedSections;
            if (array.indexOf(currentNode.section) === -1) {
              array.push(currentNode.section);
            }
            return;
          }
          currentNode = currentNode.parentNode;
        }
      }

      mutations.cl_each(function (mutation) {
        markModifiedSection(mutation.target);
        mutation.addedNodes.cl_each(markModifiedSection);
        mutation.removedNodes.cl_each(markModifiedSection);
      });
      highlighter.fixContent(modifiedSections, removedSections, noContentFix);
      noContentFix = false;
    });

    if (!skipSaveSelection) {
      selectionMgr.saveSelectionState();
    }
    skipSaveSelection = false;

    var newTextContent = getTextContent();
    var diffs = diffMatchPatch.diff_main(lastTextContent, newTextContent);
    editor.$markers.cl_each(function (marker) {
      marker.adjustOffset(diffs);
    });

    var sectionList = highlighter.parseSections(newTextContent);
    editor.$trigger('contentChanged', newTextContent, diffs, sectionList);
    if (!ignoreUndo) {
      undoMgr.addDiffs(lastTextContent, newTextContent, diffs);
      undoMgr.setDefaultMode('typing');
      undoMgr.saveState();
    }
    ignoreUndo = false;
    lastTextContent = newTextContent;
    triggerSpellCheck();
  }

  watcher = new cledit.Watcher(editor, checkContentChange);
  watcher.startWatching();

  function setSelection(start, end) {
    selectionMgr.setSelectionStartEnd(start, end == null ? start : end);
    selectionMgr.updateCursorCoordinates();
  }

  function keydownHandler(handler) {
    return function (evt) {
      if (evt.which !== 17 && evt.which !== 91 && evt.which !== 18 && evt.which !== 16) {
          handler(evt);
        }
    };
  }

  var windowKeydownListener = void 0;
  var windowMouseListener = void 0;
  var windowResizeListener = void 0;
  function tryDestroy() {
    if (document.contains(contentElt)) {
      return false;
    }
    watcher.stopWatching();
    window.removeEventListener('keydown', windowKeydownListener);
    window.removeEventListener('mousedown', windowMouseListener);
    window.removeEventListener('mouseup', windowMouseListener);
    window.removeEventListener('resize', windowResizeListener);
    editor.$trigger('destroy');
    return true;
  }

  windowKeydownListener = function windowKeydownListener(evt) {
    if (!tryDestroy()) {
      keydownHandler(function () {
        adjustCursorPosition();
      })(evt);
    }
  };
  window.addEventListener('keydown', windowKeydownListener);

  windowMouseListener = function windowMouseListener() {
    if (!tryDestroy()) {
      selectionMgr.saveSelectionState(true, false);
    }
  };
  window.addEventListener('mousedown', windowMouseListener);
  window.addEventListener('mouseup', windowMouseListener);

  windowResizeListener = function windowResizeListener() {
    if (!tryDestroy()) {
      selectionMgr.updateCursorCoordinates();
    }
  };
  window.addEventListener('resize', windowResizeListener);

  contentElt.addEventListener('contextmenu', selectionMgr.saveSelectionState.cl_bind(selectionMgr, true, false));

  contentElt.addEventListener('keydown', keydownHandler(function (evt) {
    selectionMgr.saveSelectionState();

    var contentChanging = false;
    var textContent = getTextContent();
    var min = Math.min(selectionMgr.selectionStart, selectionMgr.selectionEnd);
    var max = Math.max(selectionMgr.selectionStart, selectionMgr.selectionEnd);
    var state = {
      before: textContent.slice(0, min),
      after: textContent.slice(max),
      selection: textContent.slice(min, max),
      isBackwardSelection: selectionMgr.selectionStart > selectionMgr.selectionEnd
    };
    editor.$keystrokes.cl_some(function (keystroke) {
      if (!keystroke.handler(evt, state, editor)) {
        return false;
      }
      var newContent = state.before + state.selection + state.after;
      if (newContent !== getTextContent()) {
        editor.setContent(newContent, false, min);
        contentChanging = true;
        skipSaveSelection = true;
        highlighter.cancelComposition = true;
      }
      min = state.before.length;
      max = min + state.selection.length;
      selectionMgr.setSelectionStartEnd(state.isBackwardSelection ? max : min, state.isBackwardSelection ? min : max, !contentChanging);
      return true;
    });

    if (!contentChanging) {
      adjustCursorPosition();
    }
  }));

  contentElt.addEventListener('compositionstart', function () {
    highlighter.isComposing += 1;
  });

  contentElt.addEventListener('compositionend', function () {
    setTimeout(function () {
      if (highlighter.isComposing) {
        highlighter.isComposing -= 1;
        if (!highlighter.isComposing) {
          checkContentChange([]);
        }
      }
    }, 1);
  });

  var turndownService = void 0;
  if (isMarkdown) {
    contentElt.addEventListener('copy', function (evt) {
      if (evt.clipboardData) {
        evt.clipboardData.setData('text/plain', selectionMgr.getSelectedText());
        evt.preventDefault();
      }
    });

    contentElt.addEventListener('cut', function (evt) {
      if (evt.clipboardData) {
        evt.clipboardData.setData('text/plain', selectionMgr.getSelectedText());
        evt.preventDefault();
        replace(selectionMgr.selectionStart, selectionMgr.selectionEnd, '');
      } else {
        undoMgr.setCurrentMode('single');
      }
      adjustCursorPosition();
    });

    turndownService = new __WEBPACK_IMPORTED_MODULE_1_turndown_lib_turndown_browser_umd___default.a(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['data/computedSettings'].turndown);
    turndownService.escape = function (str) {
      return str;
    };
  }

  contentElt.addEventListener('paste', function (evt) {
    undoMgr.setCurrentMode('single');
    evt.preventDefault();
    var data = void 0;
    var clipboardData = evt.clipboardData;

    if (clipboardData) {
      data = clipboardData.getData('text/plain');
      if (turndownService) {
        try {
          var html = clipboardData.getData('text/html');
          if (html) {
            var sanitizedHtml = __WEBPACK_IMPORTED_MODULE_2__libs_htmlSanitizer__["a" /* default */].sanitizeHtml(html).replace(/&#160;/g, ' ');
            if (sanitizedHtml) {
              data = turndownService.turndown(sanitizedHtml);
            }
          }
        } catch (e) {}
      }
    } else {
      clipboardData = window.clipboardData.clipboardData;

      data = clipboardData && clipboardData.getData('Text');
    }
    if (!data) {
      return;
    }
    replace(selectionMgr.selectionStart, selectionMgr.selectionEnd, data);
    adjustCursorPosition();
  });

  contentElt.addEventListener('focus', function () {
    editor.$trigger('focus');
  });

  contentElt.addEventListener('blur', function () {
    editor.$trigger('blur');
  });

  function addKeystroke(keystroke) {
    var keystrokes = Array.isArray(keystroke) ? keystroke : [keystroke];
    editor.$keystrokes = editor.$keystrokes.concat(keystrokes).sort(function (keystroke1, keystroke2) {
      return keystroke1.priority - keystroke2.priority;
    });
  }
  addKeystroke(cledit.defaultKeystrokes);

  editor.selectionMgr = selectionMgr;
  editor.undoMgr = undoMgr;
  editor.highlighter = highlighter;
  editor.watcher = watcher;
  editor.adjustCursorPosition = adjustCursorPosition;
  editor.setContent = setContent;
  editor.replace = replace;
  editor.replaceAll = replaceAll;
  editor.getContent = getTextContent;
  editor.focus = focus;
  editor.setSelection = setSelection;
  editor.addKeystroke = addKeystroke;
  editor.addMarker = addMarker;
  editor.removeMarker = removeMarker;

  editor.init = function () {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var options = {
      getCursorFocusRatio: function getCursorFocusRatio() {
        return 0.1;
      },
      sectionHighlighter: function sectionHighlighter(section) {
        return section.text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
      },

      sectionDelimiter: ''
    }.cl_extend(opts);
    editor.options = options;

    if (options.content !== undefined) {
      lastTextContent = options.content.toString();
      if (lastTextContent.slice(-1) !== '\n') {
        lastTextContent += '\n';
      }
    }

    var sectionList = highlighter.parseSections(lastTextContent, true);
    editor.$trigger('contentChanged', lastTextContent, [0, lastTextContent], sectionList);
    if (options.selectionStart !== undefined && options.selectionEnd !== undefined) {
      editor.setSelection(options.selectionStart, options.selectionEnd);
    } else {
      selectionMgr.saveSelectionState();
    }
    undoMgr.init(options);

    if (options.scrollTop !== undefined) {
      scrollElt.scrollTop = options.scrollTop;
    }
  };

  return editor;
}

/* harmony default export */ __webpack_exports__["a"] = (cledit);

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getOptionsListeners = [];
var initConverterListeners = [];
var sectionPreviewListeners = [];

/* harmony default export */ __webpack_exports__["a"] = ({
  onGetOptions: function onGetOptions(listener) {
    getOptionsListeners.push(listener);
  },
  onInitConverter: function onInitConverter(priority, listener) {
    initConverterListeners[priority] = listener;
  },
  onSectionPreview: function onSectionPreview(listener) {
    sectionPreviewListeners.push(listener);
  },
  getOptions: function getOptions(properties, isCurrentFile) {
    return getOptionsListeners.reduce(function (options, listener) {
      listener(options, properties, isCurrentFile);
      return options;
    }, {});
  },
  initConverter: function initConverter(markdown, options) {
    initConverterListeners.forEach(function (listener) {
      listener(markdown, options);
    });
  },
  sectionPreview: function sectionPreview(elt, options, isEditor) {
    sectionPreviewListeners.forEach(function (listener) {
      listener(elt, options, isEditor);
    });
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  providersById: {},
  register: function register(provider) {
    this.providersById[provider.id] = provider;
    return provider;
  }
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__localDbSvc__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__diffUtils__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__networkSvc__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__providers_common_providerRegistry__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__providers_googleDriveAppDataProvider__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__providers_couchdbWorkspaceProvider__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__providers_githubWorkspaceProvider__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__providers_gitlabWorkspaceProvider__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__providers_googleDriveWorkspaceProvider__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__tempFileSvc__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__workspaceSvc__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__data_constants__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__badgeSvc__ = __webpack_require__(11);














var _this = this;

















var minAutoSyncEvery = 60 * 1000;
var inactivityThreshold = 3 * 1000;
var restartSyncAfter = 30 * 1000;
var restartContentSyncAfter = 1000;
var checkSponsorshipAfter = 5 * 60 * 1000 + 30 * 1000;
var maxContentHistory = 20;

var LAST_SEEN = 0;
var LAST_MERGED = 1;
var LAST_SENT = 2;

var actionProvider = void 0;
var workspaceProvider = void 0;

var lastSyncActivity = void 0;
var getLastStoredSyncActivity = function getLastStoredSyncActivity() {
  return parseInt(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['workspace/lastSyncActivityKey']), 10) || 0;
};

var isWorkspaceSyncPossible = function isWorkspaceSyncPossible() {
  return !!__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['workspace/syncToken'];
};

var hasCurrentFileSyncLocations = function hasCurrentFileSyncLocations() {
  return !!__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['syncLocation/current'].length;
};

var isSyncPossible = function isSyncPossible() {
  return !__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].state.offline && (isWorkspaceSyncPossible() || hasCurrentFileSyncLocations());
};

var isSyncWindow = function isSyncWindow() {
  var storedLastSyncActivity = getLastStoredSyncActivity();
  return lastSyncActivity === storedLastSyncActivity || Date.now() > inactivityThreshold + storedLastSyncActivity;
};

var isAutoSyncReady = function isAutoSyncReady() {
  var autoSyncEvery = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/computedSettings'].autoSyncEvery;

  if (autoSyncEvery < minAutoSyncEvery) {
    autoSyncEvery = minAutoSyncEvery;
  }
  return Date.now() > autoSyncEvery + getLastStoredSyncActivity();
};

var setLastSyncActivity = function setLastSyncActivity() {
  var currentDate = Date.now();
  lastSyncActivity = currentDate;
  localStorage.setItem(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['workspace/lastSyncActivityKey'], currentDate);
};

var upgradeSyncedContent = function upgradeSyncedContent(syncedContent) {
  if (syncedContent.v) {
    return syncedContent;
  }
  var hashUpgrades = {};
  var historyData = {};
  var syncHistory = {};
  __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_entries___default()(syncedContent.historyData).forEach(function (_ref) {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
        hash = _ref2[0],
        content = _ref2[1];

    var newContent = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].addItemHash(content);
    historyData[newContent.hash] = newContent;
    hashUpgrades[hash] = newContent.hash;
  });
  __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_entries___default()(syncedContent.syncHistory).forEach(function (_ref3) {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
        id = _ref4[0],
        hashEntries = _ref4[1];

    syncHistory[id] = hashEntries.map(function (hash) {
      return hashUpgrades[hash];
    });
  });
  return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, syncedContent, {
    historyData: historyData,
    syncHistory: syncHistory,
    v: 1
  });
};

var cleanSyncedContent = function cleanSyncedContent(syncedContent) {
  var _ref5;

  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys___default()(syncedContent.syncHistory).forEach(function (syncLocationId) {
    if (syncLocationId !== 'main' && !__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].state.syncLocation.itemsById[syncLocationId]) {
      delete syncedContent.syncHistory[syncLocationId];
    }
  });

  var allSyncLocationHashSet = new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set___default.a((_ref5 = []).concat.apply(_ref5, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys___default()(syncedContent.syncHistory).map(function (id) {
    return syncedContent.syncHistory[id];
  }))));

  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys___default()(syncedContent.historyData).map(function (hash) {
    return parseInt(hash, 10);
  }).forEach(function (hash) {
    if (!allSyncLocationHashSet.has(hash)) {
      delete syncedContent.historyData[hash];
    }
  });
};

var applyChanges = function applyChanges(changes) {
  var allItemsById = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters.allItemsById);
  var syncDataById = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/syncDataById']);
  var idsToKeep = {};
  var saveSyncData = false;
  var getExistingItem = void 0;
  if (__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['workspace/currentWorkspaceIsGit']) {
    var itemsByGitPath = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters.itemsByGitPath);
    getExistingItem = function getExistingItem(existingSyncData) {
      return existingSyncData && itemsByGitPath[existingSyncData.id];
    };
  } else {
    getExistingItem = function getExistingItem(existingSyncData) {
      return existingSyncData && allItemsById[existingSyncData.itemId];
    };
  }

  changes.forEach(function (change) {
    var existingSyncData = syncDataById[change.syncDataId];
    var existingItem = getExistingItem(existingSyncData);

    if (!change.item && existingSyncData) {
      if (syncDataById[change.syncDataId]) {
        delete syncDataById[change.syncDataId];
        saveSyncData = true;
      }
      if (existingItem) {
        __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].commit(existingItem.type + '/deleteItem', existingItem.id);
        delete allItemsById[existingItem.id];
      }
    } else if (change.item && change.item.hash) {
      idsToKeep[change.item.id] = true;

      if ((existingSyncData || {}).hash !== change.syncData.hash) {
        syncDataById[change.syncDataId] = change.syncData;
        saveSyncData = true;
      }
      if ((existingSyncData || {}).hash !== change.item.hash && (existingItem || {}).hash !== change.item.hash && change.item.type !== 'content' && change.item.type !== 'data') {
        __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].commit(change.item.type + '/setItem', change.item);
        allItemsById[change.item.id] = change.item;
      }
    }
  });

  if (saveSyncData) {
    __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].dispatch('data/setSyncDataById', syncDataById);

    __WEBPACK_IMPORTED_MODULE_25__workspaceSvc__["a" /* default */].sanitizeWorkspace(idsToKeep);
  }
};

var createSyncLocation = function createSyncLocation(syncLocation) {
  var currentFile = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['file/current'];
  var fileId = currentFile.id;
  syncLocation.fileId = fileId;

  var content = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].deepCopy(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['content/current']);
  __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].dispatch('queue/enqueue', __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
    var provider, token, updatedSyncLocation, newSyncedContent, newSyncHistoryItem;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            provider = __WEBPACK_IMPORTED_MODULE_18__providers_common_providerRegistry__["a" /* default */].providersById[syncLocation.providerId];
            token = provider.getToken(syncLocation);
            _context.next = 4;
            return provider.uploadContent(token, __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, content, {
              history: [content.hash]
            }), syncLocation);

          case 4:
            updatedSyncLocation = _context.sent;
            _context.next = 7;
            return __WEBPACK_IMPORTED_MODULE_13__localDbSvc__["a" /* default */].loadSyncedContent(fileId);

          case 7:
            newSyncedContent = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].deepCopy(upgradeSyncedContent(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].state.syncedContent.itemsById[fileId + '/syncedContent']));
            newSyncHistoryItem = [];

            newSyncedContent.syncHistory[syncLocation.id] = newSyncHistoryItem;
            newSyncHistoryItem[LAST_SEEN] = content.hash;
            newSyncHistoryItem[LAST_SENT] = content.hash;
            newSyncedContent.historyData[content.hash] = content;

            __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].commit('syncedContent/patchItem', newSyncedContent);
            __WEBPACK_IMPORTED_MODULE_25__workspaceSvc__["a" /* default */].addSyncLocation(updatedSyncLocation);
            __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].dispatch('notification/info', 'A new synchronized location was added to "' + currentFile.name + '".');

          case 16:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  })));
};

var tooLateChecker = function tooLateChecker(timeout) {
  var tooLateAfter = Date.now() + timeout;
  return function (cb) {
    if (tooLateAfter < Date.now()) {
      throw new Error('TOO_LATE');
    }
    return cb();
  };
};

var isTempFile = function isTempFile(fileId) {
  var contentId = fileId + '/content';
  if (__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/syncDataByItemId'][contentId]) {
    return false;
  }
  var file = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].state.file.itemsById[fileId];
  var content = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].state.content.itemsById[contentId];
  if (!file || !content) {
    return false;
  }
  if (file.parentId === 'temp') {
    return true;
  }
  var locations = [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['syncLocation/filteredGroupedByFileId'][fileId] || []), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['publishLocation/filteredGroupedByFileId'][fileId] || []));
  if (locations.length) {
    return false;
  }
  var welcomeFileHashes = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/localSettings'].welcomeFileHashes;

  var hash = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].hash(content.text);
  var hasDiscussions = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys___default()(content.discussions).length;
  return file.name === 'Welcome file' && welcomeFileHashes[hash] && !hasDiscussions;
};

var updateSyncData = function updateSyncData(result) {
  [result.syncData, result.contentSyncData, result.fileSyncData].forEach(function (syncData) {
    if (syncData) {
      var oldSyncData = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/syncDataById'][syncData.id];
      if (__WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].serializeObject(oldSyncData) !== __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].serializeObject(syncData)) {
        __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].dispatch('data/patchSyncDataById', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()({}, syncData.id, syncData));
      }
    }
  });
  return result;
};

var SyncContext = function SyncContext() {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, SyncContext);

  this.restartSkipContents = false;
  this.attempted = {};
};

var syncFile = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee7(fileId) {
    var syncContext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new SyncContext();
    var contentId, getSyncedContent, getSyncHistoryItem, syncLocations;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            contentId = fileId + '/content';

            syncContext.attempted[contentId] = true;

            _context7.next = 4;
            return __WEBPACK_IMPORTED_MODULE_13__localDbSvc__["a" /* default */].loadSyncedContent(fileId);

          case 4:
            _context7.prev = 4;
            _context7.next = 7;
            return __WEBPACK_IMPORTED_MODULE_13__localDbSvc__["a" /* default */].loadItem(contentId);

          case 7:
            _context7.next = 11;
            break;

          case 9:
            _context7.prev = 9;
            _context7.t0 = _context7['catch'](4);

          case 11:
            getSyncedContent = function getSyncedContent() {
              return upgradeSyncedContent(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].state.syncedContent.itemsById[fileId + '/syncedContent']);
            };

            getSyncHistoryItem = function getSyncHistoryItem(syncLocationId) {
              return getSyncedContent().syncHistory[syncLocationId];
            };

            _context7.prev = 13;

            if (!isTempFile(fileId)) {
              _context7.next = 16;
              break;
            }

            return _context7.abrupt('return');

          case 16:
            syncLocations = [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['syncLocation/filteredGroupedByFileId'][fileId] || []));

            if (isWorkspaceSyncPossible()) {
              syncLocations.unshift({ id: 'main', providerId: workspaceProvider.id, fileId: fileId });
            }

            _context7.next = 20;
            return __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].awaitSequence(syncLocations, function () {
              var _ref8 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee6(syncLocation) {
                var provider, token, downloadContent, uploadContent, doSyncLocation;
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        provider = __WEBPACK_IMPORTED_MODULE_18__providers_common_providerRegistry__["a" /* default */].providersById[syncLocation.providerId];

                        if (provider) {
                          _context6.next = 3;
                          break;
                        }

                        return _context6.abrupt('return');

                      case 3:
                        token = provider.getToken(syncLocation);

                        if (token) {
                          _context6.next = 6;
                          break;
                        }

                        return _context6.abrupt('return');

                      case 6:
                        downloadContent = function () {
                          var _ref9 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2() {
                            var oldContentSyncData, oldFileSyncData, _updateSyncData, content;

                            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                              while (1) {
                                switch (_context2.prev = _context2.next) {
                                  case 0:
                                    if (!(syncLocation.id !== 'main')) {
                                      _context2.next = 2;
                                      break;
                                    }

                                    return _context2.abrupt('return', provider.downloadContent(token, syncLocation));

                                  case 2:
                                    oldContentSyncData = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/syncDataByItemId'][contentId];
                                    oldFileSyncData = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/syncDataByItemId'][fileId];

                                    if (!(!oldContentSyncData || !oldFileSyncData)) {
                                      _context2.next = 6;
                                      break;
                                    }

                                    return _context2.abrupt('return', null);

                                  case 6:
                                    _context2.t0 = updateSyncData;
                                    _context2.next = 9;
                                    return provider.downloadWorkspaceContent({
                                      token: token,
                                      contentId: contentId,
                                      contentSyncData: oldContentSyncData,
                                      fileSyncData: oldFileSyncData
                                    });

                                  case 9:
                                    _context2.t1 = _context2.sent;
                                    _updateSyncData = (0, _context2.t0)(_context2.t1);
                                    content = _updateSyncData.content;
                                    return _context2.abrupt('return', content);

                                  case 13:
                                  case 'end':
                                    return _context2.stop();
                                }
                              }
                            }, _callee2, _this);
                          }));

                          return function downloadContent() {
                            return _ref9.apply(this, arguments);
                          };
                        }();

                        uploadContent = function () {
                          var _ref10 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3(content, ifNotTooLate) {
                            var oldContentSyncData, oldFileSyncData;
                            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                              while (1) {
                                switch (_context3.prev = _context3.next) {
                                  case 0:
                                    if (!(syncLocation.id !== 'main')) {
                                      _context3.next = 2;
                                      break;
                                    }

                                    return _context3.abrupt('return', provider.uploadContent(token, content, syncLocation, ifNotTooLate));

                                  case 2:
                                    oldContentSyncData = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/syncDataByItemId'][contentId];

                                    if (!(oldContentSyncData && oldContentSyncData.hash === content.hash)) {
                                      _context3.next = 5;
                                      break;
                                    }

                                    return _context3.abrupt('return', syncLocation);

                                  case 5:
                                    oldFileSyncData = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/syncDataByItemId'][fileId];
                                    _context3.t0 = updateSyncData;
                                    _context3.next = 9;
                                    return provider.uploadWorkspaceContent({
                                      token: token,
                                      content: content,

                                      file: __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].deepCopy(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].state.file.itemsById[fileId]),
                                      contentSyncData: oldContentSyncData,
                                      fileSyncData: oldFileSyncData,
                                      ifNotTooLate: ifNotTooLate
                                    });

                                  case 9:
                                    _context3.t1 = _context3.sent;
                                    (0, _context3.t0)(_context3.t1);
                                    return _context3.abrupt('return', syncLocation);

                                  case 12:
                                  case 'end':
                                    return _context3.stop();
                                }
                              }
                            }, _callee3, _this);
                          }));

                          return function uploadContent(_x4, _x5) {
                            return _ref10.apply(this, arguments);
                          };
                        }();

                        doSyncLocation = function () {
                          var _ref11 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4() {
                            var serverContent, syncedContent, syncHistoryItem, mergedContent, clientContent, lastMergedContent, mergedContentHistory, skipUpload, idx, newSyncedContent, newSyncHistoryItem, item, syncLocationToStore;
                            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                              while (1) {
                                switch (_context4.prev = _context4.next) {
                                  case 0:
                                    _context4.next = 2;
                                    return downloadContent(token, syncLocation);

                                  case 2:
                                    serverContent = _context4.sent;
                                    syncedContent = getSyncedContent();
                                    syncHistoryItem = getSyncHistoryItem(syncLocation.id);
                                    mergedContent = void 0;
                                    clientContent = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].deepCopy(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].state.content.itemsById[contentId]);

                                    if (!clientContent) {
                                      mergedContent = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].deepCopy(serverContent || null);
                                    } else if (!serverContent || serverContent.hash === clientContent.hash || syncedContent.historyData[serverContent.hash]) {
                                      mergedContent = clientContent;
                                    } else {
                                      lastMergedContent = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].someResult(serverContent.history, function (hash) {
                                        return syncedContent.historyData[hash];
                                      });

                                      if (!lastMergedContent && syncHistoryItem) {
                                        lastMergedContent = syncedContent.historyData[syncHistoryItem[LAST_MERGED]];
                                      }
                                      mergedContent = __WEBPACK_IMPORTED_MODULE_16__diffUtils__["a" /* default */].mergeContent(serverContent, clientContent, lastMergedContent);
                                    }

                                    if (mergedContent) {
                                      _context4.next = 10;
                                      break;
                                    }

                                    return _context4.abrupt('return');

                                  case 10:
                                    __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].commit('content/setItem', {
                                      id: contentId,
                                      text: __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].sanitizeText(mergedContent.text),
                                      properties: __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].sanitizeText(mergedContent.properties),
                                      discussions: mergedContent.discussions,
                                      comments: mergedContent.comments
                                    });

                                    mergedContent = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].deepCopy(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].state.content.itemsById[contentId]);

                                    mergedContentHistory = serverContent ? serverContent.history.slice() : [];
                                    skipUpload = true;

                                    if (mergedContentHistory[0] !== mergedContent.hash) {
                                      mergedContentHistory.unshift(mergedContent.hash);

                                      skipUpload = false;
                                    }
                                    if (syncHistoryItem && syncHistoryItem[LAST_SENT] != null && syncHistoryItem[LAST_SENT] !== mergedContent.hash) {
                                      idx = mergedContentHistory.lastIndexOf(syncHistoryItem[LAST_SENT]);

                                      if (idx !== -1) {
                                        mergedContentHistory.splice(idx, 1);
                                      }
                                    }

                                    newSyncedContent = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].deepCopy(syncedContent);
                                    newSyncHistoryItem = newSyncedContent.syncHistory[syncLocation.id] || [];

                                    newSyncedContent.syncHistory[syncLocation.id] = newSyncHistoryItem;
                                    if (serverContent && (serverContent.hash === newSyncHistoryItem[LAST_SEEN] || serverContent.history.includes(newSyncHistoryItem[LAST_SEEN]))) {
                                      newSyncHistoryItem[LAST_MERGED] = newSyncHistoryItem[LAST_SEEN];
                                    }
                                    newSyncHistoryItem[LAST_MERGED] = newSyncHistoryItem[LAST_MERGED] || null;
                                    newSyncHistoryItem[LAST_SEEN] = mergedContent.hash;
                                    newSyncHistoryItem[LAST_SENT] = skipUpload ? null : mergedContent.hash;
                                    newSyncedContent.historyData[mergedContent.hash] = mergedContent;

                                    cleanSyncedContent(newSyncedContent);

                                    __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].commit('syncedContent/patchItem', newSyncedContent);

                                    if (!skipUpload) {
                                      _context4.next = 28;
                                      break;
                                    }

                                    return _context4.abrupt('return');

                                  case 28:
                                    if (provider === workspaceProvider && !__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/syncDataByItemId'][fileId]) {
                                      syncContext.restartSkipContents = true;
                                    }

                                    item = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, mergedContent, {
                                      history: mergedContentHistory.slice(0, maxContentHistory)
                                    });
                                    _context4.next = 32;
                                    return uploadContent(item, tooLateChecker(restartContentSyncAfter));

                                  case 32:
                                    syncLocationToStore = _context4.sent;

                                    if (__WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].serializeObject(syncLocation) !== __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].serializeObject(syncLocationToStore)) {
                                      __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].commit('syncLocation/patchItem', syncLocationToStore);
                                      __WEBPACK_IMPORTED_MODULE_25__workspaceSvc__["a" /* default */].ensureUniqueLocations();
                                    }

                                  case 34:
                                  case 'end':
                                    return _context4.stop();
                                }
                              }
                            }, _callee4, _this);
                          }));

                          return function doSyncLocation() {
                            return _ref11.apply(this, arguments);
                          };
                        }();

                        _context6.next = 11;
                        return __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].dispatch('queue/doWithLocation', {
                          location: syncLocation,
                          action: function () {
                            var _ref12 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee5() {
                              return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                                while (1) {
                                  switch (_context5.prev = _context5.next) {
                                    case 0:
                                      _context5.prev = 0;
                                      _context5.next = 3;
                                      return doSyncLocation();

                                    case 3:
                                      _context5.next = 11;
                                      break;

                                    case 5:
                                      _context5.prev = 5;
                                      _context5.t0 = _context5['catch'](0);

                                      if (!(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].state.offline || _context5.t0 && _context5.t0.message === 'TOO_LATE')) {
                                        _context5.next = 9;
                                        break;
                                      }

                                      throw _context5.t0;

                                    case 9:
                                      console.error(_context5.t0);
                                      __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].dispatch('notification/error', _context5.t0);

                                    case 11:
                                    case 'end':
                                      return _context5.stop();
                                  }
                                }
                              }, _callee5, _this, [[0, 5]]);
                            }));

                            return function action() {
                              return _ref12.apply(this, arguments);
                            };
                          }()
                        });

                      case 11:
                      case 'end':
                        return _context6.stop();
                    }
                  }
                }, _callee6, _this);
              }));

              return function (_x3) {
                return _ref8.apply(this, arguments);
              };
            }());

          case 20:
            _context7.next = 30;
            break;

          case 22:
            _context7.prev = 22;
            _context7.t1 = _context7['catch'](13);

            if (!(_context7.t1 && _context7.t1.message === 'TOO_LATE')) {
              _context7.next = 29;
              break;
            }

            _context7.next = 27;
            return syncFile(fileId, syncContext);

          case 27:
            _context7.next = 30;
            break;

          case 29:
            throw _context7.t1;

          case 30:
            _context7.prev = 30;
            _context7.next = 33;
            return __WEBPACK_IMPORTED_MODULE_13__localDbSvc__["a" /* default */].unloadContents();

          case 33:
            return _context7.finish(30);

          case 34:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, _this, [[4, 9], [13, 22, 30, 34]]);
  }));

  return function syncFile(_x) {
    return _ref7.apply(this, arguments);
  };
}();

var syncDataItem = function () {
  var _ref13 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee8(dataId) {
    var getItem, oldItem, oldSyncData, token, _updateSyncData2, item, serverItem, dataSyncData, clientItem, mergedItem;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            getItem = function getItem() {
              return __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].state.data.itemsById[dataId] || __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].state.data.lsItemsById[dataId];
            };

            oldItem = getItem();
            oldSyncData = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/syncDataByItemId'][dataId];

            if (!(oldSyncData && oldItem && oldItem.hash === oldSyncData.hash)) {
              _context8.next = 5;
              break;
            }

            return _context8.abrupt('return');

          case 5:
            token = workspaceProvider.getToken();
            _context8.t0 = updateSyncData;
            _context8.next = 9;
            return workspaceProvider.downloadWorkspaceData({
              token: token,
              syncData: oldSyncData
            });

          case 9:
            _context8.t1 = _context8.sent;
            _updateSyncData2 = (0, _context8.t0)(_context8.t1);
            item = _updateSyncData2.item;
            serverItem = item;
            dataSyncData = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/dataSyncDataById'][dataId];
            clientItem = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].deepCopy(getItem());

            mergedItem = function () {
              if (!clientItem) {
                return serverItem;
              }
              if (!serverItem) {
                return clientItem;
              }
              if (!dataSyncData) {
                return serverItem;
              }
              if (dataSyncData.hash !== serverItem.hash) {
                if (dataSyncData.hash !== clientItem.hash && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(clientItem.data) === 'object') {
                  return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, clientItem, {
                    data: __WEBPACK_IMPORTED_MODULE_16__diffUtils__["a" /* default */].mergeObjects(serverItem.data, clientItem.data)
                  });
                }
                return serverItem;
              }
              return clientItem;
            }();

            if (mergedItem) {
              _context8.next = 18;
              break;
            }

            return _context8.abrupt('return');

          case 18:
            if (!(clientItem && dataId === 'workspaces')) {
              _context8.next = 21;
              break;
            }

            _context8.next = 21;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys___default()(clientItem.data).filter(function (id) {
              return !mergedItem.data[id];
            }).map(function (id) {
              return __WEBPACK_IMPORTED_MODULE_25__workspaceSvc__["a" /* default */].removeWorkspace(id);
            }));

          case 21:
            __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].commit('data/setItem', __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({
              id: dataId
            }, mergedItem));

            mergedItem = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].deepCopy(getItem());

            if (!(!serverItem || serverItem.hash !== mergedItem.hash)) {
              _context8.next = 29;
              break;
            }

            _context8.t2 = updateSyncData;
            _context8.next = 27;
            return workspaceProvider.uploadWorkspaceData({
              token: token,
              item: mergedItem,
              syncData: __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/syncDataByItemId'][dataId],
              ifNotTooLate: tooLateChecker(restartContentSyncAfter)
            });

          case 27:
            _context8.t3 = _context8.sent;
            (0, _context8.t2)(_context8.t3);

          case 29:
            __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].dispatch('data/patchDataSyncDataById', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()({}, dataId, __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].deepCopy(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/syncDataByItemId'][dataId])));

          case 30:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, _this);
  }));

  return function syncDataItem(_x6) {
    return _ref13.apply(this, arguments);
  };
}();

var syncWorkspace = function () {
  var _ref14 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee12() {
    var skipContents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var workspace, syncContext, syncToken, localSettings, changes, ifNotTooLate, currentFileId;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.prev = 0;
            workspace = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['workspace/currentWorkspace'];
            syncContext = new SyncContext();
            syncToken = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['workspace/syncToken'];
            localSettings = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/localSettings'];

            if (localSettings.syncSub) {
              _context12.next = 9;
              break;
            }

            __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].dispatch('data/patchLocalSettings', {
              syncSub: syncToken.sub
            });
            _context12.next = 11;
            break;

          case 9:
            if (!(localSettings.syncSub !== syncToken.sub)) {
              _context12.next = 11;
              break;
            }

            throw new Error('Synchronization failed due to token inconsistency.');

          case 11:
            _context12.next = 13;
            return workspaceProvider.getChanges();

          case 13:
            changes = _context12.sent;

            applyChanges(workspaceProvider.prepareChanges(changes));
            workspaceProvider.onChangesApplied();

            ifNotTooLate = tooLateChecker(restartSyncAfter);
            _context12.next = 19;
            return __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].awaitSome(function () {
              return ifNotTooLate(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee9() {
                var storeItemMap, syncDataByItemId, isGit, _ref16, _ref17, changedItem, syncDataToUpdate;

                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        storeItemMap = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].state.file.itemsById, __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].state.folder.itemsById, __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].state.syncLocation.itemsById, __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].state.publishLocation.itemsById);
                        syncDataByItemId = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/syncDataByItemId'];
                        isGit = !!__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['workspace/currentWorkspaceIsGit'];
                        _ref16 = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].someResult(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_entries___default()(storeItemMap), function (_ref18) {
                          var _ref19 = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray___default()(_ref18, 2),
                              id = _ref19[0],
                              item = _ref19[1];

                          var syncData = syncDataByItemId[id];
                          if (syncData && syncData.hash === item.hash || !isGit && storeItemMap[item.parentId] && !syncDataByItemId[item.parentId] || isGit && item.type === 'folder' || item.type === 'file' && !syncDataByItemId[id + '/content']) {
                            return null;
                          }
                          return [item, syncData];
                        }) || [], _ref17 = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray___default()(_ref16, 2), changedItem = _ref17[0], syncDataToUpdate = _ref17[1];

                        if (changedItem) {
                          _context9.next = 6;
                          break;
                        }

                        return _context9.abrupt('return', false);

                      case 6:
                        _context9.t0 = updateSyncData;
                        _context9.next = 9;
                        return workspaceProvider.saveWorkspaceItem({
                          item: __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].deepCopy(changedItem),
                          syncData: __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].deepCopy(syncDataToUpdate),
                          ifNotTooLate: ifNotTooLate
                        });

                      case 9:
                        _context9.t1 = _context9.sent;
                        (0, _context9.t0)(_context9.t1);
                        return _context9.abrupt('return', true);

                      case 12:
                      case 'end':
                        return _context9.stop();
                    }
                  }
                }, _callee9, _this);
              })));
            });

          case 19:
            _context12.next = 21;
            return __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].awaitSome(function () {
              return ifNotTooLate(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee10() {
                var getItem, getFileItem, itemsByGitPath, allItemsById, syncDataById, syncDataToRemove, syncDataByIdCopy;
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                  while (1) {
                    switch (_context10.prev = _context10.next) {
                      case 0:
                        getItem = void 0;
                        getFileItem = void 0;

                        if (__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['workspace/currentWorkspaceIsGit']) {
                          itemsByGitPath = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters.itemsByGitPath;

                          getItem = function getItem(syncData) {
                            return itemsByGitPath[syncData.id];
                          };
                          getFileItem = function getFileItem(syncData) {
                            return itemsByGitPath[syncData.id.slice(1)];
                          };
                        } else {
                          allItemsById = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters.allItemsById;

                          getItem = function getItem(syncData) {
                            return allItemsById[syncData.itemId];
                          };
                          getFileItem = function getFileItem(syncData) {
                            return allItemsById[syncData.itemId.split('/')[0]];
                          };
                        }

                        syncDataById = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/syncDataById'];
                        syncDataToRemove = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].deepCopy(__WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].someResult(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(syncDataById), function (syncData) {
                          if (getItem(syncData) || syncData.type === 'data' || syncData.type === 'content' && getFileItem(syncData)) {
                            return null;
                          }
                          return syncData;
                        }));

                        if (syncDataToRemove) {
                          _context10.next = 7;
                          break;
                        }

                        return _context10.abrupt('return', false);

                      case 7:
                        _context10.next = 9;
                        return workspaceProvider.removeWorkspaceItem({
                          syncData: syncDataToRemove,
                          ifNotTooLate: ifNotTooLate
                        });

                      case 9:
                        syncDataByIdCopy = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/syncDataById']);

                        delete syncDataByIdCopy[syncDataToRemove.id];
                        __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].dispatch('data/setSyncDataById', syncDataByIdCopy);
                        return _context10.abrupt('return', true);

                      case 13:
                      case 'end':
                        return _context10.stop();
                    }
                  }
                }, _callee10, _this);
              })));
            });

          case 21:
            if (!(workspace.id === 'main')) {
              _context12.next = 28;
              break;
            }

            _context12.next = 24;
            return syncDataItem('settings');

          case 24:
            _context12.next = 26;
            return syncDataItem('workspaces');

          case 26:
            _context12.next = 28;
            return syncDataItem('badgeCreations');

          case 28:
            _context12.next = 30;
            return syncDataItem('templates');

          case 30:
            if (skipContents) {
              _context12.next = 37;
              break;
            }

            currentFileId = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['file/current'].id;

            if (!currentFileId) {
              _context12.next = 35;
              break;
            }

            _context12.next = 35;
            return syncFile(currentFileId, syncContext);

          case 35:
            _context12.next = 37;
            return __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].awaitSome(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee11() {
              var getSyncData, gitPathsByItemId, syncDataById, syncDataByItemId, ids, contentMap, fileIdToSync;
              return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
                while (1) {
                  switch (_context11.prev = _context11.next) {
                    case 0:
                      getSyncData = void 0;

                      if (__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['workspace/currentWorkspaceIsGit']) {
                        gitPathsByItemId = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters.gitPathsByItemId;
                        syncDataById = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/syncDataById'];

                        getSyncData = function getSyncData(contentId) {
                          return syncDataById[gitPathsByItemId[contentId]];
                        };
                      } else {
                        syncDataByItemId = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/syncDataByItemId'];

                        getSyncData = function getSyncData(contentId) {
                          return syncDataByItemId[contentId];
                        };
                      }

                      ids = [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_13__localDbSvc__["a" /* default */].hashMap.content).map(function (contentId) {
                        return [contentId.split('/')[0], contentId];
                      })), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['file/items'].map(function (file) {
                        return [file.id, file.id + '/content'];
                      })));
                      contentMap = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].state.content.itemsById;
                      fileIdToSync = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].someResult(ids, function (_ref22) {
                        var _ref23 = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray___default()(_ref22, 2),
                            fileId = _ref23[0],
                            contentId = _ref23[1];

                        var loadedContent = contentMap[contentId];
                        var hash = loadedContent ? loadedContent.hash : __WEBPACK_IMPORTED_MODULE_13__localDbSvc__["a" /* default */].hashMap.content[contentId];
                        var syncData = getSyncData(contentId);
                        if (!syncContext.attempted[contentId] && (!syncData || syncData.hash !== hash)) {
                          return fileId;
                        }
                        return null;
                      });

                      if (fileIdToSync) {
                        _context11.next = 7;
                        break;
                      }

                      return _context11.abrupt('return', false);

                    case 7:
                      _context11.next = 9;
                      return syncFile(fileIdToSync, syncContext);

                    case 9:
                      return _context11.abrupt('return', true);

                    case 10:
                    case 'end':
                      return _context11.stop();
                  }
                }
              }, _callee11, _this);
            })));

          case 37:
            if (!syncContext.restartSkipContents) {
              _context12.next = 40;
              break;
            }

            _context12.next = 40;
            return syncWorkspace(true);

          case 40:

            if (workspace.id === 'main') {
              __WEBPACK_IMPORTED_MODULE_27__badgeSvc__["a" /* default */].addBadge('syncMainWorkspace');
            }
            _context12.next = 51;
            break;

          case 43:
            _context12.prev = 43;
            _context12.t0 = _context12['catch'](0);

            if (!(_context12.t0 && _context12.t0.message === 'TOO_LATE')) {
              _context12.next = 50;
              break;
            }

            _context12.next = 48;
            return syncWorkspace();

          case 48:
            _context12.next = 51;
            break;

          case 50:
            throw _context12.t0;

          case 51:
          case 'end':
            return _context12.stop();
        }
      }
    }, _callee12, _this, [[0, 43]]);
  }));

  return function syncWorkspace() {
    return _ref14.apply(this, arguments);
  };
}();

var requestSync = function requestSync() {
  var addTriggerSyncBadge = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].state.light) {
    return;
  }

  __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].dispatch('queue/enqueueSyncRequest', __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee14() {
    var intervalId, attempt;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            intervalId = void 0;

            attempt = function () {
              var _ref25 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee13() {
                var fileHashesToClean, syncDataByItemId;
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
                  while (1) {
                    switch (_context13.prev = _context13.next) {
                      case 0:
                        if (!(__WEBPACK_IMPORTED_MODULE_17__networkSvc__["a" /* default */].isUserActive() && isSyncWindow())) {
                          _context13.next = 22;
                          break;
                        }

                        clearInterval(intervalId);

                        if (isSyncPossible()) {
                          _context13.next = 4;
                          break;
                        }

                        throw new Error('Sync not possible.');

                      case 4:
                        fileHashesToClean = {};

                        if (getLastStoredSyncActivity() + __WEBPACK_IMPORTED_MODULE_26__data_constants__["a" /* default */].cleanTrashAfter < Date.now()) {
                          syncDataByItemId = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/syncDataByItemId'];

                          __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['file/items'].forEach(function (file) {
                            var syncData = syncDataByItemId[file.id];
                            if (syncData && file.parentId === 'trash' && file.hash === syncData.hash) {
                              fileHashesToClean[file.id] = file.hash;
                            }
                          });
                        }

                        intervalId = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].setInterval(function () {
                          return setLastSyncActivity();
                        }, 1000);
                        setLastSyncActivity();

                        _context13.prev = 8;

                        if (!isWorkspaceSyncPossible()) {
                          _context13.next = 14;
                          break;
                        }

                        _context13.next = 12;
                        return syncWorkspace();

                      case 12:
                        _context13.next = 17;
                        break;

                      case 14:
                        if (!hasCurrentFileSyncLocations()) {
                          _context13.next = 17;
                          break;
                        }

                        _context13.next = 17;
                        return syncFile(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['file/current'].id);

                      case 17:
                        __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_entries___default()(fileHashesToClean).forEach(function (_ref26) {
                          var _ref27 = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray___default()(_ref26, 2),
                              fileId = _ref27[0],
                              fileHash = _ref27[1];

                          var file = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].state.file.itemsById[fileId];
                          if (file && file.hash === fileHash) {
                            __WEBPACK_IMPORTED_MODULE_25__workspaceSvc__["a" /* default */].deleteFile(fileId);
                          }
                        });

                        if (addTriggerSyncBadge) {
                          __WEBPACK_IMPORTED_MODULE_27__badgeSvc__["a" /* default */].addBadge('triggerSync');
                        }

                      case 19:
                        _context13.prev = 19;

                        clearInterval(intervalId);
                        return _context13.finish(19);

                      case 22:
                      case 'end':
                        return _context13.stop();
                    }
                  }
                }, _callee13, _this, [[8,, 19, 22]]);
              }));

              return function attempt() {
                return _ref25.apply(this, arguments);
              };
            }();

            intervalId = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].setInterval(function () {
              return attempt();
            }, 1000);
            return _context14.abrupt('return', attempt());

          case 4:
          case 'end':
            return _context14.stop();
        }
      }
    }, _callee14, _this);
  })));
};

/* harmony default export */ __webpack_exports__["a"] = ({
  init: function init() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee15() {
      var workspace, paymentSuccess, sponsorToken, currentDate, newSyncLocation;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_13__localDbSvc__["a" /* default */].syncLocalStorage();

              actionProvider = __WEBPACK_IMPORTED_MODULE_18__providers_common_providerRegistry__["a" /* default */].providersById[__WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].queryParams.providerId];

              if (!(actionProvider && actionProvider.initAction)) {
                _context15.next = 5;
                break;
              }

              _context15.next = 5;
              return actionProvider.initAction();

            case 5:
              workspaceProvider = __WEBPACK_IMPORTED_MODULE_18__providers_common_providerRegistry__["a" /* default */].providersById[__WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].queryParams.providerId];
              if (!workspaceProvider || !workspaceProvider.initWorkspace) {
                workspaceProvider = __WEBPACK_IMPORTED_MODULE_19__providers_googleDriveAppDataProvider__["a" /* default */];
              }
              _context15.next = 9;
              return workspaceProvider.initWorkspace();

            case 9:
              workspace = _context15.sent;
              paymentSuccess = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].queryParams.paymentSuccess;

              __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].setQueryParams(workspaceProvider.getWorkspaceParams(workspace));

              __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].dispatch('workspace/setCurrentWorkspaceId', workspace.id);
              _context15.next = 15;
              return __WEBPACK_IMPORTED_MODULE_13__localDbSvc__["a" /* default */].init();

            case 15:
              if (paymentSuccess) {
                __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].dispatch('modal/open', 'paymentSuccess').catch(function () {});
                sponsorToken = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['workspace/sponsorToken'];
                currentDate = Date.now();

                if (sponsorToken && sponsorToken.expiresOn > currentDate - checkSponsorshipAfter) {
                  __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].dispatch('data/addGoogleToken', __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, sponsorToken, {
                    expiresOn: currentDate - checkSponsorshipAfter
                  }));
                }
              }

              actionProvider = __WEBPACK_IMPORTED_MODULE_18__providers_common_providerRegistry__["a" /* default */].providersById[__WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].queryParams.providerId] || actionProvider;

              if (!(actionProvider && actionProvider.performAction)) {
                _context15.next = 22;
                break;
              }

              _context15.next = 20;
              return actionProvider.performAction();

            case 20:
              newSyncLocation = _context15.sent;

              if (newSyncLocation) {
                _this2.createSyncLocation(newSyncLocation);
              }

            case 22:
              _context15.next = 24;
              return __WEBPACK_IMPORTED_MODULE_24__tempFileSvc__["a" /* default */].init();

            case 24:

              if (!__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].state.light) {
                __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].setInterval(function () {
                  if (isSyncPossible() && __WEBPACK_IMPORTED_MODULE_17__networkSvc__["a" /* default */].isUserActive() && isSyncWindow() && isAutoSyncReady()) {
                    requestSync();
                  }
                }, 1000);

                __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].setInterval(function () {
                  if (__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].state.queue.isEmpty) {
                    __WEBPACK_IMPORTED_MODULE_13__localDbSvc__["a" /* default */].unloadContents();
                  }
                }, 5000);
              }

            case 25:
            case 'end':
              return _context15.stop();
          }
        }
      }, _callee15, _this2);
    }))();
  },

  isSyncPossible: isSyncPossible,
  requestSync: requestSync,
  createSyncLocation: createSyncLocation
});

/***/ }),
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_diff_match_patch__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_diff_match_patch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_diff_match_patch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prismjs__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prismjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_markdown_it__ = __webpack_require__(2146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_markdown_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_markdown_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__markdownGrammarSvc__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__extensionSvc__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(4);













var htmlSectionMarker = '\uF111\uF222\uF333\uF444';
var diffMatchPatch = new __WEBPACK_IMPORTED_MODULE_6_diff_match_patch___default.a();

var languageAliases = {
  js: 'javascript',
  json: 'javascript',
  html: 'markup',
  svg: 'markup',
  xml: 'markup',
  py: 'python',
  rb: 'ruby',
  yml: 'yaml',
  ps1: 'powershell',
  psm1: 'powershell'
};
__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default()(languageAliases).forEach(function (_ref) {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
      alias = _ref2[0],
      language = _ref2[1];

  __WEBPACK_IMPORTED_MODULE_7_prismjs___default.a.languages[alias] = __WEBPACK_IMPORTED_MODULE_7_prismjs___default.a.languages[language];
});

var insideFences = {};
__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_7_prismjs___default.a.languages).forEach(function (_ref3) {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
      name = _ref4[0],
      language = _ref4[1];

  if (__WEBPACK_IMPORTED_MODULE_7_prismjs___default.a.util.type(language) === 'Object') {
    insideFences['language-' + name] = {
      pattern: new RegExp('(```|~~~)' + name + '\\W[\\s\\S]*'),
      inside: {
        'cl cl-pre': /(```|~~~).*/,
        rest: language
      }
    };
  }
});

var noSpellcheckTokens = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(null);
['code', 'pre', 'pre gfm', 'math block', 'math inline', 'math expr block', 'math expr inline', 'latex block'].forEach(function (key) {
  noSpellcheckTokens[key] = true;
});
__WEBPACK_IMPORTED_MODULE_7_prismjs___default.a.hooks.add('wrap', function (env) {
  if (noSpellcheckTokens[env.type]) {
    env.attributes.spellcheck = 'false';
  }
});

function createFlagMap(arr) {
  return arr.reduce(function (map, type) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, map, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, type, true));
  }, {});
}
var startSectionBlockTypeMap = createFlagMap(['paragraph_open', 'blockquote_open', 'heading_open', 'code', 'fence', 'table_open', 'html_block', 'bullet_list_open', 'ordered_list_open', 'hr', 'dl_open']);
var listBlockTypeMap = createFlagMap(['bullet_list_open', 'ordered_list_open']);
var blockquoteBlockTypeMap = createFlagMap(['blockquote_open']);
var tableBlockTypeMap = createFlagMap(['table_open']);
var deflistBlockTypeMap = createFlagMap(['dl_open']);

function hashArray(arr, valueHash, valueArray) {
  var hash = [];
  arr.forEach(function (str) {
    var strHash = valueHash[str];
    if (strHash === undefined) {
      strHash = valueArray.length;
      valueArray.push(str);
      valueHash[str] = strHash;
    }
    hash.push(strHash);
  });
  return String.fromCharCode.apply(null, hash);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  defaultOptions: null,
  defaultConverter: null,
  defaultPrismGrammars: null,

  init: function init() {
    var defaultProperties = { extensions: __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].computedPresets.default };

    this.defaultOptions = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_10__extensionSvc__["a" /* default */].getOptions(defaultProperties), {
      insideFences: insideFences
    });

    this.defaultConverter = this.createConverter(this.defaultOptions);
    this.defaultPrismGrammars = __WEBPACK_IMPORTED_MODULE_9__markdownGrammarSvc__["a" /* default */].makeGrammars(this.defaultOptions);
  },
  createConverter: function createConverter(options) {
    var converter = new __WEBPACK_IMPORTED_MODULE_8_markdown_it___default.a('zero');
    converter.core.ruler.enable([], true);
    converter.block.ruler.enable([], true);
    converter.inline.ruler.enable([], true);
    __WEBPACK_IMPORTED_MODULE_10__extensionSvc__["a" /* default */].initConverter(converter, options);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(startSectionBlockTypeMap).forEach(function (type) {
      var rule = converter.renderer.rules[type] || converter.renderer.renderToken;
      converter.renderer.rules[type] = function (tokens, idx, opts, env, self) {
        if (tokens[idx].sectionDelimiter) {
          return htmlSectionMarker + rule.call(converter.renderer, tokens, idx, opts, env, self);
        }
        return rule.call(converter.renderer, tokens, idx, opts, env, self);
      };
    });
    return converter;
  },
  parseSections: function parseSections(converter, text) {
    var markdownState = new converter.core.State(text, converter, {});
    var markdownCoreRules = converter.core.ruler.getRules('');
    markdownCoreRules[0](markdownState);
    markdownCoreRules[1](markdownState);
    var lines = text.split('\n');
    if (!lines[lines.length - 1]) {
      lines.pop();
    }
    var parsingCtx = {
      text: text,
      sections: [],
      converter: converter,
      markdownState: markdownState,
      markdownCoreRules: markdownCoreRules
    };
    var data = 'main';
    var i = 0;

    function addSection(maxLine) {
      var section = {
        text: '',
        data: data
      };
      for (; i < maxLine; i += 1) {
        section.text += lines[i] + '\n';
      }
      if (section) {
        parsingCtx.sections.push(section);
      }
    }
    markdownState.tokens.forEach(function (token, index) {
      if (token.level === 0 && startSectionBlockTypeMap[token.type] === true) {
        if (index > 0) {
          token.sectionDelimiter = true;
          addSection(token.map[0]);
        }
        if (listBlockTypeMap[token.type] === true) {
          data = 'list';
        } else if (blockquoteBlockTypeMap[token.type] === true) {
          data = 'blockquote';
        } else if (tableBlockTypeMap[token.type] === true) {
          data = 'table';
        } else if (deflistBlockTypeMap[token.type] === true) {
          data = 'deflist';
        } else {
          data = 'main';
        }
      }
    });
    addSection(lines.length);
    return parsingCtx;
  },
  convert: function convert(parsingCtx, previousConversionCtx) {
    if (!parsingCtx.markdownState.isConverted) {
      parsingCtx.markdownCoreRules.slice(2).forEach(function (rule) {
        return rule(parsingCtx.markdownState);
      });
      parsingCtx.markdownState.isConverted = true;
    }
    var tokens = parsingCtx.markdownState.tokens;

    var html = parsingCtx.converter.renderer.render(tokens, parsingCtx.converter.options, parsingCtx.markdownState.env);
    var htmlSectionList = html.split(htmlSectionMarker);
    if (htmlSectionList[0] === '') {
      htmlSectionList.shift();
    }
    var valueHash = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(null);
    var valueArray = [];
    var newSectionHash = hashArray(htmlSectionList, valueHash, valueArray);
    var htmlSectionDiff = void 0;
    if (previousConversionCtx) {
      var oldSectionHash = hashArray(previousConversionCtx.htmlSectionList, valueHash, valueArray);
      htmlSectionDiff = diffMatchPatch.diff_main(oldSectionHash, newSectionHash, false);
    } else {
      htmlSectionDiff = [[1, newSectionHash]];
    }
    return {
      text: parsingCtx.text,
      sectionList: parsingCtx.sectionList,
      htmlSectionList: htmlSectionList,
      htmlSectionDiff: htmlSectionDiff
    };
  },
  highlight: function highlight(markdown) {
    var converter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.defaultConverter;
    var grammars = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.defaultPrismGrammars;

    var parsingCtx = this.parseSections(converter, markdown);
    return parsingCtx.sections.map(function (section) {
      return __WEBPACK_IMPORTED_MODULE_7_prismjs___default.a.highlight(section.text, grammars[section.data]);
    }).join('');
  }
});

/***/ }),
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_create__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_createClass__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__data_welcomeFile_md__ = __webpack_require__(2208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__data_welcomeFile_md___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__data_welcomeFile_md__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__workspaceSvc__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__data_constants__ = __webpack_require__(94);



















var deleteMarkerMaxAge = 1000;
var dbVersion = 1;
var dbStoreName = 'objects';
var silent = __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].queryParams.silent;

var resetApp = localStorage.getItem('resetStackEdit');
if (resetApp) {
  localStorage.removeItem('resetStackEdit');
}

var Connection = function () {
  function Connection() {
    var _this = this;

    var workspaceId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['workspace/currentWorkspace'].id;

    __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_classCallCheck___default()(this, Connection);

    this.getTxCbs = [];

    this.dbName = __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].getDbName(workspaceId);

    var request = indexedDB.open(this.dbName, dbVersion);

    request.onerror = function () {
      throw new Error("Can't connect to IndexedDB.");
    };

    request.onsuccess = function (event) {
      _this.db = event.target.result;
      _this.db.onversionchange = function () {
        return window.location.reload();
      };

      _this.getTxCbs.forEach(function (_ref) {
        var onTx = _ref.onTx,
            onError = _ref.onError;
        return _this.createTx(onTx, onError);
      });
      _this.getTxCbs = null;
    };

    request.onupgradeneeded = function (event) {
      var eventDb = event.target.result;
      var oldVersion = event.oldVersion || 0;

      switch (oldVersion) {
        case 0:
          {
            var dbStore = eventDb.createObjectStore(dbStoreName, {
              keyPath: 'id'
            });
            dbStore.createIndex('tx', 'tx', {
              unique: false
            });
          }
        default:
      }
    };
  }

  __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_createClass___default()(Connection, [{
    key: 'createTx',
    value: function createTx(onTx, onError) {
      if (!this.db) {
        return this.getTxCbs.push({ onTx: onTx, onError: onError });
      }

      var tx = this.db.transaction(this.db.objectStoreNames, 'readwrite');
      tx.onerror = onError;

      return onTx(tx);
    }
  }]);

  return Connection;
}();

var contentTypes = {
  content: true,
  contentState: true,
  syncedContent: true
};

var hashMap = {};
__WEBPACK_IMPORTED_MODULE_17__data_constants__["a" /* default */].types.forEach(function (type) {
  hashMap[type] = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_create___default()(null);
});
var lsHashMap = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_create___default()(null);

var localDbSvc = {
  lastTx: 0,
  hashMap: hashMap,
  connection: null,

  syncLocalStorage: function syncLocalStorage() {
    __WEBPACK_IMPORTED_MODULE_17__data_constants__["a" /* default */].localStorageDataIds.forEach(function (id) {
      var key = 'data/' + id;

      if (id !== 'layoutSettings' || !lsHashMap[id]) {
        try {
          var storedItem = JSON.parse(localStorage.getItem(key));
          if (storedItem.hash && lsHashMap[id] !== storedItem.hash) {
            __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].commit('data/setItem', storedItem);
            lsHashMap[id] = storedItem.hash;
          }
        } catch (e) {}
      }

      var item = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].state.data.lsItemsById[id];
      if (item && item.hash !== lsHashMap[id]) {
        localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()(item));
        lsHashMap[id] = item.hash;
      }
    });
  },
  sync: function sync() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this2.connection.createTx(function (tx) {
                  var lastTx = _this2.lastTx;

                  _this2.readAll(tx, function (storeItemMap) {
                    if (lastTx !== _this2.lastTx) {
                      __WEBPACK_IMPORTED_MODULE_16__workspaceSvc__["a" /* default */].sanitizeWorkspace();
                    }

                    _this2.writeAll(storeItemMap, tx);

                    _this2.syncLocalStorage();

                    resolve();
                  });
                }, function () {
                  return reject(new Error('Local DB access error.'));
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },
  readAll: function readAll(tx, cb) {
    var _this3 = this;

    var lastTx = this.lastTx;

    var dbStore = tx.objectStore(dbStoreName);
    var index = dbStore.index('tx');
    var range = IDBKeyRange.lowerBound(this.lastTx, true);
    var changes = [];
    index.openCursor(range).onsuccess = function (event) {
      var cursor = event.target.result;
      if (cursor) {
        var item = cursor.value;
        if (item.tx > lastTx) {
          lastTx = item.tx;
          if (_this3.lastTx && item.tx - _this3.lastTx > deleteMarkerMaxAge) {
            window.location.reload();
            return;
          }
        }

        changes.push(item);
        cursor.continue();
        return;
      }

      var storeItemMap = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters.allItemsById);
      changes.forEach(function (item) {
        _this3.readDbItem(item, storeItemMap);

        if (!item.hash && lastTx - item.tx > deleteMarkerMaxAge) {
          dbStore.delete(item.id);
        }
      });

      _this3.lastTx = lastTx;
      cb(storeItemMap);
    };
  },
  writeAll: function writeAll(storeItemMap, tx) {
    var _this4 = this;

    if (silent) {
      return;
    }
    var dbStore = tx.objectStore(dbStoreName);
    var incrementedTx = this.lastTx + 1;

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.hashMap).forEach(function (type) {
      var checker = function checker(cb) {
        return function (id) {
          return !storeItemMap[id] && cb(id);
        };
      };
      if (contentTypes[type]) {
        checker = function checker(cb) {
          return function (id) {
            if (!storeItemMap[id]) {
              var _id$split = id.split('/'),
                  _id$split2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_id$split, 1),
                  fileId = _id$split2[0];

              if (!__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].state.file.itemsById[fileId]) {
                cb(id);
              }
            }
          };
        };
      }
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(_this4.hashMap[type]).forEach(checker(function (id) {
        dbStore.put({
          id: id,
          type: type,
          tx: incrementedTx
        });
        delete _this4.hashMap[type][id];
        _this4.lastTx = incrementedTx;
      }));
    });

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(storeItemMap).forEach(function (_ref2) {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
          storeItem = _ref3[1];

      if (_this4.hashMap[storeItem.type][storeItem.id] !== storeItem.hash) {
        var item = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, storeItem, {
          tx: incrementedTx
        });
        dbStore.put(item);
        _this4.hashMap[item.type][item.id] = item.hash;
        _this4.lastTx = incrementedTx;
      }
    });
  },
  readDbItem: function readDbItem(dbItem, storeItemMap) {
    var storeItem = storeItemMap[dbItem.id];
    if (!dbItem.hash) {
      delete this.hashMap[dbItem.type][dbItem.id];
      if (storeItem) {
        __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].commit(storeItem.type + '/deleteItem', storeItem.id);
        delete storeItemMap[storeItem.id];
      }
    } else if (this.hashMap[dbItem.type][dbItem.id] !== dbItem.hash) {
      this.hashMap[dbItem.type][dbItem.id] = dbItem.hash;

      if (storeItem || !contentTypes[dbItem.type]) {
        dbItem.tx = undefined;
        __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].commit(dbItem.type + '/setItem', dbItem);
        storeItemMap[dbItem.id] = dbItem;
      }
    }
  },
  loadItem: function loadItem(id) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var itemInStore;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              itemInStore = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters.allItemsById[id];

              if (!itemInStore) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a.resolve(itemInStore));

            case 3:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var onError = function onError() {
                  return reject(new Error('Data not available.'));
                };
                _this5.connection.createTx(function (tx) {
                  var dbStore = tx.objectStore(dbStoreName);
                  var request = dbStore.get(id);
                  request.onsuccess = function () {
                    var dbItem = request.result;
                    if (!dbItem || !dbItem.hash) {
                      onError();
                    } else {
                      _this5.hashMap[dbItem.type][dbItem.id] = dbItem.hash;

                      dbItem.tx = undefined;
                      __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].commit(dbItem.type + '/setItem', dbItem);
                      resolve(dbItem);
                    }
                  };
                }, function () {
                  return onError();
                });
              }));

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this5);
    }))();
  },
  unloadContents: function unloadContents() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var lastOpenedFileIdSet;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this6.sync();

            case 2:
              lastOpenedFileIdSet = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/lastOpenedIds']);

              __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(contentTypes).forEach(function (type) {
                __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters[type + '/items'].forEach(function (item) {
                  var _item$id$split = item.id.split('/'),
                      _item$id$split2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_item$id$split, 1),
                      fileId = _item$id$split2[0];

                  if (!lastOpenedFileIdSet.has(fileId)) {
                    __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].commit(type + '/deleteItem', item.id);
                  }
                });
              });

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this6);
    }))();
  },
  init: function init() {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var hash, welcomeFileHashes;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!resetApp) {
                _context5.next = 5;
                break;
              }

              _context5.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a.all(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['workspace/workspacesById']).map(function (workspaceId) {
                return __WEBPACK_IMPORTED_MODULE_16__workspaceSvc__["a" /* default */].removeWorkspace(workspaceId);
              }));

            case 3:
              __WEBPACK_IMPORTED_MODULE_17__data_constants__["a" /* default */].localStorageDataIds.forEach(function (id) {
                localStorage.removeItem('data/' + id);
              });
              throw new Error('RELOAD');

            case 5:
              _this7.connection = new Connection();

              _context5.next = 8;
              return localDbSvc.sync();

            case 8:
              __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].watch(function () {
                return __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/workspaces'];
              }, function () {
                return _this7.syncLocalStorage();
              });

              hash = __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].hash(__WEBPACK_IMPORTED_MODULE_15__data_welcomeFile_md___default.a);
              welcomeFileHashes = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/localSettings'].welcomeFileHashes;

              if (!welcomeFileHashes[hash]) {
                __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].dispatch('data/patchLocalSettings', {
                  welcomeFileHashes: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, welcomeFileHashes, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, hash, 1))
                });
              }

              if (!__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['workspace/syncToken'] && __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].state.workspace.lastFocus + __WEBPACK_IMPORTED_MODULE_17__data_constants__["a" /* default */].cleanTrashAfter < Date.now()) {
                __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['file/items'].filter(function (file) {
                  return file.parentId === 'trash';
                }).forEach(function (file) {
                  return __WEBPACK_IMPORTED_MODULE_16__workspaceSvc__["a" /* default */].deleteFile(file.id);
                });
              }

              __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].setInterval(function () {
                return localDbSvc.sync();
              }, 1000);

              __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].watch(function () {
                return __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['file/current'].id;
              }, __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var currentFile, recentFile, newFile, lastOpenedFile;
                return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        currentFile = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['file/current'];

                        if (currentFile.id) {
                          _context4.next = 13;
                          break;
                        }

                        recentFile = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['file/lastOpened'];

                        if (!recentFile.id) {
                          _context4.next = 7;
                          break;
                        }

                        __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].commit('file/setCurrentId', recentFile.id);
                        _context4.next = 11;
                        break;

                      case 7:
                        _context4.next = 9;
                        return __WEBPACK_IMPORTED_MODULE_16__workspaceSvc__["a" /* default */].createFile({
                          name: 'Welcome file',
                          text: __WEBPACK_IMPORTED_MODULE_15__data_welcomeFile_md___default.a
                        }, true);

                      case 9:
                        newFile = _context4.sent;

                        __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].commit('file/setCurrentId', newFile.id);

                      case 11:
                        _context4.next = 36;
                        break;

                      case 13:
                        _context4.prev = 13;
                        _context4.next = 16;
                        return localDbSvc.loadContentState(currentFile.id);

                      case 16:
                        _context4.next = 18;
                        return localDbSvc.loadSyncedContent(currentFile.id);

                      case 18:
                        _context4.prev = 18;
                        _context4.next = 21;
                        return localDbSvc.loadItem(currentFile.id + '/content');

                      case 21:
                        _context4.next = 28;
                        break;

                      case 23:
                        _context4.prev = 23;
                        _context4.t0 = _context4['catch'](18);
                        lastOpenedFile = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['file/lastOpened'];

                        __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].commit('file/setCurrentId', lastOpenedFile.id);
                        throw _context4.t0;

                      case 28:
                        __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].dispatch('data/setLastOpenedId', currentFile.id);

                        __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].commit('discussion/setCurrentDiscussionId', __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['discussion/nextDiscussionId']);
                        _context4.next = 36;
                        break;

                      case 32:
                        _context4.prev = 32;
                        _context4.t1 = _context4['catch'](13);

                        console.error(_context4.t1);
                        __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].dispatch('notification/error', _context4.t1);

                      case 36:
                      case 'end':
                        return _context4.stop();
                    }
                  }
                }, _callee4, _this7, [[13, 32], [18, 23]]);
              })), { immediate: true });

            case 15:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this7);
    }))();
  },
  getWorkspaceItems: function getWorkspaceItems(workspaceId, onItem) {
    var onFinish = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

    var connection = new Connection(workspaceId);
    connection.createTx(function (tx) {
      var dbStore = tx.objectStore(dbStoreName);
      var index = dbStore.index('tx');
      index.openCursor().onsuccess = function (event) {
        var cursor = event.target.result;
        if (cursor) {
          onItem(cursor.value);
          cursor.continue();
        } else {
          connection.db.close();
          onFinish();
        }
      };
    });

    return function () {
      return connection.db.close();
    };
  }
};

var loader = function loader(type) {
  return function (fileId) {
    return localDbSvc.loadItem(fileId + '/' + type).catch(function () {
      return __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].commit(type + '/setItem', {
        id: fileId + '/' + type
      });
    });
  };
};
localDbSvc.loadSyncedContent = loader('syncedContent');
localDbSvc.loadContentState = loader('contentState');

/* harmony default export */ __webpack_exports__["a"] = (localDbSvc);

/***/ }),
/* 152 */,
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__networkSvc__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__userSvc__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__badgeSvc__ = __webpack_require__(11);





var _this = this;







var getScopes = function getScopes(token) {
  return [token.repoFullAccess ? 'repo' : 'public_repo', 'gist'];
};

var request = function request(token, options) {
  return __WEBPACK_IMPORTED_MODULE_5__networkSvc__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, options, {
    headers: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, options.headers || {}, {
      Authorization: 'token ' + token.accessToken
    }),
    params: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, options.params || {}, {
      t: Date.now() })
  }));
};

var repoRequest = function repoRequest(token, owner, repo, options) {
  return request(token, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, options, {
    url: 'https://api.github.com/repos/' + encodeURIComponent(owner) + '/' + encodeURIComponent(repo) + '/' + options.url
  })).then(function (res) {
    return res.body;
  });
};

var getCommitMessage = function getCommitMessage(name, path) {
  var message = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters['data/computedSettings'].git[name];
  return message.replace(/{{path}}/g, path);
};

var subPrefix = 'gh';
__WEBPACK_IMPORTED_MODULE_7__userSvc__["a" /* default */].setInfoResolver('github', subPrefix, function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(sub) {
    var user;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_5__networkSvc__["a" /* default */].request({
              url: 'https://api.github.com/user/' + sub,
              params: {
                t: Date.now() }
            });

          case 3:
            user = _context.sent.body;
            return _context.abrupt('return', {
              id: subPrefix + ':' + user.id,
              name: user.login,
              imageUrl: user.avatar_url || ''
            });

          case 7:
            _context.prev = 7;
            _context.t0 = _context['catch'](0);

            if (!(_context.t0.status !== 404)) {
              _context.next = 11;
              break;
            }

            throw new Error('RETRY');

          case 11:
            throw _context.t0;

          case 12:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 7]]);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());

/* harmony default export */ __webpack_exports__["a"] = ({
  subPrefix: subPrefix,

  startOauth2: function startOauth2(scopes) {
    var _this2 = this;

    var sub = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var clientId, _ref2, code, accessToken, user, token;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              clientId = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters['data/serverConf'].githubClientId;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_5__networkSvc__["a" /* default */].startOauth2('https://github.com/login/oauth/authorize', {
                client_id: clientId,
                scope: scopes.join(' ')
              }, silent);

            case 3:
              _ref2 = _context2.sent;
              code = _ref2.code;
              _context2.next = 7;
              return __WEBPACK_IMPORTED_MODULE_5__networkSvc__["a" /* default */].request({
                method: 'GET',
                url: 'oauth2/githubToken',
                params: {
                  clientId: clientId,
                  code: code
                }
              });

            case 7:
              accessToken = _context2.sent.body;
              _context2.next = 10;
              return __WEBPACK_IMPORTED_MODULE_5__networkSvc__["a" /* default */].request({
                method: 'GET',
                url: 'https://api.github.com/user',
                headers: {
                  Authorization: 'token ' + accessToken
                }
              });

            case 10:
              user = _context2.sent.body;

              __WEBPACK_IMPORTED_MODULE_7__userSvc__["a" /* default */].addUserInfo({
                id: subPrefix + ':' + user.id,
                name: user.login,
                imageUrl: user.avatar_url || ''
              });

              if (!(sub && '' + user.id !== sub)) {
                _context2.next = 14;
                break;
              }

              throw new Error('GitHub account ID not expected.');

            case 14:
              token = {
                scopes: scopes,
                accessToken: accessToken,
                name: user.login,
                sub: '' + user.id,
                repoFullAccess: scopes.includes('repo')
              };

              __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('data/addGithubToken', token);
              return _context2.abrupt('return', token);

            case 17:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  addAccount: function addAccount() {
    var _this3 = this;

    var repoFullAccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var token;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.startOauth2(getScopes({ repoFullAccess: repoFullAccess }));

            case 2:
              token = _context3.sent;

              __WEBPACK_IMPORTED_MODULE_8__badgeSvc__["a" /* default */].addBadge('addGitHubAccount');
              return _context3.abrupt('return', token);

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getTree: function getTree(_ref3) {
    var _this4 = this;

    var token = _ref3.token,
        owner = _ref3.owner,
        repo = _ref3.repo,
        branch = _ref3.branch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var _ref4, commit, _ref5, tree, truncated;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return repoRequest(token, owner, repo, {
                url: 'commits/' + encodeURIComponent(branch)
              });

            case 2:
              _ref4 = _context4.sent;
              commit = _ref4.commit;
              _context4.next = 6;
              return repoRequest(token, owner, repo, {
                url: 'git/trees/' + encodeURIComponent(commit.tree.sha) + '?recursive=1'
              });

            case 6:
              _ref5 = _context4.sent;
              tree = _ref5.tree;
              truncated = _ref5.truncated;

              if (!truncated) {
                _context4.next = 11;
                break;
              }

              throw new Error('Git tree too big. Please remove some files in the repository.');

            case 11:
              return _context4.abrupt('return', tree);

            case 12:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  getCommits: function getCommits(_ref6) {
    var _this5 = this;

    var token = _ref6.token,
        owner = _ref6.owner,
        repo = _ref6.repo,
        sha = _ref6.sha,
        path = _ref6.path;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt('return', repoRequest(token, owner, repo, {
                url: 'commits',
                params: { sha: sha, path: path }
              }));

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  uploadFile: function uploadFile(_ref7) {
    var _this6 = this;

    var token = _ref7.token,
        owner = _ref7.owner,
        repo = _ref7.repo,
        branch = _ref7.branch,
        path = _ref7.path,
        content = _ref7.content,
        sha = _ref7.sha;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt('return', repoRequest(token, owner, repo, {
                method: 'PUT',
                url: 'contents/' + encodeURIComponent(path),
                body: {
                  message: getCommitMessage(sha ? 'updateFileMessage' : 'createFileMessage', path),
                  content: __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].encodeBase64(content),
                  sha: sha,
                  branch: branch
                }
              }));

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  removeFile: function removeFile(_ref8) {
    var _this7 = this;

    var token = _ref8.token,
        owner = _ref8.owner,
        repo = _ref8.repo,
        branch = _ref8.branch,
        path = _ref8.path,
        sha = _ref8.sha;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt('return', repoRequest(token, owner, repo, {
                method: 'DELETE',
                url: 'contents/' + encodeURIComponent(path),
                body: {
                  message: getCommitMessage('deleteFileMessage', path),
                  sha: sha,
                  branch: branch
                }
              }));

            case 1:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  downloadFile: function downloadFile(_ref9) {
    var _this8 = this;

    var token = _ref9.token,
        owner = _ref9.owner,
        repo = _ref9.repo,
        branch = _ref9.branch,
        path = _ref9.path;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var _ref10, sha, content;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return repoRequest(token, owner, repo, {
                url: 'contents/' + encodeURIComponent(path),
                params: { ref: branch }
              });

            case 2:
              _ref10 = _context8.sent;
              sha = _ref10.sha;
              content = _ref10.content;
              return _context8.abrupt('return', {
                sha: sha,
                data: __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].decodeBase64(content)
              });

            case 6:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  uploadGist: function uploadGist(_ref11) {
    var _this9 = this;

    var token = _ref11.token,
        description = _ref11.description,
        filename = _ref11.filename,
        content = _ref11.content,
        isPublic = _ref11.isPublic,
        gistId = _ref11.gistId;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
      var _ref12, body;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return request(token, gistId ? {
                method: 'PATCH',
                url: 'https://api.github.com/gists/' + gistId,
                body: {
                  description: description,
                  files: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, filename, {
                    content: content
                  })
                }
              } : {
                method: 'POST',
                url: 'https://api.github.com/gists',
                body: {
                  description: description,
                  files: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, filename, {
                    content: content
                  }),
                  public: isPublic
                }
              });

            case 2:
              _ref12 = _context9.sent;
              body = _ref12.body;
              return _context9.abrupt('return', body);

            case 5:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  downloadGist: function downloadGist(_ref13) {
    var _this10 = this;

    var token = _ref13.token,
        gistId = _ref13.gistId,
        filename = _ref13.filename;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
      var result;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return request(token, {
                url: 'https://api.github.com/gists/' + gistId
              });

            case 2:
              _context10.t0 = filename;
              result = _context10.sent.body.files[_context10.t0];

              if (result) {
                _context10.next = 6;
                break;
              }

              throw new Error('Gist file not found.');

            case 6:
              return _context10.abrupt('return', result.content);

            case 7:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  getGistCommits: function getGistCommits(_ref14) {
    var _this11 = this;

    var token = _ref14.token,
        gistId = _ref14.gistId;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
      var _ref15, body;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return request(token, {
                url: 'https://api.github.com/gists/' + gistId + '/commits'
              });

            case 2:
              _ref15 = _context11.sent;
              body = _ref15.body;
              return _context11.abrupt('return', body);

            case 5:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },
  downloadGistRevision: function downloadGistRevision(_ref16) {
    var _this12 = this;

    var token = _ref16.token,
        gistId = _ref16.gistId,
        filename = _ref16.filename,
        sha = _ref16.sha;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
      var result;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return request(token, {
                url: 'https://api.github.com/gists/' + gistId + '/' + sha
              });

            case 2:
              _context12.t0 = filename;
              result = _context12.sent.body.files[_context12.t0];

              if (result) {
                _context12.next = 6;
                break;
              }

              throw new Error('Gist file not found.');

            case 6:
              return _context12.abrupt('return', result.content);

            case 7:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this12);
    }))();
  }
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__networkSvc__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__userSvc__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__badgeSvc__ = __webpack_require__(11);





var _this = this;







var request = function request(_ref, options) {
  var accessToken = _ref.accessToken,
      serverUrl = _ref.serverUrl;
  return __WEBPACK_IMPORTED_MODULE_5__networkSvc__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, options, {
    url: serverUrl + '/api/v4/' + options.url,
    headers: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, options.headers || {}, {
      Authorization: 'Bearer ' + accessToken
    })
  })).then(function (res) {
    return res.body;
  });
};

var getCommitMessage = function getCommitMessage(name, path) {
  var message = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters['data/computedSettings'].git[name];
  return message.replace(/{{path}}/g, path);
};

var subPrefix = 'gl';
__WEBPACK_IMPORTED_MODULE_7__userSvc__["a" /* default */].setInfoResolver('gitlab', subPrefix, function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(sub) {
    var _sub$match, _sub$match2, serverUrl, id, user, uniqueSub;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _sub$match = sub.match(/^(.+)\/([^/]+)$/), _sub$match2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_sub$match, 3), serverUrl = _sub$match2[1], id = _sub$match2[2];
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_5__networkSvc__["a" /* default */].request({
              url: serverUrl + '/api/v4/users/' + id
            });

          case 4:
            user = _context.sent.body;
            uniqueSub = serverUrl + '/' + user.id;
            return _context.abrupt('return', {
              id: subPrefix + ':' + uniqueSub,
              name: user.username,
              imageUrl: user.avatar_url || ''
            });

          case 9:
            _context.prev = 9;
            _context.t0 = _context['catch'](0);

            if (!(_context.t0.status !== 404)) {
              _context.next = 13;
              break;
            }

            throw new Error('RETRY');

          case 13:
            throw _context.t0;

          case 14:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 9]]);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}());

/* harmony default export */ __webpack_exports__["a"] = ({
  subPrefix: subPrefix,

  startOauth2: function startOauth2(serverUrl, applicationId) {
    var _this2 = this;

    var sub = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var silent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _ref3, accessToken, user, uniqueSub, token;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_5__networkSvc__["a" /* default */].startOauth2(serverUrl + '/oauth/authorize', {
                client_id: applicationId,
                response_type: 'token',
                scope: 'api'
              }, silent);

            case 2:
              _ref3 = _context2.sent;
              accessToken = _ref3.accessToken;
              _context2.next = 6;
              return request({ accessToken: accessToken, serverUrl: serverUrl }, {
                url: 'user'
              });

            case 6:
              user = _context2.sent;
              uniqueSub = serverUrl + '/' + user.id;

              __WEBPACK_IMPORTED_MODULE_7__userSvc__["a" /* default */].addUserInfo({
                id: subPrefix + ':' + uniqueSub,
                name: user.username,
                imageUrl: user.avatar_url || ''
              });

              if (!(sub && uniqueSub !== sub)) {
                _context2.next = 11;
                break;
              }

              throw new Error('GitLab account ID not expected.');

            case 11:
              token = {
                accessToken: accessToken,
                name: user.username,
                serverUrl: serverUrl,
                sub: uniqueSub
              };

              __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('data/addGitlabToken', token);
              return _context2.abrupt('return', token);

            case 14:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  addAccount: function addAccount(serverUrl, applicationId) {
    var _this3 = this;

    var sub = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var token;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.startOauth2(serverUrl, applicationId, sub);

            case 2:
              token = _context3.sent;

              __WEBPACK_IMPORTED_MODULE_8__badgeSvc__["a" /* default */].addBadge('addGitLabAccount');
              return _context3.abrupt('return', token);

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getProjectId: function getProjectId(token, _ref4) {
    var _this4 = this;

    var projectPath = _ref4.projectPath,
        projectId = _ref4.projectId;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var project;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!projectId) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt('return', projectId);

            case 2:
              _context4.next = 4;
              return request(token, {
                url: 'projects/' + encodeURIComponent(projectPath)
              });

            case 4:
              project = _context4.sent;
              return _context4.abrupt('return', project.id);

            case 6:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  getTree: function getTree(_ref5) {
    var _this5 = this;

    var token = _ref5.token,
        projectId = _ref5.projectId,
        branch = _ref5.branch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt('return', request(token, {
                url: 'projects/' + encodeURIComponent(projectId) + '/repository/tree',
                params: {
                  ref: branch,
                  recursive: true,
                  per_page: 9999
                }
              }));

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  getCommits: function getCommits(_ref6) {
    var _this6 = this;

    var token = _ref6.token,
        projectId = _ref6.projectId,
        branch = _ref6.branch,
        path = _ref6.path;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt('return', request(token, {
                url: 'projects/' + encodeURIComponent(projectId) + '/repository/commits',
                params: {
                  ref_name: branch,
                  path: path
                }
              }));

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  uploadFile: function uploadFile(_ref7) {
    var _this7 = this;

    var token = _ref7.token,
        projectId = _ref7.projectId,
        branch = _ref7.branch,
        path = _ref7.path,
        content = _ref7.content,
        sha = _ref7.sha;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt('return', request(token, {
                method: sha ? 'PUT' : 'POST',
                url: 'projects/' + encodeURIComponent(projectId) + '/repository/files/' + encodeURIComponent(path),
                body: {
                  commit_message: getCommitMessage(sha ? 'updateFileMessage' : 'createFileMessage', path),
                  content: content,
                  last_commit_id: sha,
                  branch: branch
                }
              }));

            case 1:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  removeFile: function removeFile(_ref8) {
    var _this8 = this;

    var token = _ref8.token,
        projectId = _ref8.projectId,
        branch = _ref8.branch,
        path = _ref8.path,
        sha = _ref8.sha;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt('return', request(token, {
                method: 'DELETE',
                url: 'projects/' + encodeURIComponent(projectId) + '/repository/files/' + encodeURIComponent(path),
                body: {
                  commit_message: getCommitMessage('deleteFileMessage', path),
                  last_commit_id: sha,
                  branch: branch
                }
              }));

            case 1:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  downloadFile: function downloadFile(_ref9) {
    var _this9 = this;

    var token = _ref9.token,
        projectId = _ref9.projectId,
        branch = _ref9.branch,
        path = _ref9.path;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return request(token, {
                url: 'projects/' + encodeURIComponent(projectId) + '/repository/files/' + encodeURIComponent(path),
                params: { ref: branch }
              });

            case 2:
              res = _context9.sent;
              return _context9.abrupt('return', {
                sha: res.last_commit_id,
                data: __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].decodeBase64(res.content)
              });

            case 4:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_utils__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["a"] = (function (empty) {
  var simpleHash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var hashFunc = simpleHash ? Date.now : function (item) {
    return __WEBPACK_IMPORTED_MODULE_3__services_utils__["a" /* default */].getItemHash(item);
  };

  return {
    namespaced: true,
    state: {
      itemsById: {}
    },
    getters: {
      items: function items(_ref) {
        var itemsById = _ref.itemsById;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(itemsById);
      }
    },
    mutations: {
      setItem: function setItem(state, value) {
        var item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(empty(value.id), value);
        if (!item.hash || !simpleHash) {
          item.hash = hashFunc(item);
        }
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.itemsById, item.id, item);
      },
      patchItem: function patchItem(state, patch) {
        var item = state.itemsById[patch.id];
        if (item) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(item, patch);
          item.hash = hashFunc(item);
          __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.itemsById, item.id, item);
          return true;
        }
        return false;
      },
      deleteItem: function deleteItem(state, id) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].delete(state.itemsById, id);
      }
    },
    actions: {}
  };
});

/***/ }),
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);


var aHrefSanitizationWhitelist = /^\s*(https?|ftp|mailto|tel|file):/;
var imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;

var urlParsingNode = window.document.createElement('a');

function sanitizeUri(uri, isImage) {
  var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
  urlParsingNode.setAttribute('href', uri);
  var normalizedVal = urlParsingNode.href;
  if (normalizedVal !== '' && !normalizedVal.match(regex)) {
    return 'unsafe:' + normalizedVal;
  }
  return uri;
}

var buf;

var START_TAG_REGEXP = /^<((?:[a-zA-Z])[\w:-]*)((?:\s+[\w:-]+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)\s*(>?)/,
    END_TAG_REGEXP = /^<\/\s*([\w:-]+)[^>]*>/,
    ATTR_REGEXP = /([\w:-]+)(?:\s*=\s*(?:(?:"((?:[^"])*)")|(?:'((?:[^'])*)')|([^>\s]+)))?/g,
    BEGIN_TAG_REGEXP = /^</,
    BEGING_END_TAGE_REGEXP = /^<\//,
    COMMENT_REGEXP = /<!--(.*?)-->/g,
    DOCTYPE_REGEXP = /<!DOCTYPE([^>]*?)>/i,
    CDATA_REGEXP = /<!\[CDATA\[(.*?)]]>/g,
    SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
    NON_ALPHANUMERIC_REGEXP = /([^\#-~| |!])/g;

var voidElements = makeMap("area,br,col,hr,img,wbr");

var optionalEndTagBlockElements = makeMap("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),
    optionalEndTagInlineElements = makeMap("rp,rt"),
    optionalEndTagElements = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, optionalEndTagInlineElements, optionalEndTagBlockElements);

var blockElements = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, optionalEndTagBlockElements, makeMap("address,article," + "aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5," + "h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,script,section,table,ul"));

blockElements.iframe = true;

var inlineElements = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, optionalEndTagInlineElements, makeMap("a,abbr,acronym,b," + "bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s," + "samp,small,span,strike,strong,sub,sup,time,tt,u,var"));

var svgElements = makeMap("circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph," + "hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline," + "radialGradient,rect,stop,svg,switch,text,title,tspan,use");

var specialElements = makeMap("script,style");

var validElements = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, voidElements, blockElements, inlineElements, optionalEndTagElements, svgElements);

var uriAttrs = makeMap("background,cite,href,longdesc,src,usemap,xlink:href");

var htmlAttrs = makeMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' + 'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' + 'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' + 'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' + 'valign,value,vspace,width');

var svgAttrs = makeMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' + 'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' + 'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' + 'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' + 'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' + 'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' + 'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' + 'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' + 'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' + 'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' + 'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' + 'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' + 'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' + 'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' + 'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);

var validAttrs = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, uriAttrs, svgAttrs, htmlAttrs);

validAttrs.id = true;
validAttrs.allowfullscreen = true;

function makeMap(str, lowercaseKeys) {
  var obj = {},
      items = str.split(','),
      i;
  for (i = 0; i < items.length; i++) {
    obj[lowercaseKeys ? items[i].toLowerCase() : items[i]] = true;
  }
  return obj;
}

function htmlParser(html, handler) {
  if (typeof html !== 'string') {
    if (html === null || typeof html === 'undefined') {
      html = '';
    } else {
      html = '' + html;
    }
  }
  var index,
      chars,
      match,
      stack = [],
      last = html,
      text;
  stack.last = function () {
    return stack[stack.length - 1];
  };

  while (html) {
    text = '';
    chars = true;

    if (!stack.last() || !specialElements[stack.last()]) {
      if (html.indexOf("<!--") === 0) {
        index = html.indexOf("--", 4);

        if (index >= 0 && html.lastIndexOf("-->", index) === index) {
          if (handler.comment) handler.comment(html.substring(4, index));
          html = html.substring(index + 3);
          chars = false;
        }
      } else if (DOCTYPE_REGEXP.test(html)) {
        match = html.match(DOCTYPE_REGEXP);

        if (match) {
          html = html.replace(match[0], '');
          chars = false;
        }
      } else if (BEGING_END_TAGE_REGEXP.test(html)) {
        match = html.match(END_TAG_REGEXP);

        if (match) {
          html = html.substring(match[0].length);
          match[0].replace(END_TAG_REGEXP, parseEndTag);
          chars = false;
        }
      } else if (BEGIN_TAG_REGEXP.test(html)) {
        match = html.match(START_TAG_REGEXP);

        if (match) {
          if (match[4]) {
            html = html.substring(match[0].length);
            match[0].replace(START_TAG_REGEXP, parseStartTag);
          }
          chars = false;
        } else {
          text += '<';
          html = html.substring(1);
        }
      }

      if (chars) {
        index = html.indexOf("<");

        text += index < 0 ? html : html.substring(0, index);
        html = index < 0 ? "" : html.substring(index);

        if (handler.chars) handler.chars(decodeEntities(text));
      }
    } else {
      html = html.replace(new RegExp("([\\W\\w]*)<\\s*\\/\\s*" + stack.last() + "[^>]*>", 'i'), function (all, text) {
        text = text.replace(COMMENT_REGEXP, "$1").replace(CDATA_REGEXP, "$1");

        if (handler.chars) handler.chars(decodeEntities(text));

        return "";
      });

      parseEndTag("", stack.last());
    }

    if (html == last) {
      stack.reverse();
      return stack.cl_each(function (tag) {
        buf.push('</');
        buf.push(tag);
        buf.push('>');
      });
    }
    last = html;
  }

  parseEndTag();

  function parseStartTag(tag, tagName, rest, unary) {
    tagName = tagName && tagName.toLowerCase();
    if (blockElements[tagName]) {
      while (stack.last() && inlineElements[stack.last()]) {
        parseEndTag("", stack.last());
      }
    }

    if (optionalEndTagElements[tagName] && stack.last() == tagName) {
      parseEndTag("", tagName);
    }

    unary = voidElements[tagName] || !!unary;

    if (!unary) {
      stack.push(tagName);
    }

    var attrs = {};

    rest.replace(ATTR_REGEXP, function (match, name, doubleQuotedValue, singleQuotedValue, unquotedValue) {
      var value = doubleQuotedValue || singleQuotedValue || unquotedValue || '';

      attrs[name] = decodeEntities(value);
    });
    if (handler.start) handler.start(tagName, attrs, unary);
  }

  function parseEndTag(tag, tagName) {
    var pos = 0,
        i;
    tagName = tagName && tagName.toLowerCase();
    if (tagName) {
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos] == tagName) break;
      }
    }

    if (pos >= 0) {
      for (i = stack.length - 1; i >= pos; i--) {
        if (handler.end) handler.end(stack[i]);
      }
      stack.length = pos;
    }
  }
}

var hiddenPre = document.createElement("pre");

function decodeEntities(value) {
  if (!value) {
    return '';
  }

  hiddenPre.innerHTML = value.replace(/</g, "&lt;");

  return hiddenPre.textContent;
}

function encodeEntities(value) {
  return value.replace(/&/g, '&amp;').replace(SURROGATE_PAIR_REGEXP, function (value) {
    var hi = value.charCodeAt(0);
    var low = value.charCodeAt(1);
    return '&#' + ((hi - 0xD800) * 0x400 + (low - 0xDC00) + 0x10000) + ';';
  }).replace(NON_ALPHANUMERIC_REGEXP, function (value) {
    return '&#' + value.charCodeAt(0) + ';';
  }).replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function htmlSanitizeWriter(buf, uriValidator) {
  var ignore = false;
  var out = buf.push.bind(buf);
  return {
    start: function start(tag, attrs, unary) {
      tag = tag && tag.toLowerCase();
      if (!ignore && specialElements[tag]) {
        ignore = tag;
      }
      if (!ignore && validElements[tag] === true) {
        out('<');
        out(tag);
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(attrs).forEach(function (key) {
          var value = attrs[key];
          var lkey = key && key.toLowerCase();
          var isImage = tag === 'img' && lkey === 'src' || lkey === 'background';
          if (validAttrs[lkey] === true && (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
            out(' ');
            out(key);
            out('="');
            out(encodeEntities(value));
            out('"');
          }
        });
        out(unary ? '/>' : '>');
      }
    },
    end: function end(tag) {
      tag = tag && tag.toLowerCase();
      if (!ignore && validElements[tag] === true) {
        out('</');
        out(tag);
        out('>');
      }
      if (tag == ignore) {
        ignore = false;
      }
    },
    chars: function chars(_chars) {
      if (!ignore) {
        out(encodeEntities(_chars));
      }
    },
    comment: function comment(_comment) {
      if (!ignore) {
        out('<!--');
        out(encodeEntities(_comment));
        out('-->');
      }
    }
  };
}

function sanitizeHtml(html) {
  buf = [];
  htmlParser(html, htmlSanitizeWriter(buf, function (uri, isImage) {
    return !/^unsafe/.test(sanitizeUri(uri, isImage));
  }));
  return buf.join('');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  sanitizeHtml: sanitizeHtml,
  sanitizeUri: sanitizeUri
});

/***/ }),
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bezier_easing__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bezier_easing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bezier_easing__);






var easings = {
  materialIn: __WEBPACK_IMPORTED_MODULE_4_bezier_easing___default()(0.75, 0, 0.8, 0.25),
  materialOut: __WEBPACK_IMPORTED_MODULE_4_bezier_easing___default()(0.25, 0.8, 0.25, 1),
  inOut: __WEBPACK_IMPORTED_MODULE_4_bezier_easing___default()(0.25, 0.1, 0.67, 1)
};

var vendors = ['moz', 'webkit'];
for (var x = 0; x < vendors.length && !window.requestAnimationFrame; x += 1) {
  window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
  window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
}

var transformStyles = ['WebkitTransform', 'MozTransform', 'msTransform', 'OTransform', 'transform'];

var transitionEndEvents = {
  WebkitTransition: 'webkitTransitionEnd',
  MozTransition: 'transitionend',
  msTransition: 'MSTransitionEnd',
  OTransition: 'oTransitionEnd',
  transition: 'transitionend'
};

function getStyle(styles) {
  var elt = document.createElement('div');
  return styles.reduce(function (result, style) {
    if (elt.style[style] === undefined) {
      return undefined;
    }
    return style;
  }, undefined);
}

var transformStyle = getStyle(transformStyles);
var transitionStyle = getStyle(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(transitionEndEvents));
var transitionEndEvent = transitionEndEvents[transitionStyle];

function identity(x) {
  return x;
}

function ElementAttribute(name) {
  this.name = name;
  this.setStart = function (animation) {
    var value = animation.elt[name];
    animation.$start[name] = value;
    return value !== undefined && animation.$end[name] !== undefined;
  };
  this.applyCurrent = function (animation) {
    animation.elt[name] = animation.$current[name];
  };
}

function StyleAttribute(name, unit, defaultValue) {
  var wrap = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : identity;

  this.name = name;
  this.setStart = function (animation) {
    var value = parseFloat(animation.elt.style[name]);
    if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default()(value)) {
      value = animation.$current[name] || defaultValue;
    }
    animation.$start[name] = value;
    return animation.$end[name] !== undefined;
  };
  this.applyCurrent = function (animation) {
    animation.elt.style[name] = wrap(animation.$current[name]) + unit;
  };
}

function TransformAttribute(name, unit, defaultValue) {
  var wrap = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : identity;

  this.name = name;
  this.setStart = function (animation) {
    var value = animation.$current[name];
    if (value === undefined) {
      value = defaultValue;
    }
    animation.$start[name] = value;
    if (animation.$end[name] === undefined) {
      animation.$end[name] = value;
    }
    return value !== undefined;
  };
  this.applyCurrent = function (animation) {
    var value = animation.$current[name];
    return value !== defaultValue && name + '(' + wrap(value) + unit + ')';
  };
}

var attributes = [new ElementAttribute('scrollTop'), new ElementAttribute('scrollLeft'), new StyleAttribute('opacity', '', 1), new StyleAttribute('zIndex', '', 0), new TransformAttribute('translateX', 'px', 0, Math.round), new TransformAttribute('translateY', 'px', 0, Math.round), new TransformAttribute('scale', '', 1), new TransformAttribute('rotate', 'deg', 0)].concat(['width', 'height', 'top', 'right', 'bottom', 'left'].map(function (name) {
  return new StyleAttribute(name, 'px', 0, Math.round);
}));

var Animation = function () {
  function Animation(elt) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Animation);

    this.elt = elt;
    this.$current = {};
    this.$pending = {};
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Animation, [{
    key: 'start',
    value: function start(param1, param2, param3) {
      var _this = this;

      var endCb = param1;
      var stepCb = param2;
      var useTransition = false;
      if (typeof param1 === 'boolean') {
        useTransition = param1;
        endCb = param2;
        stepCb = param3;
      }

      this.stop();
      this.$start = {};
      this.$end = this.$pending;
      this.$pending = {};
      this.$attributes = attributes.filter(function (attribute) {
        return attribute.setStart(_this);
      });
      this.$end.duration = this.$end.duration || 0;
      this.$end.delay = this.$end.delay || 0;
      this.$end.easing = easings[this.$end.easing] || easings.materialOut;
      this.$end.endCb = typeof endCb === 'function' && endCb;
      this.$end.stepCb = typeof stepCb === 'function' && stepCb;
      this.$startTime = Date.now() + this.$end.delay;
      if (!this.$end.duration) {
        this.loop(false);
      } else if (useTransition) {
        this.loop(true);
      } else {
        this.$requestId = window.requestAnimationFrame(function () {
          return _this.loop(false);
        });
      }
      return this.elt;
    }
  }, {
    key: 'stop',
    value: function stop() {
      window.cancelAnimationFrame(this.$requestId);
    }
  }, {
    key: 'loop',
    value: function loop(useTransition) {
      var _this2 = this;

      var onTransitionEnd = function onTransitionEnd(evt) {
        if (evt.target === _this2.elt) {
          _this2.elt.removeEventListener(transitionEndEvent, onTransitionEnd);
          var endCb = _this2.$end.endCb;

          _this2.$end.endCb = undefined;
          if (endCb) {
            endCb();
          }
        }
      };

      var progress = (Date.now() - this.$startTime) / this.$end.duration;
      var transition = '';
      if (useTransition) {
        progress = 1;
        var transitions = ['all', this.$end.duration + 'ms', this.$end.easing.toCSS()];
        if (this.$end.delay) {
          transitions.push(this.$end.duration + 'ms');
        }
        transition = transitions.join(' ');
        if (this.$end.endCb) {
          this.elt.addEventListener(transitionEndEvent, onTransitionEnd);
        }
      } else if (progress < 1) {
        this.$requestId = window.requestAnimationFrame(function () {
          return _this2.loop(false);
        });
        if (progress < 0) {
          return;
        }
      } else if (this.$end.endCb) {
        this.$requestId = window.requestAnimationFrame(this.$end.endCb);
      }

      var coeff = this.$end.easing.get(progress);
      var transforms = this.$attributes.reduce(function (result, attribute) {
        if (progress < 1) {
          var diff = _this2.$end[attribute.name] - _this2.$start[attribute.name];
          _this2.$current[attribute.name] = _this2.$start[attribute.name] + diff * coeff;
        } else {
          _this2.$current[attribute.name] = _this2.$end[attribute.name];
        }
        var transform = attribute.applyCurrent(_this2);
        if (transform) {
          result.push(transform);
        }
        return result;
      }, []);

      if (transforms.length) {
        transforms.push('translateZ(0)');
      }
      var transform = transforms.join(' ');
      this.elt.style[transformStyle] = transform;
      this.elt.style[transitionStyle] = transition;
      if (this.$end.stepCb) {
        this.$end.stepCb();
      }
    }
  }]);

  return Animation;
}();

attributes.map(function (attribute) {
  return attribute.name;
}).concat('duration', 'easing', 'delay').forEach(function (name) {
  Animation.prototype[name] = function setter(val) {
    this.$pending[name] = val;
    return this;
  };
});

function animate(elt) {
  if (!elt.$animation) {
    elt.$animation = new Animation(elt);
  }
  return elt.$animation;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  animate: animate
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_worker_loader_templateWorker_js__ = __webpack_require__(2651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_worker_loader_templateWorker_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_worker_loader_templateWorker_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__localDbSvc__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__markdownConversionSvc__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__extensionSvc__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__libs_htmlSanitizer__ = __webpack_require__(182);













function groupHeadings(headings) {
  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var result = [];
  var currentItem = void 0;

  function pushCurrentItem() {
    if (currentItem) {
      if (currentItem.children.length > 0) {
        currentItem.children = groupHeadings(currentItem.children, level + 1);
      }
      result.push(currentItem);
    }
  }
  headings.forEach(function (heading) {
    if (heading.level !== level) {
      currentItem = currentItem || {
        children: []
      };
      currentItem.children.push(heading);
    } else {
      pushCurrentItem();
      currentItem = heading;
    }
  });
  pushCurrentItem();
  return result;
}

var containerElt = document.createElement('div');
containerElt.className = 'hidden-rendering-container';
document.body.appendChild(containerElt);

/* harmony default export */ __webpack_exports__["a"] = ({
  applyTemplate: function applyTemplate(fileId) {
    var _this = this;

    var template = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      value: '{{{files.0.content.text}}}',
      helpers: ''
    };
    var pdf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var file, content, properties, options, converter, parsingCtx, conversionCtx, html, headings, toc, view, worker;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              file = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.file.itemsById[fileId];
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_6__localDbSvc__["a" /* default */].loadItem(fileId + '/content');

            case 3:
              content = _context.sent;
              properties = __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].computeProperties(content.properties);
              options = __WEBPACK_IMPORTED_MODULE_8__extensionSvc__["a" /* default */].getOptions(properties);
              converter = __WEBPACK_IMPORTED_MODULE_7__markdownConversionSvc__["a" /* default */].createConverter(options, true);
              parsingCtx = __WEBPACK_IMPORTED_MODULE_7__markdownConversionSvc__["a" /* default */].parseSections(converter, content.text);
              conversionCtx = __WEBPACK_IMPORTED_MODULE_7__markdownConversionSvc__["a" /* default */].convert(parsingCtx);
              html = conversionCtx.htmlSectionList.map(__WEBPACK_IMPORTED_MODULE_11__libs_htmlSanitizer__["a" /* default */].sanitizeHtml).join('');

              containerElt.innerHTML = html;
              __WEBPACK_IMPORTED_MODULE_8__extensionSvc__["a" /* default */].sectionPreview(containerElt, options);

              containerElt.querySelectorAll('.table-wrapper').cl_each(function (wrapperElt) {
                while (wrapperElt.firstChild) {
                  wrapperElt.parentNode.insertBefore(wrapperElt.firstChild, wrapperElt.nextSibling);
                }
                wrapperElt.parentNode.removeChild(wrapperElt);
              });

              headings = containerElt.querySelectorAll('h1,h2,h3,h4,h5,h6').cl_map(function (headingElt) {
                return {
                  title: headingElt.textContent,
                  anchor: headingElt.id,
                  level: parseInt(headingElt.tagName.slice(1), 10),
                  children: []
                };
              });
              toc = groupHeadings(headings);
              view = {
                pdf: pdf,
                files: [{
                  name: file.name,
                  content: {
                    text: content.text,
                    properties: properties,
                    yamlProperties: content.properties,
                    html: containerElt.innerHTML,
                    toc: toc
                  }
                }]
              };

              containerElt.innerHTML = '';

              worker = new __WEBPACK_IMPORTED_MODULE_5_worker_loader_templateWorker_js___default.a();
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var timeoutId = setTimeout(function () {
                  worker.terminate();
                  reject(new Error('Template generation timeout.'));
                }, 10000);
                worker.addEventListener('message', function (e) {
                  clearTimeout(timeoutId);
                  worker.terminate();

                  var _e$data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(e.data, 2),
                      err = _e$data[0],
                      result = _e$data[1];

                  if (err) {
                    reject(new Error('' + err));
                  } else {
                    resolve('' + result);
                  }
                });
                worker.postMessage([template.value, view, template.helpers]);
              }));

            case 19:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  exportToDisk: function exportToDisk(fileId, type, template) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var file, html, blob;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              file = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.file.itemsById[fileId];
              _context2.next = 3;
              return _this2.applyTemplate(fileId, template);

            case 3:
              html = _context2.sent;
              blob = new Blob([html], {
                type: 'text/plain;charset=utf-8'
              });

              __WEBPACK_IMPORTED_MODULE_4_file_saver___default.a.saveAs(blob, file.name + '.' + type);

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_githubHelper__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Provider__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__workspaceSvc__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__userSvc__ = __webpack_require__(46);










var savedSha = {};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */]({
  id: 'github',
  name: 'GitHub',
  getToken: function getToken(_ref) {
    var sub = _ref.sub;

    return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['data/githubTokensBySub'][sub];
  },
  getLocationUrl: function getLocationUrl(_ref2) {
    var owner = _ref2.owner,
        repo = _ref2.repo,
        branch = _ref2.branch,
        path = _ref2.path;

    return 'https://github.com/' + encodeURIComponent(owner) + '/' + encodeURIComponent(repo) + '/tree/' + encodeURIComponent(branch) + '/' + __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].encodeUrlPath(path);
  },
  getLocationDescription: function getLocationDescription(_ref3) {
    var path = _ref3.path;

    return path;
  },
  downloadContent: function downloadContent(token, syncLocation) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref4, sha, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_githubHelper__["a" /* default */].downloadFile(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, syncLocation, {
                token: token
              }));

            case 2:
              _ref4 = _context.sent;
              sha = _ref4.sha;
              data = _ref4.data;

              savedSha[syncLocation.id] = sha;
              return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */].parseContent(data, syncLocation.fileId + '/content'));

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  uploadContent: function uploadContent(token, content, syncLocation) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var sha;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (savedSha[syncLocation.id]) {
                _context2.next = 8;
                break;
              }

              _context2.prev = 1;
              _context2.next = 4;
              return _this2.downloadContent(token, syncLocation);

            case 4:
              _context2.next = 8;
              break;

            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2['catch'](1);

            case 8:
              sha = savedSha[syncLocation.id];

              delete savedSha[syncLocation.id];
              _context2.next = 12;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_githubHelper__["a" /* default */].uploadFile(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, syncLocation, {
                token: token,
                content: __WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */].serializeContent(content),
                sha: sha
              }));

            case 12:
              return _context2.abrupt('return', syncLocation);

            case 13:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[1, 6]]);
    }))();
  },
  publish: function publish(token, html, metadata, publishLocation) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var sha;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return _this3.downloadContent(token, publishLocation);

            case 3:
              _context3.next = 7;
              break;

            case 5:
              _context3.prev = 5;
              _context3.t0 = _context3['catch'](0);

            case 7:
              sha = savedSha[publishLocation.id];

              delete savedSha[publishLocation.id];
              _context3.next = 11;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_githubHelper__["a" /* default */].uploadFile(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, publishLocation, {
                token: token,
                content: html,
                sha: sha
              }));

            case 11:
              return _context3.abrupt('return', publishLocation);

            case 12:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 5]]);
    }))();
  },
  openFile: function openFile(token, syncLocation) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var content, name, slashPos, dotPos, item;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (__WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */].openFileWithLocation(syncLocation)) {
                _context4.next = 23;
                break;
              }

              content = void 0;
              _context4.prev = 2;
              _context4.next = 5;
              return _this4.downloadContent(token, syncLocation);

            case 5:
              content = _context4.sent;
              _context4.next = 12;
              break;

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4['catch'](2);

              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('notification/error', 'Could not open file ' + syncLocation.path + '.');
              return _context4.abrupt('return');

            case 12:
              name = syncLocation.path;
              slashPos = name.lastIndexOf('/');

              if (slashPos > -1 && slashPos < name.length - 1) {
                name = name.slice(slashPos + 1);
              }
              dotPos = name.lastIndexOf('.');

              if (dotPos > 0 && slashPos < name.length) {
                name = name.slice(0, dotPos);
              }
              _context4.next = 19;
              return __WEBPACK_IMPORTED_MODULE_7__workspaceSvc__["a" /* default */].createFile({
                name: name,
                parentId: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['file/current'].parentId,
                text: content.text,
                properties: content.properties,
                discussions: content.discussions,
                comments: content.comments
              }, true);

            case 19:
              item = _context4.sent;

              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('file/setCurrentId', item.id);
              __WEBPACK_IMPORTED_MODULE_7__workspaceSvc__["a" /* default */].addSyncLocation(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, syncLocation, {
                fileId: item.id
              }));
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('notification/info', __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['file/current'].name + ' was imported from GitHub.');

            case 23:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[2, 8]]);
    }))();
  },
  makeLocation: function makeLocation(token, owner, repo, branch, path) {
    return {
      providerId: this.id,
      sub: token.sub,
      owner: owner,
      repo: repo,
      branch: branch,
      path: path
    };
  },
  listFileRevisions: function listFileRevisions(_ref5) {
    var _this5 = this;

    var token = _ref5.token,
        syncLocation = _ref5.syncLocation;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var entries;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_githubHelper__["a" /* default */].getCommits(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, syncLocation, {
                token: token
              }));

            case 2:
              entries = _context5.sent;
              return _context5.abrupt('return', entries.map(function (_ref6) {
                var author = _ref6.author,
                    committer = _ref6.committer,
                    commit = _ref6.commit,
                    sha = _ref6.sha;

                var user = void 0;
                if (author && author.login) {
                  user = author;
                } else if (committer && committer.login) {
                  user = committer;
                }
                var sub = __WEBPACK_IMPORTED_MODULE_4__helpers_githubHelper__["a" /* default */].subPrefix + ':' + user.id;
                __WEBPACK_IMPORTED_MODULE_8__userSvc__["a" /* default */].addUserInfo({ id: sub, name: user.login, imageUrl: user.avatar_url });
                var date = commit.author && commit.author.date || commit.committer && commit.committer.date;
                return {
                  id: sha,
                  sub: sub,
                  created: date ? new Date(date).getTime() : 1
                };
              }));

            case 4:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  loadFileRevision: function loadFileRevision() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt('return', false);

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  getFileRevisionContent: function getFileRevisionContent(_ref7) {
    var _this7 = this;

    var token = _ref7.token,
        contentId = _ref7.contentId,
        syncLocation = _ref7.syncLocation,
        revisionId = _ref7.revisionId;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var _ref8, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_githubHelper__["a" /* default */].downloadFile(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, syncLocation, {
                token: token,
                branch: revisionId
              }));

            case 2:
              _ref8 = _context7.sent;
              data = _ref8.data;
              return _context7.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */].parseContent(data, contentId));

            case 5:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  }
}));

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_gitlabHelper__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Provider__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__workspaceSvc__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__userSvc__ = __webpack_require__(46);










var savedSha = {};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */]({
  id: 'gitlab',
  name: 'GitLab',
  getToken: function getToken(_ref) {
    var sub = _ref.sub;

    return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['data/gitlabTokensBySub'][sub];
  },
  getLocationUrl: function getLocationUrl(_ref2) {
    var sub = _ref2.sub,
        projectPath = _ref2.projectPath,
        branch = _ref2.branch,
        path = _ref2.path;

    var token = this.getToken({ sub: sub });
    return token.serverUrl + '/' + projectPath + '/blob/' + encodeURIComponent(branch) + '/' + __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].encodeUrlPath(path);
  },
  getLocationDescription: function getLocationDescription(_ref3) {
    var path = _ref3.path;

    return path;
  },
  downloadContent: function downloadContent(token, syncLocation) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref4, sha, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_gitlabHelper__["a" /* default */].downloadFile(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, syncLocation, {
                token: token
              }));

            case 2:
              _ref4 = _context.sent;
              sha = _ref4.sha;
              data = _ref4.data;

              savedSha[syncLocation.id] = sha;
              return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */].parseContent(data, syncLocation.fileId + '/content'));

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  uploadContent: function uploadContent(token, content, syncLocation) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var updatedSyncLocation, sha;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default.a;
              _context2.t1 = {};
              _context2.t2 = syncLocation;
              _context2.next = 5;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_gitlabHelper__["a" /* default */].getProjectId(token, syncLocation);

            case 5:
              _context2.t3 = _context2.sent;
              _context2.t4 = {
                projectId: _context2.t3
              };
              updatedSyncLocation = (0, _context2.t0)(_context2.t1, _context2.t2, _context2.t4);

              if (savedSha[updatedSyncLocation.id]) {
                _context2.next = 16;
                break;
              }

              _context2.prev = 9;
              _context2.next = 12;
              return _this2.downloadContent(token, updatedSyncLocation);

            case 12:
              _context2.next = 16;
              break;

            case 14:
              _context2.prev = 14;
              _context2.t5 = _context2['catch'](9);

            case 16:
              sha = savedSha[updatedSyncLocation.id];

              delete savedSha[updatedSyncLocation.id];
              _context2.next = 20;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_gitlabHelper__["a" /* default */].uploadFile(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, updatedSyncLocation, {
                token: token,
                content: __WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */].serializeContent(content),
                sha: sha
              }));

            case 20:
              return _context2.abrupt('return', updatedSyncLocation);

            case 21:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[9, 14]]);
    }))();
  },
  publish: function publish(token, html, metadata, publishLocation) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var updatedPublishLocation, sha;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.t0 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default.a;
              _context3.t1 = {};
              _context3.t2 = publishLocation;
              _context3.next = 5;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_gitlabHelper__["a" /* default */].getProjectId(token, publishLocation);

            case 5:
              _context3.t3 = _context3.sent;
              _context3.t4 = {
                projectId: _context3.t3
              };
              updatedPublishLocation = (0, _context3.t0)(_context3.t1, _context3.t2, _context3.t4);
              _context3.prev = 8;
              _context3.next = 11;
              return _this3.downloadContent(token, updatedPublishLocation);

            case 11:
              _context3.next = 15;
              break;

            case 13:
              _context3.prev = 13;
              _context3.t5 = _context3['catch'](8);

            case 15:
              sha = savedSha[updatedPublishLocation.id];

              delete savedSha[updatedPublishLocation.id];
              _context3.next = 19;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_gitlabHelper__["a" /* default */].uploadFile(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, updatedPublishLocation, {
                token: token,
                content: html,
                sha: sha
              }));

            case 19:
              return _context3.abrupt('return', updatedPublishLocation);

            case 20:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[8, 13]]);
    }))();
  },
  openFile: function openFile(token, syncLocation) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var updatedSyncLocation, content, name, slashPos, dotPos, item;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.t0 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default.a;
              _context4.t1 = {};
              _context4.t2 = syncLocation;
              _context4.next = 5;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_gitlabHelper__["a" /* default */].getProjectId(token, syncLocation);

            case 5:
              _context4.t3 = _context4.sent;
              _context4.t4 = {
                projectId: _context4.t3
              };
              updatedSyncLocation = (0, _context4.t0)(_context4.t1, _context4.t2, _context4.t4);

              if (__WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */].openFileWithLocation(updatedSyncLocation)) {
                _context4.next = 31;
                break;
              }

              content = void 0;
              _context4.prev = 10;
              _context4.next = 13;
              return _this4.downloadContent(token, updatedSyncLocation);

            case 13:
              content = _context4.sent;
              _context4.next = 20;
              break;

            case 16:
              _context4.prev = 16;
              _context4.t5 = _context4['catch'](10);

              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('notification/error', 'Could not open file ' + updatedSyncLocation.path + '.');
              return _context4.abrupt('return');

            case 20:
              name = updatedSyncLocation.path;
              slashPos = name.lastIndexOf('/');

              if (slashPos > -1 && slashPos < name.length - 1) {
                name = name.slice(slashPos + 1);
              }
              dotPos = name.lastIndexOf('.');

              if (dotPos > 0 && slashPos < name.length) {
                name = name.slice(0, dotPos);
              }
              _context4.next = 27;
              return __WEBPACK_IMPORTED_MODULE_7__workspaceSvc__["a" /* default */].createFile({
                name: name,
                parentId: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['file/current'].parentId,
                text: content.text,
                properties: content.properties,
                discussions: content.discussions,
                comments: content.comments
              }, true);

            case 27:
              item = _context4.sent;

              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('file/setCurrentId', item.id);
              __WEBPACK_IMPORTED_MODULE_7__workspaceSvc__["a" /* default */].addSyncLocation(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, updatedSyncLocation, {
                fileId: item.id
              }));
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('notification/info', __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['file/current'].name + ' was imported from GitLab.');

            case 31:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[10, 16]]);
    }))();
  },
  makeLocation: function makeLocation(token, projectPath, branch, path) {
    return {
      providerId: this.id,
      sub: token.sub,
      projectPath: projectPath,
      branch: branch,
      path: path
    };
  },
  listFileRevisions: function listFileRevisions(_ref5) {
    var _this5 = this;

    var token = _ref5.token,
        syncLocation = _ref5.syncLocation;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var entries;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_gitlabHelper__["a" /* default */].getCommits(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, syncLocation, {
                token: token
              }));

            case 2:
              entries = _context5.sent;
              return _context5.abrupt('return', entries.map(function (entry) {
                var email = entry.author_email || entry.committer_email;
                var sub = __WEBPACK_IMPORTED_MODULE_4__helpers_gitlabHelper__["a" /* default */].subPrefix + ':' + token.serverUrl + '/' + email;
                __WEBPACK_IMPORTED_MODULE_8__userSvc__["a" /* default */].addUserInfo({
                  id: sub,
                  name: entry.author_name || entry.committer_name,
                  imageUrl: ''
                });
                var date = entry.authored_date || entry.committed_date || 1;
                return {
                  id: entry.id,
                  sub: sub,
                  created: date ? new Date(date).getTime() : 1
                };
              }));

            case 4:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  loadFileRevision: function loadFileRevision() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt('return', false);

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  getFileRevisionContent: function getFileRevisionContent(_ref6) {
    var _this7 = this;

    var token = _ref6.token,
        contentId = _ref6.contentId,
        syncLocation = _ref6.syncLocation,
        revisionId = _ref6.revisionId;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var _ref7, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_gitlabHelper__["a" /* default */].downloadFile(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, syncLocation, {
                token: token,
                branch: revisionId
              }));

            case 2:
              _ref7 = _context7.sent;
              data = _ref7.data;
              return _context7.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */].parseContent(data, contentId));

            case 5:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  }
}));

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__networkSvc__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__userSvc__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__badgeSvc__ = __webpack_require__(11);







var _this = this;






var getAppKey = function getAppKey(fullAccess) {
  if (fullAccess) {
    return __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters['data/serverConf'].dropboxAppKeyFull;
  }
  return __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters['data/serverConf'].dropboxAppKey;
};

var httpHeaderSafeJson = function httpHeaderSafeJson(args) {
  return args && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(args).replace(/[\u007f-\uffff]/g, function (c) {
    return '\\u' + ('000' + c.charCodeAt(0).toString(16)).slice(-4);
  });
};

var request = function request(_ref, options, args) {
  var accessToken = _ref.accessToken;
  return __WEBPACK_IMPORTED_MODULE_6__networkSvc__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, options, {
    headers: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, options.headers || {}, {
      'Content-Type': options.body && (typeof options.body === 'string' ? 'application/octet-stream' : 'application/json; charset=utf-8'),
      'Dropbox-API-Arg': httpHeaderSafeJson(args),
      Authorization: 'Bearer ' + accessToken
    })
  }));
};

var subPrefix = 'db';
__WEBPACK_IMPORTED_MODULE_7__userSvc__["a" /* default */].setInfoResolver('dropbox', subPrefix, function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(sub) {
    var dropboxToken, _ref3, body;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            dropboxToken = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters['data/dropboxTokensBySub'])[0];
            _context.prev = 1;
            _context.next = 4;
            return request(dropboxToken, {
              method: 'POST',
              url: 'https://api.dropboxapi.com/2/users/get_account',
              body: {
                account_id: sub
              }
            });

          case 4:
            _ref3 = _context.sent;
            body = _ref3.body;
            return _context.abrupt('return', {
              id: subPrefix + ':' + body.account_id,
              name: body.name.display_name,
              imageUrl: body.profile_photo_url || ''
            });

          case 9:
            _context.prev = 9;
            _context.t0 = _context['catch'](1);

            if (!(!dropboxToken || _context.t0.status !== 404)) {
              _context.next = 13;
              break;
            }

            throw new Error('RETRY');

          case 13:
            throw _context.t0;

          case 14:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[1, 9]]);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}());

/* harmony default export */ __webpack_exports__["a"] = ({
  subPrefix: subPrefix,

  startOauth2: function startOauth2(fullAccess) {
    var _this2 = this;

    var sub = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _ref4, accessToken, _ref5, body, token;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_6__networkSvc__["a" /* default */].startOauth2('https://www.dropbox.com/oauth2/authorize', {
                client_id: getAppKey(fullAccess),
                response_type: 'token'
              }, silent);

            case 2:
              _ref4 = _context2.sent;
              accessToken = _ref4.accessToken;
              _context2.next = 6;
              return request({ accessToken: accessToken }, {
                method: 'POST',
                url: 'https://api.dropboxapi.com/2/users/get_current_account'
              });

            case 6:
              _ref5 = _context2.sent;
              body = _ref5.body;

              __WEBPACK_IMPORTED_MODULE_7__userSvc__["a" /* default */].addUserInfo({
                id: subPrefix + ':' + body.account_id,
                name: body.name.display_name,
                imageUrl: body.profile_photo_url || ''
              });

              if (!(sub && '' + body.account_id !== sub)) {
                _context2.next = 11;
                break;
              }

              throw new Error('Dropbox account ID not expected.');

            case 11:
              token = {
                accessToken: accessToken,
                name: body.name.display_name,
                sub: '' + body.account_id,
                fullAccess: fullAccess
              };

              __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].dispatch('data/addDropboxToken', token);
              return _context2.abrupt('return', token);

            case 14:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  addAccount: function addAccount() {
    var _this3 = this;

    var fullAccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var token;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.startOauth2(fullAccess);

            case 2:
              token = _context3.sent;

              __WEBPACK_IMPORTED_MODULE_9__badgeSvc__["a" /* default */].addBadge('addDropboxAccount');
              return _context3.abrupt('return', token);

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  uploadFile: function uploadFile(_ref6) {
    var _this4 = this;

    var token = _ref6.token,
        path = _ref6.path,
        content = _ref6.content,
        fileId = _ref6.fileId;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return request(token, {
                method: 'POST',
                url: 'https://content.dropboxapi.com/2/files/upload',
                body: content
              }, {
                path: fileId || path,
                mode: 'overwrite'
              });

            case 2:
              return _context4.abrupt('return', _context4.sent.body);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  downloadFile: function downloadFile(_ref7) {
    var _this5 = this;

    var token = _ref7.token,
        path = _ref7.path,
        fileId = _ref7.fileId;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return request(token, {
                method: 'POST',
                url: 'https://content.dropboxapi.com/2/files/download',
                raw: true
              }, {
                path: fileId || path
              });

            case 2:
              res = _context5.sent;
              return _context5.abrupt('return', {
                id: JSON.parse(res.headers['dropbox-api-result']).id,
                content: res.body
              });

            case 4:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  listRevisions: function listRevisions(_ref8) {
    var _this6 = this;

    var token = _ref8.token,
        path = _ref8.path,
        fileId = _ref8.fileId;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return request(token, {
                method: 'POST',
                url: 'https://api.dropboxapi.com/2/files/list_revisions',
                body: fileId ? {
                  path: fileId,
                  mode: 'id',
                  limit: 100
                } : {
                  path: path,
                  limit: 100
                }
              });

            case 2:
              res = _context6.sent;
              return _context6.abrupt('return', res.body.entries);

            case 4:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  openChooser: function openChooser(token) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (window.Dropbox) {
                _context7.next = 3;
                break;
              }

              _context7.next = 3;
              return __WEBPACK_IMPORTED_MODULE_6__networkSvc__["a" /* default */].loadScript('https://www.dropbox.com/static/api/2/dropins.js');

            case 3:
              return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                window.Dropbox.appKey = getAppKey(token.fullAccess);
                window.Dropbox.choose({
                  multiselect: true,
                  linkType: 'direct',
                  success: function success(files) {
                    return resolve(files.map(function (file) {
                      var path = file.link.replace(/.*\/view\/[^/]*/, '');
                      return decodeURI(path);
                    }));
                  },
                  cancel: function cancel() {
                    return resolve([]);
                  }
                });
              }));

            case 4:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  }
});

/***/ }),
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserImage_vue_vue_type_template_id_2fb33b9e___ = __webpack_require__(2396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserImage_vue_vue_type_script_lang_js___ = __webpack_require__(875);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserImage_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__UserImage_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__UserImage_vue_vue_type_template_id_2fb33b9e___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__UserImage_vue_vue_type_template_id_2fb33b9e___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserImage.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 303 */,
/* 304 */,
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_editor_cledit__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_utils__ = __webpack_require__(4);







var savedSelection = null;
var nextTickCbs = [];
var nextTickExecCbs = __WEBPACK_IMPORTED_MODULE_3__services_editor_cledit__["a" /* default */].Utils.debounce(function () {
  while (nextTickCbs.length) {
    nextTickCbs.shift()();
  }
  if (savedSelection) {
    __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].clEditor.selectionMgr.setSelectionStartEnd(savedSelection.start, savedSelection.end);
  }
  savedSelection = null;
});

var nextTick = function nextTick(cb) {
  nextTickCbs.push(cb);
  nextTickExecCbs();
};

var nextTickRestoreSelection = function nextTickRestoreSelection() {
  savedSelection = {
    start: __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].clEditor.selectionMgr.selectionStart,
    end: __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].clEditor.selectionMgr.selectionEnd
  };
  nextTickExecCbs();
};

var EditorClassApplier = function () {
  function EditorClassApplier(classGetter, offsetGetter, properties) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, EditorClassApplier);

    this.classGetter = typeof classGetter === 'function' ? classGetter : function () {
      return classGetter;
    };
    this.offsetGetter = typeof offsetGetter === 'function' ? offsetGetter : function () {
      return offsetGetter;
    };
    this.properties = properties || {};
    this.eltCollection = __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].editorElt.getElementsByClassName(this.classGetter()[0]);
    this.lastEltCount = this.eltCollection.length;

    this.restoreClass = function () {
      if (!_this.eltCollection.length || _this.eltCollection.length !== _this.lastEltCount) {
        _this.removeClass();
        _this.applyClass();
      }
    };

    __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].clEditor.on('contentChanged', this.restoreClass);
    nextTick(function () {
      return _this.restoreClass();
    });
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(EditorClassApplier, [{
    key: 'applyClass',
    value: function applyClass() {
      if (!this.stopped) {
        var offset = this.offsetGetter();
        if (offset && offset.start !== offset.end) {
          var range = __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].clEditor.selectionMgr.createRange(Math.min(offset.start, offset.end), Math.max(offset.start, offset.end));
          var properties = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.properties, {
            className: this.classGetter().join(' ')
          });
          __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].clEditor.watcher.noWatch(function () {
            __WEBPACK_IMPORTED_MODULE_5__services_utils__["a" /* default */].wrapRange(range, properties);
          });
          if (__WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].clEditor.selectionMgr.hasFocus()) {
            nextTickRestoreSelection();
          }
          this.lastEltCount = this.eltCollection.length;
        }
      }
    }
  }, {
    key: 'removeClass',
    value: function removeClass() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].clEditor.watcher.noWatch(function () {
        __WEBPACK_IMPORTED_MODULE_5__services_utils__["a" /* default */].unwrapRange(_this2.eltCollection);
      });
      if (__WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].clEditor.selectionMgr.hasFocus()) {
        nextTickRestoreSelection();
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].clEditor.off('contentChanged', this.restoreClass);
      nextTick(function () {
        return _this3.removeClass();
      });
      this.stopped = true;
    }
  }]);

  return EditorClassApplier;
}();

/* harmony default export */ __webpack_exports__["a"] = (EditorClassApplier);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_dropboxHelper__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Provider__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__workspaceSvc__ = __webpack_require__(36);









var makePathAbsolute = function makePathAbsolute(token, path) {
  if (!token.fullAccess) {
    return '/Applications/StackEdit (restricted)' + path;
  }
  return path;
};
var makePathRelative = function makePathRelative(token, path) {
  if (!token.fullAccess) {
    return path.replace(/^\/Applications\/StackEdit \(restricted\)/, '');
  }
  return path;
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */]({
  id: 'dropbox',
  name: 'Dropbox',
  getToken: function getToken(_ref) {
    var sub = _ref.sub;

    return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['data/dropboxTokensBySub'][sub];
  },
  getLocationUrl: function getLocationUrl(_ref2) {
    var path = _ref2.path;

    var pathComponents = path.split('/').map(encodeURIComponent);
    var filename = pathComponents.pop();
    return 'https://www.dropbox.com/home' + pathComponents.join('/') + '?preview=' + filename;
  },
  getLocationDescription: function getLocationDescription(_ref3) {
    var path = _ref3.path,
        dropboxFileId = _ref3.dropboxFileId;

    return dropboxFileId || path;
  },
  checkPath: function checkPath(path) {
    return path && path.match(/^\/[^\\<>:"|?*]+$/);
  },
  downloadContent: function downloadContent(token, syncLocation) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref4, content;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_dropboxHelper__["a" /* default */].downloadFile({
                token: token,
                path: makePathRelative(token, syncLocation.path),
                fileId: syncLocation.dropboxFileId
              });

            case 2:
              _ref4 = _context.sent;
              content = _ref4.content;
              return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */].parseContent(content, syncLocation.fileId + '/content'));

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  uploadContent: function uploadContent(token, content, syncLocation) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var dropboxFile;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_dropboxHelper__["a" /* default */].uploadFile({
                token: token,
                path: makePathRelative(token, syncLocation.path),
                content: __WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */].serializeContent(content),
                fileId: syncLocation.dropboxFileId
              });

            case 2:
              dropboxFile = _context2.sent;
              return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, syncLocation, {
                path: makePathAbsolute(token, dropboxFile.path_display),
                dropboxFileId: dropboxFile.id
              }));

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  publish: function publish(token, html, metadata, publishLocation) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var dropboxFile;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_dropboxHelper__["a" /* default */].uploadFile({
                token: token,
                path: publishLocation.path,
                content: html,
                fileId: publishLocation.dropboxFileId
              });

            case 2:
              dropboxFile = _context3.sent;
              return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, publishLocation, {
                path: makePathAbsolute(token, dropboxFile.path_display),
                dropboxFileId: dropboxFile.id
              }));

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  openFiles: function openFiles(token, paths) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].awaitSequence(paths, function () {
                var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(path) {
                  var syncLocation, content, name, slashPos, dotPos, item;
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          if (__WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */].openFileWithLocation({
                            providerId: _this4.id,
                            path: path
                          })) {
                            _context4.next = 24;
                            break;
                          }

                          syncLocation = {
                            path: path,
                            providerId: _this4.id,
                            sub: token.sub
                          };
                          content = void 0;
                          _context4.prev = 3;
                          _context4.next = 6;
                          return _this4.downloadContent(token, syncLocation);

                        case 6:
                          content = _context4.sent;
                          _context4.next = 13;
                          break;

                        case 9:
                          _context4.prev = 9;
                          _context4.t0 = _context4['catch'](3);

                          __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('notification/error', 'Could not open file ' + path + '.');
                          return _context4.abrupt('return');

                        case 13:
                          name = path;
                          slashPos = name.lastIndexOf('/');

                          if (slashPos > -1 && slashPos < name.length - 1) {
                            name = name.slice(slashPos + 1);
                          }
                          dotPos = name.lastIndexOf('.');

                          if (dotPos > 0 && slashPos < name.length) {
                            name = name.slice(0, dotPos);
                          }
                          _context4.next = 20;
                          return __WEBPACK_IMPORTED_MODULE_7__workspaceSvc__["a" /* default */].createFile({
                            name: name,
                            parentId: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['file/current'].parentId,
                            text: content.text,
                            properties: content.properties,
                            discussions: content.discussions,
                            comments: content.comments
                          }, true);

                        case 20:
                          item = _context4.sent;

                          __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('file/setCurrentId', item.id);
                          __WEBPACK_IMPORTED_MODULE_7__workspaceSvc__["a" /* default */].addSyncLocation(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, syncLocation, {
                            fileId: item.id
                          }));
                          __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('notification/info', __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['file/current'].name + ' was imported from Dropbox.');

                        case 24:
                        case 'end':
                          return _context4.stop();
                      }
                    }
                  }, _callee4, _this4, [[3, 9]]);
                }));

                return function (_x) {
                  return _ref5.apply(this, arguments);
                };
              }());

            case 2:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this4);
    }))();
  },
  makeLocation: function makeLocation(token, path) {
    return {
      providerId: this.id,
      sub: token.sub,
      path: path
    };
  },
  listFileRevisions: function listFileRevisions(_ref6) {
    var _this5 = this;

    var token = _ref6.token,
        syncLocation = _ref6.syncLocation;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var entries;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_dropboxHelper__["a" /* default */].listRevisions({
                token: token,
                path: makePathRelative(token, syncLocation.path),
                fileId: syncLocation.dropboxFileId
              });

            case 2:
              entries = _context6.sent;
              return _context6.abrupt('return', entries.map(function (entry) {
                return {
                  id: entry.rev,
                  sub: __WEBPACK_IMPORTED_MODULE_4__helpers_dropboxHelper__["a" /* default */].subPrefix + ':' + ((entry.sharing_info || {}).modified_by || token.sub),
                  created: new Date(entry.server_modified).getTime()
                };
              }));

            case 4:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this5);
    }))();
  },
  loadFileRevision: function loadFileRevision() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt('return', false);

            case 1:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this6);
    }))();
  },
  getFileRevisionContent: function getFileRevisionContent(_ref7) {
    var _this7 = this;

    var token = _ref7.token,
        contentId = _ref7.contentId,
        revisionId = _ref7.revisionId;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var _ref8, content;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_dropboxHelper__["a" /* default */].downloadFile({
                token: token,
                path: 'rev:' + revisionId
              });

            case 2:
              _ref8 = _context8.sent;
              content = _ref8.content;
              return _context8.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */].parseContent(content, contentId));

            case 5:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this7);
    }))();
  }
}));

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_googleHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Provider__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__workspaceSvc__ = __webpack_require__(36);









/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */]({
  id: 'googleDrive',
  name: 'Google Drive',
  getToken: function getToken(_ref) {
    var sub = _ref.sub;

    var token = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['data/googleTokensBySub'][sub];
    return token && token.isDrive ? token : null;
  },
  getLocationUrl: function getLocationUrl(_ref2) {
    var driveFileId = _ref2.driveFileId;

    return 'https://docs.google.com/file/d/' + driveFileId + '/edit';
  },
  getLocationDescription: function getLocationDescription(_ref3) {
    var driveFileId = _ref3.driveFileId;

    return driveFileId;
  },
  initAction: function initAction() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var state, token, openWorkspaceIfExists, folder;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = __WEBPACK_IMPORTED_MODULE_4__helpers_googleHelper__["a" /* default */].driveState || {};

              if (!state.userId) {
                _context2.next = 31;
                break;
              }

              token = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['data/googleTokensBySub'][state.userId];

              if (!(!token || !token.isDrive)) {
                _context2.next = 9;
                break;
              }

              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('modal/open', { type: 'googleDriveAccount' });

            case 6:
              _context2.next = 8;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_googleHelper__["a" /* default */].addDriveAccount(!__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['data/localSettings'].googleDriveRestrictedAccess, state.userId);

            case 8:
              token = _context2.sent;

            case 9:
              openWorkspaceIfExists = function openWorkspaceIfExists(file) {
                var folderId = file && file.appProperties && file.appProperties.folderId;
                if (folderId) {
                  var workspaceParams = {
                    providerId: 'googleDriveWorkspace',
                    folderId: folderId
                  };
                  var workspaceId = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].makeWorkspaceId(workspaceParams);
                  var workspace = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['workspace/workspacesById'][workspaceId];

                  if (workspace) {
                    __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].setQueryParams(workspaceParams);
                  }
                }
              };

              _context2.t0 = state.action;
              _context2.next = _context2.t0 === 'create' ? 13 : _context2.t0 === 'open' ? 28 : 13;
              break;

            case 13:
              _context2.prev = 13;
              _context2.next = 16;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_googleHelper__["a" /* default */].getFile(token, state.folderId);

            case 16:
              folder = _context2.sent;

              folder.appProperties = folder.appProperties || {};
              __WEBPACK_IMPORTED_MODULE_4__helpers_googleHelper__["a" /* default */].driveActionFolder = folder;
              openWorkspaceIfExists(folder);
              _context2.next = 27;
              break;

            case 22:
              _context2.prev = 22;
              _context2.t1 = _context2['catch'](13);

              if (!(!_context2.t1 || _context2.t1.status !== 404)) {
                _context2.next = 26;
                break;
              }

              throw _context2.t1;

            case 26:
              __WEBPACK_IMPORTED_MODULE_4__helpers_googleHelper__["a" /* default */].driveActionFolder = { id: state.folderId };

            case 27:
              return _context2.abrupt('break', 31);

            case 28:
              _context2.next = 30;
              return __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].awaitSequence(state.ids || [], function () {
                var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(id) {
                  var file;
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return __WEBPACK_IMPORTED_MODULE_4__helpers_googleHelper__["a" /* default */].getFile(token, id);

                        case 2:
                          file = _context.sent;

                          file.appProperties = file.appProperties || {};
                          __WEBPACK_IMPORTED_MODULE_4__helpers_googleHelper__["a" /* default */].driveActionFiles.push(file);

                        case 5:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this);
                }));

                return function (_x) {
                  return _ref4.apply(this, arguments);
                };
              }());

            case 30:
              openWorkspaceIfExists(__WEBPACK_IMPORTED_MODULE_4__helpers_googleHelper__["a" /* default */].driveActionFiles[0]);

            case 31:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[13, 22]]);
    }))();
  },
  performAction: function performAction() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var state, token, file;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state = __WEBPACK_IMPORTED_MODULE_4__helpers_googleHelper__["a" /* default */].driveState || {};
              token = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['data/googleTokensBySub'][state.userId];
              _context3.t0 = token && state.action;
              _context3.next = _context3.t0 === 'create' ? 5 : _context3.t0 === 'open' ? 10 : 12;
              break;

            case 5:
              _context3.next = 7;
              return __WEBPACK_IMPORTED_MODULE_7__workspaceSvc__["a" /* default */].createFile({}, true);

            case 7:
              file = _context3.sent;

              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('file/setCurrentId', file.id);
              return _context3.abrupt('return', _this2.makeLocation(token, null, __WEBPACK_IMPORTED_MODULE_4__helpers_googleHelper__["a" /* default */].driveActionFolder.id));

            case 10:
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('queue/enqueue', function () {
                return _this2.openFiles(token, __WEBPACK_IMPORTED_MODULE_4__helpers_googleHelper__["a" /* default */].driveActionFiles);
              });
              return _context3.abrupt('return', null);

            case 12:
              return _context3.abrupt('return', null);

            case 13:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }))();
  },
  downloadContent: function downloadContent(token, syncLocation) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var content;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_googleHelper__["a" /* default */].downloadFile(token, syncLocation.driveFileId);

            case 2:
              content = _context4.sent;
              return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */].parseContent(content, syncLocation.fileId + '/content'));

            case 4:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this3);
    }))();
  },
  uploadContent: function uploadContent(token, content, syncLocation, ifNotTooLate) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var file, name, parents, driveFile;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              file = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.file.itemsById[syncLocation.fileId];
              name = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].sanitizeName(file && file.name);
              parents = [];

              if (syncLocation.driveParentId) {
                parents.push(syncLocation.driveParentId);
              }
              _context5.next = 6;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_googleHelper__["a" /* default */].uploadFile({
                token: token,
                name: name,
                parents: parents,
                media: __WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */].serializeContent(content),
                fileId: syncLocation.driveFileId,
                ifNotTooLate: ifNotTooLate
              });

            case 6:
              driveFile = _context5.sent;
              return _context5.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, syncLocation, {
                driveFileId: driveFile.id
              }));

            case 8:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this4);
    }))();
  },
  publish: function publish(token, html, metadata, publishLocation) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var driveFile;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_googleHelper__["a" /* default */].uploadFile({
                token: token,
                name: metadata.title,
                parents: [],
                media: html,
                mediaType: publishLocation.templateId ? 'text/html' : undefined,
                fileId: publishLocation.driveFileId
              });

            case 2:
              driveFile = _context6.sent;
              return _context6.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, publishLocation, {
                driveFileId: driveFile.id
              }));

            case 4:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this5);
    }))();
  },
  openFiles: function openFiles(token, driveFiles) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt('return', __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].awaitSequence(driveFiles, function () {
                var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7(driveFile) {
                  var syncLocation, content, item;
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          if (__WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */].openFileWithLocation({
                            providerId: _this6.id,
                            driveFileId: driveFile.id
                          })) {
                            _context7.next = 19;
                            break;
                          }

                          syncLocation = {
                            driveFileId: driveFile.id,
                            providerId: _this6.id,
                            sub: token.sub
                          };
                          content = void 0;
                          _context7.prev = 3;
                          _context7.next = 6;
                          return _this6.downloadContent(token, syncLocation);

                        case 6:
                          content = _context7.sent;
                          _context7.next = 13;
                          break;

                        case 9:
                          _context7.prev = 9;
                          _context7.t0 = _context7['catch'](3);

                          __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('notification/error', 'Could not open file ' + driveFile.id + '.');
                          return _context7.abrupt('return');

                        case 13:
                          _context7.next = 15;
                          return __WEBPACK_IMPORTED_MODULE_7__workspaceSvc__["a" /* default */].createFile({
                            name: driveFile.name,
                            parentId: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['file/current'].parentId,
                            text: content.text,
                            properties: content.properties,
                            discussions: content.discussions,
                            comments: content.comments
                          }, true);

                        case 15:
                          item = _context7.sent;

                          __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('file/setCurrentId', item.id);
                          __WEBPACK_IMPORTED_MODULE_7__workspaceSvc__["a" /* default */].addSyncLocation(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, syncLocation, {
                            fileId: item.id
                          }));
                          __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('notification/info', __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['file/current'].name + ' was imported from Google Drive.');

                        case 19:
                        case 'end':
                          return _context7.stop();
                      }
                    }
                  }, _callee7, _this6, [[3, 9]]);
                }));

                return function (_x2) {
                  return _ref5.apply(this, arguments);
                };
              }()));

            case 1:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this6);
    }))();
  },
  makeLocation: function makeLocation(token, fileId, folderId) {
    var location = {
      providerId: this.id,
      sub: token.sub
    };
    if (fileId) {
      location.driveFileId = fileId;
    }
    if (folderId) {
      location.driveParentId = folderId;
    }
    return location;
  },
  listFileRevisions: function listFileRevisions(_ref6) {
    var _this7 = this;

    var token = _ref6.token,
        syncLocation = _ref6.syncLocation;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
      var revisions;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_googleHelper__["a" /* default */].getFileRevisions(token, syncLocation.driveFileId);

            case 2:
              revisions = _context9.sent;
              return _context9.abrupt('return', revisions.map(function (revision) {
                return {
                  id: revision.id,
                  sub: __WEBPACK_IMPORTED_MODULE_4__helpers_googleHelper__["a" /* default */].subPrefix + ':' + revision.lastModifyingUser.permissionId,
                  created: new Date(revision.modifiedTime).getTime()
                };
              }));

            case 4:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this7);
    }))();
  },
  loadFileRevision: function loadFileRevision() {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt('return', false);

            case 1:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this8);
    }))();
  },
  getFileRevisionContent: function getFileRevisionContent(_ref7) {
    var _this9 = this;

    var token = _ref7.token,
        contentId = _ref7.contentId,
        syncLocation = _ref7.syncLocation,
        revisionId = _ref7.revisionId;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
      var content;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_googleHelper__["a" /* default */].downloadFileRevision(token, syncLocation.driveFileId, revisionId);

            case 2:
              content = _context11.sent;
              return _context11.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */].parseContent(content, contentId));

            case 4:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this9);
    }))();
  }
}));

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__networkSvc__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__badgeSvc__ = __webpack_require__(11);







var tokenExpirationMargin = 5 * 60 * 1000;

var request = function request(token, options) {
  return __WEBPACK_IMPORTED_MODULE_3__networkSvc__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, options, {
    headers: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, options.headers || {}, {
      Authorization: 'Bearer ' + token.accessToken
    })
  })).then(function (res) {
    return res.body;
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  startOauth2: function startOauth2() {
    var _this = this;

    var sub = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var clientId, _ref, accessToken, expiresIn, body, token;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              clientId = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['data/serverConf'].wordpressClientId;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__networkSvc__["a" /* default */].startOauth2('https://public-api.wordpress.com/oauth2/authorize', {
                client_id: clientId,
                response_type: 'token',
                scope: 'global'
              }, silent);

            case 3:
              _ref = _context.sent;
              accessToken = _ref.accessToken;
              expiresIn = _ref.expiresIn;
              _context.next = 8;
              return request({ accessToken: accessToken }, {
                url: 'https://public-api.wordpress.com/rest/v1.1/me'
              });

            case 8:
              body = _context.sent;

              if (!(sub && '' + body.ID !== sub)) {
                _context.next = 11;
                break;
              }

              throw new Error('WordPress account ID not expected.');

            case 11:
              token = {
                accessToken: accessToken,
                expiresOn: Date.now() + expiresIn * 1000,
                name: body.display_name,
                sub: '' + body.ID
              };

              __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('data/addWordpressToken', token);
              return _context.abrupt('return', token);

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  refreshToken: function refreshToken(token) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var sub, lastToken;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              sub = token.sub;
              lastToken = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['data/wordpressTokensBySub'][sub];

              if (!(lastToken.expiresOn > Date.now() + tokenExpirationMargin)) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt('return', lastToken);

            case 4:
              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('modal/open', {
                type: 'providerRedirection',
                name: 'WordPress'
              });

            case 6:
              return _context2.abrupt('return', _this2.startOauth2(sub));

            case 7:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  addAccount: function addAccount() {
    var _this3 = this;

    var fullAccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var token;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.startOauth2(fullAccess);

            case 2:
              token = _context3.sent;

              __WEBPACK_IMPORTED_MODULE_5__badgeSvc__["a" /* default */].addBadge('addWordpressAccount');
              return _context3.abrupt('return', token);

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  uploadPost: function uploadPost(_ref2) {
    var _this4 = this;

    var token = _ref2.token,
        domain = _ref2.domain,
        siteId = _ref2.siteId,
        postId = _ref2.postId,
        title = _ref2.title,
        content = _ref2.content,
        tags = _ref2.tags,
        categories = _ref2.categories,
        excerpt = _ref2.excerpt,
        author = _ref2.author,
        featuredImage = _ref2.featuredImage,
        status = _ref2.status,
        date = _ref2.date;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var refreshedToken;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this4.refreshToken(token);

            case 2:
              refreshedToken = _context4.sent;
              return _context4.abrupt('return', request(refreshedToken, {
                method: 'POST',
                url: 'https://public-api.wordpress.com/rest/v1.2/sites/' + (siteId || domain) + '/posts/' + (postId || 'new'),
                body: {
                  content: content,
                  title: title,
                  tags: tags,
                  categories: categories,
                  excerpt: excerpt,
                  author: author,
                  featured_image: featuredImage || '',
                  status: status,
                  date: date && date.toISOString()
                }
              }));

            case 4:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__networkSvc__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__badgeSvc__ = __webpack_require__(11);







var request = function request(token, options) {
  return __WEBPACK_IMPORTED_MODULE_3__networkSvc__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, options, {
    headers: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, options.headers || {}, {
      Authorization: 'Bearer ' + token.accessToken
    })
  })).then(function (res) {
    return res.body;
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  startOauth2: function startOauth2(subdomain, clientId) {
    var _this = this;

    var sub = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var silent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, accessToken, _ref2, user, uniqueSub, token;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3__networkSvc__["a" /* default */].startOauth2('https://' + subdomain + '.zendesk.com/oauth/authorizations/new', {
                client_id: clientId,
                response_type: 'token',
                scope: 'read hc:write'
              }, silent);

            case 2:
              _ref = _context.sent;
              accessToken = _ref.accessToken;
              _context.next = 6;
              return request({ accessToken: accessToken }, {
                url: 'https://' + subdomain + '.zendesk.com/api/v2/users/me.json'
              });

            case 6:
              _ref2 = _context.sent;
              user = _ref2.user;
              uniqueSub = subdomain + '/' + user.id;

              if (!(sub && uniqueSub !== sub)) {
                _context.next = 11;
                break;
              }

              throw new Error('Zendesk account ID not expected.');

            case 11:
              token = {
                accessToken: accessToken,
                name: user.name,
                subdomain: subdomain,
                sub: uniqueSub
              };

              __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('data/addZendeskToken', token);
              return _context.abrupt('return', token);

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  addAccount: function addAccount(subdomain, clientId) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var token;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.startOauth2(subdomain, clientId);

            case 2:
              token = _context2.sent;

              __WEBPACK_IMPORTED_MODULE_5__badgeSvc__["a" /* default */].addBadge('addZendeskAccount');
              return _context2.abrupt('return', token);

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  uploadArticle: function uploadArticle(_ref3) {
    var _this3 = this;

    var token = _ref3.token,
        sectionId = _ref3.sectionId,
        articleId = _ref3.articleId,
        title = _ref3.title,
        content = _ref3.content,
        labels = _ref3.labels,
        locale = _ref3.locale,
        isDraft = _ref3.isDraft;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var article, body;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              article = {
                title: title,
                body: content,
                locale: locale,
                draft: isDraft
              };

              if (!articleId) {
                _context3.next = 8;
                break;
              }

              _context3.next = 4;
              return request(token, {
                method: 'PUT',
                url: 'https://' + token.subdomain + '.zendesk.com/api/v2/help_center/articles/' + articleId + '/translations/' + locale + '.json',
                body: { translation: article }
              });

            case 4:
              if (!labels) {
                _context3.next = 7;
                break;
              }

              _context3.next = 7;
              return request(token, {
                method: 'PUT',
                url: 'https://' + token.subdomain + '.zendesk.com/api/v2/help_center/articles/' + articleId + '.json',
                body: {
                  article: {
                    label_names: labels
                  }
                }
              });

            case 7:
              return _context3.abrupt('return', articleId);

            case 8:
              if (labels) {
                article.label_names = labels;
              }
              _context3.next = 11;
              return request(token, {
                method: 'POST',
                url: 'https://' + token.subdomain + '.zendesk.com/api/v2/help_center/sections/' + sectionId + '/articles.json',
                body: { article: article }
              });

            case 11:
              body = _context3.sent;
              return _context3.abrupt('return', '' + body.article.id);

            case 13:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editor_cledit__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__editorSvc__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__workspaceSvc__ = __webpack_require__(36);










var _utils$queryParams = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].queryParams,
    origin = _utils$queryParams.origin,
    fileName = _utils$queryParams.fileName,
    contentText = _utils$queryParams.contentText,
    contentProperties = _utils$queryParams.contentProperties;

var isLight = origin && window.parent;

/* harmony default export */ __webpack_exports__["a"] = ({
  setReady: function setReady() {
    if (isLight) {
      setTimeout(function () {
        return window.parent.postMessage({ type: 'ready' }, origin);
      }, 1);
    }
  },

  closed: false,
  close: function close() {
    if (isLight) {
      if (!this.closed) {
        window.parent.postMessage({ type: 'close' }, origin);
      }
      this.closed = true;
    }
  },
  init: function init() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var file, lastCreated, fileItemsById, onChange;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (isLight) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return');

            case 2:
              __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('setLight', true);

              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_8__workspaceSvc__["a" /* default */].createFile({
                name: fileName || __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].getHostname(origin),
                text: contentText || '\n',
                properties: contentProperties,
                parentId: 'temp'
              }, true);

            case 5:
              file = _context.sent;
              lastCreated = {};
              fileItemsById = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.file.itemsById;

              __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['data/lastCreated']).forEach(function (_ref) {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                    id = _ref2[0],
                    value = _ref2[1];

                if (fileItemsById[id] && fileItemsById[id].parentId === 'temp') {
                  lastCreated[id] = value;
                }
              });

              lastCreated[file.id] = {
                created: Date.now()
              };

              __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(lastCreated).sort(function (_ref3, _ref4) {
                var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
                    value1 = _ref6[1];

                var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref4, 2),
                    value2 = _ref5[1];

                return value2.created - value1.created;
              }).splice(10).forEach(function (_ref7) {
                var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref7, 1),
                    id = _ref8[0];

                delete lastCreated[id];
                __WEBPACK_IMPORTED_MODULE_8__workspaceSvc__["a" /* default */].deleteFile(id);
              });

              __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('data/setLastCreated', lastCreated);
              __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('file/setCurrentId', file.id);

              onChange = __WEBPACK_IMPORTED_MODULE_4__editor_cledit__["a" /* default */].Utils.debounce(function () {
                var currentFile = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['file/current'];
                if (currentFile.id !== file.id) {
                  _this.close();
                } else if (!_this.closed && __WEBPACK_IMPORTED_MODULE_7__editorSvc__["a" /* default */].previewCtx.html != null) {
                  var content = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['content/current'];
                  var properties = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].computeProperties(content.properties);
                  window.parent.postMessage({
                    type: 'fileChange',
                    payload: {
                      id: file.id,
                      name: currentFile.name,
                      content: {
                        text: content.text.slice(0, -1),
                        properties: properties,
                        yamlProperties: content.properties,
                        html: __WEBPACK_IMPORTED_MODULE_7__editorSvc__["a" /* default */].previewCtx.html
                      }
                    }
                  }, origin);
                }
              }, 25);

              __WEBPACK_IMPORTED_MODULE_7__editorSvc__["a" /* default */].$on('previewCtx', onChange);
              __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].watch(function () {
                return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['file/current'].name;
              }, onChange);

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CodeEditor_vue_vue_type_template_id_263a5b36___ = __webpack_require__(2380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CodeEditor_vue_vue_type_script_lang_js___ = __webpack_require__(860);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CodeEditor_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__CodeEditor_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__CodeEditor_vue_vue_type_template_id_263a5b36___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__CodeEditor_vue_vue_type_template_id_263a5b36___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "CodeEditor.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormEntry_vue_vue_type_template_id_60a3d8e0___ = __webpack_require__(2428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormEntry_vue_vue_type_script_lang_js___ = __webpack_require__(906);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__FormEntry_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__FormEntry_vue_vue_type_template_id_60a3d8e0___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__FormEntry_vue_vue_type_template_id_60a3d8e0___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormEntry.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 449 */,
/* 450 */,
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_editor_cledit__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_utils__ = __webpack_require__(4);







var nextTickCbs = [];
var nextTickExecCbs = __WEBPACK_IMPORTED_MODULE_3__services_editor_cledit__["a" /* default */].Utils.debounce(function () {
  while (nextTickCbs.length) {
    nextTickCbs.shift()();
  }
});

var nextTick = function nextTick(cb) {
  nextTickCbs.push(cb);
  nextTickExecCbs();
};

var PreviewClassApplier = function () {
  function PreviewClassApplier(classGetter, offsetGetter, properties) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PreviewClassApplier);

    this.classGetter = typeof classGetter === 'function' ? classGetter : function () {
      return classGetter;
    };
    this.offsetGetter = typeof offsetGetter === 'function' ? offsetGetter : function () {
      return offsetGetter;
    };
    this.properties = properties || {};
    this.eltCollection = __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].previewElt.getElementsByClassName(this.classGetter()[0]);
    this.lastEltCount = this.eltCollection.length;

    this.restoreClass = function () {
      if (!__WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].previewCtxWithDiffs) {
        _this.removeClass();
      } else if (!_this.eltCollection.length || _this.eltCollection.length !== _this.lastEltCount) {
        _this.removeClass();
        _this.applyClass();
      }
    };

    __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].$on('previewCtxWithDiffs', this.restoreClass);
    nextTick(function () {
      return _this.restoreClass();
    });
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PreviewClassApplier, [{
    key: 'applyClass',
    value: function applyClass() {
      if (!this.stopped) {
        var offset = this.offsetGetter();
        if (offset) {
          var offsetStart = __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].getPreviewOffset(offset.start, __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].previewCtx.sectionDescList);
          var offsetEnd = __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].getPreviewOffset(offset.end, __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].previewCtx.sectionDescList);
          if (offsetStart != null && offsetEnd != null && offsetStart !== offsetEnd) {
            var start = __WEBPACK_IMPORTED_MODULE_3__services_editor_cledit__["a" /* default */].Utils.findContainer(__WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].previewElt, Math.min(offsetStart, offsetEnd));
            var end = __WEBPACK_IMPORTED_MODULE_3__services_editor_cledit__["a" /* default */].Utils.findContainer(__WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].previewElt, Math.max(offsetStart, offsetEnd));
            var range = document.createRange();
            range.setStart(start.container, start.offsetInContainer);
            range.setEnd(end.container, end.offsetInContainer);
            var properties = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.properties, {
              className: this.classGetter().join(' ')
            });
            __WEBPACK_IMPORTED_MODULE_5__services_utils__["a" /* default */].wrapRange(range, properties);
            this.lastEltCount = this.eltCollection.length;
          }
        }
      }
    }
  }, {
    key: 'removeClass',
    value: function removeClass() {
      __WEBPACK_IMPORTED_MODULE_5__services_utils__["a" /* default */].unwrapRange(this.eltCollection);
    }
  }, {
    key: 'stop',
    value: function stop() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].$off('previewCtxWithDiffs', this.restoreClass);
      nextTick(function () {
        return _this2.removeClass();
      });
      this.stopped = true;
    }
  }]);

  return PreviewClassApplier;
}();

/* harmony default export */ __webpack_exports__["a"] = (PreviewClassApplier);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    id: id,
    type: 'content',
    text: '\n',
    properties: '\n',
    discussions: {},
    comments: {},
    hash: 0
  };
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    id: id,
    type: 'file',
    name: '',
    parentId: null,
    hash: 0
  };
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    id: id,
    type: 'folder',
    name: '',
    parentId: null,
    hash: 0
  };
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{}, {
  method: 'bold',
  title: 'Bold',
  icon: 'format-bold'
}, {
  method: 'italic',
  title: 'Italic',
  icon: 'format-italic'
}, {
  method: 'heading',
  title: 'Heading',
  icon: 'format-size'
}, {
  method: 'strikethrough',
  title: 'Strikethrough',
  icon: 'format-strikethrough'
}, {}, {
  method: 'ulist',
  title: 'Unordered list',
  icon: 'format-list-bulleted'
}, {
  method: 'olist',
  title: 'Ordered list',
  icon: 'format-list-numbers'
}, {
  method: 'clist',
  title: 'Check list',
  icon: 'format-list-checks'
}, {}, {
  method: 'quote',
  title: 'Blockquote',
  icon: 'format-quote-close'
}, {
  method: 'code',
  title: 'Code',
  icon: 'code-tags'
}, {
  method: 'table',
  title: 'Table',
  icon: 'table'
}, {
  method: 'link',
  title: 'Link',
  icon: 'link-variant'
}, {
  method: 'image',
  title: 'Image',
  icon: 'file-image'
}]);

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var zero = {
  markdown: {
    abbr: false,
    breaks: false,
    deflist: false,
    del: false,
    fence: false,
    footnote: false,
    imgsize: false,
    linkify: false,
    mark: false,
    sub: false,
    sup: false,
    table: false,
    tasklist: false,
    typographer: false
  },

  emoji: {
    enabled: false,

    shortcuts: false
  },

  abc: {
    enabled: false
  },

  katex: {
    enabled: false
  },

  mermaid: {
    enabled: false
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  zero: [zero],
  commonmark: [zero, {
    markdown: {
      fence: true
    }
  }],
  gfm: [zero, {
    markdown: {
      breaks: true,
      del: true,
      fence: true,
      linkify: true,
      table: true,
      tasklist: true
    },
    emoji: {
      enabled: true
    }
  }],
  default: [zero, {
    markdown: {
      abbr: true,
      breaks: true,
      deflist: true,
      del: true,
      fence: true,
      footnote: true,
      imgsize: true,
      linkify: true,
      mark: true,
      sub: true,
      sup: true,
      table: true,
      tasklist: true,
      typographer: true
    },
    emoji: {
      enabled: true
    },
    katex: {
      enabled: true
    },
    mermaid: {
      enabled: true
    },
    abc: {
      enabled: true
    }
  }]
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


var arrayProperties = {};
var liveCollectionProperties = {};
var functionProperties = {};
var objectProperties = {};
var slice = Array.prototype.slice;

arrayProperties.cl_each = function (cb) {
    var i = 0;
    var length = this.length;
    for (; i < length; i++) {
        cb(this[i], i, this);
    }
};

arrayProperties.cl_map = function (cb) {
    var i = 0;
    var length = this.length;
    var result = Array(length);
    for (; i < length; i++) {
        result[i] = cb(this[i], i, this);
    }
    return result;
};

arrayProperties.cl_reduce = function (cb, memo) {
    var i = 0;
    var length = this.length;
    for (; i < length; i++) {
        memo = cb(memo, this[i], i, this);
    }
    return memo;
};

arrayProperties.cl_some = function (cb) {
    var i = 0;
    var length = this.length;
    for (; i < length; i++) {
        if (cb(this[i], i, this)) {
            return true;
        }
    }
};

arrayProperties.cl_filter = function (cb) {
    var i = 0;
    var length = this.length;
    var result = [];
    for (; i < length; i++) {
        cb(this[i], i, this) && result.push(this[i]);
    }
    return result;
};

liveCollectionProperties.cl_each = function (cb) {
    slice.call(this).cl_each(cb);
};

liveCollectionProperties.cl_map = function (cb) {
    return slice.call(this).cl_map(cb);
};

liveCollectionProperties.cl_filter = function (cb) {
    return slice.call(this).cl_filter(cb);
};

liveCollectionProperties.cl_reduce = function (cb, memo) {
    return slice.call(this).cl_reduce(cb, memo);
};

functionProperties.cl_bind = function (context) {
    var self = this;
    var args = slice.call(arguments, 1);
    context = context || null;
    return args.length ? function () {
        return arguments.length ? self.apply(context, args.concat(slice.call(arguments))) : self.apply(context, args);
    } : function () {
        return arguments.length ? self.apply(context, arguments) : self.call(context);
    };
};

objectProperties.cl_each = function (cb) {
    var i = 0;
    var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this);
    var length = keys.length;
    for (; i < length; i++) {
        cb(this[keys[i]], keys[i], this);
    }
};

objectProperties.cl_map = function (cb) {
    var i = 0;
    var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this);
    var length = keys.length;
    var result = Array(length);
    for (; i < length; i++) {
        result[i] = cb(this[keys[i]], keys[i], this);
    }
    return result;
};

objectProperties.cl_reduce = function (cb, memo) {
    var i = 0;
    var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this);
    var length = keys.length;
    for (; i < length; i++) {
        memo = cb(memo, this[keys[i]], keys[i], this);
    }
    return memo;
};

objectProperties.cl_some = function (cb) {
    var i = 0;
    var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this);
    var length = keys.length;
    for (; i < length; i++) {
        if (cb(this[keys[i]], keys[i], this)) {
            return true;
        }
    }
};

objectProperties.cl_extend = function (obj) {
    if (obj) {
        var i = 0;
        var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj);
        var length = keys.length;
        for (; i < length; i++) {
            this[keys[i]] = obj[keys[i]];
        }
    }
    return this;
};

function build(properties) {
    return objectProperties.cl_reduce.call(properties, function (memo, value, key) {
        memo[key] = {
            value: value,
            configurable: true
        };
        return memo;
    }, {});
}

arrayProperties = build(arrayProperties);
liveCollectionProperties = build(liveCollectionProperties);
functionProperties = build(functionProperties);
objectProperties = build(objectProperties);

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Array.prototype, arrayProperties);
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Int8Array.prototype, arrayProperties);
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Uint8Array.prototype, arrayProperties);
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Uint8ClampedArray.prototype, arrayProperties);
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Int16Array.prototype, arrayProperties);
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Uint16Array.prototype, arrayProperties);
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Int32Array.prototype, arrayProperties);
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Uint32Array.prototype, arrayProperties);
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Float32Array.prototype, arrayProperties);
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Float64Array.prototype, arrayProperties);
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Function.prototype, functionProperties);
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Object.prototype, objectProperties);
if (typeof window !== 'undefined') {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(HTMLCollection.prototype, liveCollectionProperties);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(NodeList.prototype, liveCollectionProperties);
}

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_diff_match_patch__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_diff_match_patch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_diff_match_patch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(4);






var diffMatchPatch = new __WEBPACK_IMPORTED_MODULE_3_diff_match_patch___default.a();
diffMatchPatch.Match_Distance = 10000;

function makePatchableText(content, markerKeys, markerIdxMap) {
  if (!content || !content.discussions) {
    return null;
  }
  var markers = [];

  var discussionKeys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(content.discussions).sort();
  discussionKeys.forEach(function (discussionId) {
    var discussion = content.discussions[discussionId];

    function addMarker(offsetName) {
      var markerKey = discussionId + offsetName;
      if (discussion[offsetName] !== undefined) {
        var idx = markerIdxMap[markerKey];
        if (idx === undefined) {
          idx = markerKeys.length;
          markerIdxMap[markerKey] = idx;
          markerKeys.push({
            id: discussionId,
            offsetName: offsetName
          });
        }
        markers.push({
          idx: idx,
          offset: discussion[offsetName]
        });
      }
    }

    addMarker('start');
    addMarker('end');
  });

  var lastOffset = 0;
  var result = '';
  markers.sort(function (marker1, marker2) {
    return marker1.offset - marker2.offset;
  }).forEach(function (marker) {
    result += content.text.slice(lastOffset, marker.offset) + String.fromCharCode(0xe000 + marker.idx);
    lastOffset = marker.offset;
  });
  return result + content.text.slice(lastOffset);
}

function stripDiscussionOffsets(objectMap) {
  if (objectMap == null) {
    return objectMap;
  }
  var result = {};
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(objectMap).forEach(function (id) {
    result[id] = {
      text: objectMap[id].text
    };
  });
  return result;
}

function restoreDiscussionOffsets(content, markerKeys) {
  if (markerKeys.length) {
    var count = 0;
    content.text = content.text.replace(new RegExp('[\uE000-' + String.fromCharCode(0xe000 + markerKeys.length - 1) + ']', 'g'), function (match, offset) {
      var idx = match.charCodeAt(0) - 0xe000;
      var markerKey = markerKeys[idx];
      var discussion = content.discussions[markerKey.id];
      if (discussion) {
        discussion[markerKey.offsetName] = offset - count;
      }
      count += 1;
      return '';
    });

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(content.discussions).forEach(function (discussionId) {
      var discussion = content.discussions[discussionId];
      if (discussion.start === undefined) {
        discussion.start = discussion.end || 0;
      }
      if (discussion.end === undefined || discussion.end < discussion.start) {
        discussion.end = discussion.start;
      }
    });
  }
}

function mergeText(serverText, clientText, lastMergedText) {
  var serverClientDiffs = diffMatchPatch.diff_main(serverText, clientText);
  diffMatchPatch.diff_cleanupSemantic(serverClientDiffs);

  var fusionText = serverClientDiffs.map(function (diff) {
    return diff[1];
  }).join('');
  if (!lastMergedText) {
    return fusionText;
  }

  var intersectionText = serverClientDiffs.filter(function (diff) {
    return diff[0] === __WEBPACK_IMPORTED_MODULE_3_diff_match_patch___default.a.DIFF_EQUAL;
  }).map(function (diff) {
    return diff[1];
  }).join('');
  var lastMergedTextDiffs = diffMatchPatch.diff_main(lastMergedText, intersectionText).filter(function (diff) {
    return diff[0] !== __WEBPACK_IMPORTED_MODULE_3_diff_match_patch___default.a.DIFF_INSERT;
  });
  diffMatchPatch.diff_cleanupSemantic(lastMergedTextDiffs);

  var patches = diffMatchPatch.patch_make(lastMergedText, lastMergedTextDiffs);

  return diffMatchPatch.patch_apply(patches, fusionText)[0];
}

function mergeValues(serverValue, clientValue, lastMergedValue) {
  if (!lastMergedValue) {
    return serverValue || clientValue;
  }
  var newSerializedValue = __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].serializeObject(clientValue);
  var serverSerializedValue = __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].serializeObject(serverValue);
  if (newSerializedValue === serverSerializedValue) {
    return serverValue;
  }
  var oldSerializedValue = __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].serializeObject(lastMergedValue);
  if (oldSerializedValue !== newSerializedValue && !serverValue) {
    return clientValue;
  }
  if (oldSerializedValue !== serverSerializedValue && !clientValue) {
    return serverValue;
  }
  if (oldSerializedValue !== newSerializedValue && oldSerializedValue === serverSerializedValue) {
    return clientValue;
  }
  return serverValue;
}

function mergeObjects(serverObject, clientObject) {
  var lastMergedObject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var mergedObject = {};
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, clientObject, serverObject)).forEach(function (key) {
    var mergedValue = mergeValues(serverObject[key], clientObject[key], lastMergedObject[key]);
    if (mergedValue != null) {
      mergedObject[key] = mergedValue;
    }
  });
  return __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].deepCopy(mergedObject);
}

function mergeContent(serverContent, clientContent) {
  var lastMergedContent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var markerKeys = [];
  var markerIdxMap = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(null);
  var lastMergedText = makePatchableText(lastMergedContent, markerKeys, markerIdxMap);
  var serverText = makePatchableText(serverContent, markerKeys, markerIdxMap);
  var clientText = makePatchableText(clientContent, markerKeys, markerIdxMap);
  var isServerTextChanges = lastMergedText !== serverText;
  var isClientTextChanges = lastMergedText !== clientText;
  var isTextSynchronized = serverText === clientText;
  var text = clientText;
  if (!isTextSynchronized && isServerTextChanges) {
    text = serverText;
    if (isClientTextChanges) {
      text = mergeText(serverText, clientText, lastMergedText);
    }
  }

  var result = {
    text: text,
    properties: mergeValues(serverContent.properties, clientContent.properties, lastMergedContent.properties),
    discussions: mergeObjects(stripDiscussionOffsets(serverContent.discussions), stripDiscussionOffsets(clientContent.discussions), stripDiscussionOffsets(lastMergedContent.discussions)),
    comments: mergeObjects(serverContent.comments, clientContent.comments, lastMergedContent.comments)
  };
  restoreDiscussionOffsets(result, markerKeys);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  makePatchableText: makePatchableText,
  restoreDiscussionOffsets: restoreDiscussionOffsets,
  mergeObjects: mergeObjects,
  mergeContent: mergeContent
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__workspaceSvc__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__badgeSvc__ = __webpack_require__(11);






/* harmony default export */ __webpack_exports__["a"] = ({
  newItem: function newItem() {
    var isFolder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var parentId = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters['explorer/selectedNodeFolder'].item.id;
    if (parentId === 'trash' || isFolder && parentId === 'temp') {
        parentId = null;
      }
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('explorer/openNode', parentId);
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('explorer/setNewItem', {
      type: isFolder ? 'folder' : 'file',
      parentId: parentId
    });
  },
  deleteItem: function deleteItem() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var selectedNode, moveToTrash, deleteFile, currentFileId, doClose, recursiveDelete;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              selectedNode = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters['explorer/selectedNode'];

              if (!selectedNode.isNil) {
                _context.next = 3;
                break;
              }

              return _context.abrupt('return');

            case 3:
              if (!(selectedNode.isTrash || selectedNode.item.parentId === 'trash')) {
                _context.next = 12;
                break;
              }

              _context.prev = 4;
              _context.next = 7;
              return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('modal/open', 'trashDeletion');

            case 7:
              _context.next = 11;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](4);

            case 11:
              return _context.abrupt('return');

            case 12:
              moveToTrash = true;
              _context.prev = 13;

              if (!selectedNode.isTemp) {
                _context.next = 20;
                break;
              }

              _context.next = 17;
              return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('modal/open', 'tempFolderDeletion');

            case 17:
              moveToTrash = false;
              _context.next = 29;
              break;

            case 20:
              if (!(selectedNode.item.parentId === 'temp')) {
                _context.next = 26;
                break;
              }

              _context.next = 23;
              return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('modal/open', {
                type: 'tempFileDeletion',
                item: selectedNode.item
              });

            case 23:
              moveToTrash = false;
              _context.next = 29;
              break;

            case 26:
              if (!selectedNode.isFolder) {
                _context.next = 29;
                break;
              }

              _context.next = 29;
              return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('modal/open', {
                type: 'folderDeletion',
                item: selectedNode.item
              });

            case 29:
              _context.next = 34;
              break;

            case 31:
              _context.prev = 31;
              _context.t1 = _context['catch'](13);
              return _context.abrupt('return');

            case 34:
              deleteFile = function deleteFile(id) {
                if (moveToTrash) {
                  __WEBPACK_IMPORTED_MODULE_3__workspaceSvc__["a" /* default */].setOrPatchItem({
                    id: id,
                    parentId: 'trash'
                  });
                } else {
                  __WEBPACK_IMPORTED_MODULE_3__workspaceSvc__["a" /* default */].deleteFile(id);
                }
              };

              if (selectedNode === __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters['explorer/selectedNode']) {
                currentFileId = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters['file/current'].id;
                doClose = selectedNode.item.id === currentFileId;

                if (selectedNode.isFolder) {
                  recursiveDelete = function recursiveDelete(folderNode) {
                    folderNode.folders.forEach(recursiveDelete);
                    folderNode.files.forEach(function (fileNode) {
                      doClose = doClose || fileNode.item.id === currentFileId;
                      deleteFile(fileNode.item.id);
                    });
                    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('folder/deleteItem', folderNode.item.id);
                  };

                  recursiveDelete(selectedNode);
                  __WEBPACK_IMPORTED_MODULE_4__badgeSvc__["a" /* default */].addBadge('removeFolder');
                } else {
                  deleteFile(selectedNode.item.id);
                  __WEBPACK_IMPORTED_MODULE_4__badgeSvc__["a" /* default */].addBadge('removeFile');
                }
                if (doClose) {
                  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters['data/lastOpenedIds'].some(function (id) {
                    var file = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.file.itemsById[id];
                    if (file.parentId === 'trash') {
                      return false;
                    }
                    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('file/setCurrentId', id);
                    return true;
                  });
                }
              }

            case 36:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[4, 9], [13, 31]]);
    }))();
  }
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_utils__ = __webpack_require__(4);








var endsWith = function endsWith(str, suffix) {
  return str.slice(-suffix.length) === suffix;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  shaByPath: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(null),
  makeChanges: function makeChanges(tree) {
    var _this = this;

    var workspacePath = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspace'].path || '';

    this.shaByPath = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(null);

    var treeFolderMap = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(null);
    var treeFileMap = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(null);
    var treeDataMap = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(null);
    var treeSyncLocationMap = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(null);
    var treePublishLocationMap = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(null);

    tree.filter(function (_ref) {
      var type = _ref.type,
          path = _ref.path;
      return type === 'blob' && path.indexOf(workspacePath) === 0;
    }).forEach(function (blobEntry) {
      var path = blobEntry.path.slice(workspacePath.length);

      _this.shaByPath[path] = blobEntry.sha;
      if (path.indexOf('.stackedit-data/') === 0) {
        treeDataMap[path] = true;
      } else {
        var parentPath = '';
        path.split('/').slice(0, -1).forEach(function (folderName) {
          var folderPath = '' + parentPath + folderName + '/';
          treeFolderMap[folderPath] = parentPath;
          parentPath = folderPath;
        });

        if (endsWith(path, '.md')) {
          treeFileMap[path] = parentPath;
        } else if (endsWith(path, '.sync')) {
          treeSyncLocationMap[path] = true;
        } else if (endsWith(path, '.publish')) {
          treePublishLocationMap[path] = true;
        }
      }
    });

    var changes = [];
    var idsByPath = {};
    var syncDataByPath = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['data/syncDataById'];
    var itemIdsByGitPath = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.itemIdsByGitPath;

    var getIdFromPath = function getIdFromPath(path, isFile) {
      var itemId = idsByPath[path];
      if (!itemId) {
        var existingItemId = itemIdsByGitPath[path];
        if (existingItemId && (!isFile || syncDataByPath[path] || syncDataByPath['/' + path])) {
          itemId = existingItemId;
        } else {
          itemId = __WEBPACK_IMPORTED_MODULE_6__services_utils__["a" /* default */].uid();
        }

        if (isFile) {
          idsByPath['/' + path] = itemId + '/content';
        }
        idsByPath[path] = itemId;
      }
      return itemId;
    };

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(treeFolderMap).forEach(function (_ref2) {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
          path = _ref3[0],
          parentPath = _ref3[1];

      if (path === '.stackedit-trash/') {
        idsByPath[path] = 'trash';
      } else {
        var item = __WEBPACK_IMPORTED_MODULE_6__services_utils__["a" /* default */].addItemHash({
          id: getIdFromPath(path),
          type: 'folder',
          name: path.slice(parentPath.length, -1),
          parentId: idsByPath[parentPath] || null
        });

        var folderSyncData = syncDataByPath[path];
        if (!folderSyncData || folderSyncData.hash !== item.hash) {
          changes.push({
            syncDataId: path,
            item: item,
            syncData: {
              id: path,
              type: item.type,
              hash: item.hash
            }
          });
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(treeFileMap).forEach(function (_ref4) {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref4, 2),
          path = _ref5[0],
          parentPath = _ref5[1];

      var fileId = getIdFromPath(path, true);
      var contentPath = '/' + path;
      var contentId = idsByPath[contentPath];

      var item = __WEBPACK_IMPORTED_MODULE_6__services_utils__["a" /* default */].addItemHash({
        id: fileId,
        type: 'file',
        name: path.slice(parentPath.length, -'.md'.length),
        parentId: idsByPath[parentPath] || null
      });

      var fileSyncData = syncDataByPath[path];
      if (!fileSyncData || fileSyncData.hash !== item.hash) {
        changes.push({
          syncDataId: path,
          item: item,
          syncData: {
            id: path,
            type: item.type,
            hash: item.hash
          }
        });
      }

      var contentSyncData = syncDataByPath[contentPath];
      if (!contentSyncData || contentSyncData.sha !== _this.shaByPath[path]) {
        var type = 'content';

        changes.push({
          syncDataId: contentPath,
          item: {
            id: contentId,
            type: type,

            hash: 1
          },
          syncData: {
            id: contentPath,
            type: type,

            hash: 1
          }
        });
      }
    });

    var syncDataByItemId = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['data/syncDataByItemId'];
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(treeDataMap).forEach(function (path) {
      var _ref6 = path.match(/^\.stackedit-data\/(templates)\.json$/) || [],
          _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref6, 2),
          id = _ref7[1];

      if (id) {
        idsByPath[path] = id;
        var syncData = syncDataByItemId[id];
        if (!syncData || syncData.sha !== _this.shaByPath[path]) {
          var type = 'data';
          changes.push({
            syncDataId: path,
            item: {
              id: id,
              type: type,

              hash: 1
            },
            syncData: {
              id: path,
              type: type,

              hash: 1
            }
          });
        }
      }
    });

    [{
      type: 'syncLocation',
      map: treeSyncLocationMap,
      pathMatcher: /^([\s\S]+)\.([\w-]+)\.sync$/
    }, {
      type: 'publishLocation',
      map: treePublishLocationMap,
      pathMatcher: /^([\s\S]+)\.([\w-]+)\.publish$/
    }].forEach(function (_ref8) {
      var type = _ref8.type,
          map = _ref8.map,
          pathMatcher = _ref8.pathMatcher;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(map).forEach(function (path) {
        var _ref9 = path.match(pathMatcher) || [],
            _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref9, 3),
            filePath = _ref10[1],
            data = _ref10[2];

        if (filePath) {
          var fileId = idsByPath[filePath + '.md'];
          if (fileId) {
            var id = itemIdsByGitPath[path] || __WEBPACK_IMPORTED_MODULE_6__services_utils__["a" /* default */].uid();
            idsByPath[path] = id;

            var item = __WEBPACK_IMPORTED_MODULE_6__services_utils__["a" /* default */].addItemHash(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, JSON.parse(__WEBPACK_IMPORTED_MODULE_6__services_utils__["a" /* default */].decodeBase64(data)), {
              id: id,
              type: type,
              fileId: fileId
            }));

            var locationSyncData = syncDataByPath[path];
            if (!locationSyncData || locationSyncData.hash !== item.hash) {
              changes.push({
                syncDataId: path,
                item: item,
                syncData: {
                  id: path,
                  type: item.type,
                  hash: item.hash
                }
              });
            }
          }
        }
      });
    });

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(syncDataByPath).forEach(function (path) {
      if (!idsByPath[path]) {
        changes.push({ syncDataId: path });
      }
    });

    return changes;
  }
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);


var charInsideUrl = '(&|[-A-Z0-9+@#/%?=~_|[\\]()!:,.;])';
var charEndingUrl = '(&|[-A-Z0-9+@#/%=~_|[\\])])';
var urlPattern = new RegExp('(https?|ftp)(://' + charInsideUrl + '*' + charEndingUrl + ')(?=$|\\W)', 'gi');
var emailPattern = /(?:mailto:)?([-.\w]+@[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+)/gi;

var markup = {
  comment: /<!--[\w\W]*?-->/g,
  tag: {
    pattern: /<\/?[\w:-]+\s*(?:\s+[\w:-]+(?:=(?:("|')(\\?[\w\W])*?\1|[^\s'">=]+))?\s*)*\/?>/gi,
    inside: {
      tag: {
        pattern: /^<\/?[\w:-]+/i,
        inside: {
          punctuation: /^<\/?/,
          namespace: /^[\w-]+?:/
        }
      },
      'attr-value': {
        pattern: /=(?:('|")[\w\W]*?(\1)|[^\s>]+)/gi,
        inside: {
          punctuation: /=|>|"/g
        }
      },
      punctuation: /\/?>/g,
      'attr-name': {
        pattern: /[\w:-]+/g,
        inside: {
          namespace: /^[\w-]+?:/
        }
      }
    }
  },
  entity: /&#?[\da-z]{1,8};/gi
};

var latex = {
  keyword: /\\(?:[^a-zA-Z]|[a-zA-Z]+)/g,

  lparen: /[[({]/g,

  rparen: /[\])}]/g,

  comment: /%.*/g
};

/* harmony default export */ __webpack_exports__["a"] = ({
  makeGrammars: function makeGrammars(options) {
    var grammars = {
      main: {},
      list: {},
      blockquote: {},
      table: {},
      deflist: {}
    };

    grammars.deflist.deflist = {
      pattern: new RegExp(['^ {0,3}\\S.*\\n', '(?:[ \\t]*\\n)?', '(?:', '[ \\t]*:[ \\t].*\\n', '(?:', '(?:', '.*\\S.*\\n', '|', '[ \\t]*\\n(?! ?\\S)', ')', ')*', '(?:[ \\t]*\\n)*', ')+'].join(''), 'm'),
      inside: {
        term: /^.+/,
        cl: /^[ \t]*:[ \t]/gm
      }
    };

    var insideFences = options.insideFences || {};
    insideFences['cl cl-pre'] = /```|~~~/;
    if (options.fence) {
      grammars.main['pre gfm'] = {
        pattern: /^(```|~~~)[\s\S]*?\n\1 *$/gm,
        inside: insideFences
      };
      grammars.list['pre gfm'] = {
        pattern: /^(?: {4}|\t)(```|~~~)[\s\S]*?\n(?: {4}|\t)\1\s*$/gm,
        inside: insideFences
      };
      grammars.deflist.deflist.inside['pre gfm'] = grammars.list['pre gfm'];
    }

    grammars.main['h1 alt'] = {
      pattern: /^.+\n=+[ \t]*$/gm,
      inside: {
        'cl cl-hash': /=+[ \t]*$/
      }
    };
    grammars.main['h2 alt'] = {
      pattern: /^.+\n-+[ \t]*$/gm,
      inside: {
        'cl cl-hash': /-+[ \t]*$/
      }
    };
    for (var i = 6; i >= 1; i -= 1) {
      grammars.main['h' + i] = {
        pattern: new RegExp('^#{' + i + '}[ \t].+$', 'gm'),
        inside: {
          'cl cl-hash': new RegExp('^#{' + i + '}')
        }
      };
    }

    var list = /^[ \t]*([*+-]|\d+\.)[ \t]/gm;
    var blockquote = {
      pattern: /^\s*>.*(?:\n[ \t]*\S.*)*/gm,
      inside: {
        'cl cl-gt': /^\s*>/gm,
        'cl cl-li': list
      }
    };
    grammars.list.blockquote = blockquote;
    grammars.blockquote.blockquote = blockquote;
    grammars.deflist.deflist.inside.blockquote = blockquote;
    grammars.list['cl cl-li'] = list;
    grammars.blockquote['cl cl-li'] = list;
    grammars.deflist.deflist.inside['cl cl-li'] = list;

    grammars.table.table = {
      pattern: new RegExp(['^\\s*\\S.*[|].*\\n', '[-| :]+\\n', '(?:.*[|].*\\n?)*', '$'].join(''), 'gm'),
      inside: {
        'cl cl-title-separator': /^[-| :]+$/gm,
        'cl cl-pipe': /[|]/gm
      }
    };

    grammars.main.hr = {
      pattern: /^ {0,3}([*\-_] *){3,}$/gm
    };

    if (options.tasklist) {
      grammars.list.task = {
        pattern: /^\[[ xX]\] /,
        inside: {
          cl: /[[\]]/,
          strong: /[xX]/
        }
      };
    }

    var defs = {};
    if (options.footnote) {
      defs.fndef = {
        pattern: /^ {0,3}\[\^.*?\]:.*$/gm,
        inside: {
          'ref-id': {
            pattern: /^ {0,3}\[\^.*?\]/,
            inside: {
              cl: /(\[\^|\])/
            }
          }
        }
      };
    }
    if (options.abbr) {
      defs.abbrdef = {
        pattern: /^ {0,3}\*\[.*?\]:.*$/gm,
        inside: {
          'abbr-id': {
            pattern: /^ {0,3}\*\[.*?\]/,
            inside: {
              cl: /(\*\[|\])/
            }
          }
        }
      };
    }
    defs.linkdef = {
      pattern: /^ {0,3}\[.*?\]:.*$/gm,
      inside: {
        'link-id': {
          pattern: /^ {0,3}\[.*?\]/,
          inside: {
            cl: /[[\]]/
          }
        },
        url: urlPattern
      }
    };

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(defs).forEach(function (_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          name = _ref2[0],
          def = _ref2[1];

      grammars.main[name] = def;
      grammars.list[name] = def;
      grammars.blockquote[name] = def;
      grammars.table[name] = def;
      grammars.deflist[name] = def;
    });

    grammars.main.pre = {
      pattern: /^\s*\n(?: {4}|\t).*\S.*\n((?: {4}|\t).*\n)*/gm
    };

    var rest = {};
    rest.code = {
      pattern: /(`+)[\s\S]*?\1/g,
      inside: {
        'cl cl-code': /`/
      }
    };
    if (options.math) {
      rest['math block'] = {
        pattern: /\\\\\[[\s\S]*?\\\\\]/g,
        inside: {
          'cl cl-bracket-start': /^\\\\\[/,
          'cl cl-bracket-end': /\\\\\]$/,
          rest: latex
        }
      };
      rest['math inline'] = {
        pattern: /\\\\\([\s\S]*?\\\\\)/g,
        inside: {
          'cl cl-bracket-start': /^\\\\\(/,
          'cl cl-bracket-end': /\\\\\)$/,
          rest: latex
        }
      };
      rest['math expr block'] = {
        pattern: /(\$\$)[\s\S]*?\1/g,
        inside: {
          'cl cl-bracket-start': /^\$\$/,
          'cl cl-bracket-end': /\$\$$/,
          rest: latex
        }
      };
      rest['math expr inline'] = {
        pattern: /\$(?!\s)[\s\S]*?\S\$(?!\d)/g,
        inside: {
          'cl cl-bracket-start': /^\$/,
          'cl cl-bracket-end': /\$$/,
          rest: latex
        }
      };
    }
    if (options.footnote) {
      rest.inlinefn = {
        pattern: /\^\[.+?\]/g,
        inside: {
          cl: /(\^\[|\])/
        }
      };
      rest.fn = {
        pattern: /\[\^.+?\]/g,
        inside: {
          cl: /(\[\^|\])/
        }
      };
    }
    rest.img = {
      pattern: /!\[.*?\]\(.+?\)/g,
      inside: {
        'cl cl-title': /['‘][^'’]*['’]|["“][^"”]*["”](?=\)$)/,
        'cl cl-src': {
          pattern: /(\]\()[^('" \t]+(?=[)'" \t])/,
          lookbehind: true
        }
      }
    };
    if (options.imgsize) {
      rest.img.inside['cl cl-size'] = /=\d*x\d*/;
    }
    rest.link = {
      pattern: /\[.*?\]\(.+?\)/gm,
      inside: {
        'cl cl-underlined-text': {
          pattern: /(\[)[^\]]*/,
          lookbehind: true
        },
        'cl cl-title': /['‘][^'’]*['’]|["“][^"”]*["”](?=\)$)/
      }
    };
    rest.imgref = {
      pattern: /!\[.*?\][ \t]*\[.*?\]/g
    };
    rest.linkref = {
      pattern: /\[.*?\][ \t]*\[.*?\]/g,
      inside: {
        'cl cl-underlined-text': {
          pattern: /^(\[)[^\]]*(?=\][ \t]*\[)/,
          lookbehind: true
        }
      }
    };
    rest.comment = markup.comment;
    rest.tag = markup.tag;
    rest.url = urlPattern;
    rest.email = emailPattern;
    rest.strong = {
      pattern: /(^|[^\w*])(__|\*\*)(?![_*])[\s\S]*?\2(?=([^\w*]|$))/gm,
      lookbehind: true,
      inside: {
        'cl cl-strong cl-start': /^(__|\*\*)/,
        'cl cl-strong cl-close': /(__|\*\*)$/
      }
    };
    rest.em = {
      pattern: /(^|[^\w*])(_|\*)(?![_*])[\s\S]*?\2(?=([^\w*]|$))/gm,
      lookbehind: true,
      inside: {
        'cl cl-em cl-start': /^(_|\*)/,
        'cl cl-em cl-close': /(_|\*)$/
      }
    };
    rest['strong em'] = {
      pattern: /(^|[^\w*])(__|\*\*)(_|\*)(?![_*])[\s\S]*?\3\2(?=([^\w*]|$))/gm,
      lookbehind: true,
      inside: {
        'cl cl-strong cl-start': /^(__|\*\*)(_|\*)/,
        'cl cl-strong cl-close': /(_|\*)(__|\*\*)$/
      }
    };
    rest['strong em inv'] = {
      pattern: /(^|[^\w*])(_|\*)(__|\*\*)(?![_*])[\s\S]*?\3\2(?=([^\w*]|$))/gm,
      lookbehind: true,
      inside: {
        'cl cl-strong cl-start': /^(_|\*)(__|\*\*)/,
        'cl cl-strong cl-close': /(__|\*\*)(_|\*)$/
      }
    };
    if (options.del) {
      rest.del = {
        pattern: /(^|[^\w*])(~~)[\s\S]*?\2(?=([^\w*]|$))/gm,
        lookbehind: true,
        inside: {
          cl: /~~/,
          'cl-del-text': /[^~]+/
        }
      };
    }
    if (options.mark) {
      rest.mark = {
        pattern: /(^|[^\w*])(==)[\s\S]*?\2(?=([^\w*]|$))/gm,
        lookbehind: true,
        inside: {
          cl: /==/,
          'cl-mark-text': /[^=]+/
        }
      };
    }
    if (options.sub) {
      rest.sub = {
        pattern: /(~)(?=\S)(.*?\S)\1/gm,
        inside: {
          cl: /~/
        }
      };
    }
    if (options.sup) {
      rest.sup = {
        pattern: /(\^)(?=\S)(.*?\S)\1/gm,
        inside: {
          cl: /\^/
        }
      };
    }
    rest.entity = markup.entity;

    for (var c = 6; c >= 1; c -= 1) {
      grammars.main['h' + c].inside.rest = rest;
    }
    grammars.main['h1 alt'].inside.rest = rest;
    grammars.main['h2 alt'].inside.rest = rest;
    grammars.table.table.inside.rest = rest;
    grammars.main.rest = rest;
    grammars.list.rest = rest;
    grammars.blockquote.blockquote.inside.rest = rest;
    grammars.deflist.deflist.inside.rest = rest;
    if (options.footnote) {
      grammars.main.fndef.inside.rest = rest;
    }

    var restLight = {
      code: rest.code,
      inlinefn: rest.inlinefn,
      fn: rest.fn,
      link: rest.link,
      linkref: rest.linkref
    };
    rest.strong.inside.rest = restLight;
    rest.em.inside.rest = restLight;
    if (options.del) {
      rest.del.inside.rest = restLight;
    }
    if (options.mark) {
      rest.mark.inside.rest = restLight;
    }

    var inside = {
      code: rest.code,
      comment: rest.comment,
      tag: rest.tag,
      strong: rest.strong,
      em: rest.em,
      del: rest.del,
      sub: rest.sub,
      sup: rest.sup,
      entity: markup.entity
    };
    rest.link.inside['cl cl-underlined-text'].inside = inside;
    rest.linkref.inside['cl cl-underlined-text'].inside = inside;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(grammars).forEach(function (_ref3) {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
          grammar = _ref4[1];

      grammar.rest = grammar.rest || {};
      grammar.rest.p = /.+/;
    });

    return grammars;
  }
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_githubHelper__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Provider__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__userSvc__ = __webpack_require__(46);









/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */]({
  id: 'gist',
  name: 'Gist',
  getToken: function getToken(_ref) {
    var sub = _ref.sub;

    return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['data/githubTokensBySub'][sub];
  },
  getLocationUrl: function getLocationUrl(_ref2) {
    var gistId = _ref2.gistId;

    return 'https://gist.github.com/' + gistId;
  },
  getLocationDescription: function getLocationDescription(_ref3) {
    var filename = _ref3.filename;

    return filename;
  },
  downloadContent: function downloadContent(token, syncLocation) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var content;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_githubHelper__["a" /* default */].downloadGist(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, syncLocation, {
                token: token
              }));

            case 2:
              content = _context.sent;
              return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */].parseContent(content, syncLocation.fileId + '/content'));

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  uploadContent: function uploadContent(token, content, syncLocation) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var file, description, gist;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              file = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.file.itemsById[syncLocation.fileId];
              description = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].sanitizeName(file && file.name);
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_githubHelper__["a" /* default */].uploadGist(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, syncLocation, {
                token: token,
                description: description,
                content: __WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */].serializeContent(content)
              }));

            case 4:
              gist = _context2.sent;
              return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, syncLocation, {
                gistId: gist.id
              }));

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  publish: function publish(token, html, metadata, publishLocation) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var gist;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_githubHelper__["a" /* default */].uploadGist(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, publishLocation, {
                token: token,
                description: metadata.title,
                content: html
              }));

            case 2:
              gist = _context3.sent;
              return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, publishLocation, {
                gistId: gist.id
              }));

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  makeLocation: function makeLocation(token, filename, isPublic, gistId) {
    return {
      providerId: this.id,
      sub: token.sub,
      filename: filename,
      isPublic: isPublic,
      gistId: gistId
    };
  },
  listFileRevisions: function listFileRevisions(_ref4) {
    var _this4 = this;

    var token = _ref4.token,
        syncLocation = _ref4.syncLocation;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var entries;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_githubHelper__["a" /* default */].getGistCommits(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, syncLocation, {
                token: token
              }));

            case 2:
              entries = _context4.sent;
              return _context4.abrupt('return', entries.map(function (entry) {
                var sub = __WEBPACK_IMPORTED_MODULE_4__helpers_githubHelper__["a" /* default */].subPrefix + ':' + entry.user.id;
                __WEBPACK_IMPORTED_MODULE_7__userSvc__["a" /* default */].addUserInfo({ id: sub, name: entry.user.login, imageUrl: entry.user.avatar_url });
                return {
                  sub: sub,
                  id: entry.version,
                  created: new Date(entry.committed_at).getTime()
                };
              }));

            case 4:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  loadFileRevision: function loadFileRevision() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt('return', false);

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  getFileRevisionContent: function getFileRevisionContent(_ref5) {
    var _this6 = this;

    var token = _ref5.token,
        contentId = _ref5.contentId,
        syncLocation = _ref5.syncLocation,
        revisionId = _ref5.revisionId;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_githubHelper__["a" /* default */].downloadGistRevision(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, syncLocation, {
                token: token,
                sha: revisionId
              }));

            case 2:
              data = _context6.sent;
              return _context6.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */].parseContent(data, contentId));

            case 4:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
}));

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__localDbSvc__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__networkSvc__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__exportSvc__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__providers_common_providerRegistry__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__workspaceSvc__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__badgeSvc__ = __webpack_require__(11);




var _this = this;










var hasCurrentFilePublishLocations = function hasCurrentFilePublishLocations() {
  return !!__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['publishLocation/current'].length;
};

var loader = function loader(type) {
  return function (fileId) {
    return __WEBPACK_IMPORTED_MODULE_3__localDbSvc__["a" /* default */].loadItem(fileId + '/' + type).catch(function () {
      return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit(type + '/setItem', {
        id: fileId + '/' + type
      });
    });
  };
};
var loadContent = loader('content');

var ensureArray = function ensureArray(value) {
  if (!value) {
    return [];
  }
  if (!Array.isArray(value)) {
    return ('' + value).trim().split(/\s*,\s*/);
  }
  return value;
};

var ensureString = function ensureString(value, defaultValue) {
  if (!value) {
    return defaultValue;
  }
  return '' + value;
};

var ensureDate = function ensureDate(value, defaultValue) {
  if (!value) {
    return defaultValue;
  }
  return new Date('' + value);
};

var publish = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(publishLocation) {
    var fileId, template, html, content, file, properties, provider, token, metadata;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            fileId = publishLocation.fileId;
            template = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['data/allTemplatesById'][publishLocation.templateId];
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_7__exportSvc__["a" /* default */].applyTemplate(fileId, template);

          case 4:
            html = _context.sent;
            _context.next = 7;
            return __WEBPACK_IMPORTED_MODULE_3__localDbSvc__["a" /* default */].loadItem(fileId + '/content');

          case 7:
            content = _context.sent;
            file = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.file.itemsById[fileId];
            properties = __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].computeProperties(content.properties);
            provider = __WEBPACK_IMPORTED_MODULE_8__providers_common_providerRegistry__["a" /* default */].providersById[publishLocation.providerId];
            token = provider.getToken(publishLocation);
            metadata = {
              title: ensureString(properties.title, file.name),
              author: ensureString(properties.author),
              tags: ensureArray(properties.tags),
              categories: ensureArray(properties.categories),
              excerpt: ensureString(properties.excerpt),
              featuredImage: ensureString(properties.featuredImage),
              status: ensureString(properties.status),
              date: ensureDate(properties.date, new Date())
            };
            return _context.abrupt('return', provider.publish(token, html, metadata, publishLocation));

          case 14:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function publish(_x) {
    return _ref.apply(this, arguments);
  };
}();

var publishFile = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(fileId) {
    var counter, publishLocations, file;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            counter = 0;
            _context4.next = 3;
            return loadContent(fileId);

          case 3:
            publishLocations = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['publishLocation/filteredGroupedByFileId'][fileId] || []));
            _context4.prev = 4;
            _context4.next = 7;
            return __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].awaitSequence(publishLocations, function () {
              var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(publishLocation) {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('queue/doWithLocation', {
                          location: publishLocation,
                          action: function () {
                            var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                              var publishLocationToStore;
                              return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                                while (1) {
                                  switch (_context2.prev = _context2.next) {
                                    case 0:
                                      _context2.next = 2;
                                      return publish(publishLocation);

                                    case 2:
                                      publishLocationToStore = _context2.sent;
                                      _context2.prev = 3;

                                      if (__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].serializeObject(publishLocation) !== __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].serializeObject(publishLocationToStore)) {
                                        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('publishLocation/patchItem', publishLocationToStore);
                                        __WEBPACK_IMPORTED_MODULE_9__workspaceSvc__["a" /* default */].ensureUniqueLocations();
                                      }
                                      counter += 1;
                                      _context2.next = 14;
                                      break;

                                    case 8:
                                      _context2.prev = 8;
                                      _context2.t0 = _context2['catch'](3);

                                      if (!__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.offline) {
                                        _context2.next = 12;
                                        break;
                                      }

                                      throw _context2.t0;

                                    case 12:
                                      console.error(_context2.t0);
                                      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('notification/error', _context2.t0);

                                    case 14:
                                    case 'end':
                                      return _context2.stop();
                                  }
                                }
                              }, _callee2, _this, [[3, 8]]);
                            }));

                            return function action() {
                              return _ref4.apply(this, arguments);
                            };
                          }()
                        });

                      case 2:
                      case 'end':
                        return _context3.stop();
                    }
                  }
                }, _callee3, _this);
              }));

              return function (_x3) {
                return _ref3.apply(this, arguments);
              };
            }());

          case 7:
            file = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.file.itemsById[fileId];

            __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('notification/info', '"' + file.name + '" was published to ' + counter + ' location(s).');

          case 9:
            _context4.prev = 9;
            _context4.next = 12;
            return __WEBPACK_IMPORTED_MODULE_3__localDbSvc__["a" /* default */].unloadContents();

          case 12:
            return _context4.finish(9);

          case 13:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this, [[4,, 9, 13]]);
  }));

  return function publishFile(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var requestPublish = function requestPublish() {
  if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.light) {
    return;
  }

  __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('queue/enqueuePublishRequest', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
    var intervalId, attempt;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            intervalId = void 0;

            attempt = function () {
              var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        if (!__WEBPACK_IMPORTED_MODULE_6__networkSvc__["a" /* default */].isUserActive()) {
                          _context5.next = 7;
                          break;
                        }

                        clearInterval(intervalId);

                        if (hasCurrentFilePublishLocations()) {
                          _context5.next = 4;
                          break;
                        }

                        throw new Error('Publish not possible.');

                      case 4:
                        _context5.next = 6;
                        return publishFile(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['file/current'].id);

                      case 6:
                        __WEBPACK_IMPORTED_MODULE_10__badgeSvc__["a" /* default */].addBadge('triggerPublish');

                      case 7:
                      case 'end':
                        return _context5.stop();
                    }
                  }
                }, _callee5, _this);
              }));

              return function attempt() {
                return _ref6.apply(this, arguments);
              };
            }();

            intervalId = __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].setInterval(function () {
              return attempt();
            }, 1000);
            return _context6.abrupt('return', attempt());

          case 4:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this);
  })));
};

var createPublishLocation = function createPublishLocation(publishLocation, featureId) {
  var currentFile = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['file/current'];
  publishLocation.fileId = currentFile.id;
  __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('queue/enqueue', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
    var publishLocationToStore;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return publish(publishLocation);

          case 2:
            publishLocationToStore = _context7.sent;

            __WEBPACK_IMPORTED_MODULE_9__workspaceSvc__["a" /* default */].addPublishLocation(publishLocationToStore);
            __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('notification/info', 'A new publication location was added to "' + currentFile.name + '".');
            if (featureId) {
              __WEBPACK_IMPORTED_MODULE_10__badgeSvc__["a" /* default */].addBadge(featureId);
            }

          case 6:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, _this);
  })));
};

/* harmony default export */ __webpack_exports__["a"] = ({
  requestPublish: requestPublish,
  createPublishLocation: createPublishLocation
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_markdownHighlighting_scss__ = __webpack_require__(1931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_markdownHighlighting_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_markdownHighlighting_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_app_scss__ = __webpack_require__(1928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_app_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout__ = __webpack_require__(2223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modal__ = __webpack_require__(2224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Notification__ = __webpack_require__(2226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ContextMenu__ = __webpack_require__(2218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SplashScreen__ = __webpack_require__(2229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_syncSvc__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_networkSvc__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_tempFileSvc__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_vueGlobals__ = __webpack_require__(970);


















var themeClasses = {
  light: ['app--light'],
  dark: ['app--dark']
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Layout: __WEBPACK_IMPORTED_MODULE_5__Layout__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_6__Modal__["a" /* default */],
    Notification: __WEBPACK_IMPORTED_MODULE_7__Notification__["a" /* default */],
    ContextMenu: __WEBPACK_IMPORTED_MODULE_8__ContextMenu__["a" /* default */],
    SplashScreen: __WEBPACK_IMPORTED_MODULE_9__SplashScreen__["a" /* default */]
  },
  data: function data() {
    return {
      ready: false
    };
  },
  computed: {
    classes: function classes() {
      var result = themeClasses[__WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].getters['data/computedSettings'].colorTheme];
      return Array.isArray(result) ? result : themeClasses.light;
    }
  },
  methods: {
    close: function close() {
      __WEBPACK_IMPORTED_MODULE_12__services_tempFileSvc__["a" /* default */].close();
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_10__services_syncSvc__["a" /* default */].init();

            case 3:
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_11__services_networkSvc__["a" /* default */].init();

            case 5:
              _this.ready = true;
              __WEBPACK_IMPORTED_MODULE_12__services_tempFileSvc__["a" /* default */].setReady();
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](0);

              if (_context.t0 && _context.t0.message === 'RELOAD') {
                window.location.reload();
              } else if (_context.t0 && _context.t0.message !== 'RELOAD') {
                console.error(_context.t0);
                __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].dispatch('notification/error', _context.t0);
              }

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 9]]);
    }))();
  }
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['light']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('data', ['layoutSettings'])),
  methods: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('data', ['toggleNavigationBar', 'toggleEditor', 'toggleSidePreview', 'toggleStatusBar', 'toggleFocusMode', 'toggleScrollSync'])
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_editor_cledit__ = __webpack_require__(65);





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value', 'lang', 'disabled'],
  mounted: function mounted() {
    var _this = this;

    var preElt = this.$el;
    var scrollElt = preElt;
    while (scrollElt && !scrollElt.classList.contains('modal')) {
      scrollElt = scrollElt.parentNode;
    }
    if (scrollElt) {
      var clEditor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_editor_cledit__["a" /* default */])(preElt, scrollElt);
      clEditor.on('contentChanged', function (value) {
        return _this.$emit('changed', value);
      });
      clEditor.init({
        content: this.value,
        sectionHighlighter: function sectionHighlighter(section) {
          return __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlight(section.text, __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.languages[_this.lang]);
        }
      });
      clEditor.toggleEditable(!this.disabled);
    }
  }
});

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('contextMenu', ['coordinates', 'items', 'resolve'])),
  methods: {
    close: function close() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.resolve(item);
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('contextMenu/close');
    }
  }
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gutters_CommentList__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gutters_EditorNewDiscussionButton__ = __webpack_require__(2234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CommentList: __WEBPACK_IMPORTED_MODULE_2__gutters_CommentList__["a" /* default */],
    EditorNewDiscussionButton: __WEBPACK_IMPORTED_MODULE_3__gutters_EditorNewDiscussionButton__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('file', ['isCurrentTemp']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('layout', ['styles']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('data', ['computedSettings'])),
  mounted: function mounted() {
    var editorElt = this.$el.querySelector('.editor__inner');
    var onDiscussionEvt = function onDiscussionEvt(cb) {
      return function (evt) {
        var elt = evt.target;
        while (elt && elt !== editorElt) {
          if (elt.discussionId) {
            cb(elt.discussionId);
            return;
          }
          elt = elt.parentNode;
        }
      };
    };

    var classToggler = function classToggler(toggle) {
      return function (discussionId) {
        editorElt.getElementsByClassName('discussion-editor-highlighting--' + discussionId).cl_each(function (elt) {
          return elt.classList.toggle('discussion-editor-highlighting--hover', toggle);
        });
        document.getElementsByClassName('comment--discussion-' + discussionId).cl_each(function (elt) {
          return elt.classList.toggle('comment--hover', toggle);
        });
      };
    };

    editorElt.addEventListener('mouseover', onDiscussionEvt(classToggler(true)));
    editorElt.addEventListener('mouseout', onDiscussionEvt(classToggler(false)));
    editorElt.addEventListener('click', onDiscussionEvt(function (discussionId) {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('discussion/setCurrentDiscussionId', discussionId);
    }));

    this.$watch(function () {
      return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.discussion.currentDiscussionId;
    }, function (discussionId, oldDiscussionId) {
      if (oldDiscussionId) {
        editorElt.querySelectorAll('.discussion-editor-highlighting--' + oldDiscussionId).cl_each(function (elt) {
          return elt.classList.remove('discussion-editor-highlighting--selected');
        });
      }
      if (discussionId) {
        editorElt.querySelectorAll('.discussion-editor-highlighting--' + discussionId).cl_each(function (elt) {
          return elt.classList.add('discussion-editor-highlighting--selected');
        });
      }
    });
  }
});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ExplorerNode__ = __webpack_require__(2221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_explorerSvc__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ExplorerNode: __WEBPACK_IMPORTED_MODULE_2__ExplorerNode__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['light']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('explorer', ['newChildNode']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('explorer', ['rootNode', 'selectedNode'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('data', ['toggleExplorer']), {
    newItem: function newItem(isFolder) {
      return __WEBPACK_IMPORTED_MODULE_3__services_explorerSvc__["a" /* default */].newItem(isFolder);
    },
    deleteItem: function deleteItem() {
      return __WEBPACK_IMPORTED_MODULE_3__services_explorerSvc__["a" /* default */].deleteItem();
    },
    editItem: function editItem() {
      var node = this.selectedNode;
      if (!node.isTrash && !node.isTemp) {
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('explorer/setEditingId', node.item.id);
      }
    }
  }),
  created: function created() {
    this.$watch(function () {
      return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['file/current'].id;
    }, function (currentFileId) {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('explorer/setSelectedId', currentFileId);
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('explorer/openNode', currentFileId);
    }, {
      immediate: true
    });
  }
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_workspaceSvc__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_explorerSvc__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_badgeSvc__ = __webpack_require__(11);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'explorer-node',
  props: ['node', 'depth'],
  data: function data() {
    return {
      editingValue: ''
    };
  },
  computed: {
    leftPadding: function leftPadding() {
      return this.depth * 15 + 'px';
    },
    childLeftPadding: function childLeftPadding() {
      return (this.depth + 1) * 15 + 'px';
    },
    isSelected: function isSelected() {
      return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters['explorer/selectedNode'] === this.node;
    },
    isEditing: function isEditing() {
      return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters['explorer/editingNode'] === this.node;
    },
    isDragTarget: function isDragTarget() {
      return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters['explorer/dragTargetNode'] === this.node;
    },
    isDragTargetFolder: function isDragTargetFolder() {
      return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters['explorer/dragTargetNodeFolder'] === this.node;
    },
    isOpen: function isOpen() {
      return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.explorer.openNodes[this.node.item.id] || this.node.isRoot;
    },
    newChild: function newChild() {
      return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters['explorer/newChildNodeParent'] === this.node && __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.explorer.newChildNode;
    },

    newChildName: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.explorer.newChildNode.item.name;
      },
      set: function set(value) {
        __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('explorer/setNewItemName', value);
      }
    },
    editingNodeName: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters['explorer/editingNode'].item.name;
      },
      set: function set(value) {
        this.editingValue = value.trim();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('explorer', ['setEditingId']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('explorer', ['setDragTarget']), {
    select: function select() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.node.item.id;
      var doOpen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var node = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters['explorer/nodeMap'][id];
      if (!node) {
        return false;
      }
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('explorer/setSelectedId', id);
      if (doOpen) {
        setTimeout(function () {
          if (node.isFolder) {
            __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('explorer/toggleOpenNode', id);
          } else if (__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.file.currentId !== id) {
            __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('file/setCurrentId', id);
            __WEBPACK_IMPORTED_MODULE_7__services_badgeSvc__["a" /* default */].addBadge('switchFile');
          }
        }, 10);
      }
      return true;
    },
    submitNewChild: function submitNewChild(cancel) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var newChildNode, item, _item;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                newChildNode = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.explorer.newChildNode;

                if (!(!cancel && !newChildNode.isNil && newChildNode.item.name)) {
                  _context.next = 20;
                  break;
                }

                _context.prev = 2;

                if (!newChildNode.isFolder) {
                  _context.next = 11;
                  break;
                }

                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_4__services_workspaceSvc__["a" /* default */].storeItem(newChildNode.item);

              case 6:
                item = _context.sent;

                _this.select(item.id);
                __WEBPACK_IMPORTED_MODULE_7__services_badgeSvc__["a" /* default */].addBadge('createFolder');
                _context.next = 16;
                break;

              case 11:
                _context.next = 13;
                return __WEBPACK_IMPORTED_MODULE_4__services_workspaceSvc__["a" /* default */].createFile(newChildNode.item);

              case 13:
                _item = _context.sent;

                _this.select(_item.id);
                __WEBPACK_IMPORTED_MODULE_7__services_badgeSvc__["a" /* default */].addBadge('createFile');

              case 16:
                _context.next = 20;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context['catch'](2);

              case 20:
                __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('explorer/setNewItem', null);

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 18]]);
      }))();
    },
    submitEdit: function submitEdit(cancel) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _store$getters$explor, item, isFolder, value;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _store$getters$explor = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters['explorer/editingNode'], item = _store$getters$explor.item, isFolder = _store$getters$explor.isFolder;
                value = _this2.editingValue;

                _this2.setEditingId(null);

                if (!(!cancel && item.id && value && item.name !== value)) {
                  _context2.next = 12;
                  break;
                }

                _context2.prev = 4;
                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_4__services_workspaceSvc__["a" /* default */].storeItem(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, item, {
                  name: value
                }));

              case 7:
                __WEBPACK_IMPORTED_MODULE_7__services_badgeSvc__["a" /* default */].addBadge(isFolder ? 'renameFolder' : 'renameFile');
                _context2.next = 12;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](4);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[4, 10]]);
      }))();
    },
    setDragSourceId: function setDragSourceId(evt) {
      if (this.node.noDrag) {
        evt.preventDefault();
        return;
      }
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('explorer/setDragSourceId', this.node.item.id);

      evt.dataTransfer.setData('Text', '');
    },
    onDrop: function onDrop() {
      var sourceNode = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters['explorer/dragSourceNode'];
      var targetNode = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters['explorer/dragTargetNodeFolder'];
      this.setDragTarget();
      if (!sourceNode.isNil && !targetNode.isNil && sourceNode.item.id !== targetNode.item.id) {
        __WEBPACK_IMPORTED_MODULE_4__services_workspaceSvc__["a" /* default */].storeItem(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, sourceNode.item, {
          parentId: targetNode.item.id
        }));
        __WEBPACK_IMPORTED_MODULE_7__services_badgeSvc__["a" /* default */].addBadge(sourceNode.isFolder ? 'moveFolder' : 'moveFile');
      }
    },
    onContextMenu: function onContextMenu(evt) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var item;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this3.select(undefined, false)) {
                  _context3.next = 7;
                  break;
                }

                evt.preventDefault();
                evt.stopPropagation();
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('contextMenu/open', {
                  coordinates: {
                    left: evt.clientX,
                    top: evt.clientY
                  },
                  items: [{
                    name: 'New file',
                    disabled: !_this3.node.isFolder || _this3.node.isTrash,
                    perform: function perform() {
                      return __WEBPACK_IMPORTED_MODULE_5__services_explorerSvc__["a" /* default */].newItem(false);
                    }
                  }, {
                    name: 'New folder',
                    disabled: !_this3.node.isFolder || _this3.node.isTrash || _this3.node.isTemp,
                    perform: function perform() {
                      return __WEBPACK_IMPORTED_MODULE_5__services_explorerSvc__["a" /* default */].newItem(true);
                    }
                  }, {
                    type: 'separator'
                  }, {
                    name: 'Rename',
                    disabled: _this3.node.isTrash || _this3.node.isTemp,
                    perform: function perform() {
                      return _this3.setEditingId(_this3.node.item.id);
                    }
                  }, {
                    name: 'Delete',
                    perform: function perform() {
                      return __WEBPACK_IMPORTED_MODULE_5__services_explorerSvc__["a" /* default */].deleteItem();
                    }
                  }]
                });

              case 5:
                item = _context3.sent;

                if (item) {
                  item.perform();
                }

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  })
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_editorSvc__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_editor_cledit__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_EditorClassApplier__ = __webpack_require__(305);














var accessor = function accessor(fieldName, setterName) {
  return {
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].state.findReplace[fieldName];
    },
    set: function set(value) {
      __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('findReplace/' + setterName, value);
    }
  };
};

var computedLayoutSetting = function computedLayoutSetting(key) {
  return {
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters['data/layoutSettings'][key];
    },
    set: function set(value) {
      __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].dispatch('data/patchLayoutSettings', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()({}, key, value));
    }
  };
};

var DynamicClassApplier = function DynamicClassApplier(cssClass, offset, silent) {
  var _this = this;

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, DynamicClassApplier);

  this.clean = function () {
    __WEBPACK_IMPORTED_MODULE_7__services_editorSvc__["a" /* default */].clEditor.removeMarker(_this.startMarker);
    __WEBPACK_IMPORTED_MODULE_7__services_editorSvc__["a" /* default */].clEditor.removeMarker(_this.endMarker);
    if (_this.classApplier) {
      _this.classApplier.stop();
    }
  };

  this.startMarker = new __WEBPACK_IMPORTED_MODULE_8__services_editor_cledit__["a" /* default */].Marker(offset.start);
  this.endMarker = new __WEBPACK_IMPORTED_MODULE_8__services_editor_cledit__["a" /* default */].Marker(offset.end);
  __WEBPACK_IMPORTED_MODULE_7__services_editorSvc__["a" /* default */].clEditor.addMarker(this.startMarker);
  __WEBPACK_IMPORTED_MODULE_7__services_editorSvc__["a" /* default */].clEditor.addMarker(this.endMarker);
  if (!silent) {
    this.classApplier = new __WEBPACK_IMPORTED_MODULE_10__common_EditorClassApplier__["a" /* default */](['find-replace-' + this.startMarker.id, cssClass], function () {
      return {
        start: _this.startMarker.offset,
        end: _this.endMarker.offset
      };
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      findCount: 0,
      findPosition: 0
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('findReplace', ['type', 'lastOpen']), {
    findText: accessor('findText', 'setFindText'),
    replaceText: accessor('replaceText', 'setReplaceText'),
    findCaseSensitive: computedLayoutSetting('findCaseSensitive'),
    findUseRegexp: computedLayoutSetting('findUseRegexp')
  }),
  methods: {
    highlightOccurrences: function highlightOccurrences() {
      var _this2 = this;

      var oldClassAppliers = {};
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.classAppliers).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            classApplier = _ref2[1];

        var newKey = classApplier.startMarker.offset + ':' + classApplier.endMarker.offset;
        oldClassAppliers[newKey] = classApplier;
      });
      var offsetList = [];
      this.classAppliers = {};
      if (this.state !== 'destroyed' && this.findText) {
        try {
          this.searchRegex = this.findText;
          if (!this.findUseRegexp) {
            this.searchRegex = this.searchRegex.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
          }
          this.replaceRegex = new RegExp(this.searchRegex, this.findCaseSensitive ? 'm' : 'mi');
          this.searchRegex = new RegExp(this.searchRegex, this.findCaseSensitive ? 'gm' : 'gmi');
          __WEBPACK_IMPORTED_MODULE_7__services_editorSvc__["a" /* default */].clEditor.getContent().replace(this.searchRegex, function () {
            var _ref3;

            var match = arguments.length <= 0 ? undefined : arguments[0];
            var offset = (_ref3 = arguments.length - 2, arguments.length <= _ref3 ? undefined : arguments[_ref3]);
            offsetList.push({
              start: offset,
              end: offset + match.length
            });
          });
          offsetList.forEach(function (offset, i) {
            var key = offset.start + ':' + offset.end;
            _this2.classAppliers[key] = oldClassAppliers[key] || new DynamicClassApplier('find-replace-highlighting', offset, i > 200);
          });
        } catch (e) {}
        if (this.state !== 'created') {
          this.find('selection');
          this.state = 'created';
        }
      }
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(oldClassAppliers).forEach(function (_ref4) {
        var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref4, 2),
            key = _ref5[0],
            classApplier = _ref5[1];

        if (!_this2.classAppliers[key]) {
          classApplier.clean();
          if (classApplier === _this2.selectedClassApplier) {
            _this2.selectedClassApplier.child.clean();
            _this2.selectedClassApplier = null;
          }
        }
      });
      this.findCount = offsetList.length;
    },
    unselectClassApplier: function unselectClassApplier() {
      if (this.selectedClassApplier) {
        this.selectedClassApplier.child.clean();
        this.selectedClassApplier.child = null;
        this.selectedClassApplier = null;
      }
      this.findPosition = 0;
    },
    find: function find() {
      var _this3 = this;

      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'forward';
      var selectedClassApplier = this.selectedClassApplier;

      this.unselectClassApplier();
      var selectionMgr = __WEBPACK_IMPORTED_MODULE_7__services_editorSvc__["a" /* default */].clEditor.selectionMgr;

      var startOffset = Math.min(selectionMgr.selectionStart, selectionMgr.selectionEnd);
      var endOffset = Math.max(selectionMgr.selectionStart, selectionMgr.selectionEnd);
      var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.classAppliers);
      var finder = function finder(checker) {
        return function (key) {
          if (checker(_this3.classAppliers[key]) && selectedClassApplier !== _this3.classAppliers[key]) {
            _this3.selectedClassApplier = _this3.classAppliers[key];
            return true;
          }
          return false;
        };
      };
      if (mode === 'backward') {
        this.selectedClassApplier = this.classAppliers[keys[keys.length - 1]];
        keys.reverse().some(finder(function (classApplier) {
          return classApplier.startMarker.offset <= startOffset;
        }));
      } else if (mode === 'selection') {
        keys.some(finder(function (classApplier) {
          return classApplier.startMarker.offset === startOffset && classApplier.endMarker.offset === endOffset;
        }));
      } else if (mode === 'forward') {
        this.selectedClassApplier = this.classAppliers[keys[0]];
        keys.some(finder(function (classApplier) {
          return classApplier.endMarker.offset >= endOffset;
        }));
      }
      if (this.selectedClassApplier) {
        selectionMgr.setSelectionStartEnd(this.selectedClassApplier.startMarker.offset, this.selectedClassApplier.endMarker.offset);
        this.selectedClassApplier.child = new DynamicClassApplier('find-replace-selection', {
          start: this.selectedClassApplier.startMarker.offset,
          end: this.selectedClassApplier.endMarker.offset
        });
        selectionMgr.updateCursorCoordinates(this.$el.parentNode.clientHeight);

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.classAppliers).forEach(function (key, i) {
          if (_this3.selectedClassApplier !== _this3.classAppliers[key]) {
            return false;
          }
          _this3.findPosition = i + 1;
          return true;
        });
      }
    },
    replace: function replace() {
      var _this4 = this;

      if (this.searchRegex) {
        if (!this.selectedClassApplier) {
          this.find();
          return;
        }
        __WEBPACK_IMPORTED_MODULE_7__services_editorSvc__["a" /* default */].clEditor.replaceAll(this.replaceRegex, this.replaceText, this.selectedClassApplier.startMarker.offset);
        this.$nextTick(function () {
          return _this4.find();
        });
      }
    },
    replaceAll: function replaceAll() {
      if (this.searchRegex) {
        __WEBPACK_IMPORTED_MODULE_7__services_editorSvc__["a" /* default */].clEditor.replaceAll(this.searchRegex, this.replaceText);
      }
    },
    close: function close() {
      __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('findReplace/setType');
    },
    onEscape: function onEscape() {
      __WEBPACK_IMPORTED_MODULE_7__services_editorSvc__["a" /* default */].clEditor.focus();
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    this.classAppliers = {};

    this.debouncedHighlightOccurrences = __WEBPACK_IMPORTED_MODULE_8__services_editor_cledit__["a" /* default */].Utils.debounce(function () {
      return _this5.highlightOccurrences();
    }, 25);

    this.$watch(function () {
      return _this5.findText;
    }, this.debouncedHighlightOccurrences);
    this.$watch(function () {
      return _this5.findCaseSensitive;
    }, this.debouncedHighlightOccurrences);
    this.$watch(function () {
      return _this5.findUseRegexp;
    }, this.debouncedHighlightOccurrences);

    __WEBPACK_IMPORTED_MODULE_7__services_editorSvc__["a" /* default */].clEditor.on('contentChanged', this.debouncedHighlightOccurrences);

    this.$watch(function () {
      return _this5.lastOpen;
    }, function () {
      var elt = _this5.$el.querySelector('.find-replace__text-input--' + _this5.type);
      elt.focus();
      elt.setSelectionRange(0, _this5[_this5.type + 'Text'].length);

      _this5.state = null;
      _this5.debouncedHighlightOccurrences();
    }, {
      immediate: true
    });

    this.onKeyup = function (evt) {
      if (evt.which === 27) {
        __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('findReplace/setType');
      }
    };
    window.addEventListener('keyup', this.onKeyup);

    this.onFocusIn = function () {
      return _this5.$el.contains(document.activeElement) || setTimeout(function () {
        return _this5.unselectClassApplier();
      }, 15);
    };
    window.addEventListener('focusin', this.onFocusIn);
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_7__services_editorSvc__["a" /* default */].clEditor.off('contentChanged', this.debouncedHighlightOccurrences);
    window.removeEventListener('keyup', this.onKeyup);
    window.removeEventListener('focusin', this.onFocusIn);
    this.state = 'destroyed';
    this.debouncedHighlightOccurrences();
  }
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NavigationBar__ = __webpack_require__(2225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ButtonBar__ = __webpack_require__(2217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StatusBar__ = __webpack_require__(2230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Explorer__ = __webpack_require__(2220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SideBar__ = __webpack_require__(2228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Editor__ = __webpack_require__(2219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Preview__ = __webpack_require__(2227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Tour__ = __webpack_require__(2232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__gutters_StickyComment__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__gutters_CurrentDiscussion__ = __webpack_require__(2233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FindReplace__ = __webpack_require__(2222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_editorSvc__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_markdownConversionSvc__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store__ = __webpack_require__(2);



















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    NavigationBar: __WEBPACK_IMPORTED_MODULE_2__NavigationBar__["a" /* default */],
    ButtonBar: __WEBPACK_IMPORTED_MODULE_3__ButtonBar__["a" /* default */],
    StatusBar: __WEBPACK_IMPORTED_MODULE_4__StatusBar__["a" /* default */],
    Explorer: __WEBPACK_IMPORTED_MODULE_5__Explorer__["a" /* default */],
    SideBar: __WEBPACK_IMPORTED_MODULE_6__SideBar__["a" /* default */],
    Editor: __WEBPACK_IMPORTED_MODULE_7__Editor__["a" /* default */],
    Preview: __WEBPACK_IMPORTED_MODULE_8__Preview__["a" /* default */],
    Tour: __WEBPACK_IMPORTED_MODULE_9__Tour__["a" /* default */],
    StickyComment: __WEBPACK_IMPORTED_MODULE_10__gutters_StickyComment__["a" /* default */],
    CurrentDiscussion: __WEBPACK_IMPORTED_MODULE_11__gutters_CurrentDiscussion__["a" /* default */],
    FindReplace: __WEBPACK_IMPORTED_MODULE_12__FindReplace__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['light']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('content', ['revisionContent']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('discussion', ['stickyComment']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('layout', ['constants', 'styles']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('data', ['layoutSettings']), {
    showFindReplace: function showFindReplace() {
      return !!__WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].state.findReplace.type;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('layout', ['updateBodySize']), {
    saveSelection: function saveSelection() {
      return __WEBPACK_IMPORTED_MODULE_13__services_editorSvc__["a" /* default */].saveSelection(true);
    }
  }),
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_14__services_markdownConversionSvc__["a" /* default */].init();
    this.updateBodySize();
    window.addEventListener('resize', this.updateBodySize);
    window.addEventListener('keyup', this.saveSelection);
    window.addEventListener('mouseup', this.saveSelection);
    window.addEventListener('focusin', this.saveSelection);
    window.addEventListener('contextmenu', this.saveSelection);
  },
  mounted: function mounted() {
    var _this = this;

    var editorElt = this.$el.querySelector('.editor__inner');
    var previewElt = this.$el.querySelector('.preview__inner-2');
    var tocElt = this.$el.querySelector('.toc__inner');
    __WEBPACK_IMPORTED_MODULE_13__services_editorSvc__["a" /* default */].init(editorElt, previewElt, tocElt);

    var focus = function focus() {
      if (_this.styles.showEditor) {
        __WEBPACK_IMPORTED_MODULE_13__services_editorSvc__["a" /* default */].clEditor.focus();
      }
    };
    setTimeout(focus, 100);
    this.$watch(function () {
      return _this.styles.showEditor;
    }, focus);
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.updateStyle);
    window.removeEventListener('keyup', this.saveSelection);
    window.removeEventListener('mouseup', this.saveSelection);
    window.removeEventListener('focusin', this.saveSelection);
    window.removeEventListener('contextmenu', this.saveSelection);
  }
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_simpleModals__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_editorSvc__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_syncSvc__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_providers_helpers_googleHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modals_common_ModalInner__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modals_FilePropertiesModal__ = __webpack_require__(2246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modals_SettingsModal__ = __webpack_require__(2253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modals_TemplatesModal__ = __webpack_require__(2256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modals_AboutModal__ = __webpack_require__(2243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modals_HtmlExportModal__ = __webpack_require__(2247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modals_PdfExportModal__ = __webpack_require__(2251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modals_PandocExportModal__ = __webpack_require__(2250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modals_LinkModal__ = __webpack_require__(2249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modals_ImageModal__ = __webpack_require__(2248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modals_SyncManagementModal__ = __webpack_require__(2255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modals_PublishManagementModal__ = __webpack_require__(2252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modals_WorkspaceManagementModal__ = __webpack_require__(2257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modals_AccountManagementModal__ = __webpack_require__(2244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__modals_BadgeManagementModal__ = __webpack_require__(2245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__modals_SponsorModal__ = __webpack_require__(2254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__modals_providers_GooglePhotoModal__ = __webpack_require__(2281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__modals_providers_GoogleDriveAccountModal__ = __webpack_require__(2277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__modals_providers_GoogleDriveSaveModal__ = __webpack_require__(2279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__modals_providers_GoogleDriveWorkspaceModal__ = __webpack_require__(2280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__modals_providers_GoogleDrivePublishModal__ = __webpack_require__(2278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__modals_providers_DropboxAccountModal__ = __webpack_require__(2262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__modals_providers_DropboxSaveModal__ = __webpack_require__(2264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__modals_providers_DropboxPublishModal__ = __webpack_require__(2263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__modals_providers_GithubAccountModal__ = __webpack_require__(2267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__modals_providers_GithubOpenModal__ = __webpack_require__(2268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__modals_providers_GithubSaveModal__ = __webpack_require__(2270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__modals_providers_GithubWorkspaceModal__ = __webpack_require__(2271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__modals_providers_GithubPublishModal__ = __webpack_require__(2269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__modals_providers_GistSyncModal__ = __webpack_require__(2266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__modals_providers_GistPublishModal__ = __webpack_require__(2265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__modals_providers_GitlabAccountModal__ = __webpack_require__(2272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__modals_providers_GitlabOpenModal__ = __webpack_require__(2273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__modals_providers_GitlabPublishModal__ = __webpack_require__(2274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__modals_providers_GitlabSaveModal__ = __webpack_require__(2275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__modals_providers_GitlabWorkspaceModal__ = __webpack_require__(2276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__modals_providers_WordpressPublishModal__ = __webpack_require__(2282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__modals_providers_BloggerPublishModal__ = __webpack_require__(2259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__modals_providers_BloggerPagePublishModal__ = __webpack_require__(2258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__modals_providers_ZendeskAccountModal__ = __webpack_require__(2283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__modals_providers_ZendeskPublishModal__ = __webpack_require__(2284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__modals_providers_CouchdbWorkspaceModal__ = __webpack_require__(2261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__modals_providers_CouchdbCredentialsModal__ = __webpack_require__(2260);

























































var getTabbables = function getTabbables(container) {
  return container.querySelectorAll('a[href], button, .textfield, input[type=checkbox]').cl_filter(function (el) {
    return !el.disabled && el.offsetParent !== null && !el.classList.contains('not-tabbable');
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ModalInner: __WEBPACK_IMPORTED_MODULE_9__modals_common_ModalInner__["a" /* default */],
    FilePropertiesModal: __WEBPACK_IMPORTED_MODULE_10__modals_FilePropertiesModal__["a" /* default */],
    SettingsModal: __WEBPACK_IMPORTED_MODULE_11__modals_SettingsModal__["a" /* default */],
    TemplatesModal: __WEBPACK_IMPORTED_MODULE_12__modals_TemplatesModal__["a" /* default */],
    AboutModal: __WEBPACK_IMPORTED_MODULE_13__modals_AboutModal__["a" /* default */],
    HtmlExportModal: __WEBPACK_IMPORTED_MODULE_14__modals_HtmlExportModal__["a" /* default */],
    PdfExportModal: __WEBPACK_IMPORTED_MODULE_15__modals_PdfExportModal__["a" /* default */],
    PandocExportModal: __WEBPACK_IMPORTED_MODULE_16__modals_PandocExportModal__["a" /* default */],
    LinkModal: __WEBPACK_IMPORTED_MODULE_17__modals_LinkModal__["a" /* default */],
    ImageModal: __WEBPACK_IMPORTED_MODULE_18__modals_ImageModal__["a" /* default */],
    SyncManagementModal: __WEBPACK_IMPORTED_MODULE_19__modals_SyncManagementModal__["a" /* default */],
    PublishManagementModal: __WEBPACK_IMPORTED_MODULE_20__modals_PublishManagementModal__["a" /* default */],
    WorkspaceManagementModal: __WEBPACK_IMPORTED_MODULE_21__modals_WorkspaceManagementModal__["a" /* default */],
    AccountManagementModal: __WEBPACK_IMPORTED_MODULE_22__modals_AccountManagementModal__["a" /* default */],
    BadgeManagementModal: __WEBPACK_IMPORTED_MODULE_23__modals_BadgeManagementModal__["a" /* default */],
    SponsorModal: __WEBPACK_IMPORTED_MODULE_24__modals_SponsorModal__["a" /* default */],

    GooglePhotoModal: __WEBPACK_IMPORTED_MODULE_25__modals_providers_GooglePhotoModal__["a" /* default */],
    GoogleDriveAccountModal: __WEBPACK_IMPORTED_MODULE_26__modals_providers_GoogleDriveAccountModal__["a" /* default */],
    GoogleDriveSaveModal: __WEBPACK_IMPORTED_MODULE_27__modals_providers_GoogleDriveSaveModal__["a" /* default */],
    GoogleDriveWorkspaceModal: __WEBPACK_IMPORTED_MODULE_28__modals_providers_GoogleDriveWorkspaceModal__["a" /* default */],
    GoogleDrivePublishModal: __WEBPACK_IMPORTED_MODULE_29__modals_providers_GoogleDrivePublishModal__["a" /* default */],
    DropboxAccountModal: __WEBPACK_IMPORTED_MODULE_30__modals_providers_DropboxAccountModal__["a" /* default */],
    DropboxSaveModal: __WEBPACK_IMPORTED_MODULE_31__modals_providers_DropboxSaveModal__["a" /* default */],
    DropboxPublishModal: __WEBPACK_IMPORTED_MODULE_32__modals_providers_DropboxPublishModal__["a" /* default */],
    GithubAccountModal: __WEBPACK_IMPORTED_MODULE_33__modals_providers_GithubAccountModal__["a" /* default */],
    GithubOpenModal: __WEBPACK_IMPORTED_MODULE_34__modals_providers_GithubOpenModal__["a" /* default */],
    GithubSaveModal: __WEBPACK_IMPORTED_MODULE_35__modals_providers_GithubSaveModal__["a" /* default */],
    GithubWorkspaceModal: __WEBPACK_IMPORTED_MODULE_36__modals_providers_GithubWorkspaceModal__["a" /* default */],
    GithubPublishModal: __WEBPACK_IMPORTED_MODULE_37__modals_providers_GithubPublishModal__["a" /* default */],
    GistSyncModal: __WEBPACK_IMPORTED_MODULE_38__modals_providers_GistSyncModal__["a" /* default */],
    GistPublishModal: __WEBPACK_IMPORTED_MODULE_39__modals_providers_GistPublishModal__["a" /* default */],
    GitlabAccountModal: __WEBPACK_IMPORTED_MODULE_40__modals_providers_GitlabAccountModal__["a" /* default */],
    GitlabOpenModal: __WEBPACK_IMPORTED_MODULE_41__modals_providers_GitlabOpenModal__["a" /* default */],
    GitlabPublishModal: __WEBPACK_IMPORTED_MODULE_42__modals_providers_GitlabPublishModal__["a" /* default */],
    GitlabSaveModal: __WEBPACK_IMPORTED_MODULE_43__modals_providers_GitlabSaveModal__["a" /* default */],
    GitlabWorkspaceModal: __WEBPACK_IMPORTED_MODULE_44__modals_providers_GitlabWorkspaceModal__["a" /* default */],
    WordpressPublishModal: __WEBPACK_IMPORTED_MODULE_45__modals_providers_WordpressPublishModal__["a" /* default */],
    BloggerPublishModal: __WEBPACK_IMPORTED_MODULE_46__modals_providers_BloggerPublishModal__["a" /* default */],
    BloggerPagePublishModal: __WEBPACK_IMPORTED_MODULE_47__modals_providers_BloggerPagePublishModal__["a" /* default */],
    ZendeskAccountModal: __WEBPACK_IMPORTED_MODULE_48__modals_providers_ZendeskAccountModal__["a" /* default */],
    ZendeskPublishModal: __WEBPACK_IMPORTED_MODULE_49__modals_providers_ZendeskPublishModal__["a" /* default */],
    CouchdbWorkspaceModal: __WEBPACK_IMPORTED_MODULE_50__modals_providers_CouchdbWorkspaceModal__["a" /* default */],
    CouchdbCredentialsModal: __WEBPACK_IMPORTED_MODULE_51__modals_providers_CouchdbCredentialsModal__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['isSponsor']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('modal', ['config']), {
    currentModalComponent: function currentModalComponent() {
      if (this.config.type) {
        var componentName = this.config.type[0].toUpperCase();
        componentName += this.config.type.slice(1);
        componentName += 'Modal';
        if (this.$options.components[componentName]) {
          return componentName;
        }
      }
      return null;
    },
    simpleModal: function simpleModal() {
      return __WEBPACK_IMPORTED_MODULE_4__data_simpleModals__["a" /* default */][this.config.type] || {};
    }
  }),
  methods: {
    sponsor: function sponsor() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters['workspace/sponsorToken']) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].dispatch('modal/open', 'signInForSponsorship');

              case 4:
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_7__services_providers_helpers_googleHelper__["a" /* default */].signin();

              case 6:
                __WEBPACK_IMPORTED_MODULE_6__services_syncSvc__["a" /* default */].requestSync();

              case 7:
                if (__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters.isSponsor) {
                  _context.next = 10;
                  break;
                }

                _context.next = 10;
                return __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].dispatch('modal/open', 'sponsor');

              case 10:
                _context.next = 14;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](0);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 12]]);
      }))();
    },
    onEscape: function onEscape() {
      this.config.reject();
      __WEBPACK_IMPORTED_MODULE_5__services_editorSvc__["a" /* default */].clEditor.focus();
    },
    onTab: function onTab(evt) {
      var tabbables = getTabbables(this.$el);
      var firstTabbable = tabbables[0];
      var lastTabbable = tabbables[tabbables.length - 1];
      if (evt.shiftKey && firstTabbable === evt.target) {
        evt.preventDefault();
        lastTabbable.focus();
      } else if (!evt.shiftKey && lastTabbable === evt.target) {
        evt.preventDefault();
        firstTabbable.focus();
      }
    },
    onFocusInOut: function onFocusInOut(evt) {
      var parentNode = evt.target.parentNode;

      if (parentNode && parentNode.parentNode) {
        if (parentNode.classList.contains('form-entry__field') && parentNode.parentNode.classList.contains('form-entry')) {
          parentNode.parentNode.classList.toggle('form-entry--focused', evt.type === 'focusin');
        }
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$watch(function () {
      return _this2.config;
    }, function (isOpen) {
      if (isOpen) {
        var tabbables = getTabbables(_this2.$el);
        if (tabbables[0]) {
          tabbables[0].focus();
        }
      }
    }, { immediate: true });
  }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_editorSvc__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_syncSvc__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_publishSvc__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_animationSvc__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_tempFileSvc__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__data_pagedownButtons__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_workspaceSvc__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_badgeSvc__ = __webpack_require__(11);



















var mod = /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'Meta' : 'Ctrl';

var getShortcut = function getShortcut(method) {
  var result = '';
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].getters['data/computedSettings'].shortcuts).some(function (_ref) {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
        keys = _ref2[0],
        shortcut = _ref2[1];

    if ('' + (shortcut.method || shortcut) === method) {
      result = keys.split('+').map(function (key) {
        return key.toLowerCase();
      }).map(function (key) {
        if (key === 'mod') {
          return mod;
        }

        return key && '' + key[0].toUpperCase() + key.slice(1);
      }).join('+');
    }
    return result;
  });
  return result && ' \u2013 ' + result;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      mounted: false,
      title: '',
      titleFocus: false,
      titleHover: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])(['light', 'offline']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('queue', ['isSyncRequested', 'isPublishRequested', 'currentLocation']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('layout', ['canUndo', 'canRedo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('content', ['revisionContent']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])('layout', ['styles']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])('syncLocation', {
    syncLocations: 'current'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])('publishLocation', {
    publishLocations: 'current'
  }), {
    pagedownButtons: function pagedownButtons() {
      return __WEBPACK_IMPORTED_MODULE_12__data_pagedownButtons__["a" /* default */].map(function (button) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, button, {
          titleWithShortcut: '' + button.title + getShortcut(button.method),
          iconClass: 'icon-' + button.icon
        });
      });
    },
    isSyncPossible: function isSyncPossible() {
      return __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].getters['workspace/syncToken'] || __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].getters['syncLocation/current'].length;
    },
    showSpinner: function showSpinner() {
      return !__WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].state.queue.isEmpty;
    },
    titleWidth: function titleWidth() {
      if (!this.mounted) {
        return 0;
      }
      this.titleFakeElt.textContent = this.title;
      var width = this.titleFakeElt.getBoundingClientRect().width + 2;
      return Math.min(width, this.styles.titleMaxWidth);
    },
    titleScrolling: function titleScrolling() {
      var result = this.titleHover && !this.titleFocus;
      if (this.titleInputElt) {
        if (result) {
          var scrollLeft = this.titleInputElt.scrollWidth - this.titleInputElt.offsetWidth;
          __WEBPACK_IMPORTED_MODULE_9__services_animationSvc__["a" /* default */].animate(this.titleInputElt).scrollLeft(scrollLeft).duration(scrollLeft * 10).easing('inOut').start();
        } else {
          __WEBPACK_IMPORTED_MODULE_9__services_animationSvc__["a" /* default */].animate(this.titleInputElt).scrollLeft(0).start();
        }
      }
      return result;
    },
    editCancelTrigger: function editCancelTrigger() {
      var current = __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].getters['file/current'];
      return __WEBPACK_IMPORTED_MODULE_11__services_utils__["a" /* default */].serializeObject([current.id, current.name]);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('content', ['setRevisionContent']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('content', ['restoreRevision']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('data', ['toggleExplorer', 'toggleSideBar']), {
    undo: function undo() {
      return __WEBPACK_IMPORTED_MODULE_6__services_editorSvc__["a" /* default */].clEditor.undoMgr.undo();
    },
    redo: function redo() {
      return __WEBPACK_IMPORTED_MODULE_6__services_editorSvc__["a" /* default */].clEditor.undoMgr.redo();
    },
    requestSync: function requestSync() {
      if (this.isSyncPossible && !this.isSyncRequested) {
        __WEBPACK_IMPORTED_MODULE_7__services_syncSvc__["a" /* default */].requestSync(true);
      }
    },
    requestPublish: function requestPublish() {
      if (this.publishLocations.length && !this.isPublishRequested) {
        __WEBPACK_IMPORTED_MODULE_8__services_publishSvc__["a" /* default */].requestPublish();
      }
    },
    pagedownClick: function pagedownClick(name) {
      if (__WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].getters['content/isCurrentEditable']) {
        var text = __WEBPACK_IMPORTED_MODULE_6__services_editorSvc__["a" /* default */].clEditor.getContent();
        __WEBPACK_IMPORTED_MODULE_6__services_editorSvc__["a" /* default */].pagedownEditor.uiManager.doClick(name);
        if (text !== __WEBPACK_IMPORTED_MODULE_6__services_editorSvc__["a" /* default */].clEditor.getContent()) {
          __WEBPACK_IMPORTED_MODULE_15__services_badgeSvc__["a" /* default */].addBadge('formatButtons');
        }
      }
    },
    editTitle: function editTitle(toggle) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var title;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.titleFocus = toggle;

                if (!toggle) {
                  _context.next = 5;
                  break;
                }

                _this.titleInputElt.setSelectionRange(0, _this.titleInputElt.value.length);
                _context.next = 16;
                break;

              case 5:
                title = _this.title.trim();

                _this.title = __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].getters['file/current'].name;

                if (!(title && _this.title !== title)) {
                  _context.next = 16;
                  break;
                }

                _context.prev = 8;
                _context.next = 11;
                return __WEBPACK_IMPORTED_MODULE_14__services_workspaceSvc__["a" /* default */].storeItem(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].getters['file/current'], {
                  name: title
                }));

              case 11:
                __WEBPACK_IMPORTED_MODULE_15__services_badgeSvc__["a" /* default */].addBadge('editCurrentFileName');
                _context.next = 16;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](8);

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[8, 14]]);
      }))();
    },
    submitTitle: function submitTitle(reset) {
      if (reset) {
        this.title = '';
      }
      this.titleInputElt.blur();
    },
    close: function close() {
      __WEBPACK_IMPORTED_MODULE_10__services_tempFileSvc__["a" /* default */].close();
    }
  }),
  created: function created() {
    var _this2 = this;

    this.$watch(function () {
      return _this2.editCancelTrigger;
    }, function () {
      _this2.title = '';
      _this2.editTitle(false);
    }, { immediate: true });
  },
  mounted: function mounted() {
    this.titleFakeElt = this.$el.querySelector('.navigation-bar__title--fake');
    this.titleInputElt = this.$el.querySelector('.navigation-bar__title--input');
    this.mounted = true;
  }
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapState */])('notification', ['items'])
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gutters_CommentList__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gutters_PreviewNewDiscussionButton__ = __webpack_require__(2235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(2);








var appUri = window.location.protocol + '//' + window.location.host;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CommentList: __WEBPACK_IMPORTED_MODULE_2__gutters_CommentList__["a" /* default */],
    PreviewNewDiscussionButton: __WEBPACK_IMPORTED_MODULE_3__gutters_PreviewNewDiscussionButton__["a" /* default */]
  },
  data: function data() {
    return {
      previewTop: true
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('file', ['isCurrentTemp']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('layout', ['styles'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('data', ['toggleEditor']), {
    onClick: function onClick(evt) {
      var elt = evt.target;
      while (elt !== this.$el) {
        if (elt.href && elt.href.match(/^https?:\/\//) && (!elt.hash || elt.href.slice(0, appUri.length) !== appUri)) {
          evt.preventDefault();
          var wnd = window.open(elt.href, '_blank');
          wnd.focus();
          return;
        }
        elt = elt.parentNode;
      }
    },
    onScroll: function onScroll(evt) {
      this.previewTop = evt.target.scrollTop < 10;
    }
  }),
  mounted: function mounted() {
    var previewElt = this.$el.querySelector('.preview__inner-2');
    var onDiscussionEvt = function onDiscussionEvt(cb) {
      return function (evt) {
        var elt = evt.target;
        while (elt && elt !== previewElt) {
          if (elt.discussionId) {
            cb(elt.discussionId);
            return;
          }
          elt = elt.parentNode;
        }
      };
    };

    var classToggler = function classToggler(toggle) {
      return function (discussionId) {
        previewElt.getElementsByClassName('discussion-preview-highlighting--' + discussionId).cl_each(function (elt) {
          return elt.classList.toggle('discussion-preview-highlighting--hover', toggle);
        });
        document.getElementsByClassName('comment--discussion-' + discussionId).cl_each(function (elt) {
          return elt.classList.toggle('comment--hover', toggle);
        });
      };
    };

    previewElt.addEventListener('mouseover', onDiscussionEvt(classToggler(true)));
    previewElt.addEventListener('mouseout', onDiscussionEvt(classToggler(false)));
    previewElt.addEventListener('click', onDiscussionEvt(function (discussionId) {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('discussion/setCurrentDiscussionId', discussionId);
    }));

    this.$watch(function () {
      return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.discussion.currentDiscussionId;
    }, function (discussionId, oldDiscussionId) {
      if (oldDiscussionId) {
        previewElt.querySelectorAll('.discussion-preview-highlighting--' + oldDiscussionId).cl_each(function (elt) {
          return elt.classList.remove('discussion-preview-highlighting--selected');
        });
      }
      if (discussionId) {
        previewElt.querySelectorAll('.discussion-preview-highlighting--' + discussionId).cl_each(function (elt) {
          return elt.classList.add('discussion-preview-highlighting--selected');
        });
      }
    });
  }
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Toc__ = __webpack_require__(2231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__menus_MainMenu__ = __webpack_require__(2238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__menus_WorkspacesMenu__ = __webpack_require__(2242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__menus_SyncMenu__ = __webpack_require__(2240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__menus_PublishMenu__ = __webpack_require__(2239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__menus_HistoryMenu__ = __webpack_require__(2236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__menus_ImportExportMenu__ = __webpack_require__(2237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__menus_WorkspaceBackupMenu__ = __webpack_require__(2241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_markdownSample_md__ = __webpack_require__(2203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_markdownSample_md___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__data_markdownSample_md__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_markdownConversionSvc__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__(2);
















var panelNames = {
  menu: 'Menu',
  workspaces: 'Workspaces',
  help: 'Markdown cheat sheet',
  toc: 'Table of contents',
  sync: 'Synchronize',
  publish: 'Publish',
  history: 'File history',
  importExport: 'Import/export',
  workspaceBackups: 'Workspace backups'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Toc: __WEBPACK_IMPORTED_MODULE_2__Toc__["a" /* default */],
    MainMenu: __WEBPACK_IMPORTED_MODULE_3__menus_MainMenu__["a" /* default */],
    WorkspacesMenu: __WEBPACK_IMPORTED_MODULE_4__menus_WorkspacesMenu__["a" /* default */],
    SyncMenu: __WEBPACK_IMPORTED_MODULE_5__menus_SyncMenu__["a" /* default */],
    PublishMenu: __WEBPACK_IMPORTED_MODULE_6__menus_PublishMenu__["a" /* default */],
    HistoryMenu: __WEBPACK_IMPORTED_MODULE_7__menus_HistoryMenu__["a" /* default */],
    ImportExportMenu: __WEBPACK_IMPORTED_MODULE_8__menus_ImportExportMenu__["a" /* default */],
    WorkspaceBackupMenu: __WEBPACK_IMPORTED_MODULE_9__menus_WorkspaceBackupMenu__["a" /* default */]
  },
  data: function data() {
    return {
      markdownSample: __WEBPACK_IMPORTED_MODULE_11__services_markdownConversionSvc__["a" /* default */].highlight(__WEBPACK_IMPORTED_MODULE_10__data_markdownSample_md___default.a)
    };
  },
  computed: {
    panel: function panel() {
      if (__WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].state.light) {
        return null;
      }
      var result = __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters['data/layoutSettings'].sideBarPanel;
      return panelNames[result] ? result : 'menu';
    },
    panelName: function panelName() {
      return panelNames[this.panel];
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('data', ['toggleSideBar']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('data', {
    setPanel: 'setSideBarPanel'
  }))
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_utils__ = __webpack_require__(4);







var Stat = function Stat(name, regex) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Stat);

  this.id = __WEBPACK_IMPORTED_MODULE_3__services_utils__["a" /* default */].uid();
  this.name = name;
  this.regex = new RegExp(regex, 'gm');
  this.value = null;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      textSelection: false,
      htmlSelection: false,
      line: 0,
      column: 0,
      textStats: [new Stat('bytes', '[\\s\\S]'), new Stat('words', '\\S+'), new Stat('lines', '\n')],
      htmlStats: [new Stat('characters', '\\S'), new Stat('words', '\\S+'), new Stat('paragraphs', '\\S.*')]
    };
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('layout', ['styles']),
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].$on('sectionList', function () {
      return _this.computeText();
    });
    __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].$on('selectionRange', function () {
      return _this.computeText();
    });
    __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].$on('previewCtx', function () {
      return _this.computeHtml();
    });
    __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].$on('previewSelectionRange', function () {
      return _this.computeHtml();
    });
  },


  methods: {
    computeText: function computeText() {
      var _this2 = this;

      setTimeout(function () {
        _this2.textSelection = false;
        var text = __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].clEditor.getContent();
        var beforeText = text.slice(0, __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].clEditor.selectionMgr.selectionEnd);
        var beforeLines = beforeText.split('\n');
        _this2.line = beforeLines.length;
        _this2.column = beforeLines.pop().length;

        var selectedText = __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].clEditor.selectionMgr.getSelectedText();
        if (selectedText) {
          _this2.textSelection = true;
          text = selectedText;
        }
        _this2.textStats.forEach(function (stat) {
          stat.value = (text.match(stat.regex) || []).length;
        });
      }, 10);
    },
    computeHtml: function computeHtml() {
      var _this3 = this;

      setTimeout(function () {
        var text = void 0;
        if (__WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].previewSelectionRange) {
          text = '' + __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].previewSelectionRange;
        }
        _this3.htmlSelection = true;
        if (!text) {
          _this3.htmlSelection = false;
          text = __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].previewCtx.text;
        }
        if (text != null) {
          _this3.htmlStats.forEach(function (stat) {
            stat.value = (text.match(stat.regex) || []).length;
          });
        }
      }, 10);
    }
  }
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__ = __webpack_require__(28);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      maskY: 0
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('layout', ['styles'])),
  mounted: function mounted() {
    var _this = this;

    var tocElt = this.$el.querySelector('.toc__inner');

    var isMousedown = void 0;
    function onClick(e) {
      if (!isMousedown) {
        return;
      }
      e.preventDefault();
      var y = e.clientY - tocElt.getBoundingClientRect().top;

      __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].previewCtx.sectionDescList.some(function (sectionDesc) {
        if (y >= sectionDesc.tocDimension.endOffset) {
          return false;
        }
        var posInSection = (y - sectionDesc.tocDimension.startOffset) / (sectionDesc.tocDimension.height || 1);
        var editorScrollTop = sectionDesc.editorDimension.startOffset + sectionDesc.editorDimension.height * posInSection;
        __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].editorElt.parentNode.scrollTop = editorScrollTop;
        var previewScrollTop = sectionDesc.previewDimension.startOffset + sectionDesc.previewDimension.height * posInSection;
        __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].previewElt.parentNode.scrollTop = previewScrollTop;
        return true;
      });
    }

    tocElt.addEventListener('mouseup', function () {
      isMousedown = false;
    });
    tocElt.addEventListener('mouseleave', function () {
      isMousedown = false;
    });
    tocElt.addEventListener('mousedown', function (e) {
      isMousedown = e.which === 1;
      onClick(e);
    });
    tocElt.addEventListener('mousemove', function (e) {
      onClick(e);
    });

    var updateMaskY = function updateMaskY() {
      var scrollPosition = __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].getScrollPosition();
      if (scrollPosition) {
        var sectionDesc = __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].previewCtxMeasured.sectionDescList[scrollPosition.sectionIdx];
        _this.maskY = sectionDesc.tocDimension.startOffset + scrollPosition.posInSection * sectionDesc.tocDimension.height;
      }
    };

    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].editorElt.parentNode.addEventListener('scroll', function () {
        if (_this.styles.showEditor) {
          updateMaskY();
        }
      });
      __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].previewElt.parentNode.addEventListener('scroll', function () {
        if (!_this.styles.showEditor) {
          updateMaskY();
        }
      });
    });
  }
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(2);





var steps = ['welcome', 'editor', 'explorer', 'menu', 'end'];

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      stepIdx: 0,
      stepStyles: {}
    };
  },
  computed: {
    step: function step() {
      return steps[this.stepIdx];
    },
    stepStyle: function stepStyle() {
      return this.stepStyles[this.step] || {};
    }
  },
  methods: {
    updatePositions: function updatePositions() {
      var _this = this;

      document.querySelectorAll('[tour-step-anchor]').cl_each(function (anchorElt) {
        var anchorRect = anchorElt.getBoundingClientRect();
        var anchorSteps = (anchorElt.getAttribute('tour-step-anchor') || '').split(',');
        anchorSteps.forEach(function (step) {
          var style = {
            top: anchorRect.top + anchorRect.height / 2 + 'px',
            left: anchorRect.left + anchorRect.width / 2 + 'px'
          };
          switch (step) {
            case 'welcome':
            case 'end':
              {
                style.top = anchorRect.top + 'px';
                break;
              }
            case 'editor':
            case 'menu':
              {
                style.left = anchorRect.left + 'px';
                break;
              }
            case 'explorer':
              {
                style.left = anchorRect.left + anchorRect.width + 'px';
                break;
              }
            default:
              return;
          }
          __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(_this.stepStyles, step, style);
        });
      });
    },
    finish: function finish() {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('data/patchLayoutSettings', {
        welcomeTourFinished: true
      });
    },
    next: function next() {
      this.stepIdx += 1;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$watch(function () {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['layout/styles'];
    }, function () {
      return _this2.updatePositions();
    }, { immediate: true });
  }
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_userSvc__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['userId'],
  computed: {
    sanitizedUserId: function sanitizedUserId() {
      return __WEBPACK_IMPORTED_MODULE_0__services_userSvc__["a" /* default */].sanitizeUserId(this.userId);
    },
    url: function url() {
      var userInfo = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.userInfo.itemsById[this.sanitizedUserId];
      return userInfo && userInfo.imageUrl && 'url(\'' + userInfo.imageUrl + '\')';
    }
  },
  watch: {
    sanitizedUserId: {
      handler: function handler(sanitizedUserId) {
        return __WEBPACK_IMPORTED_MODULE_0__services_userSvc__["a" /* default */].addUserId(sanitizedUserId);
      },
      immediate: true
    }
  }
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_userSvc__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['userId'],
  computed: {
    sanitizedUserId: function sanitizedUserId() {
      return __WEBPACK_IMPORTED_MODULE_0__services_userSvc__["a" /* default */].sanitizeUserId(this.userId);
    },
    name: function name() {
      var userInfo = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.userInfo.itemsById[this.sanitizedUserId];
      return userInfo ? userInfo.name : 'Someone';
    }
  },
  watch: {
    sanitizedUserId: {
      handler: function handler(sanitizedUserId) {
        return __WEBPACK_IMPORTED_MODULE_0__services_userSvc__["a" /* default */].addUserId(sanitizedUserId);
      },
      immediate: true
    }
  }
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserImage__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserName__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_editorSvc__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__libs_htmlSanitizer__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_badgeSvc__ = __webpack_require__(11);













/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    UserImage: __WEBPACK_IMPORTED_MODULE_4__UserImage__["a" /* default */],
    UserName: __WEBPACK_IMPORTED_MODULE_5__UserName__["a" /* default */]
  },
  props: ['comment'],
  computed: {
    showReply: function showReply() {
      return this.comment === __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters['discussion/currentDiscussionLastComment'] && !__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].state.discussion.isCommenting;
    },
    text: function text() {
      return __WEBPACK_IMPORTED_MODULE_7__libs_htmlSanitizer__["a" /* default */].sanitizeHtml(__WEBPACK_IMPORTED_MODULE_6__services_editorSvc__["a" /* default */].converter.render(this.comment.text));
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('discussion', ['setIsCommenting']), {
    removeComment: function removeComment() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].dispatch('modal/open', 'commentDeletion');

              case 3:
                __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].dispatch('discussion/cleanCurrentFile', { filterComment: _this.comment });
                __WEBPACK_IMPORTED_MODULE_9__services_badgeSvc__["a" /* default */].addBadge('removeComment');
                _context.next = 9;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    }
  }),
  mounted: function mounted() {
    var isSticky = this.$el.parentNode.classList.contains('sticky-comment');
    if (isSticky) {
      var commentId = __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters['discussion/currentDiscussionLastCommentId'];
      var scrollerElt = this.$el.querySelector('.comment__text-inner');

      var scrollerMirrorElt = void 0;
      var getScrollerMirrorElt = function getScrollerMirrorElt() {
        if (!scrollerMirrorElt) {
          scrollerMirrorElt = document.querySelector('.comment-list .comment--' + commentId + ' .comment__text-inner');
        }
        return scrollerMirrorElt || { scrollTop: 0 };
      };

      scrollerElt.scrollTop = getScrollerMirrorElt().scrollTop;
      scrollerElt.addEventListener('scroll', function () {
        getScrollerMirrorElt().scrollTop = scrollerElt.scrollTop;
      });
    }
  }
});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Comment__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NewComment__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_editorSvc__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_utils__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Comment: __WEBPACK_IMPORTED_MODULE_4__Comment__["a" /* default */],
    NewComment: __WEBPACK_IMPORTED_MODULE_5__NewComment__["a" /* default */]
  },
  data: function data() {
    return {
      tops: {}
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('layout', ['constants', 'styles']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('discussion', ['currentDiscussionId', 'isCommenting', 'newCommentText', 'stickyComment']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('discussion', ['newDiscussion', 'currentDiscussion', 'currentFileDiscussions', 'currentFileDiscussionLastComments', 'currentDiscussionComments', 'currentDiscussionLastCommentId']), {
    updateTopsTrigger: function updateTopsTrigger() {
      return __WEBPACK_IMPORTED_MODULE_8__services_utils__["a" /* default */].serializeObject([this.styles, this.currentFileDiscussionLastComments, this.currentDiscussionComments, this.currentDiscussionId, this.isCommenting]);
    },
    updateStickyTrigger: function updateStickyTrigger() {
      return __WEBPACK_IMPORTED_MODULE_8__services_utils__["a" /* default */].serializeObject([this.updateTopsTrigger, this.newCommentText]);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('discussion', ['setCurrentDiscussionId']), {
    updateTops: function updateTops() {
      var _this = this;

      var layoutSettings = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters['data/layoutSettings'];
      var minTop = -2;
      var minCommentTop = minTop;
      var getTop = function getTop(discussion, commentElt1, commentElt2, isCurrent) {
        var firstElt = commentElt1 || commentElt2;
        var secondElt = commentElt1 && commentElt2;
        var coordinates = layoutSettings.showEditor ? __WEBPACK_IMPORTED_MODULE_6__services_editorSvc__["a" /* default */].clEditor.selectionMgr.getCoordinates(discussion.end) : __WEBPACK_IMPORTED_MODULE_6__services_editorSvc__["a" /* default */].getPreviewOffsetCoordinates(__WEBPACK_IMPORTED_MODULE_6__services_editorSvc__["a" /* default */].getPreviewOffset(discussion.end));
        var commentTop = minTop;
        if (coordinates) {
          commentTop = coordinates.top + coordinates.height - 80;
        }
        var top = commentTop;
        if (isCurrent) {
          top -= firstElt.offsetTop + 2;
        }
        if (top < minTop) {
          commentTop += minTop - top;
          top = minTop;
        }
        if (commentTop < minCommentTop) {
          top += minCommentTop - commentTop;
          commentTop = minCommentTop;
        }
        minCommentTop = commentTop + firstElt.offsetHeight + 60;
        if (secondElt) {
          minCommentTop += secondElt.offsetHeight;
        }
        return top;
      };

      var tops = {};
      var discussions = this.currentFileDiscussions;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(discussions).sort(function (_ref, _ref2) {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            discussion1 = _ref4[1];

        var _ref3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
            discussion2 = _ref3[1];

        return discussion1.end - discussion2.end;
      }).forEach(function (_ref5) {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
            discussionId = _ref6[0],
            discussion = _ref6[1];

        if (discussion === _this.currentDiscussion || discussion === _this.newDiscussion) {
          tops.current = getTop(discussion, _this.currentDiscussionLastCommentId && _this.$el.querySelector('.comment--' + _this.currentDiscussionLastCommentId), _this.$el.querySelector('.comment--new'), true);
        } else {
          tops[discussionId] = getTop(discussion, _this.$el.querySelector('.comment--discussion-' + discussionId));
        }
      });
      this.tops = tops;
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.$watch(function () {
      return _this2.updateTopsTrigger;
    }, function () {
      return _this2.updateTops();
    }, { immediate: true });

    var layoutSettings = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters['data/layoutSettings'];
    this.scrollerElt = layoutSettings.showEditor ? __WEBPACK_IMPORTED_MODULE_6__services_editorSvc__["a" /* default */].editorElt.parentNode : __WEBPACK_IMPORTED_MODULE_6__services_editorSvc__["a" /* default */].previewElt.parentNode;

    this.updateSticky = function () {
      var height = 0;
      var offsetTop = _this2.tops.current;
      var lastCommentElt = _this2.$el.querySelector('.comment--' + _this2.currentDiscussionLastCommentId);
      if (lastCommentElt) {
        height += lastCommentElt.clientHeight;
        offsetTop += lastCommentElt.offsetTop;
      }
      var newCommentElt = _this2.$el.querySelector('.comment--new');
      if (newCommentElt) {
        height += newCommentElt.clientHeight;
      }
      var currentDiscussionElt = document.querySelector('.current-discussion__inner');
      var minOffsetTop = _this2.scrollerElt.scrollTop + 10;
      var maxOffsetTop = _this2.scrollerElt.scrollTop + _this2.scrollerElt.clientHeight - height - currentDiscussionElt.clientHeight;
      var stickyComment = null;
      if (offsetTop > maxOffsetTop || maxOffsetTop < minOffsetTop) {
        stickyComment = 'bottom';
      } else if (offsetTop < minOffsetTop) {
        stickyComment = 'top';
      }
      if (__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state.discussion.stickyComment !== stickyComment) {
        __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('discussion/setStickyComment', stickyComment);
      }
    };

    this.scrollerElt.addEventListener('scroll', this.updateSticky);
    this.$watch(function () {
      return _this2.updateStickyTrigger;
    }, function () {
      return _this2.updateSticky();
    }, { immediate: true });

    if (!__WEBPACK_IMPORTED_MODULE_6__services_editorSvc__["a" /* default */].previewCtxWithDiffs) {
      __WEBPACK_IMPORTED_MODULE_6__services_editorSvc__["a" /* default */].$once('previewCtxWithDiffs', function () {
        _this2.updateTops();
        _this2.updateSticky();
      });
    }
  },
  destroyed: function destroyed() {
    this.scrollerElt.removeEventListener('scroll', this.updateSticky);
  }
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_animationSvc__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_markdownConversionSvc__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StickyComment__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_badgeSvc__ = __webpack_require__(11);













/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StickyComment: __WEBPACK_IMPORTED_MODULE_7__StickyComment__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('discussion', ['stickyComment', 'currentDiscussionId']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('discussion', ['currentDiscussion', 'previousDiscussionId', 'nextDiscussionId', 'currentFileDiscussions', 'currentDiscussionLastCommentId']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('layout', ['constants']), {
    text: function text() {
      return __WEBPACK_IMPORTED_MODULE_6__services_markdownConversionSvc__["a" /* default */].highlight(this.currentDiscussion.text);
    },
    showNext: function showNext() {
      return this.nextDiscussionId && this.nextDiscussionId !== this.currentDiscussionId;
    },
    showRemove: function showRemove() {
      return this.currentDiscussionLastCommentId;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('discussion', ['setCurrentDiscussionId']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('notification', ['info']), {
    goToDiscussion: function goToDiscussion() {
      var discussionId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currentDiscussionId;

      this.setCurrentDiscussionId(discussionId);
      var layoutSettings = __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters['data/layoutSettings'];
      var discussion = this.currentFileDiscussions[discussionId];
      var coordinates = layoutSettings.showEditor ? __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].clEditor.selectionMgr.getCoordinates(discussion.end) : __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].getPreviewOffsetCoordinates(__WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].getPreviewOffset(discussion.end));
      if (!coordinates) {
        this.info("Discussion can't be located in the file.");
      } else {
        var scrollerElt = layoutSettings.showEditor ? __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].editorElt.parentNode : __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].previewElt.parentNode;
        var scrollTop = coordinates.top - scrollerElt.offsetHeight / 2;
        var maxScrollTop = scrollerElt.scrollHeight - scrollerElt.offsetHeight;
        if (scrollTop < 0) {
          scrollTop = 0;
        } else if (scrollTop > maxScrollTop) {
          scrollTop = maxScrollTop;
        }
        __WEBPACK_IMPORTED_MODULE_5__services_animationSvc__["a" /* default */].animate(scrollerElt).scrollTop(scrollTop).duration(200).start();
      }
    },
    removeDiscussion: function removeDiscussion() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].dispatch('modal/open', 'discussionDeletion');

              case 3:
                __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].dispatch('discussion/cleanCurrentFile', {
                  filterDiscussion: _this.currentDiscussion
                });
                __WEBPACK_IMPORTED_MODULE_9__services_badgeSvc__["a" /* default */].addBadge('removeDiscussion');
                _context.next = 9;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    }
  })
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selection: null,
      coordinates: null
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('discussion', ['createNewDiscussion']), {
    checkSelection: function checkSelection() {
      var _this = this;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        var offset = void 0;

        if (!__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.content.revisionContent && __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].clEditor.selectionMgr.hasFocus()) {
          _this.selection = __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].getTrimmedSelection();
          if (_this.selection) {
            var text = __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].clEditor.getContent();
            offset = _this.selection.end;
            while (offset && text[offset - 1] === '\n') {
              offset -= 1;
            }
          }
        }
        _this.coordinates = offset ? __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].clEditor.selectionMgr.getCoordinates(offset) : null;
      }, 25);
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].clEditor.selectionMgr.on('selectionChanged', function () {
        return _this2.checkSelection();
      });
      __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].clEditor.selectionMgr.on('cursorCoordinatesChanged', function () {
        return _this2.checkSelection();
      });
      __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].clEditor.on('focus', function () {
        return _this2.checkSelection();
      });
      __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].clEditor.on('blur', function () {
        return _this2.checkSelection();
      });
      _this2.checkSelection();
    });
  }
});

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prismjs__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prismjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserImage__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_editor_cledit__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_editorSvc__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_markdownConversionSvc__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_userSvc__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_badgeSvc__ = __webpack_require__(11);















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    UserImage: __WEBPACK_IMPORTED_MODULE_4__UserImage__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('workspace', ['loginToken']), {
    userId: function userId() {
      return __WEBPACK_IMPORTED_MODULE_9__services_userSvc__["a" /* default */].getCurrentUserId();
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapMutations */])('discussion', ['setNewCommentFocus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('discussion', ['cancelNewComment']), {
    addComment: function addComment() {
      var text = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.discussion.newCommentText.trim();
      if (text.length) {
        if (text.length > 2000) {
          __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].dispatch('notification/error', 'Comment is too long.');
        } else {
          var discussionId = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.discussion.currentDiscussionId;
          var comment = {
            discussionId: discussionId,
            sub: this.userId,
            text: text,
            created: Date.now()
          };
          var patch = {
            comments: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters['content/current'].comments, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_8__services_utils__["a" /* default */].uid(), comment))
          };
          if (discussionId === __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.discussion.newDiscussionId) {
            patch.discussions = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters['content/current'].discussions, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, discussionId, __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters['discussion/newDiscussion']));
            __WEBPACK_IMPORTED_MODULE_11__services_badgeSvc__["a" /* default */].addBadge('createDiscussion');
          } else {
            __WEBPACK_IMPORTED_MODULE_11__services_badgeSvc__["a" /* default */].addBadge('addComment');
          }
          __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].dispatch('content/patchCurrent', patch);
          __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('discussion/setNewCommentText');
          __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('discussion/setIsCommenting');
        }
      }
    }
  }),
  mounted: function mounted() {
    var _this = this;

    var preElt = this.$el.querySelector('pre.markdown-highlighting');
    var scrollerElt = this.$el.querySelector('.comment__text-inner');
    var clEditor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_editor_cledit__["a" /* default */])(preElt, scrollerElt, true);
    clEditor.init({
      sectionHighlighter: function sectionHighlighter(section) {
        return __WEBPACK_IMPORTED_MODULE_3_prismjs___default.a.highlight(section.text, __WEBPACK_IMPORTED_MODULE_6__services_editorSvc__["a" /* default */].prismGrammars[section.data]);
      },
      sectionParser: function sectionParser(text) {
        return __WEBPACK_IMPORTED_MODULE_7__services_markdownConversionSvc__["a" /* default */].parseSections(__WEBPACK_IMPORTED_MODULE_6__services_editorSvc__["a" /* default */].converter, text).sections;
      },
      content: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.discussion.newCommentText,
      selectionStart: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.discussion.newCommentSelection.start,
      selectionEnd: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.discussion.newCommentSelection.end,
      getCursorFocusRatio: function getCursorFocusRatio() {
        return 0.2;
      }
    });
    clEditor.on('focus', function () {
      return _this.setNewCommentFocus(true);
    });

    clEditor.on('contentChanged', function (value) {
      return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('discussion/setNewCommentText', value);
    });
    clEditor.selectionMgr.on('selectionChanged', function (start, end) {
      return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('discussion/setNewCommentSelection', {
        start: start, end: end
      });
    });

    var isSticky = this.$el.parentNode.classList.contains('sticky-comment');
    var isVisible = function isVisible() {
      return isSticky || __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.discussion.stickyComment === null;
    };

    this.$watch(function () {
      return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.discussion.currentDiscussionId;
    }, function () {
      return _this.$nextTick(function () {
        if (isVisible() && __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.discussion.newCommentFocus) {
          clEditor.focus();
        }
      });
    }, { immediate: true });

    if (isSticky) {
      var scrollerMirrorElt = void 0;
      var getScrollerMirrorElt = function getScrollerMirrorElt() {
        if (!scrollerMirrorElt) {
          scrollerMirrorElt = document.querySelector('.comment-list .comment--new .comment__text-inner');
        }
        return scrollerMirrorElt || { scrollTop: 0 };
      };

      scrollerElt.scrollTop = getScrollerMirrorElt().scrollTop;
      scrollerElt.addEventListener('scroll', function () {
        getScrollerMirrorElt().scrollTop = scrollerElt.scrollTop;
      });
    } else {
      this.$watch(function () {
        return isVisible();
      }, function (visible) {
        clEditor.toggleEditable(visible);
        if (visible) {
          var text = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.discussion.newCommentText;
          clEditor.setContent(text);
          var selection = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.discussion.newCommentSelection;
          clEditor.selectionMgr.setSelectionStartEnd(selection.start, selection.end);
          if (__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.discussion.newCommentFocus) {
            clEditor.focus();
          }
        }
      }, { immediate: true });
      this.$watch(function () {
        return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.discussion.newCommentText;
      }, function (newCommentText) {
        return clEditor.setContent(newCommentText);
      });
    }
  }
});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selection: null,
      coordinates: null
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('discussion', ['createNewDiscussion']), {
    checkSelection: function checkSelection() {
      var _this = this;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        var offset = void 0;

        if (!__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.content.revisionContent && __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].previewSelectionRange) {
          _this.selection = __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].getTrimmedSelection();
          if (_this.selection) {
            var text = __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].previewCtxWithDiffs.text;

            offset = __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].getPreviewOffset(_this.selection.end);
            while (offset && text[offset - 1] === '\n') {
              offset -= 1;
            }
          }
        }
        _this.coordinates = offset ? __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].getPreviewOffsetCoordinates(offset) : null;
      }, 25);
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_2__services_editorSvc__["a" /* default */].$on('previewSelectionRange', function () {
        return _this2.checkSelection();
      });
      _this2.$watch(function () {
        return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['layout/styles'].previewWidth;
      }, function () {
        return _this2.checkSelection();
      });
      _this2.checkSelection();
    });
  }
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Comment__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NewComment__ = __webpack_require__(855);







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Comment: __WEBPACK_IMPORTED_MODULE_2__Comment__["a" /* default */],
    NewComment: __WEBPACK_IMPORTED_MODULE_3__NewComment__["a" /* default */]
  },
  data: function data() {
    return {
      top: 0
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('layout', ['constants']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('discussion', ['isCommenting']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('discussion', ['currentDiscussionLastComment']))
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_providers_common_providerRegistry__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_MenuEntry__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UserImage__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__UserName__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_EditorClassApplier__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_PreviewClassApplier__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_providers_helpers_googleHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_syncSvc__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_badgeSvc__ = __webpack_require__(11);




















var editorClassAppliers = [];
var previewClassAppliers = [];

var cachedHistoryContextHash = void 0;
var revisionsPromise = void 0;
var revisionContentPromises = void 0;
var pageSize = 30;
var spacerThreshold = 6 * 60 * 60 * 1000;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MenuEntry: __WEBPACK_IMPORTED_MODULE_7__common_MenuEntry__["a" /* default */],
    UserImage: __WEBPACK_IMPORTED_MODULE_8__UserImage__["a" /* default */],
    UserName: __WEBPACK_IMPORTED_MODULE_9__UserName__["a" /* default */]
  },
  data: function data() {
    return {
      allRevisions: [],
      loading: false,
      showCount: pageSize,
      syncLocationId: null
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])('data', ['syncDataByItemId']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])('syncLocation', {
    syncLocations: 'currentWithWorkspaceSyncLocation'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('content', ['revisionContent']), {
    syncLocation: function syncLocation() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_12__services_utils__["a" /* default */].someResult(this.syncLocations, function (syncLocation) {
        if (syncLocation.id === _this.syncLocationId) {
          return syncLocation;
        }
        return null;
      });
    },
    syncLocationProviderName: function syncLocationProviderName() {
      if (!this.syncLocation) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_6__services_providers_common_providerRegistry__["a" /* default */].providersById[this.syncLocation.providerId].name;
    },
    currentFileName: function currentFileName() {
      return __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].getters['file/current'].name;
    },
    historyContext: function historyContext() {
      var syncLocation = this.syncLocation;

      if (syncLocation) {
        var provider = __WEBPACK_IMPORTED_MODULE_6__services_providers_common_providerRegistry__["a" /* default */].providersById[syncLocation.providerId];
        var token = provider.getToken(syncLocation);
        var fileId = __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].getters['file/current'].id;
        var contentId = fileId + '/content';
        var historyContext = {
          token: token,
          fileId: fileId,
          contentId: contentId,
          syncLocation: this.syncLocation
        };
        if (syncLocation.id !== 'main') {
          return historyContext;
        }

        var syncDataByItemId = this.syncDataByItemId;

        var fileSyncData = syncDataByItemId[fileId];
        var contentSyncData = syncDataByItemId[contentId];
        if (fileSyncData && contentSyncData) {
          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, historyContext, {
            fileSyncDataId: fileSyncData.id,
            contentSyncDataId: contentSyncData.id
          });
        }
      }
      return null;
    },
    historyContextHash: function historyContextHash() {
      return __WEBPACK_IMPORTED_MODULE_12__services_utils__["a" /* default */].serializeObject(this.historyContext);
    },
    revisions: function revisions() {
      return this.allRevisions.slice().sort(function (revision1, revision2) {
        return revision2.created - revision1.created;
      }).slice(0, this.showCount);
    },
    revisionsWithSpacer: function revisionsWithSpacer() {
      var previousCreated = 0;
      return this.revisions.map(function (revision) {
        var revisionWithSpacer = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, revision, {
          spacer: revision.created + spacerThreshold < previousCreated
        });
        previousCreated = revision.created;
        return revisionWithSpacer;
      });
    },
    showMoreButton: function showMoreButton() {
      return this.showCount < this.allRevisions.length;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('content', ['setRevisionContent']), {
    signin: function signin() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_13__services_providers_helpers_googleHelper__["a" /* default */].signin();

              case 3:
                __WEBPACK_IMPORTED_MODULE_14__services_syncSvc__["a" /* default */].requestSync();
                _context.next = 8;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](0);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 6]]);
      }))();
    },
    close: function close() {
      __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].dispatch('data/setSideBarPanel', 'menu');
    },
    showMore: function showMore() {
      this.showCount += pageSize;
    },
    open: function open(revision) {
      var revisionContentPromise = revisionContentPromises[revision.id];
      if (!revisionContentPromise) {
        var historyContext = __WEBPACK_IMPORTED_MODULE_12__services_utils__["a" /* default */].deepCopy(this.historyContext);
        if (historyContext) {
          var provider = __WEBPACK_IMPORTED_MODULE_6__services_providers_common_providerRegistry__["a" /* default */].providersById[this.syncLocation.providerId];
          revisionContentPromise = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].dispatch('queue/enqueue', function () {
              return provider.getFileRevisionContent(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, historyContext, {
                revisionId: revision.id
              })).then(resolve, reject);
            });
          });
          revisionContentPromises[revision.id] = revisionContentPromise;
          revisionContentPromise.catch(function (err) {
            __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].dispatch('notification/error', err);
            revisionContentPromises[revision.id] = null;
          });
        }
      }
      if (revisionContentPromise) {
        revisionContentPromise.then(function (revisionContent) {
          return __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].dispatch('content/setRevisionContent', revisionContent);
        });
      }
    },
    refreshHighlighters: function refreshHighlighters() {
      var revisionContent = this.revisionContent;

      editorClassAppliers.forEach(function (editorClassApplier) {
        return editorClassApplier.stop();
      });
      editorClassAppliers = [];
      previewClassAppliers.forEach(function (previewClassApplier) {
        return previewClassApplier.stop();
      });
      previewClassAppliers = [];
      if (revisionContent) {
        var offset = 0;
        revisionContent.diffs.forEach(function (_ref) {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
              type = _ref2[0],
              text = _ref2[1];

          if (type) {
            var classes = ['revision-diff', 'revision-diff--' + (type > 0 ? 'insert' : 'delete')];
            var offsets = {
              start: offset,
              end: offset + text.length
            };
            editorClassAppliers.push(new __WEBPACK_IMPORTED_MODULE_10__common_EditorClassApplier__["a" /* default */](['revision-diff--' + __WEBPACK_IMPORTED_MODULE_12__services_utils__["a" /* default */].uid()].concat(classes), offsets));
            previewClassAppliers.push(new __WEBPACK_IMPORTED_MODULE_11__common_PreviewClassApplier__["a" /* default */](['revision-diff--' + __WEBPACK_IMPORTED_MODULE_12__services_utils__["a" /* default */].uid()].concat(classes), offsets));
          }
          offset += text.length;
        });
      }
    }
  }),
  watch: {
    syncLocation: {
      immediate: true,
      handler: function handler(value) {
        var firstSyncLocation = this.syncLocations[0];
        if (firstSyncLocation) {
          if (!value) {
            this.syncLocationId = firstSyncLocation.id;
          } else if (value.id !== firstSyncLocation.id) {
            __WEBPACK_IMPORTED_MODULE_16__services_badgeSvc__["a" /* default */].addBadge('chooseHistory');
          }
        }
      }
    },

    historyContextHash: {
      immediate: true,
      handler: function handler() {
        var _this3 = this;

        this.allRevisions = [];
        var historyContext = __WEBPACK_IMPORTED_MODULE_12__services_utils__["a" /* default */].deepCopy(this.historyContext);
        if (historyContext) {
          if (this.historyContextHash !== cachedHistoryContextHash) {
            this.setRevisionContent();
            cachedHistoryContextHash = this.historyContextHash;
            revisionContentPromises = {};
            var provider = __WEBPACK_IMPORTED_MODULE_6__services_providers_common_providerRegistry__["a" /* default */].providersById[this.syncLocation.providerId];
            revisionsPromise = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              return __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].dispatch('queue/enqueue', function () {
                return provider.listFileRevisions(historyContext).then(resolve, reject);
              });
            }).catch(function (err) {
              __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].dispatch('notification/error', err);
              cachedHistoryContextHash = null;
              return [];
            });
          }
          if (revisionsPromise) {
            this.loading = true;
            revisionsPromise.then(function (revisions) {
              _this3.loading = false;
              _this3.allRevisions = revisions;
            });
          }
        }
      }
    },
    revisions: function revisions(_revisions) {
      var _this4 = this;

      var historyContext = this.historyContext;

      if (historyContext) {
        __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].dispatch('queue/enqueue', function () {
          return __WEBPACK_IMPORTED_MODULE_12__services_utils__["a" /* default */].awaitSequence(_revisions, function () {
            var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(revision) {
              var provider;
              return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      if (!(!_this4.destroyed && _this4.revisions === _revisions && _this4.historyContext === historyContext)) {
                        _context2.next = 4;
                        break;
                      }

                      provider = __WEBPACK_IMPORTED_MODULE_6__services_providers_common_providerRegistry__["a" /* default */].providersById[_this4.syncLocation.providerId];
                      _context2.next = 4;
                      return provider.loadFileRevision(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, historyContext, {
                        revision: revision
                      }));

                    case 4:
                    case 'end':
                      return _context2.stop();
                  }
                }
              }, _callee2, _this4);
            }));

            return function (_x) {
              return _ref3.apply(this, arguments);
            };
          }());
        });
      }
    },

    revisionContent: {
      immediate: true,
      handler: function handler() {
        this.refreshHighlighters();
      }
    }
  },
  created: function created() {
    var _this5 = this;

    this.onKeyup = function (evt) {
      if (evt.which === 27) {
        _this5.setRevisionContent();
      }
    };
    window.addEventListener('keyup', this.onKeyup);
  },
  destroyed: function destroyed() {
    this.setRevisionContent();

    this.refreshHighlighters();

    window.removeEventListener('keyup', this.onKeyup);

    this.destroyed = true;
  }
});

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_turndown_lib_turndown_browser_umd__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_turndown_lib_turndown_browser_umd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_turndown_lib_turndown_browser_umd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__libs_htmlSanitizer__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_MenuEntry__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_providers_common_Provider__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_workspaceSvc__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_exportSvc__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_badgeSvc__ = __webpack_require__(11);
















var turndownService = new __WEBPACK_IMPORTED_MODULE_5_turndown_lib_turndown_browser_umd___default.a(__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters['data/computedSettings'].turndown);

var readFile = function readFile(file) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
    if (file) {
      var reader = new FileReader();
      reader.onload = function (e) {
        var content = e.target.result;
        if (content.match(/\uFFFD/)) {
          __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].dispatch('notification/error', 'File is not readable.');
        } else {
          resolve(content);
        }
      };
      reader.readAsText(file);
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MenuEntry: __WEBPACK_IMPORTED_MODULE_7__common_MenuEntry__["a" /* default */]
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['isSponsor']),
  methods: {
    onImportMarkdown: function onImportMarkdown(evt) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var file, content, item;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                file = evt.target.files[0];
                _context.next = 3;
                return readFile(file);

              case 3:
                content = _context.sent;
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_10__services_workspaceSvc__["a" /* default */].createFile(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__services_providers_common_Provider__["a" /* default */].parseContent(content), {
                  name: file.name
                }));

              case 6:
                item = _context.sent;

                __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('file/setCurrentId', item.id);
                __WEBPACK_IMPORTED_MODULE_12__services_badgeSvc__["a" /* default */].addBadge('importMarkdown');

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    onImportHtml: function onImportHtml(evt) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var file, content, sanitizedContent, item;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                file = evt.target.files[0];
                _context2.next = 3;
                return readFile(file);

              case 3:
                content = _context2.sent;
                sanitizedContent = __WEBPACK_IMPORTED_MODULE_6__libs_htmlSanitizer__["a" /* default */].sanitizeHtml(content).replace(/&#160;/g, ' ');
                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_10__services_workspaceSvc__["a" /* default */].createFile(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__services_providers_common_Provider__["a" /* default */].parseContent(turndownService.turndown(sanitizedContent)), {
                  name: file.name
                }));

              case 7:
                item = _context2.sent;

                __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('file/setCurrentId', item.id);
                __WEBPACK_IMPORTED_MODULE_12__services_badgeSvc__["a" /* default */].addBadge('importHtml');

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    exportMarkdown: function exportMarkdown() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var currentFile;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                currentFile = __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters['file/current'];
                _context3.prev = 1;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_11__services_exportSvc__["a" /* default */].exportToDisk(currentFile.id, 'md');

              case 4:
                __WEBPACK_IMPORTED_MODULE_12__services_badgeSvc__["a" /* default */].addBadge('exportMarkdown');
                _context3.next = 9;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](1);

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[1, 7]]);
      }))();
    },
    exportHtml: function exportHtml() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].dispatch('modal/open', 'htmlExport');

              case 3:
                _context4.next = 7;
                break;

              case 5:
                _context4.prev = 5;
                _context4.t0 = _context4['catch'](0);

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 5]]);
      }))();
    },
    exportPdf: function exportPdf() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].dispatch('modal/open', 'pdfExport');

              case 3:
                _context5.next = 7;
                break;

              case 5:
                _context5.prev = 5;
                _context5.t0 = _context5['catch'](0);

              case 7:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 5]]);
      }))();
    },
    exportPandoc: function exportPandoc() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].dispatch('modal/open', 'pandocExport');

              case 3:
                _context6.next = 7;
                break;

              case 5:
                _context6.prev = 5;
                _context6.t0 = _context6['catch'](0);

              case 7:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[0, 5]]);
      }))();
    }
  }
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_MenuEntry__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_providers_common_providerRegistry__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UserImage__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_providers_helpers_googleHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_syncSvc__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_userSvc__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__(2);
















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MenuEntry: __WEBPACK_IMPORTED_MODULE_6__common_MenuEntry__["a" /* default */],
    UserImage: __WEBPACK_IMPORTED_MODULE_8__UserImage__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])('workspace', ['currentWorkspace', 'syncToken', 'loginToken']), {
    userId: function userId() {
      return __WEBPACK_IMPORTED_MODULE_11__services_userSvc__["a" /* default */].getCurrentUserId();
    },
    workspaceLocationUrl: function workspaceLocationUrl() {
      var provider = __WEBPACK_IMPORTED_MODULE_7__services_providers_common_providerRegistry__["a" /* default */].providersById[this.currentWorkspace.providerId];
      return provider.getWorkspaceLocationUrl(this.currentWorkspace);
    },
    workspaceCount: function workspaceCount() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters['workspace/workspacesById']).length;
    },
    syncLocationCount: function syncLocationCount() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters['syncLocation/currentWithWorkspaceSyncLocation']).length;
    },
    publishLocationCount: function publishLocationCount() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters['publishLocation/current']).length;
    },
    templateCount: function templateCount() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters['data/allTemplatesById']).length;
    },
    accountCount: function accountCount() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters['data/tokensByType']).reduce(function (count, tokensBySub) {
        return count + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(tokensBySub).length;
      }, 0);
    },
    badgeCount: function badgeCount() {
      return __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters['data/allBadges'].filter(function (badge) {
        return badge.isEarned;
      }).length;
    },
    featureCount: function featureCount() {
      return __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters['data/allBadges'].length;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('data', {
    setPanel: 'setSideBarPanel'
  }), {
    signin: function signin() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__services_providers_helpers_googleHelper__["a" /* default */].signin();

              case 3:
                __WEBPACK_IMPORTED_MODULE_10__services_syncSvc__["a" /* default */].requestSync();
                _context.next = 8;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](0);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 6]]);
      }))();
    },
    fileProperties: function fileProperties() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].dispatch('modal/open', 'fileProperties');

              case 3:
                _context2.next = 7;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2['catch'](0);

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 5]]);
      }))();
    },
    print: function print() {
      window.print();
    },
    settings: function settings() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].dispatch('modal/open', 'settings');

              case 3:
                _context3.next = 7;
                break;

              case 5:
                _context3.prev = 5;
                _context3.t0 = _context3['catch'](0);

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 5]]);
      }))();
    },
    templates: function templates() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].dispatch('modal/open', 'templates');

              case 3:
                _context4.next = 7;
                break;

              case 5:
                _context4.prev = 5;
                _context4.t0 = _context4['catch'](0);

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 5]]);
      }))();
    },
    accounts: function accounts() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].dispatch('modal/open', 'accountManagement');

              case 3:
                _context5.next = 7;
                break;

              case 5:
                _context5.prev = 5;
                _context5.t0 = _context5['catch'](0);

              case 7:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 5]]);
      }))();
    },
    badges: function badges() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].dispatch('modal/open', 'badgeManagement');

              case 3:
                _context6.next = 7;
                break;

              case 5:
                _context6.prev = 5;
                _context6.t0 = _context6['catch'](0);

              case 7:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[0, 5]]);
      }))();
    },
    reset: function reset() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].dispatch('modal/open', 'reset');

              case 3:
                localStorage.setItem('resetStackEdit', '1');
                window.location.reload();
                _context7.next = 9;
                break;

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7['catch'](0);

              case 9:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[0, 7]]);
      }))();
    },
    about: function about() {
      __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].dispatch('modal/open', 'about');
    }
  })
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_MenuEntry__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_providers_helpers_googleHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_providers_helpers_dropboxHelper__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_providers_helpers_githubHelper__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_providers_helpers_gitlabHelper__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_providers_helpers_wordpressHelper__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_providers_helpers_zendeskHelper__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_publishSvc__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store__ = __webpack_require__(2);






var _this = this;












var tokensToArray = function tokensToArray(tokens) {
  var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return true;
  };
  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(tokens).filter(function (token) {
    return filter(token);
  }).sort(function (token1, token2) {
    return token1.name.localeCompare(token2.name);
  });
};

var publishModalOpener = function publishModalOpener(type, featureId) {
  return function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(token) {
      var publishLocation;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].dispatch('modal/open', {
                type: type,
                token: token
              });

            case 3:
              publishLocation = _context.sent;

              __WEBPACK_IMPORTED_MODULE_13__services_publishSvc__["a" /* default */].createPublishLocation(publishLocation, featureId);
              _context.next = 9;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](0);

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 7]]);
    }));

    return function (_x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MenuEntry: __WEBPACK_IMPORTED_MODULE_6__common_MenuEntry__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('queue', ['isPublishRequested']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])('file', ['isCurrentTemp']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])('publishLocation', {
    publishLocations: 'current'
  }), {
    locationCount: function locationCount() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.publishLocations).length;
    },
    currentFileName: function currentFileName() {
      return '"' + __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['file/current'].name + '"';
    },
    bloggerTokens: function bloggerTokens() {
      return tokensToArray(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/googleTokensBySub'], function (token) {
        return token.isBlogger;
      });
    },
    dropboxTokens: function dropboxTokens() {
      return tokensToArray(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/dropboxTokensBySub']);
    },
    githubTokens: function githubTokens() {
      return tokensToArray(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/githubTokensBySub']);
    },
    gitlabTokens: function gitlabTokens() {
      return tokensToArray(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/gitlabTokensBySub']);
    },
    googleDriveTokens: function googleDriveTokens() {
      return tokensToArray(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/googleTokensBySub'], function (token) {
        return token.isDrive;
      });
    },
    wordpressTokens: function wordpressTokens() {
      return tokensToArray(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/wordpressTokensBySub']);
    },
    zendeskTokens: function zendeskTokens() {
      return tokensToArray(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/zendeskTokensBySub']);
    },
    noToken: function noToken() {
      return !this.bloggerTokens.length && !this.dropboxTokens.length && !this.githubTokens.length && !this.gitlabTokens.length && !this.googleDriveTokens.length && !this.wordpressTokens.length && !this.zendeskTokens.length;
    }
  }),
  methods: {
    requestPublish: function requestPublish() {
      if (!this.isPublishRequested) {
        __WEBPACK_IMPORTED_MODULE_13__services_publishSvc__["a" /* default */].requestPublish();
      }
    },
    managePublish: function managePublish() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].dispatch('modal/open', 'publishManagement');

              case 3:
                _context2.next = 7;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2['catch'](0);

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 5]]);
      }))();
    },
    addBloggerAccount: function addBloggerAccount() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_7__services_providers_helpers_googleHelper__["a" /* default */].addBloggerAccount();

              case 3:
                _context3.next = 7;
                break;

              case 5:
                _context3.prev = 5;
                _context3.t0 = _context3['catch'](0);

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 5]]);
      }))();
    },
    addDropboxAccount: function addDropboxAccount() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].dispatch('modal/open', { type: 'dropboxAccount' });

              case 3:
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_8__services_providers_helpers_dropboxHelper__["a" /* default */].addAccount(!__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/localSettings'].dropboxRestrictedAccess);

              case 5:
                _context4.next = 9;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 7]]);
      }))();
    },
    addGithubAccount: function addGithubAccount() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].dispatch('modal/open', { type: 'githubAccount' });

              case 3:
                _context5.next = 5;
                return __WEBPACK_IMPORTED_MODULE_9__services_providers_helpers_githubHelper__["a" /* default */].addAccount(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/localSettings'].githubRepoFullAccess);

              case 5:
                _context5.next = 9;
                break;

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5['catch'](0);

              case 9:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 7]]);
      }))();
    },
    addGitlabAccount: function addGitlabAccount() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var _ref2, serverUrl, applicationId;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].dispatch('modal/open', { type: 'gitlabAccount' });

              case 3:
                _ref2 = _context6.sent;
                serverUrl = _ref2.serverUrl;
                applicationId = _ref2.applicationId;
                _context6.next = 8;
                return __WEBPACK_IMPORTED_MODULE_10__services_providers_helpers_gitlabHelper__["a" /* default */].addAccount(serverUrl, applicationId);

              case 8:
                _context6.next = 12;
                break;

              case 10:
                _context6.prev = 10;
                _context6.t0 = _context6['catch'](0);

              case 12:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[0, 10]]);
      }))();
    },
    addGoogleDriveAccount: function addGoogleDriveAccount() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].dispatch('modal/open', { type: 'googleDriveAccount' });

              case 3:
                _context7.next = 5;
                return __WEBPACK_IMPORTED_MODULE_7__services_providers_helpers_googleHelper__["a" /* default */].addDriveAccount(!__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters['data/localSettings'].googleDriveRestrictedAccess);

              case 5:
                _context7.next = 9;
                break;

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7['catch'](0);

              case 9:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[0, 7]]);
      }))();
    },
    addWordpressAccount: function addWordpressAccount() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return __WEBPACK_IMPORTED_MODULE_11__services_providers_helpers_wordpressHelper__["a" /* default */].addAccount();

              case 3:
                _context8.next = 7;
                break;

              case 5:
                _context8.prev = 5;
                _context8.t0 = _context8['catch'](0);

              case 7:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8, [[0, 5]]);
      }))();
    },
    addZendeskAccount: function addZendeskAccount() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var _ref3, subdomain, clientId;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].dispatch('modal/open', { type: 'zendeskAccount' });

              case 3:
                _ref3 = _context9.sent;
                subdomain = _ref3.subdomain;
                clientId = _ref3.clientId;
                _context9.next = 8;
                return __WEBPACK_IMPORTED_MODULE_12__services_providers_helpers_zendeskHelper__["a" /* default */].addAccount(subdomain, clientId);

              case 8:
                _context9.next = 12;
                break;

              case 10:
                _context9.prev = 10;
                _context9.t0 = _context9['catch'](0);

              case 12:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this9, [[0, 10]]);
      }))();
    },

    publishBlogger: publishModalOpener('bloggerPublish', 'publishToBlogger'),
    publishBloggerPage: publishModalOpener('bloggerPagePublish', 'publishToBloggerPage'),
    publishDropbox: publishModalOpener('dropboxPublish', 'publishToDropbox'),
    publishGithub: publishModalOpener('githubPublish', 'publishToGithub'),
    publishGist: publishModalOpener('gistPublish', 'publishToGist'),
    publishGitlab: publishModalOpener('gitlabPublish', 'publishToGitlab'),
    publishGoogleDrive: publishModalOpener('googleDrivePublish', 'publishToGoogleDrive'),
    publishWordpress: publishModalOpener('wordpressPublish', 'publishToWordPress'),
    publishZendesk: publishModalOpener('zendeskPublish', 'publishToZendesk')
  }
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_MenuEntry__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_providers_helpers_googleHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_providers_helpers_dropboxHelper__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_providers_helpers_githubHelper__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_providers_helpers_gitlabHelper__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_providers_googleDriveProvider__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_providers_dropboxProvider__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_providers_githubProvider__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_providers_gitlabProvider__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_syncSvc__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services_badgeSvc__ = __webpack_require__(11);





















var tokensToArray = function tokensToArray(tokens) {
  var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return true;
  };
  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(tokens).filter(function (token) {
    return filter(token);
  }).sort(function (token1, token2) {
    return token1.name.localeCompare(token2.name);
  });
};

var openSyncModal = function openSyncModal(token, type) {
  return __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].dispatch('modal/open', {
    type: type,
    token: token
  }).then(function (syncLocation) {
    return __WEBPACK_IMPORTED_MODULE_15__services_syncSvc__["a" /* default */].createSyncLocation(syncLocation);
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MenuEntry: __WEBPACK_IMPORTED_MODULE_6__common_MenuEntry__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('queue', ['isSyncRequested']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])('workspace', ['syncToken']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])('file', ['isCurrentTemp']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])('syncLocation', {
    syncLocations: 'currentWithWorkspaceSyncLocation'
  }), {
    locationCount: function locationCount() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.syncLocations).length;
    },
    currentFileName: function currentFileName() {
      return '"' + __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].getters['file/current'].name + '"';
    },
    dropboxTokens: function dropboxTokens() {
      return tokensToArray(__WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].getters['data/dropboxTokensBySub']);
    },
    githubTokens: function githubTokens() {
      return tokensToArray(__WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].getters['data/githubTokensBySub']);
    },
    gitlabTokens: function gitlabTokens() {
      return tokensToArray(__WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].getters['data/gitlabTokensBySub']);
    },
    googleDriveTokens: function googleDriveTokens() {
      return tokensToArray(__WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].getters['data/googleTokensBySub'], function (token) {
        return token.isDrive;
      });
    },
    noToken: function noToken() {
      return !this.googleDriveTokens.length && !this.dropboxTokens.length && !this.githubTokens.length;
    }
  }),
  methods: {
    requestSync: function requestSync() {
      if (!this.isSyncRequested) {
        __WEBPACK_IMPORTED_MODULE_15__services_syncSvc__["a" /* default */].requestSync(true);
      }
    },
    manageSync: function manageSync() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].dispatch('modal/open', 'syncManagement');

              case 3:
                _context.next = 7;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context['catch'](0);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 5]]);
      }))();
    },
    addDropboxAccount: function addDropboxAccount() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].dispatch('modal/open', { type: 'dropboxAccount' });

              case 3:
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_8__services_providers_helpers_dropboxHelper__["a" /* default */].addAccount(!__WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].getters['data/localSettings'].dropboxRestrictedAccess);

              case 5:
                _context2.next = 9;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 7]]);
      }))();
    },
    addGithubAccount: function addGithubAccount() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].dispatch('modal/open', { type: 'githubAccount' });

              case 3:
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_9__services_providers_helpers_githubHelper__["a" /* default */].addAccount(__WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].getters['data/localSettings'].githubRepoFullAccess);

              case 5:
                _context3.next = 9;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 7]]);
      }))();
    },
    addGitlabAccount: function addGitlabAccount() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _ref, serverUrl, applicationId;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].dispatch('modal/open', { type: 'gitlabAccount' });

              case 3:
                _ref = _context4.sent;
                serverUrl = _ref.serverUrl;
                applicationId = _ref.applicationId;
                _context4.next = 8;
                return __WEBPACK_IMPORTED_MODULE_10__services_providers_helpers_gitlabHelper__["a" /* default */].addAccount(serverUrl, applicationId);

              case 8:
                _context4.next = 12;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](0);

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 10]]);
      }))();
    },
    addGoogleDriveAccount: function addGoogleDriveAccount() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].dispatch('modal/open', { type: 'googleDriveAccount' });

              case 3:
                _context5.next = 5;
                return __WEBPACK_IMPORTED_MODULE_7__services_providers_helpers_googleHelper__["a" /* default */].addDriveAccount(!__WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].getters['data/localSettings'].googleDriveRestrictedAccess);

              case 5:
                _context5.next = 9;
                break;

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5['catch'](0);

              case 9:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 7]]);
      }))();
    },
    openDropbox: function openDropbox(token) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var paths;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8__services_providers_helpers_dropboxHelper__["a" /* default */].openChooser(token);

              case 2:
                paths = _context7.sent;

                __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].dispatch('queue/enqueue', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          _context6.next = 2;
                          return __WEBPACK_IMPORTED_MODULE_12__services_providers_dropboxProvider__["a" /* default */].openFiles(token, paths);

                        case 2:
                          __WEBPACK_IMPORTED_MODULE_17__services_badgeSvc__["a" /* default */].addBadge('openFromDropbox');

                        case 3:
                        case 'end':
                          return _context6.stop();
                      }
                    }
                  }, _callee6, _this6);
                })));

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this6);
      }))();
    },
    saveDropbox: function saveDropbox(token) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return openSyncModal(token, 'dropboxSave');

              case 3:
                __WEBPACK_IMPORTED_MODULE_17__services_badgeSvc__["a" /* default */].addBadge('saveOnDropbox');
                _context8.next = 8;
                break;

              case 6:
                _context8.prev = 6;
                _context8.t0 = _context8['catch'](0);

              case 8:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this7, [[0, 6]]);
      }))();
    },
    openGoogleDrive: function openGoogleDrive(token) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var files;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return __WEBPACK_IMPORTED_MODULE_7__services_providers_helpers_googleHelper__["a" /* default */].openPicker(token, 'doc');

              case 2:
                files = _context10.sent;

                __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].dispatch('queue/enqueue', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          _context9.next = 2;
                          return __WEBPACK_IMPORTED_MODULE_11__services_providers_googleDriveProvider__["a" /* default */].openFiles(token, files);

                        case 2:
                          __WEBPACK_IMPORTED_MODULE_17__services_badgeSvc__["a" /* default */].addBadge('openFromGoogleDrive');

                        case 3:
                        case 'end':
                          return _context9.stop();
                      }
                    }
                  }, _callee9, _this8);
                })));

              case 4:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this8);
      }))();
    },
    saveGoogleDrive: function saveGoogleDrive(token) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return openSyncModal(token, 'googleDriveSave');

              case 3:
                __WEBPACK_IMPORTED_MODULE_17__services_badgeSvc__["a" /* default */].addBadge('saveOnGoogleDrive');
                _context11.next = 8;
                break;

              case 6:
                _context11.prev = 6;
                _context11.t0 = _context11['catch'](0);

              case 8:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this9, [[0, 6]]);
      }))();
    },
    openGithub: function openGithub(token) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var syncLocation;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                _context13.next = 3;
                return __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].dispatch('modal/open', {
                  type: 'githubOpen',
                  token: token
                });

              case 3:
                syncLocation = _context13.sent;

                __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].dispatch('queue/enqueue', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
                    while (1) {
                      switch (_context12.prev = _context12.next) {
                        case 0:
                          _context12.next = 2;
                          return __WEBPACK_IMPORTED_MODULE_13__services_providers_githubProvider__["a" /* default */].openFile(token, syncLocation);

                        case 2:
                          __WEBPACK_IMPORTED_MODULE_17__services_badgeSvc__["a" /* default */].addBadge('openFromGithub');

                        case 3:
                        case 'end':
                          return _context12.stop();
                      }
                    }
                  }, _callee12, _this10);
                })));
                _context13.next = 9;
                break;

              case 7:
                _context13.prev = 7;
                _context13.t0 = _context13['catch'](0);

              case 9:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this10, [[0, 7]]);
      }))();
    },
    saveGithub: function saveGithub(token) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                _context14.next = 3;
                return openSyncModal(token, 'githubSave');

              case 3:
                __WEBPACK_IMPORTED_MODULE_17__services_badgeSvc__["a" /* default */].addBadge('saveOnGithub');
                _context14.next = 8;
                break;

              case 6:
                _context14.prev = 6;
                _context14.t0 = _context14['catch'](0);

              case 8:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this11, [[0, 6]]);
      }))();
    },
    saveGist: function saveGist(token) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                _context15.next = 3;
                return openSyncModal(token, 'gistSync');

              case 3:
                __WEBPACK_IMPORTED_MODULE_17__services_badgeSvc__["a" /* default */].addBadge('saveOnGist');
                _context15.next = 8;
                break;

              case 6:
                _context15.prev = 6;
                _context15.t0 = _context15['catch'](0);

              case 8:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this12, [[0, 6]]);
      }))();
    },
    openGitlab: function openGitlab(token) {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17() {
        var syncLocation;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                _context17.next = 3;
                return __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].dispatch('modal/open', {
                  type: 'gitlabOpen',
                  token: token
                });

              case 3:
                syncLocation = _context17.sent;

                __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].dispatch('queue/enqueue', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16() {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
                    while (1) {
                      switch (_context16.prev = _context16.next) {
                        case 0:
                          _context16.next = 2;
                          return __WEBPACK_IMPORTED_MODULE_14__services_providers_gitlabProvider__["a" /* default */].openFile(token, syncLocation);

                        case 2:
                          __WEBPACK_IMPORTED_MODULE_17__services_badgeSvc__["a" /* default */].addBadge('openFromGitlab');

                        case 3:
                        case 'end':
                          return _context16.stop();
                      }
                    }
                  }, _callee16, _this13);
                })));
                _context17.next = 9;
                break;

              case 7:
                _context17.prev = 7;
                _context17.t0 = _context17['catch'](0);

              case 9:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, _this13, [[0, 7]]);
      }))();
    },
    saveGitlab: function saveGitlab(token) {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;
                _context18.next = 3;
                return openSyncModal(token, 'gitlabSave');

              case 3:
                __WEBPACK_IMPORTED_MODULE_17__services_badgeSvc__["a" /* default */].addBadge('saveOnGitlab');
                _context18.next = 8;
                break;

              case 6:
                _context18.prev = 6;
                _context18.t0 = _context18['catch'](0);

              case 8:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, _this14, [[0, 6]]);
      }))();
    }
  }
});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_MenuEntry__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_backupSvc__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_localDbSvc__ = __webpack_require__(151);









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MenuEntry: __WEBPACK_IMPORTED_MODULE_2__common_MenuEntry__["a" /* default */]
  },
  computed: {
    workspaceId: function workspaceId() {
      return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['workspace/currentWorkspace'].id;
    }
  },
  methods: {
    onImportBackup: function onImportBackup(evt) {
      var file = evt.target.files[0];
      if (file) {
        var reader = new FileReader();
        reader.onload = function (e) {
          var text = e.target.result;
          if (text.match(/\uFFFD/)) {
            __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('notification/error', 'File is not readable.');
          } else {
            __WEBPACK_IMPORTED_MODULE_4__services_backupSvc__["a" /* default */].importBackup(text);
          }
        };
        var blob = file.slice(0, 10000000);
        reader.readAsText(blob);
      }
    },
    exportWorkspace: function exportWorkspace() {
      var allItemsById = {};
      __WEBPACK_IMPORTED_MODULE_5__services_localDbSvc__["a" /* default */].getWorkspaceItems(this.workspaceId, function (item) {
        allItemsById[item.id] = item;
      }, function () {
        var backup = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(allItemsById);
        var blob = new Blob([backup], {
          type: 'text/plain;charset=utf-8'
        });
        __WEBPACK_IMPORTED_MODULE_1_file_saver___default.a.saveAs(blob, 'StackEdit workspace.json');
      });
    }
  }
});

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_MenuEntry__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_providers_helpers_googleHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_providers_helpers_gitlabHelper__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(2);












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MenuEntry: __WEBPACK_IMPORTED_MODULE_5__common_MenuEntry__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('workspace', ['workspacesById', 'currentWorkspace']), {
    workspaceCount: function workspaceCount() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.workspacesById).length;
    }
  }),
  methods: {
    addCouchdbWorkspace: function addCouchdbWorkspace() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                try {
                  __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].dispatch('modal/open', {
                    type: 'couchdbWorkspace'
                  });
                } catch (e) {}

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    addGithubWorkspace: function addGithubWorkspace() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                try {
                  __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].dispatch('modal/open', {
                    type: 'githubWorkspace'
                  });
                } catch (e) {}

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    addGitlabWorkspace: function addGitlabWorkspace() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref, serverUrl, applicationId, token;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].dispatch('modal/open', { type: 'gitlabAccount' });

              case 3:
                _ref = _context3.sent;
                serverUrl = _ref.serverUrl;
                applicationId = _ref.applicationId;
                _context3.next = 8;
                return __WEBPACK_IMPORTED_MODULE_7__services_providers_helpers_gitlabHelper__["a" /* default */].addAccount(serverUrl, applicationId);

              case 8:
                token = _context3.sent;

                __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].dispatch('modal/open', {
                  type: 'gitlabWorkspace',
                  token: token
                });
                _context3.next = 14;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3['catch'](0);

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 12]]);
      }))();
    },
    addGoogleDriveWorkspace: function addGoogleDriveWorkspace() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var token;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__services_providers_helpers_googleHelper__["a" /* default */].addDriveAccount(true);

              case 3:
                token = _context4.sent;

                __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].dispatch('modal/open', {
                  type: 'googleDriveWorkspace',
                  token: token
                });
                _context4.next = 9;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 7]]);
      }))();
    },
    manageWorkspaces: function manageWorkspaces() {
      try {
        __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].dispatch('modal/open', 'workspaceManagement');
      } catch (e) {}
    }
  }
});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_ModalInner__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_markdownConversionSvc__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_faq_md__ = __webpack_require__(2202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_faq_md___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__data_faq_md__);








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ModalInner: __WEBPACK_IMPORTED_MODULE_2__common_ModalInner__["a" /* default */]
  },
  data: function data() {
    return {
      version: "5.15.4"
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('modal', ['config']), {
    faq: function faq() {
      return __WEBPACK_IMPORTED_MODULE_3__services_markdownConversionSvc__["a" /* default */].defaultConverter.render(__WEBPACK_IMPORTED_MODULE_4__data_faq_md___default.a);
    }
  })
});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_ModalInner__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__menus_common_MenuEntry__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_providers_helpers_googleHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_providers_helpers_dropboxHelper__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_providers_helpers_githubHelper__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_providers_helpers_gitlabHelper__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_providers_helpers_wordpressHelper__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_providers_helpers_zendeskHelper__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services_badgeSvc__ = __webpack_require__(11);





















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ModalInner: __WEBPACK_IMPORTED_MODULE_7__common_ModalInner__["a" /* default */],
    MenuEntry: __WEBPACK_IMPORTED_MODULE_8__menus_common_MenuEntry__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])('modal', ['config']), {
    entries: function entries() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters['data/googleTokensBySub']).map(function (token) {
        return {
          token: token,
          providerId: 'google',
          userId: token.sub,
          name: token.name,
          scopes: ['openid', 'profile'].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(token.scopes.map(function (scope) {
            return scope.replace(/^https:\/\/www.googleapis.com\/auth\//, '');
          })))
        };
      })), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters['data/couchdbTokensBySub']).map(function (token) {
        return {
          token: token,
          providerId: 'couchdb',
          url: token.dbUrl,
          name: token.name
        };
      })), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters['data/dropboxTokensBySub']).map(function (token) {
        return {
          token: token,
          providerId: 'dropbox',
          userId: token.sub,
          name: token.name
        };
      })), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters['data/githubTokensBySub']).map(function (token) {
        return {
          token: token,
          providerId: 'github',
          userId: token.sub,
          name: token.name,
          scopes: token.scopes
        };
      })), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters['data/gitlabTokensBySub']).map(function (token) {
        return {
          token: token,
          providerId: 'gitlab',
          url: token.serverUrl,
          userId: token.sub,
          name: token.name,
          scopes: ['api']
        };
      })), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters['data/wordpressTokensBySub']).map(function (token) {
        return {
          token: token,
          providerId: 'wordpress',
          userId: token.sub,
          name: token.name,
          scopes: ['global']
        };
      })), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters['data/zendeskTokensBySub']).map(function (token) {
        return {
          token: token,
          providerId: 'zendesk',
          url: 'https://' + token.subdomain + '.zendesk.com/',
          userId: token.sub,
          name: token.name,
          scopes: ['read', 'hc:write']
        };
      })));
    }
  }),
  methods: {
    remove: function remove(entry) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var tokensBySub;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tokensBySub = __WEBPACK_IMPORTED_MODULE_10__services_utils__["a" /* default */].deepCopy(__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters['data/' + entry.providerId + 'TokensBySub']);

                delete tokensBySub[entry.token.sub];
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].dispatch('data/patchTokensByType', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, entry.providerId, tokensBySub));

              case 4:
                __WEBPACK_IMPORTED_MODULE_17__services_badgeSvc__["a" /* default */].addBadge('removeAccount');

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    addBloggerAccount: function addBloggerAccount() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_11__services_providers_helpers_googleHelper__["a" /* default */].addBloggerAccount();

              case 3:
                _context2.next = 7;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2['catch'](0);

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 5]]);
      }))();
    },
    addDropboxAccount: function addDropboxAccount() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].dispatch('modal/open', { type: 'dropboxAccount' });

              case 3:
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12__services_providers_helpers_dropboxHelper__["a" /* default */].addAccount(!__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters['data/localSettings'].dropboxRestrictedAccess);

              case 5:
                _context3.next = 9;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 7]]);
      }))();
    },
    addGithubAccount: function addGithubAccount() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].dispatch('modal/open', { type: 'githubAccount' });

              case 3:
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_13__services_providers_helpers_githubHelper__["a" /* default */].addAccount(__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters['data/localSettings'].githubRepoFullAccess);

              case 5:
                _context4.next = 9;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 7]]);
      }))();
    },
    addGitlabAccount: function addGitlabAccount() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var _ref, serverUrl, applicationId;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].dispatch('modal/open', { type: 'gitlabAccount' });

              case 3:
                _ref = _context5.sent;
                serverUrl = _ref.serverUrl;
                applicationId = _ref.applicationId;
                _context5.next = 8;
                return __WEBPACK_IMPORTED_MODULE_14__services_providers_helpers_gitlabHelper__["a" /* default */].addAccount(serverUrl, applicationId);

              case 8:
                _context5.next = 12;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5['catch'](0);

              case 12:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 10]]);
      }))();
    },
    addGoogleDriveAccount: function addGoogleDriveAccount() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].dispatch('modal/open', { type: 'googleDriveAccount' });

              case 3:
                _context6.next = 5;
                return __WEBPACK_IMPORTED_MODULE_11__services_providers_helpers_googleHelper__["a" /* default */].addDriveAccount(!__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters['data/localSettings'].googleDriveRestrictedAccess);

              case 5:
                _context6.next = 9;
                break;

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6['catch'](0);

              case 9:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[0, 7]]);
      }))();
    },
    addGooglePhotosAccount: function addGooglePhotosAccount() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return __WEBPACK_IMPORTED_MODULE_11__services_providers_helpers_googleHelper__["a" /* default */].addPhotosAccount();

              case 3:
                _context7.next = 7;
                break;

              case 5:
                _context7.prev = 5;
                _context7.t0 = _context7['catch'](0);

              case 7:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[0, 5]]);
      }))();
    },
    addWordpressAccount: function addWordpressAccount() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return __WEBPACK_IMPORTED_MODULE_15__services_providers_helpers_wordpressHelper__["a" /* default */].addAccount();

              case 3:
                _context8.next = 7;
                break;

              case 5:
                _context8.prev = 5;
                _context8.t0 = _context8['catch'](0);

              case 7:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8, [[0, 5]]);
      }))();
    },
    addZendeskAccount: function addZendeskAccount() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var _ref2, subdomain, clientId;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].dispatch('modal/open', { type: 'zendeskAccount' });

              case 3:
                _ref2 = _context9.sent;
                subdomain = _ref2.subdomain;
                clientId = _ref2.clientId;
                _context9.next = 8;
                return __WEBPACK_IMPORTED_MODULE_16__services_providers_helpers_zendeskHelper__["a" /* default */].addAccount(subdomain, clientId);

              case 8:
                _context9.next = 12;
                break;

              case 10:
                _context9.prev = 10;
                _context9.t0 = _context9['catch'](0);

              case 12:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this9, [[0, 10]]);
      }))();
    }
  }
});

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_ModalInner__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ModalInner: __WEBPACK_IMPORTED_MODULE_3__common_ModalInner__["a" /* default */]
  },
  data: function data() {
    return {
      shown: {}
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('modal', ['config']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('data', ['badgeTree']), {
    badgeCount: function badgeCount() {
      return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['data/allBadges'].filter(function (badge) {
        return badge.isEarned;
      }).length;
    },
    featureCount: function featureCount() {
      return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['data/allBadges'].length;
    }
  }),
  methods: {
    show: function show(featureId) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(this.shown, featureId, true);
    }
  }
});

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_yaml__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_yaml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_yaml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_ModalInner__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Tab__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_FormEntry__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CodeEditor__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_presets__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_badgeSvc__ = __webpack_require__(11);















var metadataProperties = {
  title: '',
  author: '',
  tags: '',
  categories: '',
  excerpt: '',
  featuredImage: '',
  status: '',
  date: ''
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ModalInner: __WEBPACK_IMPORTED_MODULE_4__common_ModalInner__["a" /* default */],
    Tab: __WEBPACK_IMPORTED_MODULE_5__common_Tab__["a" /* default */],
    FormEntry: __WEBPACK_IMPORTED_MODULE_6__common_FormEntry__["a" /* default */],
    CodeEditor: __WEBPACK_IMPORTED_MODULE_7__CodeEditor__["a" /* default */]
  },
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      contentId: null,
      yamlProperties: null,
      preset: '',
      error: null
    }, metadataProperties);
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('modal', ['config']), {
    presets: function presets() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_9__data_presets__["a" /* default */]).sort();
    },
    tab: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters['data/localSettings'].filePropertiesTab;
      },
      set: function set(value) {
        __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].dispatch('data/patchLocalSettings', {
          filePropertiesTab: value
        });
      }
    }
  }),
  created: function created() {
    var content = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters['content/current'];
    this.contentId = content.id;
    this.setYamlProperties(content.properties);
    if (this.tab !== 'yaml') {
      this.setSimpleTab();
    }
  },

  methods: {
    yamlToSimple: function yamlToSimple() {
      var _this = this;

      var properties = this.properties || {};
      var extensions = properties.extensions || {};
      this.preset = extensions.preset;
      if (!this.presets.includes(this.preset)) {
        this.preset = 'default';
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(metadataProperties).forEach(function (name) {
        _this[name] = '' + (properties[name] || '');
      });
    },
    simpleToYaml: function simpleToYaml() {
      var _this2 = this;

      var hasChanged = false;
      var properties = this.properties || {};
      var extensions = properties.extensions || {};
      if (this.preset !== extensions.preset) {
        if (this.preset !== 'default') {
          extensions.preset = this.preset;
          hasChanged = true;
        } else if (extensions.preset) {
          delete extensions.preset;
          hasChanged = true;
        }
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(metadataProperties).forEach(function (name) {
        if (_this2[name] !== properties[name]) {
          if (_this2[name]) {
            properties[name] = _this2[name];
            hasChanged = true;
          } else if (properties[name]) {
            delete properties[name];
            hasChanged = true;
          }
        }
      });
      if (hasChanged) {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(extensions).length) {
          properties.extensions = extensions;
        } else {
          delete properties.extensions;
        }
        this.setYamlProperties(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(properties).length ? __WEBPACK_IMPORTED_MODULE_2_js_yaml___default.a.safeDump(properties) : '\n');
      }
    },
    setSimpleTab: function setSimpleTab() {
      this.tab = 'simple';
      this.yamlToSimple();
    },
    setYamlTab: function setYamlTab() {
      this.tab = 'yaml';
      this.simpleToYaml();
    },
    setYamlProperties: function setYamlProperties(value) {
      this.yamlProperties = value;
      try {
        this.properties = __WEBPACK_IMPORTED_MODULE_2_js_yaml___default.a.safeLoad(value);
        this.error = null;
      } catch (e) {
        this.error = e.message;
      }
    },
    resolve: function resolve() {
      if (this.tab === 'simple') {
        this.simpleToYaml();
      }
      if (this.error) {
        this.setYamlTab();
      } else {
        var properties = this.properties || {};
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(metadataProperties).some(function (key) {
          return properties[key];
        })) {
          __WEBPACK_IMPORTED_MODULE_11__services_badgeSvc__["a" /* default */].addBadge('setMetadata');
        }
        var extensions = properties.extensions || {};
        if (extensions.preset) {
          __WEBPACK_IMPORTED_MODULE_11__services_badgeSvc__["a" /* default */].addBadge('changePreset');
        }
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(extensions).filter(function (key) {
          return key !== 'preset';
        }).length) {
          __WEBPACK_IMPORTED_MODULE_11__services_badgeSvc__["a" /* default */].addBadge('changeExtension');
        }
        __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('content/patchItem', {
          id: this.contentId,
          properties: __WEBPACK_IMPORTED_MODULE_8__services_utils__["a" /* default */].sanitizeText(this.yamlProperties)
        });
        this.config.resolve();
      }
    }
  }
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_exportSvc__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_modalTemplate__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_badgeSvc__ = __webpack_require__(11);











/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_modalTemplate__["a" /* default */])({
  data: function data() {
    return {
      result: ''
    };
  },
  computedLocalSettings: {
    selectedTemplate: 'htmlExportTemplate'
  },
  mounted: function mounted() {
    var _this = this;

    var timeoutId = void 0;
    this.$watch('selectedTemplate', function (selectedTemplate) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var currentFile, html;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                currentFile = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters['file/current'];
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__services_exportSvc__["a" /* default */].applyTemplate(currentFile.id, _this.allTemplatesById[selectedTemplate]);

              case 3:
                html = _context.sent;

                _this.result = html;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      })), 10);
    }, {
      immediate: true
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('notification', ['info']), {
    resolve: function resolve() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var config, currentFile;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                config = _this2.config;
                currentFile = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters['file/current'];

                config.resolve();
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__services_exportSvc__["a" /* default */].exportToDisk(currentFile.id, 'html', _this2.allTemplatesById[_this2.selectedTemplate]);

              case 5:
                __WEBPACK_IMPORTED_MODULE_7__services_badgeSvc__["a" /* default */].addBadge('exportHtml');

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  })
}));

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_modalTemplate__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__menus_common_MenuEntry__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_providers_helpers_googleHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(2);










/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_modalTemplate__["a" /* default */])({
  components: {
    MenuEntry: __WEBPACK_IMPORTED_MODULE_4__menus_common_MenuEntry__["a" /* default */]
  },
  data: function data() {
    return {
      url: ''
    };
  },
  computed: {
    googlePhotosTokens: function googlePhotosTokens() {
      var googleTokensBySub = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters['data/googleTokensBySub'];
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(googleTokensBySub).filter(function (token) {
        return token.isPhotos;
      }).sort(function (token1, token2) {
        return token1.name.localeCompare(token2.name);
      });
    }
  },
  methods: {
    resolve: function resolve(evt) {
      evt.preventDefault();
      if (!this.url) {
        this.setError('url');
      } else {
        var callback = this.config.callback;

        this.config.resolve();
        callback(this.url);
      }
    },
    reject: function reject() {
      var callback = this.config.callback;

      this.config.reject();
      callback(null);
    },
    addGooglePhotosAccount: function addGooglePhotosAccount() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__services_providers_helpers_googleHelper__["a" /* default */].addPhotosAccount();

              case 3:
                _context.next = 7;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context['catch'](0);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 5]]);
      }))();
    },
    openGooglePhotos: function openGooglePhotos(token) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var callback, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                callback = _this2.config.callback;

                _this2.config.reject();
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__services_providers_helpers_googleHelper__["a" /* default */].openPicker(token, 'img');

              case 4:
                res = _context2.sent;

                if (res[0]) {
                  __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('modal/open', {
                    type: 'googlePhoto',
                    url: res[0].url,
                    callback: callback
                  });
                }

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
}));

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_modalTemplate__ = __webpack_require__(13);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_modalTemplate__["a" /* default */])({
  data: function data() {
    return {
      url: ''
    };
  },
  methods: {
    resolve: function resolve(evt) {
      evt.preventDefault();
      if (!this.url) {
        this.setError('url');
      } else {
        var callback = this.config.callback;

        this.config.resolve();
        callback(this.url);
      }
    },
    reject: function reject() {
      var callback = this.config.callback;

      this.config.reject();
      callback(null);
    }
  }
}));

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_file_saver__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_networkSvc__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_editorSvc__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_providers_helpers_googleHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_modalTemplate__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_badgeSvc__ = __webpack_require__(11);













/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_modalTemplate__["a" /* default */])({
  computedLocalSettings: {
    selectedFormat: 'pandocExportFormat'
  },
  methods: {
    resolve: function resolve() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var currentFile, currentContent, selectedFormat;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.config.resolve();
                currentFile = __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters['file/current'];
                currentContent = __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters['content/current'];
                selectedFormat = _this.selectedFormat;

                __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].dispatch('queue/enqueue', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                  var tokenToRefresh, sponsorToken, _ref2, body;

                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          tokenToRefresh = __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters['workspace/sponsorToken'];
                          _context.t0 = tokenToRefresh;

                          if (!_context.t0) {
                            _context.next = 6;
                            break;
                          }

                          _context.next = 5;
                          return __WEBPACK_IMPORTED_MODULE_6__services_providers_helpers_googleHelper__["a" /* default */].refreshToken(tokenToRefresh);

                        case 5:
                          _context.t0 = _context.sent;

                        case 6:
                          sponsorToken = _context.t0;
                          _context.prev = 7;
                          _context.next = 10;
                          return __WEBPACK_IMPORTED_MODULE_4__services_networkSvc__["a" /* default */].request({
                            method: 'POST',
                            url: 'pandocExport',
                            params: {
                              idToken: sponsorToken && sponsorToken.idToken,
                              format: selectedFormat,
                              options: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters['data/computedSettings'].pandoc),
                              metadata: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(currentContent.properties)
                            },
                            body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_5__services_editorSvc__["a" /* default */].getPandocAst()),
                            blob: true,
                            timeout: 60000
                          });

                        case 10:
                          _ref2 = _context.sent;
                          body = _ref2.body;

                          __WEBPACK_IMPORTED_MODULE_3_file_saver___default.a.saveAs(body, currentFile.name + '.' + selectedFormat);
                          __WEBPACK_IMPORTED_MODULE_9__services_badgeSvc__["a" /* default */].addBadge('exportPandoc');
                          _context.next = 19;
                          break;

                        case 16:
                          _context.prev = 16;
                          _context.t1 = _context['catch'](7);

                          if (_context.t1.status === 401) {
                            __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].dispatch('modal/open', 'sponsorOnly');
                          } else {
                            console.error(_context.t1);
                            __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].dispatch('notification/error', _context.t1);
                          }

                        case 19:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this, [[7, 16]]);
                })));

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    }
  }
}));

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_file_saver__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_exportSvc__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_networkSvc__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_providers_helpers_googleHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_modalTemplate__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_badgeSvc__ = __webpack_require__(11);















/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__common_modalTemplate__["a" /* default */])({
  computedLocalSettings: {
    selectedTemplate: 'pdfExportTemplate'
  },
  methods: {
    resolve: function resolve() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var currentFile;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.config.resolve();
                currentFile = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters['file/current'];

                __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].dispatch('queue/enqueue', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                  var _ref2, _ref3, sponsorToken, html, _ref4, body;

                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve().then(function () {
                            var tokenToRefresh = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters['workspace/sponsorToken'];
                            return tokenToRefresh && __WEBPACK_IMPORTED_MODULE_8__services_providers_helpers_googleHelper__["a" /* default */].refreshToken(tokenToRefresh);
                          }), __WEBPACK_IMPORTED_MODULE_6__services_exportSvc__["a" /* default */].applyTemplate(currentFile.id, _this.allTemplatesById[_this.selectedTemplate], true)]);

                        case 2:
                          _ref2 = _context.sent;
                          _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                          sponsorToken = _ref3[0];
                          html = _ref3[1];
                          _context.prev = 6;
                          _context.next = 9;
                          return __WEBPACK_IMPORTED_MODULE_7__services_networkSvc__["a" /* default */].request({
                            method: 'POST',
                            url: 'pdfExport',
                            params: {
                              idToken: sponsorToken && sponsorToken.idToken,
                              options: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters['data/computedSettings'].wkhtmltopdf)
                            },
                            body: html,
                            blob: true,
                            timeout: 60000
                          });

                        case 9:
                          _ref4 = _context.sent;
                          body = _ref4.body;

                          __WEBPACK_IMPORTED_MODULE_5_file_saver___default.a.saveAs(body, currentFile.name + '.pdf');
                          __WEBPACK_IMPORTED_MODULE_11__services_badgeSvc__["a" /* default */].addBadge('exportPdf');
                          _context.next = 18;
                          break;

                        case 15:
                          _context.prev = 15;
                          _context.t0 = _context['catch'](6);

                          if (_context.t0.status === 401) {
                            __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].dispatch('modal/open', 'sponsorOnly');
                          } else {
                            console.error(_context.t0);
                            __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].dispatch('notification/error', _context.t0);
                          }

                        case 18:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this, [[6, 15]]);
                })));

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    }
  }
}));

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_ModalInner__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_badgeSvc__ = __webpack_require__(11);








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ModalInner: __WEBPACK_IMPORTED_MODULE_2__common_ModalInner__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('modal', ['config']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('publishLocation', {
    publishLocations: 'current'
  }), {
    currentFileName: function currentFileName() {
      return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['file/current'].name;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notification', ['info']), {
    remove: function remove(location) {
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('publishLocation/deleteItem', location.id);
      __WEBPACK_IMPORTED_MODULE_4__services_badgeSvc__["a" /* default */].addBadge('removePublishLocation');
    }
  })
});

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_yaml__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_yaml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_yaml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_ModalInner__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Tab__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CodeEditor__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_defaults_defaultSettings_yml__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_defaults_defaultSettings_yml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__data_defaults_defaultSettings_yml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_badgeSvc__ = __webpack_require__(11);















var emptySettings = '# Add your custom settings here to override the\n# default settings.\n';

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ModalInner: __WEBPACK_IMPORTED_MODULE_6__common_ModalInner__["a" /* default */],
    Tab: __WEBPACK_IMPORTED_MODULE_7__common_Tab__["a" /* default */],
    CodeEditor: __WEBPACK_IMPORTED_MODULE_8__CodeEditor__["a" /* default */]
  },
  data: function data() {
    return {
      tab: 'custom',
      defaultSettings: __WEBPACK_IMPORTED_MODULE_9__data_defaults_defaultSettings_yml___default.a,
      customSettings: null,
      error: null
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])('modal', ['config']), {
    strippedCustomSettings: function strippedCustomSettings() {
      return this.customSettings === emptySettings ? '\n' : this.customSettings.replace(/\t/g, '  ');
    }
  }),
  created: function created() {
    var settings = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters['data/settings'];
    this.setCustomSettings(settings === '\n' ? emptySettings : settings);
  },

  methods: {
    setCustomSettings: function setCustomSettings(value) {
      this.customSettings = value;
      try {
        __WEBPACK_IMPORTED_MODULE_4_js_yaml___default.a.safeLoad(this.strippedCustomSettings);
        this.error = null;
      } catch (e) {
        this.error = e.message;
      }
    },
    resolve: function resolve() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var settings, customSettings, computedSettings, customSettingsCount;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.error) {
                  _context.next = 10;
                  break;
                }

                settings = _this.strippedCustomSettings;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].dispatch('data/setSettings', settings);

              case 4:
                customSettings = __WEBPACK_IMPORTED_MODULE_4_js_yaml___default.a.safeLoad(settings);

                if (customSettings.shortcuts) {
                  __WEBPACK_IMPORTED_MODULE_11__services_badgeSvc__["a" /* default */].addBadge('changeShortcuts');
                }
                computedSettings = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters['data/computedSettings'];
                customSettingsCount = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(customSettings).filter(function (key) {
                  return key !== 'shortcuts' && computedSettings[key];
                }).length;

                if (customSettingsCount) {
                  __WEBPACK_IMPORTED_MODULE_11__services_badgeSvc__["a" /* default */].addBadge('changeSettings');
                }
                _this.config.resolve(settings);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_ModalInner__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ModalInner: __WEBPACK_IMPORTED_MODULE_2__common_ModalInner__["a" /* default */]
  },
  data: function data() {
    var sponsorToken = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['workspace/sponsorToken'];
    var makeButton = function makeButton(id, price, description, offer) {
      var params = {
        cmd: '_s-xclick',
        hosted_button_id: id,
        custom: sponsorToken.sub
      };
      return {
        id: id,
        price: price,
        description: description,
        offer: offer,
        link: __WEBPACK_IMPORTED_MODULE_3__services_utils__["a" /* default */].addQueryParams('https://www.paypal.com/cgi-bin/webscr', params)
      };
    };

    return {
      buttons: sponsorToken ? [makeButton('QD7SFZS79D2AL', '$5', '3 months sponsorship'), makeButton('WG64NCFL9TQZJ', '$15', '1 year sponsorship', '-25%'), makeButton('G2E7MN873EQ3U', '$25', '2 years sponsorship', '-37%'), makeButton('JQJT7ARKYC7FC', '$50', '5 years sponsorship', '-50%')] : []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('modal', ['config'])),
  methods: {
    sponsor: function sponsor() {}
  }
});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_ModalInner__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_badgeSvc__ = __webpack_require__(11);








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ModalInner: __WEBPACK_IMPORTED_MODULE_2__common_ModalInner__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('modal', ['config']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('syncLocation', {
    syncLocations: 'currentWithWorkspaceSyncLocation'
  }), {
    currentFileName: function currentFileName() {
      return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['file/current'].name;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notification', ['info']), {
    remove: function remove(location) {
      if (location.id === 'main') {
        this.info('This location can not be removed.');
      } else {
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('syncLocation/deleteItem', location.id);
        __WEBPACK_IMPORTED_MODULE_4__services_badgeSvc__["a" /* default */].addBadge('removeSyncLocation');
      }
    }
  })
});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_badgeSvc__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_ModalInner__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CodeEditor__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__data_empties_emptyTemplateValue_html__ = __webpack_require__(2201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__data_empties_emptyTemplateValue_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__data_empties_emptyTemplateValue_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__raw_loader_data_empties_emptyTemplateHelpers_js__ = __webpack_require__(2200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__raw_loader_data_empties_emptyTemplateHelpers_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__raw_loader_data_empties_emptyTemplateHelpers_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store__ = __webpack_require__(2);

















var collator = new Intl.Collator(undefined, { sensitivity: 'base' });

function fillEmptyFields(template) {
  if (template.value === '\n') {
    template.value = __WEBPACK_IMPORTED_MODULE_11__data_empties_emptyTemplateValue_html___default.a;
  }
  if (template.helpers === '\n') {
    template.helpers = __WEBPACK_IMPORTED_MODULE_12__raw_loader_data_empties_emptyTemplateHelpers_js___default.a;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ModalInner: __WEBPACK_IMPORTED_MODULE_9__common_ModalInner__["a" /* default */],
    CodeEditor: __WEBPACK_IMPORTED_MODULE_10__CodeEditor__["a" /* default */]
  },
  data: function data() {
    return {
      selectedId: '',
      templates: {},
      showHelpers: false,
      isEditing: false,
      editingName: ''
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])('modal', ['config']), {
    isReadOnly: function isReadOnly() {
      return this.templates[this.selectedId].isAdditional;
    }
  }),
  created: function created() {
    var _this = this;

    this.$watch(function () {
      return __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].getters['data/allTemplatesById'];
    }, function (allTemplatesById) {
      var templates = {};

      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(allTemplatesById).sort(function (_ref, _ref2) {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            template1 = _ref4[1];

        var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
            template2 = _ref3[1];

        return collator.compare(template1.name, template2.name);
      }).forEach(function (_ref5) {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
            id = _ref6[0],
            template = _ref6[1];

        var templateClone = __WEBPACK_IMPORTED_MODULE_7__services_utils__["a" /* default */].deepCopy(template);
        fillEmptyFields(templateClone);
        templates[id] = templateClone;
      });
      _this.templates = templates;
      _this.selectedId = _this.config.selectedId;
      if (!templates[_this.selectedId]) {
        var _Object$keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(templates);

        var _Object$keys2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_Object$keys, 1);

        _this.selectedId = _Object$keys2[0];
      }
      _this.isEditing = false;
    }, { immediate: true });
    this.$watch('selectedId', function (selectedId) {
      var template = _this.templates[selectedId];
      _this.showHelpers = template.helpers !== __WEBPACK_IMPORTED_MODULE_12__raw_loader_data_empties_emptyTemplateHelpers_js___default.a;
      _this.editingName = template.name;
    }, { immediate: true });
  },

  methods: {
    create: function create() {
      var template = {
        name: 'New template',
        value: '\n',
        helpers: '\n'
      };
      fillEmptyFields(template);
      this.selectedId = __WEBPACK_IMPORTED_MODULE_7__services_utils__["a" /* default */].uid();
      this.templates[this.selectedId] = template;
      this.isEditing = true;
    },
    copy: function copy() {
      var template = __WEBPACK_IMPORTED_MODULE_7__services_utils__["a" /* default */].deepCopy(this.templates[this.selectedId]);
      template.name += ' copy';
      delete template.isAdditional;
      this.selectedId = __WEBPACK_IMPORTED_MODULE_7__services_utils__["a" /* default */].uid();
      this.templates[this.selectedId] = template;
      this.isEditing = true;
    },
    remove: function remove() {
      delete this.templates[this.selectedId];

      var _Object$keys4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.templates);

      var _Object$keys5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_Object$keys4, 1);

      this.selectedId = _Object$keys5[0];
    },
    submitEdit: function submitEdit(cancel) {
      var _this2 = this;

      var template = this.templates[this.selectedId];
      if (!cancel && this.editingName) {
        template.name = __WEBPACK_IMPORTED_MODULE_7__services_utils__["a" /* default */].sanitizeName(this.editingName);
      } else {
        this.editingName = template.name;
      }
      setTimeout(function () {
        _this2.isEditing = false;
      }, 1);
    },
    resolve: function resolve() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var oldTemplateIds, newTemplateIds, createdCount, removedCount;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                oldTemplateIds = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].getters['data/templatesById']);
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].dispatch('data/setTemplatesById', _this3.templates);

              case 3:
                newTemplateIds = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].getters['data/templatesById']);
                createdCount = newTemplateIds.filter(function (id) {
                  return !oldTemplateIds.includes(id);
                }).length;
                removedCount = oldTemplateIds.filter(function (id) {
                  return !newTemplateIds.includes(id);
                }).length;

                if (createdCount) {
                  __WEBPACK_IMPORTED_MODULE_8__services_badgeSvc__["a" /* default */].addBadge('addTemplate');
                }
                if (removedCount) {
                  __WEBPACK_IMPORTED_MODULE_8__services_badgeSvc__["a" /* default */].addBadge('removeTemplate');
                }
                _this3.config.resolve({
                  templates: _this3.templates,
                  selectedId: _this3.selectedId
                });

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    }
  }
});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_ModalInner__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_workspaceSvc__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_badgeSvc__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_localDbSvc__ = __webpack_require__(151);















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ModalInner: __WEBPACK_IMPORTED_MODULE_7__common_ModalInner__["a" /* default */]
  },
  data: function data() {
    return {
      editedId: null,
      editingName: '',
      availableOffline: {}
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])('modal', ['config']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])('workspace', ['workspacesById', 'mainWorkspace', 'currentWorkspace'])),
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('notification', ['info']), {
    edit: function edit(id) {
      this.editedId = id;
      this.editingName = this.workspacesById[id].name;
    },
    submitEdit: function submitEdit(cancel) {
      var workspace = this.workspacesById[this.editedId];
      if (workspace) {
        if (!cancel && this.editingName && this.editingName !== workspace.name) {
          __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].dispatch('workspace/patchWorkspacesById', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, this.editedId, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, workspace, {
            name: this.editingName
          })));
          __WEBPACK_IMPORTED_MODULE_10__services_badgeSvc__["a" /* default */].addBadge('renameWorkspace');
        } else {
          this.editingName = workspace.name;
        }
      }
      this.editedId = null;
    },
    remove: function remove(id) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(id === _this.mainWorkspace.id)) {
                  _context.next = 4;
                  break;
                }

                _this.info('Your main workspace can not be removed.');
                _context.next = 17;
                break;

              case 4:
                if (!(id === _this.currentWorkspace.id)) {
                  _context.next = 8;
                  break;
                }

                _this.info('Please close the workspace before removing it.');
                _context.next = 17;
                break;

              case 8:
                _context.prev = 8;
                _context.next = 11;
                return __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].dispatch('modal/open', 'removeWorkspace');

              case 11:
                __WEBPACK_IMPORTED_MODULE_8__services_workspaceSvc__["a" /* default */].removeWorkspace(id);
                __WEBPACK_IMPORTED_MODULE_10__services_badgeSvc__["a" /* default */].addBadge('removeWorkspace');
                _context.next = 17;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](8);

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[8, 15]]);
      }))();
    }
  }),
  created: function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.workspacesById).forEach(function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(workspaceId) {
        var cancel;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                cancel = __WEBPACK_IMPORTED_MODULE_11__services_localDbSvc__["a" /* default */].getWorkspaceItems(workspaceId, function () {
                  __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].set(_this2.availableOffline, workspaceId, true);
                  cancel();
                });

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  }
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['label', 'info', 'error'],
  data: function data() {
    return {
      uid: __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].uid()
    };
  },
  mounted: function mounted() {
    this.$el.querySelector('input,select').id = this.uid;
  }
});

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('modal', ['config']))
});

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['active']
});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_providers_bloggerPageProvider__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__["a" /* default */])({
  data: function data() {
    return {
      pageId: ''
    };
  },
  computedLocalSettings: {
    blogUrl: 'bloggerBlogUrl',
    selectedTemplate: 'bloggerPublishTemplate'
  },
  methods: {
    resolve: function resolve() {
      if (!this.blogUrl) {
        this.setError('blogUrl');
      } else {
        var location = __WEBPACK_IMPORTED_MODULE_0__services_providers_bloggerPageProvider__["a" /* default */].makeLocation(this.config.token, this.blogUrl, this.pageId);
        location.templateId = this.selectedTemplate;
        this.config.resolve(location);
      }
    }
  }
}));

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_providers_bloggerProvider__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__["a" /* default */])({
  data: function data() {
    return {
      postId: ''
    };
  },
  computedLocalSettings: {
    blogUrl: 'bloggerBlogUrl',
    selectedTemplate: 'bloggerPublishTemplate'
  },
  methods: {
    resolve: function resolve() {
      if (!this.blogUrl) {
        this.setError('blogUrl');
      } else {
        var location = __WEBPACK_IMPORTED_MODULE_0__services_providers_bloggerProvider__["a" /* default */].makeLocation(this.config.token, this.blogUrl, this.postId);
        location.templateId = this.selectedTemplate;
        this.config.resolve(location);
      }
    }
  }
}));

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__["a" /* default */])({
  data: function data() {
    return {
      name: '',
      password: ''
    };
  },
  created: function created() {
    this.name = this.config.token.name;
    this.password = this.config.token.password;
  },

  methods: {
    resolve: function resolve() {
      if (!this.name) {
        this.setError('name');
      }
      if (!this.password) {
        this.setError('password');
      }
      if (this.name && this.password) {
        var token = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.config.token, {
          name: this.name,
          password: this.password
        });
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('data/addCouchdbToken', token);
        this.config.resolve();
      }
    }
  }
}));

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_modalTemplate__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_utils__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_modalTemplate__["a" /* default */])({
  data: function data() {
    return {
      dbUrl: ''
    };
  },
  methods: {
    resolve: function resolve() {
      if (!this.dbUrl) {
        this.setError('dbUrl');
      } else {
        var url = __WEBPACK_IMPORTED_MODULE_1__services_utils__["a" /* default */].addQueryParams('app', {
          providerId: 'couchdbWorkspace',
          dbUrl: this.dbUrl
        }, true);
        this.config.resolve();
        window.open(url);
      }
    }
  }
}));

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_modalTemplate__ = __webpack_require__(13);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_modalTemplate__["a" /* default */])({
  computedLocalSettings: {
    restrictedAccess: 'dropboxRestrictedAccess'
  }
}));

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_providers_dropboxProvider__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__["a" /* default */])({
  data: function data() {
    return {
      path: ''
    };
  },
  computedLocalSettings: {
    selectedTemplate: 'dropboxPublishTemplate'
  },
  created: function created() {
    this.path = '/' + this.currentFileName + '.html';
  },

  methods: {
    resolve: function resolve() {
      if (!__WEBPACK_IMPORTED_MODULE_0__services_providers_dropboxProvider__["a" /* default */].checkPath(this.path)) {
        this.setError('path');
      } else {
        var location = __WEBPACK_IMPORTED_MODULE_0__services_providers_dropboxProvider__["a" /* default */].makeLocation(this.config.token, this.path);
        location.templateId = this.selectedTemplate;
        this.config.resolve(location);
      }
    }
  }
}));

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_providers_dropboxProvider__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__["a" /* default */])({
  data: function data() {
    return {
      path: ''
    };
  },
  created: function created() {
    this.path = '/' + this.currentFileName + '.md';
  },

  methods: {
    resolve: function resolve() {
      if (!__WEBPACK_IMPORTED_MODULE_0__services_providers_dropboxProvider__["a" /* default */].checkPath(this.path)) {
        this.setError('path');
      } else {
        var location = __WEBPACK_IMPORTED_MODULE_0__services_providers_dropboxProvider__["a" /* default */].makeLocation(this.config.token, this.path);
        this.config.resolve(location);
      }
    }
  }
}));

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_providers_gistProvider__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__["a" /* default */])({
  data: function data() {
    return {
      filename: '',
      gistId: ''
    };
  },
  computedLocalSettings: {
    isPublic: 'gistIsPublic',
    selectedTemplate: 'gistPublishTemplate'
  },
  created: function created() {
    this.filename = this.currentFileName + '.md';
  },

  methods: {
    resolve: function resolve() {
      if (!this.filename) {
        this.setError('filename');
      } else {
        var location = __WEBPACK_IMPORTED_MODULE_0__services_providers_gistProvider__["a" /* default */].makeLocation(this.config.token, this.filename, this.isPublic, this.gistId);
        location.templateId = this.selectedTemplate;
        this.config.resolve(location);
      }
    }
  }
}));

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_providers_gistProvider__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__["a" /* default */])({
  data: function data() {
    return {
      filename: '',
      gistId: ''
    };
  },
  computedLocalSettings: {
    isPublic: 'gistIsPublic'
  },
  created: function created() {
    this.filename = this.currentFileName + '.md';
  },

  methods: {
    resolve: function resolve() {
      if (!this.filename) {
        this.setError('filename');
      } else {
        var location = __WEBPACK_IMPORTED_MODULE_0__services_providers_gistProvider__["a" /* default */].makeLocation(this.config.token, this.filename, this.isPublic, this.gistId);
        this.config.resolve(location);
      }
    }
  }
}));

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_modalTemplate__ = __webpack_require__(13);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_modalTemplate__["a" /* default */])({
  computedLocalSettings: {
    repoFullAccess: 'githubRepoFullAccess'
  }
}));

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_providers_githubProvider__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_utils__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__["a" /* default */])({
  data: function data() {
    return {
      branch: '',
      path: ''
    };
  },
  computedLocalSettings: {
    repoUrl: 'githubRepoUrl'
  },
  methods: {
    resolve: function resolve() {
      var parsedRepo = __WEBPACK_IMPORTED_MODULE_2__services_utils__["a" /* default */].parseGithubRepoUrl(this.repoUrl);
      if (!parsedRepo) {
        this.setError('repoUrl');
      }
      if (!this.path) {
        this.setError('path');
      }
      if (parsedRepo && this.path) {
        var location = __WEBPACK_IMPORTED_MODULE_0__services_providers_githubProvider__["a" /* default */].makeLocation(this.config.token, parsedRepo.owner, parsedRepo.repo, this.branch || 'master', this.path);
        this.config.resolve(location);
      }
    }
  }
}));

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_providers_githubProvider__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_utils__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__["a" /* default */])({
  data: function data() {
    return {
      branch: '',
      path: ''
    };
  },
  computedLocalSettings: {
    repoUrl: 'githubRepoUrl',
    selectedTemplate: 'githubPublishTemplate'
  },
  created: function created() {
    this.path = this.currentFileName + '.md';
  },

  methods: {
    resolve: function resolve() {
      var parsedRepo = __WEBPACK_IMPORTED_MODULE_2__services_utils__["a" /* default */].parseGithubRepoUrl(this.repoUrl);
      if (!parsedRepo) {
        this.setError('repoUrl');
      }
      if (!this.path) {
        this.setError('path');
      }
      if (parsedRepo && this.path) {
        var location = __WEBPACK_IMPORTED_MODULE_0__services_providers_githubProvider__["a" /* default */].makeLocation(this.config.token, parsedRepo.owner, parsedRepo.repo, this.branch || 'master', this.path);
        location.templateId = this.selectedTemplate;
        this.config.resolve(location);
      }
    }
  }
}));

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_providers_githubProvider__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_utils__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__["a" /* default */])({
  data: function data() {
    return {
      branch: '',
      path: ''
    };
  },
  computedLocalSettings: {
    repoUrl: 'githubRepoUrl'
  },
  created: function created() {
    this.path = this.currentFileName + '.md';
  },

  methods: {
    resolve: function resolve() {
      var parsedRepo = __WEBPACK_IMPORTED_MODULE_2__services_utils__["a" /* default */].parseGithubRepoUrl(this.repoUrl);
      if (!parsedRepo) {
        this.setError('repoUrl');
      }
      if (!this.path) {
        this.setError('path');
      }
      if (parsedRepo && this.path) {
        var location = __WEBPACK_IMPORTED_MODULE_0__services_providers_githubProvider__["a" /* default */].makeLocation(this.config.token, parsedRepo.owner, parsedRepo.repo, this.branch || 'master', this.path);
        this.config.resolve(location);
      }
    }
  }
}));

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_modalTemplate__ = __webpack_require__(13);






/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_modalTemplate__["a" /* default */])({
  data: function data() {
    return {
      branch: '',
      path: ''
    };
  },
  computedLocalSettings: {
    repoUrl: 'githubWorkspaceRepoUrl'
  },
  methods: {
    resolve: function resolve() {
      var parsedRepo = __WEBPACK_IMPORTED_MODULE_1__services_utils__["a" /* default */].parseGithubRepoUrl(this.repoUrl);
      if (!parsedRepo) {
        this.setError('repoUrl');
      } else {
        var path = this.path && this.path.replace(/^\//, '');
        var url = __WEBPACK_IMPORTED_MODULE_1__services_utils__["a" /* default */].addQueryParams('app', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, parsedRepo, {
          providerId: 'githubWorkspace',
          branch: this.branch || 'master',
          path: path || undefined
        }), true);
        this.config.resolve();
        window.open(url);
      }
    }
  }
}));

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_modalTemplate__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_constants__ = __webpack_require__(94);





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_modalTemplate__["a" /* default */])({
  data: function data() {
    return {
      redirectUrl: __WEBPACK_IMPORTED_MODULE_1__data_constants__["a" /* default */].oauth2RedirectUri
    };
  },
  computedLocalSettings: {
    serverUrl: 'gitlabServerUrl',
    applicationId: 'gitlabApplicationId'
  },
  methods: {
    resolve: function resolve() {
      var serverUrl = this.config.forceServerUrl || this.serverUrl;
      if (!serverUrl) {
        this.setError('serverUrl');
      }
      if (!this.applicationId) {
        this.setError('applicationId');
      }
      if (serverUrl && this.applicationId) {
        var parsedUrl = serverUrl.match(/^(https:\/\/[^/]+)/);
        if (!parsedUrl) {
          this.setError('serverUrl');
        } else {
          this.config.resolve({
            serverUrl: parsedUrl[1],
            applicationId: this.applicationId
          });
        }
      }
    }
  }
}));

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_providers_gitlabProvider__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_utils__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__["a" /* default */])({
  data: function data() {
    return {
      branch: '',
      path: ''
    };
  },
  computedLocalSettings: {
    projectUrl: 'gitlabProjectUrl'
  },
  methods: {
    resolve: function resolve() {
      var projectPath = __WEBPACK_IMPORTED_MODULE_2__services_utils__["a" /* default */].parseGitlabProjectPath(this.projectUrl);
      if (!projectPath) {
        this.setError('projectUrl');
      }
      if (!this.path) {
        this.setError('path');
      }
      if (projectPath && this.path) {
        var location = __WEBPACK_IMPORTED_MODULE_0__services_providers_gitlabProvider__["a" /* default */].makeLocation(this.config.token, projectPath, this.branch || 'master', this.path);
        this.config.resolve(location);
      }
    }
  }
}));

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_providers_gitlabProvider__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_utils__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__["a" /* default */])({
  data: function data() {
    return {
      branch: '',
      path: ''
    };
  },
  computedLocalSettings: {
    projectUrl: 'gitlabProjectUrl',
    selectedTemplate: 'gitlabPublishTemplate'
  },
  created: function created() {
    this.path = this.currentFileName + '.md';
  },

  methods: {
    resolve: function resolve() {
      var projectPath = __WEBPACK_IMPORTED_MODULE_2__services_utils__["a" /* default */].parseGitlabProjectPath(this.projectUrl);
      if (!projectPath) {
        this.setError('projectUrl');
      }
      if (!this.path) {
        this.setError('path');
      }
      if (projectPath && this.path) {
        var location = __WEBPACK_IMPORTED_MODULE_0__services_providers_gitlabProvider__["a" /* default */].makeLocation(this.config.token, projectPath, this.branch || 'master', this.path);
        location.templateId = this.selectedTemplate;
        this.config.resolve(location);
      }
    }
  }
}));

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_providers_gitlabProvider__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_utils__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__["a" /* default */])({
  data: function data() {
    return {
      branch: '',
      path: ''
    };
  },
  computedLocalSettings: {
    projectUrl: 'gitlabProjectUrl'
  },
  created: function created() {
    this.path = this.currentFileName + '.md';
  },

  methods: {
    resolve: function resolve() {
      var projectPath = __WEBPACK_IMPORTED_MODULE_2__services_utils__["a" /* default */].parseGitlabProjectPath(this.projectUrl);
      if (!projectPath) {
        this.setError('projectUrl');
      }
      if (!this.path) {
        this.setError('path');
      }
      if (projectPath && this.path) {
        var location = __WEBPACK_IMPORTED_MODULE_0__services_providers_gitlabProvider__["a" /* default */].makeLocation(this.config.token, projectPath, this.branch || 'master', this.path);
        this.config.resolve(location);
      }
    }
  }
}));

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__["a" /* default */])({
  data: function data() {
    return {
      branch: '',
      path: ''
    };
  },
  computedLocalSettings: {
    projectUrl: 'gitlabWorkspaceProjectUrl'
  },
  methods: {
    resolve: function resolve() {
      var projectPath = __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].parseGitlabProjectPath(this.projectUrl);
      if (!projectPath) {
        this.setError('projectUrl');
      } else {
        var path = this.path && this.path.replace(/^\//, '');
        var url = __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].addQueryParams('app', {
          providerId: 'gitlabWorkspace',
          serverUrl: this.config.token.serverUrl,
          projectPath: projectPath,
          branch: this.branch || 'master',
          path: path || undefined,
          sub: this.config.token.sub
        }, true);
        this.config.resolve();
        window.open(url);
      }
    }
  }
}));

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_modalTemplate__ = __webpack_require__(13);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_modalTemplate__["a" /* default */])({
  computedLocalSettings: {
    restrictedAccess: 'googleDriveRestrictedAccess'
  }
}));

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_providers_helpers_googleHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_providers_googleDriveProvider__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_modalTemplate__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_modalTemplate__["a" /* default */])({
  data: function data() {
    return {
      fileId: ''
    };
  },
  computedLocalSettings: {
    folderId: 'googleDriveFolderId',
    selectedTemplate: 'googleDrivePublishTemplate',
    format: 'googleDrivePublishFormat'
  },
  methods: {
    openFolder: function openFolder() {
      return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('modal/hideUntil', __WEBPACK_IMPORTED_MODULE_0__services_providers_helpers_googleHelper__["a" /* default */].openPicker(this.config.token, 'folder').then(function (folders) {
        if (folders[0]) {
          __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('data/patchLocalSettings', {
            googleDriveFolderId: folders[0].id
          });
        }
      }));
    },
    resolve: function resolve() {
      var location = __WEBPACK_IMPORTED_MODULE_1__services_providers_googleDriveProvider__["a" /* default */].makeLocation(this.config.token, this.fileId);
      if (this.format === 'html') {
        location.templateId = this.selectedTemplate;
      }
      this.config.resolve(location);
    }
  }
}));

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_providers_helpers_googleHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_providers_googleDriveProvider__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_modalTemplate__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_modalTemplate__["a" /* default */])({
  data: function data() {
    return {
      fileId: ''
    };
  },
  computedLocalSettings: {
    folderId: 'googleDriveFolderId'
  },
  methods: {
    openFolder: function openFolder() {
      return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('modal/hideUntil', __WEBPACK_IMPORTED_MODULE_0__services_providers_helpers_googleHelper__["a" /* default */].openPicker(this.config.token, 'folder').then(function (folders) {
        if (folders[0]) {
          __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('data/patchLocalSettings', {
            googleDriveFolderId: folders[0].id
          });
        }
      }));
    },
    resolve: function resolve() {
      var location = __WEBPACK_IMPORTED_MODULE_1__services_providers_googleDriveProvider__["a" /* default */].makeLocation(this.config.token, this.fileId, this.folderId);
      this.config.resolve(location);
    }
  }
}));

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_providers_helpers_googleHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__["a" /* default */])({
  computedLocalSettings: {
    folderId: 'googleDriveWorkspaceFolderId'
  },
  methods: {
    openFolder: function openFolder() {
      return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('modal/hideUntil', __WEBPACK_IMPORTED_MODULE_0__services_providers_helpers_googleHelper__["a" /* default */].openPicker(this.config.token, 'folder').then(function (folders) {
        if (folders[0]) {
          __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('data/patchLocalSettings', {
            googleDriveWorkspaceFolderId: folders[0].id
          });
        }
      }));
    },
    resolve: function resolve() {
      var url = __WEBPACK_IMPORTED_MODULE_2__services_utils__["a" /* default */].addQueryParams('app', {
        providerId: 'googleDriveWorkspace',
        folderId: this.folderId,
        sub: this.config.token.sub
      }, true);
      this.config.resolve();
      window.open(url);
    }
  }
}));

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_ModalInner__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_FormEntry__ = __webpack_require__(448);








var makeThumbnail = function makeThumbnail(url, size) {
  return url + '=s' + size;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ModalInner: __WEBPACK_IMPORTED_MODULE_3__common_ModalInner__["a" /* default */],
    FormEntry: __WEBPACK_IMPORTED_MODULE_4__common_FormEntry__["a" /* default */]
  },
  data: function data() {
    return {
      title: '',
      size: ''
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    thumbnailUrl: function thumbnailUrl() {
      return 'url(' + makeThumbnail(this.config.url, 320) + ')';
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('modal', ['config'])),
  methods: {
    resolve: function resolve() {
      var url = this.config.url;

      var size = parseInt(this.size, 10);
      if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(size)) {
        url = makeThumbnail(url, size);
      }
      if (this.title) {
        url += ' "' + this.title + '"';
      }
      var callback = this.config.callback;

      this.config.resolve();
      callback(url);
    },
    reject: function reject() {
      var callback = this.config.callback;

      this.config.reject();
      callback(null);
    }
  }
});

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_providers_wordpressProvider__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__["a" /* default */])({
  data: function data() {
    return {
      postId: ''
    };
  },
  computedLocalSettings: {
    domain: 'wordpressDomain',
    selectedTemplate: 'wordpressPublishTemplate'
  },
  methods: {
    resolve: function resolve() {
      if (!this.domain) {
        this.setError('domain');
      } else {
        var location = __WEBPACK_IMPORTED_MODULE_0__services_providers_wordpressProvider__["a" /* default */].makeLocation(this.config.token, this.domain, this.postId);
        location.templateId = this.selectedTemplate;
        this.config.resolve(location);
      }
    }
  }
}));

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_modalTemplate__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_constants__ = __webpack_require__(94);





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_modalTemplate__["a" /* default */])({
  data: function data() {
    return {
      redirectUrl: __WEBPACK_IMPORTED_MODULE_1__data_constants__["a" /* default */].oauth2RedirectUri
    };
  },
  computedLocalSettings: {
    siteUrl: 'zendeskSiteUrl',
    clientId: 'zendeskClientId'
  },
  methods: {
    resolve: function resolve() {
      if (!this.siteUrl) {
        this.setError('siteUrl');
      }
      if (!this.clientId) {
        this.setError('clientId');
      }
      if (this.siteUrl && this.clientId) {
        var parsedUrl = this.siteUrl.match(/^https:\/\/([^.]+)\.zendesk\.com/);
        if (!parsedUrl) {
          this.setError('siteUrl');
        } else {
          this.config.resolve({
            subdomain: parsedUrl[1],
            clientId: this.clientId
          });
        }
      }
    }
  }
}));

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_providers_zendeskProvider__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_modalTemplate__["a" /* default */])({
  data: function data() {
    return {
      articleId: ''
    };
  },
  computedLocalSettings: {
    sectionId: 'zendescPublishSectionId',
    locale: 'zendescPublishLocale',
    selectedTemplate: 'zendeskPublishTemplate'
  },
  methods: {
    resolve: function resolve() {
      if (!this.sectionId && !this.articleId) {
        this.setError('sectionId');
      } else {
        var location = __WEBPACK_IMPORTED_MODULE_0__services_providers_zendeskProvider__["a" /* default */].makeLocation(this.config.token, this.sectionId, this.locale || 'en-us', this.articleId);
        location.templateId = this.selectedTemplate;
        this.config.resolve(location);
      }
    }
  }
}));

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['providerId'],
  computed: {
    classState: function classState() {
      switch (this.providerId) {
        case 'googleDrive':
        case 'googleDriveAppData':
        case 'googleDriveWorkspace':
          return 'google-drive';
        case 'googlePhotos':
          return 'google-photos';
        case 'githubWorkspace':
          return 'github';
        case 'gist':
          return 'github';
        case 'gitlabWorkspace':
          return 'gitlab';
        case 'bloggerPage':
          return 'blogger';
        case 'couchdbWorkspace':
          return 'couchdb';
        default:
          return this.providerId;
      }
    }
  }
});

/***/ }),
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 749 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 750 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 751 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 752 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 753 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 754 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 755 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 756 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 759 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 760 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 762 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 763 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 764 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 765 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 767 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 769 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 770 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 771 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 772 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 773 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 774 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 775 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 776 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 777 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 778 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 779 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 780 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 781 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 782 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 783 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 784 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 785 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./bmp": 832,
	"./bmp.js": 832,
	"./gif": 833,
	"./gif.js": 833,
	"./jpg": 834,
	"./jpg.js": 834,
	"./png": 835,
	"./png.js": 835,
	"./psd": 836,
	"./psd.js": 836,
	"./svg": 837,
	"./svg.js": 837,
	"./tiff": 838,
	"./tiff.js": 838,
	"./webp": 839,
	"./webp.js": 839
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 830;

/***/ }),
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */
/***/ (function(module, exports) {

module.exports = "# light or dark\ncolorTheme: light\n# Adjust font size in editor and preview\nfontSizeFactor: 1\n# Adjust maximum text width in editor and preview\nmaxWidthFactor: 1\n# Auto-sync frequency (in ms). Minimum is 60000.\nautoSyncEvery: 90000\n\n# Editor settings\neditor:\n  # Automatic list numbering\n  listAutoNumber: true\n  # Display images in the editor\n  inlineImages: true\n  # Use monospaced font only\n  monospacedFontOnly: false\n\n# Keyboard shortcuts\n# See https://craig.is/killing/mice\nshortcuts:\n  mod+s: sync\n  mod+f: find\n  mod+alt+f: replace\n  mod+g: replace\n  mod+shift+b: bold\n  mod+shift+c: clist\n  mod+shift+k: code\n  mod+shift+h: heading\n  mod+shift+r: hr\n  mod+shift+g: image\n  mod+shift+i: italic\n  mod+shift+l: link\n  mod+shift+o: olist\n  mod+shift+q: quote\n  mod+shift+s: strikethrough\n  mod+shift+t: table\n  mod+shift+u: ulist\n  '= = > space':\n    method: expand\n    params:\n    - '==> '\n    - '⇒ '\n  '< = = space':\n    method: expand\n    params:\n    - '<== '\n    - '⇐ '\n\n# Options passed to wkhtmltopdf\n# See https://wkhtmltopdf.org/usage/wkhtmltopdf.txt\nwkhtmltopdf:\n  marginTop: 25\n  marginRight: 25\n  marginBottom: 25\n  marginLeft: 25\n  # A3, A4, Legal or Letter\n  pageSize: A4\n\n# Options passed to pandoc\n# See https://pandoc.org/MANUAL.html\npandoc:\n  highlightStyle: kate\n  toc: true\n  tocDepth: 3\n\n# HTML to Markdown converter options\n# See https://github.com/domchristie/turndown\nturndown:\n  headingStyle: atx\n  hr: ----------\n  bulletListMarker: '-'\n  codeBlockStyle: fenced\n  fence: '```'\n  emDelimiter: _\n  strongDelimiter: '**'\n  linkStyle: inlined\n  linkReferenceStyle: full\n\n# GitHub/GitLab commit messages\ngit:\n  createFileMessage: '{{path}} created from https://stackedit.io/'\n  updateFileMessage: '{{path}} updated from https://stackedit.io/'\n  deleteFileMessage: '{{path}} deleted from https://stackedit.io/'\n\n# Default content for new files\nnewFileContent: |\n\n\n\n  > Written with [StackEdit](https://stackedit.io/).\n\n# Default properties for new files\nnewFileProperties: |\n#  extensions:\n#    preset: gfm\n\n"

/***/ }),
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserName_vue_vue_type_template_id_e4a96cac___ = __webpack_require__(2397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserName_vue_vue_type_script_lang_js___ = __webpack_require__(876);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__UserName_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__UserName_vue_vue_type_template_id_e4a96cac___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__UserName_vue_vue_type_template_id_e4a96cac___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserName.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Comment_vue_vue_type_template_id_5125024a___ = __webpack_require__(2398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Comment_vue_vue_type_script_lang_js___ = __webpack_require__(877);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Comment_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Comment_vue_vue_type_template_id_5125024a___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Comment_vue_vue_type_template_id_5125024a___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Comment.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommentList_vue_vue_type_template_id_69b763ee___ = __webpack_require__(2399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CommentList_vue_vue_type_script_lang_js___ = __webpack_require__(878);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CommentList_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__CommentList_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__CommentList_vue_vue_type_template_id_69b763ee___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__CommentList_vue_vue_type_template_id_69b763ee___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "CommentList.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NewComment_vue_vue_type_template_id_2d6ad252___ = __webpack_require__(2402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NewComment_vue_vue_type_script_lang_js___ = __webpack_require__(881);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__NewComment_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__NewComment_vue_vue_type_template_id_2d6ad252___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__NewComment_vue_vue_type_template_id_2d6ad252___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewComment.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StickyComment_vue_vue_type_template_id_19671b10___ = __webpack_require__(2404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StickyComment_vue_vue_type_script_lang_js___ = __webpack_require__(883);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StickyComment_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__StickyComment_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__StickyComment_vue_vue_type_template_id_19671b10___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__StickyComment_vue_vue_type_template_id_19671b10___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "StickyComment.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tab_vue_vue_type_template_id_1ec480ff___ = __webpack_require__(2430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tab_vue_vue_type_script_lang_js___ = __webpack_require__(908);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Tab_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Tab_vue_vue_type_template_id_1ec480ff___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Tab_vue_vue_type_template_id_1ec480ff___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Tab.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js___ = __webpack_require__(464);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonBar_vue_vue_type_script_lang_js___ = __webpack_require__(465);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonBar_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeEditor_vue_vue_type_script_lang_js___ = __webpack_require__(466);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeEditor_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ContextMenu_vue_vue_type_script_lang_js___ = __webpack_require__(467);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ContextMenu_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Editor_vue_vue_type_script_lang_js___ = __webpack_require__(468);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Editor_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Explorer_vue_vue_type_script_lang_js___ = __webpack_require__(469);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Explorer_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ExplorerNode_vue_vue_type_script_lang_js___ = __webpack_require__(470);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ExplorerNode_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_FindReplace_vue_vue_type_script_lang_js___ = __webpack_require__(471);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_FindReplace_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Layout_vue_vue_type_script_lang_js___ = __webpack_require__(472);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Layout_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Modal_vue_vue_type_script_lang_js___ = __webpack_require__(473);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Modal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_NavigationBar_vue_vue_type_script_lang_js___ = __webpack_require__(474);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_NavigationBar_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Notification_vue_vue_type_script_lang_js___ = __webpack_require__(475);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Notification_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Preview_vue_vue_type_script_lang_js___ = __webpack_require__(476);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Preview_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SideBar_vue_vue_type_script_lang_js___ = __webpack_require__(477);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SideBar_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusBar_vue_vue_type_script_lang_js___ = __webpack_require__(478);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusBar_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Toc_vue_vue_type_script_lang_js___ = __webpack_require__(479);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Toc_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Tour_vue_vue_type_script_lang_js___ = __webpack_require__(480);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Tour_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_UserImage_vue_vue_type_script_lang_js___ = __webpack_require__(481);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_UserImage_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_UserName_vue_vue_type_script_lang_js___ = __webpack_require__(482);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_UserName_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Comment_vue_vue_type_script_lang_js___ = __webpack_require__(483);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Comment_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CommentList_vue_vue_type_script_lang_js___ = __webpack_require__(484);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CommentList_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CurrentDiscussion_vue_vue_type_script_lang_js___ = __webpack_require__(485);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CurrentDiscussion_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_EditorNewDiscussionButton_vue_vue_type_script_lang_js___ = __webpack_require__(486);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_EditorNewDiscussionButton_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_NewComment_vue_vue_type_script_lang_js___ = __webpack_require__(487);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_NewComment_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PreviewNewDiscussionButton_vue_vue_type_script_lang_js___ = __webpack_require__(488);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PreviewNewDiscussionButton_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_StickyComment_vue_vue_type_script_lang_js___ = __webpack_require__(489);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_StickyComment_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryMenu_vue_vue_type_script_lang_js___ = __webpack_require__(490);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryMenu_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportExportMenu_vue_vue_type_script_lang_js___ = __webpack_require__(491);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportExportMenu_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MainMenu_vue_vue_type_script_lang_js___ = __webpack_require__(492);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MainMenu_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PublishMenu_vue_vue_type_script_lang_js___ = __webpack_require__(493);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PublishMenu_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SyncMenu_vue_vue_type_script_lang_js___ = __webpack_require__(494);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SyncMenu_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkspaceBackupMenu_vue_vue_type_script_lang_js___ = __webpack_require__(495);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkspaceBackupMenu_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkspacesMenu_vue_vue_type_script_lang_js___ = __webpack_require__(496);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkspacesMenu_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AboutModal_vue_vue_type_script_lang_js___ = __webpack_require__(497);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AboutModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AccountManagementModal_vue_vue_type_script_lang_js___ = __webpack_require__(498);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AccountManagementModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BadgeManagementModal_vue_vue_type_script_lang_js___ = __webpack_require__(499);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BadgeManagementModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_FilePropertiesModal_vue_vue_type_script_lang_js___ = __webpack_require__(500);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_FilePropertiesModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_HtmlExportModal_vue_vue_type_script_lang_js___ = __webpack_require__(501);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_HtmlExportModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageModal_vue_vue_type_script_lang_js___ = __webpack_require__(502);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_LinkModal_vue_vue_type_script_lang_js___ = __webpack_require__(503);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_LinkModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PandocExportModal_vue_vue_type_script_lang_js___ = __webpack_require__(504);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PandocExportModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PdfExportModal_vue_vue_type_script_lang_js___ = __webpack_require__(505);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PdfExportModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PublishManagementModal_vue_vue_type_script_lang_js___ = __webpack_require__(506);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PublishManagementModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SettingsModal_vue_vue_type_script_lang_js___ = __webpack_require__(507);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SettingsModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SponsorModal_vue_vue_type_script_lang_js___ = __webpack_require__(508);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SponsorModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SyncManagementModal_vue_vue_type_script_lang_js___ = __webpack_require__(509);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SyncManagementModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TemplatesModal_vue_vue_type_script_lang_js___ = __webpack_require__(510);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TemplatesModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkspaceManagementModal_vue_vue_type_script_lang_js___ = __webpack_require__(511);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkspaceManagementModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_FormEntry_vue_vue_type_script_lang_js___ = __webpack_require__(512);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_FormEntry_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ModalInner_vue_vue_type_script_lang_js___ = __webpack_require__(513);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ModalInner_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Tab_vue_vue_type_script_lang_js___ = __webpack_require__(514);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Tab_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BloggerPagePublishModal_vue_vue_type_script_lang_js___ = __webpack_require__(515);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BloggerPagePublishModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BloggerPublishModal_vue_vue_type_script_lang_js___ = __webpack_require__(516);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BloggerPublishModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CouchdbCredentialsModal_vue_vue_type_script_lang_js___ = __webpack_require__(517);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CouchdbCredentialsModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CouchdbWorkspaceModal_vue_vue_type_script_lang_js___ = __webpack_require__(518);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CouchdbWorkspaceModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DropboxAccountModal_vue_vue_type_script_lang_js___ = __webpack_require__(519);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DropboxAccountModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DropboxPublishModal_vue_vue_type_script_lang_js___ = __webpack_require__(520);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DropboxPublishModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DropboxSaveModal_vue_vue_type_script_lang_js___ = __webpack_require__(521);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DropboxSaveModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GistPublishModal_vue_vue_type_script_lang_js___ = __webpack_require__(522);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GistPublishModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GistSyncModal_vue_vue_type_script_lang_js___ = __webpack_require__(523);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GistSyncModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GithubAccountModal_vue_vue_type_script_lang_js___ = __webpack_require__(524);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GithubAccountModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GithubOpenModal_vue_vue_type_script_lang_js___ = __webpack_require__(525);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GithubOpenModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GithubPublishModal_vue_vue_type_script_lang_js___ = __webpack_require__(526);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GithubPublishModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GithubSaveModal_vue_vue_type_script_lang_js___ = __webpack_require__(527);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GithubSaveModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GithubWorkspaceModal_vue_vue_type_script_lang_js___ = __webpack_require__(528);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GithubWorkspaceModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GitlabAccountModal_vue_vue_type_script_lang_js___ = __webpack_require__(529);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GitlabAccountModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GitlabOpenModal_vue_vue_type_script_lang_js___ = __webpack_require__(530);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GitlabOpenModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GitlabPublishModal_vue_vue_type_script_lang_js___ = __webpack_require__(531);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GitlabPublishModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GitlabSaveModal_vue_vue_type_script_lang_js___ = __webpack_require__(532);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GitlabSaveModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GitlabWorkspaceModal_vue_vue_type_script_lang_js___ = __webpack_require__(533);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GitlabWorkspaceModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GoogleDriveAccountModal_vue_vue_type_script_lang_js___ = __webpack_require__(534);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GoogleDriveAccountModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GoogleDrivePublishModal_vue_vue_type_script_lang_js___ = __webpack_require__(535);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GoogleDrivePublishModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GoogleDriveSaveModal_vue_vue_type_script_lang_js___ = __webpack_require__(536);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GoogleDriveSaveModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GoogleDriveWorkspaceModal_vue_vue_type_script_lang_js___ = __webpack_require__(537);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GoogleDriveWorkspaceModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GooglePhotoModal_vue_vue_type_script_lang_js___ = __webpack_require__(538);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GooglePhotoModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_WordpressPublishModal_vue_vue_type_script_lang_js___ = __webpack_require__(539);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_WordpressPublishModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ZendeskAccountModal_vue_vue_type_script_lang_js___ = __webpack_require__(540);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ZendeskAccountModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ZendeskPublishModal_vue_vue_type_script_lang_js___ = __webpack_require__(541);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ZendeskPublishModal_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Provider_vue_vue_type_script_lang_js___ = __webpack_require__(542);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Provider_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 937 */,
/* 938 */,
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emojiExtension__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__abcExtension__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__katexExtension__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__markdownExtension__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mermaidExtension__ = __webpack_require__(987);






/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Provider__ = __webpack_require__(2324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormatBold__ = __webpack_require__(2303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FormatItalic__ = __webpack_require__(2304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormatQuoteClose__ = __webpack_require__(2308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LinkVariant__ = __webpack_require__(2315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FileImage__ = __webpack_require__(2298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Table__ = __webpack_require__(2334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormatListNumbers__ = __webpack_require__(2307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FormatListBulleted__ = __webpack_require__(2305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FormatSize__ = __webpack_require__(2309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FormatStrikethrough__ = __webpack_require__(2310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__StatusBar__ = __webpack_require__(2331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__NavigationBar__ = __webpack_require__(2320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SidePreview__ = __webpack_require__(2329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Eye__ = __webpack_require__(2297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Settings__ = __webpack_require__(2328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__FilePlus__ = __webpack_require__(2300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__FileMultiple__ = __webpack_require__(2299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__FolderPlus__ = __webpack_require__(2302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Delete__ = __webpack_require__(2294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Close__ = __webpack_require__(2288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Pen__ = __webpack_require__(2322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Target__ = __webpack_require__(2335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ArrowLeft__ = __webpack_require__(2286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__HelpCircle__ = __webpack_require__(2311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Toc__ = __webpack_require__(2336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Login__ = __webpack_require__(2316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Logout__ = __webpack_require__(2317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Sync__ = __webpack_require__(2332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__SyncOff__ = __webpack_require__(2333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Upload__ = __webpack_require__(2338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ViewList__ = __webpack_require__(2339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Download__ = __webpack_require__(2296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__CodeTags__ = __webpack_require__(2290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__CodeBraces__ = __webpack_require__(2289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__OpenInNew__ = __webpack_require__(2321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Information__ = __webpack_require__(2313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Alert__ = __webpack_require__(2285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__SignalOff__ = __webpack_require__(2330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Folder__ = __webpack_require__(2301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__ScrollSync__ = __webpack_require__(2326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Printer__ = __webpack_require__(2323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Undo__ = __webpack_require__(2337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Redo__ = __webpack_require__(2325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__ContentSave__ = __webpack_require__(2292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Message__ = __webpack_require__(2319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__History__ = __webpack_require__(2312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Database__ = __webpack_require__(2293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Magnify__ = __webpack_require__(2318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__FormatListChecks__ = __webpack_require__(2306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__CheckCircle__ = __webpack_require__(2287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__ContentCopy__ = __webpack_require__(2291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__Key__ = __webpack_require__(2314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__DotsHorizontal__ = __webpack_require__(2295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Seal__ = __webpack_require__(2327);

























































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconProvider', __WEBPACK_IMPORTED_MODULE_1__Provider__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconFormatBold', __WEBPACK_IMPORTED_MODULE_2__FormatBold__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconFormatItalic', __WEBPACK_IMPORTED_MODULE_3__FormatItalic__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconFormatQuoteClose', __WEBPACK_IMPORTED_MODULE_4__FormatQuoteClose__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconLinkVariant', __WEBPACK_IMPORTED_MODULE_5__LinkVariant__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconFileImage', __WEBPACK_IMPORTED_MODULE_6__FileImage__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconTable', __WEBPACK_IMPORTED_MODULE_7__Table__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconFormatListNumbers', __WEBPACK_IMPORTED_MODULE_8__FormatListNumbers__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconFormatListBulleted', __WEBPACK_IMPORTED_MODULE_9__FormatListBulleted__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconFormatSize', __WEBPACK_IMPORTED_MODULE_10__FormatSize__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconFormatStrikethrough', __WEBPACK_IMPORTED_MODULE_11__FormatStrikethrough__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconStatusBar', __WEBPACK_IMPORTED_MODULE_12__StatusBar__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconNavigationBar', __WEBPACK_IMPORTED_MODULE_13__NavigationBar__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconSidePreview', __WEBPACK_IMPORTED_MODULE_14__SidePreview__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconEye', __WEBPACK_IMPORTED_MODULE_15__Eye__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconSettings', __WEBPACK_IMPORTED_MODULE_16__Settings__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconFilePlus', __WEBPACK_IMPORTED_MODULE_17__FilePlus__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconFileMultiple', __WEBPACK_IMPORTED_MODULE_18__FileMultiple__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconFolderPlus', __WEBPACK_IMPORTED_MODULE_19__FolderPlus__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconDelete', __WEBPACK_IMPORTED_MODULE_20__Delete__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconClose', __WEBPACK_IMPORTED_MODULE_21__Close__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconPen', __WEBPACK_IMPORTED_MODULE_22__Pen__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconTarget', __WEBPACK_IMPORTED_MODULE_23__Target__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconArrowLeft', __WEBPACK_IMPORTED_MODULE_24__ArrowLeft__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconHelpCircle', __WEBPACK_IMPORTED_MODULE_25__HelpCircle__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconToc', __WEBPACK_IMPORTED_MODULE_26__Toc__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconLogin', __WEBPACK_IMPORTED_MODULE_27__Login__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconLogout', __WEBPACK_IMPORTED_MODULE_28__Logout__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconSync', __WEBPACK_IMPORTED_MODULE_29__Sync__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconSyncOff', __WEBPACK_IMPORTED_MODULE_30__SyncOff__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconUpload', __WEBPACK_IMPORTED_MODULE_31__Upload__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconViewList', __WEBPACK_IMPORTED_MODULE_32__ViewList__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconDownload', __WEBPACK_IMPORTED_MODULE_33__Download__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconCodeTags', __WEBPACK_IMPORTED_MODULE_34__CodeTags__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconCodeBraces', __WEBPACK_IMPORTED_MODULE_35__CodeBraces__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconOpenInNew', __WEBPACK_IMPORTED_MODULE_36__OpenInNew__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconInformation', __WEBPACK_IMPORTED_MODULE_37__Information__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconAlert', __WEBPACK_IMPORTED_MODULE_38__Alert__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconSignalOff', __WEBPACK_IMPORTED_MODULE_39__SignalOff__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconFolder', __WEBPACK_IMPORTED_MODULE_40__Folder__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconScrollSync', __WEBPACK_IMPORTED_MODULE_41__ScrollSync__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconPrinter', __WEBPACK_IMPORTED_MODULE_42__Printer__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconUndo', __WEBPACK_IMPORTED_MODULE_43__Undo__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconRedo', __WEBPACK_IMPORTED_MODULE_44__Redo__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconContentSave', __WEBPACK_IMPORTED_MODULE_45__ContentSave__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconMessage', __WEBPACK_IMPORTED_MODULE_46__Message__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconHistory', __WEBPACK_IMPORTED_MODULE_47__History__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconDatabase', __WEBPACK_IMPORTED_MODULE_48__Database__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconMagnify', __WEBPACK_IMPORTED_MODULE_49__Magnify__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconFormatListChecks', __WEBPACK_IMPORTED_MODULE_50__FormatListChecks__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconCheckCircle', __WEBPACK_IMPORTED_MODULE_51__CheckCircle__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconContentCopy', __WEBPACK_IMPORTED_MODULE_52__ContentCopy__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconKey', __WEBPACK_IMPORTED_MODULE_53__Key__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconDotsHorizontal', __WEBPACK_IMPORTED_MODULE_54__DotsHorizontal__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('iconSeal', __WEBPACK_IMPORTED_MODULE_55__Seal__["a" /* default */]);

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shortcuts__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keystrokes__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scrollSync__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__taskChange__ = __webpack_require__(1004);





/***/ }),
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_3d7fc3de___ = __webpack_require__(2378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue_vue_type_script_lang_js___ = __webpack_require__(858);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__App_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_3d7fc3de___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_3d7fc3de___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "App.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_timeSvc__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(2);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('focus', {
  inserted: function inserted(el) {
    el.focus();
    var value = el.value;

    if (value && el.setSelectionRange) {
      el.setSelectionRange(0, value.length);
    }
  }
});

var setVisible = function setVisible(el, value) {
  el.style.display = value ? '' : 'none';
  if (value) {
    el.removeAttribute('aria-hidden');
  } else {
    el.setAttribute('aria-hidden', 'true');
  }
};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('show', {
  bind: function bind(el, _ref) {
    var value = _ref.value;

    setVisible(el, value);
  },
  update: function update(el, _ref2) {
    var value = _ref2.value,
        oldValue = _ref2.oldValue;

    if (value !== oldValue) {
      setVisible(el, value);
    }
  }
});

var setElTitle = function setElTitle(el, title) {
  el.title = title;
  el.setAttribute('aria-label', title);
};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('title', {
  bind: function bind(el, _ref3) {
    var value = _ref3.value;

    setElTitle(el, value);
  },
  update: function update(el, _ref4) {
    var value = _ref4.value,
        oldValue = _ref4.oldValue;

    if (value !== oldValue) {
      setElTitle(el, value);
    }
  }
});

var createClipboard = function createClipboard(el, value) {
  el.seClipboard = new __WEBPACK_IMPORTED_MODULE_1_clipboard___default.a(el, { text: function text() {
      return value;
    } });
};
var destroyClipboard = function destroyClipboard(el) {
  if (el.seClipboard) {
    el.seClipboard.destroy();
    el.seClipboard = null;
  }
};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('clipboard', {
  bind: function bind(el, _ref5) {
    var value = _ref5.value;

    createClipboard(el, value);
  },
  update: function update(el, _ref6) {
    var value = _ref6.value,
        oldValue = _ref6.oldValue;

    if (value !== oldValue) {
      destroyClipboard(el);
      createClipboard(el, value);
    }
  },
  unbind: function unbind(el) {
    destroyClipboard(el);
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('formatTime', function (time) {
  return __WEBPACK_IMPORTED_MODULE_2__services_timeSvc__["a" /* default */].format(time, __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.timeCounter);
});

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  return {
    showNavigationBar: true,
    showEditor: true,
    showSidePreview: true,
    showStatusBar: true,
    showSideBar: false,
    showExplorer: false,
    scrollSync: true,
    focusMode: false,
    findCaseSensitive: false,
    findUseRegexp: false,
    sideBarPanel: 'menu',
    welcomeTourFinished: false
  };
});

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  return {
    welcomeFileHashes: {},
    filePropertiesTab: '',
    htmlExportTemplate: 'styledHtml',
    pdfExportTemplate: 'styledHtml',
    pandocExportFormat: 'pdf',
    googleDriveRestrictedAccess: false,
    googleDriveFolderId: '',
    googleDriveWorkspaceFolderId: '',
    googleDrivePublishFormat: 'markdown',
    googleDrivePublishTemplate: 'styledHtml',
    bloggerBlogUrl: '',
    bloggerPublishTemplate: 'plainHtml',
    dropboxRestrictedAccess: false,
    dropboxPublishTemplate: 'styledHtml',
    githubRepoFullAccess: false,
    githubRepoUrl: '',
    githubWorkspaceRepoUrl: '',
    githubPublishTemplate: 'jekyllSite',
    gistIsPublic: false,
    gistPublishTemplate: 'plainText',
    gitlabServerUrl: '',
    gitlabApplicationId: '',
    gitlabProjectUrl: '',
    gitlabWorkspaceProjectUrl: '',
    gitlabPublishTemplate: 'plainText',
    wordpressDomain: '',
    wordpressPublishTemplate: 'plainHtml',
    zendeskSiteUrl: '',
    zendeskClientId: '',
    zendescPublishSectionId: '',
    zendescPublishLocale: '',
    zendeskPublishTemplate: 'plainHtml'
  };
});

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  return {
    main: {
      id: 'main',
      name: 'Main workspace'
    }
  };
});

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    id: id,
    type: 'contentState',
    selectionStart: 0,
    selectionEnd: 0,
    scrollPosition: null,
    hash: 0
  };
});

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    id: id,
    type: 'publishLocation',
    providerId: null,
    fileId: null,
    templateId: null,
    hash: 0
  };
});

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    id: id,
    type: 'syncLocation',
    providerId: null,
    fileId: null,
    hash: 0
  };
});

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    id: id,
    type: 'syncedContent',
    historyData: {},
    syncHistory: {},
    v: 0,
    hash: 0
  };
});

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Feature = function () {
  function Feature(id, badgeName, description) {
    var children = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Feature);

    this.id = id;
    this.badgeName = badgeName;
    this.description = description;
    this.children = children;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Feature, [{
    key: 'toBadge',
    value: function toBadge(badgeCreations) {
      var children = this.children ? this.children.map(function (child) {
        return child.toBadge(badgeCreations);
      }) : null;
      return {
        featureId: this.id,
        name: this.badgeName,
        description: this.description,
        children: children,
        isEarned: children ? children.every(function (child) {
          return child.isEarned;
        }) : !!badgeCreations[this.id],
        hasSomeEarned: children && children.some(function (child) {
          return child.isEarned;
        })
      };
    }
  }]);

  return Feature;
}();

/* harmony default export */ __webpack_exports__["a"] = ([new Feature('navigationBar', 'Nav bar expert', 'Master the navigation bar by formatting some Markdown and renaming the current file.', [new Feature('formatButtons', 'Formatter', 'Use the format buttons to change formatting in your Markdown file.'), new Feature('editCurrentFileName', 'Renamer', 'Use the name field in the navigation bar to rename the current file.'), new Feature('toggleExplorer', 'Explorer toggler', 'Use the navigation bar to toggle the explorer.'), new Feature('toggleSideBar', 'Side bar toggler', 'Use the navigation bar to toggle the side bar.')]), new Feature('explorer', 'Explorer', 'Use the file explorer to manage files and folders in your workspace.', [new Feature('createFile', 'File creator', 'Use the file explorer to create a new file in your workspace.'), new Feature('switchFile', 'File switcher', 'Use the file explorer to switch from one file to another in your workspace.'), new Feature('createFolder', 'Folder creator', 'Use the file explorer to create a new folder in your workspace.'), new Feature('moveFile', 'File mover', 'Drag a file in the file explorer to move it in another folder.'), new Feature('moveFolder', 'Folder mover', 'Drag a folder in the file explorer to move it in another folder.'), new Feature('renameFile', 'File renamer', 'Use the file explorer to rename a file in your workspace.'), new Feature('renameFolder', 'Folder renamer', 'Use the file explorer to rename a folder in your workspace.'), new Feature('removeFile', 'File remover', 'Use the file explorer to remove a file in your workspace.'), new Feature('removeFolder', 'Folder remover', 'Use the file explorer to remove a folder in your workspace.')]), new Feature('buttonBar', 'Button bar expert', 'Use the button bar to customize the editor layout and to toggle features.', [new Feature('toggleNavigationBar', 'Navigation bar toggler', 'Use the button bar to toggle the navigation bar.'), new Feature('toggleSidePreview', 'Side preview toggler', 'Use the button bar to toggle the side preview.'), new Feature('toggleEditor', 'Editor toggler', 'Use the button bar to toggle the editor.'), new Feature('toggleFocusMode', 'Focused', 'Use the button bar to toggle the focus mode. This mode keeps the caret vertically centered while typing.'), new Feature('toggleScrollSync', 'Scroll sync toggler', 'Use the button bar to toggle the scroll sync feature. This feature links the editor and the preview scrollbars.'), new Feature('toggleStatusBar', 'Status bar toggler', 'Use the button bar to toggle the status bar.')]), new Feature('signIn', 'Signed in', 'Sign in with Google, sync your main workspace and unlock functionalities.', [new Feature('syncMainWorkspace', 'Main workspace synced', 'Sign in with Google to sync your main workspace with your Google Drive app data folder.'), new Feature('sponsor', 'Sponsor', 'Sign in with Google and sponsor StackEdit to unlock PDF and Pandoc exports.')]), new Feature('workspaces', 'Workspace expert', 'Use the workspace menu to create all kinds of workspaces and to manage them.', [new Feature('addCouchdbWorkspace', 'CouchDB workspace creator', 'Use the workspace menu to create a CouchDB workspace.'), new Feature('addGithubWorkspace', 'GitHub workspace creator', 'Use the workspace menu to create a GitHub workspace.'), new Feature('addGitlabWorkspace', 'GitLab workspace creator', 'Use the workspace menu to create a GitLab workspace.'), new Feature('addGoogleDriveWorkspace', 'Google Drive workspace creator', 'Use the workspace menu to create a Google Drive workspace.'), new Feature('renameWorkspace', 'Workspace renamer', 'Use the "Manage workspaces" dialog to rename a workspace.'), new Feature('removeWorkspace', 'Workspace remover', 'Use the "Manage workspaces" dialog to remove a workspace locally.')]), new Feature('manageAccounts', 'Account manager', 'Link all kinds of external accounts and use the "Accounts" dialog to manage them.', [new Feature('addBloggerAccount', 'Blogger user', 'Link your Blogger account to StackEdit.'), new Feature('addDropboxAccount', 'Dropbox user', 'Link your Dropbox account to StackEdit.'), new Feature('addGitHubAccount', 'GitHub user', 'Link your GitHub account to StackEdit.'), new Feature('addGitLabAccount', 'GitLab user', 'Link your GitLab account to StackEdit.'), new Feature('addGoogleDriveAccount', 'Google Drive user', 'Link your Google Drive account to StackEdit.'), new Feature('addGooglePhotosAccount', 'Google Photos user', 'Link your Google Photos account to StackEdit.'), new Feature('addWordpressAccount', 'WordPress user', 'Link your WordPress account to StackEdit.'), new Feature('addZendeskAccount', 'Zendesk user', 'Link your Zendesk account to StackEdit.'), new Feature('removeAccount', 'Revoker', 'Use the "Accounts" dialog to remove access to an external account.')]), new Feature('syncFiles', 'File synchronizer', 'Master the "Synchronize" menu by opening and saving files with all kinds of external accounts.', [new Feature('openFromDropbox', 'Dropbox reader', 'Use the "Synchronize" menu to open a file from your Dropbox account.'), new Feature('saveOnDropbox', 'Dropbox writer', 'Use the "Synchronize" menu to save a file in your Dropbox account.'), new Feature('openFromGithub', 'GitHub reader', 'Use the "Synchronize" menu to open a file from a GitHub repository.'), new Feature('saveOnGithub', 'GitHub writer', 'Use the "Synchronize" menu to save a file in a GitHub repository.'), new Feature('saveOnGist', 'Gist writer', 'Use the "Synchronize" menu to save a file in a Gist.'), new Feature('openFromGitlab', 'GitLab reader', 'Use the "Synchronize" menu to open a file from a GitLab repository.'), new Feature('saveOnGitlab', 'GitLab writer', 'Use the "Synchronize" menu to save a file in a GitLab repository.'), new Feature('openFromGoogleDrive', 'Google Drive reader', 'Use the "Synchronize" menu to open a file from your Google Drive account.'), new Feature('saveOnGoogleDrive', 'Google Drive writer', 'Use the "Synchronize" menu to save a file in your Google Drive account.'), new Feature('triggerSync', 'Sync trigger', 'Use the "Synchronize" menu or the navigation bar to manually trigger synchronization.'), new Feature('syncMultipleLocations', 'Multi-sync', 'Use the "Synchronize" menu to synchronize a file with multiple external locations.'), new Feature('removeSyncLocation', 'Desynchronizer', 'Use the "File synchronization" dialog to remove a sync location.')]), new Feature('publishFiles', 'File publisher', 'Master the "Publish" menu by publishing files to all kinds of external accounts.', [new Feature('publishToBlogger', 'Blogger publisher', 'Use the "Publish" menu to publish a Blogger article.'), new Feature('publishToBloggerPage', 'Blogger Page publisher', 'Use the "Publish" menu to publish a Blogger page.'), new Feature('publishToDropbox', 'Dropbox publisher', 'Use the "Publish" menu to publish a file to your Dropbox account.'), new Feature('publishToGithub', 'GitHub publisher', 'Use the "Publish" menu to publish a file to a GitHub repository.'), new Feature('publishToGist', 'Gist publisher', 'Use the "Publish" menu to publish a file to a Gist.'), new Feature('publishToGitlab', 'GitLab publisher', 'Use the "Publish" menu to publish a file to a GitLab repository.'), new Feature('publishToGoogleDrive', 'Google Drive publisher', 'Use the "Publish" menu to publish a file to your Google Drive account.'), new Feature('publishToWordPress', 'WordPress publisher', 'Use the "Publish" menu to publish a WordPress article.'), new Feature('publishToZendesk', 'Zendesk publisher', 'Use the "Publish" menu to publish a Zendesk Help Center article.'), new Feature('triggerPublish', 'Publication reviser', 'Use the "Publish" menu or the navigation bar to manually update publications.'), new Feature('publishMultipleLocations', 'Multi-publication', 'Use the "Publish" menu to publish a file to multiple external locations.'), new Feature('removePublishLocation', 'Unpublisher', 'Use the "File publication" dialog to remove a publish location.')]), new Feature('manageHistory', 'Historian', 'Use the "File history" menu to see version history and restore old versions of the current file.', [new Feature('restoreVersion', 'Restorer', 'Use the "File history" menu to restore an old version of the current file.'), new Feature('chooseHistory', 'History chooser', 'Select a different history for a file that is synced with multiple external locations.')]), new Feature('manageProperties', 'Property expert', 'Use the "File properties" dialog to change properties for the current file.', [new Feature('setMetadata', 'Metadata setter', 'Use the "File properties" dialog to set metadata for the current file.'), new Feature('changePreset', 'Preset changer', 'Use the "File properties" dialog to change the Markdown engine preset.'), new Feature('changeExtension', 'Extension expert', 'Use the "File properties" dialog to enable, disable or configure Markdown engine extensions.')]), new Feature('comment', 'Comment expert', 'Start and remove discussions, add and remove comments.', [new Feature('createDiscussion', 'Discussion starter', 'Use the "comment" button to start a new discussion.'), new Feature('addComment', 'Commenter', 'Use the discussion gutter to add a comment to an existing discussion.'), new Feature('removeComment', 'Moderator', 'Use the discussion gutter to remove a comment in a discussion.'), new Feature('removeDiscussion', 'Discussion closer', 'Use the discussion gutter to remove a discussion.')]), new Feature('importExport', 'Import/export', 'Use the "Import/export" menu to import and export files.', [new Feature('importMarkdown', 'Markdown importer', 'Use the "Import/export" menu to import a Markdown file from disk.'), new Feature('exportMarkdown', 'Markdown exporter', 'Use the "Import/export" menu to export a Markdown file to disk.'), new Feature('importHtml', 'HTML importer', 'Use the "Import/export" menu to import an HTML file from disk and convert it to Markdown.'), new Feature('exportHtml', 'HTML exporter', 'Use the "Import/export" menu to export a file to disk as an HTML file using a Handlebars template.'), new Feature('exportPdf', 'PDF exporter', 'Use the "Import/export" menu to export a file to disk as a PDF file.'), new Feature('exportPandoc', 'Pandoc exporter', 'Use the "Import/export" menu to export a file to disk using Pandoc.')]), new Feature('manageSettings', 'Settings expert', 'Use the "Settings" dialog to tweak the application behaviors and change keyboard shortcuts.', [new Feature('changeSettings', 'Tweaker', 'Use the "Settings" dialog to tweak the application behaviors.'), new Feature('changeShortcuts', 'Shortcut editor', 'Use the "Settings" dialog to change keyboard shortcuts.')]), new Feature('manageTemplates', 'Template expert', 'Use the "Templates" dialog to create, remove or modify Handlebars templates.', [new Feature('addTemplate', 'Template creator', 'Use the "Templates" dialog to create a Handlebars template.'), new Feature('removeTemplate', 'Template remover', 'Use the "Templates" dialog to remove a Handlebars template.')])]);

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var simpleModal = function simpleModal(contentHtml, rejectText, resolveText) {
  return {
    contentHtml: typeof contentHtml === 'function' ? contentHtml : function () {
      return contentHtml;
    },
    rejectText: rejectText,
    resolveText: resolveText
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  commentDeletion: simpleModal('<p>You are about to delete a comment. Are you sure?</p>', 'No', 'Yes, delete'),
  discussionDeletion: simpleModal('<p>You are about to delete a discussion. Are you sure?</p>', 'No', 'Yes, delete'),
  fileRestoration: simpleModal('<p>You are about to revert some changes. Are you sure?</p>', 'No', 'Yes, revert'),
  folderDeletion: simpleModal(function (config) {
    return '<p>You are about to delete the folder <b>' + config.item.name + '</b>. Its files will be moved to Trash. Are you sure?</p>';
  }, 'No', 'Yes, delete'),
  pathConflict: simpleModal(function (config) {
    return '<p><b>' + config.item.name + '</b> already exists. Do you want to add a suffix?</p>';
  }, 'No', 'Yes, add suffix'),
  paymentSuccess: simpleModal('<h3>Thank you for your payment!</h3><p>Your sponsorship will be active in a minute.</p>', 'Ok'),
  providerRedirection: simpleModal(function (config) {
    return '<p>You are about to navigate to the <b>' + config.name + '</b> authorization page.</p>';
  }, 'Cancel', 'Ok, go on'),
  removeWorkspace: simpleModal('<p>You are about to remove a workspace locally. Are you sure?</p>', 'No', 'Yes, remove'),
  reset: simpleModal('<p>This will clean all your workspaces locally. Are you sure?</p>', 'No', 'Yes, clean'),
  signInForComment: simpleModal('<p>You have to sign in with Google to start commenting.</p>\n    <div class="modal__info"><b>Note:</b> This will sync your main workspace.</div>', 'Cancel', 'Ok, sign in'),
  signInForSponsorship: simpleModal('<p>You have to sign in with Google to sponsor.</p>\n    <div class="modal__info"><b>Note:</b> This will sync your main workspace.</div>', 'Cancel', 'Ok, sign in'),
  sponsorOnly: simpleModal('<p>This feature is restricted to sponsors as it relies on server resources.</p>', 'Ok, I understand'),
  stripName: simpleModal(function (config) {
    return '<p><b>' + config.item.name + '</b> contains illegal characters. Do you want to strip them?</p>';
  }, 'No', 'Yes, strip'),
  tempFileDeletion: simpleModal(function (config) {
    return '<p>You are about to permanently delete the temporary file <b>' + config.item.name + '</b>. Are you sure?</p>';
  }, 'No', 'Yes, delete'),
  tempFolderDeletion: simpleModal('<p>You are about to permanently delete all the temporary files. Are you sure?</p>', 'No', 'Yes, delete all'),
  trashDeletion: simpleModal('<p>Files in the trash are automatically deleted after 7 days of inactivity.</p>', 'Ok'),
  unauthorizedName: simpleModal(function (config) {
    return '<p><b>' + config.item.name + '</b> is an unauthorized name.</p>';
  }, 'Ok'),
  workspaceGoogleRedirection: simpleModal('<p>StackEdit needs full Google Drive access to open this workspace.</p>', 'Cancel', 'Ok, grant')
});

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_abcjs_src_api_abc_tunebook_svg__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_abcjs_src_api_abc_tunebook_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_abcjs_src_api_abc_tunebook_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_extensionSvc__ = __webpack_require__(103);



var render = function render(elt) {
  var content = elt.textContent;

  var divElt = document.createElement('div');
  divElt.className = 'abc-notation-block';

  elt.parentNode.parentNode.replaceChild(divElt, elt.parentNode);
  __WEBPACK_IMPORTED_MODULE_0_abcjs_src_api_abc_tunebook_svg___default()(divElt, content, {});
};

__WEBPACK_IMPORTED_MODULE_1__services_extensionSvc__["a" /* default */].onGetOptions(function (options, properties) {
  options.abc = properties.extensions.abc.enabled;
});

__WEBPACK_IMPORTED_MODULE_1__services_extensionSvc__["a" /* default */].onSectionPreview(function (elt) {
  elt.querySelectorAll('.prism.language-abc').cl_each(function (notationElt) {
    return render(notationElt);
  });
});

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_markdown_it_emoji__ = __webpack_require__(2130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_markdown_it_emoji___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_markdown_it_emoji__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_extensionSvc__ = __webpack_require__(103);



__WEBPACK_IMPORTED_MODULE_1__services_extensionSvc__["a" /* default */].onGetOptions(function (options, properties) {
  options.emoji = properties.extensions.emoji.enabled;
  options.emojiShortcuts = properties.extensions.emoji.shortcuts;
});

__WEBPACK_IMPORTED_MODULE_1__services_extensionSvc__["a" /* default */].onInitConverter(1, function (markdown, options) {
  if (options.emoji) {
    markdown.use(__WEBPACK_IMPORTED_MODULE_0_markdown_it_emoji___default.a, options.emojiShortcuts ? {} : { shortcuts: {} });
  }
});

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_katex__ = __webpack_require__(2094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_katex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_katex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_markdownItMath__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_extensionSvc__ = __webpack_require__(103);




__WEBPACK_IMPORTED_MODULE_2__services_extensionSvc__["a" /* default */].onGetOptions(function (options, properties) {
  options.math = properties.extensions.katex.enabled;
});

__WEBPACK_IMPORTED_MODULE_2__services_extensionSvc__["a" /* default */].onInitConverter(2, function (markdown, options) {
  if (options.math) {
    markdown.use(__WEBPACK_IMPORTED_MODULE_1__libs_markdownItMath__["a" /* default */]);
    markdown.renderer.rules.inline_math = function (tokens, idx) {
      return '<span class="katex--inline">' + markdown.utils.escapeHtml(tokens[idx].content) + '</span>';
    };
    markdown.renderer.rules.display_math = function (tokens, idx) {
      return '<span class="katex--display">' + markdown.utils.escapeHtml(tokens[idx].content) + '</span>';
    };
  }
});

__WEBPACK_IMPORTED_MODULE_2__services_extensionSvc__["a" /* default */].onSectionPreview(function (elt) {
  var highlighter = function highlighter(displayMode) {
    return function (katexElt) {
      if (!katexElt.highlighted) {
        try {
          __WEBPACK_IMPORTED_MODULE_0_katex___default.a.render(katexElt.textContent, katexElt, { displayMode: displayMode });
        } catch (e) {
          katexElt.textContent = '' + e.message;
        }
      }
      katexElt.highlighted = true;
    };
  };
  elt.querySelectorAll('.katex--inline').cl_each(highlighter(false));
  elt.querySelectorAll('.katex--display').cl_each(highlighter(true));
});

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (md) {
  md.core.ruler.before('replacements', 'anchors', function (state) {
    var anchorHash = {};
    var headingOpenToken = void 0;
    var headingContent = void 0;
    state.tokens.forEach(function (token) {
      if (token.type === 'heading_open') {
        headingContent = '';
        headingOpenToken = token;
      } else if (token.type === 'heading_close') {
        headingOpenToken.headingContent = headingContent;

        var slug = headingContent.replace(/\s/g, '-').replace(/[\0-,/:-@[-^`{-~]/g, '').toLowerCase();
        var i = void 0;
        for (i = 0; i < slug.length; i += 1) {
          var charCode = slug.charCodeAt(i);
          if (charCode >= 0x61 && charCode <= 0x7A || charCode > 0x7E) {
            break;
          }
        }

        slug = slug.slice(i) || 'section';

        var anchor = slug;
        var index = 1;
        while (Object.prototype.hasOwnProperty.call(anchorHash, anchor)) {
          anchor = slug + '-' + index;
          index += 1;
        }
        anchorHash[anchor] = true;
        headingOpenToken.headingAnchor = anchor;
        headingOpenToken.attrs = [['id', anchor]];
        headingOpenToken = undefined;
      } else if (headingOpenToken) {
        headingContent += token.children.reduce(function (result, child) {
          if (child.type !== 'footnote_ref') {
            return result + child.content;
          }
          return result;
        }, '');
      }
    });
  });
});

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function texMath(state, silent) {
  var startMathPos = state.pos;
  if (state.src.charCodeAt(startMathPos) !== 0x24) {
      return false;
    }

  var endMarker = '$';
  startMathPos += 1;
  var afterStartMarker = state.src.charCodeAt(startMathPos);
  if (afterStartMarker === 0x24) {
      endMarker = '$$';
      startMathPos += 1;
      if (state.src.charCodeAt(startMathPos) === 0x24) {
          return false;
        }
    } else if (afterStartMarker === 0x20 || afterStartMarker === 0x09 || afterStartMarker === 0x0a) {
      return false;
    }
  var endMarkerPos = state.src.indexOf(endMarker, startMathPos);
  if (endMarkerPos === -1) {
    return false;
  }
  if (state.src.charCodeAt(endMarkerPos - 1) === 0x5C) {
      return false;
    }
  var nextPos = endMarkerPos + endMarker.length;
  if (endMarker.length === 1) {
    var beforeEndMarker = state.src.charCodeAt(endMarkerPos - 1);
    if (beforeEndMarker === 0x20 || beforeEndMarker === 0x09 || beforeEndMarker === 0x0a) {
        return false;
      }

    var suffix = state.src.charCodeAt(nextPos);
    if (suffix >= 0x30 && suffix < 0x3A) {
      return false;
    }
  }

  if (!silent) {
    var token = state.push(endMarker.length === 1 ? 'inline_math' : 'display_math', '', 0);
    token.content = state.src.slice(startMathPos, endMarkerPos);
  }
  state.pos = nextPos;
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (function (md) {
  md.inline.ruler.push('texMath', texMath);
});

/***/ }),
/* 985 */
/***/ (function(module, exports) {

function attrSet(token, name, value) {
  var index = token.attrIndex(name);
  var attr = [name, value];

  if (index < 0) {
    token.attrPush(attr);
  } else {
    token.attrs[index] = attr;
  }
}

module.exports = function (md) {
  md.core.ruler.after('inline', 'tasklist', function (_ref) {
    var tokens = _ref.tokens,
        Token = _ref.Token;

    for (var i = 2; i < tokens.length; i += 1) {
      var token = tokens[i];
      if (token.content && token.content.charCodeAt(0) === 0x5b && token.content.charCodeAt(2) === 0x5d && token.content.charCodeAt(3) === 0x20 && token.type === 'inline' && tokens[i - 1].type === 'paragraph_open' && tokens[i - 2].type === 'list_item_open') {
        var cross = token.content[1].toLowerCase();
        if (cross === ' ' || cross === 'x') {
          var checkbox = new Token('html_inline', '', 0);
          if (cross === ' ') {
            checkbox.content = '<span class="task-list-item-checkbox" type="checkbox">&#9744;</span>';
          } else {
            checkbox.content = '<span class="task-list-item-checkbox checked" type="checkbox">&#9745;</span>';
          }
          token.children.unshift(checkbox);
          token.children[1].content = token.children[1].content.slice(3);
          token.content = token.content.slice(3);
          attrSet(tokens[i - 2], 'class', 'task-list-item');
        }
      }
    }
  });
};

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prismjs__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prismjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_markdown_it_abbr__ = __webpack_require__(2128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_markdown_it_abbr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_markdown_it_abbr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_markdown_it_deflist__ = __webpack_require__(2129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_markdown_it_deflist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_markdown_it_deflist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_markdown_it_footnote__ = __webpack_require__(2136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_markdown_it_footnote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_markdown_it_footnote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_markdown_it_mark__ = __webpack_require__(2142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_markdown_it_mark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_markdown_it_mark__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_markdown_it_imsize__ = __webpack_require__(2141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_markdown_it_imsize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_markdown_it_imsize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_markdown_it_sub__ = __webpack_require__(2144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_markdown_it_sub___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_markdown_it_sub__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_markdown_it_sup__ = __webpack_require__(2145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_markdown_it_sup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_markdown_it_sup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_markdownItTasklist__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_markdownItTasklist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__libs_markdownItTasklist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__libs_markdownItAnchor__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_extensionSvc__ = __webpack_require__(103);













var coreBaseRules = ['normalize', 'block', 'inline', 'linkify', 'replacements', 'smartquotes'];
var blockBaseRules = ['code', 'fence', 'blockquote', 'hr', 'list', 'reference', 'heading', 'lheading', 'html_block', 'table', 'paragraph'];
var inlineBaseRules = ['text', 'newline', 'escape', 'backticks', 'strikethrough', 'emphasis', 'link', 'image', 'autolink', 'html_inline', 'entity'];
var inlineBaseRules2 = ['balance_pairs', 'strikethrough', 'emphasis', 'text_collapse'];

__WEBPACK_IMPORTED_MODULE_11__services_extensionSvc__["a" /* default */].onGetOptions(function (options, properties) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(options, properties.extensions.markdown);
});

__WEBPACK_IMPORTED_MODULE_11__services_extensionSvc__["a" /* default */].onInitConverter(0, function (markdown, options) {
  markdown.set({
    html: true,
    breaks: !!options.breaks,
    linkify: !!options.linkify,
    typographer: !!options.typographer,
    langPrefix: 'prism language-'
  });

  markdown.core.ruler.enable(coreBaseRules);

  var blockRules = blockBaseRules.slice();
  if (!options.fence) {
    blockRules.splice(blockRules.indexOf('fence'), 1);
  }
  if (!options.table) {
    blockRules.splice(blockRules.indexOf('table'), 1);
  }
  markdown.block.ruler.enable(blockRules);

  var inlineRules = inlineBaseRules.slice();
  var inlineRules2 = inlineBaseRules2.slice();
  if (!options.del) {
    inlineRules.splice(blockRules.indexOf('strikethrough'), 1);
    inlineRules2.splice(blockRules.indexOf('strikethrough'), 1);
  }
  markdown.inline.ruler.enable(inlineRules);
  markdown.inline.ruler2.enable(inlineRules2);

  if (options.abbr) {
    markdown.use(__WEBPACK_IMPORTED_MODULE_2_markdown_it_abbr___default.a);
  }
  if (options.deflist) {
    markdown.use(__WEBPACK_IMPORTED_MODULE_3_markdown_it_deflist___default.a);
  }
  if (options.footnote) {
    markdown.use(__WEBPACK_IMPORTED_MODULE_4_markdown_it_footnote___default.a);
  }
  if (options.imgsize) {
    markdown.use(__WEBPACK_IMPORTED_MODULE_6_markdown_it_imsize___default.a);
  }
  if (options.mark) {
    markdown.use(__WEBPACK_IMPORTED_MODULE_5_markdown_it_mark___default.a);
  }
  if (options.sub) {
    markdown.use(__WEBPACK_IMPORTED_MODULE_7_markdown_it_sub___default.a);
  }
  if (options.sup) {
    markdown.use(__WEBPACK_IMPORTED_MODULE_8_markdown_it_sup___default.a);
  }
  if (options.tasklist) {
    markdown.use(__WEBPACK_IMPORTED_MODULE_9__libs_markdownItTasklist___default.a);
  }
  markdown.use(__WEBPACK_IMPORTED_MODULE_10__libs_markdownItAnchor__["a" /* default */]);

  markdown.renderer.rules.table_open = function (tokens, idx, opts) {
    return '<div class="table-wrapper">' + markdown.renderer.renderToken(tokens, idx, opts);
  };
  markdown.renderer.rules.table_close = function (tokens, idx, opts) {
    return markdown.renderer.renderToken(tokens, idx, opts) + '</div>';
  };

  var textAlignLength = 'text-align:'.length;
  markdown.renderer.rules.td_open = function (tokens, idx, opts) {
    var token = tokens[idx];
    if (token.attrs && token.attrs.length && token.attrs[0][0] === 'style') {
      token.attrs = [['align', token.attrs[0][1].slice(textAlignLength)]];
    }
    return markdown.renderer.renderToken(tokens, idx, opts);
  };
  markdown.renderer.rules.th_open = markdown.renderer.rules.td_open;

  markdown.renderer.rules.footnote_ref = function (tokens, idx) {
    var n = '' + Number(tokens[idx].meta.id + 1);
    var id = 'fnref' + n;
    if (tokens[idx].meta.subId > 0) {
      id += ':' + tokens[idx].meta.subId;
    }
    return '<sup class="footnote-ref"><a href="#fn' + n + '" id="' + id + '">' + n + '</a></sup>';
  };
});

__WEBPACK_IMPORTED_MODULE_11__services_extensionSvc__["a" /* default */].onSectionPreview(function (elt, options, isEditor) {
  elt.querySelectorAll('.prism').cl_each(function (prismElt) {
    if (!prismElt.$highlightedWithPrism) {
      __WEBPACK_IMPORTED_MODULE_1_prismjs___default.a.highlightElement(prismElt);
      prismElt.$highlightedWithPrism = true;
    }
  });

  elt.querySelectorAll('span.task-list-item-checkbox').cl_each(function (spanElt) {
    var checkboxElt = document.createElement('input');
    checkboxElt.type = 'checkbox';
    checkboxElt.className = 'task-list-item-checkbox';
    if (spanElt.classList.contains('checked')) {
      checkboxElt.setAttribute('checked', true);
    }
    if (!isEditor) {
      checkboxElt.disabled = 'disabled';
    }
    spanElt.parentNode.replaceChild(checkboxElt, spanElt);
  });
});

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mermaid__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_extensionSvc__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_utils__ = __webpack_require__(4);




var config = {
  logLevel: 5,
  startOnLoad: false,
  arrowMarkerAbsolute: false,
  theme: 'neutral',
  flowchart: {
    htmlLabels: true,
    curve: 'linear'
  },
  sequence: {
    diagramMarginX: 50,
    diagramMarginY: 10,
    actorMargin: 50,
    width: 150,
    height: 65,
    boxMargin: 10,
    boxTextMargin: 5,
    noteMargin: 10,
    messageMargin: 35,
    mirrorActors: true,
    bottomMarginAdj: 1,
    useMaxWidth: true
  },
  gantt: {
    titleTopMargin: 25,
    barHeight: 20,
    barGap: 4,
    topPadding: 50,
    leftPadding: 75,
    gridLineStartPadding: 35,
    fontSize: 11,
    fontFamily: '"Open-Sans", "sans-serif"',
    numberSectionStyles: 4,
    axisFormat: '%Y-%m-%d'
  }
};

var containerElt = document.createElement('div');
containerElt.className = 'hidden-rendering-container';
document.body.appendChild(containerElt);

var _init = function init() {
  window.mermaid.initialize(config);
  _init = function init() {};
};

var render = function render(elt) {
  try {
    _init();
    var svgId = 'mermaid-svg-' + __WEBPACK_IMPORTED_MODULE_2__services_utils__["a" /* default */].uid();
    window.mermaid.mermaidAPI.render(svgId, elt.textContent, function () {
      while (elt.firstChild) {
        elt.removeChild(elt.lastChild);
      }
      elt.appendChild(containerElt.querySelector('#' + svgId));
    }, containerElt);
  } catch (e) {
    console.error(e);
  }
};

__WEBPACK_IMPORTED_MODULE_1__services_extensionSvc__["a" /* default */].onGetOptions(function (options, properties) {
  options.mermaid = properties.extensions.mermaid.enabled;
});

__WEBPACK_IMPORTED_MODULE_1__services_extensionSvc__["a" /* default */].onSectionPreview(function (elt) {
  elt.querySelectorAll('.prism.language-mermaid').cl_each(function (diagramElt) {
    return render(diagramElt.parentNode);
  });
});

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_polyfill__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_indexeddbshim_dist_indexeddbshim__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_indexeddbshim_dist_indexeddbshim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_indexeddbshim_dist_indexeddbshim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_offline_plugin_runtime__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_offline_plugin_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_offline_plugin_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__extensions__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_optional__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__icons__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_App__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_localDbSvc__ = __webpack_require__(151);



var _this = this;












if (!indexedDB) {
  throw new Error('Your browser is not supported. Please upgrade to the latest version.');
}

__WEBPACK_IMPORTED_MODULE_5_offline_plugin_runtime__["install"]({
  onUpdateReady: function onUpdateReady() {
    __WEBPACK_IMPORTED_MODULE_5_offline_plugin_runtime__["applyUpdate"]();
  },
  onUpdated: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.light) {
                _context.next = 5;
                break;
              }

              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_11__services_localDbSvc__["a" /* default */].sync();

            case 3:
              localStorage.updated = true;

              window.location.reload();

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function onUpdated() {
      return _ref.apply(this, arguments);
    };
  }()
});

if (localStorage.updated) {
  __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].dispatch('notification/info', 'StackEdit has just updated itself!');
  setTimeout(function () {
    return localStorage.removeItem('updated');
  }, 2000);
}

if (!localStorage.installPrompted) {
  window.addEventListener('beforeinstallprompt', function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(promptEvent) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              promptEvent.preventDefault();

              _context2.prev = 1;
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].dispatch('notification/confirm', 'Add StackEdit to your home screen?');

            case 4:
              promptEvent.prompt();
              _context2.next = 7;
              return promptEvent.userChoice;

            case 7:
              _context2.next = 11;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2['catch'](1);

            case 11:
              localStorage.installPrompted = true;

            case 12:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[1, 9]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());
}

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_9__components_App__["a" /* default */]);
  }
});

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {},
    re = window.RegExp,
    SETTINGS = {
  lineLength: 72
};

var defaultsStrings = {
  bold: "Strong <strong> Ctrl/Cmd+B",
  boldexample: "strong text",

  italic: "Emphasis <em> Ctrl/Cmd+I",
  italicexample: "emphasized text",

  strikethrough: "Strikethrough <s> Ctrl/Cmd+I",
  strikethroughexample: "strikethrough text",

  link: "Hyperlink <a> Ctrl/Cmd+L",
  linkdescription: "enter link description here",
  linkdialog: "<p><b>Insert Hyperlink</b></p><p>http://example.com/ \"optional title\"</p>",

  quote: "Blockquote <blockquote> Ctrl/Cmd+Q",
  quoteexample: "Blockquote",

  code: "Code Sample <pre><code> Ctrl/Cmd+K",
  codeexample: "enter code here",

  image: "Image <img> Ctrl/Cmd+G",
  imagedescription: "enter image description here",
  imagedialog: "<p><b>Insert Image</b></p><p>http://example.com/images/diagram.jpg \"optional title\"<br><br>Need <a href='http://www.google.com/search?q=free+image+hosting' target='_blank'>free image hosting?</a></p>",

  olist: "Numbered List <ol> Ctrl/Cmd+O",
  ulist: "Bulleted List <ul> Ctrl/Cmd+U",
  litem: "List item",

  heading: "Heading <h1>/<h2> Ctrl/Cmd+H",
  headingexample: "Heading",

  hr: "Horizontal Rule <hr> Ctrl/Cmd+R",

  undo: "Undo - Ctrl/Cmd+Z",
  redo: "Redo - Ctrl/Cmd+Y",

  help: "Markdown Editing Help"
};

function Pagedown(options) {

  options = options || {};

  if (typeof options.handler === "function") {
    options = {
      helpButton: options
    };
  }
  options.strings = options.strings || {};
  var getString = function getString(identifier) {
    return options.strings[identifier] || defaultsStrings[identifier];
  };

  function identity(x) {
    return x;
  }

  function returnFalse() {
    return false;
  }

  function HookCollection() {}
  HookCollection.prototype = {

    chain: function chain(hookname, func) {
      var original = this[hookname];
      if (!original) {
        throw new Error("unknown hook " + hookname);
      }

      if (original === identity) {
        this[hookname] = func;
      } else {
        this[hookname] = function () {
          var args = Array.prototype.slice.call(arguments, 0);
          args[0] = original.apply(null, args);
          return func.apply(null, args);
        };
      }
    },
    set: function set(hookname, func) {
      if (!this[hookname]) {
        throw new Error("unknown hook " + hookname);
      }
      this[hookname] = func;
    },
    addNoop: function addNoop(hookname) {
      this[hookname] = identity;
    },
    addFalse: function addFalse(hookname) {
      this[hookname] = returnFalse;
    }
  };

  var hooks = this.hooks = new HookCollection();
  hooks.addNoop("onPreviewRefresh");
  hooks.addNoop("postBlockquoteCreation");
  hooks.addFalse("insertImageDialog");

  hooks.addFalse("insertLinkDialog");

  var that = this,
      input;

  this.run = function () {
    if (input) return;

    input = options.input;
    var commandManager = new CommandManager(hooks, getString);
    var uiManager;

    uiManager = new UIManager(input, commandManager);

    that.uiManager = uiManager;
  };
}

function Chunks() {}

Chunks.prototype.findTags = function (startRegex, endRegex) {

  var chunkObj = this;
  var regex;

  if (startRegex) {

    regex = util.extendRegExp(startRegex, "", "$");

    this.before = this.before.replace(regex, function (match) {
      chunkObj.startTag = chunkObj.startTag + match;
      return "";
    });

    regex = util.extendRegExp(startRegex, "^", "");

    this.selection = this.selection.replace(regex, function (match) {
      chunkObj.startTag = chunkObj.startTag + match;
      return "";
    });
  }

  if (endRegex) {

    regex = util.extendRegExp(endRegex, "", "$");

    this.selection = this.selection.replace(regex, function (match) {
      chunkObj.endTag = match + chunkObj.endTag;
      return "";
    });

    regex = util.extendRegExp(endRegex, "^", "");

    this.after = this.after.replace(regex, function (match) {
      chunkObj.endTag = match + chunkObj.endTag;
      return "";
    });
  }
};

Chunks.prototype.trimWhitespace = function (remove) {
  var beforeReplacer,
      afterReplacer,
      that = this;
  if (remove) {
    beforeReplacer = afterReplacer = "";
  } else {
    beforeReplacer = function beforeReplacer(s) {
      that.before += s;
      return "";
    };
    afterReplacer = function afterReplacer(s) {
      that.after = s + that.after;
      return "";
    };
  }

  this.selection = this.selection.replace(/^(\s*)/, beforeReplacer).replace(/(\s*)$/, afterReplacer);
};

Chunks.prototype.skipLines = function (nLinesBefore, nLinesAfter, findExtraNewlines) {

  if (nLinesBefore === undefined) {
    nLinesBefore = 1;
  }

  if (nLinesAfter === undefined) {
    nLinesAfter = 1;
  }

  nLinesBefore++;
  nLinesAfter++;

  var regexText;
  var replacementText;

  if (navigator.userAgent.match(/Chrome/)) {
    "X".match(/()./);
  }

  this.selection = this.selection.replace(/(^\n*)/, "");

  this.startTag = this.startTag + re.$1;

  this.selection = this.selection.replace(/(\n*$)/, "");
  this.endTag = this.endTag + re.$1;
  this.startTag = this.startTag.replace(/(^\n*)/, "");
  this.before = this.before + re.$1;
  this.endTag = this.endTag.replace(/(\n*$)/, "");
  this.after = this.after + re.$1;

  if (this.before) {

    regexText = replacementText = "";

    while (nLinesBefore--) {
      regexText += "\\n?";
      replacementText += "\n";
    }

    if (findExtraNewlines) {
      regexText = "\\n*";
    }
    this.before = this.before.replace(new re(regexText + "$", ""), replacementText);
  }

  if (this.after) {

    regexText = replacementText = "";

    while (nLinesAfter--) {
      regexText += "\\n?";
      replacementText += "\n";
    }
    if (findExtraNewlines) {
      regexText = "\\n*";
    }

    this.after = this.after.replace(new re(regexText, ""), replacementText);
  }
};

util.fixEolChars = function (text) {
  text = text.replace(/\r\n/g, "\n");
  text = text.replace(/\r/g, "\n");
  return text;
};

util.extendRegExp = function (regex, pre, post) {

  if (pre === null || pre === undefined) {
    pre = "";
  }
  if (post === null || post === undefined) {
    post = "";
  }

  var pattern = regex.toString();
  var flags;

  pattern = pattern.replace(/\/([gim]*)$/, function (wholeMatch, flagsPart) {
    flags = flagsPart;
    return "";
  });

  pattern = pattern.replace(/(^\/|\/$)/g, "");
  pattern = pre + pattern + post;

  return new re(pattern, flags);
};

function TextareaState(input) {
  var stateObj = this;
  var inputArea = input;
  this.init = function () {
    this.setInputAreaSelectionStartEnd();
    this.text = inputArea.getContent();
  };

  this.setInputAreaSelection = function () {
    inputArea.focus();
    inputArea.setSelection(stateObj.start, stateObj.end);
  };

  this.setInputAreaSelectionStartEnd = function () {
    stateObj.start = Math.min(inputArea.selectionMgr.selectionStart, inputArea.selectionMgr.selectionEnd);
    stateObj.end = Math.max(inputArea.selectionMgr.selectionStart, inputArea.selectionMgr.selectionEnd);
  };

  this.restore = function () {

    if (stateObj.text !== undefined && stateObj.text != inputArea.getContent()) {
      inputArea.setContent(stateObj.text);
    }
    this.setInputAreaSelection();
  };

  this.getChunks = function () {

    var chunk = new Chunks();
    chunk.before = util.fixEolChars(stateObj.text.substring(0, stateObj.start));
    chunk.startTag = "";
    chunk.selection = util.fixEolChars(stateObj.text.substring(stateObj.start, stateObj.end));
    chunk.endTag = "";
    chunk.after = util.fixEolChars(stateObj.text.substring(stateObj.end));

    return chunk;
  };

  this.setChunks = function (chunk) {

    chunk.before = chunk.before + chunk.startTag;
    chunk.after = chunk.endTag + chunk.after;

    this.start = chunk.before.length;
    this.end = chunk.before.length + chunk.selection.length;
    this.text = chunk.before + chunk.selection + chunk.after;
  };
  this.init();
}

function UIManager(input, commandManager) {

  var inputBox = input,
      buttons = {};

  makeSpritedButtonRow();

  function doClick(buttonName) {
    var button = buttons[buttonName];
    if (!button) {
      return;
    }

    inputBox.focus();
    var linkOrImage = button === buttons.link || button.id === buttons.image;

    var state = new TextareaState(input);

    if (!state) {
      return;
    }

    var chunks = state.getChunks();

    var fixupInputArea = function fixupInputArea() {

      inputBox.focus();

      if (chunks) {
        state.setChunks(chunks);
      }

      state.restore();
    };

    var noCleanup = button(chunks, fixupInputArea);

    if (!noCleanup) {
      fixupInputArea();
      if (!linkOrImage) {
        inputBox.adjustCursorPosition();
      }
    }
  }

  function bindCommand(method) {
    if (typeof method === "string") method = commandManager[method];
    return function () {
      method.apply(commandManager, arguments);
    };
  }

  function makeSpritedButtonRow() {

    buttons.bold = bindCommand("doBold");
    buttons.italic = bindCommand("doItalic");
    buttons.strikethrough = bindCommand("doStrikethrough");
    buttons.link = bindCommand(function (chunk, postProcessing) {
      return this.doLinkOrImage(chunk, postProcessing, false);
    });
    buttons.quote = bindCommand("doBlockquote");
    buttons.code = bindCommand("doCode");
    buttons.image = bindCommand(function (chunk, postProcessing) {
      return this.doLinkOrImage(chunk, postProcessing, true);
    });
    buttons.olist = bindCommand(function (chunk, postProcessing) {
      this.doList(chunk, postProcessing, true);
    });
    buttons.ulist = bindCommand(function (chunk, postProcessing) {
      this.doList(chunk, postProcessing, false);
    });
    buttons.clist = bindCommand(function (chunk, postProcessing) {
      this.doList(chunk, postProcessing, false, true);
    });
    buttons.heading = bindCommand("doHeading");
    buttons.hr = bindCommand("doHorizontalRule");
    buttons.table = bindCommand("doTable");
  }

  this.doClick = doClick;
}

function CommandManager(pluginHooks, getString) {
  this.hooks = pluginHooks;
  this.getString = getString;
}

var commandProto = CommandManager.prototype;

commandProto.prefixes = "(?:\\s{4,}|\\s*>|\\s*-\\s+|\\s*\\d+\\.|=|\\+|-|_|\\*|#|\\s*\\[[^\n]]+\\]:)";

commandProto.unwrap = function (chunk) {
  var txt = new re("([^\\n])\\n(?!(\\n|" + this.prefixes + "))", "g");
  chunk.selection = chunk.selection.replace(txt, "$1 $2");
};

commandProto.wrap = function (chunk, len) {
  this.unwrap(chunk);
  var regex = new re("(.{1," + len + "})( +|$\\n?)", "gm"),
      that = this;

  chunk.selection = chunk.selection.replace(regex, function (line, marked) {
    if (new re("^" + that.prefixes, "").test(line)) {
      return line;
    }
    return marked + "\n";
  });

  chunk.selection = chunk.selection.replace(/\s+$/, "");
};

commandProto.doBold = function (chunk, postProcessing) {
  return this.doBorI(chunk, postProcessing, 2, this.getString("boldexample"));
};

commandProto.doItalic = function (chunk, postProcessing) {
  return this.doBorI(chunk, postProcessing, 1, this.getString("italicexample"));
};

commandProto.doBorI = function (chunk, postProcessing, nStars, insertText) {
  chunk.trimWhitespace();
  chunk.selection = chunk.selection.replace(/\n{2,}/g, "\n");

  var starsBefore = /(\**$)/.exec(chunk.before)[0];
  var starsAfter = /(^\**)/.exec(chunk.after)[0];

  var prevStars = Math.min(starsBefore.length, starsAfter.length);

  if (prevStars >= nStars && (prevStars != 2 || nStars != 1)) {
    chunk.before = chunk.before.replace(re("[*]{" + nStars + "}$", ""), "");
    chunk.after = chunk.after.replace(re("^[*]{" + nStars + "}", ""), "");
  } else if (!chunk.selection && starsAfter) {
    chunk.after = chunk.after.replace(/^([*_]*)/, "");
    chunk.before = chunk.before.replace(/(\s?)$/, "");
    var whitespace = re.$1;
    chunk.before = chunk.before + starsAfter + whitespace;
  } else {
    if (!chunk.selection && !starsAfter) {
      chunk.selection = insertText;
    }

    var markup = nStars <= 1 ? "*" : "**";
    chunk.before = chunk.before + markup;
    chunk.after = markup + chunk.after;
  }

  return;
};

commandProto.doStrikethrough = function (chunk, postProcessing) {
  chunk.trimWhitespace();
  chunk.selection = chunk.selection.replace(/\n{2,}/g, "\n");

  var starsBefore = /(~*$)/.exec(chunk.before)[0];
  var starsAfter = /(^~*)/.exec(chunk.after)[0];

  var prevStars = Math.min(starsBefore.length, starsAfter.length);

  var nStars = 2;

  if (prevStars >= nStars && (prevStars != 2 || nStars != 1)) {
    chunk.before = chunk.before.replace(re("[~]{" + nStars + "}$", ""), "");
    chunk.after = chunk.after.replace(re("^[~]{" + nStars + "}", ""), "");
  } else if (!chunk.selection && starsAfter) {
    chunk.after = chunk.after.replace(/^(~*)/, "");
    chunk.before = chunk.before.replace(/(\s?)$/, "");
    var whitespace = re.$1;
    chunk.before = chunk.before + starsAfter + whitespace;
  } else {
    if (!chunk.selection && !starsAfter) {
      chunk.selection = this.getString("strikethroughexample");
    }

    var markup = "~~";
    chunk.before = chunk.before + markup;
    chunk.after = markup + chunk.after;
  }

  return;
};

commandProto.stripLinkDefs = function (text, defsToAdd) {

  text = text.replace(/^[ ]{0,3}\[(\d+)\]:[ \t]*\n?[ \t]*<?(\S+?)>?[ \t]*\n?[ \t]*(?:(\n*)["(](.+?)[")][ \t]*)?(?:\n+|$)/gm, function (totalMatch, id, link, newlines, title) {
    defsToAdd[id] = totalMatch.replace(/\s*$/, "");
    if (newlines) {
      defsToAdd[id] = totalMatch.replace(/["(](.+?)[")]$/, "");
      return newlines + title;
    }
    return "";
  });

  return text;
};

commandProto.addLinkDef = function (chunk, linkDef) {

  var refNumber = 0;
  var defsToAdd = {};
  chunk.before = this.stripLinkDefs(chunk.before, defsToAdd);
  chunk.selection = this.stripLinkDefs(chunk.selection, defsToAdd);
  chunk.after = this.stripLinkDefs(chunk.after, defsToAdd);

  var defs = "";
  var regex = /(\[)((?:\[[^\]]*\]|[^\[\]])*)(\][ ]?(?:\n[ ]*)?\[)(\d+)(\])/g;

  var addDefNumber = function addDefNumber(def) {
    refNumber++;
    def = def.replace(/^[ ]{0,3}\[(\d+)\]:/, "  [" + refNumber + "]:");
    defs += "\n" + def;
  };

  var getLink = function getLink(wholeMatch, before, inner, afterInner, id, end) {
    inner = inner.replace(regex, getLink);
    if (defsToAdd[id]) {
      addDefNumber(defsToAdd[id]);
      return before + inner + afterInner + refNumber + end;
    }
    return wholeMatch;
  };

  chunk.before = chunk.before.replace(regex, getLink);

  if (linkDef) {
    addDefNumber(linkDef);
  } else {
    chunk.selection = chunk.selection.replace(regex, getLink);
  }

  var refOut = refNumber;

  chunk.after = chunk.after.replace(regex, getLink);

  if (chunk.after) {
    chunk.after = chunk.after.replace(/\n*$/, "");
  }
  if (!chunk.after) {
    chunk.selection = chunk.selection.replace(/\n*$/, "");
  }

  chunk.after += "\n\n" + defs;

  return refOut;
};

function properlyEncoded(linkdef) {
  return linkdef.replace(/^\s*(.*?)(?:\s+"(.+)")?\s*$/, function (wholematch, link, title) {
    link = link.replace(/\?.*$/, function (querypart) {
      return querypart.replace(/\+/g, " ");
    });
    link = decodeURIComponent(link);
    link = encodeURI(link).replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29');
    link = link.replace(/\?.*$/, function (querypart) {
      return querypart.replace(/\+/g, "%2b");
    });
    if (title) {
      title = title.trim ? title.trim() : title.replace(/^\s*/, "").replace(/\s*$/, "");
      title = title.replace(/"/g, "quot;").replace(/\(/g, "&#40;").replace(/\)/g, "&#41;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    return title ? link + ' "' + title + '"' : link;
  });
}

commandProto.doLinkOrImage = function (chunk, postProcessing, isImage) {

  chunk.trimWhitespace();

  chunk.findTags(/\s*!?\[/, /\][ ]?(?:\n[ ]*)?(\(.*?\))?/);

  if (chunk.endTag.length > 1 && chunk.startTag.length > 0) {

    chunk.startTag = chunk.startTag.replace(/!?\[/, "");
    chunk.endTag = "";
    this.addLinkDef(chunk, null);
  } else {
    chunk.selection = chunk.startTag + chunk.selection + chunk.endTag;
    chunk.startTag = chunk.endTag = "";

    if (/\n\n/.test(chunk.selection)) {
      this.addLinkDef(chunk, null);
      return;
    }
    var that = this;

    var linkEnteredCallback = function linkEnteredCallback(link) {

      if (link !== null) {
        chunk.selection = (" " + chunk.selection).replace(/([^\\](?:\\\\)*)(?=[[\]])/g, "$1\\").substr(1);

        chunk.startTag = isImage ? "![" : "[";

        chunk.endTag = "](" + properlyEncoded(link) + ")";

        if (!chunk.selection) {
          if (isImage) {
            chunk.selection = that.getString("imagedescription");
          } else {
            chunk.selection = that.getString("linkdescription");
          }
        }
      }
      postProcessing();
    };

    if (isImage) {
      this.hooks.insertImageDialog(linkEnteredCallback);
    } else {
      this.hooks.insertLinkDialog(linkEnteredCallback);
    }
    return true;
  }
};

commandProto.doAutoindent = function (chunk) {

  var commandMgr = this,
      fakeSelection = false;

  chunk.before = chunk.before.replace(/(\n|^)[ ]{0,3}([*+-]|\d+[.])[ \t]*\n$/, "\n\n");
  chunk.before = chunk.before.replace(/(\n|^)[ ]{0,3}>[ \t]*\n$/, "\n\n");
  chunk.before = chunk.before.replace(/(\n|^)[ \t]+\n$/, "\n\n");

  if (!chunk.selection && !/^[ \t]*(?:\n|$)/.test(chunk.after)) {
    chunk.after = chunk.after.replace(/^[^\n]*/, function (wholeMatch) {
      chunk.selection = wholeMatch;
      return "";
    });
    fakeSelection = true;
  }

  if (/(\n|^)[ ]{0,3}([*+-]|\d+[.])[ \t]+.*\n$/.test(chunk.before)) {
    if (commandMgr.doList) {
      commandMgr.doList(chunk);
    }
  }
  if (/(\n|^)[ ]{0,3}>[ \t]+.*\n$/.test(chunk.before)) {
    if (commandMgr.doBlockquote) {
      commandMgr.doBlockquote(chunk);
    }
  }
  if (/(\n|^)(\t|[ ]{4,}).*\n$/.test(chunk.before)) {
    if (commandMgr.doCode) {
      commandMgr.doCode(chunk);
    }
  }

  if (fakeSelection) {
    chunk.after = chunk.selection + chunk.after;
    chunk.selection = "";
  }
};

commandProto.doBlockquote = function (chunk) {

  chunk.selection = chunk.selection.replace(/^(\n*)([^\r]+?)(\n*)$/, function (totalMatch, newlinesBefore, text, newlinesAfter) {
    chunk.before += newlinesBefore;
    chunk.after = newlinesAfter + chunk.after;
    return text;
  });

  chunk.before = chunk.before.replace(/(>[ \t]*)$/, function (totalMatch, blankLine) {
    chunk.selection = blankLine + chunk.selection;
    return "";
  });

  chunk.selection = chunk.selection.replace(/^(\s|>)+$/, "");
  chunk.selection = chunk.selection || this.getString("quoteexample");

  var match = "",
      leftOver = "",
      line;
  if (chunk.before) {
    var lines = chunk.before.replace(/\n$/, "").split("\n");
    var inChain = false;
    for (var i = 0; i < lines.length; i++) {
      var good = false;
      line = lines[i];
      inChain = inChain && line.length > 0;
      if (/^>/.test(line)) {
        good = true;
        if (!inChain && line.length > 1) inChain = true;
      } else if (/^[ \t]*$/.test(line)) {
        good = true;
      } else {
        good = inChain;
      }
      if (good) {
        match += line + "\n";
      } else {
        leftOver += match + line;
        match = "\n";
      }
    }
    if (!/(^|\n)>/.test(match)) {
      leftOver += match;
      match = "";
    }
  }

  chunk.startTag = match;
  chunk.before = leftOver;

  if (chunk.after) {
    chunk.after = chunk.after.replace(/^\n?/, "\n");
  }

  chunk.after = chunk.after.replace(/^(((\n|^)(\n[ \t]*)*>(.+\n)*.*)+(\n[ \t]*)*)/, function (totalMatch) {
    chunk.endTag = totalMatch;
    return "";
  });

  var replaceBlanksInTags = function replaceBlanksInTags(useBracket) {

    var replacement = useBracket ? "> " : "";

    if (chunk.startTag) {
      chunk.startTag = chunk.startTag.replace(/\n((>|\s)*)\n$/, function (totalMatch, markdown) {
        return "\n" + markdown.replace(/^[ ]{0,3}>?[ \t]*$/gm, replacement) + "\n";
      });
    }
    if (chunk.endTag) {
      chunk.endTag = chunk.endTag.replace(/^\n((>|\s)*)\n/, function (totalMatch, markdown) {
        return "\n" + markdown.replace(/^[ ]{0,3}>?[ \t]*$/gm, replacement) + "\n";
      });
    }
  };

  if (/^(?![ ]{0,3}>)/m.test(chunk.selection)) {
    this.wrap(chunk, SETTINGS.lineLength - 2);
    chunk.selection = chunk.selection.replace(/^/gm, "> ");
    replaceBlanksInTags(true);
    chunk.skipLines();
  } else {
    chunk.selection = chunk.selection.replace(/^[ ]{0,3}> ?/gm, "");
    this.unwrap(chunk);
    replaceBlanksInTags(false);

    if (!/^(\n|^)[ ]{0,3}>/.test(chunk.selection) && chunk.startTag) {
      chunk.startTag = chunk.startTag.replace(/\n{0,2}$/, "\n\n");
    }

    if (!/(\n|^)[ ]{0,3}>.*$/.test(chunk.selection) && chunk.endTag) {
      chunk.endTag = chunk.endTag.replace(/^\n{0,2}/, "\n\n");
    }
  }

  chunk.selection = this.hooks.postBlockquoteCreation(chunk.selection);

  if (!/\n/.test(chunk.selection)) {
    chunk.selection = chunk.selection.replace(/^(> *)/, function (wholeMatch, blanks) {
      chunk.startTag += blanks;
      return "";
    });
  }
};

commandProto.doCode = function (chunk) {

  var hasTextBefore = /\S[ ]*$/.test(chunk.before);
  var hasTextAfter = /^[ ]*\S/.test(chunk.after);

  if (!hasTextAfter && !hasTextBefore || /\n/.test(chunk.selection)) {

    chunk.before = chunk.before.replace(/[ ]{4}$/, function (totalMatch) {
      chunk.selection = totalMatch + chunk.selection;
      return "";
    });

    var nLinesBack = 1;
    var nLinesForward = 1;

    if (/(\n|^)(\t|[ ]{4,}).*\n$/.test(chunk.before)) {
      nLinesBack = 0;
    }
    if (/^\n(\t|[ ]{4,})/.test(chunk.after)) {
      nLinesForward = 0;
    }

    chunk.skipLines(nLinesBack, nLinesForward);

    if (!chunk.selection) {
      chunk.startTag = "    ";
      chunk.selection = this.getString("codeexample");
    } else {
      if (/^[ ]{0,3}\S/m.test(chunk.selection)) {
        if (/\n/.test(chunk.selection)) chunk.selection = chunk.selection.replace(/^/gm, "    ");else chunk.before += "    ";
      } else {
        chunk.selection = chunk.selection.replace(/^(?:[ ]{4}|[ ]{0,3}\t)/gm, "");
      }
    }
  } else {

    chunk.trimWhitespace();
    chunk.findTags(/`/, /`/);

    if (!chunk.startTag && !chunk.endTag) {
      chunk.startTag = chunk.endTag = "`";
      if (!chunk.selection) {
        chunk.selection = this.getString("codeexample");
      }
    } else if (chunk.endTag && !chunk.startTag) {
      chunk.before += chunk.endTag;
      chunk.endTag = "";
    } else {
      chunk.startTag = chunk.endTag = "";
    }
  }
};

commandProto.doList = function (chunk, postProcessing, isNumberedList, isCheckList) {
  var previousItemsRegex = /(\n|^)(([ ]{0,3}([*+-]|\d+[.])[ \t]+.*)(\n.+|\n{2,}([*+-].*|\d+[.])[ \t]+.*|\n{2,}[ \t]+\S.*)*)\n*$/;
  var nextItemsRegex = /^\n*(([ ]{0,3}([*+-]|\d+[.])[ \t]+.*)(\n.+|\n{2,}([*+-].*|\d+[.])[ \t]+.*|\n{2,}[ \t]+\S.*)*)\n*/;

  var bullet = "-";

  var num = 1;

  var getItemPrefix = function getItemPrefix(checkListContent) {
    var prefix;
    if (isNumberedList) {
      prefix = " " + num + ". ";
      num++;
    } else {
      prefix = " " + bullet + " ";
      if (isCheckList) {
        prefix += '[';
        prefix += checkListContent || ' ';
        prefix += '] ';
      }
    }
    return prefix;
  };

  var getPrefixedItem = function getPrefixedItem(itemText) {
    if (isNumberedList === undefined) {
      isNumberedList = /^\s*\d/.test(itemText);
    }

    itemText = itemText.replace(isCheckList ? /^[ ]{0,3}([*+-]|\d+[.])\s+\[([ xX])\]\s/gm : /^[ ]{0,3}([*+-]|\d+[.])\s/gm, function (match, p1, p2) {
      return getItemPrefix(p2);
    });

    return itemText;
  };

  chunk.findTags(/(\n|^)*[ ]{0,3}([*+-]|\d+[.])\s+/, null);

  if (chunk.before && !/\n$/.test(chunk.before) && !/^\n/.test(chunk.startTag)) {
    chunk.before += chunk.startTag;
    chunk.startTag = "";
  }

  if (chunk.startTag) {

    var hasDigits = /\d+[.]/.test(chunk.startTag);
    chunk.startTag = "";
    chunk.selection = chunk.selection.replace(/\n[ ]{4}/g, "\n");
    this.unwrap(chunk);
    chunk.skipLines();

    if (hasDigits) {
      chunk.after = chunk.after.replace(nextItemsRegex, getPrefixedItem);
    }
    if (isNumberedList == hasDigits) {
      return;
    }
  }

  var nLinesUp = 1;

  chunk.before = chunk.before.replace(previousItemsRegex, function (itemText) {
    if (/^\s*([*+-])/.test(itemText)) {
      bullet = re.$1;
    }
    nLinesUp = /[^\n]\n\n[^\n]/.test(itemText) ? 1 : 0;
    return getPrefixedItem(itemText);
  });

  if (!chunk.selection) {
    chunk.selection = this.getString("litem");
  }

  var prefix = getItemPrefix();

  var nLinesDown = 1;

  chunk.after = chunk.after.replace(nextItemsRegex, function (itemText) {
    nLinesDown = /[^\n]\n\n[^\n]/.test(itemText) ? 1 : 0;
    return getPrefixedItem(itemText);
  });

  chunk.trimWhitespace(true);
  chunk.skipLines(nLinesUp, nLinesDown, true);
  chunk.startTag = prefix;
  var spaces = prefix.replace(/./g, " ");
  this.wrap(chunk, SETTINGS.lineLength - spaces.length);
  chunk.selection = chunk.selection.replace(/\n/g, "\n" + spaces);
};

commandProto.doTable = function (chunk) {

  var keepFirstAndLastPipes = true,
      regex = /((?:(?:[^\n]*?\|[^\n]*) *)?(?:\r?\n|^))((?:\| *:?-+:? *|\|?(?: *:?-+:? *\|)+)(?: *:?-+:? *)? *\r?\n)((?:(?:[^\n]*?\|[^\n]*) *(?:\r?\n|$))+)/;

  function padding(len, str) {
    var result = '';
    str = str || ' ';
    len = Math.floor(len);
    for (var i = 0; i < len; i++) {
      result += str;
    }
    return result;
  }

  function stripTailPipes(str) {
    return str.trim().replace(/(^\||\|$)/g, "");
  }

  function splitCells(str) {
    return str.split('|');
  }

  function addTailPipes(str) {
    if (keepFirstAndLastPipes) {
      return "|" + str + "|";
    } else {
      return str;
    }
  }

  function joinCells(arr) {
    return arr.join('|');
  }

  function formatTable(text, appendNewline) {
    var i, j, len1, ref1, ref2, ref3, k, len2, results, formatline, headerline, just, formatrow, data, line, lines, justify, cell, cells, first, last, ends, columns, content, widths, formatted, front, back;
    formatline = text[2].trim();
    headerline = text[1].trim();
    ref1 = headerline.length === 0 ? [0, text[3]] : [1, text[1] + text[3]], formatrow = ref1[0], data = ref1[1];
    lines = data.trim().split('\n');
    justify = [];
    ref2 = splitCells(stripTailPipes(formatline));
    for (j = 0, len1 = ref2.length; j < len1; j++) {
      cell = ref2[j];
      ref3 = cell.trim(), first = ref3[0], last = ref3[ref3.length - 1];
      switch (ends = (first ? first : ':') + (last ? last : '')) {
        case '::':
        case '-:':
        case ':-':
          justify.push(ends);
          break;
        default:
          justify.push('--');
      }
    }
    columns = justify.length;
    content = [];
    for (j = 0, len1 = lines.length; j < len1; j++) {
      line = lines[j];
      cells = splitCells(stripTailPipes(line));
      cells[columns - 1] = joinCells(cells.slice(columns - 1));
      results = [];
      for (k = 0, len2 = cells.length; k < len2; k++) {
        cell = cells[k];
        results.push(padding(' ') + ((ref2 = cell ? typeof cell.trim === "function" ? cell.trim() : void 0 : void 0) ? ref2 : '') + padding(' '));
      }
      content.push(results);
    }
    widths = [];
    for (i = j = 0, ref2 = columns - 1; 0 <= ref2 ? j <= ref2 : j >= ref2; i = 0 <= ref2 ? ++j : --j) {
      results = [];
      for (k = 0, len1 = content.length; k < len1; k++) {
        cells = content[k];
        results.push(cells[i].length);
      }
      widths.push(Math.max.apply(Math, [2].concat(results)));
    }
    just = function just(string, col) {
      var back, front, length;
      length = widths[col] - string.length;
      switch (justify[col]) {
        case '::':
          front = padding[0], back = padding[1];
          return padding(length / 2) + string + padding((length + 1) / 2);
        case '-:':
          return padding(length) + string;
        default:
          return string + padding(length);
      }
    };
    formatted = [];
    for (j = 0, len1 = content.length; j < len1; j++) {
      cells = content[j];
      results = [];
      for (i = k = 0, ref2 = columns - 1; 0 <= ref2 ? k <= ref2 : k >= ref2; i = 0 <= ref2 ? ++k : --k) {
        results.push(just(cells[i], i));
      }
      formatted.push(addTailPipes(joinCells(results)));
    }
    formatline = addTailPipes(joinCells(function () {
      var j, ref2, ref3, results;
      results = [];
      for (i = j = 0, ref2 = columns - 1; 0 <= ref2 ? j <= ref2 : j >= ref2; i = 0 <= ref2 ? ++j : --j) {
        ref3 = justify[i], front = ref3[0], back = ref3[1];
        results.push(front + padding(widths[i] - 2, '-') + back);
      }
      return results;
    }()));
    formatted.splice(formatrow, 0, formatline);
    var result = (headerline.length === 0 && text[1] !== '' ? '\n' : '') + formatted.join('\n');
    if (appendNewline !== false) {
      result += '\n';
    }
    return result;
  }

  if (chunk.before.slice(-1) !== '\n') {
    chunk.before += '\n';
  }
  var match = chunk.selection.match(regex);
  if (match) {
    chunk.selection = formatTable(match, chunk.selection.slice(-1) === '\n');
  } else {
    var table = chunk.selection + '|\n-|-\n|';
    match = table.match(regex);
    if (!match || match[0].slice(0, table.length) !== table) {
      return;
    }
    table = formatTable(match);
    var selectionOffset = keepFirstAndLastPipes ? 1 : 0;
    var pipePos = table.indexOf('|', selectionOffset);
    chunk.before += table.slice(0, selectionOffset);
    chunk.selection = table.slice(selectionOffset, pipePos);
    chunk.after = table.slice(pipePos) + chunk.after;
  }
};

commandProto.doHeading = function (chunk) {
  chunk.selection = chunk.selection.replace(/\s+/g, " ");
  chunk.selection = chunk.selection.replace(/(^\s+|\s+$)/g, "");

  if (!chunk.selection) {
    chunk.startTag = "## ";
    chunk.selection = this.getString("headingexample");
    return;
  }

  var headerLevel = 0;
  chunk.findTags(/#+[ ]*/, /[ ]*#+/);
  if (/#+/.test(chunk.startTag)) {
    headerLevel = re.lastMatch.length;
  }
  chunk.startTag = chunk.endTag = "";

  chunk.findTags(null, /\s?(-+|=+)/);
  if (/=+/.test(chunk.endTag)) {
    headerLevel = 1;
  }
  if (/-+/.test(chunk.endTag)) {
    headerLevel = 2;
  }

  chunk.startTag = chunk.endTag = "";
  chunk.skipLines(1, 1);

  var headerLevelToCreate = headerLevel === 0 ? 2 : headerLevel - 1;

  if (headerLevelToCreate > 0) {

    chunk.startTag = '';
    while (headerLevelToCreate--) {
      chunk.startTag += '#';
    }
    chunk.startTag += ' ';
  }
};

commandProto.doHorizontalRule = function (chunk) {
  chunk.startTag = "----------\n";
  chunk.selection = "";
  chunk.skipLines(2, 1, true);
};

/* harmony default export */ __webpack_exports__["a"] = (function (options) {
  return new Pagedown(options);
});;

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__workspaceSvc__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["a"] = ({
  importBackup: function importBackup(jsonValue) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var fileNameMap, folderNameMap, parentIdMap, textMap, propertiesMap, discussionsMap, commentsMap, folderIdMap, parsedValue;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              fileNameMap = {};
              folderNameMap = {};
              parentIdMap = {};
              textMap = {};
              propertiesMap = {};
              discussionsMap = {};
              commentsMap = {};
              folderIdMap = {
                trash: 'trash'
              };
              parsedValue = JSON.parse(jsonValue);

              __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(parsedValue).forEach(function (_ref) {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                    id = _ref2[0],
                    value = _ref2[1];

                if (value) {
                  var v4Match = id.match(/^file\.([^.]+)\.([^.]+)$/);
                  if (v4Match) {
                    var _v4Match = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(v4Match, 3),
                        v4Id = _v4Match[1],
                        type = _v4Match[2];

                    if (type === 'title') {
                      fileNameMap[v4Id] = value;
                    } else if (type === 'content') {
                      textMap[v4Id] = value;
                    }
                  } else if (value.type === 'folder') {
                    folderIdMap[id] = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].uid();
                    folderNameMap[id] = value.name;
                    parentIdMap[id] = '' + (value.parentId || '');
                  } else if (value.type === 'file') {
                    fileNameMap[id] = value.name;
                    parentIdMap[id] = '' + (value.parentId || '');
                  } else if (value.type === 'content') {
                    var _id$split = id.split('/'),
                        _id$split2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_id$split, 1),
                        fileId = _id$split2[0];

                    if (fileId) {
                      textMap[fileId] = value.text;
                      propertiesMap[fileId] = value.properties;
                      discussionsMap[fileId] = value.discussions;
                      commentsMap[fileId] = value.comments;
                    }
                  }
                }
              });

              _context3.next = 12;
              return __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].awaitSequence(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(folderNameMap), function () {
                var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(externalId) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__workspaceSvc__["a" /* default */].setOrPatchItem({
                            id: folderIdMap[externalId],
                            type: 'folder',
                            name: folderNameMap[externalId],
                            parentId: folderIdMap[parentIdMap[externalId]]
                          }));

                        case 1:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this);
                }));

                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }());

            case 12:
              _context3.next = 14;
              return __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].awaitSequence(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(fileNameMap), function () {
                var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(externalId) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__workspaceSvc__["a" /* default */].createFile({
                            name: fileNameMap[externalId],
                            parentId: folderIdMap[parentIdMap[externalId]],
                            text: textMap[externalId],
                            properties: propertiesMap[externalId],
                            discussions: discussionsMap[externalId],
                            comments: commentsMap[externalId]
                          }, true));

                        case 1:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this);
                }));

                return function (_x2) {
                  return _ref4.apply(this, arguments);
                };
              }());

            case 14:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }))();
  }
});

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cleditCore__ = __webpack_require__(102);





var styleElts = [];

function createStyleSheet(document) {
  var styleElt = document.createElement('style');
  styleElt.type = 'text/css';
  styleElt.innerHTML = '.cledit-section * { display: inline; }';
  document.head.appendChild(styleElt);
  styleElts.push(styleElt);
}

function Highlighter(editor) {
  var _this = this;

  __WEBPACK_IMPORTED_MODULE_3__cleditCore__["a" /* default */].Utils.createEventHooks(this);

  if (!styleElts.cl_some(function (styleElt) {
    return document.head.contains(styleElt);
  })) {
    createStyleSheet(document);
  }

  var contentElt = editor.$contentElt;
  this.isComposing = 0;

  var sectionList = [];
  var insertBeforeSection = void 0;
  var useBr = __WEBPACK_IMPORTED_MODULE_3__cleditCore__["a" /* default */].Utils.isWebkit;
  var trailingNodeTag = 'div';
  var hiddenLfInnerHtml = '<br><span class="hd-lf" style="display: none">\n</span>';

  var lfHtml = '<span class="lf">' + (useBr ? hiddenLfInnerHtml : '\n') + '</span>';

  this.fixContent = function (modifiedSections, removedSections, noContentFix) {
    modifiedSections.cl_each(function (section) {
      section.forceHighlighting = true;
      if (!noContentFix) {
        if (useBr) {
          section.elt.getElementsByClassName('hd-lf').cl_each(function (lfElt) {
            return lfElt.parentNode.removeChild(lfElt);
          });
          section.elt.getElementsByTagName('br').cl_each(function (brElt) {
            return brElt.parentNode.replaceChild(document.createTextNode('\n'), brElt);
          });
        }
        if (section.elt.textContent.slice(-1) !== '\n') {
          section.elt.appendChild(document.createTextNode('\n'));
        }
      }
    });
  };

  this.addTrailingNode = function () {
    _this.trailingNode = document.createElement(trailingNodeTag);
    contentElt.appendChild(_this.trailingNode);
  };

  var Section = function () {
    function Section(text) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Section);

      this.text = text.text === undefined ? text : text.text;
      this.data = text.data;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Section, [{
      key: 'setElement',
      value: function setElement(elt) {
        this.elt = elt;
        elt.section = this;
      }
    }]);

    return Section;
  }();

  this.parseSections = function (content, isInit) {
    if (_this.isComposing && !_this.cancelComposition) {
      return sectionList;
    }

    _this.cancelComposition = false;
    var newSectionList = (editor.options.sectionParser ? editor.options.sectionParser(content) : [content]).cl_map(function (sectionText) {
      return new Section(sectionText);
    });

    var modifiedSections = [];
    var sectionsToRemove = [];
    insertBeforeSection = undefined;

    if (isInit) {
      sectionsToRemove = sectionList;
      sectionList = newSectionList;
      modifiedSections = newSectionList;
    } else {
      var leftIndex = sectionList.length;
      sectionList.cl_some(function (section, index) {
        var newSection = newSectionList[index];
        if (index >= newSectionList.length || section.forceHighlighting || section.text !== newSection.text || section.elt.parentNode !== contentElt || section.elt.textContent !== newSection.text) {
          leftIndex = index;
          return true;
        }
        return false;
      });

      var rightIndex = -sectionList.length;
      sectionList.slice().reverse().cl_some(function (section, index) {
        var newSection = newSectionList[newSectionList.length - index - 1];
        if (index >= newSectionList.length || section.forceHighlighting || section.text !== newSection.text || section.elt.parentNode !== contentElt || section.elt.textContent !== newSection.text) {
          rightIndex = -index;
          return true;
        }
        return false;
      });

      if (leftIndex - rightIndex > sectionList.length) {
        rightIndex = leftIndex - sectionList.length;
      }

      var leftSections = sectionList.slice(0, leftIndex);
      modifiedSections = newSectionList.slice(leftIndex, newSectionList.length + rightIndex);
      var rightSections = sectionList.slice(sectionList.length + rightIndex, sectionList.length);

      var _rightSections = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(rightSections, 1);

      insertBeforeSection = _rightSections[0];

      sectionsToRemove = sectionList.slice(leftIndex, sectionList.length + rightIndex);
      sectionList = leftSections.concat(modifiedSections).concat(rightSections);
    }

    var highlight = function highlight(section) {
      var html = editor.options.sectionHighlighter(section).replace(/\n/g, lfHtml);
      var sectionElt = document.createElement('div');
      sectionElt.className = 'cledit-section';
      sectionElt.innerHTML = html;
      section.setElement(sectionElt);
      _this.$trigger('sectionHighlighted', section);
    };

    var newSectionEltList = document.createDocumentFragment();
    modifiedSections.cl_each(function (section) {
      section.forceHighlighting = false;
      highlight(section);
      newSectionEltList.appendChild(section.elt);
    });
    editor.watcher.noWatch(function () {
      if (isInit) {
        contentElt.innerHTML = '';
        contentElt.appendChild(newSectionEltList);
        _this.addTrailingNode();
        return;
      }

      sectionsToRemove.cl_each(function (section) {
        if (section.elt.parentNode === contentElt) {
          contentElt.removeChild(section.elt);
        }

        section.elt.section = undefined;
      });

      if (insertBeforeSection !== undefined) {
        contentElt.insertBefore(newSectionEltList, insertBeforeSection.elt);
      } else {
        contentElt.appendChild(newSectionEltList);
      }

      var childNode = contentElt.firstChild;
      while (childNode) {
        var nextNode = childNode.nextSibling;
        if (!childNode.section) {
          contentElt.removeChild(childNode);
        }
        childNode = nextNode;
      }
      _this.addTrailingNode();
      _this.$trigger('highlighted');

      if (editor.selectionMgr.hasFocus()) {
        editor.selectionMgr.restoreSelection();
        editor.selectionMgr.updateCursorCoordinates();
      }
    });

    return sectionList;
  };
}

__WEBPACK_IMPORTED_MODULE_3__cleditCore__["a" /* default */].Highlighter = Highlighter;

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cleditCore__ = __webpack_require__(102);



function Keystroke(handler, priority) {
  this.handler = handler;
  this.priority = priority || 100;
}

__WEBPACK_IMPORTED_MODULE_1__cleditCore__["a" /* default */].Keystroke = Keystroke;

var clearNewline = void 0;
var charTypes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(null);

'./\\()"\'-:,.;<>~!@#$%^&*|+=[]{}`~?'.split('').cl_each(function (wordSeparator) {
  charTypes[wordSeparator] = 'wordSeparator';
});
charTypes[' '] = 'space';
charTypes['\t'] = 'space';
charTypes['\n'] = 'newLine';

function getNextWordOffset(text, offset, isBackward) {
  var previousType = void 0;
  var result = offset;
  while (isBackward && result > 0 || !isBackward && result < text.length) {
    var currentType = charTypes[isBackward ? text[result - 1] : text[result]] || 'word';
    if (previousType && currentType !== previousType) {
      if (previousType === 'word' || currentType === 'space' || previousType === 'newLine' || currentType === 'newLine') {
        break;
      }
    }
    previousType = currentType;
    if (isBackward) {
      result -= 1;
    } else {
      result += 1;
    }
  }
  return result;
}

__WEBPACK_IMPORTED_MODULE_1__cleditCore__["a" /* default */].defaultKeystrokes = [new Keystroke(function (evt, state, editor) {
  if (!evt.ctrlKey && !evt.metaKey || evt.altKey) {
    return false;
  }
  var keyCode = evt.charCode || evt.keyCode;
  var keyCodeChar = String.fromCharCode(keyCode).toLowerCase();
  var action = void 0;
  switch (keyCodeChar) {
    case 'y':
      action = 'redo';
      break;
    case 'z':
      action = evt.shiftKey ? 'redo' : 'undo';
      break;
    default:
  }
  if (action) {
    evt.preventDefault();
    setTimeout(function () {
      return editor.undoMgr[action]();
    }, 10);
    return true;
  }
  return false;
}), new Keystroke(function (evt, state) {
  if (evt.which !== 9 || evt.metaKey || evt.ctrlKey) {
    return false;
  }

  var strSplice = function strSplice(str, i, remove) {
    var add = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    return str.slice(0, i) + add + str.slice(i + (+remove || 0));
  };

  evt.preventDefault();
  var isInverse = evt.shiftKey;
  var lf = state.before.lastIndexOf('\n') + 1;
  if (isInverse) {
    if (/\s/.test(state.before.charAt(lf))) {
      state.before = strSplice(state.before, lf, 1);
    }
    state.selection = state.selection.replace(/^[ \t]/gm, '');
  } else if (state.selection) {
    state.before = strSplice(state.before, lf, 0, '\t');
    state.selection = state.selection.replace(/\n(?=[\s\S])/g, '\n\t');
  } else {
    state.before += '\t';
  }
  return true;
}), new Keystroke(function (evt, state, editor) {
  if (evt.which !== 13) {
      clearNewline = false;
      return false;
    }

  evt.preventDefault();
  var lf = state.before.lastIndexOf('\n') + 1;
  if (clearNewline) {
    state.before = state.before.substring(0, lf);
    state.selection = '';
    clearNewline = false;
    return true;
  }
  clearNewline = false;
  var previousLine = state.before.slice(lf);
  var indent = previousLine.match(/^\s*/)[0];
  if (indent.length) {
    clearNewline = true;
  }

  editor.undoMgr.setCurrentMode('single');
  state.before += '\n' + indent;
  state.selection = '';
  return true;
}), new Keystroke(function (evt, state, editor) {
  if (evt.which !== 8 && evt.which !== 46) {
      return false;
    }

  editor.undoMgr.setCurrentMode('delete');
  if (!state.selection) {
    var isJump = __WEBPACK_IMPORTED_MODULE_1__cleditCore__["a" /* default */].Utils.isMac && evt.altKey || !__WEBPACK_IMPORTED_MODULE_1__cleditCore__["a" /* default */].Utils.isMac && evt.ctrlKey;
    if (isJump) {
      var text = state.before + state.after;
      var offset = getNextWordOffset(text, state.before.length, evt.which === 8);
      if (evt.which === 8) {
        state.before = state.before.slice(0, offset);
      } else {
        state.after = state.after.slice(offset - text.length);
      }
      evt.preventDefault();
      return true;
    } else if (evt.which === 8 && state.before.slice(-1) === '\n') {
      state.before = state.before.slice(0, -1);
      evt.preventDefault();
      return true;
    } else if (evt.which === 46 && state.after.slice(0, 1) === '\n') {
      state.after = state.after.slice(1);
      evt.preventDefault();
      return true;
    }
  } else {
    state.selection = '';
    evt.preventDefault();
    return true;
  }
  return false;
}), new Keystroke(function (evt, state, editor) {
  if (evt.which !== 37 && evt.which !== 39) {
      return false;
    }
  var isJump = __WEBPACK_IMPORTED_MODULE_1__cleditCore__["a" /* default */].Utils.isMac && evt.altKey || !__WEBPACK_IMPORTED_MODULE_1__cleditCore__["a" /* default */].Utils.isMac && evt.ctrlKey;
  if (!isJump) {
    return false;
  }

  var textContent = editor.getContent();
  var offset = getNextWordOffset(textContent, editor.selectionMgr.selectionEnd, evt.which === 37);
  if (evt.shiftKey) {
    var min = Math.min(editor.selectionMgr.selectionStart, offset);
    var max = Math.max(editor.selectionMgr.selectionStart, offset);
    state.before = textContent.slice(0, min);
    state.after = textContent.slice(max);
    state.selection = textContent.slice(min, max);
    state.isBackwardSelection = editor.selectionMgr.selectionStart > offset;
  } else {
    state.before = textContent.slice(0, offset);
    state.after = textContent.slice(offset);
    state.selection = '';
  }
  evt.preventDefault();
  return true;
})];

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cleditCore__ = __webpack_require__(102);




var DIFF_DELETE = -1;
var DIFF_INSERT = 1;
var DIFF_EQUAL = 0;

var idCounter = 0;

var Marker = function () {
  function Marker(offset, trailing) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Marker);

    this.id = idCounter;
    idCounter += 1;
    this.offset = offset;
    this.trailing = trailing;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Marker, [{
    key: 'adjustOffset',
    value: function adjustOffset(diffs) {
      var _this = this;

      var startOffset = 0;
      diffs.cl_each(function (diff) {
        var diffType = diff[0];
        var diffText = diff[1];
        var diffOffset = diffText.length;
        switch (diffType) {
          case DIFF_EQUAL:
            startOffset += diffOffset;
            break;
          case DIFF_INSERT:
            if (_this.trailing ? _this.offset > startOffset : _this.offset >= startOffset) {
              _this.offset += diffOffset;
            }
            startOffset += diffOffset;
            break;
          case DIFF_DELETE:
            if (_this.offset > startOffset) {
              _this.offset -= Math.min(diffOffset, _this.offset - startOffset);
            }
            break;
          default:
        }
      });
    }
  }]);

  return Marker;
}();

__WEBPACK_IMPORTED_MODULE_2__cleditCore__["a" /* default */].Marker = Marker;

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cleditCore__ = __webpack_require__(102);


function SelectionMgr(editor) {
  var _this = this;

  var debounce = __WEBPACK_IMPORTED_MODULE_0__cleditCore__["a" /* default */].Utils.debounce;

  var contentElt = editor.$contentElt;
  var scrollElt = editor.$scrollElt;
  __WEBPACK_IMPORTED_MODULE_0__cleditCore__["a" /* default */].Utils.createEventHooks(this);

  var lastSelectionStart = 0;
  var lastSelectionEnd = 0;
  this.selectionStart = 0;
  this.selectionEnd = 0;
  this.cursorCoordinates = {};

  this.findContainer = function (offset) {
    var result = __WEBPACK_IMPORTED_MODULE_0__cleditCore__["a" /* default */].Utils.findContainer(contentElt, offset);
    if (result.container.nodeValue === '\n') {
      var hdLfElt = result.container.parentNode;
      if (hdLfElt.className === 'hd-lf' && hdLfElt.previousSibling && hdLfElt.previousSibling.tagName === 'BR') {
        result.container = hdLfElt.parentNode;
        result.offsetInContainer = Array.prototype.indexOf.call(result.container.childNodes, result.offsetInContainer === 0 ? hdLfElt.previousSibling : hdLfElt);
      }
    }
    return result;
  };

  this.createRange = function (start, end) {
    var range = document.createRange();
    var startContainer = typeof start === 'number' ? _this.findContainer(start < 0 ? 0 : start) : start;
    var endContainer = startContainer;
    if (start !== end) {
      endContainer = typeof end === 'number' ? _this.findContainer(end < 0 ? 0 : end) : end;
    }
    range.setStart(startContainer.container, startContainer.offsetInContainer);
    range.setEnd(endContainer.container, endContainer.offsetInContainer);
    return range;
  };

  var adjustScroll = void 0;
  var debouncedUpdateCursorCoordinates = debounce(function () {
    var coordinates = _this.getCoordinates(_this.selectionEnd, _this.selectionEndContainer, _this.selectionEndOffset);
    if (_this.cursorCoordinates.top !== coordinates.top || _this.cursorCoordinates.height !== coordinates.height || _this.cursorCoordinates.left !== coordinates.left) {
      _this.cursorCoordinates = coordinates;
      _this.$trigger('cursorCoordinatesChanged', coordinates);
    }
    if (adjustScroll) {
      var scrollEltHeight = scrollElt.clientHeight;
      if (typeof adjustScroll === 'number') {
        scrollEltHeight -= adjustScroll;
      }
      var adjustment = scrollEltHeight / 2 * editor.options.getCursorFocusRatio();
      var cursorTop = _this.cursorCoordinates.top + _this.cursorCoordinates.height / 2;

      cursorTop += contentElt.getBoundingClientRect().top - scrollElt.getBoundingClientRect().top + scrollElt.scrollTop;
      var minScrollTop = cursorTop - adjustment;
      var maxScrollTop = cursorTop + adjustment - scrollEltHeight;
      if (scrollElt.scrollTop > minScrollTop) {
        scrollElt.scrollTop = minScrollTop;
      } else if (scrollElt.scrollTop < maxScrollTop) {
        scrollElt.scrollTop = maxScrollTop;
      }
    }
    adjustScroll = false;
  });

  this.updateCursorCoordinates = function (adjustScrollParam) {
    adjustScroll = adjustScroll || adjustScrollParam;
    debouncedUpdateCursorCoordinates();
  };

  var oldSelectionRange = void 0;

  var checkSelection = function checkSelection(selectionRange) {
    if (!oldSelectionRange || oldSelectionRange.startContainer !== selectionRange.startContainer || oldSelectionRange.startOffset !== selectionRange.startOffset || oldSelectionRange.endContainer !== selectionRange.endContainer || oldSelectionRange.endOffset !== selectionRange.endOffset) {
      oldSelectionRange = selectionRange;
      _this.$trigger('selectionChanged', _this.selectionStart, _this.selectionEnd, selectionRange);
      return true;
    }
    return false;
  };

  this.hasFocus = function () {
    return contentElt === document.activeElement;
  };

  this.restoreSelection = function () {
    var min = Math.min(_this.selectionStart, _this.selectionEnd);
    var max = Math.max(_this.selectionStart, _this.selectionEnd);
    var selectionRange = _this.createRange(min, max);
    if (!document.contains(selectionRange.commonAncestorContainer)) {
      return null;
    }
    var selection = window.getSelection();
    selection.removeAllRanges();
    var isBackward = _this.selectionStart > _this.selectionEnd;
    if (isBackward && selection.extend) {
      var beginRange = selectionRange.cloneRange();
      beginRange.collapse(false);
      selection.addRange(beginRange);
      selection.extend(selectionRange.startContainer, selectionRange.startOffset);
    } else {
      selection.addRange(selectionRange);
    }
    checkSelection(selectionRange);
    return selectionRange;
  };

  var saveLastSelection = debounce(function () {
    lastSelectionStart = _this.selectionStart;
    lastSelectionEnd = _this.selectionEnd;
  }, 50);

  var setSelection = function setSelection() {
    var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.selectionStart;
    var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.selectionEnd;

    _this.selectionStart = start < 0 ? 0 : start;
    _this.selectionEnd = end < 0 ? 0 : end;
    saveLastSelection();
  };

  this.setSelectionStartEnd = function (start, end) {
    var restoreSelection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    setSelection(start, end);
    if (restoreSelection && _this.hasFocus()) {
      return _this.restoreSelection();
    }
    return null;
  };

  this.saveSelectionState = function () {
    function arrayContains(arr, val) {
      var i = arr.length;
      while (i) {
        i -= 1;
        if (arr[i] === val) {
          return true;
        }
      }
      return false;
    }

    function getClosestAncestorIn(node, ancestor, selfIsAncestor) {
      var p = void 0;
      var n = selfIsAncestor ? node : node.parentNode;
      while (n) {
        p = n.parentNode;
        if (p === ancestor) {
          return n;
        }
        n = p;
      }
      return null;
    }

    function getNodeIndex(node) {
      var i = 0;
      var previousSibling = node.previousSibling;

      while (previousSibling) {
        i += 1;
        var _previousSibling = previousSibling;
        previousSibling = _previousSibling.previousSibling;
      }
      return i;
    }

    function getCommonAncestor(node1, node2) {
      var ancestors = [];
      var n = void 0;
      for (n = node1; n; n = n.parentNode) {
        ancestors.push(n);
      }

      for (n = node2; n; n = n.parentNode) {
        if (arrayContains(ancestors, n)) {
          return n;
        }
      }

      return null;
    }

    function comparePoints(nodeA, offsetA, nodeB, offsetB) {
      var n = void 0;
      if (nodeA === nodeB) {
        if (offsetA === offsetB) {
          return 0;
        }
        return offsetA < offsetB ? -1 : 1;
      }
      var nodeC = getClosestAncestorIn(nodeB, nodeA, true);
      if (nodeC) {
        return offsetA <= getNodeIndex(nodeC) ? -1 : 1;
      }
      nodeC = getClosestAncestorIn(nodeA, nodeB, true);
      if (nodeC) {
        return getNodeIndex(nodeC) < offsetB ? -1 : 1;
      }
      var root = getCommonAncestor(nodeA, nodeB);
      if (!root) {
        throw new Error('comparePoints error: nodes have no common ancestor');
      }

      var childA = nodeA === root ? root : getClosestAncestorIn(nodeA, root, true);
      var childB = nodeB === root ? root : getClosestAncestorIn(nodeB, root, true);

      if (childA === childB) {
        throw module.createError('comparePoints got to case 4 and childA and childB are the same!');
      }
      n = root.firstChild;
      while (n) {
        if (n === childA) {
          return -1;
        } else if (n === childB) {
          return 1;
        }
        n = n.nextSibling;
      }
      return 0;
    }

    var save = function save() {
      var result = void 0;
      if (_this.hasFocus()) {
        var selectionStart = _this.selectionStart;
        var selectionEnd = _this.selectionEnd;

        var selection = window.getSelection();
        if (selection.rangeCount > 0) {
          var selectionRange = selection.getRangeAt(0);
          var node = selectionRange.startContainer;

          if (contentElt.compareDocumentPosition(node) & window.Node.DOCUMENT_POSITION_CONTAINED_BY || contentElt === node) {
            var offset = selectionRange.startOffset;
            if (node.firstChild && offset > 0) {
              node = node.childNodes[offset - 1];
              offset = node.textContent.length;
            }
            var container = node;
            while (node !== contentElt) {
              node = node.previousSibling;
              while (node) {
                offset += (node.textContent || '').length;
                node = node.previousSibling;
              }
              node = container.parentNode;
              container = node;
            }
            var selectionText = '' + selectionRange;

            var brElt = selectionRange.endContainer.firstChild;
            if (brElt && brElt.tagName === 'BR' && selectionRange.endOffset === 1) {
              selectionText += '\n';
            }
            if (comparePoints(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset) === 1) {
              selectionStart = offset + selectionText.length;
              selectionEnd = offset;
            } else {
              selectionStart = offset;
              selectionEnd = offset + selectionText.length;
            }

            if (selectionStart === selectionEnd && selectionStart === editor.getContent().length) {
              selectionEnd -= 1;
              selectionStart = selectionEnd;
              result = _this.setSelectionStartEnd(selectionStart, selectionEnd);
            } else {
              setSelection(selectionStart, selectionEnd);
              result = checkSelection(selectionRange);

              result = result || lastSelectionStart !== _this.selectionStart;
            }
          }
        }
      }
      return result;
    };

    var saveCheckChange = function saveCheckChange() {
      return save() && (lastSelectionStart !== _this.selectionStart || lastSelectionEnd !== _this.selectionEnd);
    };

    var nextTickAdjustScroll = false;
    var longerDebouncedSave = debounce(function () {
      _this.updateCursorCoordinates(saveCheckChange() && nextTickAdjustScroll);
      nextTickAdjustScroll = false;
    }, 10);
    var debouncedSave = debounce(function () {
      _this.updateCursorCoordinates(saveCheckChange() && nextTickAdjustScroll);

      longerDebouncedSave();
    });

    return function (debounced, adjustScrollParam, forceAdjustScroll) {
      if (forceAdjustScroll) {
        lastSelectionStart = undefined;
        lastSelectionEnd = undefined;
      }
      if (debounced) {
        nextTickAdjustScroll = nextTickAdjustScroll || adjustScrollParam;
        debouncedSave();
      } else {
        save();
      }
    };
  }();

  this.getSelectedText = function () {
    var min = Math.min(_this.selectionStart, _this.selectionEnd);
    var max = Math.max(_this.selectionStart, _this.selectionEnd);
    return editor.getContent().substring(min, max);
  };

  this.getCoordinates = function (inputOffset, containerParam, offsetInContainerParam) {
    var container = containerParam;
    var offsetInContainer = offsetInContainerParam;
    if (!container) {
      var offset = _this.findContainer(inputOffset);
      container = offset.container;
      offsetInContainer = offset.offsetInContainer;
    }
    var containerElt = container;
    if (!containerElt.hasChildNodes() && container.parentNode) {
      containerElt = container.parentNode;
    }
    var isInvisible = false;
    while (!containerElt.offsetHeight) {
      isInvisible = true;
      if (containerElt.previousSibling) {
        containerElt = containerElt.previousSibling;
      } else {
        containerElt = containerElt.parentNode;
        if (!containerElt) {
          return {
            top: 0,
            height: 0,
            left: 0
          };
        }
      }
    }
    var rect = void 0;
    var left = 'left';
    if (isInvisible || container.textContent === '\n') {
      rect = containerElt.getBoundingClientRect();
    } else {
      var selectedChar = editor.getContent()[inputOffset];
      var startOffset = {
        container: container,
        offsetInContainer: offsetInContainer
      };
      var endOffset = {
        container: container,
        offsetInContainer: offsetInContainer
      };
      if (inputOffset > 0 && (selectedChar === undefined || selectedChar === '\n')) {
        left = 'right';
        if (startOffset.offsetInContainer === 0) {
          startOffset = inputOffset - 1;
        } else {
          startOffset.offsetInContainer -= 1;
        }
      } else if (endOffset.offsetInContainer === container.textContent.length) {
        endOffset = inputOffset + 1;
      } else {
        endOffset.offsetInContainer += 1;
      }
      var range = _this.createRange(startOffset, endOffset);
      rect = range.getBoundingClientRect();
    }
    var contentRect = contentElt.getBoundingClientRect();
    return {
      top: Math.round(rect.top - contentRect.top + contentElt.scrollTop),
      height: Math.round(rect.height),
      left: Math.round(rect[left] - contentRect.left + contentElt.scrollLeft)
    };
  };

  this.getClosestWordOffset = function (offset) {
    var offsetStart = 0;
    var offsetEnd = 0;
    var nextOffset = 0;
    editor.getContent().split(/\s/).cl_some(function (word) {
      if (word) {
        offsetStart = nextOffset;
        offsetEnd = nextOffset + word.length;
        if (offsetEnd > offset) {
          return true;
        }
      }
      nextOffset += word.length + 1;
      return false;
    });
    return {
      start: offsetStart,
      end: offsetEnd
    };
  };
}

__WEBPACK_IMPORTED_MODULE_0__cleditCore__["a" /* default */].SelectionMgr = SelectionMgr;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(938)(module)))

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_diff_match_patch__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_diff_match_patch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_diff_match_patch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cleditCore__ = __webpack_require__(102);





function UndoMgr(editor) {
  var _this2 = this;

  __WEBPACK_IMPORTED_MODULE_3__cleditCore__["a" /* default */].Utils.createEventHooks(this);

  var diffMatchPatch = new __WEBPACK_IMPORTED_MODULE_2_diff_match_patch___default.a();


  var self = this;
  var selectionMgr = void 0;
  var undoStack = [];
  var redoStack = [];
  var currentState = void 0;
  var previousPatches = [];
  var currentPatches = [];
  var debounce = __WEBPACK_IMPORTED_MODULE_3__cleditCore__["a" /* default */].Utils.debounce;


  this.options = {
    undoStackMaxSize: 200,
    bufferStateUntilIdle: 1000,
    patchHandler: {
      makePatches: function makePatches(oldContent, newContent, diffs) {
        return diffMatchPatch.patch_make(oldContent, diffs);
      },
      applyPatches: function applyPatches(patches, content) {
        return diffMatchPatch.patch_apply(patches, content)[0];
      },
      reversePatches: function reversePatches(patches) {
        var reversedPatches = diffMatchPatch.patch_deepCopy(patches).reverse();
        reversedPatches.cl_each(function (patch) {
          patch.diffs.cl_each(function (diff) {
            diff[0] = -diff[0];
          });
        });
        return reversedPatches;
      }
    }
  };

  var stateMgr = void 0;
  function StateMgr() {
    var _this = this;

    var currentTime = void 0;
    var lastTime = void 0;
    var lastMode = void 0;

    this.isBufferState = function () {
      currentTime = Date.now();
      return _this.currentMode !== 'single' && _this.currentMode === lastMode && currentTime - lastTime < self.options.bufferStateUntilIdle;
    };

    this.setDefaultMode = function (mode) {
      _this.currentMode = _this.currentMode || mode;
    };

    this.resetMode = function () {
      stateMgr.currentMode = undefined;
      lastMode = undefined;
    };

    this.saveMode = function () {
      lastMode = _this.currentMode;
      _this.currentMode = undefined;
      lastTime = currentTime;
    };
  }

  var State = function () {
    function State() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, State);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(State, [{
      key: 'addToUndoStack',
      value: function addToUndoStack() {
        undoStack.push(this);
        this.patches = previousPatches;
        previousPatches = [];
      }
    }, {
      key: 'addToRedoStack',
      value: function addToRedoStack() {
        redoStack.push(this);
        this.patches = previousPatches;
        previousPatches = [];
      }
    }]);

    return State;
  }();

  stateMgr = new StateMgr();
  this.setCurrentMode = function (mode) {
    stateMgr.currentMode = mode;
  };
  this.setDefaultMode = stateMgr.setDefaultMode.cl_bind(stateMgr);

  this.addDiffs = function (oldContent, newContent, diffs) {
    var patches = _this2.options.patchHandler.makePatches(oldContent, newContent, diffs);
    patches.cl_each(function (patch) {
      return currentPatches.push(patch);
    });
  };

  function saveCurrentPatches() {
    Array.prototype.push.apply(previousPatches, currentPatches);
    currentPatches = [];
  }

  this.saveState = debounce(function () {
    redoStack.length = 0;
    if (!stateMgr.isBufferState()) {
      currentState.addToUndoStack();

      while (undoStack.length > _this2.options.undoStackMaxSize) {
        undoStack.shift();
      }
    }
    saveCurrentPatches();
    currentState = new State();
    stateMgr.saveMode();
    _this2.$trigger('undoStateChange');
  });

  this.canUndo = function () {
    return !!undoStack.length;
  };
  this.canRedo = function () {
    return !!redoStack.length;
  };

  var restoreState = function restoreState(patchesParam, isForward) {
    var patches = patchesParam;

    var content = editor.getContent();
    if (!isForward) {
      patches = _this2.options.patchHandler.reversePatches(patches);
    }

    var newContent = _this2.options.patchHandler.applyPatches(patches, content);
    var newContentText = newContent.text || newContent;
    var range = editor.setContent(newContentText, true);
    var selection = newContent.selection || {
      start: range.end,
      end: range.end
    };

    selectionMgr.setSelectionStartEnd(selection.start, selection.end);
    selectionMgr.updateCursorCoordinates(true);

    stateMgr.resetMode();
    _this2.$trigger('undoStateChange');
    editor.adjustCursorPosition();
  };

  this.undo = function () {
    var state = undoStack.pop();
    if (!state) {
      return;
    }
    saveCurrentPatches();
    currentState.addToRedoStack();
    restoreState(currentState.patches);
    previousPatches = state.patches;
    currentState = state;
  };

  this.redo = function () {
    var state = redoStack.pop();
    if (!state) {
      return;
    }
    currentState.addToUndoStack();
    restoreState(state.patches, true);
    previousPatches = state.patches;
    currentState = state;
  };

  this.init = function (options) {
    _this2.options.cl_extend(options || {});
    selectionMgr = editor.selectionMgr;

    if (!currentState) {
      currentState = new State();
    }
  };
}

__WEBPACK_IMPORTED_MODULE_3__cleditCore__["a" /* default */].UndoMgr = UndoMgr;

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cleditCore__ = __webpack_require__(102);



var Utils = {
  isGecko: 'MozAppearance' in document.documentElement.style,
  isWebkit: 'WebkitAppearance' in document.documentElement.style,
  isMsie: 'msTransform' in document.documentElement.style,
  isMac: navigator.userAgent.indexOf('Mac OS X') !== -1
};

Utils.defer = function () {
  var queue = new Array(1000);
  var queueLength = 0;
  function flush() {
    for (var i = 0; i < queueLength; i += 1) {
      try {
        queue[i]();
      } catch (e) {
        console.error(e.message, e.stack);
      }
      queue[i] = undefined;
    }
    queueLength = 0;
  }

  var iterations = 0;
  var observer = new window.MutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function (fn) {
    queue[queueLength] = fn;
    queueLength += 1;
    if (queueLength === 1) {
      iterations = (iterations + 1) % 2;
      node.data = iterations;
    }
  };
}();

Utils.debounce = function (func, wait) {
  var timeoutId = void 0;
  var isExpected = void 0;
  return wait ? function () {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(func, wait);
  } : function () {
    if (!isExpected) {
      isExpected = true;
      Utils.defer(function () {
        isExpected = false;
        func();
      });
    }
  };
};

Utils.createEventHooks = function (object) {
  var listenerMap = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(null);
  object.$trigger = function (eventType) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var listeners = listenerMap[eventType];
    if (listeners) {
      listeners.cl_each(function (listener) {
        try {
          listener.apply(object, args);
        } catch (e) {
          console.error(e.message, e.stack);
        }
      });
    }
  };
  object.on = function (eventType, listener) {
    var listeners = listenerMap[eventType];
    if (!listeners) {
      listeners = [];
      listenerMap[eventType] = listeners;
    }
    listeners.push(listener);
  };
  object.off = function (eventType, listener) {
    var listeners = listenerMap[eventType];
    if (listeners) {
      var index = listeners.indexOf(listener);
      if (index !== -1) {
        listeners.splice(index, 1);
      }
    }
  };
};

Utils.findContainer = function (elt, offset) {
  var containerOffset = 0;
  var container = void 0;
  var child = elt;
  do {
    container = child;
    child = child.firstChild;
    if (child) {
      do {
        var len = child.textContent.length;
        if (containerOffset <= offset && containerOffset + len > offset) {
          break;
        }
        containerOffset += len;
        child = child.nextSibling;
      } while (child);
    }
  } while (child && child.firstChild && child.nodeType !== 3);

  if (child) {
    return {
      container: child,
      offsetInContainer: offset - containerOffset
    };
  }
  while (container.lastChild) {
    container = container.lastChild;
  }
  return {
    container: container,
    offsetInContainer: container.nodeType === 3 ? container.textContent.length : 0
  };
};

__WEBPACK_IMPORTED_MODULE_1__cleditCore__["a" /* default */].Utils = Utils;

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cleditCore__ = __webpack_require__(102);


function Watcher(editor, listener) {
  var _this = this;

  this.isWatching = false;
  var contentObserver = void 0;
  this.startWatching = function () {
    _this.stopWatching();
    _this.isWatching = true;
    contentObserver = new window.MutationObserver(listener);
    contentObserver.observe(editor.$contentElt, {
      childList: true,
      subtree: true,
      characterData: true
    });
  };
  this.stopWatching = function () {
    if (contentObserver) {
      contentObserver.disconnect();
      contentObserver = undefined;
    }
    _this.isWatching = false;
  };
  this.noWatch = function (cb) {
    if (_this.isWatching === true) {
      _this.stopWatching();
      cb();
      _this.startWatching();
    } else {
      cb();
    }
  };
}

__WEBPACK_IMPORTED_MODULE_0__cleditCore__["a" /* default */].Watcher = Watcher;

/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_diff_match_patch__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_diff_match_patch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_diff_match_patch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cledit__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__diffUtils__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_EditorClassApplier__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_PreviewClassApplier__ = __webpack_require__(451);














var clEditor = void 0;

var discussionMarkers = {};
var markerKeys = void 0;
var markerIdxMap = void 0;
var previousPatchableText = void 0;
var currentPatchableText = void 0;
var isChangePatch = void 0;
var contentId = void 0;
var editorClassAppliers = {};
var previewClassAppliers = {};

function getDiscussionMarkers(discussion, discussionId, onMarker) {
  var getMarker = function getMarker(offsetName) {
    var markerKey = discussionId + ':' + offsetName;
    var marker = discussionMarkers[markerKey];
    if (!marker) {
      marker = new __WEBPACK_IMPORTED_MODULE_7__cledit__["a" /* default */].Marker(discussion[offsetName], offsetName === 'end');
      marker.discussionId = discussionId;
      marker.offsetName = offsetName;
      clEditor.addMarker(marker);
      discussionMarkers[markerKey] = marker;
    }
    onMarker(marker);
  };
  getMarker('start');
  getMarker('end');
}

function syncDiscussionMarkers(content, writeOffsets) {
  var discussions = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, content.discussions);
  var newDiscussion = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters['discussion/newDiscussion'];
  if (newDiscussion) {
    discussions[__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.discussion.newDiscussionId] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, newDiscussion);
  }
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(discussionMarkers).forEach(function (_ref) {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
        markerKey = _ref2[0],
        marker = _ref2[1];

    var discussion = discussions[marker.discussionId];
    if (!discussion) {
      clEditor.removeMarker(marker);
      delete discussionMarkers[markerKey];
    }
  });

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(discussions).forEach(function (_ref3) {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
        discussionId = _ref4[0],
        discussion = _ref4[1];

    getDiscussionMarkers(discussion, discussionId, writeOffsets ? function (marker) {
      discussion[marker.offsetName] = marker.offset;
    } : function (marker) {
      marker.offset = discussion[marker.offsetName];
    });
  });

  if (writeOffsets && newDiscussion) {
    __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('discussion/patchNewDiscussion', discussions[__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.discussion.newDiscussionId]);
  }
}

function removeDiscussionMarkers() {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(discussionMarkers).forEach(function (_ref5) {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
        marker = _ref6[1];

    clEditor.removeMarker(marker);
  });
  discussionMarkers = {};
  markerKeys = [];
  markerIdxMap = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(null);
}

var diffMatchPatch = new __WEBPACK_IMPORTED_MODULE_6_diff_match_patch___default.a();

function makePatches() {
  var diffs = diffMatchPatch.diff_main(previousPatchableText, currentPatchableText);
  return diffMatchPatch.patch_make(previousPatchableText, diffs);
}

function applyPatches(patches) {
  var newPatchableText = diffMatchPatch.patch_apply(patches, currentPatchableText)[0];
  var result = newPatchableText;
  if (markerKeys.length) {
    result = result.replace(new RegExp('[\uE000-' + String.fromCharCode(0xe000 + markerKeys.length - 1) + ']', 'g'), '');
  }

  if (result !== clEditor.getContent()) {
    previousPatchableText = currentPatchableText;
    currentPatchableText = newPatchableText;
    isChangePatch = true;
  }
  return result;
}

function reversePatches(patches) {
  var result = diffMatchPatch.patch_deepCopy(patches).reverse();
  result.forEach(function (patch) {
    patch.diffs.forEach(function (diff) {
      diff[0] = -diff[0];
    });
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  createClEditor: function createClEditor(editorElt) {
    this.clEditor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__cledit__["a" /* default */])(editorElt, editorElt.parentNode, true);
    clEditor = this.clEditor;

    clEditor.on('contentChanged', function (text) {
      var oldContent = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters['content/current'];
      var newContent = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].deepCopy(oldContent), {
        text: __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].sanitizeText(text)
      });
      syncDiscussionMarkers(newContent, true);
      if (!isChangePatch) {
        previousPatchableText = currentPatchableText;
        currentPatchableText = __WEBPACK_IMPORTED_MODULE_9__diffUtils__["a" /* default */].makePatchableText(newContent, markerKeys, markerIdxMap);
      } else {
        newContent.text = currentPatchableText;
        __WEBPACK_IMPORTED_MODULE_9__diffUtils__["a" /* default */].restoreDiscussionOffsets(newContent, markerKeys);
        syncDiscussionMarkers(newContent, false);
      }
      __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].dispatch('content/patchCurrent', newContent);
      isChangePatch = false;
    });
    clEditor.on('focus', function () {
      return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('discussion/setNewCommentFocus', false);
    });
  },
  initClEditorInternal: function initClEditorInternal(opts) {
    var content = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters['content/current'];
    if (content) {
      removeDiscussionMarkers();
      var contentState = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters['contentState/current'];
      var options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
        selectionStart: contentState.selectionStart,
        selectionEnd: contentState.selectionEnd,
        patchHandler: {
          makePatches: makePatches,
          applyPatches: applyPatches,
          reversePatches: reversePatches
        }
      }, opts);

      if (contentId !== content.id) {
        contentId = content.id;
        currentPatchableText = __WEBPACK_IMPORTED_MODULE_9__diffUtils__["a" /* default */].makePatchableText(content, markerKeys, markerIdxMap);
        previousPatchableText = currentPatchableText;
        syncDiscussionMarkers(content, false);
        options.content = content.text;
      }

      clEditor.init(options);
    }
  },
  applyContent: function applyContent() {
    if (clEditor) {
      var content = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters['content/current'];
      if (clEditor.setContent(content.text, true).range) {
        removeDiscussionMarkers();
      } else {
        syncDiscussionMarkers(content, false);
      }
    }
  },
  getTrimmedSelection: function getTrimmedSelection() {
    var _clEditor = clEditor,
        selectionMgr = _clEditor.selectionMgr;

    var start = Math.min(selectionMgr.selectionStart, selectionMgr.selectionEnd);
    var end = Math.max(selectionMgr.selectionStart, selectionMgr.selectionEnd);
    var text = clEditor.getContent();
    while ((text[start] || '').match(/\s/)) {
      start += 1;
    }
    while ((text[end - 1] || '').match(/\s/)) {
      end -= 1;
    }
    return start < end && { start: start, end: end };
  },
  initHighlighters: function initHighlighters() {
    __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].watch(function () {
      return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters['discussion/newDiscussion'];
    }, function () {
      return syncDiscussionMarkers(__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters['content/current'], false);
    });

    __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].watch(function () {
      return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters['discussion/currentFileDiscussions'];
    }, function (discussions) {
      var classGetter = function classGetter(type, discussionId) {
        return function () {
          var classes = ['discussion-' + type + '-highlighting--' + discussionId, 'discussion-' + type + '-highlighting'];
          if (__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.discussion.currentDiscussionId === discussionId) {
            classes.push('discussion-' + type + '-highlighting--selected');
          }
          return classes;
        };
      };
      var offsetGetter = function offsetGetter(discussionId) {
        return function () {
          var startMarker = discussionMarkers[discussionId + ':start'];
          var endMarker = discussionMarkers[discussionId + ':end'];
          return startMarker && endMarker && {
            start: startMarker.offset,
            end: endMarker.offset
          };
        };
      };

      var oldEditorClassAppliers = editorClassAppliers;
      editorClassAppliers = {};
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(discussions).forEach(function (discussionId) {
        var classApplier = oldEditorClassAppliers[discussionId] || new __WEBPACK_IMPORTED_MODULE_11__components_common_EditorClassApplier__["a" /* default */](classGetter('editor', discussionId), offsetGetter(discussionId), { discussionId: discussionId });
        editorClassAppliers[discussionId] = classApplier;
      });

      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(oldEditorClassAppliers).forEach(function (_ref7) {
        var _ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
            discussionId = _ref8[0],
            classApplier = _ref8[1];

        if (!editorClassAppliers[discussionId]) {
          classApplier.stop();
        }
      });

      var oldPreviewClassAppliers = previewClassAppliers;
      previewClassAppliers = {};
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(discussions).forEach(function (discussionId) {
        var classApplier = oldPreviewClassAppliers[discussionId] || new __WEBPACK_IMPORTED_MODULE_12__components_common_PreviewClassApplier__["a" /* default */](classGetter('preview', discussionId), offsetGetter(discussionId), { discussionId: discussionId });
        previewClassAppliers[discussionId] = classApplier;
      });

      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(oldPreviewClassAppliers).forEach(function (_ref9) {
        var _ref10 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref9, 2),
            discussionId = _ref10[0],
            classApplier = _ref10[1];

        if (!previewClassAppliers[discussionId]) {
          classApplier.stop();
        }
      });
    });
  }
});

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_diff_match_patch__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_diff_match_patch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_diff_match_patch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cledit__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__animationSvc__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(2);





var diffMatchPatch = new __WEBPACK_IMPORTED_MODULE_0_diff_match_patch___default.a();

/* harmony default export */ __webpack_exports__["a"] = ({
  getScrollPosition: function getScrollPosition() {
    var elt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['layout/styles'].showEditor ? this.editorElt : this.previewElt;

    var dimensionKey = elt === this.editorElt ? 'editorDimension' : 'previewDimension';
    var scrollTop = elt.parentNode.scrollTop;

    var result = void 0;
    if (this.previewCtxMeasured) {
      this.previewCtxMeasured.sectionDescList.some(function (sectionDesc, sectionIdx) {
        if (scrollTop >= sectionDesc[dimensionKey].endOffset) {
          return false;
        }
        var posInSection = (scrollTop - sectionDesc[dimensionKey].startOffset) / (sectionDesc[dimensionKey].height || 1);
        result = {
          sectionIdx: sectionIdx,
          posInSection: posInSection
        };
        return true;
      });
    }
    return result;
  },
  restoreScrollPosition: function restoreScrollPosition() {
    var scrollPosition = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['contentState/current'].scrollPosition;

    if (scrollPosition && this.previewCtxMeasured) {
      var sectionDesc = this.previewCtxMeasured.sectionDescList[scrollPosition.sectionIdx];
      if (sectionDesc) {
        var editorScrollTop = sectionDesc.editorDimension.startOffset + sectionDesc.editorDimension.height * scrollPosition.posInSection;
        this.editorElt.parentNode.scrollTop = Math.floor(editorScrollTop);
        var previewScrollTop = sectionDesc.previewDimension.startOffset + sectionDesc.previewDimension.height * scrollPosition.posInSection;
        this.previewElt.parentNode.scrollTop = Math.floor(previewScrollTop);
      }
    }
  },
  getPreviewOffset: function getPreviewOffset(editorOffset) {
    var sectionDescList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (this.previewCtxWithDiffs || {}).sectionDescList;

    if (!sectionDescList) {
      return null;
    }
    var offset = editorOffset;
    var previewOffset = 0;
    sectionDescList.some(function (sectionDesc) {
      if (!sectionDesc.textToPreviewDiffs) {
        previewOffset = null;
        return true;
      }
      if (sectionDesc.section.text.length >= offset) {
        previewOffset += diffMatchPatch.diff_xIndex(sectionDesc.textToPreviewDiffs, offset);
        return true;
      }
      offset -= sectionDesc.section.text.length;
      previewOffset += sectionDesc.previewText.length;
      return false;
    });
    return previewOffset;
  },
  getEditorOffset: function getEditorOffset(previewOffset) {
    var sectionDescList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (this.previewCtxWithDiffs || {}).sectionDescList;

    if (!sectionDescList) {
      return null;
    }
    var offset = previewOffset;
    var editorOffset = 0;
    sectionDescList.some(function (sectionDesc) {
      if (!sectionDesc.textToPreviewDiffs) {
        editorOffset = null;
        return true;
      }
      if (sectionDesc.previewText.length >= offset) {
        var previewToTextDiffs = sectionDesc.textToPreviewDiffs.map(function (diff) {
          return [-diff[0], diff[1]];
        });
        editorOffset += diffMatchPatch.diff_xIndex(previewToTextDiffs, offset);
        return true;
      }
      offset -= sectionDesc.previewText.length;
      editorOffset += sectionDesc.section.text.length;
      return false;
    });
    return editorOffset;
  },
  getPreviewOffsetCoordinates: function getPreviewOffsetCoordinates(offset) {
    var start = __WEBPACK_IMPORTED_MODULE_1__cledit__["a" /* default */].Utils.findContainer(this.previewElt, offset && offset - 1);
    var end = __WEBPACK_IMPORTED_MODULE_1__cledit__["a" /* default */].Utils.findContainer(this.previewElt, offset || offset + 1);
    var range = document.createRange();
    range.setStart(start.container, start.offsetInContainer);
    range.setEnd(end.container, end.offsetInContainer);
    var rect = range.getBoundingClientRect();
    var contentRect = this.previewElt.getBoundingClientRect();
    return {
      top: Math.round(rect.top - contentRect.top + this.previewElt.scrollTop),
      height: Math.round(rect.height),
      left: Math.round(rect.right - contentRect.left + this.previewElt.scrollLeft)
    };
  },
  scrollToAnchor: function scrollToAnchor(anchor) {
    var scrollTop = 0;
    var scrollerElt = this.previewElt.parentNode;
    var elt = document.getElementById(anchor);
    if (elt) {
      scrollTop = elt.offsetTop;
    }
    var maxScrollTop = scrollerElt.scrollHeight - scrollerElt.offsetHeight;
    if (scrollTop < 0) {
      scrollTop = 0;
    } else if (scrollTop > maxScrollTop) {
      scrollTop = maxScrollTop;
    }
    __WEBPACK_IMPORTED_MODULE_2__animationSvc__["a" /* default */].animate(scrollerElt).scrollTop(scrollTop).duration(360).start();
  }
});

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var SectionDimension = function SectionDimension(startOffset, endOffset) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SectionDimension);

  this.startOffset = startOffset;
  this.endOffset = endOffset;
  this.height = endOffset - startOffset;
};

var dimensionNormalizer = function dimensionNormalizer(dimensionName) {
  return function (editorSvc) {
    var dimensionList = editorSvc.previewCtx.sectionDescList.map(function (sectionDesc) {
      return sectionDesc[dimensionName];
    });
    var dimension = void 0;
    var i = void 0;
    var j = void 0;
    for (i = 0; i < dimensionList.length; i += 1) {
      dimension = dimensionList[i];
      if (dimension.height) {
        for (j = i + 1; j < dimensionList.length && dimensionList[j].height === 0; j += 1) {}
        var normalizeFactor = j - i;
        if (normalizeFactor !== 1) {
          var normalizedHeight = dimension.height / normalizeFactor;
          dimension.height = normalizedHeight;
          dimension.endOffset = dimension.startOffset + dimension.height;
          for (j = i + 1; j < i + normalizeFactor; j += 1) {
            var startOffset = dimension.endOffset;
            dimension = dimensionList[j];
            dimension.startOffset = startOffset;
            dimension.height = normalizedHeight;
            dimension.endOffset = dimension.startOffset + dimension.height;
          }
          i = j - 1;
        }
      }
    }
  };
};

var normalizeEditorDimensions = dimensionNormalizer('editorDimension');
var normalizePreviewDimensions = dimensionNormalizer('previewDimension');
var normalizeTocDimensions = dimensionNormalizer('tocDimension');

/* harmony default export */ __webpack_exports__["a"] = ({
  measureSectionDimensions: function measureSectionDimensions(editorSvc) {
    var editorSectionOffset = 0;
    var previewSectionOffset = 0;
    var tocSectionOffset = 0;
    var sectionDesc = editorSvc.previewCtx.sectionDescList[0];
    var nextSectionDesc = void 0;
    var i = 1;
    for (; i < editorSvc.previewCtx.sectionDescList.length; i += 1) {
      nextSectionDesc = editorSvc.previewCtx.sectionDescList[i];

      var newEditorSectionOffset = nextSectionDesc.editorElt ? nextSectionDesc.editorElt.offsetTop : editorSectionOffset;
      newEditorSectionOffset = newEditorSectionOffset > editorSectionOffset ? newEditorSectionOffset : editorSectionOffset;
      sectionDesc.editorDimension = new SectionDimension(editorSectionOffset, newEditorSectionOffset);
      editorSectionOffset = newEditorSectionOffset;

      var newPreviewSectionOffset = nextSectionDesc.previewElt ? nextSectionDesc.previewElt.offsetTop : previewSectionOffset;
      newPreviewSectionOffset = newPreviewSectionOffset > previewSectionOffset ? newPreviewSectionOffset : previewSectionOffset;
      sectionDesc.previewDimension = new SectionDimension(previewSectionOffset, newPreviewSectionOffset);
      previewSectionOffset = newPreviewSectionOffset;

      var newTocSectionOffset = nextSectionDesc.tocElt ? nextSectionDesc.tocElt.offsetTop + nextSectionDesc.tocElt.offsetHeight / 2 : tocSectionOffset;
      newTocSectionOffset = newTocSectionOffset > tocSectionOffset ? newTocSectionOffset : tocSectionOffset;
      sectionDesc.tocDimension = new SectionDimension(tocSectionOffset, newTocSectionOffset);
      tocSectionOffset = newTocSectionOffset;

      sectionDesc = nextSectionDesc;
    }

    sectionDesc = editorSvc.previewCtx.sectionDescList[i - 1];
    if (sectionDesc) {
      sectionDesc.editorDimension = new SectionDimension(editorSectionOffset, editorSvc.editorElt.scrollHeight);
      sectionDesc.previewDimension = new SectionDimension(previewSectionOffset, editorSvc.previewElt.scrollHeight);
      sectionDesc.tocDimension = new SectionDimension(tocSectionOffset, editorSvc.tocElt.scrollHeight);
    }

    normalizeEditorDimensions(editorSvc);
    normalizePreviewDimensions(editorSvc);
    normalizeTocDimensions(editorSvc);
  }
});

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editor_cledit__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editorSvc__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(2);




var Keystroke = __WEBPACK_IMPORTED_MODULE_0__editor_cledit__["a" /* default */].Keystroke;

var indentRegexp = /^ {0,3}>[ ]*|^[ \t]*[*+-][ \t](?:\[[ xX]\][ \t])?|^([ \t]*)\d+\.[ \t](?:\[[ xX]\][ \t])?|^\s+/;
var clearNewline = void 0;
var lastSelection = void 0;

function fixNumberedList(state, indent) {
  if (state.selection || indent === undefined || !__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters['data/computedSettings'].editor.listAutoNumber) {
    return;
  }
  var spaceIndent = indent.replace(/\t/g, '    ');
  var indentRegex = new RegExp('^[ \\s]*$|^' + spaceIndent + '(\\d+\\.[ \\t])?(( )?.*)$');

  function getHits(lines) {
    var hits = [];
    var pendingHits = [];

    function flush() {
      if (!pendingHits.hasHit && pendingHits.hasNoIndent) {
        return false;
      }
      hits = hits.concat(pendingHits);
      pendingHits = [];
      return true;
    }

    lines.some(function (line) {
      var match = line.replace(/^[ \t]*/, function (wholeMatch) {
        return wholeMatch.replace(/\t/g, '    ');
      }).match(indentRegex);
      if (!match || line.match(/^#+ /)) {
        flush();
        return true;
      }
      pendingHits.push({
        line: line,
        match: match
      });
      if (match[2] !== undefined) {
        if (match[1]) {
          pendingHits.hasHit = true;
        } else if (!match[3]) {
          pendingHits.hasNoIndent = true;
        }
      } else if (!flush()) {
        return true;
      }
      return false;
    });
    return hits;
  }

  function formatHits(hits) {
    var num = void 0;
    return hits.map(function (hit) {
      if (hit.match[1]) {
        if (!num) {
          num = parseInt(hit.match[1], 10);
        }
        var result = indent + num + hit.match[1].slice(-2) + hit.match[2];
        num += 1;
        return result;
      }
      return hit.line;
    });
  }

  var before = state.before.split('\n');
  before.unshift('');
  var after = state.after.split('\n');
  var currentLine = before.pop() || '';
  var currentPos = currentLine.length;
  currentLine += after.shift() || '';
  var lines = before.concat(currentLine).concat(after);
  var idx = before.length - getHits(before.slice().reverse()).length;
  while (idx <= before.length + 1) {
    var hits = formatHits(getHits(lines.slice(idx)));
    if (!hits.length) {
      idx += 1;
    } else {
      lines = lines.slice(0, idx).concat(hits).concat(lines.slice(idx + hits.length));
      idx += hits.length;
    }
  }
  currentLine = lines[before.length];
  state.before = lines.slice(1, before.length);
  state.before.push(currentLine.slice(0, currentPos));
  state.before = state.before.join('\n');
  state.after = [currentLine.slice(currentPos)].concat(lines.slice(before.length + 1));
  state.after = state.after.join('\n');
}

function enterKeyHandler(evt, state) {
  if (evt.which !== 13) {
    clearNewline = false;
    return false;
  }

  evt.preventDefault();

  var lastLf = state.before.lastIndexOf('\n') + 1;
  var lastLine = state.before.slice(lastLf);

  var indentMatch = lastLine.match(indentRegexp) || [''];
  if (clearNewline && !state.selection && state.before.length === lastSelection) {
    state.before = state.before.substring(0, lastLf);
    state.selection = '';
    clearNewline = false;
    fixNumberedList(state, indentMatch[1]);
    return true;
  }
  clearNewline = false;
  var indent = indentMatch[0];
  if (indent.length) {
    clearNewline = true;
  }

  __WEBPACK_IMPORTED_MODULE_1__editorSvc__["a" /* default */].clEditor.undoMgr.setCurrentMode('single');

  state.before += '\n' + indent;
  state.selection = '';
  lastSelection = state.before.length;
  fixNumberedList(state, indentMatch[1]);
  return true;
}

function tabKeyHandler(evt, state) {
  if (evt.which !== 9 || evt.metaKey || evt.ctrlKey) {
    return false;
  }

  var strSplice = function strSplice(str, i, remove, add) {
    return str.slice(0, i) + (add || '') + str.slice(i + (+remove || 0));
  };

  evt.preventDefault();
  var isInverse = evt.shiftKey;
  var lastLf = state.before.lastIndexOf('\n') + 1;
  var lastLine = state.before.slice(lastLf);
  var currentLine = lastLine + state.selection + state.after;
  var indentMatch = currentLine.match(indentRegexp);
  if (isInverse) {
    var previousChar = state.before.slice(-1);
    if (/\s/.test(state.before.charAt(lastLf))) {
      state.before = strSplice(state.before, lastLf, 1);
      if (indentMatch) {
        fixNumberedList(state, indentMatch[1]);
        if (indentMatch[1]) {
          fixNumberedList(state, indentMatch[1].slice(1));
        }
      }
    }
    var selection = previousChar + state.selection;
    state.selection = selection.replace(/\n[ \t]/gm, '\n');
    if (previousChar) {
      state.selection = state.selection.slice(1);
    }
  } else if (state.selection || indentMatch && indentMatch[0].length >= lastLine.length) {
    state.before = strSplice(state.before, lastLf, 0, '\t');
    state.selection = state.selection.replace(/\n(?=.)/g, '\n\t');
    if (indentMatch) {
      fixNumberedList(state, indentMatch[1]);
      fixNumberedList(state, '\t' + indentMatch[1]);
    }
  } else {
    state.before += '\t';
  }
  return true;
}

__WEBPACK_IMPORTED_MODULE_1__editorSvc__["a" /* default */].$on('inited', function () {
  __WEBPACK_IMPORTED_MODULE_1__editorSvc__["a" /* default */].clEditor.addKeystroke(new Keystroke(enterKeyHandler, 50));
  __WEBPACK_IMPORTED_MODULE_1__editorSvc__["a" /* default */].clEditor.addKeystroke(new Keystroke(tabKeyHandler, 50));
});

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__animationSvc__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editorSvc__ = __webpack_require__(28);




var editorScrollerElt = void 0;
var previewScrollerElt = void 0;
var editorFinishTimeoutId = void 0;
var previewFinishTimeoutId = void 0;
var skipAnimation = void 0;
var isScrollEditor = void 0;
var isScrollPreview = void 0;
var isEditorMoving = void 0;
var isPreviewMoving = void 0;
var sectionDescList = [];

var throttleTimeoutId = void 0;
var throttleLastTime = 0;

function throttle(func, wait) {
  clearTimeout(throttleTimeoutId);
  var currentTime = Date.now();
  var localWait = wait + throttleLastTime - currentTime;
  if (localWait < 1) {
    throttleLastTime = currentTime;
    func();
  } else {
    throttleTimeoutId = setTimeout(function () {
      throttleLastTime = Date.now();
      func();
    }, localWait);
  }
}

var doScrollSync = function doScrollSync() {
  var localSkipAnimation = skipAnimation || !__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters['layout/styles'].showSidePreview;
  skipAnimation = false;
  if (!__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters['data/layoutSettings'].scrollSync || sectionDescList.length === 0) {
    return;
  }
  var editorScrollTop = editorScrollerElt.scrollTop;
  if (editorScrollTop < 0) {
    editorScrollTop = 0;
  }
  var previewScrollTop = previewScrollerElt.scrollTop;
  var scrollTo = void 0;
  if (isScrollEditor) {
    isScrollEditor = false;
    sectionDescList.some(function (sectionDesc) {
      if (editorScrollTop > sectionDesc.editorDimension.endOffset) {
        return false;
      }
      var posInSection = (editorScrollTop - sectionDesc.editorDimension.startOffset) / (sectionDesc.editorDimension.height || 1);
      scrollTo = sectionDesc.previewDimension.startOffset + sectionDesc.previewDimension.height * posInSection;
      return true;
    });
    scrollTo = Math.min(scrollTo, previewScrollerElt.scrollHeight - previewScrollerElt.offsetHeight);

    throttle(function () {
      clearTimeout(previewFinishTimeoutId);
      __WEBPACK_IMPORTED_MODULE_1__animationSvc__["a" /* default */].animate(previewScrollerElt).scrollTop(scrollTo).duration(!localSkipAnimation && 100).start(function () {
        previewFinishTimeoutId = setTimeout(function () {
          isPreviewMoving = false;
        }, 100);
      }, function () {
        isPreviewMoving = true;
      });
    }, localSkipAnimation ? 500 : 50);
  } else if (!__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters['layout/styles'].showEditor || isScrollPreview) {
    isScrollPreview = false;
    sectionDescList.some(function (sectionDesc) {
      if (previewScrollTop > sectionDesc.previewDimension.endOffset) {
        return false;
      }
      var posInSection = (previewScrollTop - sectionDesc.previewDimension.startOffset) / (sectionDesc.previewDimension.height || 1);
      scrollTo = sectionDesc.editorDimension.startOffset + sectionDesc.editorDimension.height * posInSection;
      return true;
    });
    scrollTo = Math.min(scrollTo, editorScrollerElt.scrollHeight - editorScrollerElt.offsetHeight);

    throttle(function () {
      clearTimeout(editorFinishTimeoutId);
      __WEBPACK_IMPORTED_MODULE_1__animationSvc__["a" /* default */].animate(editorScrollerElt).scrollTop(scrollTo).duration(!localSkipAnimation && 100).start(function () {
        editorFinishTimeoutId = setTimeout(function () {
          isEditorMoving = false;
        }, 100);
      }, function () {
        isEditorMoving = true;
      });
    }, localSkipAnimation ? 500 : 50);
  }
};

var isPreviewRefreshing = void 0;
var timeoutId = void 0;

var forceScrollSync = function forceScrollSync() {
  if (!isPreviewRefreshing) {
    doScrollSync();
  }
};
__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].watch(function () {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters['data/layoutSettings'].scrollSync;
}, forceScrollSync);

__WEBPACK_IMPORTED_MODULE_2__editorSvc__["a" /* default */].$on('inited', function () {
  editorScrollerElt = __WEBPACK_IMPORTED_MODULE_2__editorSvc__["a" /* default */].editorElt.parentNode;
  previewScrollerElt = __WEBPACK_IMPORTED_MODULE_2__editorSvc__["a" /* default */].previewElt.parentNode;

  editorScrollerElt.addEventListener('scroll', function () {
    if (isEditorMoving) {
      return;
    }
    isScrollEditor = true;
    isScrollPreview = false;
    doScrollSync();
  });

  previewScrollerElt.addEventListener('scroll', function () {
    if (isPreviewMoving || isPreviewRefreshing) {
      return;
    }
    isScrollPreview = true;
    isScrollEditor = false;
    doScrollSync();
  });
});

__WEBPACK_IMPORTED_MODULE_2__editorSvc__["a" /* default */].$on('sectionList', function () {
  clearTimeout(timeoutId);
  isPreviewRefreshing = true;
  sectionDescList = [];
});

__WEBPACK_IMPORTED_MODULE_2__editorSvc__["a" /* default */].$on('previewCtx', function () {
  isScrollEditor = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters['layout/styles'].showEditor;

  timeoutId = setTimeout(function () {
    isPreviewRefreshing = false;
  }, 100);
});

__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].watch(function () {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters['layout/styles'].showEditor;
}, function (showEditor) {
  isScrollEditor = showEditor;
  isScrollPreview = !showEditor;
  skipAnimation = true;
});

__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].watch(function () {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters['file/current'].id;
}, function () {
  skipAnimation = true;
});

__WEBPACK_IMPORTED_MODULE_2__editorSvc__["a" /* default */].$on('previewCtxMeasured', function (previewCtxMeasured) {
  if (previewCtxMeasured) {
    sectionDescList = previewCtxMeasured.sectionDescList;

    forceScrollSync();
  }
});

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mousetrap__ = __webpack_require__(2197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mousetrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mousetrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_syncSvc__ = __webpack_require__(105);







__WEBPACK_IMPORTED_MODULE_2_mousetrap___default.a.prototype.stopCallback = function () {
  return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['modal/config'] || !__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['content/isCurrentEditable'];
};

var pagedownHandler = function pagedownHandler(name) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].pagedownEditor.uiManager.doClick(name);
    return true;
  };
};

var findReplaceOpener = function findReplaceOpener(type) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('findReplace/open', {
      type: type,
      findText: __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].clEditor.selectionMgr.hasFocus() && __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].clEditor.selectionMgr.getSelectedText()
    });
    return true;
  };
};

var methods = {
  bold: pagedownHandler('bold'),
  italic: pagedownHandler('italic'),
  strikethrough: pagedownHandler('strikethrough'),
  link: pagedownHandler('link'),
  quote: pagedownHandler('quote'),
  code: pagedownHandler('code'),
  image: pagedownHandler('image'),
  olist: pagedownHandler('olist'),
  ulist: pagedownHandler('ulist'),
  clist: pagedownHandler('clist'),
  heading: pagedownHandler('heading'),
  hr: pagedownHandler('hr'),
  sync: function sync() {
    if (__WEBPACK_IMPORTED_MODULE_5__services_syncSvc__["a" /* default */].isSyncPossible()) {
      __WEBPACK_IMPORTED_MODULE_5__services_syncSvc__["a" /* default */].requestSync();
    }
    return true;
  },

  find: findReplaceOpener('find'),
  replace: findReplaceOpener('replace'),
  expand: function expand(param1, param2) {
    var text = '' + (param1 || '');
    var replacement = '' + (param2 || '');
    if (text && replacement) {
      setTimeout(function () {
        var selectionMgr = __WEBPACK_IMPORTED_MODULE_4__services_editorSvc__["a" /* default */].clEditor.selectionMgr;

        var offset = selectionMgr.selectionStart;
        if (offset === selectionMgr.selectionEnd) {
          var range = selectionMgr.createRange(offset - text.length, offset);
          if ('' + range === text) {
            range.deleteContents();
            range.insertNode(document.createTextNode(replacement));
            offset = offset - text.length + replacement.length;
            selectionMgr.setSelectionStartEnd(offset, offset);
            selectionMgr.updateCursorCoordinates(true);
          }
        }
      }, 1);
    }
  }
};

__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].watch(function () {
  return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['data/computedSettings'];
}, function (computedSettings) {
  __WEBPACK_IMPORTED_MODULE_2_mousetrap___default.a.reset();

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(computedSettings.shortcuts).forEach(function (_ref) {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
        key = _ref2[0],
        shortcut = _ref2[1];

    if (shortcut) {
      var method = '' + (shortcut.method || shortcut);
      var params = shortcut.params || [];
      if (!Array.isArray(params)) {
        params = [params];
      }
      if (Object.prototype.hasOwnProperty.call(methods, method)) {
        try {
          __WEBPACK_IMPORTED_MODULE_2_mousetrap___default.a.bind('' + key, function () {
            return !methods[method].apply(null, params);
          });
        } catch (e) {}
      }
    }
  });
}, {
  immediate: true
});

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editorSvc__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(2);



__WEBPACK_IMPORTED_MODULE_0__editorSvc__["a" /* default */].$on('inited', function () {
  var getPreviewOffset = function getPreviewOffset(elt) {
    var offset = 0;
    if (!elt || elt === __WEBPACK_IMPORTED_MODULE_0__editorSvc__["a" /* default */].previewElt) {
      return offset;
    }
    var previousSibling = elt.previousSibling;

    while (previousSibling) {
      offset += previousSibling.textContent.length;
      var _previousSibling = previousSibling;
      previousSibling = _previousSibling.previousSibling;
    }
    return offset + getPreviewOffset(elt.parentNode);
  };

  __WEBPACK_IMPORTED_MODULE_0__editorSvc__["a" /* default */].previewElt.addEventListener('click', function (evt) {
    if (evt.target.classList.contains('task-list-item-checkbox')) {
      evt.preventDefault();
      if (__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['content/isCurrentEditable']) {
        var editorContent = __WEBPACK_IMPORTED_MODULE_0__editorSvc__["a" /* default */].clEditor.getContent();

        setTimeout(function () {
          if (editorContent === __WEBPACK_IMPORTED_MODULE_0__editorSvc__["a" /* default */].clEditor.getContent()) {
            var previewOffset = getPreviewOffset(evt.target);
            var endOffset = __WEBPACK_IMPORTED_MODULE_0__editorSvc__["a" /* default */].getEditorOffset(previewOffset + 1);
            if (endOffset != null) {
              var startOffset = editorContent.lastIndexOf('\n', endOffset) + 1;
              var line = editorContent.slice(startOffset, endOffset);
              var match = line.match(/^([ \t]*(?:[*+-]|\d+\.)[ \t]+\[)[ xX](\] .*)/);
              if (match) {
                var newContent = editorContent.slice(0, startOffset);
                newContent += match[1];
                newContent += evt.target.checked ? ' ' : 'x';
                newContent += match[2];
                newContent += editorContent.slice(endOffset);
                __WEBPACK_IMPORTED_MODULE_0__editorSvc__["a" /* default */].clEditor.setContent(newContent, true);
              }
            }
          }
        }, 10);
      }
    }
  });
});

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_googleHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Provider__ = __webpack_require__(39);







/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */]({
  id: 'bloggerPage',
  name: 'Blogger Page',
  getToken: function getToken(_ref) {
    var sub = _ref.sub;

    var token = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['data/googleTokensBySub'][sub];
    return token && token.isBlogger ? token : null;
  },
  getLocationUrl: function getLocationUrl(_ref2) {
    var blogId = _ref2.blogId,
        pageId = _ref2.pageId;

    return 'https://www.blogger.com/blogger.g?blogID=' + blogId + '#editor/target=page;pageID=' + pageId;
  },
  getLocationDescription: function getLocationDescription(_ref3) {
    var pageId = _ref3.pageId;

    return pageId;
  },
  publish: function publish(token, html, metadata, publishLocation) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var page;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_googleHelper__["a" /* default */].uploadBlogger({
                token: token,
                blogUrl: publishLocation.blogUrl,
                blogId: publishLocation.blogId,
                postId: publishLocation.pageId,
                title: metadata.title,
                content: html,
                isPage: true
              });

            case 2:
              page = _context.sent;
              return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, publishLocation, {
                blogId: page.blog.id,
                pageId: page.id
              }));

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  makeLocation: function makeLocation(token, blogUrl, pageId) {
    var location = {
      providerId: this.id,
      sub: token.sub,
      blogUrl: blogUrl
    };
    if (pageId) {
      location.pageId = pageId;
    }
    return location;
  }
}));

/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_googleHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Provider__ = __webpack_require__(39);







/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */]({
  id: 'blogger',
  name: 'Blogger',
  getToken: function getToken(_ref) {
    var sub = _ref.sub;

    var token = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['data/googleTokensBySub'][sub];
    return token && token.isBlogger ? token : null;
  },
  getLocationUrl: function getLocationUrl(_ref2) {
    var blogId = _ref2.blogId,
        postId = _ref2.postId;

    return 'https://www.blogger.com/blogger.g?blogID=' + blogId + '#editor/target=post;postID=' + postId;
  },
  getLocationDescription: function getLocationDescription(_ref3) {
    var postId = _ref3.postId;

    return postId;
  },
  publish: function publish(token, html, metadata, publishLocation) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var post;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_googleHelper__["a" /* default */].uploadBlogger(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, publishLocation, {
                token: token,
                title: metadata.title,
                content: html,
                labels: metadata.tags,
                isDraft: metadata.status === 'draft',
                published: metadata.date
              }));

            case 2:
              post = _context.sent;
              return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, publishLocation, {
                blogId: post.blog.id,
                postId: post.id
              }));

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  makeLocation: function makeLocation(token, blogUrl, postId) {
    var location = {
      providerId: this.id,
      sub: token.sub,
      blogUrl: blogUrl
    };
    if (postId) {
      location.postId = postId;
    }
    return location;
  }
}));

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_couchdbHelper__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Provider__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__badgeSvc__ = __webpack_require__(11);











var syncLastSeq = void 0;

/* unused harmony default export */ var _unused_webpack_default_export = (new __WEBPACK_IMPORTED_MODULE_7__common_Provider__["a" /* default */]({
  id: 'couchdbWorkspace',
  name: 'CouchDB',
  getToken: function getToken() {
    return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/syncToken'];
  },
  getWorkspaceParams: function getWorkspaceParams(_ref) {
    var dbUrl = _ref.dbUrl;

    return {
      providerId: this.id,
      dbUrl: dbUrl
    };
  },
  getWorkspaceLocationUrl: function getWorkspaceLocationUrl(_ref2) {
    var dbUrl = _ref2.dbUrl;

    return dbUrl;
  },
  getSyncDataUrl: function getSyncDataUrl(fileSyncData, _ref3) {
    var id = _ref3.id;

    var _getToken = this.getToken(),
        dbUrl = _getToken.dbUrl;

    return dbUrl + '/' + id + '/data';
  },
  getSyncDataDescription: function getSyncDataDescription(fileSyncData, _ref4) {
    var id = _ref4.id;

    return id;
  },
  initWorkspace: function initWorkspace() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      var dbUrl, workspaceParams, workspaceId, db;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dbUrl = (__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].queryParams.dbUrl || '').replace(/\/?$/, '');
              workspaceParams = _this.getWorkspaceParams({ dbUrl: dbUrl });
              workspaceId = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].makeWorkspaceId(workspaceParams);

              if (!__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['data/couchdbTokensBySub'][workspaceId]) {
                __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('data/addCouchdbToken', {
                  sub: workspaceId,
                  dbUrl: dbUrl
                });
              }

              if (__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/workspacesById'][workspaceId]) {
                _context.next = 15;
                break;
              }

              _context.prev = 5;
              _context.next = 8;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_couchdbHelper__["a" /* default */].getDb(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['data/couchdbTokensBySub'][workspaceId]);

            case 8:
              db = _context.sent;

              __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('workspace/patchWorkspacesById', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, workspaceId, {
                id: workspaceId,
                name: db.db_name,
                providerId: _this.id,
                dbUrl: dbUrl
              }));
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context['catch'](5);
              throw new Error(dbUrl + ' is not accessible. Make sure you have the proper permissions.');

            case 15:

              __WEBPACK_IMPORTED_MODULE_9__badgeSvc__["a" /* default */].addBadge('addCouchdbWorkspace');
              return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/workspacesById'][workspaceId]);

            case 17:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[5, 12]]);
    }))();
  },
  getChanges: function getChanges() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var syncToken, lastSeq, result, changes;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              syncToken = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/syncToken'];
              lastSeq = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['data/localSettings'].syncLastSeq;
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_couchdbHelper__["a" /* default */].getChanges(syncToken, lastSeq);

            case 4:
              result = _context2.sent;
              changes = result.changes.filter(function (change) {
                if (!change.deleted && change.doc) {
                  change.item = change.doc.item;
                  if (!change.item || !change.item.id || !change.item.type) {
                    return false;
                  }

                  change.syncData = {
                    id: change.id,
                    itemId: change.item.id,
                    type: change.item.type,
                    hash: change.item.hash,
                    rev: change.doc._rev };
                }
                change.syncDataId = change.id;
                return true;
              });

              syncLastSeq = result.lastSeq;
              return _context2.abrupt('return', changes);

            case 8:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  onChangesApplied: function onChangesApplied() {
    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('data/patchLocalSettings', {
      syncLastSeq: syncLastSeq
    });
  },
  saveWorkspaceItem: function saveWorkspaceItem(_ref5) {
    var _this3 = this;

    var item = _ref5.item,
        syncData = _ref5.syncData;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var syncToken, _ref6, id, rev;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              syncToken = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/syncToken'];
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_couchdbHelper__["a" /* default */].uploadDocument({
                token: syncToken,
                item: item,
                documentId: syncData && syncData.id,
                rev: syncData && syncData.rev
              });

            case 3:
              _ref6 = _context3.sent;
              id = _ref6.id;
              rev = _ref6.rev;
              return _context3.abrupt('return', {
                syncData: {
                  id: id,
                  itemId: item.id,
                  type: item.type,
                  hash: item.hash,
                  rev: rev
                }
              });

            case 7:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  removeWorkspaceItem: function removeWorkspaceItem(_ref7) {
    var syncData = _ref7.syncData;

    var syncToken = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/syncToken'];
    return __WEBPACK_IMPORTED_MODULE_6__helpers_couchdbHelper__["a" /* default */].removeDocument(syncToken, syncData.id, syncData.rev);
  },
  downloadWorkspaceContent: function downloadWorkspaceContent(_ref8) {
    var _this4 = this;

    var token = _ref8.token,
        contentSyncData = _ref8.contentSyncData;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var body, rev, content;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_couchdbHelper__["a" /* default */].retrieveDocumentWithAttachments(token, contentSyncData.id);

            case 2:
              body = _context4.sent;
              rev = body._rev;
              content = __WEBPACK_IMPORTED_MODULE_7__common_Provider__["a" /* default */].parseContent(body.attachments.data, body.item.id);
              return _context4.abrupt('return', {
                content: content,
                contentSyncData: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, contentSyncData, {
                  hash: content.hash,
                  rev: rev
                })
              });

            case 6:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  downloadWorkspaceData: function downloadWorkspaceData(_ref9) {
    var _this5 = this;

    var token = _ref9.token,
        syncData = _ref9.syncData;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var body, item, rev;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (syncData) {
                _context5.next = 2;
                break;
              }

              return _context5.abrupt('return', {});

            case 2:
              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_couchdbHelper__["a" /* default */].retrieveDocumentWithAttachments(token, syncData.id);

            case 4:
              body = _context5.sent;
              item = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].addItemHash(JSON.parse(body.attachments.data));
              rev = body._rev;
              return _context5.abrupt('return', {
                item: item,
                syncData: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, syncData, {
                  hash: item.hash,
                  rev: rev
                })
              });

            case 8:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  uploadWorkspaceContent: function uploadWorkspaceContent(_ref10) {
    var _this6 = this;

    var token = _ref10.token,
        content = _ref10.content,
        contentSyncData = _ref10.contentSyncData;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_couchdbHelper__["a" /* default */].uploadDocument({
                token: token,
                item: {
                  id: content.id,
                  type: content.type,
                  hash: content.hash
                },
                data: __WEBPACK_IMPORTED_MODULE_7__common_Provider__["a" /* default */].serializeContent(content),
                dataType: 'text/plain',
                documentId: contentSyncData && contentSyncData.id,
                rev: contentSyncData && contentSyncData.rev
              });

            case 2:
              res = _context6.sent;
              return _context6.abrupt('return', {
                contentSyncData: {
                  id: res.id,
                  itemId: content.id,
                  type: content.type,
                  hash: content.hash,
                  rev: res.rev
                }
              });

            case 4:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  uploadWorkspaceData: function uploadWorkspaceData(_ref11) {
    var _this7 = this;

    var token = _ref11.token,
        item = _ref11.item,
        syncData = _ref11.syncData;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_couchdbHelper__["a" /* default */].uploadDocument({
                token: token,
                item: {
                  id: item.id,
                  type: item.type,
                  hash: item.hash
                },
                data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item),
                dataType: 'application/json',
                documentId: syncData && syncData.id,
                rev: syncData && syncData.rev
              });

            case 2:
              res = _context7.sent;
              return _context7.abrupt('return', {
                syncData: {
                  id: res.id,
                  itemId: item.id,
                  type: item.type,
                  hash: item.hash,
                  rev: res.rev
                }
              });

            case 4:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  listFileRevisions: function listFileRevisions(_ref12) {
    var _this8 = this;

    var token = _ref12.token,
        contentSyncDataId = _ref12.contentSyncDataId;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var body, revisions;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_couchdbHelper__["a" /* default */].retrieveDocumentWithRevisions(token, contentSyncDataId);

            case 2:
              body = _context8.sent;
              revisions = [];

              body._revs_info.forEach(function (revInfo, idx) {
                if (revInfo.status === 'available') {
                  revisions.push({
                    id: revInfo.rev,
                    sub: null,
                    created: idx,
                    loaded: false
                  });
                }
              });
              return _context8.abrupt('return', revisions);

            case 6:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  loadFileRevision: function loadFileRevision(_ref13) {
    var _this9 = this;

    var token = _ref13.token,
        contentSyncDataId = _ref13.contentSyncDataId,
        revision = _ref13.revision;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9() {
      var body;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              if (!revision.loaded) {
                _context9.next = 2;
                break;
              }

              return _context9.abrupt('return', false);

            case 2:
              _context9.next = 4;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_couchdbHelper__["a" /* default */].retrieveDocument(token, contentSyncDataId, revision.id);

            case 4:
              body = _context9.sent;

              revision.sub = body.sub;
              revision.created = body.time;
              revision.loaded = true;
              return _context9.abrupt('return', true);

            case 9:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  getFileRevisionContent: function getFileRevisionContent(_ref14) {
    var _this10 = this;

    var token = _ref14.token,
        contentSyncDataId = _ref14.contentSyncDataId,
        revisionId = _ref14.revisionId;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10() {
      var body;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_couchdbHelper__["a" /* default */].retrieveDocumentWithAttachments(token, contentSyncDataId, revisionId);

            case 2:
              body = _context10.sent;
              return _context10.abrupt('return', __WEBPACK_IMPORTED_MODULE_7__common_Provider__["a" /* default */].parseContent(body.attachments.data, body.item.id));

            case 4:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  }
}));

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_githubHelper__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Provider__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__userSvc__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__gitWorkspaceSvc__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__badgeSvc__ = __webpack_require__(11);













var getAbsolutePath = function getAbsolutePath(_ref) {
  var id = _ref.id;
  return '' + (__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspace'].path || '') + id;
};

/* unused harmony default export */ var _unused_webpack_default_export = (new __WEBPACK_IMPORTED_MODULE_7__common_Provider__["a" /* default */]({
  id: 'githubWorkspace',
  name: 'GitHub',
  getToken: function getToken() {
    return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/syncToken'];
  },
  getWorkspaceParams: function getWorkspaceParams(_ref2) {
    var owner = _ref2.owner,
        repo = _ref2.repo,
        branch = _ref2.branch,
        path = _ref2.path;

    return {
      providerId: this.id,
      owner: owner,
      repo: repo,
      branch: branch,
      path: path
    };
  },
  getWorkspaceLocationUrl: function getWorkspaceLocationUrl(_ref3) {
    var owner = _ref3.owner,
        repo = _ref3.repo,
        branch = _ref3.branch,
        path = _ref3.path;

    return 'https://github.com/' + encodeURIComponent(owner) + '/' + encodeURIComponent(repo) + '/tree/' + encodeURIComponent(branch) + '/' + __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].encodeUrlPath(path);
  },
  getSyncDataUrl: function getSyncDataUrl(_ref4) {
    var id = _ref4.id;
    var _store$getters$worksp = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspace'],
        owner = _store$getters$worksp.owner,
        repo = _store$getters$worksp.repo,
        branch = _store$getters$worksp.branch;

    return 'https://github.com/' + encodeURIComponent(owner) + '/' + encodeURIComponent(repo) + '/tree/' + encodeURIComponent(branch) + '/' + __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].encodeUrlPath(getAbsolutePath({ id: id }));
  },
  getSyncDataDescription: function getSyncDataDescription(_ref5) {
    var id = _ref5.id;

    return getAbsolutePath({ id: id });
  },
  initWorkspace: function initWorkspace() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _utils$queryParams, owner, repo, branch, workspaceParams, path, workspaceId, workspace, token, pathEntries, name;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _utils$queryParams = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].queryParams, owner = _utils$queryParams.owner, repo = _utils$queryParams.repo, branch = _utils$queryParams.branch;
              workspaceParams = _this.getWorkspaceParams({ owner: owner, repo: repo, branch: branch });

              if (!branch) {
                workspaceParams.branch = 'master';
              }

              path = (__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].queryParams.path || '').trim().replace(/^\/*/, '').replace(/\/*$/, '/');

              if (path !== '/') {
                workspaceParams.path = path;
              }

              workspaceId = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].makeWorkspaceId(workspaceParams);
              workspace = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/workspacesById'][workspaceId];
              token = void 0;

              if (workspace) {
                token = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['data/githubTokensBySub'][workspace.sub];
              }

              if (token) {
                _context.next = 15;
                break;
              }

              _context.next = 12;
              return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('modal/open', { type: 'githubAccount' });

            case 12:
              _context.next = 14;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_githubHelper__["a" /* default */].addAccount(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['data/localSettings'].githubRepoFullAccess);

            case 14:
              token = _context.sent;

            case 15:

              if (!workspace) {
                pathEntries = (path || '').split('/');
                name = pathEntries[pathEntries.length - 2] || repo;

                __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('workspace/patchWorkspacesById', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, workspaceId, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, workspaceParams, {
                  id: workspaceId,
                  sub: token.sub,
                  name: name
                })));
              }

              __WEBPACK_IMPORTED_MODULE_11__badgeSvc__["a" /* default */].addBadge('addGithubWorkspace');
              return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/workspacesById'][workspaceId]);

            case 18:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getChanges: function getChanges() {
    return __WEBPACK_IMPORTED_MODULE_6__helpers_githubHelper__["a" /* default */].getTree(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspace'], {
      token: this.getToken()
    }));
  },
  prepareChanges: function prepareChanges(tree) {
    return __WEBPACK_IMPORTED_MODULE_10__gitWorkspaceSvc__["a" /* default */].makeChanges(tree);
  },
  saveWorkspaceItem: function saveWorkspaceItem(_ref6) {
    var _this2 = this;

    var item = _ref6.item;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var syncData, syncToken;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              syncData = {
                id: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.gitPathsByItemId[item.id],
                type: item.type,
                hash: item.hash
              };

              if (!(item.type === 'file' || item.type === 'folder')) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt('return', { syncData: syncData });

            case 3:
              syncToken = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/syncToken'];
              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_githubHelper__["a" /* default */].uploadFile(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspace'], {
                token: syncToken,
                path: getAbsolutePath(syncData),
                content: '',
                sha: __WEBPACK_IMPORTED_MODULE_10__gitWorkspaceSvc__["a" /* default */].shaByPath[syncData.id]
              }));

            case 6:
              return _context2.abrupt('return', { syncData: syncData });

            case 7:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  removeWorkspaceItem: function removeWorkspaceItem(_ref7) {
    var _this3 = this;

    var syncData = _ref7.syncData;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var syncToken;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!__WEBPACK_IMPORTED_MODULE_10__gitWorkspaceSvc__["a" /* default */].shaByPath[syncData.id]) {
                _context3.next = 4;
                break;
              }

              syncToken = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/syncToken'];
              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_githubHelper__["a" /* default */].removeFile(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspace'], {
                token: syncToken,
                path: getAbsolutePath(syncData),
                sha: __WEBPACK_IMPORTED_MODULE_10__gitWorkspaceSvc__["a" /* default */].shaByPath[syncData.id]
              }));

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  downloadWorkspaceContent: function downloadWorkspaceContent(_ref8) {
    var _this4 = this;

    var token = _ref8.token,
        contentId = _ref8.contentId,
        contentSyncData = _ref8.contentSyncData,
        fileSyncData = _ref8.fileSyncData;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var _ref9, sha, data, content;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_githubHelper__["a" /* default */].downloadFile(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspace'], {
                token: token,
                path: getAbsolutePath(fileSyncData)
              }));

            case 2:
              _ref9 = _context4.sent;
              sha = _ref9.sha;
              data = _ref9.data;

              __WEBPACK_IMPORTED_MODULE_10__gitWorkspaceSvc__["a" /* default */].shaByPath[fileSyncData.id] = sha;
              content = __WEBPACK_IMPORTED_MODULE_7__common_Provider__["a" /* default */].parseContent(data, contentId);
              return _context4.abrupt('return', {
                content: content,
                contentSyncData: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, contentSyncData, {
                  hash: content.hash,
                  sha: sha
                })
              });

            case 8:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  downloadWorkspaceData: function downloadWorkspaceData(_ref10) {
    var _this5 = this;

    var token = _ref10.token,
        syncData = _ref10.syncData;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var _ref11, sha, data, item;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (syncData) {
                _context5.next = 2;
                break;
              }

              return _context5.abrupt('return', {});

            case 2:
              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_githubHelper__["a" /* default */].downloadFile(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspace'], {
                token: token,
                path: getAbsolutePath(syncData)
              }));

            case 4:
              _ref11 = _context5.sent;
              sha = _ref11.sha;
              data = _ref11.data;

              __WEBPACK_IMPORTED_MODULE_10__gitWorkspaceSvc__["a" /* default */].shaByPath[syncData.id] = sha;
              item = JSON.parse(data);
              return _context5.abrupt('return', {
                item: item,
                syncData: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, syncData, {
                  hash: item.hash,
                  sha: sha
                })
              });

            case 10:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  uploadWorkspaceContent: function uploadWorkspaceContent(_ref12) {
    var _this6 = this;

    var token = _ref12.token,
        content = _ref12.content,
        file = _ref12.file;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var path, absolutePath, res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              path = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.gitPathsByItemId[file.id];
              absolutePath = '' + (__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspace'].path || '') + path;
              _context6.next = 4;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_githubHelper__["a" /* default */].uploadFile(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspace'], {
                token: token,
                path: absolutePath,
                content: __WEBPACK_IMPORTED_MODULE_7__common_Provider__["a" /* default */].serializeContent(content),
                sha: __WEBPACK_IMPORTED_MODULE_10__gitWorkspaceSvc__["a" /* default */].shaByPath[path]
              }));

            case 4:
              res = _context6.sent;
              return _context6.abrupt('return', {
                contentSyncData: {
                  id: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.gitPathsByItemId[content.id],
                  type: content.type,
                  hash: content.hash,
                  sha: res.content.sha
                },
                fileSyncData: {
                  id: path,
                  type: 'file',
                  hash: file.hash
                }
              });

            case 6:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  uploadWorkspaceData: function uploadWorkspaceData(_ref13) {
    var _this7 = this;

    var token = _ref13.token,
        item = _ref13.item;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var path, syncData, res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              path = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.gitPathsByItemId[item.id];
              syncData = {
                id: path,
                type: item.type,
                hash: item.hash
              };
              _context7.next = 4;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_githubHelper__["a" /* default */].uploadFile(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspace'], {
                token: token,
                path: getAbsolutePath(syncData),
                content: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item),
                sha: __WEBPACK_IMPORTED_MODULE_10__gitWorkspaceSvc__["a" /* default */].shaByPath[path]
              }));

            case 4:
              res = _context7.sent;
              return _context7.abrupt('return', {
                syncData: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, syncData, {
                  sha: res.content.sha
                })
              });

            case 6:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  listFileRevisions: function listFileRevisions(_ref14) {
    var _this8 = this;

    var token = _ref14.token,
        fileSyncDataId = _ref14.fileSyncDataId;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var _store$getters$worksp2, owner, repo, branch, entries;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _store$getters$worksp2 = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspace'], owner = _store$getters$worksp2.owner, repo = _store$getters$worksp2.repo, branch = _store$getters$worksp2.branch;
              _context8.next = 3;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_githubHelper__["a" /* default */].getCommits({
                token: token,
                owner: owner,
                repo: repo,
                sha: branch,
                path: getAbsolutePath({ id: fileSyncDataId })
              });

            case 3:
              entries = _context8.sent;
              return _context8.abrupt('return', entries.map(function (_ref15) {
                var author = _ref15.author,
                    committer = _ref15.committer,
                    commit = _ref15.commit,
                    sha = _ref15.sha;

                var user = void 0;
                if (author && author.login) {
                  user = author;
                } else if (committer && committer.login) {
                  user = committer;
                }
                var sub = __WEBPACK_IMPORTED_MODULE_6__helpers_githubHelper__["a" /* default */].subPrefix + ':' + user.id;
                __WEBPACK_IMPORTED_MODULE_9__userSvc__["a" /* default */].addUserInfo({ id: sub, name: user.login, imageUrl: user.avatar_url });
                var date = commit.author && commit.author.date || commit.committer && commit.committer.date || 1;
                return {
                  id: sha,
                  sub: sub,
                  created: new Date(date).getTime()
                };
              }));

            case 5:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  loadFileRevision: function loadFileRevision() {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt('return', false);

            case 1:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  getFileRevisionContent: function getFileRevisionContent(_ref16) {
    var _this10 = this;

    var token = _ref16.token,
        contentId = _ref16.contentId,
        fileSyncDataId = _ref16.fileSyncDataId,
        revisionId = _ref16.revisionId;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
      var _ref17, data;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_githubHelper__["a" /* default */].downloadFile(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspace'], {
                token: token,
                branch: revisionId,
                path: getAbsolutePath({ id: fileSyncDataId })
              }));

            case 2:
              _ref17 = _context10.sent;
              data = _ref17.data;
              return _context10.abrupt('return', __WEBPACK_IMPORTED_MODULE_7__common_Provider__["a" /* default */].parseContent(data, contentId));

            case 5:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  }
}));

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_gitlabHelper__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Provider__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__userSvc__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__gitWorkspaceSvc__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__badgeSvc__ = __webpack_require__(11);













var getAbsolutePath = function getAbsolutePath(_ref) {
  var id = _ref.id;
  return '' + (__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspace'].path || '') + id;
};

/* unused harmony default export */ var _unused_webpack_default_export = (new __WEBPACK_IMPORTED_MODULE_7__common_Provider__["a" /* default */]({
  id: 'gitlabWorkspace',
  name: 'GitLab',
  getToken: function getToken() {
    return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/syncToken'];
  },
  getWorkspaceParams: function getWorkspaceParams(_ref2) {
    var serverUrl = _ref2.serverUrl,
        projectPath = _ref2.projectPath,
        branch = _ref2.branch,
        path = _ref2.path;

    return {
      providerId: this.id,
      serverUrl: serverUrl,
      projectPath: projectPath,
      branch: branch,
      path: path
    };
  },
  getWorkspaceLocationUrl: function getWorkspaceLocationUrl(_ref3) {
    var serverUrl = _ref3.serverUrl,
        projectPath = _ref3.projectPath,
        branch = _ref3.branch,
        path = _ref3.path;

    return serverUrl + '/' + projectPath + '/blob/' + encodeURIComponent(branch) + '/' + __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].encodeUrlPath(path);
  },
  getSyncDataUrl: function getSyncDataUrl(_ref4) {
    var id = _ref4.id;
    var _store$getters$worksp = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspace'],
        projectPath = _store$getters$worksp.projectPath,
        branch = _store$getters$worksp.branch;

    var _getToken = this.getToken(),
        serverUrl = _getToken.serverUrl;

    return serverUrl + '/' + projectPath + '/blob/' + encodeURIComponent(branch) + '/' + __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].encodeUrlPath(getAbsolutePath({ id: id }));
  },
  getSyncDataDescription: function getSyncDataDescription(_ref5) {
    var id = _ref5.id;

    return getAbsolutePath({ id: id });
  },
  initWorkspace: function initWorkspace() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _utils$queryParams, serverUrl, branch, workspaceParams, projectPath, path, workspaceId, workspace, sub, token, _ref6, applicationId, projectId, pathEntries, projectPathEntries, name;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _utils$queryParams = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].queryParams, serverUrl = _utils$queryParams.serverUrl, branch = _utils$queryParams.branch;
              workspaceParams = _this.getWorkspaceParams({ serverUrl: serverUrl, branch: branch });

              if (!branch) {
                workspaceParams.branch = 'master';
              }

              projectPath = (__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].queryParams.projectPath || '').trim().replace(/^\/*/, '').replace(/\/*$/, '');

              workspaceParams.projectPath = projectPath;

              path = (__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].queryParams.path || '').trim().replace(/^\/*/, '').replace(/\/*$/, '/');

              if (path !== '/') {
                workspaceParams.path = path;
              }

              workspaceId = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].makeWorkspaceId(workspaceParams);
              workspace = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/workspacesById'][workspaceId];
              sub = workspace ? workspace.sub : __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].queryParams.sub;
              token = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['data/gitlabTokensBySub'][sub];

              if (token) {
                _context.next = 19;
                break;
              }

              _context.next = 14;
              return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('modal/open', {
                type: 'gitlabAccount',
                forceServerUrl: serverUrl
              });

            case 14:
              _ref6 = _context.sent;
              applicationId = _ref6.applicationId;
              _context.next = 18;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_gitlabHelper__["a" /* default */].addAccount(serverUrl, applicationId, sub);

            case 18:
              token = _context.sent;

            case 19:
              if (workspace) {
                _context.next = 27;
                break;
              }

              _context.next = 22;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_gitlabHelper__["a" /* default */].getProjectId(token, workspaceParams);

            case 22:
              projectId = _context.sent;
              pathEntries = (path || '').split('/');
              projectPathEntries = (projectPath || '').split('/');
              name = pathEntries[pathEntries.length - 2] || projectPathEntries[projectPathEntries.length - 1];

              __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('workspace/patchWorkspacesById', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, workspaceId, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, workspaceParams, {
                projectId: projectId,
                id: workspaceId,
                sub: token.sub,
                name: name
              })));

            case 27:

              __WEBPACK_IMPORTED_MODULE_11__badgeSvc__["a" /* default */].addBadge('addGitlabWorkspace');
              return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/workspacesById'][workspaceId]);

            case 29:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getChanges: function getChanges() {
    return __WEBPACK_IMPORTED_MODULE_6__helpers_gitlabHelper__["a" /* default */].getTree(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspace'], {
      token: this.getToken()
    }));
  },
  prepareChanges: function prepareChanges(tree) {
    return __WEBPACK_IMPORTED_MODULE_10__gitWorkspaceSvc__["a" /* default */].makeChanges(tree.map(function (entry) {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, entry, {
        sha: entry.id
      });
    }));
  },
  saveWorkspaceItem: function saveWorkspaceItem(_ref7) {
    var _this2 = this;

    var item = _ref7.item;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var syncData, syncToken;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              syncData = {
                id: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.gitPathsByItemId[item.id],
                type: item.type,
                hash: item.hash
              };

              if (!(item.type === 'file' || item.type === 'folder')) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt('return', { syncData: syncData });

            case 3:
              syncToken = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/syncToken'];
              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_gitlabHelper__["a" /* default */].uploadFile(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspace'], {
                token: syncToken,
                path: getAbsolutePath(syncData),
                content: '',
                sha: __WEBPACK_IMPORTED_MODULE_10__gitWorkspaceSvc__["a" /* default */].shaByPath[syncData.id]
              }));

            case 6:
              return _context2.abrupt('return', { syncData: syncData });

            case 7:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  removeWorkspaceItem: function removeWorkspaceItem(_ref8) {
    var _this3 = this;

    var syncData = _ref8.syncData;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var syncToken;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!__WEBPACK_IMPORTED_MODULE_10__gitWorkspaceSvc__["a" /* default */].shaByPath[syncData.id]) {
                _context3.next = 4;
                break;
              }

              syncToken = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/syncToken'];
              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_gitlabHelper__["a" /* default */].removeFile(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspace'], {
                token: syncToken,
                path: getAbsolutePath(syncData),
                sha: __WEBPACK_IMPORTED_MODULE_10__gitWorkspaceSvc__["a" /* default */].shaByPath[syncData.id]
              }));

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  downloadWorkspaceContent: function downloadWorkspaceContent(_ref9) {
    var _this4 = this;

    var token = _ref9.token,
        contentId = _ref9.contentId,
        contentSyncData = _ref9.contentSyncData,
        fileSyncData = _ref9.fileSyncData;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var _ref10, sha, data, content;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_gitlabHelper__["a" /* default */].downloadFile(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspace'], {
                token: token,
                path: getAbsolutePath(fileSyncData)
              }));

            case 2:
              _ref10 = _context4.sent;
              sha = _ref10.sha;
              data = _ref10.data;

              __WEBPACK_IMPORTED_MODULE_10__gitWorkspaceSvc__["a" /* default */].shaByPath[fileSyncData.id] = sha;
              content = __WEBPACK_IMPORTED_MODULE_7__common_Provider__["a" /* default */].parseContent(data, contentId);
              return _context4.abrupt('return', {
                content: content,
                contentSyncData: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, contentSyncData, {
                  hash: content.hash,
                  sha: sha
                })
              });

            case 8:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  downloadWorkspaceData: function downloadWorkspaceData(_ref11) {
    var _this5 = this;

    var token = _ref11.token,
        syncData = _ref11.syncData;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var _ref12, sha, data, item;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (syncData) {
                _context5.next = 2;
                break;
              }

              return _context5.abrupt('return', {});

            case 2:
              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_gitlabHelper__["a" /* default */].downloadFile(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspace'], {
                token: token,
                path: getAbsolutePath(syncData)
              }));

            case 4:
              _ref12 = _context5.sent;
              sha = _ref12.sha;
              data = _ref12.data;

              __WEBPACK_IMPORTED_MODULE_10__gitWorkspaceSvc__["a" /* default */].shaByPath[syncData.id] = sha;
              item = JSON.parse(data);
              return _context5.abrupt('return', {
                item: item,
                syncData: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, syncData, {
                  hash: item.hash,
                  sha: sha
                })
              });

            case 10:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  uploadWorkspaceContent: function uploadWorkspaceContent(_ref13) {
    var _this6 = this;

    var token = _ref13.token,
        content = _ref13.content,
        file = _ref13.file;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var path, absolutePath, sha;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              path = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.gitPathsByItemId[file.id];
              absolutePath = '' + (__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspace'].path || '') + path;
              sha = __WEBPACK_IMPORTED_MODULE_10__gitWorkspaceSvc__["a" /* default */].shaByPath[path];
              _context6.next = 5;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_gitlabHelper__["a" /* default */].uploadFile(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspace'], {
                token: token,
                path: absolutePath,
                content: __WEBPACK_IMPORTED_MODULE_7__common_Provider__["a" /* default */].serializeContent(content),
                sha: sha
              }));

            case 5:
              return _context6.abrupt('return', {
                contentSyncData: {
                  id: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.gitPathsByItemId[content.id],
                  type: content.type,
                  hash: content.hash,
                  sha: sha
                },
                fileSyncData: {
                  id: path,
                  type: 'file',
                  hash: file.hash
                }
              });

            case 6:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  uploadWorkspaceData: function uploadWorkspaceData(_ref14) {
    var _this7 = this;

    var token = _ref14.token,
        item = _ref14.item;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var path, syncData, res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              path = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.gitPathsByItemId[item.id];
              syncData = {
                id: path,
                type: item.type,
                hash: item.hash
              };
              _context7.next = 4;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_gitlabHelper__["a" /* default */].uploadFile(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspace'], {
                token: token,
                path: getAbsolutePath(syncData),
                content: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item),
                sha: __WEBPACK_IMPORTED_MODULE_10__gitWorkspaceSvc__["a" /* default */].shaByPath[path]
              }));

            case 4:
              res = _context7.sent;
              return _context7.abrupt('return', {
                syncData: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, syncData, {
                  sha: res.content.sha
                })
              });

            case 6:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  listFileRevisions: function listFileRevisions(_ref15) {
    var _this8 = this;

    var token = _ref15.token,
        fileSyncDataId = _ref15.fileSyncDataId;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var _store$getters$worksp2, projectId, branch, entries;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _store$getters$worksp2 = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspace'], projectId = _store$getters$worksp2.projectId, branch = _store$getters$worksp2.branch;
              _context8.next = 3;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_gitlabHelper__["a" /* default */].getCommits({
                token: token,
                projectId: projectId,
                sha: branch,
                path: getAbsolutePath({ id: fileSyncDataId })
              });

            case 3:
              entries = _context8.sent;
              return _context8.abrupt('return', entries.map(function (entry) {
                var email = entry.author_email || entry.committer_email;
                var sub = __WEBPACK_IMPORTED_MODULE_6__helpers_gitlabHelper__["a" /* default */].subPrefix + ':' + token.serverUrl + '/' + email;
                __WEBPACK_IMPORTED_MODULE_9__userSvc__["a" /* default */].addUserInfo({
                  id: sub,
                  name: entry.author_name || entry.committer_name,
                  imageUrl: '' });
                var date = entry.authored_date || entry.committed_date || 1;
                return {
                  id: entry.id,
                  sub: sub,
                  created: date ? new Date(date).getTime() : 1
                };
              }));

            case 5:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  loadFileRevision: function loadFileRevision() {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt('return', false);

            case 1:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  getFileRevisionContent: function getFileRevisionContent(_ref16) {
    var _this10 = this;

    var token = _ref16.token,
        contentId = _ref16.contentId,
        fileSyncDataId = _ref16.fileSyncDataId,
        revisionId = _ref16.revisionId;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
      var _ref17, data;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return __WEBPACK_IMPORTED_MODULE_6__helpers_gitlabHelper__["a" /* default */].downloadFile(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['workspace/currentWorkspace'], {
                token: token,
                branch: revisionId,
                path: getAbsolutePath({ id: fileSyncDataId })
              }));

            case 2:
              _ref17 = _context10.sent;
              data = _ref17.data;
              return _context10.abrupt('return', __WEBPACK_IMPORTED_MODULE_7__common_Provider__["a" /* default */].parseContent(data, contentId));

            case 5:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  }
}));

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_googleHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Provider__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(4);









var syncStartPageToken = void 0;

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_6__common_Provider__["a" /* default */]({
  id: 'googleDriveAppData',
  name: 'Google Drive app data',
  getToken: function getToken() {
    return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['workspace/syncToken'];
  },
  getWorkspaceParams: function getWorkspaceParams() {
    return {};
  },
  getWorkspaceLocationUrl: function getWorkspaceLocationUrl() {
    return null;
  },
  getSyncDataUrl: function getSyncDataUrl() {
    return null;
  },
  getSyncDataDescription: function getSyncDataDescription(_ref) {
    var id = _ref.id;

    return id;
  },
  initWorkspace: function initWorkspace() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['workspace/workspacesById'].main);

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getChanges: function getChanges() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var syncToken, startPageToken, result, changes;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              syncToken = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['workspace/syncToken'];
              startPageToken = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['data/localSettings'].syncStartPageToken;
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5__helpers_googleHelper__["a" /* default */].getChanges(syncToken, startPageToken, true);

            case 4:
              result = _context2.sent;
              changes = result.changes.filter(function (change) {
                if (change.file) {
                  try {
                    change.item = JSON.parse(change.file.name);
                  } catch (e) {
                    return false;
                  }

                  change.syncData = {
                    id: change.fileId,
                    itemId: change.item.id,
                    type: change.item.type,
                    hash: change.item.hash
                  };
                }
                change.syncDataId = change.fileId;
                return true;
              });

              syncStartPageToken = result.startPageToken;
              return _context2.abrupt('return', changes);

            case 8:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  onChangesApplied: function onChangesApplied() {
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('data/patchLocalSettings', {
      syncStartPageToken: syncStartPageToken
    });
  },
  saveWorkspaceItem: function saveWorkspaceItem(_ref2) {
    var _this3 = this;

    var item = _ref2.item,
        syncData = _ref2.syncData,
        ifNotTooLate = _ref2.ifNotTooLate;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var syncToken, file;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              syncToken = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['workspace/syncToken'];
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_5__helpers_googleHelper__["a" /* default */].uploadAppDataFile({
                token: syncToken,
                name: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(item),
                fileId: syncData && syncData.id,
                ifNotTooLate: ifNotTooLate
              });

            case 3:
              file = _context3.sent;
              return _context3.abrupt('return', {
                syncData: {
                  id: file.id,
                  itemId: item.id,
                  type: item.type,
                  hash: item.hash
                }
              });

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  removeWorkspaceItem: function removeWorkspaceItem(_ref3) {
    var syncData = _ref3.syncData,
        ifNotTooLate = _ref3.ifNotTooLate;

    var syncToken = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['workspace/syncToken'];
    return __WEBPACK_IMPORTED_MODULE_5__helpers_googleHelper__["a" /* default */].removeAppDataFile(syncToken, syncData.id, ifNotTooLate);
  },
  downloadWorkspaceContent: function downloadWorkspaceContent(_ref4) {
    var _this4 = this;

    var token = _ref4.token,
        contentSyncData = _ref4.contentSyncData;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var data, content;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_5__helpers_googleHelper__["a" /* default */].downloadAppDataFile(token, contentSyncData.id);

            case 2:
              data = _context4.sent;
              content = __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].addItemHash(JSON.parse(data));
              return _context4.abrupt('return', {
                content: content,
                contentSyncData: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, contentSyncData, {
                  hash: content.hash
                })
              });

            case 5:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  downloadWorkspaceData: function downloadWorkspaceData(_ref5) {
    var _this5 = this;

    var token = _ref5.token,
        syncData = _ref5.syncData;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var data, item;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (syncData) {
                _context5.next = 2;
                break;
              }

              return _context5.abrupt('return', {});

            case 2:
              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5__helpers_googleHelper__["a" /* default */].downloadAppDataFile(token, syncData.id);

            case 4:
              data = _context5.sent;
              item = __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].addItemHash(JSON.parse(data));
              return _context5.abrupt('return', {
                item: item,
                syncData: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, syncData, {
                  hash: item.hash
                })
              });

            case 7:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  uploadWorkspaceContent: function uploadWorkspaceContent(_ref6) {
    var _this6 = this;

    var token = _ref6.token,
        content = _ref6.content,
        contentSyncData = _ref6.contentSyncData,
        ifNotTooLate = _ref6.ifNotTooLate;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var gdriveFile;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_5__helpers_googleHelper__["a" /* default */].uploadAppDataFile({
                token: token,
                name: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                  id: content.id,
                  type: content.type,
                  hash: content.hash
                }),
                media: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(content),
                fileId: contentSyncData && contentSyncData.id,
                ifNotTooLate: ifNotTooLate
              });

            case 2:
              gdriveFile = _context6.sent;
              return _context6.abrupt('return', {
                contentSyncData: {
                  id: gdriveFile.id,
                  itemId: content.id,
                  type: content.type,
                  hash: content.hash
                }
              });

            case 4:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  uploadWorkspaceData: function uploadWorkspaceData(_ref7) {
    var _this7 = this;

    var token = _ref7.token,
        item = _ref7.item,
        syncData = _ref7.syncData,
        ifNotTooLate = _ref7.ifNotTooLate;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var file;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_5__helpers_googleHelper__["a" /* default */].uploadAppDataFile({
                token: token,
                name: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                  id: item.id,
                  type: item.type,
                  hash: item.hash
                }),
                media: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(item),
                fileId: syncData && syncData.id,
                ifNotTooLate: ifNotTooLate
              });

            case 2:
              file = _context7.sent;
              return _context7.abrupt('return', {
                syncData: {
                  id: file.id,
                  itemId: item.id,
                  type: item.type,
                  hash: item.hash
                }
              });

            case 4:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  listFileRevisions: function listFileRevisions(_ref8) {
    var _this8 = this;

    var token = _ref8.token,
        contentSyncDataId = _ref8.contentSyncDataId;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var revisions;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __WEBPACK_IMPORTED_MODULE_5__helpers_googleHelper__["a" /* default */].getAppDataFileRevisions(token, contentSyncDataId);

            case 2:
              revisions = _context8.sent;
              return _context8.abrupt('return', revisions.map(function (revision) {
                return {
                  id: revision.id,
                  sub: __WEBPACK_IMPORTED_MODULE_5__helpers_googleHelper__["a" /* default */].subPrefix + ':' + revision.lastModifyingUser.permissionId,
                  created: new Date(revision.modifiedTime).getTime()
                };
              }));

            case 4:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  loadFileRevision: function loadFileRevision() {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt('return', false);

            case 1:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  getFileRevisionContent: function getFileRevisionContent(_ref9) {
    var _this10 = this;

    var token = _ref9.token,
        contentSyncDataId = _ref9.contentSyncDataId,
        revisionId = _ref9.revisionId;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10() {
      var content;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return __WEBPACK_IMPORTED_MODULE_5__helpers_googleHelper__["a" /* default */].downloadAppDataFileRevision(token, contentSyncDataId, revisionId);

            case 2:
              content = _context10.sent;
              return _context10.abrupt('return', JSON.parse(content));

            case 4:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  }
}));

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_Provider__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__workspaceSvc__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__badgeSvc__ = __webpack_require__(11);














var fileIdToOpen = void 0;
var syncStartPageToken = void 0;

/* unused harmony default export */ var _unused_webpack_default_export = (new __WEBPACK_IMPORTED_MODULE_9__common_Provider__["a" /* default */]({
  id: 'googleDriveWorkspace',
  name: 'Google Drive',
  getToken: function getToken() {
    return __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters['workspace/syncToken'];
  },
  getWorkspaceParams: function getWorkspaceParams(_ref) {
    var folderId = _ref.folderId;

    return {
      providerId: this.id,
      folderId: folderId
    };
  },
  getWorkspaceLocationUrl: function getWorkspaceLocationUrl(_ref2) {
    var folderId = _ref2.folderId;

    return 'https://docs.google.com/folder/d/' + folderId;
  },
  getSyncDataUrl: function getSyncDataUrl(_ref3) {
    var id = _ref3.id;

    return 'https://docs.google.com/file/d/' + id + '/edit';
  },
  getSyncDataDescription: function getSyncDataDescription(_ref4) {
    var id = _ref4.id;

    return id;
  },
  initWorkspace: function initWorkspace() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var makeWorkspaceId, getWorkspace, initFolder, _ref6, sub, token, folderId, folder, _folder, folderIdProperty;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              makeWorkspaceId = function makeWorkspaceId(folderId) {
                return folderId && __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].makeWorkspaceId(_this.getWorkspaceParams({ folderId: folderId }));
              };

              getWorkspace = function getWorkspace(folderId) {
                return __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters['workspace/workspacesById'][makeWorkspaceId(folderId)];
              };

              initFolder = function () {
                var _ref5 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee(token, folder) {
                  var appProperties, dataFolder, trashFolder, workspaceId;
                  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          appProperties = {
                            folderId: folder.id,
                            dataFolderId: folder.appProperties.dataFolderId,
                            trashFolderId: folder.appProperties.trashFolderId
                          };

                          if (appProperties.dataFolderId) {
                            _context.next = 6;
                            break;
                          }

                          _context.next = 4;
                          return __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].uploadFile({
                            token: token,
                            name: '.stackedit-data',
                            parents: [folder.id],
                            appProperties: { folderId: folder.id },
                            mediaType: __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].folderMimeType
                          });

                        case 4:
                          dataFolder = _context.sent;

                          appProperties.dataFolderId = dataFolder.id;

                        case 6:
                          if (appProperties.trashFolderId) {
                            _context.next = 11;
                            break;
                          }

                          _context.next = 9;
                          return __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].uploadFile({
                            token: token,
                            name: '.stackedit-trash',
                            parents: [folder.id],
                            appProperties: { folderId: folder.id },
                            mediaType: __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].folderMimeType
                          });

                        case 9:
                          trashFolder = _context.sent;

                          appProperties.trashFolderId = trashFolder.id;

                        case 11:
                          if (!(appProperties.folderId !== folder.appProperties.folderId || appProperties.dataFolderId !== folder.appProperties.dataFolderId || appProperties.trashFolderId !== folder.appProperties.trashFolderId)) {
                            _context.next = 14;
                            break;
                          }

                          _context.next = 14;
                          return __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].uploadFile({
                            token: token,
                            appProperties: appProperties,
                            mediaType: __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].folderMimeType,
                            fileId: folder.id
                          });

                        case 14:
                          workspaceId = makeWorkspaceId(folder.id);

                          __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch('workspace/patchWorkspacesById', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()({}, workspaceId, {
                            id: workspaceId,
                            sub: token.sub,
                            name: folder.name,
                            providerId: _this.id,
                            folderId: folder.id,
                            teamDriveId: folder.teamDriveId,
                            dataFolderId: appProperties.dataFolderId,
                            trashFolderId: appProperties.trashFolderId
                          }));

                        case 16:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this);
                }));

                return function initFolder(_x, _x2) {
                  return _ref5.apply(this, arguments);
                };
              }();

              _ref6 = getWorkspace(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].queryParams.folderId) || __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].queryParams, sub = _ref6.sub;
              token = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters['data/googleTokensBySub'][sub];

              if (!(!token || !token.isDrive || !token.driveFullAccess)) {
                _context2.next = 11;
                break;
              }

              _context2.next = 8;
              return __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch('modal/open', 'workspaceGoogleRedirection');

            case 8:
              _context2.next = 10;
              return __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].addDriveAccount(true, __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].queryParams.sub);

            case 10:
              token = _context2.sent;

            case 11:
              folderId = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].queryParams.folderId;

              if (folderId) {
                _context2.next = 19;
                break;
              }

              _context2.next = 15;
              return __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].uploadFile({
                token: token,
                name: 'StackEdit workspace',
                parents: [],
                mediaType: __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].folderMimeType
              });

            case 15:
              folder = _context2.sent;
              _context2.next = 18;
              return initFolder(token, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, folder, {
                appProperties: {}
              }));

            case 18:
              folderId = folder.id;

            case 19:
              if (getWorkspace(folderId)) {
                _context2.next = 36;
                break;
              }

              _folder = void 0;
              _context2.prev = 21;
              _context2.next = 24;
              return __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].getFile(token, folderId);

            case 24:
              _folder = _context2.sent;
              _context2.next = 30;
              break;

            case 27:
              _context2.prev = 27;
              _context2.t0 = _context2['catch'](21);
              throw new Error('Folder ' + folderId + ' is not accessible. Make sure you have the right permissions.');

            case 30:
              _folder.appProperties = _folder.appProperties || {};
              folderIdProperty = _folder.appProperties.folderId;

              if (!(folderIdProperty && folderIdProperty !== folderId)) {
                _context2.next = 34;
                break;
              }

              throw new Error('Folder ' + folderId + ' is part of another workspace.');

            case 34:
              _context2.next = 36;
              return initFolder(token, _folder);

            case 36:

              __WEBPACK_IMPORTED_MODULE_12__badgeSvc__["a" /* default */].addBadge('addGoogleDriveWorkspace');
              return _context2.abrupt('return', getWorkspace(folderId));

            case 38:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[21, 27]]);
    }))();
  },
  performAction: function performAction() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var state, token, driveFolder, syncData, item, file, firstFile, _syncData;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state = __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].driveState || {};
              token = _this2.getToken();
              _context3.t0 = token && state.action;
              _context3.next = _context3.t0 === 'create' ? 5 : _context3.t0 === 'open' ? 13 : 17;
              break;

            case 5:
              driveFolder = __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].driveActionFolder;
              syncData = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters['data/syncDataById'][driveFolder.id];

              if (!syncData && driveFolder.appProperties.id) {
                __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('folder/setItem', {
                  id: driveFolder.appProperties.id,
                  name: driveFolder.name
                });
                item = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state.folder.itemsById[driveFolder.appProperties.id];

                syncData = {
                  id: driveFolder.id,
                  itemId: item.id,
                  type: item.type,
                  hash: item.hash
                };
                __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch('data/patchSyncDataById', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()({}, syncData.id, syncData));
              }
              _context3.next = 10;
              return __WEBPACK_IMPORTED_MODULE_11__workspaceSvc__["a" /* default */].createFile({
                parentId: syncData && syncData.itemId
              }, true);

            case 10:
              file = _context3.sent;

              __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('file/setCurrentId', file.id);
              return _context3.abrupt('break', 17);

            case 13:
              firstFile = __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].driveActionFiles[0];
              _syncData = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters['data/syncDataById'][firstFile.id];

              if (!_syncData) {
                fileIdToOpen = firstFile.id;
              } else {
                __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('file/setCurrentId', _syncData.itemId);
              }
              return _context3.abrupt('break', 17);

            case 17:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }))();
  },
  getChanges: function getChanges() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var workspace, syncToken, lastStartPageToken, _ref7, changes, startPageToken;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              workspace = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters['workspace/currentWorkspace'];
              syncToken = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters['workspace/syncToken'];
              lastStartPageToken = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters['data/localSettings'].syncStartPageToken;
              _context4.next = 5;
              return __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].getChanges(syncToken, lastStartPageToken, false, workspace.teamDriveId);

            case 5:
              _ref7 = _context4.sent;
              changes = _ref7.changes;
              startPageToken = _ref7.startPageToken;


              syncStartPageToken = startPageToken;
              return _context4.abrupt('return', changes);

            case 10:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this3);
    }))();
  },
  prepareChanges: function prepareChanges(changes) {
    var parentIds = {};
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters['data/syncDataByItemId']).forEach(function (_ref8) {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref8, 2),
          id = _ref9[0],
          syncData = _ref9[1];

      parentIds[syncData.id] = id;
    });
    changes.forEach(function (change) {
      var _ref10 = (change.file || {}).appProperties || {},
          id = _ref10.id;

      if (id) {
        parentIds[change.fileId] = id;
      }
    });

    var workspace = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters['workspace/currentWorkspace'];
    var result = [];
    changes.forEach(function (change) {
      if (change.fileId === workspace.folderId || change.fileId === workspace.dataFolderId || change.fileId === workspace.trashFolderId) {
        return;
      }

      var contentChange = void 0;
      if (change.file) {
        var appProperties = change.file.appProperties;

        if (!appProperties || appProperties.folderId !== workspace.folderId) {
          return;
        }

        if (change.file.parents[0] === workspace.dataFolderId) {
          try {
            change.item = JSON.parse(change.file.name);
          } catch (e) {
            return;
          }
        } else {
          var type = change.file.mimeType === __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].folderMimeType ? 'folder' : 'file';
          var item = {
            id: appProperties.id,
            type: type,
            name: change.file.name,
            parentId: null
          };

          if (change.file.parents.some(function (parentId) {
            return parentId === workspace.trashFolderId;
          })) {
            item.parentId = 'trash';
          } else {
            change.file.parents.some(function (parentId) {
              if (!parentIds[parentId]) {
                return false;
              }
              item.parentId = parentIds[parentId];
              return true;
            });
          }
          change.item = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].addItemHash(item);

          if (type === 'file') {
            var id = appProperties.id + '/content';
            var syncDataId = change.fileId + '/content';
            contentChange = {
              item: {
                id: id,
                type: 'content',

                hash: 1
              },
              syncData: {
                id: syncDataId,
                itemId: id,
                type: 'content',

                hash: 1
              },
              syncDataId: syncDataId
            };
          }
        }

        change.syncData = {
          id: change.fileId,
          parentIds: change.file.parents,
          itemId: change.item.id,
          type: change.item.type,
          hash: change.item.hash
        };
      } else {
        var syncData = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters['data/syncDataById'][change.fileId];
        if (syncData && syncData.type === 'file') {
          contentChange = {
            syncDataId: change.fileId + '/content'
          };
        }
      }

      change.syncDataId = change.fileId;
      result.push(change);
      if (contentChange) {
        result.push(contentChange);
      }
    });

    return result;
  },
  onChangesApplied: function onChangesApplied() {
    __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch('data/patchLocalSettings', {
      syncStartPageToken: syncStartPageToken
    });
  },
  saveWorkspaceItem: function saveWorkspaceItem(_ref11) {
    var _this4 = this;

    var item = _ref11.item,
        syncData = _ref11.syncData,
        ifNotTooLate = _ref11.ifNotTooLate;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var workspace, syncToken, file, parentSyncData, parentId;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              workspace = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters['workspace/currentWorkspace'];
              syncToken = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters['workspace/syncToken'];
              file = void 0;

              if (!(item.type !== 'file' && item.type !== 'folder')) {
                _context5.next = 9;
                break;
              }

              _context5.next = 6;
              return __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].uploadFile({
                token: syncToken,
                name: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item),
                parents: [workspace.dataFolderId],
                appProperties: {
                  folderId: workspace.folderId
                },
                fileId: syncData && syncData.id,
                oldParents: syncData && syncData.parentIds,
                ifNotTooLate: ifNotTooLate
              });

            case 6:
              file = _context5.sent;
              _context5.next = 15;
              break;

            case 9:
              parentSyncData = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters['data/syncDataByItemId'][item.parentId];
              parentId = void 0;

              if (item.parentId === 'trash') {
                parentId = workspace.trashFolderId;
              } else if (parentSyncData) {
                parentId = parentSyncData.id;
              } else {
                parentId = workspace.folderId;
              }

              _context5.next = 14;
              return __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].uploadFile({
                token: syncToken,
                name: item.name,
                parents: [parentId],
                appProperties: {
                  id: item.id,
                  folderId: workspace.folderId
                },
                mediaType: item.type === 'folder' ? __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].folderMimeType : undefined,
                fileId: syncData && syncData.id,
                oldParents: syncData && syncData.parentIds,
                ifNotTooLate: ifNotTooLate
              });

            case 14:
              file = _context5.sent;

            case 15:
              return _context5.abrupt('return', {
                syncData: {
                  id: file.id,
                  parentIds: file.parents,
                  itemId: item.id,
                  type: item.type,
                  hash: item.hash
                }
              });

            case 16:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this4);
    }))();
  },
  removeWorkspaceItem: function removeWorkspaceItem(_ref12) {
    var _this5 = this;

    var syncData = _ref12.syncData,
        ifNotTooLate = _ref12.ifNotTooLate;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var syncToken;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!(syncData.type !== 'content')) {
                _context6.next = 4;
                break;
              }

              syncToken = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters['workspace/syncToken'];
              _context6.next = 4;
              return __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].removeFile(syncToken, syncData.id, ifNotTooLate);

            case 4:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this5);
    }))();
  },
  downloadWorkspaceContent: function downloadWorkspaceContent(_ref13) {
    var _this6 = this;

    var token = _ref13.token,
        contentSyncData = _ref13.contentSyncData,
        fileSyncData = _ref13.fileSyncData;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var data, content;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].downloadFile(token, fileSyncData.id);

            case 2:
              data = _context7.sent;
              content = __WEBPACK_IMPORTED_MODULE_9__common_Provider__["a" /* default */].parseContent(data, contentSyncData.itemId);

              if (fileIdToOpen && fileIdToOpen === fileSyncData.id) {
                fileIdToOpen = null;

                setTimeout(function () {
                  __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('file/setCurrentId', fileSyncData.itemId);
                }, 10);
              }

              return _context7.abrupt('return', {
                content: content,
                contentSyncData: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, contentSyncData, {
                  hash: content.hash
                })
              });

            case 6:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this6);
    }))();
  },
  downloadWorkspaceData: function downloadWorkspaceData(_ref14) {
    var _this7 = this;

    var token = _ref14.token,
        syncData = _ref14.syncData;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var content, item;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (syncData) {
                _context8.next = 2;
                break;
              }

              return _context8.abrupt('return', {});

            case 2:
              _context8.next = 4;
              return __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].downloadFile(token, syncData.id);

            case 4:
              content = _context8.sent;
              item = JSON.parse(content);
              return _context8.abrupt('return', {
                item: item,
                syncData: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, syncData, {
                  hash: item.hash
                })
              });

            case 7:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this7);
    }))();
  },
  uploadWorkspaceContent: function uploadWorkspaceContent(_ref15) {
    var _this8 = this;

    var token = _ref15.token,
        content = _ref15.content,
        file = _ref15.file,
        fileSyncData = _ref15.fileSyncData,
        ifNotTooLate = _ref15.ifNotTooLate;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9() {
      var gdriveFile, newFileSyncData, workspace, parentSyncData;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              gdriveFile = void 0;
              newFileSyncData = void 0;

              if (!fileSyncData) {
                _context9.next = 8;
                break;
              }

              _context9.next = 5;
              return __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].uploadFile({
                token: token,
                media: __WEBPACK_IMPORTED_MODULE_9__common_Provider__["a" /* default */].serializeContent(content),
                fileId: fileSyncData.id,
                ifNotTooLate: ifNotTooLate
              });

            case 5:
              gdriveFile = _context9.sent;
              _context9.next = 14;
              break;

            case 8:
              workspace = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters['workspace/currentWorkspace'];
              parentSyncData = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters['data/syncDataByItemId'][file.parentId];
              _context9.next = 12;
              return __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].uploadFile({
                token: token,
                name: file.name,
                parents: [parentSyncData ? parentSyncData.id : workspace.folderId],
                appProperties: {
                  id: file.id,
                  folderId: workspace.folderId
                },
                media: __WEBPACK_IMPORTED_MODULE_9__common_Provider__["a" /* default */].serializeContent(content),
                ifNotTooLate: ifNotTooLate
              });

            case 12:
              gdriveFile = _context9.sent;

              newFileSyncData = {
                id: gdriveFile.id,
                parentIds: gdriveFile.parents,
                itemId: file.id,
                type: file.type,
                hash: file.hash
              };

            case 14:
              return _context9.abrupt('return', {
                contentSyncData: {
                  id: gdriveFile.id + '/content',
                  itemId: content.id,
                  type: content.type,
                  hash: content.hash
                },
                fileSyncData: newFileSyncData
              });

            case 15:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this8);
    }))();
  },
  uploadWorkspaceData: function uploadWorkspaceData(_ref16) {
    var _this9 = this;

    var token = _ref16.token,
        item = _ref16.item,
        syncData = _ref16.syncData,
        ifNotTooLate = _ref16.ifNotTooLate;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee10() {
      var workspace, file;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              workspace = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters['workspace/currentWorkspace'];
              _context10.next = 3;
              return __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].uploadFile({
                token: token,
                name: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                  id: item.id,
                  type: item.type,
                  hash: item.hash
                }),
                parents: [workspace.dataFolderId],
                appProperties: {
                  folderId: workspace.folderId
                },
                media: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item),
                mediaType: 'application/json',
                fileId: syncData && syncData.id,
                oldParents: syncData && syncData.parentIds,
                ifNotTooLate: ifNotTooLate
              });

            case 3:
              file = _context10.sent;
              return _context10.abrupt('return', {
                syncData: {
                  id: file.id,
                  parentIds: file.parents,
                  itemId: item.id,
                  type: item.type,
                  hash: item.hash
                }
              });

            case 5:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this9);
    }))();
  },
  listFileRevisions: function listFileRevisions(_ref17) {
    var _this10 = this;

    var token = _ref17.token,
        fileSyncDataId = _ref17.fileSyncDataId;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee11() {
      var revisions;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].getFileRevisions(token, fileSyncDataId);

            case 2:
              revisions = _context11.sent;
              return _context11.abrupt('return', revisions.map(function (revision) {
                return {
                  id: revision.id,
                  sub: __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].subPrefix + ':' + revision.lastModifyingUser.permissionId,
                  created: new Date(revision.modifiedTime).getTime()
                };
              }));

            case 4:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this10);
    }))();
  },
  loadFileRevision: function loadFileRevision() {
    var _this11 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee12() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt('return', false);

            case 1:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this11);
    }))();
  },
  getFileRevisionContent: function getFileRevisionContent(_ref18) {
    var _this12 = this;

    var token = _ref18.token,
        contentId = _ref18.contentId,
        fileSyncDataId = _ref18.fileSyncDataId,
        revisionId = _ref18.revisionId;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee13() {
      var content;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return __WEBPACK_IMPORTED_MODULE_8__helpers_googleHelper__["a" /* default */].downloadFileRevision(token, fileSyncDataId, revisionId);

            case 2:
              content = _context13.sent;
              return _context13.abrupt('return', __WEBPACK_IMPORTED_MODULE_9__common_Provider__["a" /* default */].parseContent(content, contentId));

            case 4:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this12);
    }))();
  }
}));

/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__networkSvc__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__userSvc__ = __webpack_require__(46);







var _this = this;






var request = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2(token) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var baseUrl, getLastToken, assertUnauthorized, onUnauthorized, config, res;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            baseUrl = token.dbUrl + '/';

            getLastToken = function getLastToken() {
              return __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters['data/couchdbTokensBySub'][token.sub];
            };

            assertUnauthorized = function assertUnauthorized(err) {
              if (err.status !== 401) {
                throw err;
              }
            };

            onUnauthorized = function () {
              var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _getLastToken, name, password;

                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _getLastToken = getLastToken(), name = _getLastToken.name, password = _getLastToken.password;
                        _context.next = 4;
                        return __WEBPACK_IMPORTED_MODULE_6__networkSvc__["a" /* default */].request({
                          method: 'POST',
                          url: __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].resolveUrl(baseUrl, '../_session'),
                          withCredentials: true,
                          body: {
                            name: name,
                            password: password
                          }
                        });

                      case 4:
                        _context.next = 13;
                        break;

                      case 6:
                        _context.prev = 6;
                        _context.t0 = _context['catch'](0);

                        assertUnauthorized(_context.t0);
                        _context.next = 11;
                        return __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].dispatch('modal/open', {
                          type: 'couchdbCredentials',
                          token: getLastToken()
                        });

                      case 11:
                        _context.next = 13;
                        return onUnauthorized();

                      case 13:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this, [[0, 6]]);
              }));

              return function onUnauthorized() {
                return _ref2.apply(this, arguments);
              };
            }();

            config = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, options, {
              headers: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
                Accept: 'application/json'
              }, options.headers || {}),
              url: __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].resolveUrl(baseUrl, options.path || '.'),
              withCredentials: true
            });
            _context2.prev = 5;
            res = void 0;
            _context2.prev = 7;
            _context2.next = 10;
            return __WEBPACK_IMPORTED_MODULE_6__networkSvc__["a" /* default */].request(config);

          case 10:
            res = _context2.sent;
            _context2.next = 21;
            break;

          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2['catch'](7);

            assertUnauthorized(_context2.t0);
            _context2.next = 18;
            return onUnauthorized();

          case 18:
            _context2.next = 20;
            return __WEBPACK_IMPORTED_MODULE_6__networkSvc__["a" /* default */].request(config);

          case 20:
            res = _context2.sent;

          case 21:
            return _context2.abrupt('return', res.body);

          case 24:
            _context2.prev = 24;
            _context2.t1 = _context2['catch'](5);

            if (!(_context2.t1.status === 409)) {
              _context2.next = 28;
              break;
            }

            throw new Error('TOO_LATE');

          case 28:
            throw _context2.t1;

          case 29:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this, [[5, 24], [7, 13]]);
  }));

  return function request(_x) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  getDb: function getDb(token) {
    return request(token);
  },
  getChanges: function getChanges(token, lastSeq) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var result, getPage;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              result = {
                changes: [],
                lastSeq: lastSeq
              };

              getPage = function () {
                var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
                  var body;
                  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return request(token, {
                            method: 'GET',
                            path: '_changes',
                            params: {
                              since: result.lastSeq || 0,
                              include_docs: true,
                              limit: 1000
                            }
                          });

                        case 2:
                          body = _context3.sent;

                          result.changes = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(result.changes), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(body.results));
                          result.lastSeq = body.last_seq;

                          if (!body.pending) {
                            _context3.next = 7;
                            break;
                          }

                          return _context3.abrupt('return', getPage());

                        case 7:
                          return _context3.abrupt('return', result);

                        case 8:
                        case 'end':
                          return _context3.stop();
                      }
                    }
                  }, _callee3, _this2);
                }));

                return function getPage() {
                  return _ref3.apply(this, arguments);
                };
              }();

              return _context4.abrupt('return', getPage());

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this2);
    }))();
  },
  uploadDocument: function uploadDocument(_ref4) {
    var _this3 = this;

    var token = _ref4.token,
        item = _ref4.item,
        _ref4$data = _ref4.data,
        data = _ref4$data === undefined ? null : _ref4$data,
        _ref4$dataType = _ref4.dataType,
        dataType = _ref4$dataType === undefined ? null : _ref4$dataType,
        _ref4$documentId = _ref4.documentId,
        documentId = _ref4$documentId === undefined ? null : _ref4$documentId,
        _ref4$rev = _ref4.rev,
        rev = _ref4$rev === undefined ? null : _ref4$rev;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var options, userId;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              options = {
                method: 'POST',
                body: { item: item, time: Date.now() }
              };
              userId = __WEBPACK_IMPORTED_MODULE_9__userSvc__["a" /* default */].getCurrentUserId();

              if (userId) {
                options.body.sub = userId;
              }
              if (documentId) {
                options.method = 'PUT';
                options.path = documentId;
                options.body._rev = rev;
              }
              if (data) {
                options.body._attachments = {
                  data: {
                    content_type: dataType,
                    data: __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].encodeBase64(data)
                  }
                };
              }
              return _context5.abrupt('return', request(token, options));

            case 6:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this3);
    }))();
  },
  removeDocument: function removeDocument(token, documentId, rev) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (documentId) {
                _context6.next = 2;
                break;
              }

              throw new Error('Missing document ID');

            case 2:
              return _context6.abrupt('return', request(token, {
                method: 'DELETE',
                path: documentId,
                params: { rev: rev }
              }));

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this4);
    }))();
  },
  retrieveDocument: function retrieveDocument(token, documentId, rev) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt('return', request(token, {
                path: documentId,
                params: { rev: rev }
              }));

            case 1:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this5);
    }))();
  },
  retrieveDocumentWithAttachments: function retrieveDocumentWithAttachments(token, documentId, rev) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var body;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return request(token, {
                path: documentId,
                params: { attachments: true, rev: rev }
              });

            case 2:
              body = _context8.sent;

              body.attachments = {};

              __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(body._attachments).forEach(function (_ref5) {
                var _ref6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
                    name = _ref6[0],
                    attachment = _ref6[1];

                body.attachments[name] = __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].decodeBase64(attachment.data);
              });
              return _context8.abrupt('return', body);

            case 6:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this6);
    }))();
  },
  retrieveDocumentWithRevisions: function retrieveDocumentWithRevisions(token, documentId) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt('return', request(token, {
                path: documentId,
                params: {
                  revs_info: true
                }
              }));

            case 1:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this7);
    }))();
  }
});

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_wordpressHelper__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Provider__ = __webpack_require__(39);







/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */]({
  id: 'wordpress',
  name: 'WordPress',
  getToken: function getToken(_ref) {
    var sub = _ref.sub;

    return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['data/wordpressTokensBySub'][sub];
  },
  getLocationUrl: function getLocationUrl(_ref2) {
    var siteId = _ref2.siteId,
        postId = _ref2.postId;

    return 'https://wordpress.com/post/' + siteId + '/' + postId;
  },
  getLocationDescription: function getLocationDescription(_ref3) {
    var postId = _ref3.postId;

    return postId;
  },
  publish: function publish(token, html, metadata, publishLocation) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var post;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_wordpressHelper__["a" /* default */].uploadPost(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, publishLocation, metadata, {
                token: token,
                content: html
              }));

            case 2:
              post = _context.sent;
              return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, publishLocation, {
                siteId: '' + post.site_ID,
                postId: '' + post.ID
              }));

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  makeLocation: function makeLocation(token, domain, postId) {
    var location = {
      providerId: this.id,
      sub: token.sub,
      domain: domain
    };
    if (postId) {
      location.postId = postId;
    }
    return location;
  }
}));

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_zendeskHelper__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Provider__ = __webpack_require__(39);







/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_5__common_Provider__["a" /* default */]({
  id: 'zendesk',
  name: 'Zendesk',
  getToken: function getToken(_ref) {
    var sub = _ref.sub;

    return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['data/zendeskTokensBySub'][sub];
  },
  getLocationUrl: function getLocationUrl(_ref2) {
    var sub = _ref2.sub,
        locale = _ref2.locale,
        articleId = _ref2.articleId;

    var token = this.getToken({ sub: sub });
    return 'https://' + token.subdomain + '.zendesk.com/hc/' + locale + '/articles/' + articleId;
  },
  getLocationDescription: function getLocationDescription(_ref3) {
    var articleId = _ref3.articleId;

    return articleId;
  },
  publish: function publish(token, html, metadata, publishLocation) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var articleId;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__helpers_zendeskHelper__["a" /* default */].uploadArticle(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, publishLocation, {
                token: token,
                title: metadata.title,
                content: html,
                labels: metadata.tags,
                isDraft: metadata.status === 'draft'
              }));

            case 2:
              articleId = _context.sent;
              return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, publishLocation, {
                articleId: articleId
              }));

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  makeLocation: function makeLocation(token, sectionId, locale, articleId) {
    var location = {
      providerId: this.id,
      sub: token.sub,
      sectionId: sectionId,
      locale: locale
    };
    if (articleId) {
      location.articleId = articleId;
    }
    return location;
  }
}));

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

var pad = function pad(num) {
  return ('0' + num).slice(-2);
};

function strftime(time, formatString) {
  var day = time.getDay();
  var date = time.getDate();
  var month = time.getMonth();
  var year = time.getFullYear();
  var hour = time.getHours();
  var minute = time.getMinutes();
  var second = time.getSeconds();
  return formatString.replace(/%([%aAbBcdeHIlmMpPSwyYZz])/g, function (_arg) {
    var match = void 0;
    var modifier = _arg[1];
    switch (modifier) {
      case '%':
      default:
        return '%';
      case 'a':
        return weekdays[day].slice(0, 3);
      case 'A':
        return weekdays[day];
      case 'b':
        return months[month].slice(0, 3);
      case 'B':
        return months[month];
      case 'c':
        return time.toString();
      case 'd':
        return pad(date);
      case 'e':
        return date;
      case 'H':
        return pad(hour);
      case 'I':
        return pad(strftime(time, '%l'));
      case 'l':
        return hour === 0 || hour === 12 ? 12 : (hour + 12) % 12;
      case 'm':
        return pad(month + 1);
      case 'M':
        return pad(minute);
      case 'p':
        return hour > 11 ? 'PM' : 'AM';
      case 'P':
        return hour > 11 ? 'pm' : 'am';
      case 'S':
        return pad(second);
      case 'w':
        return day;
      case 'y':
        return pad(year % 100);
      case 'Y':
        return year;
      case 'Z':
        match = time.toString().match(/\((\w+)\)$/);
        return match ? match[1] : '';
      case 'z':
        match = time.toString().match(/\w([+-]\d\d\d\d) /);
        return match ? match[1] : '';
    }
  });
}

var dayFirst = null;
var yearSeparator = null;

function isDayFirst() {
  if (dayFirst !== null) {
    return dayFirst;
  }

  if (!('Intl' in window)) {
    return false;
  }

  var options = { day: 'numeric', month: 'short' };
  var formatter = new window.Intl.DateTimeFormat(undefined, options);
  var output = formatter.format(new Date(0));

  dayFirst = !!output.match(/^\d/);
  return dayFirst;
}

function isYearSeparator() {
  if (yearSeparator !== null) {
    return yearSeparator;
  }

  if (!('Intl' in window)) {
    return true;
  }

  var options = { day: 'numeric', month: 'short', year: 'numeric' };
  var formatter = new window.Intl.DateTimeFormat(undefined, options);
  var output = formatter.format(new Date(0));

  yearSeparator = !!output.match(/\d,/);
  return yearSeparator;
}

function isThisYear(date) {
  var now = new Date();
  return now.getUTCFullYear() === date.getUTCFullYear();
}

var RelativeTime = function () {
  function RelativeTime(date) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, RelativeTime);

    this.date = date;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(RelativeTime, [{
    key: 'toString',
    value: function toString() {
      var ago = this.timeElapsed();
      return ago || 'on ' + this.formatDate();
    }
  }, {
    key: 'timeElapsed',
    value: function timeElapsed() {
      var ms = new Date().getTime() - this.date.getTime();
      var sec = Math.round(ms / 1000);
      var min = Math.round(sec / 60);
      var hr = Math.round(min / 60);
      var day = Math.round(hr / 24);
      if (ms < 0) {
        return 'just now';
      } else if (sec < 45) {
        return 'just now';
      } else if (sec < 90) {
        return 'a minute ago';
      } else if (min < 45) {
        return min + ' minutes ago';
      } else if (min < 90) {
        return 'an hour ago';
      } else if (hr < 24) {
        return hr + ' hours ago';
      } else if (hr < 36) {
        return 'a day ago';
      } else if (day < 30) {
        return day + ' days ago';
      }
      return null;
    }
  }, {
    key: 'formatDate',
    value: function formatDate() {
      var format = isDayFirst() ? '%e %b' : '%b %e';
      if (!isThisYear(this.date)) {
        format += isYearSeparator() ? ', %Y' : ' %Y';
      }
      return strftime(this.date, format);
    }
  }]);

  return RelativeTime;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  format: function format(time) {
    return time && new RelativeTime(new Date(time)).toString();
  }
});

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_diff_match_patch__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_diff_match_patch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_diff_match_patch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__moduleTemplate__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_empties_emptyContent__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_editor_cledit__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_badgeSvc__ = __webpack_require__(11);












var diffMatchPatch = new __WEBPACK_IMPORTED_MODULE_5_diff_match_patch___default.a();

var module = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__moduleTemplate__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__data_empties_emptyContent__["a" /* default */]);

module.state = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, module.state, {
  revisionContent: null
});

module.mutations = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, module.mutations, {
  setRevisionContent: function setRevisionContent(state, value) {
    if (value) {
      state.revisionContent = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__data_empties_emptyContent__["a" /* default */])(), value, {
        id: __WEBPACK_IMPORTED_MODULE_8__services_utils__["a" /* default */].uid(),
        hash: Date.now()
      });
    } else {
      state.revisionContent = null;
    }
  }
});

module.getters = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, module.getters, {
  current: function current(_ref, getters, rootState, rootGetters) {
    var itemsById = _ref.itemsById,
        revisionContent = _ref.revisionContent;

    if (revisionContent) {
      return revisionContent;
    }
    return itemsById[rootGetters['file/current'].id + '/content'] || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__data_empties_emptyContent__["a" /* default */])();
  },
  currentChangeTrigger: function currentChangeTrigger(state, getters) {
    var current = getters.current;

    return __WEBPACK_IMPORTED_MODULE_8__services_utils__["a" /* default */].serializeObject([current.id, current.text, current.hash]);
  },
  currentProperties: function currentProperties(state, _ref2) {
    var current = _ref2.current;
    return __WEBPACK_IMPORTED_MODULE_8__services_utils__["a" /* default */].computeProperties(current.properties);
  },
  isCurrentEditable: function isCurrentEditable(_ref3, _ref4, rootState, rootGetters) {
    var revisionContent = _ref3.revisionContent;
    var current = _ref4.current;
    return !revisionContent && current.id && rootGetters['layout/styles'].showEditor;
  }
});

module.actions = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, module.actions, {
  patchCurrent: function patchCurrent(_ref5, value) {
    var state = _ref5.state,
        getters = _ref5.getters,
        commit = _ref5.commit;
    var id = getters.current.id;

    if (id && !state.revisionContent) {
      commit('patchItem', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, value, {
        id: id
      }));
    }
  },
  setRevisionContent: function setRevisionContent(_ref6, value) {
    var state = _ref6.state,
        rootGetters = _ref6.rootGetters,
        commit = _ref6.commit;

    var currentFile = rootGetters['file/current'];
    var currentContent = state.itemsById[currentFile.id + '/content'];
    if (currentContent) {
      var diffs = diffMatchPatch.diff_main(currentContent.text, value.text);
      diffMatchPatch.diff_cleanupSemantic(diffs);
      commit('setRevisionContent', {
        text: diffs.map(function (_ref7) {
          var _ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
              text = _ref8[1];

          return text;
        }).join(''),
        diffs: diffs,
        originalText: value.text
      });
    }
  },
  restoreRevision: function restoreRevision(_ref9) {
    var _this = this;

    var state = _ref9.state,
        getters = _ref9.getters,
        commit = _ref9.commit,
        dispatch = _ref9.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var revisionContent, currentContent, diffs;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              revisionContent = state.revisionContent;

              if (!revisionContent) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return dispatch('modal/open', 'fileRestoration', { root: true });

            case 4:
              commit('setRevisionContent');
              currentContent = __WEBPACK_IMPORTED_MODULE_8__services_utils__["a" /* default */].deepCopy(getters.current);

              if (currentContent) {
                diffs = diffMatchPatch.diff_main(currentContent.text, revisionContent.originalText);

                diffMatchPatch.diff_cleanupSemantic(diffs);
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(currentContent.discussions).forEach(function (_ref10) {
                  var _ref11 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref10, 2),
                      discussion = _ref11[1];

                  var adjustOffset = function adjustOffset(offsetName) {
                    var marker = new __WEBPACK_IMPORTED_MODULE_9__services_editor_cledit__["a" /* default */].Marker(discussion[offsetName], offsetName === 'end');
                    marker.adjustOffset(diffs);
                    discussion[offsetName] = marker.offset;
                  };
                  adjustOffset('start');
                  adjustOffset('end');
                });
                dispatch('patchCurrent', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, currentContent, {
                  text: revisionContent.originalText
                }));
                __WEBPACK_IMPORTED_MODULE_10__services_badgeSvc__["a" /* default */].addBadge('restoreVersion');
              }

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__moduleTemplate__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_empties_emptyContentState__ = __webpack_require__(974);




var module = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__moduleTemplate__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__data_empties_emptyContentState__["a" /* default */], true);

module.getters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, module.getters, {
  current: function current(_ref, getters, rootState, rootGetters) {
    var itemsById = _ref.itemsById;
    return itemsById[rootGetters['file/current'].id + '/contentState'] || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_empties_emptyContentState__["a" /* default */])();
  }
});

module.actions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, module.actions, {
  patchCurrent: function patchCurrent(_ref2, value) {
    var getters = _ref2.getters,
        commit = _ref2.commit;

    commit('patchItem', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, value, {
      id: getters.current.id
    }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var setter = function setter(propertyName) {
  return function (state, value) {
    state[propertyName] = value;
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    coordinates: {
      left: 0,
      top: 0
    },
    items: [],
    resolve: function resolve() {}
  },
  mutations: {
    setCoordinates: setter('coordinates'),
    setItems: setter('items'),
    setResolve: setter('resolve')
  },
  actions: {
    open: function open(_ref, _ref2) {
      var commit = _ref.commit,
          rootState = _ref.rootState;
      var coordinates = _ref2.coordinates,
          items = _ref2.items;

      commit('setItems', items);

      commit('setCoordinates', { top: 0, left: -9999 });

      setTimeout(function () {
        var elt = document.querySelector('.context-menu__inner');
        if (elt) {
          var height = elt.offsetHeight;
          if (coordinates.top + height > rootState.layout.bodyHeight) {
            coordinates.top -= height;
          }
          if (coordinates.top < 0) {
            coordinates.top = 0;
          }
          var width = elt.offsetWidth;
          if (coordinates.left + width > rootState.layout.bodyWidth) {
            coordinates.left -= width;
          }
          if (coordinates.left < 0) {
            coordinates.left = 0;
          }
          commit('setCoordinates', coordinates);
        }
      }, 1);

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        return commit('setResolve', resolve);
      });
    },
    close: function close(_ref3) {
      var commit = _ref3.commit;

      commit('setItems', []);
      commit('setResolve', function () {});
    }
  }
});

/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_set__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_js_yaml__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_js_yaml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_js_yaml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__data_defaults_defaultWorkspaces__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__data_defaults_defaultSettings_yml__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__data_defaults_defaultSettings_yml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__data_defaults_defaultSettings_yml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__data_defaults_defaultLocalSettings__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__data_defaults_defaultLayoutSettings__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__data_templates_plainHtmlTemplate_html__ = __webpack_require__(2205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__data_templates_plainHtmlTemplate_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__data_templates_plainHtmlTemplate_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__data_templates_styledHtmlTemplate_html__ = __webpack_require__(2206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__data_templates_styledHtmlTemplate_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__data_templates_styledHtmlTemplate_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__data_templates_styledHtmlWithTocTemplate_html__ = __webpack_require__(2207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__data_templates_styledHtmlWithTocTemplate_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__data_templates_styledHtmlWithTocTemplate_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__data_templates_jekyllSiteTemplate_html__ = __webpack_require__(2204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__data_templates_jekyllSiteTemplate_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__data_templates_jekyllSiteTemplate_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__data_constants__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__data_features__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__services_badgeSvc__ = __webpack_require__(11);























var itemTemplate = function itemTemplate(id) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    id: id,
    type: 'data',
    data: data,
    hash: 0
  };
};

var empty = function empty(id) {
  switch (id) {
    case 'workspaces':
      return itemTemplate(id, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__data_defaults_defaultWorkspaces__["a" /* default */])());
    case 'settings':
      return itemTemplate(id, '\n');
    case 'localSettings':
      return itemTemplate(id, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__data_defaults_defaultLocalSettings__["a" /* default */])());
    case 'layoutSettings':
      return itemTemplate(id, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__data_defaults_defaultLayoutSettings__["a" /* default */])());
    default:
      return itemTemplate(id);
  }
};

var localStorageIdSet = new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_set___default.a(__WEBPACK_IMPORTED_MODULE_19__data_constants__["a" /* default */].localStorageDataIds);

var getter = function getter(id) {
  return function (state) {
    var itemsById = localStorageIdSet.has(id) ? state.lsItemsById : state.itemsById;
    if (itemsById[id]) {
      return itemsById[id].data;
    }
    return empty(id).data;
  };
};
var setter = function setter(id) {
  return function (_ref, data) {
    var commit = _ref.commit;
    return commit('setItem', itemTemplate(id, data));
  };
};
var patcher = function patcher(id) {
  return function (_ref2, data) {
    var state = _ref2.state,
        commit = _ref2.commit;

    var itemsById = localStorageIdSet.has(id) ? state.lsItemsById : state.itemsById;
    var item = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()(empty(id), itemsById[id]);
    commit('setItem', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, empty(id), {
      data: (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(data)) === 'object' ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, item.data, data) : data
    }));
  };
};

var toggleLayoutSetting = function toggleLayoutSetting(name, value, featureId, getters, dispatch) {
  var currentValue = getters.layoutSettings[name];
  var patch = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, name, value === undefined ? !currentValue : !!value);
  if (patch[name] !== currentValue) {
    dispatch('patchLayoutSettings', patch);
    __WEBPACK_IMPORTED_MODULE_21__services_badgeSvc__["a" /* default */].addBadge(featureId);
  }
};

var layoutSettingsToggler = function layoutSettingsToggler(propertyName, featureId) {
  return function (_ref3, value) {
    var getters = _ref3.getters,
        dispatch = _ref3.dispatch;
    return toggleLayoutSetting(propertyName, value, featureId, getters, dispatch);
  };
};

var notEnoughSpace = function notEnoughSpace(layoutConstants, showGutter) {
  return document.body.clientWidth < layoutConstants.editorMinWidth + layoutConstants.explorerWidth + layoutConstants.sideBarWidth + layoutConstants.buttonBarWidth + (showGutter ? layoutConstants.gutterWidth : 0);
};

var makeAdditionalTemplate = function makeAdditionalTemplate(name, value) {
  var helpers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '\n';
  return {
    name: name,
    value: value,
    helpers: helpers,
    isAdditional: true
  };
};
var defaultTemplates = {
  plainText: makeAdditionalTemplate('Plain text', '{{{files.0.content.text}}}'),
  plainHtml: makeAdditionalTemplate('Plain HTML', __WEBPACK_IMPORTED_MODULE_15__data_templates_plainHtmlTemplate_html___default.a),
  styledHtml: makeAdditionalTemplate('Styled HTML', __WEBPACK_IMPORTED_MODULE_16__data_templates_styledHtmlTemplate_html___default.a),
  styledHtmlWithToc: makeAdditionalTemplate('Styled HTML with TOC', __WEBPACK_IMPORTED_MODULE_17__data_templates_styledHtmlWithTocTemplate_html___default.a),
  jekyllSite: makeAdditionalTemplate('Jekyll site', __WEBPACK_IMPORTED_MODULE_18__data_templates_jekyllSiteTemplate_html___default.a)
};

var tokenAdder = function tokenAdder(providerId) {
  return function (_ref4, token) {
    var getters = _ref4.getters,
        dispatch = _ref4.dispatch;

    dispatch('patchTokensByType', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, providerId, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, getters[providerId + 'TokensBySub'], __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, token.sub, token))));
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    itemsById: {},

    lsItemsById: {}
  },
  mutations: {
    setItem: function setItem(_ref5, value) {
      var itemsById = _ref5.itemsById,
          lsItemsById = _ref5.lsItemsById;

      var emptyItem = empty(value.id);
      var data = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(value.data) === 'object' ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()(emptyItem.data, value.data) : value.data;

      var item = __WEBPACK_IMPORTED_MODULE_10__services_utils__["a" /* default */].addItemHash(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, emptyItem, {
        data: data
      }));

      __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].set(localStorageIdSet.has(item.id) ? lsItemsById : itemsById, item.id, item);
    },
    deleteItem: function deleteItem(_ref6, id) {
      var itemsById = _ref6.itemsById;

      __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].delete(itemsById, id);
    }
  },
  getters: {
    serverConf: getter('serverConf'),
    workspaces: getter('workspaces'),
    settings: getter('settings'),
    computedSettings: function computedSettings(state, _ref7) {
      var settings = _ref7.settings;

      var customSettings = __WEBPACK_IMPORTED_MODULE_9_js_yaml___default.a.safeLoad(settings);
      var parsedSettings = __WEBPACK_IMPORTED_MODULE_9_js_yaml___default.a.safeLoad(__WEBPACK_IMPORTED_MODULE_12__data_defaults_defaultSettings_yml___default.a);
      var override = function override(obj, opt) {
        var objType = Object.prototype.toString.call(obj);
        var optType = Object.prototype.toString.call(opt);
        if (objType !== optType) {
          return obj;
        } else if (objType !== '[object Object]') {
          return opt;
        }
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(obj).forEach(function (key) {
          if (key === 'shortcuts') {
            obj[key] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()(obj[key], opt[key]);
          } else {
            obj[key] = override(obj[key], opt[key]);
          }
        });
        return obj;
      };
      return override(parsedSettings, customSettings);
    },
    localSettings: getter('localSettings'),
    layoutSettings: getter('layoutSettings'),
    templatesById: getter('templates'),
    allTemplatesById: function allTemplatesById(state, _ref8) {
      var templatesById = _ref8.templatesById;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, templatesById, defaultTemplates);
    },
    lastCreated: getter('lastCreated'),
    lastOpened: getter('lastOpened'),
    lastOpenedIds: function lastOpenedIds(state, _ref9, rootState) {
      var lastOpened = _ref9.lastOpened;

      var result = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, lastOpened);
      var currentFileId = rootState.file.currentId;
      if (currentFileId && !result[currentFileId]) {
        result[currentFileId] = Date.now();
      }
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(result).filter(function (id) {
        return rootState.file.itemsById[id];
      }).sort(function (id1, id2) {
        return result[id2] - result[id1];
      }).slice(0, 20);
    },
    syncDataById: getter('syncData'),
    syncDataByItemId: function syncDataByItemId(state, _ref10, rootState, rootGetters) {
      var syncDataById = _ref10.syncDataById;

      var result = {};
      if (rootGetters['workspace/currentWorkspaceIsGit']) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(rootGetters.gitPathsByItemId).forEach(function (_ref11) {
          var _ref12 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref11, 2),
              id = _ref12[0],
              path = _ref12[1];

          var syncDataEntry = syncDataById[path];
          if (syncDataEntry) {
            result[id] = syncDataEntry;
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(syncDataById).forEach(function (_ref13) {
          var _ref14 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref13, 2),
              syncDataEntry = _ref14[1];

          result[syncDataEntry.itemId] = syncDataEntry;
        });
      }
      return result;
    },
    dataSyncDataById: getter('dataSyncData'),
    tokensByType: getter('tokens'),
    googleTokensBySub: function googleTokensBySub(state, _ref15) {
      var tokensByType = _ref15.tokensByType;
      return tokensByType.google || {};
    },
    couchdbTokensBySub: function couchdbTokensBySub(state, _ref16) {
      var tokensByType = _ref16.tokensByType;
      return tokensByType.couchdb || {};
    },
    dropboxTokensBySub: function dropboxTokensBySub(state, _ref17) {
      var tokensByType = _ref17.tokensByType;
      return tokensByType.dropbox || {};
    },
    githubTokensBySub: function githubTokensBySub(state, _ref18) {
      var tokensByType = _ref18.tokensByType;
      return tokensByType.github || {};
    },
    gitlabTokensBySub: function gitlabTokensBySub(state, _ref19) {
      var tokensByType = _ref19.tokensByType;
      return tokensByType.gitlab || {};
    },
    wordpressTokensBySub: function wordpressTokensBySub(state, _ref20) {
      var tokensByType = _ref20.tokensByType;
      return tokensByType.wordpress || {};
    },
    zendeskTokensBySub: function zendeskTokensBySub(state, _ref21) {
      var tokensByType = _ref21.tokensByType;
      return tokensByType.zendesk || {};
    },
    badgeCreations: getter('badgeCreations'),
    badgeTree: function badgeTree(state, _ref22) {
      var badgeCreations = _ref22.badgeCreations;
      return __WEBPACK_IMPORTED_MODULE_20__data_features__["a" /* default */].map(function (feature) {
        return feature.toBadge(badgeCreations);
      });
    },
    allBadges: function allBadges(state, _ref23) {
      var badgeTree = _ref23.badgeTree;

      var result = [];
      var processBadgeNodes = function processBadgeNodes(nodes) {
        return nodes.forEach(function (node) {
          result.push(node);
          if (node.children) {
            processBadgeNodes(node.children);
          }
        });
      };
      processBadgeNodes(badgeTree);
      return result;
    }
  },
  actions: {
    setServerConf: setter('serverConf'),
    setSettings: setter('settings'),
    patchLocalSettings: patcher('localSettings'),
    patchLayoutSettings: patcher('layoutSettings'),
    toggleNavigationBar: layoutSettingsToggler('showNavigationBar', 'toggleNavigationBar'),
    toggleEditor: layoutSettingsToggler('showEditor', 'toggleEditor'),
    toggleSidePreview: layoutSettingsToggler('showSidePreview', 'toggleSidePreview'),
    toggleStatusBar: layoutSettingsToggler('showStatusBar', 'toggleStatusBar'),
    toggleScrollSync: layoutSettingsToggler('scrollSync', 'toggleScrollSync'),
    toggleFocusMode: layoutSettingsToggler('focusMode', 'toggleFocusMode'),
    toggleSideBar: function toggleSideBar(_ref24, value) {
      var getters = _ref24.getters,
          dispatch = _ref24.dispatch,
          rootGetters = _ref24.rootGetters;

      dispatch('setSideBarPanel');

      toggleLayoutSetting('showSideBar', value, 'toggleSideBar', getters, dispatch);

      if (getters.layoutSettings.showSideBar && notEnoughSpace(rootGetters['layout/constants'], rootGetters['discussion/currentDiscussion'])) {
        dispatch('patchLayoutSettings', {
          showExplorer: false
        });
      }
    },
    toggleExplorer: function toggleExplorer(_ref25, value) {
      var getters = _ref25.getters,
          dispatch = _ref25.dispatch,
          rootGetters = _ref25.rootGetters;

      toggleLayoutSetting('showExplorer', value, 'toggleExplorer', getters, dispatch);

      if (getters.layoutSettings.showExplorer && notEnoughSpace(rootGetters['layout/constants'], rootGetters['discussion/currentDiscussion'])) {
        dispatch('patchLayoutSettings', {
          showSideBar: false
        });
      }
    },
    setSideBarPanel: function setSideBarPanel(_ref26, value) {
      var dispatch = _ref26.dispatch;
      return dispatch('patchLayoutSettings', {
        sideBarPanel: value === undefined ? 'menu' : value
      });
    },
    setTemplatesById: function setTemplatesById(_ref27, templatesById) {
      var commit = _ref27.commit;

      var templatesToCommit = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, templatesById);

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(defaultTemplates).forEach(function (id) {
        delete templatesToCommit[id];
      });
      commit('setItem', itemTemplate('templates', templatesToCommit));
    },
    setLastCreated: setter('lastCreated'),
    setLastOpenedId: function setLastOpenedId(_ref28, fileId) {
      var getters = _ref28.getters,
          commit = _ref28.commit,
          rootState = _ref28.rootState;

      var lastOpened = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, getters.lastOpened);
      lastOpened[fileId] = Date.now();

      var cleanedLastOpened = {};
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(lastOpened).forEach(function (_ref29) {
        var _ref30 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref29, 2),
            id = _ref30[0],
            value = _ref30[1];

        if (rootState.file.itemsById[id]) {
          cleanedLastOpened[id] = value;
        }
      });
      commit('setItem', itemTemplate('lastOpened', cleanedLastOpened));
    },
    setSyncDataById: setter('syncData'),
    patchSyncDataById: patcher('syncData'),
    patchDataSyncDataById: patcher('dataSyncData'),
    patchTokensByType: patcher('tokens'),
    addGoogleToken: tokenAdder('google'),
    addCouchdbToken: tokenAdder('couchdb'),
    addDropboxToken: tokenAdder('dropbox'),
    addGithubToken: tokenAdder('github'),
    addGitlabToken: tokenAdder('gitlab'),
    addWordpressToken: tokenAdder('wordpress'),
    addZendeskToken: tokenAdder('zendesk'),
    patchBadgeCreations: patcher('badgeCreations')
  }
});

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_providers_helpers_googleHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_syncSvc__ = __webpack_require__(105);











var idShifter = function idShifter(offset) {
  return function (state, getters) {
    var ids = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(getters.currentFileDiscussions).filter(function (id) {
      return id !== state.newDiscussionId;
    });
    var idx = ids.indexOf(state.currentDiscussionId) + offset + ids.length;
    return ids[idx % ids.length];
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    currentDiscussionId: null,
    newDiscussion: null,
    newDiscussionId: null,
    isCommenting: false,
    newCommentText: '',
    newCommentSelection: { start: 0, end: 0 },
    newCommentFocus: false,
    stickyComment: null
  },
  mutations: {
    setCurrentDiscussionId: function setCurrentDiscussionId(state, value) {
      if (state.currentDiscussionId !== value) {
        state.currentDiscussionId = value;
        state.isCommenting = false;
      }
    },
    setNewDiscussion: function setNewDiscussion(state, value) {
      state.newDiscussion = value;
      state.newDiscussionId = __WEBPACK_IMPORTED_MODULE_7__services_utils__["a" /* default */].uid();
      state.currentDiscussionId = state.newDiscussionId;
      state.isCommenting = true;
      state.newCommentFocus = true;
    },
    patchNewDiscussion: function patchNewDiscussion(state, value) {
      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()(state.newDiscussion, value);
    },
    setIsCommenting: function setIsCommenting(state, value) {
      state.isCommenting = value;
      if (!value) {
        state.newDiscussionId = null;
      } else {
        state.newCommentFocus = true;
      }
    },
    setNewCommentText: function setNewCommentText(state, value) {
      state.newCommentText = value || '';
    },
    setNewCommentSelection: function setNewCommentSelection(state, value) {
      state.newCommentSelection = value;
    },
    setNewCommentFocus: function setNewCommentFocus(state, value) {
      state.newCommentFocus = value;
    },
    setStickyComment: function setStickyComment(state, value) {
      state.stickyComment = value;
    }
  },
  getters: {
    newDiscussion: function newDiscussion(_ref) {
      var currentDiscussionId = _ref.currentDiscussionId,
          newDiscussionId = _ref.newDiscussionId,
          _newDiscussion = _ref.newDiscussion;
      return currentDiscussionId === newDiscussionId && _newDiscussion;
    },
    currentFileDiscussionLastComments: function currentFileDiscussionLastComments(state, getters, rootState, rootGetters) {
      var _rootGetters$content = rootGetters['content/current'],
          discussions = _rootGetters$content.discussions,
          comments = _rootGetters$content.comments;

      var discussionLastComments = {};
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(comments).forEach(function (_ref2) {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
            comment = _ref3[1];

        if (discussions[comment.discussionId]) {
          var lastComment = discussionLastComments[comment.discussionId];
          if (!lastComment || lastComment.created < comment.created) {
            discussionLastComments[comment.discussionId] = comment;
          }
        }
      });
      return discussionLastComments;
    },
    currentFileDiscussions: function currentFileDiscussions(_ref4, _ref5, rootState, rootGetters) {
      var newDiscussionId = _ref4.newDiscussionId;
      var newDiscussion = _ref5.newDiscussion,
          currentFileDiscussionLastComments = _ref5.currentFileDiscussionLastComments;

      var currentFileDiscussions = {};
      if (newDiscussion) {
        currentFileDiscussions[newDiscussionId] = newDiscussion;
      }
      var discussions = rootGetters['content/current'].discussions;

      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(currentFileDiscussionLastComments).sort(function (_ref6, _ref7) {
        var _ref9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref6, 2),
            lastComment1 = _ref9[1];

        var _ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
            lastComment2 = _ref8[1];

        return lastComment1.created - lastComment2.created;
      }).forEach(function (_ref10) {
        var _ref11 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref10, 1),
            discussionId = _ref11[0];

        currentFileDiscussions[discussionId] = discussions[discussionId];
      });
      return currentFileDiscussions;
    },
    currentDiscussion: function currentDiscussion(_ref12, _ref13) {
      var currentDiscussionId = _ref12.currentDiscussionId;
      var currentFileDiscussions = _ref13.currentFileDiscussions;
      return currentFileDiscussions[currentDiscussionId];
    },
    previousDiscussionId: idShifter(-1),
    nextDiscussionId: idShifter(1),
    currentDiscussionComments: function currentDiscussionComments(_ref14, _ref15, rootState, rootGetters) {
      var currentDiscussionId = _ref14.currentDiscussionId;
      var currentDiscussion = _ref15.currentDiscussion;

      var comments = {};
      if (currentDiscussion) {
        var contentComments = rootGetters['content/current'].comments;
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(contentComments).filter(function (_ref16) {
          var _ref17 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref16, 2),
              comment = _ref17[1];

          return comment.discussionId === currentDiscussionId;
        }).sort(function (_ref18, _ref19) {
          var _ref21 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref18, 2),
              comment1 = _ref21[1];

          var _ref20 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref19, 2),
              comment2 = _ref20[1];

          return comment1.created - comment2.created;
        }).forEach(function (_ref22) {
          var _ref23 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref22, 2),
              commentId = _ref23[0],
              comment = _ref23[1];

          comments[commentId] = comment;
        });
      }
      return comments;
    },
    currentDiscussionLastCommentId: function currentDiscussionLastCommentId(state, _ref24) {
      var currentDiscussionComments = _ref24.currentDiscussionComments;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(currentDiscussionComments).pop();
    },
    currentDiscussionLastComment: function currentDiscussionLastComment(state, _ref25) {
      var currentDiscussionComments = _ref25.currentDiscussionComments,
          currentDiscussionLastCommentId = _ref25.currentDiscussionLastCommentId;
      return currentDiscussionComments[currentDiscussionLastCommentId];
    }
  },
  actions: {
    cancelNewComment: function cancelNewComment(_ref26) {
      var commit = _ref26.commit,
          getters = _ref26.getters;

      commit('setIsCommenting', false);
      if (!getters.currentDiscussion) {
        commit('setCurrentDiscussionId', getters.nextDiscussionId);
      }
    },
    createNewDiscussion: function createNewDiscussion(_ref27, selection) {
      var _this = this;

      var commit = _ref27.commit,
          dispatch = _ref27.dispatch,
          rootGetters = _ref27.rootGetters;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var loginToken, text, maxLength;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loginToken = rootGetters['workspace/loginToken'];

                if (loginToken) {
                  _context.next = 16;
                  break;
                }

                _context.prev = 2;
                _context.next = 5;
                return dispatch('modal/open', 'signInForComment', { root: true });

              case 5:
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_8__services_providers_helpers_googleHelper__["a" /* default */].signin();

              case 7:
                __WEBPACK_IMPORTED_MODULE_9__services_syncSvc__["a" /* default */].requestSync();
                _context.next = 10;
                return dispatch('createNewDiscussion', selection);

              case 10:
                _context.next = 14;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](2);

              case 14:
                _context.next = 17;
                break;

              case 16:
                if (selection) {
                  text = rootGetters['content/current'].text.slice(selection.start, selection.end).trim();
                  maxLength = 80;

                  if (text.length > maxLength) {
                    text = text.slice(0, maxLength - 1).trim() + '\u2026';
                  }
                  commit('setNewDiscussion', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, selection, { text: text }));
                }

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 12]]);
      }))();
    },
    cleanCurrentFile: function cleanCurrentFile(_ref28) {
      var getters = _ref28.getters,
          rootGetters = _ref28.rootGetters,
          commit = _ref28.commit,
          dispatch = _ref28.dispatch;

      var _ref29 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          filterComment = _ref29.filterComment,
          filterDiscussion = _ref29.filterDiscussion;

      var discussions = rootGetters['content/current'].discussions;
      var comments = rootGetters['content/current'].comments;

      var patch = {
        discussions: {},
        comments: {}
      };
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(comments).forEach(function (_ref30) {
        var _ref31 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref30, 2),
            commentId = _ref31[0],
            comment = _ref31[1];

        var discussion = discussions[comment.discussionId];
        if (discussion && comment !== filterComment && discussion !== filterDiscussion) {
          patch.discussions[comment.discussionId] = discussion;
          patch.comments[commentId] = comment;
        }
      });

      var nextDiscussionId = getters.nextDiscussionId;

      dispatch('content/patchCurrent', patch, { root: true });
      if (!getters.currentDiscussion) {
        commit('setCurrentDiscussionId', nextDiscussionId);
      }
    }
  }
});

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_empties_emptyFile__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_empties_emptyFolder__ = __webpack_require__(454);









var setter = function setter(propertyName) {
  return function (state, value) {
    state[propertyName] = value;
  };
};

function debounceAction(action, wait) {
  var timeoutId = void 0;
  return function (context) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(function () {
      return action(context);
    }, wait);
  };
}

var collator = new Intl.Collator(undefined, { sensitivity: 'base', numeric: true });
var compare = function compare(node1, node2) {
  return collator.compare(node1.item.name, node2.item.name);
};

var Node = function () {
  function Node(item) {
    var locations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var isFolder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Node);

    this.item = item;
    this.locations = locations;
    this.isFolder = isFolder;
    if (isFolder) {
      this.folders = [];
      this.files = [];
    }
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Node, [{
    key: 'sortChildren',
    value: function sortChildren() {
      if (this.isFolder) {
        this.folders.sort(compare);
        this.files.sort(compare);
        this.folders.forEach(function (child) {
          return child.sortChildren();
        });
      }
    }
  }]);

  return Node;
}();

var nilFileNode = new Node(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__data_empties_emptyFile__["a" /* default */])());
nilFileNode.isNil = true;
var fakeFileNode = new Node(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__data_empties_emptyFile__["a" /* default */])());
fakeFileNode.item.id = 'fake';
fakeFileNode.noDrag = true;

function getParent(_ref, _ref2) {
  var item = _ref.item,
      isNil = _ref.isNil;
  var nodeMap = _ref2.nodeMap,
      rootNode = _ref2.rootNode;

  if (isNil) {
    return nilFileNode;
  }
  return nodeMap[item.parentId] || rootNode;
}

function getFolder(node, getters) {
  return node.item.type === 'folder' ? node : getParent(node, getters);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    selectedId: null,
    editingId: null,
    dragSourceId: null,
    dragTargetId: null,
    newChildNode: nilFileNode,
    openNodes: {}
  },
  mutations: {
    setSelectedId: setter('selectedId'),
    setEditingId: setter('editingId'),
    setDragSourceId: setter('dragSourceId'),
    setDragTargetId: setter('dragTargetId'),
    setNewItem: function setNewItem(state, item) {
      state.newChildNode = item ? new Node(item, [], item.type === 'folder') : nilFileNode;
    },
    setNewItemName: function setNewItemName(state, name) {
      state.newChildNode.item.name = name;
    },
    toggleOpenNode: function toggleOpenNode(state, id) {
      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].set(state.openNodes, id, !state.openNodes[id]);
    }
  },
  getters: {
    nodeStructure: function nodeStructure(state, getters, rootState, rootGetters) {
      var rootNode = new Node(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__data_empties_emptyFolder__["a" /* default */])(), [], true);
      rootNode.isRoot = true;

      var trashFolderNode = new Node(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__data_empties_emptyFolder__["a" /* default */])(), [], true);
      trashFolderNode.item.id = 'trash';
      trashFolderNode.item.name = 'Trash';
      trashFolderNode.noDrag = true;
      trashFolderNode.isTrash = true;
      trashFolderNode.parentNode = rootNode;

      var tempFolderNode = new Node(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__data_empties_emptyFolder__["a" /* default */])(), [], true);
      tempFolderNode.item.id = 'temp';
      tempFolderNode.item.name = 'Temp';
      tempFolderNode.noDrag = true;
      tempFolderNode.noDrop = true;
      tempFolderNode.isTemp = true;
      tempFolderNode.parentNode = rootNode;

      var nodeMap = {
        trash: trashFolderNode,
        temp: tempFolderNode
      };
      rootGetters['folder/items'].forEach(function (item) {
        nodeMap[item.id] = new Node(item, [], true);
      });
      var syncLocationsByFileId = rootGetters['syncLocation/filteredGroupedByFileId'];
      var publishLocationsByFileId = rootGetters['publishLocation/filteredGroupedByFileId'];
      rootGetters['file/items'].forEach(function (item) {
        var locations = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(syncLocationsByFileId[item.id] || []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(publishLocationsByFileId[item.id] || []));
        nodeMap[item.id] = new Node(item, locations);
      });

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(nodeMap).forEach(function (_ref3) {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
            node = _ref4[1];

        var parentNode = nodeMap[node.item.parentId];
        if (!parentNode || !parentNode.isFolder) {
          if (node.isTrash || node.isTemp) {
            return;
          }
          parentNode = rootNode;
        }
        if (node.isFolder) {
          parentNode.folders.push(node);
        } else {
          parentNode.files.push(node);
        }
        node.parentNode = parentNode;
      });
      rootNode.sortChildren();

      rootNode.folders.unshift(tempFolderNode);
      tempFolderNode.files.forEach(function (node) {
        node.noDrop = true;
      });
      rootNode.folders.unshift(trashFolderNode);

      rootNode.files.push(fakeFileNode);
      return {
        nodeMap: nodeMap,
        rootNode: rootNode
      };
    },
    nodeMap: function nodeMap(state, _ref5) {
      var nodeStructure = _ref5.nodeStructure;
      return nodeStructure.nodeMap;
    },
    rootNode: function rootNode(state, _ref6) {
      var nodeStructure = _ref6.nodeStructure;
      return nodeStructure.rootNode;
    },
    newChildNodeParent: function newChildNodeParent(state, getters) {
      return getParent(state.newChildNode, getters);
    },
    selectedNode: function selectedNode(_ref7, _ref8) {
      var selectedId = _ref7.selectedId;
      var nodeMap = _ref8.nodeMap;
      return nodeMap[selectedId] || nilFileNode;
    },
    selectedNodeFolder: function selectedNodeFolder(state, getters) {
      return getFolder(getters.selectedNode, getters);
    },
    editingNode: function editingNode(_ref9, _ref10) {
      var editingId = _ref9.editingId;
      var nodeMap = _ref10.nodeMap;
      return nodeMap[editingId] || nilFileNode;
    },
    dragSourceNode: function dragSourceNode(_ref11, _ref12) {
      var dragSourceId = _ref11.dragSourceId;
      var nodeMap = _ref12.nodeMap;
      return nodeMap[dragSourceId] || nilFileNode;
    },
    dragTargetNode: function dragTargetNode(_ref13, _ref14) {
      var dragTargetId = _ref13.dragTargetId;
      var nodeMap = _ref14.nodeMap;

      if (dragTargetId === 'fake') {
        return fakeFileNode;
      }
      return nodeMap[dragTargetId] || nilFileNode;
    },
    dragTargetNodeFolder: function dragTargetNodeFolder(_ref15, getters) {
      var dragTargetId = _ref15.dragTargetId;

      if (dragTargetId === 'fake') {
        return getters.rootNode;
      }
      return getFolder(getters.dragTargetNode, getters);
    }
  },
  actions: {
    openNode: function openNode(_ref16, id) {
      var state = _ref16.state,
          getters = _ref16.getters,
          commit = _ref16.commit,
          dispatch = _ref16.dispatch;

      var node = getters.nodeMap[id];
      if (node) {
        if (node.isFolder && !state.openNodes[id]) {
          commit('toggleOpenNode', id);
        }
        dispatch('openNode', node.item.parentId);
      }
    },

    openDragTarget: debounceAction(function (_ref17) {
      var state = _ref17.state,
          dispatch = _ref17.dispatch;

      dispatch('openNode', state.dragTargetId);
    }, 1000),
    setDragTarget: function setDragTarget(_ref18, node) {
      var commit = _ref18.commit,
          getters = _ref18.getters,
          dispatch = _ref18.dispatch;

      if (!node) {
        commit('setDragTargetId');
      } else {
        var folderNode = getFolder(node, getters);
        var sourceId = getters.dragSourceNode.item.id;
        var nodeMap = getters.nodeMap;

        for (var parentNode = folderNode; parentNode; parentNode = nodeMap[parentNode.item.parentId]) {
          if (parentNode.item.id === sourceId) {
            commit('setDragTargetId');
            return;
          }
        }

        commit('setDragTargetId', node.item.id);
        dispatch('openDragTarget');
      }
    }
  }
});

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__moduleTemplate__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_empties_emptyFile__ = __webpack_require__(453);




var module = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__moduleTemplate__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__data_empties_emptyFile__["a" /* default */]);

module.state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, module.state, {
  currentId: null
});

module.getters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, module.getters, {
  current: function current(_ref) {
    var itemsById = _ref.itemsById,
        currentId = _ref.currentId;
    return itemsById[currentId] || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_empties_emptyFile__["a" /* default */])();
  },
  isCurrentTemp: function isCurrentTemp(state, _ref2) {
    var current = _ref2.current;
    return current.parentId === 'temp';
  },
  lastOpened: function lastOpened(_ref3, _ref4, rootState, rootGetters) {
    var itemsById = _ref3.itemsById;
    var items = _ref4.items;
    return itemsById[rootGetters['data/lastOpenedIds'][0]] || items[0] || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_empties_emptyFile__["a" /* default */])();
  }
});

module.mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, module.mutations, {
  setCurrentId: function setCurrentId(state, value) {
    state.currentId = value;
  }
});

module.actions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, module.actions, {
  patchCurrent: function patchCurrent(_ref5, value) {
    var getters = _ref5.getters,
        commit = _ref5.commit;

    commit('patchItem', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, value, {
      id: getters.current.id
    }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    type: null,
    lastOpen: 0,
    findText: '',
    replaceText: ''
  },
  mutations: {
    setType: function setType(state, value) {
      state.type = value;
    },
    setLastOpen: function setLastOpen(state) {
      state.lastOpen = Date.now();
    },
    setFindText: function setFindText(state, value) {
      state.findText = value;
    },
    setReplaceText: function setReplaceText(state, value) {
      state.replaceText = value;
    }
  },
  actions: {
    open: function open(_ref, _ref2) {
      var commit = _ref.commit;
      var type = _ref2.type,
          findText = _ref2.findText;

      commit('setType', type);
      if (findText) {
        commit('setFindText', findText);
      }
      commit('setLastOpen');
    }
  }
});

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__moduleTemplate__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_empties_emptyFolder__ = __webpack_require__(454);



var module = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__moduleTemplate__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__data_empties_emptyFolder__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_pagedownButtons__ = __webpack_require__(455);


var buttonCount = 2;
var spacerCount = 0;
__WEBPACK_IMPORTED_MODULE_0__data_pagedownButtons__["a" /* default */].forEach(function (button) {
  if (button.method) {
    buttonCount += 1;
  } else {
    spacerCount += 1;
  }
});

var minPadding = 25;
var editorTopPadding = 10;
var navigationBarEditButtonsWidth = 34 * buttonCount + 8 * spacerCount;
var navigationBarLeftButtonWidth = 38 + 4 + 12;
var navigationBarRightButtonWidth = 38 + 8;
var navigationBarSpinnerWidth = 24 + 8 + 5;
var navigationBarLocationWidth = 20;
var navigationBarSyncPublishButtonsWidth = 34 + 10;
var navigationBarTitleMargin = 8;
var maxTitleMaxWidth = 800;
var minTitleMaxWidth = 200;

var _constants = {
  editorMinWidth: 320,
  explorerWidth: 260,
  gutterWidth: 250,
  sideBarWidth: 280,
  navigationBarHeight: 44,
  buttonBarWidth: 26,
  statusBarHeight: 20
};

function computeStyles(state, getters) {
  var layoutSettings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getters['data/layoutSettings'];
  var styles = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    showNavigationBar: layoutSettings.showNavigationBar || !layoutSettings.showEditor || state.content.revisionContent || state.light,
    showStatusBar: layoutSettings.showStatusBar,
    showEditor: layoutSettings.showEditor,
    showSidePreview: layoutSettings.showSidePreview && layoutSettings.showEditor,
    showPreview: layoutSettings.showSidePreview || !layoutSettings.showEditor,
    showSideBar: layoutSettings.showSideBar && !state.light,
    showExplorer: layoutSettings.showExplorer && !state.light,
    layoutOverflow: false,
    hideLocations: state.light
  };

  styles.innerHeight = state.layout.bodyHeight;
  if (styles.showNavigationBar) {
    styles.innerHeight -= _constants.navigationBarHeight;
  }
  if (styles.showStatusBar) {
    styles.innerHeight -= _constants.statusBarHeight;
  }

  styles.innerWidth = state.layout.bodyWidth;
  if (styles.innerWidth < _constants.editorMinWidth + _constants.gutterWidth + _constants.buttonBarWidth) {
    styles.layoutOverflow = true;
  }
  if (styles.showSideBar) {
    styles.innerWidth -= _constants.sideBarWidth;
  }
  if (styles.showExplorer) {
    styles.innerWidth -= _constants.explorerWidth;
  }

  var doublePanelWidth = styles.innerWidth - _constants.buttonBarWidth;

  var showGutter = !getters['file/isCurrentTemp'] && !!getters['discussion/currentDiscussion'];
  if (showGutter) {
    doublePanelWidth -= _constants.gutterWidth;
  }
  if (doublePanelWidth < _constants.editorMinWidth) {
    doublePanelWidth = _constants.editorMinWidth;
  }

  if (styles.showSidePreview && doublePanelWidth / 2 < _constants.editorMinWidth) {
    styles.showSidePreview = false;
    styles.showPreview = false;
    styles.layoutOverflow = false;
    return computeStyles(state, getters, layoutSettings, styles);
  }

  var computedSettings = getters['data/computedSettings'];
  styles.fontSize = 18;
  styles.textWidth = 990;
  if (doublePanelWidth < 1120) {
    styles.fontSize -= 1;
    styles.textWidth = 910;
  }
  if (doublePanelWidth < 1040) {
    styles.textWidth = 830;
  }
  styles.textWidth *= computedSettings.maxWidthFactor;
  if (doublePanelWidth < styles.textWidth) {
    styles.textWidth = doublePanelWidth;
  }
  if (styles.textWidth < 640) {
    styles.fontSize -= 1;
  }
  styles.fontSize *= computedSettings.fontSizeFactor;

  var bottomPadding = Math.floor(styles.innerHeight / 2);
  var panelWidth = Math.floor(doublePanelWidth / 2);
  styles.previewWidth = styles.showSidePreview ? panelWidth : doublePanelWidth;
  var previewRightPadding = Math.max(Math.floor((styles.previewWidth - styles.textWidth) / 2), minPadding);
  if (!styles.showSidePreview) {
    styles.previewWidth += _constants.buttonBarWidth;
  }
  styles.previewGutterWidth = showGutter && !layoutSettings.showEditor ? _constants.gutterWidth : 0;
  var previewLeftPadding = previewRightPadding + styles.previewGutterWidth;
  styles.previewGutterLeft = previewLeftPadding - minPadding;
  styles.previewPadding = editorTopPadding + 'px ' + previewRightPadding + 'px ' + bottomPadding + 'px ' + previewLeftPadding + 'px';
  styles.editorWidth = styles.showSidePreview ? panelWidth : doublePanelWidth;
  var editorRightPadding = Math.max(Math.floor((styles.editorWidth - styles.textWidth) / 2), minPadding);
  styles.editorGutterWidth = showGutter && layoutSettings.showEditor ? _constants.gutterWidth : 0;
  var editorLeftPadding = editorRightPadding + styles.editorGutterWidth;
  styles.editorGutterLeft = editorLeftPadding - minPadding;
  styles.editorPadding = editorTopPadding + 'px ' + editorRightPadding + 'px ' + bottomPadding + 'px ' + editorLeftPadding + 'px';

  styles.titleMaxWidth = styles.innerWidth - navigationBarLeftButtonWidth - navigationBarRightButtonWidth - navigationBarSpinnerWidth;
  if (styles.showEditor) {
    var syncLocations = getters['syncLocation/current'];
    var publishLocations = getters['publishLocation/current'];
    styles.titleMaxWidth -= navigationBarEditButtonsWidth + navigationBarLocationWidth * (syncLocations.length + publishLocations.length) + navigationBarSyncPublishButtonsWidth * 2 + navigationBarTitleMargin;
    if (styles.titleMaxWidth + navigationBarEditButtonsWidth < minTitleMaxWidth) {
      styles.hideLocations = true;
    }
  }
  styles.titleMaxWidth = Math.max(minTitleMaxWidth, Math.min(maxTitleMaxWidth, styles.titleMaxWidth));
  return styles;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    canUndo: false,
    canRedo: false,
    bodyWidth: 0,
    bodyHeight: 0
  },
  mutations: {
    setCanUndo: function setCanUndo(state, value) {
      state.canUndo = value;
    },
    setCanRedo: function setCanRedo(state, value) {
      state.canRedo = value;
    },
    updateBodySize: function updateBodySize(state) {
      state.bodyWidth = document.body.clientWidth;
      state.bodyHeight = document.body.clientHeight;
    }
  },
  getters: {
    constants: function constants() {
      return _constants;
    },
    styles: function styles(state, getters, rootState, rootGetters) {
      return computeStyles(rootState, rootGetters);
    }
  },
  actions: {
    updateBodySize: function updateBodySize(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch,
          rootGetters = _ref.rootGetters;

      commit('updateBodySize');

      var layoutSettings = rootGetters['data/layoutSettings'];
      dispatch('data/toggleExplorer', layoutSettings.showExplorer, { root: true });
    }
  }
});

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__moduleTemplate__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_providers_common_providerRegistry__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_utils__ = __webpack_require__(4);






var addToGroup = function addToGroup(groups, item) {
  var list = groups[item.fileId];
  if (!list) {
    groups[item.fileId] = [item];
  } else {
    list.push(item);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function (empty) {
  var module = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__moduleTemplate__["a" /* default */])(empty);

  module.getters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, module.getters, {
    groupedByFileId: function groupedByFileId(state, _ref) {
      var items = _ref.items;

      var groups = {};
      items.forEach(function (item) {
        return addToGroup(groups, item);
      });
      return groups;
    },
    groupedByFileIdAndHash: function groupedByFileIdAndHash(state, _ref2) {
      var items = _ref2.items;

      var fileIdGroups = {};
      items.forEach(function (item) {
        var hashGroups = fileIdGroups[item.fileId];
        if (!hashGroups) {
          hashGroups = {};
          fileIdGroups[item.fileId] = hashGroups;
        }
        var list = hashGroups[item.hash];
        if (!list) {
          hashGroups[item.hash] = [item];
        } else {
          list.push(item);
        }
      });
      return fileIdGroups;
    },
    filteredGroupedByFileId: function filteredGroupedByFileId(state, _ref3) {
      var items = _ref3.items;

      var groups = {};
      items.filter(function (item) {
        var provider = __WEBPACK_IMPORTED_MODULE_3__services_providers_common_providerRegistry__["a" /* default */].providersById[item.providerId];
        return provider && provider.getToken(item);
      }).forEach(function (item) {
        return addToGroup(groups, item);
      });
      return groups;
    },
    current: function current(state, _ref4, rootState, rootGetters) {
      var filteredGroupedByFileId = _ref4.filteredGroupedByFileId;

      var locations = filteredGroupedByFileId[rootGetters['file/current'].id] || [];
      return locations.map(function (location) {
        var provider = __WEBPACK_IMPORTED_MODULE_3__services_providers_common_providerRegistry__["a" /* default */].providersById[location.providerId];
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, location, {
          description: __WEBPACK_IMPORTED_MODULE_4__services_utils__["a" /* default */].sanitizeName(provider.getLocationDescription(location)),
          url: provider.getLocationUrl(location)
        });
      });
    },
    currentWithWorkspaceSyncLocation: function currentWithWorkspaceSyncLocation(state, _ref5, rootState, rootGetters) {
      var current = _ref5.current;

      var fileId = rootGetters['file/current'].id;
      var fileSyncData = rootGetters['data/syncDataByItemId'][fileId];
      var contentSyncData = rootGetters['data/syncDataByItemId'][fileId + '/content'];
      if (!fileSyncData || !contentSyncData) {
        return current;
      }

      var workspaceProvider = __WEBPACK_IMPORTED_MODULE_3__services_providers_common_providerRegistry__["a" /* default */].providersById[rootGetters['workspace/currentWorkspace'].providerId];
      return [{
        id: 'main',
        providerId: workspaceProvider.id,
        fileId: fileId,
        description: __WEBPACK_IMPORTED_MODULE_4__services_utils__["a" /* default */].sanitizeName(workspaceProvider.getSyncDataDescription(fileSyncData, contentSyncData)),
        url: workspaceProvider.getSyncDataUrl(fileSyncData, contentSyncData)
      }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(current));
    }
  });

  return module;
});

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);






/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    stack: [],
    hidden: false
  },
  mutations: {
    setStack: function setStack(state, value) {
      state.stack = value;
    },
    setHidden: function setHidden(state, value) {
      state.hidden = value;
    }
  },
  getters: {
    config: function config(_ref) {
      var hidden = _ref.hidden,
          stack = _ref.stack;
      return !hidden && stack[0];
    }
  },
  actions: {
    open: function open(_ref2, param) {
      var _this = this;

      var commit = _ref2.commit,
          state = _ref2.state;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var config;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                config = (typeof param === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(param)) === 'object' ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, param) : { type: param };
                _context.prev = 1;
                _context.next = 4;
                return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  config.resolve = resolve;
                  config.reject = reject;
                  commit('setStack', [config].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.stack)));
                });

              case 4:
                return _context.abrupt('return', _context.sent);

              case 5:
                _context.prev = 5;

                commit('setStack', state.stack.filter(function (otherConfig) {
                  return otherConfig !== config;
                }));
                return _context.finish(5);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1,, 5, 8]]);
      }))();
    },
    hideUntil: function hideUntil(_ref3, promise) {
      var _this2 = this;

      var commit = _ref3.commit;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                commit('setHidden', true);
                _context2.next = 4;
                return promise;

              case 4:
                return _context2.abrupt('return', _context2.sent);

              case 5:
                _context2.prev = 5;

                commit('setHidden', false);
                return _context2.finish(5);

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0,, 5, 8]]);
      }))();
    }
  }
});

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_providers_common_providerRegistry__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_utils__ = __webpack_require__(4);





var defaultTimeout = 5000;

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    items: []
  },
  mutations: {
    setItems: function setItems(state, value) {
      state.items = value;
    }
  },
  actions: {
    showItem: function showItem(_ref, item) {
      var state = _ref.state,
          commit = _ref.commit;

      var existingItem = __WEBPACK_IMPORTED_MODULE_3__services_utils__["a" /* default */].someResult(state.items, function (other) {
        return other.type === item.type && other.content === item.content && item;
      });
      if (existingItem) {
        return existingItem.promise;
      }

      item.promise = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        commit('setItems', [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.items), [item]));
        var removeItem = function removeItem() {
          return commit('setItems', state.items.filter(function (otherItem) {
            return otherItem !== item;
          }));
        };
        setTimeout(function () {
          return removeItem();
        }, item.timeout || defaultTimeout);
        item.resolve = function (res) {
          removeItem();
          resolve(res);
        };
        item.reject = function (err) {
          removeItem();
          reject(err);
        };
      });

      return item.promise;
    },
    info: function info(_ref2, content) {
      var dispatch = _ref2.dispatch;

      return dispatch('showItem', {
        type: 'info',
        content: content
      });
    },
    badge: function badge(_ref3, content) {
      var dispatch = _ref3.dispatch;

      return dispatch('showItem', {
        type: 'badge',
        content: content
      });
    },
    confirm: function confirm(_ref4, content) {
      var dispatch = _ref4.dispatch;

      return dispatch('showItem', {
        type: 'confirm',
        content: content,
        timeout: 10000 });
    },
    error: function error(_ref5, _error) {
      var dispatch = _ref5.dispatch,
          rootState = _ref5.rootState;

      var item = { type: 'error' };
      if (_error) {
        if (_error.message) {
          item.content = _error.message;
        } else if (_error.status) {
          var location = rootState.queue.currentLocation;
          if (location.providerId) {
            var provider = __WEBPACK_IMPORTED_MODULE_2__services_providers_common_providerRegistry__["a" /* default */].providersById[location.providerId];
            item.content = 'HTTP error ' + _error.status + ' on ' + provider.name + ' location.';
          } else {
            item.content = 'HTTP error ' + _error.status + '.';
          }
        } else {
          item.content = '' + _error;
        }
      }
      if (!item.content || item.content === '[object Object]') {
        item.content = 'Unknown error.';
      }
      return dispatch('showItem', item);
    }
  }
});

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);



var setter = function setter(propertyName) {
  return function (state, value) {
    state[propertyName] = value;
  };
};

var queue = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    isEmpty: true,
    isSyncRequested: false,
    isPublishRequested: false,
    currentLocation: {}
  },
  mutations: {
    setIsEmpty: setter('isEmpty'),
    setIsSyncRequested: setter('isSyncRequested'),
    setIsPublishRequested: setter('isPublishRequested'),
    setCurrentLocation: setter('currentLocation')
  },
  actions: {
    enqueue: function enqueue(_ref, cb) {
      var state = _ref.state,
          commit = _ref.commit,
          dispatch = _ref.dispatch;

      if (state.offline) {
        return;
      }
      var checkOffline = function checkOffline() {
        if (state.offline) {
          queue = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
          commit('setIsEmpty', true);
          throw new Error('offline');
        }
      };
      if (state.isEmpty) {
        commit('setIsEmpty', false);
      }
      var newQueue = queue.then(function () {
        return checkOffline();
      }).then(function () {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve().then(function () {
          return cb();
        }).catch(function (err) {
          console.error(err);
          checkOffline();
          dispatch('notification/error', err, { root: true });
        }).then(function () {
          if (newQueue === queue) {
            commit('setIsEmpty', true);
          }
        });
      });
      queue = newQueue;
    },
    enqueueSyncRequest: function enqueueSyncRequest(_ref2, cb) {
      var state = _ref2.state,
          commit = _ref2.commit,
          dispatch = _ref2.dispatch;

      if (!state.isSyncRequested) {
        commit('setIsSyncRequested', true);
        var unset = function unset() {
          return commit('setIsSyncRequested', false);
        };
        dispatch('enqueue', function () {
          return cb().then(unset, function (err) {
            unset();
            throw err;
          });
        });
      }
    },
    enqueuePublishRequest: function enqueuePublishRequest(_ref3, cb) {
      var state = _ref3.state,
          commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      if (!state.isSyncRequested) {
        commit('setIsPublishRequested', true);
        var unset = function unset() {
          return commit('setIsPublishRequested', false);
        };
        dispatch('enqueue', function () {
          return cb().then(unset, function (err) {
            unset();
            throw err;
          });
        });
      }
    },
    doWithLocation: function doWithLocation(_ref4, _ref5) {
      var _this = this;

      var commit = _ref4.commit;
      var location = _ref5.location,
          action = _ref5.action;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                commit('setCurrentLocation', location);
                _context.next = 4;
                return action();

              case 4:
                return _context.abrupt('return', _context.sent);

              case 5:
                _context.prev = 5;

                commit('setCurrentLocation', {});
                return _context.finish(5);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0,, 5, 8]]);
      }))();
    }
  }
});

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__moduleTemplate__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_empties_emptySyncedContent__ = __webpack_require__(977);




var module = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__moduleTemplate__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__data_empties_emptySyncedContent__["a" /* default */], true);

module.getters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, module.getters, {
  current: function current(_ref, getters, rootState, rootGetters) {
    var itemsById = _ref.itemsById;
    return itemsById[rootGetters['file/current'].id + '/syncedContent'] || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_empties_emptySyncedContent__["a" /* default */])();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(56);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    itemsById: {}
  },
  mutations: {
    setItem: function setItem(_ref, item) {
      var itemsById = _ref.itemsById;

      var itemToSet = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);
      var existingItem = itemsById[item.id];
      if (existingItem) {
        if (!itemToSet.name) {
          itemToSet.name = existingItem.name;
        }
        if (!itemToSet.imageUrl) {
          itemToSet.imageUrl = existingItem.imageUrl;
        }
      }
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(itemsById, item.id, itemToSet);
    }
  }
});

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_providers_common_providerRegistry__ = __webpack_require__(104);







/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    currentWorkspaceId: null,
    lastFocus: 0
  },
  mutations: {
    setCurrentWorkspaceId: function setCurrentWorkspaceId(state, value) {
      state.currentWorkspaceId = value;
    },
    setLastFocus: function setLastFocus(state, value) {
      state.lastFocus = value;
    }
  },
  getters: {
    workspacesById: function workspacesById(state, getters, rootState, rootGetters) {
      var workspacesById = {};
      var mainWorkspaceToken = rootGetters['workspace/mainWorkspaceToken'];
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(rootGetters['data/workspaces']).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            id = _ref2[0],
            workspace = _ref2[1];

        var sanitizedWorkspace = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          id: id,
          providerId: 'googleDriveAppData',
          sub: mainWorkspaceToken && mainWorkspaceToken.sub
        }, workspace);

        var workspaceProvider = __WEBPACK_IMPORTED_MODULE_5__services_providers_common_providerRegistry__["a" /* default */].providersById[sanitizedWorkspace.providerId];
        if (workspaceProvider) {
          var params = workspaceProvider.getWorkspaceParams(sanitizedWorkspace);
          sanitizedWorkspace.url = __WEBPACK_IMPORTED_MODULE_4__services_utils__["a" /* default */].addQueryParams('app', params, true);
          sanitizedWorkspace.locationUrl = workspaceProvider.getWorkspaceLocationUrl(sanitizedWorkspace);
          workspacesById[id] = sanitizedWorkspace;
        }
      });
      return workspacesById;
    },
    mainWorkspace: function mainWorkspace(state, _ref3) {
      var workspacesById = _ref3.workspacesById;
      return workspacesById.main;
    },
    currentWorkspace: function currentWorkspace(_ref4, _ref5) {
      var currentWorkspaceId = _ref4.currentWorkspaceId;
      var workspacesById = _ref5.workspacesById,
          mainWorkspace = _ref5.mainWorkspace;
      return workspacesById[currentWorkspaceId] || mainWorkspace;
    },
    currentWorkspaceIsGit: function currentWorkspaceIsGit(state, _ref6) {
      var currentWorkspace = _ref6.currentWorkspace;
      return currentWorkspace.providerId === 'githubWorkspace' || currentWorkspace.providerId === 'gitlabWorkspace';
    },
    currentWorkspaceHasUniquePaths: function currentWorkspaceHasUniquePaths(state, _ref7) {
      var currentWorkspace = _ref7.currentWorkspace;
      return currentWorkspace.providerId === 'githubWorkspace' || currentWorkspace.providerId === 'gitlabWorkspace';
    },
    lastSyncActivityKey: function lastSyncActivityKey(state, _ref8) {
      var currentWorkspace = _ref8.currentWorkspace;
      return currentWorkspace.id + '/lastSyncActivity';
    },
    lastFocusKey: function lastFocusKey(state, _ref9) {
      var currentWorkspace = _ref9.currentWorkspace;
      return currentWorkspace.id + '/lastWindowFocus';
    },
    mainWorkspaceToken: function mainWorkspaceToken(state, getters, rootState, rootGetters) {
      return __WEBPACK_IMPORTED_MODULE_4__services_utils__["a" /* default */].someResult(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(rootGetters['data/googleTokensBySub']), function (token) {
        if (token.isLogin) {
          return token;
        }
        return null;
      });
    },
    syncToken: function syncToken(state, _ref10, rootState, rootGetters) {
      var currentWorkspace = _ref10.currentWorkspace,
          mainWorkspaceToken = _ref10.mainWorkspaceToken;

      switch (currentWorkspace.providerId) {
        case 'googleDriveWorkspace':
          return rootGetters['data/googleTokensBySub'][currentWorkspace.sub];
        case 'githubWorkspace':
          return rootGetters['data/githubTokensBySub'][currentWorkspace.sub];
        case 'gitlabWorkspace':
          return rootGetters['data/gitlabTokensBySub'][currentWorkspace.sub];
        case 'couchdbWorkspace':
          return rootGetters['data/couchdbTokensBySub'][currentWorkspace.id];
        default:
          return mainWorkspaceToken;
      }
    },
    loginType: function loginType(state, _ref11) {
      var currentWorkspace = _ref11.currentWorkspace;

      switch (currentWorkspace.providerId) {
        case 'googleDriveWorkspace':
        default:
          return 'google';
        case 'githubWorkspace':
          return 'github';
        case 'gitlabWorkspace':
          return 'gitlab';
      }
    },
    loginToken: function loginToken(state, _ref12, rootState, rootGetters) {
      var loginType = _ref12.loginType,
          currentWorkspace = _ref12.currentWorkspace;

      var tokensBySub = rootGetters['data/tokensByType'][loginType];
      return tokensBySub && tokensBySub[currentWorkspace.sub];
    },
    sponsorToken: function sponsorToken(state, _ref13) {
      var mainWorkspaceToken = _ref13.mainWorkspaceToken;
      return mainWorkspaceToken;
    }
  },
  actions: {
    removeWorkspace: function removeWorkspace(_ref14, id) {
      var commit = _ref14.commit,
          rootGetters = _ref14.rootGetters;

      var workspaces = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rootGetters['data/workspaces']);
      delete workspaces[id];
      commit('data/setItem', { id: 'workspaces', data: workspaces }, { root: true });
    },
    patchWorkspacesById: function patchWorkspacesById(_ref15, workspaces) {
      var commit = _ref15.commit,
          rootGetters = _ref15.rootGetters;

      var sanitizedWorkspaces = {};
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rootGetters['data/workspaces'], workspaces)).forEach(function (_ref16) {
        var _ref17 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref16, 2),
            id = _ref17[0],
            workspace = _ref17[1];

        sanitizedWorkspaces[id] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, workspace, {
          id: id,

          url: undefined,
          locationUrl: undefined
        });
      });

      commit('data/setItem', { id: 'workspaces', data: sanitizedWorkspaces }, { root: true });
    },
    setCurrentWorkspaceId: function setCurrentWorkspaceId(_ref18, value) {
      var commit = _ref18.commit,
          getters = _ref18.getters;

      commit('setCurrentWorkspaceId', value);
      var lastFocus = parseInt(localStorage.getItem(getters.lastFocusKey), 10) || 0;
      commit('setLastFocus', lastFocus);
    }
  }
});

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_katex_dist_katex_css__ = __webpack_require__(1933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_katex_dist_katex_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_katex_dist_katex_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fonts_scss__ = __webpack_require__(1930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fonts_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fonts_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prism_scss__ = __webpack_require__(1932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prism_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__prism_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_scss__ = __webpack_require__(1929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__base_scss__);





/***/ }),
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 1926 */,
/* 1927 */,
/* 1928 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1929 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1930 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1931 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1932 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1933 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */,
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */,
/* 1994 */,
/* 1995 */,
/* 1996 */,
/* 1997 */,
/* 1998 */,
/* 1999 */,
/* 2000 */,
/* 2001 */,
/* 2002 */,
/* 2003 */,
/* 2004 */,
/* 2005 */,
/* 2006 */,
/* 2007 */,
/* 2008 */,
/* 2009 */,
/* 2010 */,
/* 2011 */,
/* 2012 */,
/* 2013 */,
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */,
/* 2039 */,
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */,
/* 2044 */,
/* 2045 */,
/* 2046 */,
/* 2047 */,
/* 2048 */,
/* 2049 */,
/* 2050 */,
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */,
/* 2058 */,
/* 2059 */,
/* 2060 */,
/* 2061 */,
/* 2062 */,
/* 2063 */,
/* 2064 */,
/* 2065 */,
/* 2066 */,
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */,
/* 2079 */,
/* 2080 */,
/* 2081 */,
/* 2082 */,
/* 2083 */,
/* 2084 */,
/* 2085 */,
/* 2086 */,
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */,
/* 2091 */,
/* 2092 */,
/* 2093 */,
/* 2094 */,
/* 2095 */,
/* 2096 */,
/* 2097 */,
/* 2098 */,
/* 2099 */,
/* 2100 */,
/* 2101 */,
/* 2102 */,
/* 2103 */,
/* 2104 */,
/* 2105 */,
/* 2106 */,
/* 2107 */,
/* 2108 */,
/* 2109 */,
/* 2110 */,
/* 2111 */,
/* 2112 */,
/* 2113 */,
/* 2114 */,
/* 2115 */,
/* 2116 */,
/* 2117 */,
/* 2118 */,
/* 2119 */,
/* 2120 */,
/* 2121 */,
/* 2122 */,
/* 2123 */,
/* 2124 */,
/* 2125 */,
/* 2126 */,
/* 2127 */,
/* 2128 */,
/* 2129 */,
/* 2130 */,
/* 2131 */
/***/ (function(module, exports) {

module.exports = {"100":"💯","1234":"🔢","grinning":"😀","smiley":"😃","smile":"😄","grin":"😁","laughing":"😆","satisfied":"😆","sweat_smile":"😅","joy":"😂","rofl":"🤣","relaxed":"☺️","blush":"😊","innocent":"😇","slightly_smiling_face":"🙂","upside_down_face":"🙃","wink":"😉","relieved":"😌","heart_eyes":"😍","kissing_heart":"😘","kissing":"😗","kissing_smiling_eyes":"😙","kissing_closed_eyes":"😚","yum":"😋","stuck_out_tongue_winking_eye":"😜","stuck_out_tongue_closed_eyes":"😝","stuck_out_tongue":"😛","money_mouth_face":"🤑","hugs":"🤗","nerd_face":"🤓","sunglasses":"😎","clown_face":"🤡","cowboy_hat_face":"🤠","smirk":"😏","unamused":"😒","disappointed":"😞","pensive":"😔","worried":"😟","confused":"😕","slightly_frowning_face":"🙁","frowning_face":"☹️","persevere":"😣","confounded":"😖","tired_face":"😫","weary":"😩","triumph":"😤","angry":"😠","rage":"😡","pout":"😡","no_mouth":"😶","neutral_face":"😐","expressionless":"😑","hushed":"😯","frowning":"😦","anguished":"😧","open_mouth":"😮","astonished":"😲","dizzy_face":"😵","flushed":"😳","scream":"😱","fearful":"😨","cold_sweat":"😰","cry":"😢","disappointed_relieved":"😥","drooling_face":"🤤","sob":"😭","sweat":"😓","sleepy":"😪","sleeping":"😴","roll_eyes":"🙄","thinking":"🤔","lying_face":"🤥","grimacing":"😬","zipper_mouth_face":"🤐","nauseated_face":"🤢","sneezing_face":"🤧","mask":"😷","face_with_thermometer":"🤒","face_with_head_bandage":"🤕","smiling_imp":"😈","imp":"👿","japanese_ogre":"👹","japanese_goblin":"👺","hankey":"💩","poop":"💩","shit":"💩","ghost":"👻","skull":"💀","skull_and_crossbones":"☠️","alien":"👽","space_invader":"👾","robot":"🤖","jack_o_lantern":"🎃","smiley_cat":"😺","smile_cat":"😸","joy_cat":"😹","heart_eyes_cat":"😻","smirk_cat":"😼","kissing_cat":"😽","scream_cat":"🙀","crying_cat_face":"😿","pouting_cat":"😾","open_hands":"👐","raised_hands":"🙌","clap":"👏","pray":"🙏","handshake":"🤝","+1":"👍","thumbsup":"👍","-1":"👎","thumbsdown":"👎","fist_oncoming":"👊","facepunch":"👊","punch":"👊","fist_raised":"✊","fist":"✊","fist_left":"🤛","fist_right":"🤜","crossed_fingers":"🤞","v":"✌️","metal":"🤘","ok_hand":"👌","point_left":"👈","point_right":"👉","point_up_2":"👆","point_down":"👇","point_up":"☝️","hand":"✋","raised_hand":"✋","raised_back_of_hand":"🤚","raised_hand_with_fingers_splayed":"🖐","vulcan_salute":"🖖","wave":"👋","call_me_hand":"🤙","muscle":"💪","middle_finger":"🖕","fu":"🖕","writing_hand":"✍️","selfie":"🤳","nail_care":"💅","ring":"💍","lipstick":"💄","kiss":"💋","lips":"👄","tongue":"👅","ear":"👂","nose":"👃","footprints":"👣","eye":"👁","eyes":"👀","speaking_head":"🗣","bust_in_silhouette":"👤","busts_in_silhouette":"👥","baby":"👶","boy":"👦","girl":"👧","man":"👨","woman":"👩","blonde_woman":"👱‍♀","blonde_man":"👱","person_with_blond_hair":"👱","older_man":"👴","older_woman":"👵","man_with_gua_pi_mao":"👲","woman_with_turban":"👳‍♀","man_with_turban":"👳","policewoman":"👮‍♀","policeman":"👮","cop":"👮","construction_worker_woman":"👷‍♀","construction_worker_man":"👷","construction_worker":"👷","guardswoman":"💂‍♀","guardsman":"💂","female_detective":"🕵️‍♀️","male_detective":"🕵","detective":"🕵","woman_health_worker":"👩‍⚕","man_health_worker":"👨‍⚕","woman_farmer":"👩‍🌾","man_farmer":"👨‍🌾","woman_cook":"👩‍🍳","man_cook":"👨‍🍳","woman_student":"👩‍🎓","man_student":"👨‍🎓","woman_singer":"👩‍🎤","man_singer":"👨‍🎤","woman_teacher":"👩‍🏫","man_teacher":"👨‍🏫","woman_factory_worker":"👩‍🏭","man_factory_worker":"👨‍🏭","woman_technologist":"👩‍💻","man_technologist":"👨‍💻","woman_office_worker":"👩‍💼","man_office_worker":"👨‍💼","woman_mechanic":"👩‍🔧","man_mechanic":"👨‍🔧","woman_scientist":"👩‍🔬","man_scientist":"👨‍🔬","woman_artist":"👩‍🎨","man_artist":"👨‍🎨","woman_firefighter":"👩‍🚒","man_firefighter":"👨‍🚒","woman_pilot":"👩‍✈","man_pilot":"👨‍✈","woman_astronaut":"👩‍🚀","man_astronaut":"👨‍🚀","woman_judge":"👩‍⚖","man_judge":"👨‍⚖","mrs_claus":"🤶","santa":"🎅","princess":"👸","prince":"🤴","bride_with_veil":"👰","man_in_tuxedo":"🤵","angel":"👼","pregnant_woman":"🤰","bowing_woman":"🙇‍♀","bowing_man":"🙇","bow":"🙇","tipping_hand_woman":"💁","information_desk_person":"💁","sassy_woman":"💁","tipping_hand_man":"💁‍♂","sassy_man":"💁‍♂","no_good_woman":"🙅","no_good":"🙅","ng_woman":"🙅","no_good_man":"🙅‍♂","ng_man":"🙅‍♂","ok_woman":"🙆","ok_man":"🙆‍♂","raising_hand_woman":"🙋","raising_hand":"🙋","raising_hand_man":"🙋‍♂","woman_facepalming":"🤦‍♀","man_facepalming":"🤦‍♂","woman_shrugging":"🤷‍♀","man_shrugging":"🤷‍♂","pouting_woman":"🙎","person_with_pouting_face":"🙎","pouting_man":"🙎‍♂","frowning_woman":"🙍","person_frowning":"🙍","frowning_man":"🙍‍♂","haircut_woman":"💇","haircut":"💇","haircut_man":"💇‍♂","massage_woman":"💆","massage":"💆","massage_man":"💆‍♂","business_suit_levitating":"🕴","dancer":"💃","man_dancing":"🕺","dancing_women":"👯","dancers":"👯","dancing_men":"👯‍♂","walking_woman":"🚶‍♀","walking_man":"🚶","walking":"🚶","running_woman":"🏃‍♀","running_man":"🏃","runner":"🏃","running":"🏃","couple":"👫","two_women_holding_hands":"👭","two_men_holding_hands":"👬","couple_with_heart_woman_man":"💑","couple_with_heart":"💑","couple_with_heart_woman_woman":"👩‍❤️‍👩","couple_with_heart_man_man":"👨‍❤️‍👨","couplekiss_man_woman":"💏","couplekiss_woman_woman":"👩‍❤️‍💋‍👩","couplekiss_man_man":"👨‍❤️‍💋‍👨","family_man_woman_boy":"👪","family":"👪","family_man_woman_girl":"👨‍👩‍👧","family_man_woman_girl_boy":"👨‍👩‍👧‍👦","family_man_woman_boy_boy":"👨‍👩‍👦‍👦","family_man_woman_girl_girl":"👨‍👩‍👧‍👧","family_woman_woman_boy":"👩‍👩‍👦","family_woman_woman_girl":"👩‍👩‍👧","family_woman_woman_girl_boy":"👩‍👩‍👧‍👦","family_woman_woman_boy_boy":"👩‍👩‍👦‍👦","family_woman_woman_girl_girl":"👩‍👩‍👧‍👧","family_man_man_boy":"👨‍👨‍👦","family_man_man_girl":"👨‍👨‍👧","family_man_man_girl_boy":"👨‍👨‍👧‍👦","family_man_man_boy_boy":"👨‍👨‍👦‍👦","family_man_man_girl_girl":"👨‍👨‍👧‍👧","family_woman_boy":"👩‍👦","family_woman_girl":"👩‍👧","family_woman_girl_boy":"👩‍👧‍👦","family_woman_boy_boy":"👩‍👦‍👦","family_woman_girl_girl":"👩‍👧‍👧","family_man_boy":"👨‍👦","family_man_girl":"👨‍👧","family_man_girl_boy":"👨‍👧‍👦","family_man_boy_boy":"👨‍👦‍👦","family_man_girl_girl":"👨‍👧‍👧","womans_clothes":"👚","shirt":"👕","tshirt":"👕","jeans":"👖","necktie":"👔","dress":"👗","bikini":"👙","kimono":"👘","high_heel":"👠","sandal":"👡","boot":"👢","mans_shoe":"👞","shoe":"👞","athletic_shoe":"👟","womans_hat":"👒","tophat":"🎩","mortar_board":"🎓","crown":"👑","rescue_worker_helmet":"⛑","school_satchel":"🎒","pouch":"👝","purse":"👛","handbag":"👜","briefcase":"💼","eyeglasses":"👓","dark_sunglasses":"🕶","closed_umbrella":"🌂","open_umbrella":"☂️","dog":"🐶","cat":"🐱","mouse":"🐭","hamster":"🐹","rabbit":"🐰","fox_face":"🦊","bear":"🐻","panda_face":"🐼","koala":"🐨","tiger":"🐯","lion":"🦁","cow":"🐮","pig":"🐷","pig_nose":"🐽","frog":"🐸","monkey_face":"🐵","see_no_evil":"🙈","hear_no_evil":"🙉","speak_no_evil":"🙊","monkey":"🐒","chicken":"🐔","penguin":"🐧","bird":"🐦","baby_chick":"🐤","hatching_chick":"🐣","hatched_chick":"🐥","duck":"🦆","eagle":"🦅","owl":"🦉","bat":"🦇","wolf":"🐺","boar":"🐗","horse":"🐴","unicorn":"🦄","bee":"🐝","honeybee":"🐝","bug":"🐛","butterfly":"🦋","snail":"🐌","shell":"🐚","beetle":"🐞","ant":"🐜","spider":"🕷","spider_web":"🕸","turtle":"🐢","snake":"🐍","lizard":"🦎","scorpion":"🦂","crab":"🦀","squid":"🦑","octopus":"🐙","shrimp":"🦐","tropical_fish":"🐠","fish":"🐟","blowfish":"🐡","dolphin":"🐬","flipper":"🐬","shark":"🦈","whale":"🐳","whale2":"🐋","crocodile":"🐊","leopard":"🐆","tiger2":"🐅","water_buffalo":"🐃","ox":"🐂","cow2":"🐄","deer":"🦌","dromedary_camel":"🐪","camel":"🐫","elephant":"🐘","rhinoceros":"🦏","gorilla":"🦍","racehorse":"🐎","pig2":"🐖","goat":"🐐","ram":"🐏","sheep":"🐑","dog2":"🐕","poodle":"🐩","cat2":"🐈","rooster":"🐓","turkey":"🦃","dove":"🕊","rabbit2":"🐇","mouse2":"🐁","rat":"🐀","chipmunk":"🐿","feet":"🐾","paw_prints":"🐾","dragon":"🐉","dragon_face":"🐲","cactus":"🌵","christmas_tree":"🎄","evergreen_tree":"🌲","deciduous_tree":"🌳","palm_tree":"🌴","seedling":"🌱","herb":"🌿","shamrock":"☘️","four_leaf_clover":"🍀","bamboo":"🎍","tanabata_tree":"🎋","leaves":"🍃","fallen_leaf":"🍂","maple_leaf":"🍁","mushroom":"🍄","ear_of_rice":"🌾","bouquet":"💐","tulip":"🌷","rose":"🌹","wilted_flower":"🥀","sunflower":"🌻","blossom":"🌼","cherry_blossom":"🌸","hibiscus":"🌺","earth_americas":"🌎","earth_africa":"🌍","earth_asia":"🌏","full_moon":"🌕","waning_gibbous_moon":"🌖","last_quarter_moon":"🌗","waning_crescent_moon":"🌘","new_moon":"🌑","waxing_crescent_moon":"🌒","first_quarter_moon":"🌓","moon":"🌔","waxing_gibbous_moon":"🌔","new_moon_with_face":"🌚","full_moon_with_face":"🌝","sun_with_face":"🌞","first_quarter_moon_with_face":"🌛","last_quarter_moon_with_face":"🌜","crescent_moon":"🌙","dizzy":"💫","star":"⭐️","star2":"🌟","sparkles":"✨","zap":"⚡️","fire":"🔥","boom":"💥","collision":"💥","comet":"☄","sunny":"☀️","sun_behind_small_cloud":"🌤","partly_sunny":"⛅️","sun_behind_large_cloud":"🌥","sun_behind_rain_cloud":"🌦","rainbow":"🌈","cloud":"☁️","cloud_with_rain":"🌧","cloud_with_lightning_and_rain":"⛈","cloud_with_lightning":"🌩","cloud_with_snow":"🌨","snowman_with_snow":"☃️","snowman":"⛄️","snowflake":"❄️","wind_face":"🌬","dash":"💨","tornado":"🌪","fog":"🌫","ocean":"🌊","droplet":"💧","sweat_drops":"💦","umbrella":"☔️","green_apple":"🍏","apple":"🍎","pear":"🍐","tangerine":"🍊","orange":"🍊","mandarin":"🍊","lemon":"🍋","banana":"🍌","watermelon":"🍉","grapes":"🍇","strawberry":"🍓","melon":"🍈","cherries":"🍒","peach":"🍑","pineapple":"🍍","kiwi_fruit":"🥝","avocado":"🥑","tomato":"🍅","eggplant":"🍆","cucumber":"🥒","carrot":"🥕","corn":"🌽","hot_pepper":"🌶","potato":"🥔","sweet_potato":"🍠","chestnut":"🌰","peanuts":"🥜","honey_pot":"🍯","croissant":"🥐","bread":"🍞","baguette_bread":"🥖","cheese":"🧀","egg":"🥚","fried_egg":"🍳","bacon":"🥓","pancakes":"🥞","fried_shrimp":"🍤","poultry_leg":"🍗","meat_on_bone":"🍖","pizza":"🍕","hotdog":"🌭","hamburger":"🍔","fries":"🍟","stuffed_flatbread":"🥙","taco":"🌮","burrito":"🌯","green_salad":"🥗","shallow_pan_of_food":"🥘","spaghetti":"🍝","ramen":"🍜","stew":"🍲","fish_cake":"🍥","sushi":"🍣","bento":"🍱","curry":"🍛","rice":"🍚","rice_ball":"🍙","rice_cracker":"🍘","oden":"🍢","dango":"🍡","shaved_ice":"🍧","ice_cream":"🍨","icecream":"🍦","cake":"🍰","birthday":"🎂","custard":"🍮","lollipop":"🍭","candy":"🍬","chocolate_bar":"🍫","popcorn":"🍿","doughnut":"🍩","cookie":"🍪","milk_glass":"🥛","baby_bottle":"🍼","coffee":"☕️","tea":"🍵","sake":"🍶","beer":"🍺","beers":"🍻","clinking_glasses":"🥂","wine_glass":"🍷","tumbler_glass":"🥃","cocktail":"🍸","tropical_drink":"🍹","champagne":"🍾","spoon":"🥄","fork_and_knife":"🍴","plate_with_cutlery":"🍽","soccer":"⚽️","basketball":"🏀","football":"🏈","baseball":"⚾️","tennis":"🎾","volleyball":"🏐","rugby_football":"🏉","8ball":"🎱","ping_pong":"🏓","badminton":"🏸","goal_net":"🥅","ice_hockey":"🏒","field_hockey":"🏑","cricket":"🏏","golf":"⛳️","bow_and_arrow":"🏹","fishing_pole_and_fish":"🎣","boxing_glove":"🥊","martial_arts_uniform":"🥋","ice_skate":"⛸","ski":"🎿","skier":"⛷","snowboarder":"🏂","weight_lifting_woman":"🏋️‍♀️","weight_lifting_man":"🏋","person_fencing":"🤺","women_wrestling":"🤼‍♀","men_wrestling":"🤼‍♂","woman_cartwheeling":"🤸‍♀","man_cartwheeling":"🤸‍♂","basketball_woman":"⛹️‍♀️","basketball_man":"⛹","woman_playing_handball":"🤾‍♀","man_playing_handball":"🤾‍♂","golfing_woman":"🏌️‍♀️","golfing_man":"🏌","surfing_woman":"🏄‍♀","surfing_man":"🏄","surfer":"🏄","swimming_woman":"🏊‍♀","swimming_man":"🏊","swimmer":"🏊","woman_playing_water_polo":"🤽‍♀","man_playing_water_polo":"🤽‍♂","rowing_woman":"🚣‍♀","rowing_man":"🚣","rowboat":"🚣","horse_racing":"🏇","biking_woman":"🚴‍♀","biking_man":"🚴","bicyclist":"🚴","mountain_biking_woman":"🚵‍♀","mountain_biking_man":"🚵","mountain_bicyclist":"🚵","running_shirt_with_sash":"🎽","medal_sports":"🏅","medal_military":"🎖","1st_place_medal":"🥇","2nd_place_medal":"🥈","3rd_place_medal":"🥉","trophy":"🏆","rosette":"🏵","reminder_ribbon":"🎗","ticket":"🎫","tickets":"🎟","circus_tent":"🎪","woman_juggling":"🤹‍♀","man_juggling":"🤹‍♂","performing_arts":"🎭","art":"🎨","clapper":"🎬","microphone":"🎤","headphones":"🎧","musical_score":"🎼","musical_keyboard":"🎹","drum":"🥁","saxophone":"🎷","trumpet":"🎺","guitar":"🎸","violin":"🎻","game_die":"🎲","dart":"🎯","bowling":"🎳","video_game":"🎮","slot_machine":"🎰","car":"🚗","red_car":"🚗","taxi":"🚕","blue_car":"🚙","bus":"🚌","trolleybus":"🚎","racing_car":"🏎","police_car":"🚓","ambulance":"🚑","fire_engine":"🚒","minibus":"🚐","truck":"🚚","articulated_lorry":"🚛","tractor":"🚜","kick_scooter":"🛴","bike":"🚲","motor_scooter":"🛵","motorcycle":"🏍","rotating_light":"🚨","oncoming_police_car":"🚔","oncoming_bus":"🚍","oncoming_automobile":"🚘","oncoming_taxi":"🚖","aerial_tramway":"🚡","mountain_cableway":"🚠","suspension_railway":"🚟","railway_car":"🚃","train":"🚋","mountain_railway":"🚞","monorail":"🚝","bullettrain_side":"🚄","bullettrain_front":"🚅","light_rail":"🚈","steam_locomotive":"🚂","train2":"🚆","metro":"🚇","tram":"🚊","station":"🚉","helicopter":"🚁","small_airplane":"🛩","airplane":"✈️","flight_departure":"🛫","flight_arrival":"🛬","rocket":"🚀","artificial_satellite":"🛰","seat":"💺","canoe":"🛶","boat":"⛵️","sailboat":"⛵️","motor_boat":"🛥","speedboat":"🚤","passenger_ship":"🛳","ferry":"⛴","ship":"🚢","anchor":"⚓️","construction":"🚧","fuelpump":"⛽️","busstop":"🚏","vertical_traffic_light":"🚦","traffic_light":"🚥","world_map":"🗺","moyai":"🗿","statue_of_liberty":"🗽","fountain":"⛲️","tokyo_tower":"🗼","european_castle":"🏰","japanese_castle":"🏯","stadium":"🏟","ferris_wheel":"🎡","roller_coaster":"🎢","carousel_horse":"🎠","parasol_on_ground":"⛱","beach_umbrella":"🏖","desert_island":"🏝","mountain":"⛰","mountain_snow":"🏔","mount_fuji":"🗻","volcano":"🌋","desert":"🏜","camping":"🏕","tent":"⛺️","railway_track":"🛤","motorway":"🛣","building_construction":"🏗","factory":"🏭","house":"🏠","house_with_garden":"🏡","houses":"🏘","derelict_house":"🏚","office":"🏢","department_store":"🏬","post_office":"🏣","european_post_office":"🏤","hospital":"🏥","bank":"🏦","hotel":"🏨","convenience_store":"🏪","school":"🏫","love_hotel":"🏩","wedding":"💒","classical_building":"🏛","church":"⛪️","mosque":"🕌","synagogue":"🕍","kaaba":"🕋","shinto_shrine":"⛩","japan":"🗾","rice_scene":"🎑","national_park":"🏞","sunrise":"🌅","sunrise_over_mountains":"🌄","stars":"🌠","sparkler":"🎇","fireworks":"🎆","city_sunrise":"🌇","city_sunset":"🌆","cityscape":"🏙","night_with_stars":"🌃","milky_way":"🌌","bridge_at_night":"🌉","foggy":"🌁","watch":"⌚️","iphone":"📱","calling":"📲","computer":"💻","keyboard":"⌨️","desktop_computer":"🖥","printer":"🖨","computer_mouse":"🖱","trackball":"🖲","joystick":"🕹","clamp":"🗜","minidisc":"💽","floppy_disk":"💾","cd":"💿","dvd":"📀","vhs":"📼","camera":"📷","camera_flash":"📸","video_camera":"📹","movie_camera":"🎥","film_projector":"📽","film_strip":"🎞","telephone_receiver":"📞","phone":"☎️","telephone":"☎️","pager":"📟","fax":"📠","tv":"📺","radio":"📻","studio_microphone":"🎙","level_slider":"🎚","control_knobs":"🎛","stopwatch":"⏱","timer_clock":"⏲","alarm_clock":"⏰","mantelpiece_clock":"🕰","hourglass":"⌛️","hourglass_flowing_sand":"⏳","satellite":"📡","battery":"🔋","electric_plug":"🔌","bulb":"💡","flashlight":"🔦","candle":"🕯","wastebasket":"🗑","oil_drum":"🛢","money_with_wings":"💸","dollar":"💵","yen":"💴","euro":"💶","pound":"💷","moneybag":"💰","credit_card":"💳","gem":"💎","balance_scale":"⚖️","wrench":"🔧","hammer":"🔨","hammer_and_pick":"⚒","hammer_and_wrench":"🛠","pick":"⛏","nut_and_bolt":"🔩","gear":"⚙️","chains":"⛓","gun":"🔫","bomb":"💣","hocho":"🔪","knife":"🔪","dagger":"🗡","crossed_swords":"⚔️","shield":"🛡","smoking":"🚬","coffin":"⚰️","funeral_urn":"⚱️","amphora":"🏺","crystal_ball":"🔮","prayer_beads":"📿","barber":"💈","alembic":"⚗️","telescope":"🔭","microscope":"🔬","hole":"🕳","pill":"💊","syringe":"💉","thermometer":"🌡","toilet":"🚽","potable_water":"🚰","shower":"🚿","bathtub":"🛁","bath":"🛀","bellhop_bell":"🛎","key":"🔑","old_key":"🗝","door":"🚪","couch_and_lamp":"🛋","bed":"🛏","sleeping_bed":"🛌","framed_picture":"🖼","shopping":"🛍","shopping_cart":"🛒","gift":"🎁","balloon":"🎈","flags":"🎏","ribbon":"🎀","confetti_ball":"🎊","tada":"🎉","dolls":"🎎","izakaya_lantern":"🏮","lantern":"🏮","wind_chime":"🎐","email":"✉️","envelope":"✉️","envelope_with_arrow":"📩","incoming_envelope":"📨","e-mail":"📧","love_letter":"💌","inbox_tray":"📥","outbox_tray":"📤","package":"📦","label":"🏷","mailbox_closed":"📪","mailbox":"📫","mailbox_with_mail":"📬","mailbox_with_no_mail":"📭","postbox":"📮","postal_horn":"📯","scroll":"📜","page_with_curl":"📃","page_facing_up":"📄","bookmark_tabs":"📑","bar_chart":"📊","chart_with_upwards_trend":"📈","chart_with_downwards_trend":"📉","spiral_notepad":"🗒","spiral_calendar":"🗓","calendar":"📆","date":"📅","card_index":"📇","card_file_box":"🗃","ballot_box":"🗳","file_cabinet":"🗄","clipboard":"📋","file_folder":"📁","open_file_folder":"📂","card_index_dividers":"🗂","newspaper_roll":"🗞","newspaper":"📰","notebook":"📓","notebook_with_decorative_cover":"📔","ledger":"📒","closed_book":"📕","green_book":"📗","blue_book":"📘","orange_book":"📙","books":"📚","book":"📖","open_book":"📖","bookmark":"🔖","link":"🔗","paperclip":"📎","paperclips":"🖇","triangular_ruler":"📐","straight_ruler":"📏","pushpin":"📌","round_pushpin":"📍","scissors":"✂️","pen":"🖊","fountain_pen":"🖋","black_nib":"✒️","paintbrush":"🖌","crayon":"🖍","memo":"📝","pencil":"📝","pencil2":"✏️","mag":"🔍","mag_right":"🔎","lock_with_ink_pen":"🔏","closed_lock_with_key":"🔐","lock":"🔒","unlock":"🔓","heart":"❤️","yellow_heart":"💛","green_heart":"💚","blue_heart":"💙","purple_heart":"💜","black_heart":"🖤","broken_heart":"💔","heavy_heart_exclamation":"❣️","two_hearts":"💕","revolving_hearts":"💞","heartbeat":"💓","heartpulse":"💗","sparkling_heart":"💖","cupid":"💘","gift_heart":"💝","heart_decoration":"💟","peace_symbol":"☮️","latin_cross":"✝️","star_and_crescent":"☪️","om":"🕉","wheel_of_dharma":"☸️","star_of_david":"✡️","six_pointed_star":"🔯","menorah":"🕎","yin_yang":"☯️","orthodox_cross":"☦️","place_of_worship":"🛐","ophiuchus":"⛎","aries":"♈️","taurus":"♉️","gemini":"♊️","cancer":"♋️","leo":"♌️","virgo":"♍️","libra":"♎️","scorpius":"♏️","sagittarius":"♐️","capricorn":"♑️","aquarius":"♒️","pisces":"♓️","id":"🆔","atom_symbol":"⚛️","accept":"🉑","radioactive":"☢️","biohazard":"☣️","mobile_phone_off":"📴","vibration_mode":"📳","eight_pointed_black_star":"✴️","vs":"🆚","white_flower":"💮","ideograph_advantage":"🉐","secret":"㊙️","congratulations":"㊗️","u6e80":"🈵","a":"🅰️","b":"🅱️","ab":"🆎","cl":"🆑","o2":"🅾️","sos":"🆘","x":"❌","o":"⭕️","stop_sign":"🛑","no_entry":"⛔️","name_badge":"📛","no_entry_sign":"🚫","anger":"💢","hotsprings":"♨️","no_pedestrians":"🚷","do_not_litter":"🚯","no_bicycles":"🚳","non-potable_water":"🚱","underage":"🔞","no_mobile_phones":"📵","no_smoking":"🚭","exclamation":"❗️","heavy_exclamation_mark":"❗️","grey_exclamation":"❕","question":"❓","grey_question":"❔","bangbang":"‼️","interrobang":"⁉️","low_brightness":"🔅","high_brightness":"🔆","part_alternation_mark":"〽️","warning":"⚠️","children_crossing":"🚸","trident":"🔱","fleur_de_lis":"⚜️","beginner":"🔰","recycle":"♻️","white_check_mark":"✅","chart":"💹","sparkle":"❇️","eight_spoked_asterisk":"✳️","negative_squared_cross_mark":"❎","globe_with_meridians":"🌐","diamond_shape_with_a_dot_inside":"💠","m":"Ⓜ️","cyclone":"🌀","zzz":"💤","atm":"🏧","wc":"🚾","wheelchair":"♿️","parking":"🅿️","sa":"🈂️","passport_control":"🛂","customs":"🛃","baggage_claim":"🛄","left_luggage":"🛅","mens":"🚹","womens":"🚺","baby_symbol":"🚼","restroom":"🚻","put_litter_in_its_place":"🚮","cinema":"🎦","signal_strength":"📶","koko":"🈁","symbols":"🔣","information_source":"ℹ️","abc":"🔤","abcd":"🔡","capital_abcd":"🔠","ng":"🆖","ok":"🆗","up":"🆙","cool":"🆒","new":"🆕","free":"🆓","zero":"0️⃣","one":"1️⃣","two":"2️⃣","three":"3️⃣","four":"4️⃣","five":"5️⃣","six":"6️⃣","seven":"7️⃣","eight":"8️⃣","nine":"9️⃣","keycap_ten":"🔟","hash":"#️⃣","asterisk":"*️⃣","arrow_forward":"▶️","pause_button":"⏸","play_or_pause_button":"⏯","stop_button":"⏹","record_button":"⏺","next_track_button":"⏭","previous_track_button":"⏮","fast_forward":"⏩","rewind":"⏪","arrow_double_up":"⏫","arrow_double_down":"⏬","arrow_backward":"◀️","arrow_up_small":"🔼","arrow_down_small":"🔽","arrow_right":"➡️","arrow_left":"⬅️","arrow_up":"⬆️","arrow_down":"⬇️","arrow_upper_right":"↗️","arrow_lower_right":"↘️","arrow_lower_left":"↙️","arrow_upper_left":"↖️","arrow_up_down":"↕️","left_right_arrow":"↔️","arrow_right_hook":"↪️","leftwards_arrow_with_hook":"↩️","arrow_heading_up":"⤴️","arrow_heading_down":"⤵️","twisted_rightwards_arrows":"🔀","repeat":"🔁","repeat_one":"🔂","arrows_counterclockwise":"🔄","arrows_clockwise":"🔃","musical_note":"🎵","notes":"🎶","heavy_plus_sign":"➕","heavy_minus_sign":"➖","heavy_division_sign":"➗","heavy_multiplication_x":"✖️","heavy_dollar_sign":"💲","currency_exchange":"💱","tm":"™️","copyright":"©️","registered":"®️","wavy_dash":"〰️","curly_loop":"➰","loop":"➿","end":"🔚","back":"🔙","on":"🔛","top":"🔝","soon":"🔜","heavy_check_mark":"✔️","ballot_box_with_check":"☑️","radio_button":"🔘","white_circle":"⚪️","black_circle":"⚫️","red_circle":"🔴","large_blue_circle":"🔵","small_red_triangle":"🔺","small_red_triangle_down":"🔻","small_orange_diamond":"🔸","small_blue_diamond":"🔹","large_orange_diamond":"🔶","large_blue_diamond":"🔷","white_square_button":"🔳","black_square_button":"🔲","black_small_square":"▪️","white_small_square":"▫️","black_medium_small_square":"◾️","white_medium_small_square":"◽️","black_medium_square":"◼️","white_medium_square":"◻️","black_large_square":"⬛️","white_large_square":"⬜️","speaker":"🔈","mute":"🔇","sound":"🔉","loud_sound":"🔊","bell":"🔔","no_bell":"🔕","mega":"📣","loudspeaker":"📢","eye_speech_bubble":"👁‍🗨","speech_balloon":"💬","thought_balloon":"💭","right_anger_bubble":"🗯","spades":"♠️","clubs":"♣️","hearts":"♥️","diamonds":"♦️","black_joker":"🃏","flower_playing_cards":"🎴","mahjong":"🀄️","clock1":"🕐","clock2":"🕑","clock3":"🕒","clock4":"🕓","clock5":"🕔","clock6":"🕕","clock7":"🕖","clock8":"🕗","clock9":"🕘","clock10":"🕙","clock11":"🕚","clock12":"🕛","clock130":"🕜","clock230":"🕝","clock330":"🕞","clock430":"🕟","clock530":"🕠","clock630":"🕡","clock730":"🕢","clock830":"🕣","clock930":"🕤","clock1030":"🕥","clock1130":"🕦","clock1230":"🕧","white_flag":"🏳️","black_flag":"🏴","checkered_flag":"🏁","triangular_flag_on_post":"🚩","rainbow_flag":"🏳️‍🌈","afghanistan":"🇦🇫","aland_islands":"🇦🇽","albania":"🇦🇱","algeria":"🇩🇿","american_samoa":"🇦🇸","andorra":"🇦🇩","angola":"🇦🇴","anguilla":"🇦🇮","antarctica":"🇦🇶","antigua_barbuda":"🇦🇬","argentina":"🇦🇷","armenia":"🇦🇲","aruba":"🇦🇼","australia":"🇦🇺","austria":"🇦🇹","azerbaijan":"🇦🇿","bahamas":"🇧🇸","bahrain":"🇧🇭","bangladesh":"🇧🇩","barbados":"🇧🇧","belarus":"🇧🇾","belgium":"🇧🇪","belize":"🇧🇿","benin":"🇧🇯","bermuda":"🇧🇲","bhutan":"🇧🇹","bolivia":"🇧🇴","caribbean_netherlands":"🇧🇶","bosnia_herzegovina":"🇧🇦","botswana":"🇧🇼","brazil":"🇧🇷","british_indian_ocean_territory":"🇮🇴","british_virgin_islands":"🇻🇬","brunei":"🇧🇳","bulgaria":"🇧🇬","burkina_faso":"🇧🇫","burundi":"🇧🇮","cape_verde":"🇨🇻","cambodia":"🇰🇭","cameroon":"🇨🇲","canada":"🇨🇦","canary_islands":"🇮🇨","cayman_islands":"🇰🇾","central_african_republic":"🇨🇫","chad":"🇹🇩","chile":"🇨🇱","cn":"🇨🇳","christmas_island":"🇨🇽","cocos_islands":"🇨🇨","colombia":"🇨🇴","comoros":"🇰🇲","congo_brazzaville":"🇨🇬","congo_kinshasa":"🇨🇩","cook_islands":"🇨🇰","costa_rica":"🇨🇷","cote_divoire":"🇨🇮","croatia":"🇭🇷","cuba":"🇨🇺","curacao":"🇨🇼","cyprus":"🇨🇾","czech_republic":"🇨🇿","denmark":"🇩🇰","djibouti":"🇩🇯","dominica":"🇩🇲","dominican_republic":"🇩🇴","ecuador":"🇪🇨","egypt":"🇪🇬","el_salvador":"🇸🇻","equatorial_guinea":"🇬🇶","eritrea":"🇪🇷","estonia":"🇪🇪","ethiopia":"🇪🇹","eu":"🇪🇺","european_union":"🇪🇺","falkland_islands":"🇫🇰","faroe_islands":"🇫🇴","fiji":"🇫🇯","finland":"🇫🇮","fr":"🇫🇷","french_guiana":"🇬🇫","french_polynesia":"🇵🇫","french_southern_territories":"🇹🇫","gabon":"🇬🇦","gambia":"🇬🇲","georgia":"🇬🇪","de":"🇩🇪","ghana":"🇬🇭","gibraltar":"🇬🇮","greece":"🇬🇷","greenland":"🇬🇱","grenada":"🇬🇩","guadeloupe":"🇬🇵","guam":"🇬🇺","guatemala":"🇬🇹","guernsey":"🇬🇬","guinea":"🇬🇳","guinea_bissau":"🇬🇼","guyana":"🇬🇾","haiti":"🇭🇹","honduras":"🇭🇳","hong_kong":"🇭🇰","hungary":"🇭🇺","iceland":"🇮🇸","india":"🇮🇳","indonesia":"🇮🇩","iran":"🇮🇷","iraq":"🇮🇶","ireland":"🇮🇪","isle_of_man":"🇮🇲","israel":"🇮🇱","it":"🇮🇹","jamaica":"🇯🇲","jp":"🇯🇵","crossed_flags":"🎌","jersey":"🇯🇪","jordan":"🇯🇴","kazakhstan":"🇰🇿","kenya":"🇰🇪","kiribati":"🇰🇮","kosovo":"🇽🇰","kuwait":"🇰🇼","kyrgyzstan":"🇰🇬","laos":"🇱🇦","latvia":"🇱🇻","lebanon":"🇱🇧","lesotho":"🇱🇸","liberia":"🇱🇷","libya":"🇱🇾","liechtenstein":"🇱🇮","lithuania":"🇱🇹","luxembourg":"🇱🇺","macau":"🇲🇴","macedonia":"🇲🇰","madagascar":"🇲🇬","malawi":"🇲🇼","malaysia":"🇲🇾","maldives":"🇲🇻","mali":"🇲🇱","malta":"🇲🇹","marshall_islands":"🇲🇭","martinique":"🇲🇶","mauritania":"🇲🇷","mauritius":"🇲🇺","mayotte":"🇾🇹","mexico":"🇲🇽","micronesia":"🇫🇲","moldova":"🇲🇩","monaco":"🇲🇨","mongolia":"🇲🇳","montenegro":"🇲🇪","montserrat":"🇲🇸","morocco":"🇲🇦","mozambique":"🇲🇿","myanmar":"🇲🇲","namibia":"🇳🇦","nauru":"🇳🇷","nepal":"🇳🇵","netherlands":"🇳🇱","new_caledonia":"🇳🇨","new_zealand":"🇳🇿","nicaragua":"🇳🇮","niger":"🇳🇪","nigeria":"🇳🇬","niue":"🇳🇺","norfolk_island":"🇳🇫","northern_mariana_islands":"🇲🇵","north_korea":"🇰🇵","norway":"🇳🇴","oman":"🇴🇲","pakistan":"🇵🇰","palau":"🇵🇼","palestinian_territories":"🇵🇸","panama":"🇵🇦","papua_new_guinea":"🇵🇬","paraguay":"🇵🇾","peru":"🇵🇪","philippines":"🇵🇭","pitcairn_islands":"🇵🇳","poland":"🇵🇱","portugal":"🇵🇹","puerto_rico":"🇵🇷","qatar":"🇶🇦","reunion":"🇷🇪","romania":"🇷🇴","ru":"🇷🇺","rwanda":"🇷🇼","st_barthelemy":"🇧🇱","st_helena":"🇸🇭","st_kitts_nevis":"🇰🇳","st_lucia":"🇱🇨","st_pierre_miquelon":"🇵🇲","st_vincent_grenadines":"🇻🇨","samoa":"🇼🇸","san_marino":"🇸🇲","sao_tome_principe":"🇸🇹","saudi_arabia":"🇸🇦","senegal":"🇸🇳","serbia":"🇷🇸","seychelles":"🇸🇨","sierra_leone":"🇸🇱","singapore":"🇸🇬","sint_maarten":"🇸🇽","slovakia":"🇸🇰","slovenia":"🇸🇮","solomon_islands":"🇸🇧","somalia":"🇸🇴","south_africa":"🇿🇦","south_georgia_south_sandwich_islands":"🇬🇸","kr":"🇰🇷","south_sudan":"🇸🇸","es":"🇪🇸","sri_lanka":"🇱🇰","sudan":"🇸🇩","suriname":"🇸🇷","swaziland":"🇸🇿","sweden":"🇸🇪","switzerland":"🇨🇭","syria":"🇸🇾","taiwan":"🇹🇼","tajikistan":"🇹🇯","tanzania":"🇹🇿","thailand":"🇹🇭","timor_leste":"🇹🇱","togo":"🇹🇬","tokelau":"🇹🇰","tonga":"🇹🇴","trinidad_tobago":"🇹🇹","tunisia":"🇹🇳","tr":"🇹🇷","turkmenistan":"🇹🇲","turks_caicos_islands":"🇹🇨","tuvalu":"🇹🇻","uganda":"🇺🇬","ukraine":"🇺🇦","united_arab_emirates":"🇦🇪","gb":"🇬🇧","uk":"🇬🇧","us":"🇺🇸","us_virgin_islands":"🇻🇮","uruguay":"🇺🇾","uzbekistan":"🇺🇿","vanuatu":"🇻🇺","vatican_city":"🇻🇦","venezuela":"🇻🇪","vietnam":"🇻🇳","wallis_futuna":"🇼🇫","western_sahara":"🇪🇭","yemen":"🇾🇪","zambia":"🇿🇲","zimbabwe":"🇿🇼"}

/***/ }),
/* 2132 */,
/* 2133 */,
/* 2134 */,
/* 2135 */,
/* 2136 */,
/* 2137 */,
/* 2138 */,
/* 2139 */,
/* 2140 */,
/* 2141 */,
/* 2142 */,
/* 2143 */,
/* 2144 */,
/* 2145 */,
/* 2146 */,
/* 2147 */,
/* 2148 */,
/* 2149 */,
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */,
/* 2155 */,
/* 2156 */,
/* 2157 */,
/* 2158 */,
/* 2159 */,
/* 2160 */,
/* 2161 */,
/* 2162 */,
/* 2163 */,
/* 2164 */,
/* 2165 */,
/* 2166 */,
/* 2167 */,
/* 2168 */,
/* 2169 */,
/* 2170 */,
/* 2171 */,
/* 2172 */,
/* 2173 */,
/* 2174 */,
/* 2175 */,
/* 2176 */,
/* 2177 */,
/* 2178 */,
/* 2179 */,
/* 2180 */,
/* 2181 */,
/* 2182 */,
/* 2183 */,
/* 2184 */,
/* 2185 */,
/* 2186 */,
/* 2187 */,
/* 2188 */,
/* 2189 */,
/* 2190 */,
/* 2191 */,
/* 2192 */,
/* 2193 */,
/* 2194 */,
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./locale": 845,
	"./locale.js": 845
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2195;

/***/ }),
/* 2196 */,
/* 2197 */,
/* 2198 */,
/* 2199 */,
/* 2200 */
/***/ (function(module, exports) {

module.exports = "/* Add your custom Handlebars helpers here.\n\nFor example:\n\nHandlebars.registerHelper('transform', function (options) {\n  var result = options.fn(this);\n  return new Handlebars.SafeString(\n    result.replace(/<pre[^>]*>/g, '<pre class=\"prettyprint\">')\n  );\n});\n\nThen use the helper in your template:\n\n{{#transform}}{{{files.0.content.html}}}{{/transform}}\n*/\n\n"

/***/ }),
/* 2201 */
/***/ (function(module, exports) {

module.exports = "<!-- Specify your Handlebars template here.\n\nThe following JavaScript context will be passed to the template:\n\n{\n  files: [{\n    name: 'The filename',\n    content: {\n      text: 'The file content',\n      html: '<p>The file content</p>',\n      yamlProperties: 'The file properties in YAML format',\n      properties: {\n        // Computed file properties object\n      },\n      toc: [\n        // Table Of Contents tree\n      ]\n    }\n  }]\n}\n\n\nAs an example:\n\n<html><body>{{{files.0.content.html}}}</body></html>\n\nwill produce:\n\n<html><body><p>The file content</p></body></html>\n\n\nYou can use Handlebars built-in helpers and the custom StackEdit ones:\n\n{{#tocToHtml files.0.content.toc}}{{/tocToHtml}} will produce a clickable TOC.\n\n{{#tocToHtml files.0.content.toc 3}}{{/tocToHtml}} will limit the TOC depth to 3.\n-->\n\n"

/***/ }),
/* 2202 */
/***/ (function(module, exports) {

module.exports = "**Where is my data stored?**\n\nIf your workspace is not synced, your files are stored inside your browser and nowhere else.\n\nWe recommend syncing your workspace to make sure files won't be lost in case your browser data is cleared. Self-hosted CouchDB or GitLab backends are well suited for privacy.\n\n**Can StackEdit access my data without telling me?**\n\nStackEdit is a browser-based application. The access tokens issued by Google, Dropbox, GitHub... are stored in your browser and are not sent to any kind of backend or 3^rd^ party so your data won't be accessed by anyone.\n"

/***/ }),
/* 2203 */
/***/ (function(module, exports) {

module.exports = "Headers\n---------------------------\n\n# Header 1\n\n## Header 2\n\n### Header 3\n\n\n\nStyling\n---------------------------\n\n*Emphasize* _emphasize_\n\n**Strong** __strong__\n\n==Marked text.==\n\n~~Mistaken text.~~\n\n> Quoted text.\n\nH~2~O is a liquid.\n\n2^10^ is 1024.\n\n\n\nLists\n---------------------------\n\n- Item\n  * Item\n    + Item\n\n1. Item 1\n2. Item 2\n3. Item 3\n\n- [ ] Incomplete item\n- [x] Complete item\n\n\n\nLinks\n---------------------------\n\nA [link](http://example.com).\n\nAn image: ![Alt](img.jpg)\n\nA sized image: ![Alt](img.jpg =60x50)\n\n\n\nCode\n---------------------------\n\nSome `inline code`.\n\n```\n// A code block\nvar foo = 'bar';\n```\n\n```javascript\n// An highlighted block\nvar foo = 'bar';\n```\n\n\n\nTables\n---------------------------\n\nItem     | Value\n-------- | -----\nComputer | $1600\nPhone    | $12\nPipe     | $1\n\n\n| Column 1 | Column 2      |\n|:--------:| -------------:|\n| centered | right-aligned |\n\n\n\nDefinition lists\n---------------------------\n\nMarkdown\n:  Text-to-HTML conversion tool\n\nAuthors\n:  John\n:  Luke\n\n\n\nFootnotes\n---------------------------\n\nSome text with a footnote.[^1]\n\n[^1]: The footnote.\n\n\n\nAbbreviations\n---------------------------\n\nMarkdown converts text to HTML.\n\n*[HTML]: HyperText Markup Language\n\n\n\nLaTeX math\n---------------------------\n\nThe Gamma function satisfying $\\Gamma(n) = (n-1)!\\quad\\forall\nn\\in\\mathbb N$ is via the Euler integral\n\n$$\n\\Gamma(z) = \\int_0^\\infty t^{z-1}e^{-t}dt\\,.\n$$\n"

/***/ }),
/* 2204 */
/***/ (function(module, exports) {

module.exports = "---\n{{{files.0.content.yamlProperties}}}\n---\n\n{{{files.0.content.html}}}\n"

/***/ }),
/* 2205 */
/***/ (function(module, exports) {

module.exports = "{{{files.0.content.html}}}\n"

/***/ }),
/* 2206 */
/***/ (function(module, exports) {

module.exports = "<!DOCTYPE html>\n<html>\n\n<head>\n  <meta charset=\"utf-8\">\n  <meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">\n  <title>{{files.0.name}}</title>\n  <link rel=\"stylesheet\" href=\"https://stackedit.io/style.css\" />\n</head>\n\n{{#if pdf}}\n<body class=\"stackedit stackedit--pdf\">\n{{else}}\n<body class=\"stackedit\">\n{{/if}}\n  <div class=\"stackedit__html\">{{{files.0.content.html}}}</div>\n</body>\n\n</html>\n"

/***/ }),
/* 2207 */
/***/ (function(module, exports) {

module.exports = "<!DOCTYPE html>\n<html>\n\n<head>\n  <meta charset=\"utf-8\">\n  <meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">\n  <title>{{files.0.name}}</title>\n  <link rel=\"stylesheet\" href=\"https://stackedit.io/style.css\" />\n</head>\n\n{{#if pdf}}\n<body class=\"stackedit stackedit--pdf\">\n{{else}}\n<body class=\"stackedit\">\n{{/if}}\n  <div class=\"stackedit__left\">\n    <div class=\"stackedit__toc\">\n      {{#tocToHtml files.0.content.toc 2}}{{/tocToHtml}}\n    </div>\n  </div>\n  <div class=\"stackedit__right\">\n    <div class=\"stackedit__html\">\n      {{{files.0.content.html}}}\n    </div>\n  </div>\n</body>\n\n</html>\n"

/***/ }),
/* 2208 */
/***/ (function(module, exports) {

module.exports = "# Welcome to StackEdit!\n\nHi! I'm your first Markdown file in **StackEdit**. If you want to learn about StackEdit, you can read me. If you want to play with Markdown, you can edit me. Once you have finished with me, you can create new files by opening the **file explorer** on the left corner of the navigation bar.\n\n\n# Files\n\nStackEdit stores your files in your browser, which means all your files are automatically saved locally and are accessible **offline!**\n\n## Create files and folders\n\nThe file explorer is accessible using the button in left corner of the navigation bar. You can create a new file by clicking the **New file** button in the file explorer. You can also create folders by clicking the **New folder** button.\n\n## Switch to another file\n\nAll your files and folders are presented as a tree in the file explorer. You can switch from one to another by clicking a file in the tree.\n\n## Rename a file\n\nYou can rename the current file by clicking the file name in the navigation bar or by clicking the **Rename** button in the file explorer.\n\n## Delete a file\n\nYou can delete the current file by clicking the **Remove** button in the file explorer. The file will be moved into the **Trash** folder and automatically deleted after 7 days of inactivity.\n\n## Export a file\n\nYou can export the current file by clicking **Export to disk** in the menu. You can choose to export the file as plain Markdown, as HTML using a Handlebars template or as a PDF.\n\n\n# Synchronization\n\nSynchronization is one of the biggest features of StackEdit. It enables you to synchronize any file in your workspace with other files stored in your **Google Drive**, your **Dropbox** and your **GitHub** accounts. This allows you to keep writing on other devices, collaborate with people you share the file with, integrate easily into your workflow... The synchronization mechanism takes place every minute in the background, downloading, merging, and uploading file modifications.\n\nThere are two types of synchronization and they can complement each other:\n\n- The workspace synchronization will sync all your files, folders and settings automatically. This will allow you to fetch your workspace on any other device.\n\t> To start syncing your workspace, just sign in with Google in the menu.\n\n- The file synchronization will keep one file of the workspace synced with one or multiple files in **Google Drive**, **Dropbox** or **GitHub**.\n\t> Before starting to sync files, you must link an account in the **Synchronize** sub-menu.\n\n## Open a file\n\nYou can open a file from **Google Drive**, **Dropbox** or **GitHub** by opening the **Synchronize** sub-menu and clicking **Open from**. Once opened in the workspace, any modification in the file will be automatically synced.\n\n## Save a file\n\nYou can save any file of the workspace to **Google Drive**, **Dropbox** or **GitHub** by opening the **Synchronize** sub-menu and clicking **Save on**. Even if a file in the workspace is already synced, you can save it to another location. StackEdit can sync one file with multiple locations and accounts.\n\n## Synchronize a file\n\nOnce your file is linked to a synchronized location, StackEdit will periodically synchronize it by downloading/uploading any modification. A merge will be performed if necessary and conflicts will be resolved.\n\nIf you just have modified your file and you want to force syncing, click the **Synchronize now** button in the navigation bar.\n\n> **Note:** The **Synchronize now** button is disabled if you have no file to synchronize.\n\n## Manage file synchronization\n\nSince one file can be synced with multiple locations, you can list and manage synchronized locations by clicking **File synchronization** in the **Synchronize** sub-menu. This allows you to list and remove synchronized locations that are linked to your file.\n\n\n# Publication\n\nPublishing in StackEdit makes it simple for you to publish online your files. Once you're happy with a file, you can publish it to different hosting platforms like **Blogger**, **Dropbox**, **Gist**, **GitHub**, **Google Drive**, **WordPress** and **Zendesk**. With [Handlebars templates](http://handlebarsjs.com/), you have full control over what you export.\n\n> Before starting to publish, you must link an account in the **Publish** sub-menu.\n\n## Publish a File\n\nYou can publish your file by opening the **Publish** sub-menu and by clicking **Publish to**. For some locations, you can choose between the following formats:\n\n- Markdown: publish the Markdown text on a website that can interpret it (**GitHub** for instance),\n- HTML: publish the file converted to HTML via a Handlebars template (on a blog for example).\n\n## Update a publication\n\nAfter publishing, StackEdit keeps your file linked to that publication which makes it easy for you to re-publish it. Once you have modified your file and you want to update your publication, click on the **Publish now** button in the navigation bar.\n\n> **Note:** The **Publish now** button is disabled if your file has not been published yet.\n\n## Manage file publication\n\nSince one file can be published to multiple locations, you can list and manage publish locations by clicking **File publication** in the **Publish** sub-menu. This allows you to list and remove publication locations that are linked to your file.\n\n\n# Markdown extensions\n\nStackEdit extends the standard Markdown syntax by adding extra **Markdown extensions**, providing you with some nice features.\n\n> **ProTip:** You can disable any **Markdown extension** in the **File properties** dialog.\n\n\n## SmartyPants\n\nSmartyPants converts ASCII punctuation characters into \"smart\" typographic punctuation HTML entities. For example:\n\n|                |ASCII                          |HTML                         |\n|----------------|-------------------------------|-----------------------------|\n|Single backticks|`'Isn't this fun?'`            |'Isn't this fun?'            |\n|Quotes          |`\"Isn't this fun?\"`            |\"Isn't this fun?\"            |\n|Dashes          |`-- is en-dash, --- is em-dash`|-- is en-dash, --- is em-dash|\n\n\n## KaTeX\n\nYou can render LaTeX mathematical expressions using [KaTeX](https://khan.github.io/KaTeX/):\n\nThe *Gamma function* satisfying $\\Gamma(n) = (n-1)!\\quad\\forall n\\in\\mathbb N$ is via the Euler integral\n\n$$\n\\Gamma(z) = \\int_0^\\infty t^{z-1}e^{-t}dt\\,.\n$$\n\n> You can find more information about **LaTeX** mathematical expressions [here](http://meta.math.stackexchange.com/questions/5020/mathjax-basic-tutorial-and-quick-reference).\n\n\n## UML diagrams\n\nYou can render UML diagrams using [Mermaid](https://mermaidjs.github.io/). For example, this will produce a sequence diagram:\n\n```mermaid\nsequenceDiagram\nAlice ->> Bob: Hello Bob, how are you?\nBob-->>John: How about you John?\nBob--x Alice: I am good thanks!\nBob-x John: I am good thanks!\nNote right of John: Bob thinks a long<br/>long time, so long<br/>that the text does<br/>not fit on a row.\n\nBob-->Alice: Checking with John...\nAlice->John: Yes... John, how are you?\n```\n\nAnd this will produce a flow chart:\n\n```mermaid\ngraph LR\nA[Square Rect] -- Link text --> B((Circle))\nA --> C(Round Rect)\nB --> D{Rhombus}\nC --> D\n```\n"

/***/ }),
/* 2209 */,
/* 2210 */,
/* 2211 */,
/* 2212 */,
/* 2213 */,
/* 2214 */,
/* 2215 */,
/* 2216 */,
/* 2217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ButtonBar_vue_vue_type_template_id_cb4cfc6c___ = __webpack_require__(2379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ButtonBar_vue_vue_type_script_lang_js___ = __webpack_require__(859);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ButtonBar_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ButtonBar_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ButtonBar_vue_vue_type_template_id_cb4cfc6c___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ButtonBar_vue_vue_type_template_id_cb4cfc6c___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "ButtonBar.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ContextMenu_vue_vue_type_template_id_f308a61a___ = __webpack_require__(2381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContextMenu_vue_vue_type_script_lang_js___ = __webpack_require__(861);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContextMenu_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ContextMenu_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ContextMenu_vue_vue_type_template_id_f308a61a___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ContextMenu_vue_vue_type_template_id_f308a61a___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "ContextMenu.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Editor_vue_vue_type_template_id_1fa36192___ = __webpack_require__(2382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Editor_vue_vue_type_script_lang_js___ = __webpack_require__(862);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Editor_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Editor_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Editor_vue_vue_type_template_id_1fa36192___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Editor_vue_vue_type_template_id_1fa36192___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Editor.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Explorer_vue_vue_type_template_id_bef329a8___ = __webpack_require__(2383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Explorer_vue_vue_type_script_lang_js___ = __webpack_require__(863);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Explorer_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Explorer_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Explorer_vue_vue_type_template_id_bef329a8___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Explorer_vue_vue_type_template_id_bef329a8___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Explorer.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExplorerNode_vue_vue_type_template_id_4c39736c___ = __webpack_require__(2384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ExplorerNode_vue_vue_type_script_lang_js___ = __webpack_require__(864);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ExplorerNode_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ExplorerNode_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ExplorerNode_vue_vue_type_template_id_4c39736c___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ExplorerNode_vue_vue_type_template_id_4c39736c___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "ExplorerNode.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FindReplace_vue_vue_type_template_id_67773bda___ = __webpack_require__(2385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FindReplace_vue_vue_type_script_lang_js___ = __webpack_require__(865);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FindReplace_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__FindReplace_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__FindReplace_vue_vue_type_template_id_67773bda___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__FindReplace_vue_vue_type_template_id_67773bda___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "FindReplace.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Layout_vue_vue_type_template_id_7af4384a___ = __webpack_require__(2386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Layout_vue_vue_type_script_lang_js___ = __webpack_require__(866);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Layout_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Layout_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Layout_vue_vue_type_template_id_7af4384a___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Layout_vue_vue_type_template_id_7af4384a___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Layout.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal_vue_vue_type_template_id_300372c2___ = __webpack_require__(2387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal_vue_vue_type_script_lang_js___ = __webpack_require__(867);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Modal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Modal_vue_vue_type_template_id_300372c2___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Modal_vue_vue_type_template_id_300372c2___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Modal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NavigationBar_vue_vue_type_template_id_49d23abe___ = __webpack_require__(2388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavigationBar_vue_vue_type_script_lang_js___ = __webpack_require__(868);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NavigationBar_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__NavigationBar_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__NavigationBar_vue_vue_type_template_id_49d23abe___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__NavigationBar_vue_vue_type_template_id_49d23abe___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "NavigationBar.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Notification_vue_vue_type_template_id_c6a774ba___ = __webpack_require__(2389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Notification_vue_vue_type_script_lang_js___ = __webpack_require__(869);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Notification_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Notification_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Notification_vue_vue_type_template_id_c6a774ba___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Notification_vue_vue_type_template_id_c6a774ba___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Notification.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Preview_vue_vue_type_template_id_d72f6e84___ = __webpack_require__(2390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Preview_vue_vue_type_script_lang_js___ = __webpack_require__(870);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Preview_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Preview_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Preview_vue_vue_type_template_id_d72f6e84___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Preview_vue_vue_type_template_id_d72f6e84___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Preview.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideBar_vue_vue_type_template_id_71df7eb6___ = __webpack_require__(2391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SideBar_vue_vue_type_script_lang_js___ = __webpack_require__(871);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SideBar_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SideBar_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__SideBar_vue_vue_type_template_id_71df7eb6___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SideBar_vue_vue_type_template_id_71df7eb6___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "SideBar.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SplashScreen_vue_vue_type_template_id_0d0cac6d___ = __webpack_require__(2392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SplashScreen_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}



/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__SplashScreen_vue_vue_type_template_id_0d0cac6d___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SplashScreen_vue_vue_type_template_id_0d0cac6d___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "SplashScreen.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StatusBar_vue_vue_type_template_id_3bb0ebd6___ = __webpack_require__(2393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StatusBar_vue_vue_type_script_lang_js___ = __webpack_require__(872);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StatusBar_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__StatusBar_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__StatusBar_vue_vue_type_template_id_3bb0ebd6___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__StatusBar_vue_vue_type_template_id_3bb0ebd6___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "StatusBar.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Toc_vue_vue_type_template_id_fb5cc4a2___ = __webpack_require__(2394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Toc_vue_vue_type_script_lang_js___ = __webpack_require__(873);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Toc_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Toc_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Toc_vue_vue_type_template_id_fb5cc4a2___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Toc_vue_vue_type_template_id_fb5cc4a2___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Toc.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tour_vue_vue_type_template_id_01063a0c___ = __webpack_require__(2395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tour_vue_vue_type_script_lang_js___ = __webpack_require__(874);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tour_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Tour_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Tour_vue_vue_type_template_id_01063a0c___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Tour_vue_vue_type_template_id_01063a0c___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Tour.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CurrentDiscussion_vue_vue_type_template_id_2b90cf14___ = __webpack_require__(2400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CurrentDiscussion_vue_vue_type_script_lang_js___ = __webpack_require__(879);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CurrentDiscussion_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__CurrentDiscussion_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__CurrentDiscussion_vue_vue_type_template_id_2b90cf14___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__CurrentDiscussion_vue_vue_type_template_id_2b90cf14___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "CurrentDiscussion.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditorNewDiscussionButton_vue_vue_type_template_id_636a9650___ = __webpack_require__(2401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditorNewDiscussionButton_vue_vue_type_script_lang_js___ = __webpack_require__(880);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__EditorNewDiscussionButton_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__EditorNewDiscussionButton_vue_vue_type_template_id_636a9650___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__EditorNewDiscussionButton_vue_vue_type_template_id_636a9650___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditorNewDiscussionButton.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PreviewNewDiscussionButton_vue_vue_type_template_id_56434062___ = __webpack_require__(2403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreviewNewDiscussionButton_vue_vue_type_script_lang_js___ = __webpack_require__(882);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__PreviewNewDiscussionButton_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__PreviewNewDiscussionButton_vue_vue_type_template_id_56434062___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__PreviewNewDiscussionButton_vue_vue_type_template_id_56434062___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "PreviewNewDiscussionButton.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HistoryMenu_vue_vue_type_template_id_b731285e___ = __webpack_require__(2405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HistoryMenu_vue_vue_type_script_lang_js___ = __webpack_require__(884);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HistoryMenu_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__HistoryMenu_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__HistoryMenu_vue_vue_type_template_id_b731285e___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__HistoryMenu_vue_vue_type_template_id_b731285e___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "HistoryMenu.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImportExportMenu_vue_vue_type_template_id_e7c342a4___ = __webpack_require__(2406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ImportExportMenu_vue_vue_type_script_lang_js___ = __webpack_require__(885);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ImportExportMenu_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ImportExportMenu_vue_vue_type_template_id_e7c342a4___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ImportExportMenu_vue_vue_type_template_id_e7c342a4___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "ImportExportMenu.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MainMenu_vue_vue_type_template_id_e3e62cda___ = __webpack_require__(2407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainMenu_vue_vue_type_script_lang_js___ = __webpack_require__(886);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__MainMenu_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__MainMenu_vue_vue_type_template_id_e3e62cda___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__MainMenu_vue_vue_type_template_id_e3e62cda___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "MainMenu.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PublishMenu_vue_vue_type_template_id_a39804ec___ = __webpack_require__(2408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PublishMenu_vue_vue_type_script_lang_js___ = __webpack_require__(887);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__PublishMenu_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__PublishMenu_vue_vue_type_template_id_a39804ec___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__PublishMenu_vue_vue_type_template_id_a39804ec___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "PublishMenu.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SyncMenu_vue_vue_type_template_id_352ad9b8___ = __webpack_require__(2409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SyncMenu_vue_vue_type_script_lang_js___ = __webpack_require__(888);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SyncMenu_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__SyncMenu_vue_vue_type_template_id_352ad9b8___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SyncMenu_vue_vue_type_template_id_352ad9b8___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "SyncMenu.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WorkspaceBackupMenu_vue_vue_type_template_id_43f1af8e___ = __webpack_require__(2410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WorkspaceBackupMenu_vue_vue_type_script_lang_js___ = __webpack_require__(889);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__WorkspaceBackupMenu_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__WorkspaceBackupMenu_vue_vue_type_template_id_43f1af8e___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__WorkspaceBackupMenu_vue_vue_type_template_id_43f1af8e___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "WorkspaceBackupMenu.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WorkspacesMenu_vue_vue_type_template_id_2e2c9170___ = __webpack_require__(2411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WorkspacesMenu_vue_vue_type_script_lang_js___ = __webpack_require__(890);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WorkspacesMenu_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__WorkspacesMenu_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__WorkspacesMenu_vue_vue_type_template_id_2e2c9170___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__WorkspacesMenu_vue_vue_type_template_id_2e2c9170___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "WorkspacesMenu.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AboutModal_vue_vue_type_template_id_f4dab8d2___ = __webpack_require__(2413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AboutModal_vue_vue_type_script_lang_js___ = __webpack_require__(891);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AboutModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__AboutModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__AboutModal_vue_vue_type_template_id_f4dab8d2___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__AboutModal_vue_vue_type_template_id_f4dab8d2___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "AboutModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AccountManagementModal_vue_vue_type_template_id_85623052___ = __webpack_require__(2414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AccountManagementModal_vue_vue_type_script_lang_js___ = __webpack_require__(892);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AccountManagementModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__AccountManagementModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__AccountManagementModal_vue_vue_type_template_id_85623052___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__AccountManagementModal_vue_vue_type_template_id_85623052___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "AccountManagementModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BadgeManagementModal_vue_vue_type_template_id_bb23f0e0___ = __webpack_require__(2415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BadgeManagementModal_vue_vue_type_script_lang_js___ = __webpack_require__(893);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BadgeManagementModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__BadgeManagementModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__BadgeManagementModal_vue_vue_type_template_id_bb23f0e0___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__BadgeManagementModal_vue_vue_type_template_id_bb23f0e0___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "BadgeManagementModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FilePropertiesModal_vue_vue_type_template_id_19df34da___ = __webpack_require__(2416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FilePropertiesModal_vue_vue_type_script_lang_js___ = __webpack_require__(894);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FilePropertiesModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__FilePropertiesModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__FilePropertiesModal_vue_vue_type_template_id_19df34da___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__FilePropertiesModal_vue_vue_type_template_id_19df34da___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "FilePropertiesModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HtmlExportModal_vue_vue_type_template_id_2d96e412___ = __webpack_require__(2417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HtmlExportModal_vue_vue_type_script_lang_js___ = __webpack_require__(895);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__HtmlExportModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__HtmlExportModal_vue_vue_type_template_id_2d96e412___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__HtmlExportModal_vue_vue_type_template_id_2d96e412___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "HtmlExportModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImageModal_vue_vue_type_template_id_36b8fc5b___ = __webpack_require__(2418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ImageModal_vue_vue_type_script_lang_js___ = __webpack_require__(896);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ImageModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ImageModal_vue_vue_type_template_id_36b8fc5b___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ImageModal_vue_vue_type_template_id_36b8fc5b___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "ImageModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LinkModal_vue_vue_type_template_id_27350f96___ = __webpack_require__(2419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LinkModal_vue_vue_type_script_lang_js___ = __webpack_require__(897);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__LinkModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__LinkModal_vue_vue_type_template_id_27350f96___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__LinkModal_vue_vue_type_template_id_27350f96___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "LinkModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PandocExportModal_vue_vue_type_template_id_75f926fb___ = __webpack_require__(2420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PandocExportModal_vue_vue_type_script_lang_js___ = __webpack_require__(898);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__PandocExportModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__PandocExportModal_vue_vue_type_template_id_75f926fb___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__PandocExportModal_vue_vue_type_template_id_75f926fb___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "PandocExportModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PdfExportModal_vue_vue_type_template_id_c42bc19e___ = __webpack_require__(2421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PdfExportModal_vue_vue_type_script_lang_js___ = __webpack_require__(899);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__PdfExportModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__PdfExportModal_vue_vue_type_template_id_c42bc19e___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__PdfExportModal_vue_vue_type_template_id_c42bc19e___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "PdfExportModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PublishManagementModal_vue_vue_type_template_id_423ad81a___ = __webpack_require__(2422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PublishManagementModal_vue_vue_type_script_lang_js___ = __webpack_require__(900);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PublishManagementModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__PublishManagementModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__PublishManagementModal_vue_vue_type_template_id_423ad81a___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__PublishManagementModal_vue_vue_type_template_id_423ad81a___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "PublishManagementModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SettingsModal_vue_vue_type_template_id_069188e8___ = __webpack_require__(2423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SettingsModal_vue_vue_type_script_lang_js___ = __webpack_require__(901);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SettingsModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SettingsModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__SettingsModal_vue_vue_type_template_id_069188e8___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SettingsModal_vue_vue_type_template_id_069188e8___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "SettingsModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SponsorModal_vue_vue_type_template_id_7b433154___ = __webpack_require__(2424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SponsorModal_vue_vue_type_script_lang_js___ = __webpack_require__(902);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SponsorModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SponsorModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__SponsorModal_vue_vue_type_template_id_7b433154___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SponsorModal_vue_vue_type_template_id_7b433154___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "SponsorModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SyncManagementModal_vue_vue_type_template_id_1b097370___ = __webpack_require__(2425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SyncManagementModal_vue_vue_type_script_lang_js___ = __webpack_require__(903);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SyncManagementModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SyncManagementModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__SyncManagementModal_vue_vue_type_template_id_1b097370___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SyncManagementModal_vue_vue_type_template_id_1b097370___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "SyncManagementModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TemplatesModal_vue_vue_type_template_id_4ef579ca___ = __webpack_require__(2426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TemplatesModal_vue_vue_type_script_lang_js___ = __webpack_require__(904);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TemplatesModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TemplatesModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__TemplatesModal_vue_vue_type_template_id_4ef579ca___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TemplatesModal_vue_vue_type_template_id_4ef579ca___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "TemplatesModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WorkspaceManagementModal_vue_vue_type_template_id_806d7196___ = __webpack_require__(2427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WorkspaceManagementModal_vue_vue_type_script_lang_js___ = __webpack_require__(905);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WorkspaceManagementModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__WorkspaceManagementModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__WorkspaceManagementModal_vue_vue_type_template_id_806d7196___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__WorkspaceManagementModal_vue_vue_type_template_id_806d7196___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "WorkspaceManagementModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BloggerPagePublishModal_vue_vue_type_template_id_77328cd8___ = __webpack_require__(2431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BloggerPagePublishModal_vue_vue_type_script_lang_js___ = __webpack_require__(909);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__BloggerPagePublishModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__BloggerPagePublishModal_vue_vue_type_template_id_77328cd8___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__BloggerPagePublishModal_vue_vue_type_template_id_77328cd8___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "BloggerPagePublishModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BloggerPublishModal_vue_vue_type_template_id_4555f8c2___ = __webpack_require__(2432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BloggerPublishModal_vue_vue_type_script_lang_js___ = __webpack_require__(910);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__BloggerPublishModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__BloggerPublishModal_vue_vue_type_template_id_4555f8c2___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__BloggerPublishModal_vue_vue_type_template_id_4555f8c2___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "BloggerPublishModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CouchdbCredentialsModal_vue_vue_type_template_id_3dd4d3ec___ = __webpack_require__(2433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CouchdbCredentialsModal_vue_vue_type_script_lang_js___ = __webpack_require__(911);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__CouchdbCredentialsModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__CouchdbCredentialsModal_vue_vue_type_template_id_3dd4d3ec___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__CouchdbCredentialsModal_vue_vue_type_template_id_3dd4d3ec___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "CouchdbCredentialsModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CouchdbWorkspaceModal_vue_vue_type_template_id_28cc1087___ = __webpack_require__(2434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CouchdbWorkspaceModal_vue_vue_type_script_lang_js___ = __webpack_require__(912);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CouchdbWorkspaceModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__CouchdbWorkspaceModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__CouchdbWorkspaceModal_vue_vue_type_template_id_28cc1087___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__CouchdbWorkspaceModal_vue_vue_type_template_id_28cc1087___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "CouchdbWorkspaceModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DropboxAccountModal_vue_vue_type_template_id_073fe80b___ = __webpack_require__(2435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DropboxAccountModal_vue_vue_type_script_lang_js___ = __webpack_require__(913);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__DropboxAccountModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__DropboxAccountModal_vue_vue_type_template_id_073fe80b___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__DropboxAccountModal_vue_vue_type_template_id_073fe80b___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "DropboxAccountModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DropboxPublishModal_vue_vue_type_template_id_25593900___ = __webpack_require__(2436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DropboxPublishModal_vue_vue_type_script_lang_js___ = __webpack_require__(914);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__DropboxPublishModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__DropboxPublishModal_vue_vue_type_template_id_25593900___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__DropboxPublishModal_vue_vue_type_template_id_25593900___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "DropboxPublishModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DropboxSaveModal_vue_vue_type_template_id_42999494___ = __webpack_require__(2437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DropboxSaveModal_vue_vue_type_script_lang_js___ = __webpack_require__(915);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__DropboxSaveModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__DropboxSaveModal_vue_vue_type_template_id_42999494___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__DropboxSaveModal_vue_vue_type_template_id_42999494___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "DropboxSaveModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GistPublishModal_vue_vue_type_template_id_0b506c1d___ = __webpack_require__(2438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GistPublishModal_vue_vue_type_script_lang_js___ = __webpack_require__(916);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__GistPublishModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__GistPublishModal_vue_vue_type_template_id_0b506c1d___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__GistPublishModal_vue_vue_type_template_id_0b506c1d___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "GistPublishModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GistSyncModal_vue_vue_type_template_id_4e61dd35___ = __webpack_require__(2439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GistSyncModal_vue_vue_type_script_lang_js___ = __webpack_require__(917);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__GistSyncModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__GistSyncModal_vue_vue_type_template_id_4e61dd35___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__GistSyncModal_vue_vue_type_template_id_4e61dd35___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "GistSyncModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GithubAccountModal_vue_vue_type_template_id_6279cc5c___ = __webpack_require__(2440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GithubAccountModal_vue_vue_type_script_lang_js___ = __webpack_require__(918);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__GithubAccountModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__GithubAccountModal_vue_vue_type_template_id_6279cc5c___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__GithubAccountModal_vue_vue_type_template_id_6279cc5c___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "GithubAccountModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GithubOpenModal_vue_vue_type_template_id_0b395fa0___ = __webpack_require__(2441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GithubOpenModal_vue_vue_type_script_lang_js___ = __webpack_require__(919);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__GithubOpenModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__GithubOpenModal_vue_vue_type_template_id_0b395fa0___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__GithubOpenModal_vue_vue_type_template_id_0b395fa0___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "GithubOpenModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GithubPublishModal_vue_vue_type_template_id_a8f050da___ = __webpack_require__(2442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GithubPublishModal_vue_vue_type_script_lang_js___ = __webpack_require__(920);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__GithubPublishModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__GithubPublishModal_vue_vue_type_template_id_a8f050da___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__GithubPublishModal_vue_vue_type_template_id_a8f050da___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "GithubPublishModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GithubSaveModal_vue_vue_type_template_id_38d9e6c8___ = __webpack_require__(2443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GithubSaveModal_vue_vue_type_script_lang_js___ = __webpack_require__(921);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__GithubSaveModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__GithubSaveModal_vue_vue_type_template_id_38d9e6c8___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__GithubSaveModal_vue_vue_type_template_id_38d9e6c8___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "GithubSaveModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GithubWorkspaceModal_vue_vue_type_template_id_412ec522___ = __webpack_require__(2444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GithubWorkspaceModal_vue_vue_type_script_lang_js___ = __webpack_require__(922);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__GithubWorkspaceModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__GithubWorkspaceModal_vue_vue_type_template_id_412ec522___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__GithubWorkspaceModal_vue_vue_type_template_id_412ec522___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "GithubWorkspaceModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GitlabAccountModal_vue_vue_type_template_id_5f478b82___ = __webpack_require__(2445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GitlabAccountModal_vue_vue_type_script_lang_js___ = __webpack_require__(923);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__GitlabAccountModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__GitlabAccountModal_vue_vue_type_template_id_5f478b82___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__GitlabAccountModal_vue_vue_type_template_id_5f478b82___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "GitlabAccountModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GitlabOpenModal_vue_vue_type_template_id_373bef72___ = __webpack_require__(2446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GitlabOpenModal_vue_vue_type_script_lang_js___ = __webpack_require__(924);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__GitlabOpenModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__GitlabOpenModal_vue_vue_type_template_id_373bef72___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__GitlabOpenModal_vue_vue_type_template_id_373bef72___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "GitlabOpenModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GitlabPublishModal_vue_vue_type_template_id_470125a0___ = __webpack_require__(2447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GitlabPublishModal_vue_vue_type_script_lang_js___ = __webpack_require__(925);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__GitlabPublishModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__GitlabPublishModal_vue_vue_type_template_id_470125a0___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__GitlabPublishModal_vue_vue_type_template_id_470125a0___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "GitlabPublishModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GitlabSaveModal_vue_vue_type_template_id_38247121___ = __webpack_require__(2448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GitlabSaveModal_vue_vue_type_script_lang_js___ = __webpack_require__(926);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__GitlabSaveModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__GitlabSaveModal_vue_vue_type_template_id_38247121___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__GitlabSaveModal_vue_vue_type_template_id_38247121___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "GitlabSaveModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GitlabWorkspaceModal_vue_vue_type_template_id_94dfdc68___ = __webpack_require__(2449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GitlabWorkspaceModal_vue_vue_type_script_lang_js___ = __webpack_require__(927);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__GitlabWorkspaceModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__GitlabWorkspaceModal_vue_vue_type_template_id_94dfdc68___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__GitlabWorkspaceModal_vue_vue_type_template_id_94dfdc68___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "GitlabWorkspaceModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GoogleDriveAccountModal_vue_vue_type_template_id_a56df132___ = __webpack_require__(2450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GoogleDriveAccountModal_vue_vue_type_script_lang_js___ = __webpack_require__(928);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__GoogleDriveAccountModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__GoogleDriveAccountModal_vue_vue_type_template_id_a56df132___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__GoogleDriveAccountModal_vue_vue_type_template_id_a56df132___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "GoogleDriveAccountModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GoogleDrivePublishModal_vue_vue_type_template_id_270bd074___ = __webpack_require__(2451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GoogleDrivePublishModal_vue_vue_type_script_lang_js___ = __webpack_require__(929);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__GoogleDrivePublishModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__GoogleDrivePublishModal_vue_vue_type_template_id_270bd074___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__GoogleDrivePublishModal_vue_vue_type_template_id_270bd074___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "GoogleDrivePublishModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GoogleDriveSaveModal_vue_vue_type_template_id_8f85194e___ = __webpack_require__(2452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GoogleDriveSaveModal_vue_vue_type_script_lang_js___ = __webpack_require__(930);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__GoogleDriveSaveModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__GoogleDriveSaveModal_vue_vue_type_template_id_8f85194e___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__GoogleDriveSaveModal_vue_vue_type_template_id_8f85194e___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "GoogleDriveSaveModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GoogleDriveWorkspaceModal_vue_vue_type_template_id_0a0623c4___ = __webpack_require__(2453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GoogleDriveWorkspaceModal_vue_vue_type_script_lang_js___ = __webpack_require__(931);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__GoogleDriveWorkspaceModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__GoogleDriveWorkspaceModal_vue_vue_type_template_id_0a0623c4___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__GoogleDriveWorkspaceModal_vue_vue_type_template_id_0a0623c4___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "GoogleDriveWorkspaceModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GooglePhotoModal_vue_vue_type_template_id_ecda5b60___ = __webpack_require__(2454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GooglePhotoModal_vue_vue_type_script_lang_js___ = __webpack_require__(932);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GooglePhotoModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__GooglePhotoModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__GooglePhotoModal_vue_vue_type_template_id_ecda5b60___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__GooglePhotoModal_vue_vue_type_template_id_ecda5b60___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "GooglePhotoModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WordpressPublishModal_vue_vue_type_template_id_ea40eeda___ = __webpack_require__(2455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WordpressPublishModal_vue_vue_type_script_lang_js___ = __webpack_require__(933);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__WordpressPublishModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__WordpressPublishModal_vue_vue_type_template_id_ea40eeda___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__WordpressPublishModal_vue_vue_type_template_id_ea40eeda___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "WordpressPublishModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ZendeskAccountModal_vue_vue_type_template_id_71af8dbf___ = __webpack_require__(2456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ZendeskAccountModal_vue_vue_type_script_lang_js___ = __webpack_require__(934);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ZendeskAccountModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ZendeskAccountModal_vue_vue_type_template_id_71af8dbf___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ZendeskAccountModal_vue_vue_type_template_id_71af8dbf___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "ZendeskAccountModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ZendeskPublishModal_vue_vue_type_template_id_0a1717a9___ = __webpack_require__(2457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ZendeskPublishModal_vue_vue_type_script_lang_js___ = __webpack_require__(935);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ZendeskPublishModal_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ZendeskPublishModal_vue_vue_type_template_id_0a1717a9___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ZendeskPublishModal_vue_vue_type_template_id_0a1717a9___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "ZendeskPublishModal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Alert_vue_vue_type_template_id_5ebc31ce___ = __webpack_require__(2458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Alert_vue_vue_type_template_id_5ebc31ce___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Alert_vue_vue_type_template_id_5ebc31ce___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Alert.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ArrowLeft_vue_vue_type_template_id_762bdce2___ = __webpack_require__(2459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__ArrowLeft_vue_vue_type_template_id_762bdce2___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ArrowLeft_vue_vue_type_template_id_762bdce2___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArrowLeft.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CheckCircle_vue_vue_type_template_id_5abf85a3___ = __webpack_require__(2460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__CheckCircle_vue_vue_type_template_id_5abf85a3___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__CheckCircle_vue_vue_type_template_id_5abf85a3___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "CheckCircle.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Close_vue_vue_type_template_id_65533fe6___ = __webpack_require__(2461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Close_vue_vue_type_template_id_65533fe6___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Close_vue_vue_type_template_id_65533fe6___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Close.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CodeBraces_vue_vue_type_template_id_42d62230___ = __webpack_require__(2462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__CodeBraces_vue_vue_type_template_id_42d62230___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__CodeBraces_vue_vue_type_template_id_42d62230___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "CodeBraces.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CodeTags_vue_vue_type_template_id_3f258306___ = __webpack_require__(2463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__CodeTags_vue_vue_type_template_id_3f258306___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__CodeTags_vue_vue_type_template_id_3f258306___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "CodeTags.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ContentCopy_vue_vue_type_template_id_8337162c___ = __webpack_require__(2464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__ContentCopy_vue_vue_type_template_id_8337162c___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ContentCopy_vue_vue_type_template_id_8337162c___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "ContentCopy.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ContentSave_vue_vue_type_template_id_d8fecec2___ = __webpack_require__(2465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__ContentSave_vue_vue_type_template_id_d8fecec2___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ContentSave_vue_vue_type_template_id_d8fecec2___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "ContentSave.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Database_vue_vue_type_template_id_706cc37e___ = __webpack_require__(2466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Database_vue_vue_type_template_id_706cc37e___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Database_vue_vue_type_template_id_706cc37e___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Database.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Delete_vue_vue_type_template_id_0469db3c___ = __webpack_require__(2467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Delete_vue_vue_type_template_id_0469db3c___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Delete_vue_vue_type_template_id_0469db3c___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Delete.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DotsHorizontal_vue_vue_type_template_id_1b9b004d___ = __webpack_require__(2468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__DotsHorizontal_vue_vue_type_template_id_1b9b004d___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__DotsHorizontal_vue_vue_type_template_id_1b9b004d___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "DotsHorizontal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Download_vue_vue_type_template_id_1beb3b1c___ = __webpack_require__(2469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Download_vue_vue_type_template_id_1beb3b1c___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Download_vue_vue_type_template_id_1beb3b1c___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Download.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Eye_vue_vue_type_template_id_025b59ea___ = __webpack_require__(2470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Eye_vue_vue_type_template_id_025b59ea___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Eye_vue_vue_type_template_id_025b59ea___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Eye.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FileImage_vue_vue_type_template_id_761d3f03___ = __webpack_require__(2471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__FileImage_vue_vue_type_template_id_761d3f03___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__FileImage_vue_vue_type_template_id_761d3f03___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "FileImage.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FileMultiple_vue_vue_type_template_id_56e6a1bf___ = __webpack_require__(2472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__FileMultiple_vue_vue_type_template_id_56e6a1bf___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__FileMultiple_vue_vue_type_template_id_56e6a1bf___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "FileMultiple.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FilePlus_vue_vue_type_template_id_d28fa894___ = __webpack_require__(2473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__FilePlus_vue_vue_type_template_id_d28fa894___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__FilePlus_vue_vue_type_template_id_d28fa894___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "FilePlus.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Folder_vue_vue_type_template_id_b547d0a4___ = __webpack_require__(2474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Folder_vue_vue_type_template_id_b547d0a4___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Folder_vue_vue_type_template_id_b547d0a4___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Folder.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FolderPlus_vue_vue_type_template_id_6805bc50___ = __webpack_require__(2475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__FolderPlus_vue_vue_type_template_id_6805bc50___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__FolderPlus_vue_vue_type_template_id_6805bc50___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "FolderPlus.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormatBold_vue_vue_type_template_id_8b3cf758___ = __webpack_require__(2476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__FormatBold_vue_vue_type_template_id_8b3cf758___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__FormatBold_vue_vue_type_template_id_8b3cf758___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormatBold.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormatItalic_vue_vue_type_template_id_bd33b56e___ = __webpack_require__(2477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__FormatItalic_vue_vue_type_template_id_bd33b56e___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__FormatItalic_vue_vue_type_template_id_bd33b56e___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormatItalic.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormatListBulleted_vue_vue_type_template_id_2b799082___ = __webpack_require__(2478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__FormatListBulleted_vue_vue_type_template_id_2b799082___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__FormatListBulleted_vue_vue_type_template_id_2b799082___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormatListBulleted.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormatListChecks_vue_vue_type_template_id_e2837bd4___ = __webpack_require__(2479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__FormatListChecks_vue_vue_type_template_id_e2837bd4___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__FormatListChecks_vue_vue_type_template_id_e2837bd4___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormatListChecks.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormatListNumbers_vue_vue_type_template_id_2921c277___ = __webpack_require__(2480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__FormatListNumbers_vue_vue_type_template_id_2921c277___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__FormatListNumbers_vue_vue_type_template_id_2921c277___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormatListNumbers.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormatQuoteClose_vue_vue_type_template_id_49db65f1___ = __webpack_require__(2481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__FormatQuoteClose_vue_vue_type_template_id_49db65f1___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__FormatQuoteClose_vue_vue_type_template_id_49db65f1___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormatQuoteClose.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormatSize_vue_vue_type_template_id_b3ae2874___ = __webpack_require__(2482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__FormatSize_vue_vue_type_template_id_b3ae2874___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__FormatSize_vue_vue_type_template_id_b3ae2874___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormatSize.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormatStrikethrough_vue_vue_type_template_id_0a065764___ = __webpack_require__(2483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__FormatStrikethrough_vue_vue_type_template_id_0a065764___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__FormatStrikethrough_vue_vue_type_template_id_0a065764___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormatStrikethrough.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HelpCircle_vue_vue_type_template_id_673b60cd___ = __webpack_require__(2484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__HelpCircle_vue_vue_type_template_id_673b60cd___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__HelpCircle_vue_vue_type_template_id_673b60cd___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "HelpCircle.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__History_vue_vue_type_template_id_a4f3499c___ = __webpack_require__(2485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__History_vue_vue_type_template_id_a4f3499c___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__History_vue_vue_type_template_id_a4f3499c___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "History.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Information_vue_vue_type_template_id_0345d18a___ = __webpack_require__(2486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Information_vue_vue_type_template_id_0345d18a___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Information_vue_vue_type_template_id_0345d18a___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Information.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Key_vue_vue_type_template_id_4d3945be___ = __webpack_require__(2487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Key_vue_vue_type_template_id_4d3945be___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Key_vue_vue_type_template_id_4d3945be___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Key.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LinkVariant_vue_vue_type_template_id_4aeedd72___ = __webpack_require__(2488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__LinkVariant_vue_vue_type_template_id_4aeedd72___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__LinkVariant_vue_vue_type_template_id_4aeedd72___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "LinkVariant.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Login_vue_vue_type_template_id_79a2d10e___ = __webpack_require__(2489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Login_vue_vue_type_template_id_79a2d10e___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Login_vue_vue_type_template_id_79a2d10e___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Login.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logout_vue_vue_type_template_id_2df5de92___ = __webpack_require__(2490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Logout_vue_vue_type_template_id_2df5de92___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Logout_vue_vue_type_template_id_2df5de92___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Logout.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Magnify_vue_vue_type_template_id_5cd9e566___ = __webpack_require__(2491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Magnify_vue_vue_type_template_id_5cd9e566___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Magnify_vue_vue_type_template_id_5cd9e566___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Magnify.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Message_vue_vue_type_template_id_67373bde___ = __webpack_require__(2492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Message_vue_vue_type_template_id_67373bde___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Message_vue_vue_type_template_id_67373bde___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Message.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NavigationBar_vue_vue_type_template_id_71c7b527___ = __webpack_require__(2493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__NavigationBar_vue_vue_type_template_id_71c7b527___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__NavigationBar_vue_vue_type_template_id_71c7b527___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "NavigationBar.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OpenInNew_vue_vue_type_template_id_7656380f___ = __webpack_require__(2494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__OpenInNew_vue_vue_type_template_id_7656380f___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__OpenInNew_vue_vue_type_template_id_7656380f___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "OpenInNew.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pen_vue_vue_type_template_id_1a40099f___ = __webpack_require__(2495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Pen_vue_vue_type_template_id_1a40099f___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Pen_vue_vue_type_template_id_1a40099f___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Pen.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Printer_vue_vue_type_template_id_f5db01c8___ = __webpack_require__(2496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Printer_vue_vue_type_template_id_f5db01c8___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Printer_vue_vue_type_template_id_f5db01c8___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Printer.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Provider_vue_vue_type_template_id_9505d15c___ = __webpack_require__(2497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Provider_vue_vue_type_script_lang_js___ = __webpack_require__(936);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Provider_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(2377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Provider_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Provider_vue_vue_type_template_id_9505d15c___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Provider_vue_vue_type_template_id_9505d15c___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Provider.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Redo_vue_vue_type_template_id_c8199dac___ = __webpack_require__(2498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Redo_vue_vue_type_template_id_c8199dac___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Redo_vue_vue_type_template_id_c8199dac___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Redo.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScrollSync_vue_vue_type_template_id_67b89c83___ = __webpack_require__(2499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__ScrollSync_vue_vue_type_template_id_67b89c83___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ScrollSync_vue_vue_type_template_id_67b89c83___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "ScrollSync.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Seal_vue_vue_type_template_id_9fb18a62___ = __webpack_require__(2500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Seal_vue_vue_type_template_id_9fb18a62___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Seal_vue_vue_type_template_id_9fb18a62___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Seal.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Settings_vue_vue_type_template_id_1db3f9bc___ = __webpack_require__(2501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Settings_vue_vue_type_template_id_1db3f9bc___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Settings_vue_vue_type_template_id_1db3f9bc___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Settings.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidePreview_vue_vue_type_template_id_63e6ff1e___ = __webpack_require__(2502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__SidePreview_vue_vue_type_template_id_63e6ff1e___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SidePreview_vue_vue_type_template_id_63e6ff1e___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "SidePreview.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SignalOff_vue_vue_type_template_id_5cc3e882___ = __webpack_require__(2503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__SignalOff_vue_vue_type_template_id_5cc3e882___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SignalOff_vue_vue_type_template_id_5cc3e882___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "SignalOff.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StatusBar_vue_vue_type_template_id_6f766fe3___ = __webpack_require__(2504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__StatusBar_vue_vue_type_template_id_6f766fe3___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__StatusBar_vue_vue_type_template_id_6f766fe3___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "StatusBar.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sync_vue_vue_type_template_id_75cf36d8___ = __webpack_require__(2505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Sync_vue_vue_type_template_id_75cf36d8___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Sync_vue_vue_type_template_id_75cf36d8___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Sync.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SyncOff_vue_vue_type_template_id_54ff24b6___ = __webpack_require__(2506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__SyncOff_vue_vue_type_template_id_54ff24b6___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SyncOff_vue_vue_type_template_id_54ff24b6___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "SyncOff.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Table_vue_vue_type_template_id_5a62f68c___ = __webpack_require__(2507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Table_vue_vue_type_template_id_5a62f68c___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Table_vue_vue_type_template_id_5a62f68c___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Table.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Target_vue_vue_type_template_id_bfbf550a___ = __webpack_require__(2508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Target_vue_vue_type_template_id_bfbf550a___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Target_vue_vue_type_template_id_bfbf550a___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Target.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Toc_vue_vue_type_template_id_3ac1a716___ = __webpack_require__(2509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Toc_vue_vue_type_template_id_3ac1a716___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Toc_vue_vue_type_template_id_3ac1a716___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Toc.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Undo_vue_vue_type_template_id_8f7790ea___ = __webpack_require__(2510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Undo_vue_vue_type_template_id_8f7790ea___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Undo_vue_vue_type_template_id_8f7790ea___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Undo.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Upload_vue_vue_type_template_id_5a97f21f___ = __webpack_require__(2511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Upload_vue_vue_type_template_id_5a97f21f___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Upload_vue_vue_type_template_id_5a97f21f___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Upload.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ViewList_vue_vue_type_template_id_92001408___ = __webpack_require__(2512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__ViewList_vue_vue_type_template_id_92001408___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ViewList_vue_vue_type_template_id_92001408___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

component.options.__file = "ViewList.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 2340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonBar_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonBar_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonBar_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonBar_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeEditor_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeEditor_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeEditor_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeEditor_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_ContextMenu_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_ContextMenu_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_ContextMenu_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_ContextMenu_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Editor_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Editor_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Editor_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Editor_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Explorer_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Explorer_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Explorer_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Explorer_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_ExplorerNode_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_ExplorerNode_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_ExplorerNode_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_ExplorerNode_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_FindReplace_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_FindReplace_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_FindReplace_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_FindReplace_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Layout_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Layout_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Layout_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Layout_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Modal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Modal_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Modal_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Modal_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_NavigationBar_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_NavigationBar_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_NavigationBar_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_NavigationBar_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Notification_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Notification_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Notification_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Notification_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Preview_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Preview_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Preview_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Preview_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_SideBar_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_SideBar_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_SideBar_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_SideBar_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_SplashScreen_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_SplashScreen_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_SplashScreen_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_SplashScreen_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusBar_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusBar_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusBar_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusBar_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Toc_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Toc_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Toc_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Toc_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Tour_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Tour_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Tour_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Tour_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_UserImage_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_UserImage_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_UserImage_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_UserImage_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_CommentList_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_CommentList_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_CommentList_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_CommentList_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_CurrentDiscussion_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_CurrentDiscussion_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_CurrentDiscussion_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_CurrentDiscussion_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_StickyComment_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_StickyComment_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_StickyComment_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_StickyComment_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryMenu_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryMenu_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryMenu_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryMenu_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkspacesMenu_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkspacesMenu_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkspacesMenu_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkspacesMenu_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_MenuEntry_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_MenuEntry_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_MenuEntry_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_MenuEntry_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_AboutModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_AboutModal_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_AboutModal_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_AboutModal_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_AccountManagementModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_AccountManagementModal_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_AccountManagementModal_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_AccountManagementModal_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_BadgeManagementModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_BadgeManagementModal_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_BadgeManagementModal_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_BadgeManagementModal_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_FilePropertiesModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_FilePropertiesModal_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_FilePropertiesModal_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_FilePropertiesModal_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_PublishManagementModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_PublishManagementModal_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_PublishManagementModal_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_PublishManagementModal_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_SettingsModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_SettingsModal_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_SettingsModal_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_SettingsModal_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_SponsorModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_SponsorModal_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_SponsorModal_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_SponsorModal_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_SyncManagementModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_SyncManagementModal_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_SyncManagementModal_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_SyncManagementModal_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_TemplatesModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_TemplatesModal_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_TemplatesModal_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_TemplatesModal_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkspaceManagementModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkspaceManagementModal_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkspaceManagementModal_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkspaceManagementModal_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_ModalInner_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_ModalInner_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_ModalInner_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_ModalInner_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_CouchdbWorkspaceModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_CouchdbWorkspaceModal_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_CouchdbWorkspaceModal_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_CouchdbWorkspaceModal_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_GooglePhotoModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_GooglePhotoModal_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_GooglePhotoModal_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_GooglePhotoModal_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Provider_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Provider_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Provider_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_loader_js_ref_11_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_11_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_11_3_node_modules_vue_loader_lib_index_js_vue_loader_options_Provider_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 2378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_template_id_3d7fc3de___ = __webpack_require__(2513);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_template_id_3d7fc3de___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_template_id_3d7fc3de___["b"]; });


/***/ }),
/* 2379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonBar_vue_vue_type_template_id_cb4cfc6c___ = __webpack_require__(2514);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonBar_vue_vue_type_template_id_cb4cfc6c___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonBar_vue_vue_type_template_id_cb4cfc6c___["b"]; });


/***/ }),
/* 2380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeEditor_vue_vue_type_template_id_263a5b36___ = __webpack_require__(2515);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeEditor_vue_vue_type_template_id_263a5b36___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeEditor_vue_vue_type_template_id_263a5b36___["b"]; });


/***/ }),
/* 2381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ContextMenu_vue_vue_type_template_id_f308a61a___ = __webpack_require__(2516);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ContextMenu_vue_vue_type_template_id_f308a61a___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ContextMenu_vue_vue_type_template_id_f308a61a___["b"]; });


/***/ }),
/* 2382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Editor_vue_vue_type_template_id_1fa36192___ = __webpack_require__(2517);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Editor_vue_vue_type_template_id_1fa36192___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Editor_vue_vue_type_template_id_1fa36192___["b"]; });


/***/ }),
/* 2383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Explorer_vue_vue_type_template_id_bef329a8___ = __webpack_require__(2518);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Explorer_vue_vue_type_template_id_bef329a8___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Explorer_vue_vue_type_template_id_bef329a8___["b"]; });


/***/ }),
/* 2384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ExplorerNode_vue_vue_type_template_id_4c39736c___ = __webpack_require__(2519);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ExplorerNode_vue_vue_type_template_id_4c39736c___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ExplorerNode_vue_vue_type_template_id_4c39736c___["b"]; });


/***/ }),
/* 2385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FindReplace_vue_vue_type_template_id_67773bda___ = __webpack_require__(2520);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FindReplace_vue_vue_type_template_id_67773bda___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FindReplace_vue_vue_type_template_id_67773bda___["b"]; });


/***/ }),
/* 2386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Layout_vue_vue_type_template_id_7af4384a___ = __webpack_require__(2521);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Layout_vue_vue_type_template_id_7af4384a___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Layout_vue_vue_type_template_id_7af4384a___["b"]; });


/***/ }),
/* 2387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Modal_vue_vue_type_template_id_300372c2___ = __webpack_require__(2522);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Modal_vue_vue_type_template_id_300372c2___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Modal_vue_vue_type_template_id_300372c2___["b"]; });


/***/ }),
/* 2388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NavigationBar_vue_vue_type_template_id_49d23abe___ = __webpack_require__(2523);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NavigationBar_vue_vue_type_template_id_49d23abe___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NavigationBar_vue_vue_type_template_id_49d23abe___["b"]; });


/***/ }),
/* 2389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Notification_vue_vue_type_template_id_c6a774ba___ = __webpack_require__(2524);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Notification_vue_vue_type_template_id_c6a774ba___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Notification_vue_vue_type_template_id_c6a774ba___["b"]; });


/***/ }),
/* 2390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Preview_vue_vue_type_template_id_d72f6e84___ = __webpack_require__(2525);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Preview_vue_vue_type_template_id_d72f6e84___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Preview_vue_vue_type_template_id_d72f6e84___["b"]; });


/***/ }),
/* 2391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SideBar_vue_vue_type_template_id_71df7eb6___ = __webpack_require__(2526);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SideBar_vue_vue_type_template_id_71df7eb6___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SideBar_vue_vue_type_template_id_71df7eb6___["b"]; });


/***/ }),
/* 2392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SplashScreen_vue_vue_type_template_id_0d0cac6d___ = __webpack_require__(2527);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SplashScreen_vue_vue_type_template_id_0d0cac6d___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SplashScreen_vue_vue_type_template_id_0d0cac6d___["b"]; });


/***/ }),
/* 2393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusBar_vue_vue_type_template_id_3bb0ebd6___ = __webpack_require__(2528);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusBar_vue_vue_type_template_id_3bb0ebd6___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusBar_vue_vue_type_template_id_3bb0ebd6___["b"]; });


/***/ }),
/* 2394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Toc_vue_vue_type_template_id_fb5cc4a2___ = __webpack_require__(2529);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Toc_vue_vue_type_template_id_fb5cc4a2___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Toc_vue_vue_type_template_id_fb5cc4a2___["b"]; });


/***/ }),
/* 2395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Tour_vue_vue_type_template_id_01063a0c___ = __webpack_require__(2530);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Tour_vue_vue_type_template_id_01063a0c___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Tour_vue_vue_type_template_id_01063a0c___["b"]; });


/***/ }),
/* 2396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_UserImage_vue_vue_type_template_id_2fb33b9e___ = __webpack_require__(2531);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_UserImage_vue_vue_type_template_id_2fb33b9e___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_UserImage_vue_vue_type_template_id_2fb33b9e___["b"]; });


/***/ }),
/* 2397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_UserName_vue_vue_type_template_id_e4a96cac___ = __webpack_require__(2532);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_UserName_vue_vue_type_template_id_e4a96cac___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_UserName_vue_vue_type_template_id_e4a96cac___["b"]; });


/***/ }),
/* 2398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Comment_vue_vue_type_template_id_5125024a___ = __webpack_require__(2533);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Comment_vue_vue_type_template_id_5125024a___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Comment_vue_vue_type_template_id_5125024a___["b"]; });


/***/ }),
/* 2399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CommentList_vue_vue_type_template_id_69b763ee___ = __webpack_require__(2534);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CommentList_vue_vue_type_template_id_69b763ee___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CommentList_vue_vue_type_template_id_69b763ee___["b"]; });


/***/ }),
/* 2400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CurrentDiscussion_vue_vue_type_template_id_2b90cf14___ = __webpack_require__(2535);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CurrentDiscussion_vue_vue_type_template_id_2b90cf14___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CurrentDiscussion_vue_vue_type_template_id_2b90cf14___["b"]; });


/***/ }),
/* 2401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_EditorNewDiscussionButton_vue_vue_type_template_id_636a9650___ = __webpack_require__(2536);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_EditorNewDiscussionButton_vue_vue_type_template_id_636a9650___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_EditorNewDiscussionButton_vue_vue_type_template_id_636a9650___["b"]; });


/***/ }),
/* 2402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NewComment_vue_vue_type_template_id_2d6ad252___ = __webpack_require__(2537);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NewComment_vue_vue_type_template_id_2d6ad252___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NewComment_vue_vue_type_template_id_2d6ad252___["b"]; });


/***/ }),
/* 2403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PreviewNewDiscussionButton_vue_vue_type_template_id_56434062___ = __webpack_require__(2538);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PreviewNewDiscussionButton_vue_vue_type_template_id_56434062___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PreviewNewDiscussionButton_vue_vue_type_template_id_56434062___["b"]; });


/***/ }),
/* 2404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_StickyComment_vue_vue_type_template_id_19671b10___ = __webpack_require__(2539);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_StickyComment_vue_vue_type_template_id_19671b10___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_StickyComment_vue_vue_type_template_id_19671b10___["b"]; });


/***/ }),
/* 2405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryMenu_vue_vue_type_template_id_b731285e___ = __webpack_require__(2540);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryMenu_vue_vue_type_template_id_b731285e___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryMenu_vue_vue_type_template_id_b731285e___["b"]; });


/***/ }),
/* 2406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportExportMenu_vue_vue_type_template_id_e7c342a4___ = __webpack_require__(2541);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportExportMenu_vue_vue_type_template_id_e7c342a4___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportExportMenu_vue_vue_type_template_id_e7c342a4___["b"]; });


/***/ }),
/* 2407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MainMenu_vue_vue_type_template_id_e3e62cda___ = __webpack_require__(2542);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MainMenu_vue_vue_type_template_id_e3e62cda___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MainMenu_vue_vue_type_template_id_e3e62cda___["b"]; });


/***/ }),
/* 2408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PublishMenu_vue_vue_type_template_id_a39804ec___ = __webpack_require__(2543);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PublishMenu_vue_vue_type_template_id_a39804ec___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PublishMenu_vue_vue_type_template_id_a39804ec___["b"]; });


/***/ }),
/* 2409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SyncMenu_vue_vue_type_template_id_352ad9b8___ = __webpack_require__(2544);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SyncMenu_vue_vue_type_template_id_352ad9b8___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SyncMenu_vue_vue_type_template_id_352ad9b8___["b"]; });


/***/ }),
/* 2410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkspaceBackupMenu_vue_vue_type_template_id_43f1af8e___ = __webpack_require__(2545);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkspaceBackupMenu_vue_vue_type_template_id_43f1af8e___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkspaceBackupMenu_vue_vue_type_template_id_43f1af8e___["b"]; });


/***/ }),
/* 2411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkspacesMenu_vue_vue_type_template_id_2e2c9170___ = __webpack_require__(2546);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkspacesMenu_vue_vue_type_template_id_2e2c9170___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkspacesMenu_vue_vue_type_template_id_2e2c9170___["b"]; });


/***/ }),
/* 2412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MenuEntry_vue_vue_type_template_id_7a3c52ac___ = __webpack_require__(2547);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MenuEntry_vue_vue_type_template_id_7a3c52ac___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MenuEntry_vue_vue_type_template_id_7a3c52ac___["b"]; });


/***/ }),
/* 2413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AboutModal_vue_vue_type_template_id_f4dab8d2___ = __webpack_require__(2548);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AboutModal_vue_vue_type_template_id_f4dab8d2___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AboutModal_vue_vue_type_template_id_f4dab8d2___["b"]; });


/***/ }),
/* 2414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AccountManagementModal_vue_vue_type_template_id_85623052___ = __webpack_require__(2549);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AccountManagementModal_vue_vue_type_template_id_85623052___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AccountManagementModal_vue_vue_type_template_id_85623052___["b"]; });


/***/ }),
/* 2415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BadgeManagementModal_vue_vue_type_template_id_bb23f0e0___ = __webpack_require__(2550);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BadgeManagementModal_vue_vue_type_template_id_bb23f0e0___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BadgeManagementModal_vue_vue_type_template_id_bb23f0e0___["b"]; });


/***/ }),
/* 2416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FilePropertiesModal_vue_vue_type_template_id_19df34da___ = __webpack_require__(2551);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FilePropertiesModal_vue_vue_type_template_id_19df34da___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FilePropertiesModal_vue_vue_type_template_id_19df34da___["b"]; });


/***/ }),
/* 2417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_HtmlExportModal_vue_vue_type_template_id_2d96e412___ = __webpack_require__(2552);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_HtmlExportModal_vue_vue_type_template_id_2d96e412___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_HtmlExportModal_vue_vue_type_template_id_2d96e412___["b"]; });


/***/ }),
/* 2418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageModal_vue_vue_type_template_id_36b8fc5b___ = __webpack_require__(2553);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageModal_vue_vue_type_template_id_36b8fc5b___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageModal_vue_vue_type_template_id_36b8fc5b___["b"]; });


/***/ }),
/* 2419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_LinkModal_vue_vue_type_template_id_27350f96___ = __webpack_require__(2554);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_LinkModal_vue_vue_type_template_id_27350f96___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_LinkModal_vue_vue_type_template_id_27350f96___["b"]; });


/***/ }),
/* 2420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PandocExportModal_vue_vue_type_template_id_75f926fb___ = __webpack_require__(2555);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PandocExportModal_vue_vue_type_template_id_75f926fb___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PandocExportModal_vue_vue_type_template_id_75f926fb___["b"]; });


/***/ }),
/* 2421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PdfExportModal_vue_vue_type_template_id_c42bc19e___ = __webpack_require__(2556);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PdfExportModal_vue_vue_type_template_id_c42bc19e___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PdfExportModal_vue_vue_type_template_id_c42bc19e___["b"]; });


/***/ }),
/* 2422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PublishManagementModal_vue_vue_type_template_id_423ad81a___ = __webpack_require__(2557);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PublishManagementModal_vue_vue_type_template_id_423ad81a___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PublishManagementModal_vue_vue_type_template_id_423ad81a___["b"]; });


/***/ }),
/* 2423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SettingsModal_vue_vue_type_template_id_069188e8___ = __webpack_require__(2558);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SettingsModal_vue_vue_type_template_id_069188e8___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SettingsModal_vue_vue_type_template_id_069188e8___["b"]; });


/***/ }),
/* 2424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SponsorModal_vue_vue_type_template_id_7b433154___ = __webpack_require__(2559);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SponsorModal_vue_vue_type_template_id_7b433154___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SponsorModal_vue_vue_type_template_id_7b433154___["b"]; });


/***/ }),
/* 2425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SyncManagementModal_vue_vue_type_template_id_1b097370___ = __webpack_require__(2560);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SyncManagementModal_vue_vue_type_template_id_1b097370___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SyncManagementModal_vue_vue_type_template_id_1b097370___["b"]; });


/***/ }),
/* 2426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TemplatesModal_vue_vue_type_template_id_4ef579ca___ = __webpack_require__(2561);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TemplatesModal_vue_vue_type_template_id_4ef579ca___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TemplatesModal_vue_vue_type_template_id_4ef579ca___["b"]; });


/***/ }),
/* 2427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkspaceManagementModal_vue_vue_type_template_id_806d7196___ = __webpack_require__(2562);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkspaceManagementModal_vue_vue_type_template_id_806d7196___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkspaceManagementModal_vue_vue_type_template_id_806d7196___["b"]; });


/***/ }),
/* 2428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormEntry_vue_vue_type_template_id_60a3d8e0___ = __webpack_require__(2563);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormEntry_vue_vue_type_template_id_60a3d8e0___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormEntry_vue_vue_type_template_id_60a3d8e0___["b"]; });


/***/ }),
/* 2429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ModalInner_vue_vue_type_template_id_5744d9d6___ = __webpack_require__(2564);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ModalInner_vue_vue_type_template_id_5744d9d6___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ModalInner_vue_vue_type_template_id_5744d9d6___["b"]; });


/***/ }),
/* 2430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Tab_vue_vue_type_template_id_1ec480ff___ = __webpack_require__(2565);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Tab_vue_vue_type_template_id_1ec480ff___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Tab_vue_vue_type_template_id_1ec480ff___["b"]; });


/***/ }),
/* 2431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BloggerPagePublishModal_vue_vue_type_template_id_77328cd8___ = __webpack_require__(2566);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BloggerPagePublishModal_vue_vue_type_template_id_77328cd8___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BloggerPagePublishModal_vue_vue_type_template_id_77328cd8___["b"]; });


/***/ }),
/* 2432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BloggerPublishModal_vue_vue_type_template_id_4555f8c2___ = __webpack_require__(2567);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BloggerPublishModal_vue_vue_type_template_id_4555f8c2___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BloggerPublishModal_vue_vue_type_template_id_4555f8c2___["b"]; });


/***/ }),
/* 2433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CouchdbCredentialsModal_vue_vue_type_template_id_3dd4d3ec___ = __webpack_require__(2568);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CouchdbCredentialsModal_vue_vue_type_template_id_3dd4d3ec___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CouchdbCredentialsModal_vue_vue_type_template_id_3dd4d3ec___["b"]; });


/***/ }),
/* 2434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CouchdbWorkspaceModal_vue_vue_type_template_id_28cc1087___ = __webpack_require__(2569);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CouchdbWorkspaceModal_vue_vue_type_template_id_28cc1087___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CouchdbWorkspaceModal_vue_vue_type_template_id_28cc1087___["b"]; });


/***/ }),
/* 2435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DropboxAccountModal_vue_vue_type_template_id_073fe80b___ = __webpack_require__(2570);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DropboxAccountModal_vue_vue_type_template_id_073fe80b___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DropboxAccountModal_vue_vue_type_template_id_073fe80b___["b"]; });


/***/ }),
/* 2436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DropboxPublishModal_vue_vue_type_template_id_25593900___ = __webpack_require__(2571);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DropboxPublishModal_vue_vue_type_template_id_25593900___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DropboxPublishModal_vue_vue_type_template_id_25593900___["b"]; });


/***/ }),
/* 2437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DropboxSaveModal_vue_vue_type_template_id_42999494___ = __webpack_require__(2572);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DropboxSaveModal_vue_vue_type_template_id_42999494___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DropboxSaveModal_vue_vue_type_template_id_42999494___["b"]; });


/***/ }),
/* 2438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GistPublishModal_vue_vue_type_template_id_0b506c1d___ = __webpack_require__(2573);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GistPublishModal_vue_vue_type_template_id_0b506c1d___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GistPublishModal_vue_vue_type_template_id_0b506c1d___["b"]; });


/***/ }),
/* 2439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GistSyncModal_vue_vue_type_template_id_4e61dd35___ = __webpack_require__(2574);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GistSyncModal_vue_vue_type_template_id_4e61dd35___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GistSyncModal_vue_vue_type_template_id_4e61dd35___["b"]; });


/***/ }),
/* 2440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GithubAccountModal_vue_vue_type_template_id_6279cc5c___ = __webpack_require__(2575);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GithubAccountModal_vue_vue_type_template_id_6279cc5c___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GithubAccountModal_vue_vue_type_template_id_6279cc5c___["b"]; });


/***/ }),
/* 2441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GithubOpenModal_vue_vue_type_template_id_0b395fa0___ = __webpack_require__(2576);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GithubOpenModal_vue_vue_type_template_id_0b395fa0___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GithubOpenModal_vue_vue_type_template_id_0b395fa0___["b"]; });


/***/ }),
/* 2442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GithubPublishModal_vue_vue_type_template_id_a8f050da___ = __webpack_require__(2577);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GithubPublishModal_vue_vue_type_template_id_a8f050da___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GithubPublishModal_vue_vue_type_template_id_a8f050da___["b"]; });


/***/ }),
/* 2443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GithubSaveModal_vue_vue_type_template_id_38d9e6c8___ = __webpack_require__(2578);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GithubSaveModal_vue_vue_type_template_id_38d9e6c8___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GithubSaveModal_vue_vue_type_template_id_38d9e6c8___["b"]; });


/***/ }),
/* 2444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GithubWorkspaceModal_vue_vue_type_template_id_412ec522___ = __webpack_require__(2579);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GithubWorkspaceModal_vue_vue_type_template_id_412ec522___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GithubWorkspaceModal_vue_vue_type_template_id_412ec522___["b"]; });


/***/ }),
/* 2445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GitlabAccountModal_vue_vue_type_template_id_5f478b82___ = __webpack_require__(2580);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GitlabAccountModal_vue_vue_type_template_id_5f478b82___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GitlabAccountModal_vue_vue_type_template_id_5f478b82___["b"]; });


/***/ }),
/* 2446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GitlabOpenModal_vue_vue_type_template_id_373bef72___ = __webpack_require__(2581);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GitlabOpenModal_vue_vue_type_template_id_373bef72___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GitlabOpenModal_vue_vue_type_template_id_373bef72___["b"]; });


/***/ }),
/* 2447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GitlabPublishModal_vue_vue_type_template_id_470125a0___ = __webpack_require__(2582);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GitlabPublishModal_vue_vue_type_template_id_470125a0___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GitlabPublishModal_vue_vue_type_template_id_470125a0___["b"]; });


/***/ }),
/* 2448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GitlabSaveModal_vue_vue_type_template_id_38247121___ = __webpack_require__(2583);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GitlabSaveModal_vue_vue_type_template_id_38247121___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GitlabSaveModal_vue_vue_type_template_id_38247121___["b"]; });


/***/ }),
/* 2449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GitlabWorkspaceModal_vue_vue_type_template_id_94dfdc68___ = __webpack_require__(2584);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GitlabWorkspaceModal_vue_vue_type_template_id_94dfdc68___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GitlabWorkspaceModal_vue_vue_type_template_id_94dfdc68___["b"]; });


/***/ }),
/* 2450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GoogleDriveAccountModal_vue_vue_type_template_id_a56df132___ = __webpack_require__(2585);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GoogleDriveAccountModal_vue_vue_type_template_id_a56df132___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GoogleDriveAccountModal_vue_vue_type_template_id_a56df132___["b"]; });


/***/ }),
/* 2451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GoogleDrivePublishModal_vue_vue_type_template_id_270bd074___ = __webpack_require__(2586);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GoogleDrivePublishModal_vue_vue_type_template_id_270bd074___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GoogleDrivePublishModal_vue_vue_type_template_id_270bd074___["b"]; });


/***/ }),
/* 2452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GoogleDriveSaveModal_vue_vue_type_template_id_8f85194e___ = __webpack_require__(2587);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GoogleDriveSaveModal_vue_vue_type_template_id_8f85194e___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GoogleDriveSaveModal_vue_vue_type_template_id_8f85194e___["b"]; });


/***/ }),
/* 2453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GoogleDriveWorkspaceModal_vue_vue_type_template_id_0a0623c4___ = __webpack_require__(2588);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GoogleDriveWorkspaceModal_vue_vue_type_template_id_0a0623c4___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GoogleDriveWorkspaceModal_vue_vue_type_template_id_0a0623c4___["b"]; });


/***/ }),
/* 2454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GooglePhotoModal_vue_vue_type_template_id_ecda5b60___ = __webpack_require__(2589);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GooglePhotoModal_vue_vue_type_template_id_ecda5b60___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GooglePhotoModal_vue_vue_type_template_id_ecda5b60___["b"]; });


/***/ }),
/* 2455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_WordpressPublishModal_vue_vue_type_template_id_ea40eeda___ = __webpack_require__(2590);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_WordpressPublishModal_vue_vue_type_template_id_ea40eeda___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_WordpressPublishModal_vue_vue_type_template_id_ea40eeda___["b"]; });


/***/ }),
/* 2456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ZendeskAccountModal_vue_vue_type_template_id_71af8dbf___ = __webpack_require__(2591);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ZendeskAccountModal_vue_vue_type_template_id_71af8dbf___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ZendeskAccountModal_vue_vue_type_template_id_71af8dbf___["b"]; });


/***/ }),
/* 2457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ZendeskPublishModal_vue_vue_type_template_id_0a1717a9___ = __webpack_require__(2592);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ZendeskPublishModal_vue_vue_type_template_id_0a1717a9___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ZendeskPublishModal_vue_vue_type_template_id_0a1717a9___["b"]; });


/***/ }),
/* 2458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Alert_vue_vue_type_template_id_5ebc31ce___ = __webpack_require__(2593);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Alert_vue_vue_type_template_id_5ebc31ce___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Alert_vue_vue_type_template_id_5ebc31ce___["b"]; });


/***/ }),
/* 2459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ArrowLeft_vue_vue_type_template_id_762bdce2___ = __webpack_require__(2594);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ArrowLeft_vue_vue_type_template_id_762bdce2___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ArrowLeft_vue_vue_type_template_id_762bdce2___["b"]; });


/***/ }),
/* 2460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CheckCircle_vue_vue_type_template_id_5abf85a3___ = __webpack_require__(2595);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CheckCircle_vue_vue_type_template_id_5abf85a3___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CheckCircle_vue_vue_type_template_id_5abf85a3___["b"]; });


/***/ }),
/* 2461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Close_vue_vue_type_template_id_65533fe6___ = __webpack_require__(2596);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Close_vue_vue_type_template_id_65533fe6___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Close_vue_vue_type_template_id_65533fe6___["b"]; });


/***/ }),
/* 2462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeBraces_vue_vue_type_template_id_42d62230___ = __webpack_require__(2597);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeBraces_vue_vue_type_template_id_42d62230___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeBraces_vue_vue_type_template_id_42d62230___["b"]; });


/***/ }),
/* 2463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeTags_vue_vue_type_template_id_3f258306___ = __webpack_require__(2598);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeTags_vue_vue_type_template_id_3f258306___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeTags_vue_vue_type_template_id_3f258306___["b"]; });


/***/ }),
/* 2464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ContentCopy_vue_vue_type_template_id_8337162c___ = __webpack_require__(2599);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ContentCopy_vue_vue_type_template_id_8337162c___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ContentCopy_vue_vue_type_template_id_8337162c___["b"]; });


/***/ }),
/* 2465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ContentSave_vue_vue_type_template_id_d8fecec2___ = __webpack_require__(2600);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ContentSave_vue_vue_type_template_id_d8fecec2___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ContentSave_vue_vue_type_template_id_d8fecec2___["b"]; });


/***/ }),
/* 2466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Database_vue_vue_type_template_id_706cc37e___ = __webpack_require__(2601);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Database_vue_vue_type_template_id_706cc37e___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Database_vue_vue_type_template_id_706cc37e___["b"]; });


/***/ }),
/* 2467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Delete_vue_vue_type_template_id_0469db3c___ = __webpack_require__(2602);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Delete_vue_vue_type_template_id_0469db3c___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Delete_vue_vue_type_template_id_0469db3c___["b"]; });


/***/ }),
/* 2468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DotsHorizontal_vue_vue_type_template_id_1b9b004d___ = __webpack_require__(2603);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DotsHorizontal_vue_vue_type_template_id_1b9b004d___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DotsHorizontal_vue_vue_type_template_id_1b9b004d___["b"]; });


/***/ }),
/* 2469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Download_vue_vue_type_template_id_1beb3b1c___ = __webpack_require__(2604);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Download_vue_vue_type_template_id_1beb3b1c___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Download_vue_vue_type_template_id_1beb3b1c___["b"]; });


/***/ }),
/* 2470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Eye_vue_vue_type_template_id_025b59ea___ = __webpack_require__(2605);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Eye_vue_vue_type_template_id_025b59ea___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Eye_vue_vue_type_template_id_025b59ea___["b"]; });


/***/ }),
/* 2471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FileImage_vue_vue_type_template_id_761d3f03___ = __webpack_require__(2606);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FileImage_vue_vue_type_template_id_761d3f03___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FileImage_vue_vue_type_template_id_761d3f03___["b"]; });


/***/ }),
/* 2472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FileMultiple_vue_vue_type_template_id_56e6a1bf___ = __webpack_require__(2607);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FileMultiple_vue_vue_type_template_id_56e6a1bf___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FileMultiple_vue_vue_type_template_id_56e6a1bf___["b"]; });


/***/ }),
/* 2473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FilePlus_vue_vue_type_template_id_d28fa894___ = __webpack_require__(2608);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FilePlus_vue_vue_type_template_id_d28fa894___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FilePlus_vue_vue_type_template_id_d28fa894___["b"]; });


/***/ }),
/* 2474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Folder_vue_vue_type_template_id_b547d0a4___ = __webpack_require__(2609);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Folder_vue_vue_type_template_id_b547d0a4___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Folder_vue_vue_type_template_id_b547d0a4___["b"]; });


/***/ }),
/* 2475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FolderPlus_vue_vue_type_template_id_6805bc50___ = __webpack_require__(2610);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FolderPlus_vue_vue_type_template_id_6805bc50___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FolderPlus_vue_vue_type_template_id_6805bc50___["b"]; });


/***/ }),
/* 2476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormatBold_vue_vue_type_template_id_8b3cf758___ = __webpack_require__(2611);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormatBold_vue_vue_type_template_id_8b3cf758___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormatBold_vue_vue_type_template_id_8b3cf758___["b"]; });


/***/ }),
/* 2477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormatItalic_vue_vue_type_template_id_bd33b56e___ = __webpack_require__(2612);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormatItalic_vue_vue_type_template_id_bd33b56e___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormatItalic_vue_vue_type_template_id_bd33b56e___["b"]; });


/***/ }),
/* 2478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormatListBulleted_vue_vue_type_template_id_2b799082___ = __webpack_require__(2613);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormatListBulleted_vue_vue_type_template_id_2b799082___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormatListBulleted_vue_vue_type_template_id_2b799082___["b"]; });


/***/ }),
/* 2479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormatListChecks_vue_vue_type_template_id_e2837bd4___ = __webpack_require__(2614);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormatListChecks_vue_vue_type_template_id_e2837bd4___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormatListChecks_vue_vue_type_template_id_e2837bd4___["b"]; });


/***/ }),
/* 2480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormatListNumbers_vue_vue_type_template_id_2921c277___ = __webpack_require__(2615);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormatListNumbers_vue_vue_type_template_id_2921c277___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormatListNumbers_vue_vue_type_template_id_2921c277___["b"]; });


/***/ }),
/* 2481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormatQuoteClose_vue_vue_type_template_id_49db65f1___ = __webpack_require__(2616);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormatQuoteClose_vue_vue_type_template_id_49db65f1___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormatQuoteClose_vue_vue_type_template_id_49db65f1___["b"]; });


/***/ }),
/* 2482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormatSize_vue_vue_type_template_id_b3ae2874___ = __webpack_require__(2617);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormatSize_vue_vue_type_template_id_b3ae2874___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormatSize_vue_vue_type_template_id_b3ae2874___["b"]; });


/***/ }),
/* 2483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormatStrikethrough_vue_vue_type_template_id_0a065764___ = __webpack_require__(2618);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormatStrikethrough_vue_vue_type_template_id_0a065764___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FormatStrikethrough_vue_vue_type_template_id_0a065764___["b"]; });


/***/ }),
/* 2484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_HelpCircle_vue_vue_type_template_id_673b60cd___ = __webpack_require__(2619);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_HelpCircle_vue_vue_type_template_id_673b60cd___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_HelpCircle_vue_vue_type_template_id_673b60cd___["b"]; });


/***/ }),
/* 2485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_History_vue_vue_type_template_id_a4f3499c___ = __webpack_require__(2620);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_History_vue_vue_type_template_id_a4f3499c___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_History_vue_vue_type_template_id_a4f3499c___["b"]; });


/***/ }),
/* 2486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Information_vue_vue_type_template_id_0345d18a___ = __webpack_require__(2621);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Information_vue_vue_type_template_id_0345d18a___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Information_vue_vue_type_template_id_0345d18a___["b"]; });


/***/ }),
/* 2487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Key_vue_vue_type_template_id_4d3945be___ = __webpack_require__(2622);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Key_vue_vue_type_template_id_4d3945be___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Key_vue_vue_type_template_id_4d3945be___["b"]; });


/***/ }),
/* 2488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_LinkVariant_vue_vue_type_template_id_4aeedd72___ = __webpack_require__(2623);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_LinkVariant_vue_vue_type_template_id_4aeedd72___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_LinkVariant_vue_vue_type_template_id_4aeedd72___["b"]; });


/***/ }),
/* 2489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Login_vue_vue_type_template_id_79a2d10e___ = __webpack_require__(2624);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Login_vue_vue_type_template_id_79a2d10e___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Login_vue_vue_type_template_id_79a2d10e___["b"]; });


/***/ }),
/* 2490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Logout_vue_vue_type_template_id_2df5de92___ = __webpack_require__(2625);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Logout_vue_vue_type_template_id_2df5de92___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Logout_vue_vue_type_template_id_2df5de92___["b"]; });


/***/ }),
/* 2491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Magnify_vue_vue_type_template_id_5cd9e566___ = __webpack_require__(2626);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Magnify_vue_vue_type_template_id_5cd9e566___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Magnify_vue_vue_type_template_id_5cd9e566___["b"]; });


/***/ }),
/* 2492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Message_vue_vue_type_template_id_67373bde___ = __webpack_require__(2627);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Message_vue_vue_type_template_id_67373bde___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Message_vue_vue_type_template_id_67373bde___["b"]; });


/***/ }),
/* 2493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NavigationBar_vue_vue_type_template_id_71c7b527___ = __webpack_require__(2628);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NavigationBar_vue_vue_type_template_id_71c7b527___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NavigationBar_vue_vue_type_template_id_71c7b527___["b"]; });


/***/ }),
/* 2494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_OpenInNew_vue_vue_type_template_id_7656380f___ = __webpack_require__(2629);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_OpenInNew_vue_vue_type_template_id_7656380f___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_OpenInNew_vue_vue_type_template_id_7656380f___["b"]; });


/***/ }),
/* 2495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Pen_vue_vue_type_template_id_1a40099f___ = __webpack_require__(2630);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Pen_vue_vue_type_template_id_1a40099f___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Pen_vue_vue_type_template_id_1a40099f___["b"]; });


/***/ }),
/* 2496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Printer_vue_vue_type_template_id_f5db01c8___ = __webpack_require__(2631);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Printer_vue_vue_type_template_id_f5db01c8___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Printer_vue_vue_type_template_id_f5db01c8___["b"]; });


/***/ }),
/* 2497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Provider_vue_vue_type_template_id_9505d15c___ = __webpack_require__(2632);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Provider_vue_vue_type_template_id_9505d15c___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Provider_vue_vue_type_template_id_9505d15c___["b"]; });


/***/ }),
/* 2498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Redo_vue_vue_type_template_id_c8199dac___ = __webpack_require__(2633);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Redo_vue_vue_type_template_id_c8199dac___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Redo_vue_vue_type_template_id_c8199dac___["b"]; });


/***/ }),
/* 2499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ScrollSync_vue_vue_type_template_id_67b89c83___ = __webpack_require__(2634);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ScrollSync_vue_vue_type_template_id_67b89c83___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ScrollSync_vue_vue_type_template_id_67b89c83___["b"]; });


/***/ }),
/* 2500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Seal_vue_vue_type_template_id_9fb18a62___ = __webpack_require__(2635);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Seal_vue_vue_type_template_id_9fb18a62___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Seal_vue_vue_type_template_id_9fb18a62___["b"]; });


/***/ }),
/* 2501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Settings_vue_vue_type_template_id_1db3f9bc___ = __webpack_require__(2636);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Settings_vue_vue_type_template_id_1db3f9bc___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Settings_vue_vue_type_template_id_1db3f9bc___["b"]; });


/***/ }),
/* 2502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SidePreview_vue_vue_type_template_id_63e6ff1e___ = __webpack_require__(2637);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SidePreview_vue_vue_type_template_id_63e6ff1e___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SidePreview_vue_vue_type_template_id_63e6ff1e___["b"]; });


/***/ }),
/* 2503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SignalOff_vue_vue_type_template_id_5cc3e882___ = __webpack_require__(2638);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SignalOff_vue_vue_type_template_id_5cc3e882___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SignalOff_vue_vue_type_template_id_5cc3e882___["b"]; });


/***/ }),
/* 2504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusBar_vue_vue_type_template_id_6f766fe3___ = __webpack_require__(2639);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusBar_vue_vue_type_template_id_6f766fe3___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusBar_vue_vue_type_template_id_6f766fe3___["b"]; });


/***/ }),
/* 2505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Sync_vue_vue_type_template_id_75cf36d8___ = __webpack_require__(2640);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Sync_vue_vue_type_template_id_75cf36d8___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Sync_vue_vue_type_template_id_75cf36d8___["b"]; });


/***/ }),
/* 2506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SyncOff_vue_vue_type_template_id_54ff24b6___ = __webpack_require__(2641);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SyncOff_vue_vue_type_template_id_54ff24b6___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SyncOff_vue_vue_type_template_id_54ff24b6___["b"]; });


/***/ }),
/* 2507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Table_vue_vue_type_template_id_5a62f68c___ = __webpack_require__(2642);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Table_vue_vue_type_template_id_5a62f68c___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Table_vue_vue_type_template_id_5a62f68c___["b"]; });


/***/ }),
/* 2508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Target_vue_vue_type_template_id_bfbf550a___ = __webpack_require__(2643);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Target_vue_vue_type_template_id_bfbf550a___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Target_vue_vue_type_template_id_bfbf550a___["b"]; });


/***/ }),
/* 2509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Toc_vue_vue_type_template_id_3ac1a716___ = __webpack_require__(2644);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Toc_vue_vue_type_template_id_3ac1a716___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Toc_vue_vue_type_template_id_3ac1a716___["b"]; });


/***/ }),
/* 2510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Undo_vue_vue_type_template_id_8f7790ea___ = __webpack_require__(2645);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Undo_vue_vue_type_template_id_8f7790ea___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Undo_vue_vue_type_template_id_8f7790ea___["b"]; });


/***/ }),
/* 2511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Upload_vue_vue_type_template_id_5a97f21f___ = __webpack_require__(2646);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Upload_vue_vue_type_template_id_5a97f21f___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Upload_vue_vue_type_template_id_5a97f21f___["b"]; });


/***/ }),
/* 2512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ViewList_vue_vue_type_template_id_92001408___ = __webpack_require__(2647);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ViewList_vue_vue_type_template_id_92001408___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ViewList_vue_vue_type_template_id_92001408___["b"]; });


/***/ }),
/* 2513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",class:_vm.classes,on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }return _vm.close($event)}}},[(!_vm.ready)?_c('splash-screen'):_c('layout'),_vm._v(" "),_c('modal'),_vm._v(" "),_c('notification'),_vm._v(" "),_c('context-menu')],1)}
var staticRenderFns = []



/***/ }),
/* 2514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-bar"},[_c('div',{staticClass:"button-bar__inner button-bar__inner--top"},[(!_vm.light)?_c('button',{directives:[{name:"title",rawName:"v-title",value:('Toggle navigation bar'),expression:"'Toggle navigation bar'"}],staticClass:"button-bar__button button-bar__button--navigation-bar-toggler button",class:{ 'button-bar__button--on': _vm.layoutSettings.showNavigationBar },on:{"click":function($event){_vm.toggleNavigationBar()}}},[_c('icon-navigation-bar')],1):_vm._e(),_vm._v(" "),_c('button',{directives:[{name:"title",rawName:"v-title",value:('Toggle side preview'),expression:"'Toggle side preview'"}],staticClass:"button-bar__button button-bar__button--side-preview-toggler button",class:{ 'button-bar__button--on': _vm.layoutSettings.showSidePreview },attrs:{"tour-step-anchor":"editor"},on:{"click":function($event){_vm.toggleSidePreview()}}},[_c('icon-side-preview')],1),_vm._v(" "),_c('button',{directives:[{name:"title",rawName:"v-title",value:('Reader mode'),expression:"'Reader mode'"}],staticClass:"button-bar__button button-bar__button--editor-toggler button",on:{"click":function($event){_vm.toggleEditor(false)}}},[_c('icon-eye')],1)]),_vm._v(" "),_c('div',{staticClass:"button-bar__inner button-bar__inner--bottom"},[_c('button',{directives:[{name:"title",rawName:"v-title",value:('Toggle focus mode'),expression:"'Toggle focus mode'"}],staticClass:"button-bar__button button-bar__button--focus-mode-toggler button",class:{ 'button-bar__button--on': _vm.layoutSettings.focusMode },on:{"click":function($event){_vm.toggleFocusMode()}}},[_c('icon-target')],1),_vm._v(" "),_c('button',{directives:[{name:"title",rawName:"v-title",value:('Toggle scroll sync'),expression:"'Toggle scroll sync'"}],staticClass:"button-bar__button button-bar__button--scroll-sync-toggler button",class:{ 'button-bar__button--on': _vm.layoutSettings.scrollSync },on:{"click":function($event){_vm.toggleScrollSync()}}},[_c('icon-scroll-sync')],1),_vm._v(" "),_c('button',{directives:[{name:"title",rawName:"v-title",value:('Toggle status bar'),expression:"'Toggle status bar'"}],staticClass:"button-bar__button button-bar__button--status-bar-toggler button",class:{ 'button-bar__button--on': _vm.layoutSettings.showStatusBar },on:{"click":function($event){_vm.toggleStatusBar()}}},[_c('icon-status-bar')],1)])])}
var staticRenderFns = []



/***/ }),
/* 2515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',{staticClass:"code-editor textfield prism",attrs:{"disabled":_vm.disabled}})}
var staticRenderFns = []



/***/ }),
/* 2516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('div',{staticClass:"context-menu",on:{"click":function($event){_vm.close()},"contextmenu":function($event){$event.preventDefault();_vm.close()}}},[_c('div',{staticClass:"context-menu__inner flex flex--column",style:({ left: _vm.coordinates.left + 'px', top: _vm.coordinates.top + 'px' }),on:{"click":function($event){$event.stopPropagation();}}},_vm._l((_vm.items),function(item,idx){return _c('div',{key:idx},[(item.type === 'separator')?_c('div',{staticClass:"context-menu__separator"}):(item.disabled)?_c('div',{staticClass:"context-menu__item context-menu__item--disabled"},[_vm._v(_vm._s(item.name))]):_c('a',{staticClass:"context-menu__item",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.close(item)}}},[_vm._v(_vm._s(item.name))])])}))]):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 2517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor"},[_c('pre',{staticClass:"editor__inner markdown-highlighting",class:{monospaced: _vm.computedSettings.editor.monospacedFontOnly},style:({padding: _vm.styles.editorPadding})}),_vm._v(" "),_c('div',{staticClass:"gutter",style:({left: _vm.styles.editorGutterLeft + 'px'})},[(_vm.styles.editorGutterWidth)?_c('comment-list'):_vm._e(),_vm._v(" "),(!_vm.isCurrentTemp)?_c('editor-new-discussion-button'):_vm._e()],1)])}
var staticRenderFns = []



/***/ }),
/* 2518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"explorer flex flex--column"},[_c('div',{staticClass:"side-title flex flex--row flex--space-between"},[_c('div',{staticClass:"flex flex--row"},[_c('button',{directives:[{name:"title",rawName:"v-title",value:('New file'),expression:"'New file'"}],staticClass:"side-title__button side-title__button--new-file button",on:{"click":function($event){_vm.newItem()}}},[_c('icon-file-plus')],1),_vm._v(" "),_c('button',{directives:[{name:"title",rawName:"v-title",value:('New folder'),expression:"'New folder'"}],staticClass:"side-title__button side-title__button--new-folder button",on:{"click":function($event){_vm.newItem(true)}}},[_c('icon-folder-plus')],1),_vm._v(" "),_c('button',{directives:[{name:"title",rawName:"v-title",value:('Delete'),expression:"'Delete'"}],staticClass:"side-title__button side-title__button--delete button",on:{"click":function($event){_vm.deleteItem()}}},[_c('icon-delete')],1),_vm._v(" "),_c('button',{directives:[{name:"title",rawName:"v-title",value:('Rename'),expression:"'Rename'"}],staticClass:"side-title__button side-title__button--rename button",on:{"click":function($event){_vm.editItem()}}},[_c('icon-pen')],1)]),_vm._v(" "),_c('button',{directives:[{name:"title",rawName:"v-title",value:('Close explorer'),expression:"'Close explorer'"}],staticClass:"side-title__button side-title__button--close button",on:{"click":function($event){_vm.toggleExplorer(false)}}},[_c('icon-close')],1)]),_vm._v(" "),(!_vm.light)?_c('div',{staticClass:"explorer__tree",class:{'explorer__tree--new-item': !_vm.newChildNode.isNil},attrs:{"tabindex":"0"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete"])){ return null; }_vm.deleteItem()}}},[_c('explorer-node',{attrs:{"node":_vm.rootNode,"depth":0}})],1):_vm._e()])}
var staticRenderFns = []



/***/ }),
/* 2519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"explorer-node",class:{'explorer-node--selected': _vm.isSelected, 'explorer-node--folder': _vm.node.isFolder, 'explorer-node--open': _vm.isOpen, 'explorer-node--trash': _vm.node.isTrash, 'explorer-node--temp': _vm.node.isTemp, 'explorer-node--drag-target': _vm.isDragTargetFolder},on:{"dragover":function($event){$event.preventDefault();},"dragenter":function($event){$event.stopPropagation();_vm.node.noDrop || _vm.setDragTarget(_vm.node)},"dragleave":function($event){$event.stopPropagation();_vm.isDragTarget && _vm.setDragTarget()},"drop":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onDrop($event)},"contextmenu":_vm.onContextMenu}},[(_vm.isEditing)?_c('div',{staticClass:"explorer-node__item-editor",style:({paddingLeft: _vm.leftPadding}),attrs:{"draggable":"true"},on:{"dragstart":function($event){$event.stopPropagation();$event.preventDefault();}}},[_c('input',{directives:[{name:"focus",rawName:"v-focus"},{name:"model",rawName:"v-model",value:(_vm.editingNodeName),expression:"editingNodeName"}],staticClass:"text-input",attrs:{"type":"text"},domProps:{"value":(_vm.editingNodeName)},on:{"blur":function($event){_vm.submitEdit()},"keydown":[function($event){$event.stopPropagation();},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.submitEdit()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }$event.stopPropagation();_vm.submitEdit(true)}],"input":function($event){if($event.target.composing){ return; }_vm.editingNodeName=$event.target.value}}})]):_c('div',{staticClass:"explorer-node__item",style:({paddingLeft: _vm.leftPadding}),attrs:{"draggable":"true"},on:{"click":function($event){_vm.select()},"dragstart":function($event){$event.stopPropagation();return _vm.setDragSourceId($event)},"dragend":function($event){$event.stopPropagation();_vm.setDragTarget()}}},[_vm._v("\n    "+_vm._s(_vm.node.item.name)+"\n    "),_vm._l((_vm.node.locations),function(location){return _c('icon-provider',{key:location.id,staticClass:"explorer-node__location",attrs:{"provider-id":location.providerId}})})],2),_vm._v(" "),(_vm.node.isFolder && _vm.isOpen)?_c('div',{staticClass:"explorer-node__children"},[_vm._l((_vm.node.folders),function(node){return _c('explorer-node',{key:node.item.id,attrs:{"node":node,"depth":_vm.depth + 1}})}),_vm._v(" "),(_vm.newChild)?_c('div',{staticClass:"explorer-node__new-child",class:{'explorer-node__new-child--folder': _vm.newChild.isFolder},style:({paddingLeft: _vm.childLeftPadding})},[_c('input',{directives:[{name:"focus",rawName:"v-focus"},{name:"model",rawName:"v-model.trim",value:(_vm.newChildName),expression:"newChildName",modifiers:{"trim":true}}],staticClass:"text-input",attrs:{"type":"text"},domProps:{"value":(_vm.newChildName)},on:{"blur":[function($event){_vm.submitNewChild()},function($event){_vm.$forceUpdate()}],"keydown":[function($event){$event.stopPropagation();},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.submitNewChild()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }$event.stopPropagation();_vm.submitNewChild(true)}],"input":function($event){if($event.target.composing){ return; }_vm.newChildName=$event.target.value.trim()}}})]):_vm._e(),_vm._v(" "),_vm._l((_vm.node.files),function(node){return _c('explorer-node',{key:node.item.id,attrs:{"node":node,"depth":_vm.depth + 1}})})],2):_vm._e()])}
var staticRenderFns = []



/***/ }),
/* 2520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"find-replace",on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }$event.stopPropagation();return _vm.onEscape($event)}}},[_c('button',{directives:[{name:"title",rawName:"v-title",value:('Close'),expression:"'Close'"}],staticClass:"find-replace__close-button button not-tabbable",on:{"click":function($event){_vm.close()}}},[_c('icon-close')],1),_vm._v(" "),_c('div',{staticClass:"find-replace__row"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.findText),expression:"findText"}],staticClass:"find-replace__text-input find-replace__text-input--find text-input",attrs:{"type":"text"},domProps:{"value":(_vm.findText)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.find('forward')},"input":function($event){if($event.target.composing){ return; }_vm.findText=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"find-replace__find-stats"},[_vm._v("\n      "+_vm._s(_vm.findPosition)+" of "+_vm._s(_vm.findCount)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"flex flex--row flex--space-between"},[_c('div',{staticClass:"flex flex--row"},[_c('button',{staticClass:"find-replace__button find-replace__button--find-option button",class:{'find-replace__button--on': _vm.findCaseSensitive},attrs:{"title":"Case sensitive"},on:{"click":function($event){_vm.findCaseSensitive = !_vm.findCaseSensitive}}},[_vm._v("Aa")]),_vm._v(" "),_c('button',{staticClass:"find-replace__button find-replace__button--find-option button",class:{'find-replace__button--on': _vm.findUseRegexp},attrs:{"title":"Regular expression"},on:{"click":function($event){_vm.findUseRegexp = !_vm.findUseRegexp}}},[_vm._v("."),_c('sup',[_vm._v("⁕")])])]),_vm._v(" "),_c('div',{staticClass:"flex flex--row"},[_c('button',{staticClass:"find-replace__button button",on:{"click":function($event){_vm.find('backward')}}},[_vm._v("Previous")]),_vm._v(" "),_c('button',{staticClass:"find-replace__button button",on:{"click":function($event){_vm.find('forward')}}},[_vm._v("Next")])])])]),_vm._v(" "),(_vm.type === 'replace')?_c('div',[_c('div',{staticClass:"find-replace__row"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.replaceText),expression:"replaceText"}],staticClass:"find-replace__text-input find-replace__text-input--replace text-input",attrs:{"type":"text"},domProps:{"value":(_vm.replaceText)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.replace($event)},"input":function($event){if($event.target.composing){ return; }_vm.replaceText=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"find-replace__row flex flex--row flex--end"},[_c('button',{staticClass:"find-replace__button button",on:{"click":_vm.replace}},[_vm._v("Replace")]),_vm._v(" "),_c('button',{staticClass:"find-replace__button button",on:{"click":_vm.replaceAll}},[_vm._v("All")])])]):_vm._e()])}
var staticRenderFns = []



/***/ }),
/* 2521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout",class:{'layout--revision': _vm.revisionContent}},[_c('div',{staticClass:"layout__panel flex flex--row",class:{'flex--end': _vm.styles.showSideBar}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.styles.showExplorer),expression:"styles.showExplorer"}],staticClass:"layout__panel layout__panel--explorer",style:({width: _vm.styles.layoutOverflow ? '100%' : _vm.constants.explorerWidth + 'px'}),attrs:{"aria-hidden":!_vm.styles.showExplorer}},[_c('explorer')],1),_vm._v(" "),_c('div',{staticClass:"layout__panel flex flex--column",style:({width: _vm.styles.innerWidth + 'px'}),attrs:{"tour-step-anchor":"welcome,end"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.styles.showNavigationBar),expression:"styles.showNavigationBar"}],staticClass:"layout__panel layout__panel--navigation-bar",style:({height: _vm.constants.navigationBarHeight + 'px'})},[_c('navigation-bar')],1),_vm._v(" "),_c('div',{staticClass:"layout__panel flex flex--row",style:({height: _vm.styles.innerHeight + 'px'})},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.styles.showEditor),expression:"styles.showEditor"}],staticClass:"layout__panel layout__panel--editor",style:({width: (_vm.styles.editorWidth + _vm.styles.editorGutterWidth) + 'px', fontSize: _vm.styles.fontSize + 'px'})},[_c('div',{staticClass:"gutter",style:({left: _vm.styles.editorGutterLeft + 'px'})},[(_vm.styles.editorGutterWidth)?_c('div',{staticClass:"gutter__background",style:({width: _vm.styles.editorGutterWidth + 'px'})}):_vm._e()]),_vm._v(" "),_c('editor'),_vm._v(" "),_c('div',{staticClass:"gutter",style:({left: _vm.styles.editorGutterLeft + 'px'})},[(_vm.styles.editorGutterWidth && _vm.stickyComment === 'top')?_c('sticky-comment'):_vm._e(),_vm._v(" "),(_vm.styles.editorGutterWidth)?_c('current-discussion'):_vm._e()],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.styles.showEditor),expression:"styles.showEditor"}],staticClass:"layout__panel layout__panel--button-bar",style:({width: _vm.constants.buttonBarWidth + 'px'})},[_c('button-bar')],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.styles.showPreview),expression:"styles.showPreview"}],staticClass:"layout__panel layout__panel--preview",style:({width: (_vm.styles.previewWidth + _vm.styles.previewGutterWidth) + 'px', fontSize: _vm.styles.fontSize + 'px'})},[_c('div',{staticClass:"gutter",style:({left: _vm.styles.previewGutterLeft + 'px'})},[(_vm.styles.previewGutterWidth)?_c('div',{staticClass:"gutter__background",style:({width: _vm.styles.previewGutterWidth + 'px'})}):_vm._e()]),_vm._v(" "),_c('preview'),_vm._v(" "),_c('div',{staticClass:"gutter",style:({left: _vm.styles.previewGutterLeft + 'px'})},[(_vm.styles.previewGutterWidth && _vm.stickyComment === 'top')?_c('sticky-comment'):_vm._e(),_vm._v(" "),(_vm.styles.previewGutterWidth)?_c('current-discussion'):_vm._e()],1)],1),_vm._v(" "),(_vm.showFindReplace)?_c('div',{staticClass:"layout__panel layout__panel--find-replace"},[_c('find-replace')],1):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.styles.showStatusBar),expression:"styles.showStatusBar"}],staticClass:"layout__panel layout__panel--status-bar",style:({height: _vm.constants.statusBarHeight + 'px'})},[_c('status-bar')],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.styles.showSideBar),expression:"styles.showSideBar"}],staticClass:"layout__panel layout__panel--side-bar",style:({width: _vm.styles.layoutOverflow ? '100%' : _vm.constants.sideBarWidth + 'px'})},[_c('side-bar')],1)]),_vm._v(" "),(!_vm.light && !_vm.layoutSettings.welcomeTourFinished)?_c('tour'):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 2522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.config)?_c('div',{staticClass:"modal",on:{"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }$event.stopPropagation();return _vm.onEscape($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.onTab($event)}],"focusin":_vm.onFocusInOut,"focusout":_vm.onFocusInOut}},[(!_vm.isSponsor)?_c('div',{staticClass:"modal__sponsor-banner"},[_vm._v("\n    StackEdit is "),_c('a',{staticClass:"not-tabbable",attrs:{"target":"_blank","href":"https://github.com/benweet/stackedit/"}},[_vm._v("open source")]),_vm._v(", please consider\n    "),_c('a',{staticClass:"not-tabbable",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.sponsor}},[_vm._v("sponsoring")]),_vm._v(" for just $5.\n  ")]):_vm._e(),_vm._v(" "),(_vm.currentModalComponent)?_c(_vm.currentModalComponent,{tag:"component"}):_c('modal-inner',{attrs:{"aria-label":"Dialog"}},[_c('div',{staticClass:"modal__content",domProps:{"innerHTML":_vm._s(_vm.simpleModal.contentHtml(_vm.config))}}),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[(_vm.simpleModal.rejectText)?_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v(_vm._s(_vm.simpleModal.rejectText))]):_vm._e(),_vm._v(" "),(_vm.simpleModal.resolveText)?_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.config.resolve()}}},[_vm._v(_vm._s(_vm.simpleModal.resolveText))]):_vm._e()])])],1):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 2523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navigation-bar",class:{'navigation-bar--editor': _vm.styles.showEditor && !_vm.revisionContent, 'navigation-bar--light': _vm.light}},[_c('div',{staticClass:"navigation-bar__inner navigation-bar__inner--left navigation-bar__inner--button"},[(_vm.light)?_c('button',{directives:[{name:"title",rawName:"v-title",value:('Close StackEdit'),expression:"'Close StackEdit'"}],staticClass:"navigation-bar__button navigation-bar__button--close button",on:{"click":function($event){_vm.close()}}},[_c('icon-check-circle')],1):_c('button',{directives:[{name:"title",rawName:"v-title",value:('Toggle explorer'),expression:"'Toggle explorer'"}],staticClass:"navigation-bar__button navigation-bar__button--explorer-toggler button",attrs:{"tour-step-anchor":"explorer"},on:{"click":function($event){_vm.toggleExplorer()}}},[_c('icon-folder')],1)]),_vm._v(" "),_c('div',{staticClass:"navigation-bar__inner navigation-bar__inner--right navigation-bar__inner--button"},[(_vm.light)?_c('a',{directives:[{name:"title",rawName:"v-title",value:('Open StackEdit'),expression:"'Open StackEdit'"}],staticClass:"navigation-bar__button navigation-bar__button--stackedit button",attrs:{"href":"app","target":"_blank"}},[_c('icon-provider',{attrs:{"provider-id":"stackedit"}})],1):_c('button',{directives:[{name:"title",rawName:"v-title",value:('Toggle side bar'),expression:"'Toggle side bar'"}],staticClass:"navigation-bar__button navigation-bar__button--stackedit button",attrs:{"tour-step-anchor":"menu"},on:{"click":function($event){_vm.toggleSideBar()}}},[_c('icon-provider',{attrs:{"provider-id":"stackedit"}})],1)]),_vm._v(" "),_c('div',{staticClass:"navigation-bar__inner navigation-bar__inner--right navigation-bar__inner--title flex flex--row"},[_c('div',{staticClass:"navigation-bar__spinner"},[(!_vm.offline && _vm.showSpinner)?_c('div',{staticClass:"spinner"}):_vm._e(),_vm._v(" "),(_vm.offline)?_c('icon-sync-off'):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"navigation-bar__title navigation-bar__title--fake text-input"}),_vm._v(" "),_c('div',{staticClass:"navigation-bar__title navigation-bar__title--text text-input",style:({width: _vm.titleWidth + 'px'})},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],staticClass:"navigation-bar__title navigation-bar__title--input text-input",class:{'navigation-bar__title--focus': _vm.titleFocus, 'navigation-bar__title--scrolling': _vm.titleScrolling},style:({width: _vm.titleWidth + 'px'}),domProps:{"value":(_vm.title)},on:{"focus":function($event){_vm.editTitle(true)},"blur":function($event){_vm.editTitle(false)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.submitTitle(false)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }$event.stopPropagation();_vm.submitTitle(true)}],"mouseenter":function($event){_vm.titleHover = true},"mouseleave":function($event){_vm.titleHover = false},"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"flex flex--row",class:{'navigation-bar__hidden': _vm.styles.hideLocations}},[_vm._l((_vm.syncLocations),function(location){return _c('a',{directives:[{name:"title",rawName:"v-title",value:('Synchronized location'),expression:"'Synchronized location'"}],key:location.id,staticClass:"navigation-bar__button navigation-bar__button--location button",class:{'navigation-bar__button--blink': location.id === _vm.currentLocation.id},attrs:{"href":location.url,"target":"_blank"}},[_c('icon-provider',{attrs:{"provider-id":location.providerId}})],1)}),_vm._v(" "),_c('button',{directives:[{name:"title",rawName:"v-title",value:('Synchronize now'),expression:"'Synchronize now'"}],staticClass:"navigation-bar__button navigation-bar__button--sync button",attrs:{"disabled":!_vm.isSyncPossible || _vm.isSyncRequested || _vm.offline},on:{"click":_vm.requestSync}},[_c('icon-sync')],1),_vm._v(" "),_vm._l((_vm.publishLocations),function(location){return _c('a',{directives:[{name:"title",rawName:"v-title",value:('Publish location'),expression:"'Publish location'"}],key:location.id,staticClass:"navigation-bar__button navigation-bar__button--location button",class:{'navigation-bar__button--blink': location.id === _vm.currentLocation.id},attrs:{"href":location.url,"target":"_blank"}},[_c('icon-provider',{attrs:{"provider-id":location.providerId}})],1)}),_vm._v(" "),_c('button',{directives:[{name:"title",rawName:"v-title",value:('Publish now'),expression:"'Publish now'"}],staticClass:"navigation-bar__button navigation-bar__button--publish button",attrs:{"disabled":!_vm.publishLocations.length || _vm.isPublishRequested || _vm.offline},on:{"click":_vm.requestPublish}},[_c('icon-upload')],1)],2),_vm._v(" "),(_vm.revisionContent)?_c('div',{staticClass:"flex flex--row"},[_c('button',{staticClass:"navigation-bar__button navigation-bar__button--revision navigation-bar__button--restore button",on:{"click":_vm.restoreRevision}},[_vm._v("Restore")]),_vm._v(" "),_c('button',{directives:[{name:"title",rawName:"v-title",value:('Close revision'),expression:"'Close revision'"}],staticClass:"navigation-bar__button navigation-bar__button--revision button",on:{"click":function($event){_vm.setRevisionContent()}}},[_c('icon-close')],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"navigation-bar__inner navigation-bar__inner--edit-pagedownButtons"},[_c('button',{directives:[{name:"title",rawName:"v-title",value:('Undo'),expression:"'Undo'"}],staticClass:"navigation-bar__button button",attrs:{"disabled":!_vm.canUndo},on:{"click":_vm.undo}},[_c('icon-undo')],1),_vm._v(" "),_c('button',{directives:[{name:"title",rawName:"v-title",value:('Redo'),expression:"'Redo'"}],staticClass:"navigation-bar__button button",attrs:{"disabled":!_vm.canRedo},on:{"click":_vm.redo}},[_c('icon-redo')],1),_vm._v(" "),_vm._l((_vm.pagedownButtons),function(button){return _c('div',{key:button.method},[(button.method)?_c('button',{directives:[{name:"title",rawName:"v-title",value:(button.titleWithShortcut),expression:"button.titleWithShortcut"}],staticClass:"navigation-bar__button button",on:{"click":function($event){_vm.pagedownClick(button.method)}}},[_c(button.iconClass,{tag:"component"})],1):_c('div',{staticClass:"navigation-bar__spacer"})])})],2)])}
var staticRenderFns = []



/***/ }),
/* 2524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification"},_vm._l((_vm.items),function(item,idx){return _c('div',{key:idx,staticClass:"notification__item flex flex--row flex--align-center"},[_c('div',{staticClass:"notification__icon flex flex--column flex--center"},[(item.type === 'error')?_c('icon-alert'):(item.type === 'badge')?_c('icon-check-circle'):_c('icon-information')],1),_vm._v(" "),_c('div',{staticClass:"notification__content"},[_vm._v("\n      "+_vm._s(item.content)+"\n    ")]),_vm._v(" "),(item.type === 'confirm')?_c('button',{staticClass:"notification__button button",on:{"click":item.reject}},[_vm._v("\n      No\n    ")]):_vm._e(),_vm._v(" "),(item.type === 'confirm')?_c('button',{staticClass:"notification__button button",on:{"click":item.resolve}},[_vm._v("\n      Yes\n    ")]):_vm._e()])}))}
var staticRenderFns = []



/***/ }),
/* 2525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview"},[_c('div',{staticClass:"preview__inner-1",on:{"click":_vm.onClick,"scroll":_vm.onScroll}},[_c('div',{staticClass:"preview__inner-2",style:({padding: _vm.styles.previewPadding})}),_vm._v(" "),_c('div',{staticClass:"gutter",style:({left: _vm.styles.previewGutterLeft + 'px'})},[(_vm.styles.previewGutterWidth)?_c('comment-list'):_vm._e(),_vm._v(" "),(!_vm.isCurrentTemp)?_c('preview-new-discussion-button'):_vm._e()],1)]),_vm._v(" "),(!_vm.styles.showEditor)?_c('div',{staticClass:"preview__corner"},[_c('button',{directives:[{name:"title",rawName:"v-title",value:('Edit file'),expression:"'Edit file'"}],staticClass:"preview__button button",on:{"click":function($event){_vm.toggleEditor(true)}}},[_c('icon-pen')],1)]):_vm._e()])}
var staticRenderFns = []



/***/ }),
/* 2526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-bar flex flex--column"},[_c('div',{staticClass:"side-title flex flex--row"},[(_vm.panel !== 'menu')?_c('button',{directives:[{name:"title",rawName:"v-title",value:('Main menu'),expression:"'Main menu'"}],staticClass:"side-title__button button",on:{"click":function($event){_vm.setPanel('menu')}}},[_c('icon-dots-horizontal')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"side-title__title"},[_vm._v("\n      "+_vm._s(_vm.panelName)+"\n    ")]),_vm._v(" "),_c('button',{directives:[{name:"title",rawName:"v-title",value:('Close side bar'),expression:"'Close side bar'"}],staticClass:"side-title__button button",on:{"click":function($event){_vm.toggleSideBar(false)}}},[_c('icon-close')],1)]),_vm._v(" "),_c('div',{staticClass:"side-bar__inner"},[(_vm.panel === 'menu')?_c('main-menu'):(_vm.panel === 'workspaces')?_c('workspaces-menu'):(_vm.panel === 'sync')?_c('sync-menu'):(_vm.panel === 'publish')?_c('publish-menu'):(_vm.panel === 'history')?_c('history-menu'):(_vm.panel === 'export')?_c('export-menu'):(_vm.panel === 'importExport')?_c('import-export-menu'):(_vm.panel === 'workspaceBackups')?_c('workspace-backup-menu'):(_vm.panel === 'help')?_c('div',{staticClass:"side-bar__panel side-bar__panel--help"},[_c('pre',{staticClass:"markdown-highlighting",domProps:{"innerHTML":_vm._s(_vm.markdownSample)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"side-bar__panel side-bar__panel--toc",class:{'side-bar__panel--hidden': _vm.panel !== 'toc'}},[_c('toc')],1)],1)])}
var staticRenderFns = []



/***/ }),
/* 2527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"splash-screen"},[_c('div',{staticClass:"splash-screen__inner logo-background"})])}]



/***/ }),
/* 2528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stat-panel panel no-overflow"},[(_vm.styles.showEditor)?_c('div',{staticClass:"stat-panel__block stat-panel__block--left"},[_c('span',{staticClass:"stat-panel__block-name"},[_vm._v("\n      Markdown\n      "),(_vm.textSelection)?_c('span',[_vm._v("selection")]):_vm._e()]),_vm._v(" "),_vm._l((_vm.textStats),function(stat){return _c('span',{key:stat.id},[_c('span',{staticClass:"stat-panel__value"},[_vm._v(_vm._s(stat.value))]),_vm._v(" "+_vm._s(stat.name)+"\n    ")])}),_vm._v(" "),_c('span',{staticClass:"stat-panel__value"},[_vm._v("Ln "+_vm._s(_vm.line)+", Col "+_vm._s(_vm.column))])],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"stat-panel__block stat-panel__block--right"},[_c('span',{staticClass:"stat-panel__block-name"},[_vm._v("\n      HTML\n      "),(_vm.htmlSelection)?_c('span',[_vm._v("selection")]):_vm._e()]),_vm._v(" "),_vm._l((_vm.htmlStats),function(stat){return _c('span',{key:stat.id},[_c('span',{staticClass:"stat-panel__value"},[_vm._v(_vm._s(stat.value))]),_vm._v(" "+_vm._s(stat.name)+"\n    ")])})],2)])}
var staticRenderFns = []



/***/ }),
/* 2529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toc"},[_c('div',{staticClass:"toc__mask",style:({top: (_vm.maskY - 5) + 'px'})}),_vm._v(" "),_c('div',{staticClass:"toc__inner"})])}
var staticRenderFns = []



/***/ }),
/* 2530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tour",on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }$event.stopPropagation();return _vm.skip($event)}}},[_c('div',{staticClass:"tour-step",class:'tour-step--' + _vm.step,style:(_vm.stepStyle)},[(_vm.step === 'welcome')?_c('div',{staticClass:"tour-step__inner"},[_c('h2',[_vm._v("Welcome back!")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"tour-step__button-bar"},[_c('button',{staticClass:"button",on:{"click":_vm.finish}},[_vm._v("Skip")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":_vm.next}},[_vm._v("Next")])])]):(_vm.step === 'editor')?_c('div',{staticClass:"tour-step__inner"},[_c('h2',[_vm._v("Your Markdown editor")]),_vm._v(" "),_c('p',[_vm._v("StackEdit converts your Markdown to HTML in real-time.")]),_vm._v(" "),_c('p',[_vm._v("Click "),_c('icon-side-preview'),_vm._v(" to toggle the side preview.")],1),_vm._v(" "),_c('div',{staticClass:"tour-step__button-bar"},[_c('button',{staticClass:"button",on:{"click":_vm.finish}},[_vm._v("Skip")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":_vm.next}},[_vm._v("Next")])])]):(_vm.step === 'explorer')?_c('div',{staticClass:"tour-step__inner"},[_c('h2',[_vm._v("File explorer")]),_vm._v(" "),_c('p',[_vm._v("StackEdit can manage multiple files and folders in a workspace.")]),_vm._v(" "),_c('p',[_vm._v("Click "),_c('icon-folder'),_vm._v(" to open the file explorer.")],1),_vm._v(" "),_c('div',{staticClass:"tour-step__button-bar"},[_c('button',{staticClass:"button",on:{"click":_vm.finish}},[_vm._v("Skip")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":_vm.next}},[_vm._v("Next")])])]):(_vm.step === 'menu')?_c('div',{staticClass:"tour-step__inner"},[_c('h2',[_vm._v("Do a lot more!")]),_vm._v(" "),_c('p',[_vm._v("StackEdit can also synchronize and publish your files, manage collaborative workspaces...")]),_vm._v(" "),_c('p',[_vm._v("Click "),_c('icon-provider',{attrs:{"provider-id":"stackedit"}}),_vm._v(" to explore the menu.")],1),_vm._v(" "),_c('div',{staticClass:"tour-step__button-bar"},[_c('button',{staticClass:"button",on:{"click":_vm.finish}},[_vm._v("Skip")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":_vm.next}},[_vm._v("Next")])])]):(_vm.step === 'end')?_c('div',{staticClass:"tour-step__inner"},[_c('h2',[_vm._v("Enjoy!")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"tour-step__button-bar"},[_c('button',{staticClass:"button button--resolve",on:{"click":_vm.finish}},[_vm._v("Ok")])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The new "),_c('b',[_vm._v("StackEdit 5")]),_vm._v(" is here!")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Please click "),_c('b',[_vm._v("Next")]),_vm._v(" to take a quick tour.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("If you like StackEdit, please rate 5 stars on the "),_c('a',{attrs:{"target":"_blank","href":"https://chrome.google.com/webstore/detail/iiooodelglhkcpgbajoejffhijaclcdg/reviews"}},[_vm._v("Chrome Web Store")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("You can also star the project on "),_c('a',{attrs:{"target":"_blank","href":"https://github.com/benweet/stackedit"}},[_vm._v("GitHub")]),_vm._v(" and join the "),_c('a',{attrs:{"target":"_blank","href":"https://community.stackedit.io/"}},[_vm._v("community")]),_vm._v(".")])}]



/***/ }),
/* 2531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-image",style:({backgroundImage: _vm.url})})}
var staticRenderFns = []



/***/ }),
/* 2532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"user-name"},[_vm._v(_vm._s(_vm.name))])}
var staticRenderFns = []



/***/ }),
/* 2533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comment"},[_c('div',{staticClass:"comment__header flex flex--row flex--space-between flex--align-center"},[_c('div',{staticClass:"comment__user flex flex--row flex--align-center"},[_c('div',{staticClass:"comment__user-image"},[_c('user-image',{attrs:{"user-id":_vm.comment.sub}})],1),_vm._v(" "),_c('button',{directives:[{name:"title",rawName:"v-title",value:('Remove comment'),expression:"'Remove comment'"}],staticClass:"comment__remove-button button",on:{"click":_vm.removeComment}},[_c('icon-delete')],1),_vm._v(" "),_c('user-name',{attrs:{"user-id":_vm.comment.sub}})],1),_vm._v(" "),_c('div',{staticClass:"comment__created"},[_vm._v(_vm._s(_vm._f("formatTime")(_vm.comment.created)))])]),_vm._v(" "),_c('div',{staticClass:"comment__text"},[_c('div',{staticClass:"comment__text-inner",domProps:{"innerHTML":_vm._s(_vm.text)}})]),_vm._v(" "),(_vm.showReply)?_c('div',{staticClass:"comment__buttons flex flex--row flex--end"},[_c('button',{staticClass:"comment__button button",on:{"click":function($event){_vm.setIsCommenting(true)}}},[_vm._v("Reply")])]):_vm._e()])}
var staticRenderFns = []



/***/ }),
/* 2534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comment-list",class:_vm.stickyComment && 'comment-list--' + _vm.stickyComment,style:({width: _vm.constants.gutterWidth + 'px'})},[_vm._l((_vm.currentFileDiscussionLastComments),function(comment,discussionId){return (comment.discussionId !== _vm.currentDiscussionId)?_c('comment',{key:discussionId,staticClass:"comment--last",class:'comment--discussion-' + discussionId,style:({top: _vm.tops[discussionId] + 'px'}),attrs:{"comment":comment},nativeOn:{"click":function($event){_vm.setCurrentDiscussionId(discussionId)}}}):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"comment-list__current-discussion",style:({top: _vm.tops.current + 'px'})},[_vm._l((_vm.currentDiscussionComments),function(comment,id){return _c('comment',{key:id,class:'comment--' + id,attrs:{"comment":comment}})}),_vm._v(" "),(_vm.isCommenting)?_c('new-comment'):_vm._e()],2)],2)}
var staticRenderFns = []



/***/ }),
/* 2535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"current-discussion",style:({width: _vm.constants.gutterWidth + 'px'})},[(_vm.stickyComment === 'bottom')?_c('sticky-comment'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"current-discussion__inner"},[_c('div',{staticClass:"flex flex--row flex--space-between"},[_c('div',{staticClass:"current-discussion__buttons flex flex--row flex--end"},[(_vm.showNext)?_c('button',{directives:[{name:"title",rawName:"v-title",value:('Previous discussion'),expression:"'Previous discussion'"}],staticClass:"current-discussion__button button",on:{"click":function($event){_vm.goToDiscussion(_vm.previousDiscussionId)}}},[_c('icon-arrow-left')],1):_vm._e(),_vm._v(" "),(_vm.showNext)?_c('button',{directives:[{name:"title",rawName:"v-title",value:('Next discussion'),expression:"'Next discussion'"}],staticClass:"current-discussion__button current-discussion__button--rotate button",on:{"click":function($event){_vm.goToDiscussion(_vm.nextDiscussionId)}}},[_c('icon-arrow-left')],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"current-discussion__buttons flex flex--row flex--end"},[(_vm.showRemove)?_c('button',{directives:[{name:"title",rawName:"v-title",value:('Remove discussion'),expression:"'Remove discussion'"}],staticClass:"current-discussion__button current-discussion__button--remove button",on:{"click":_vm.removeDiscussion}},[_c('icon-delete')],1):_vm._e(),_vm._v(" "),_c('button',{directives:[{name:"title",rawName:"v-title",value:('Close discussion'),expression:"'Close discussion'"}],staticClass:"current-discussion__button button",on:{"click":function($event){_vm.setCurrentDiscussionId()}}},[_c('icon-close')],1)])]),_vm._v(" "),_c('div',{staticClass:"current-discussion__text markdown-highlighting markdown-highlighting--inline"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)},on:{"click":function($event){_vm.goToDiscussion()}}})])])],1)}
var staticRenderFns = []



/***/ }),
/* 2536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.coordinates)?_c('a',{directives:[{name:"title",rawName:"v-title",value:('Start a discussion'),expression:"'Start a discussion'"}],staticClass:"new-discussion-button",style:({top: _vm.coordinates.top + 'px'}),attrs:{"href":"javascript:void(0)"},on:{"mousedown":function($event){$event.stopPropagation();$event.preventDefault();},"click":function($event){_vm.createNewDiscussion(_vm.selection)}}},[_c('icon-message')],1):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 2537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comment comment--new",on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }$event.stopPropagation();return _vm.cancelNewComment($event)}}},[_c('div',{staticClass:"comment__header flex flex--row flex--space-between flex--align-center"},[_c('div',{staticClass:"comment__user flex flex--row flex--align-center"},[_c('div',{staticClass:"comment__user-image"},[_c('user-image',{attrs:{"user-id":_vm.userId}})],1),_vm._v(" "),_c('span',{staticClass:"user-name"},[_vm._v(_vm._s(_vm.loginToken.name))])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"comment__buttons flex flex--row flex--end"},[_c('button',{staticClass:"comment__button button",on:{"click":_vm.cancelNewComment}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"comment__button button",on:{"click":_vm.addComment}},[_vm._v("Ok")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comment__text"},[_c('div',{staticClass:"comment__text-inner"},[_c('pre',{staticClass:"markdown-highlighting"})])])}]



/***/ }),
/* 2538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.coordinates)?_c('a',{directives:[{name:"title",rawName:"v-title",value:('Start a discussion'),expression:"'Start a discussion'"}],staticClass:"new-discussion-button",style:({top: _vm.coordinates.top + 'px'}),attrs:{"href":"javascript:void(0)"},on:{"mousedown":function($event){$event.stopPropagation();$event.preventDefault();},"click":function($event){_vm.createNewDiscussion(_vm.selection)}}},[_c('icon-message')],1):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 2539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sticky-comment",style:({width: _vm.constants.gutterWidth + 'px', top: _vm.top + 'px'})},[(_vm.currentDiscussionLastComment)?_c('comment',{attrs:{"comment":_vm.currentDiscussionLastComment}}):_vm._e(),_vm._v(" "),(_vm.isCommenting)?_c('new-comment'):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 2540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"history side-bar__panel side-bar__panel--menu"},[_c('div',{staticClass:"side-bar__info"},[(_vm.syncLocations.length > 1)?_c('p',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.syncLocationId),expression:"syncLocationId"}],staticClass:"textfield",attrs:{"slot":"field"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.syncLocationId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}},slot:"field"},_vm._l((_vm.syncLocations),function(location){return _c('option',{key:location.id,domProps:{"value":location.id}},[_vm._v("\n          "+_vm._s(location.description)+"\n        ")])}))]):_vm._e(),_vm._v(" "),(!_vm.historyContext)?_c('p',[_vm._v("Synchronize "),_c('b',[_vm._v(_vm._s(_vm.currentFileName))]),_vm._v(" to enable revision history or "),_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.signin}},[_vm._v("sign in with Google")]),_vm._v(" to synchronize your main workspace.")]):(_vm.loading)?_c('p',[_vm._v("Loading history…")]):(!_vm.revisionsWithSpacer.length)?_c('p',[_c('b',[_vm._v(_vm._s(_vm.currentFileName))]),_vm._v(" has no history.")]):_c('div',{staticClass:"menu-entry menu-entry--info flex flex--row flex--align-center"},[_c('div',{staticClass:"menu-entry__icon menu-entry__icon--image"},[_c('icon-provider',{attrs:{"provider-id":_vm.syncLocation.providerId}})],1),_vm._v(" "),(_vm.syncLocation.url)?_c('span',[_vm._v("\n        The following revisions are stored in "),_c('a',{attrs:{"href":_vm.syncLocation.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.syncLocationProviderName))]),_vm._v(".\n      ")]):_c('span',[_vm._v("\n        The following revisions are stored in "+_vm._s(_vm.syncLocationProviderName)+".\n      ")])])]),_vm._v(" "),_c('div',_vm._l((_vm.revisionsWithSpacer),function(revision){return _c('div',{key:revision.id,staticClass:"revision"},[(revision.spacer)?_c('div',{staticClass:"history__spacer"}):_vm._e(),_vm._v(" "),_c('a',{staticClass:"revision__button button flex flex--row",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.open(revision)}}},[_c('div',{staticClass:"revision__icon"},[_c('user-image',{attrs:{"user-id":revision.sub}})],1),_vm._v(" "),_c('div',{staticClass:"revision__header flex flex--column"},[_c('user-name',{attrs:{"user-id":revision.sub}}),_vm._v(" "),_c('div',{staticClass:"revision__created"},[_vm._v(_vm._s(_vm._f("formatTime")(revision.created)))])],1)])])})),_vm._v(" "),(_vm.revisions.length)?_c('div',{staticClass:"history__spacer history__spacer--last"}):_vm._e(),_vm._v(" "),(_vm.showMoreButton)?_c('div',{staticClass:"flex flex--row flex--end"},[_c('button',{staticClass:"history__button button",on:{"click":_vm.showMore}},[_vm._v("More")])]):_vm._e()])}
var staticRenderFns = []



/***/ }),
/* 2541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-bar__panel side-bar__panel--menu"},[_c('input',{staticClass:"hidden-file",attrs:{"id":"import-markdown-file-input","type":"file"},on:{"change":_vm.onImportMarkdown}}),_vm._v(" "),_c('label',{staticClass:"menu-entry button flex flex--row flex--align-center",attrs:{"for":"import-markdown-file-input"}},[_c('div',{staticClass:"menu-entry__icon flex flex--column flex--center"},[_c('icon-upload')],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('input',{staticClass:"hidden-file",attrs:{"id":"import-html-file-input","type":"file"},on:{"change":_vm.onImportHtml}}),_vm._v(" "),_c('label',{staticClass:"menu-entry button flex flex--row flex--align-center",attrs:{"for":"import-html-file-input"}},[_c('div',{staticClass:"menu-entry__icon flex flex--column flex--center"},[_c('icon-upload')],1),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.exportMarkdown($event)}}},[_c('icon-download',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("Export as Markdown")]),_vm._v(" "),_c('span',[_vm._v("Save plain text file.")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.exportHtml($event)}}},[_c('icon-download',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("Export as HTML")]),_vm._v(" "),_c('span',[_vm._v("Generate an HTML page from a template.")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.exportPdf($event)}}},[_c('icon-download',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v(" "),_c('div',[_c('div',{staticClass:"menu-entry__label",class:{'menu-entry__label--warning': !_vm.isSponsor}},[_vm._v("sponsor")]),_vm._v(" Export as PDF")]),_vm._v(" "),_c('span',[_vm._v("Produce a PDF from an HTML template.")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.exportPandoc($event)}}},[_c('icon-download',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v(" "),_c('div',[_c('div',{staticClass:"menu-entry__label",class:{'menu-entry__label--warning': !_vm.isSponsor}},[_vm._v("sponsor")]),_vm._v(" Export with Pandoc")]),_vm._v(" "),_c('span',[_vm._v("Convert to PDF, Word, EPUB...")])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex--column"},[_c('div',[_vm._v("Import Markdown")]),_vm._v(" "),_c('span',[_vm._v("Import a plain text file.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex--column"},[_c('div',[_vm._v("Import HTML")]),_vm._v(" "),_c('span',[_vm._v("Convert an HTML file to Markdown.")])])}]



/***/ }),
/* 2542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-bar__panel side-bar__panel--menu"},[_c('div',{staticClass:"side-bar__info"},[(_vm.loginToken)?_c('div',{staticClass:"menu-entry menu-entry--info flex flex--row flex--align-center"},[_c('div',{staticClass:"menu-entry__icon menu-entry__icon--image"},[_c('user-image',{attrs:{"user-id":_vm.userId}})],1),_vm._v(" "),_c('span',[_vm._v("Signed in as "),_c('b',[_vm._v(_vm._s(_vm.loginToken.name))]),_vm._v(".")])]):_vm._e(),_vm._v(" "),(_vm.syncToken)?_c('div',{staticClass:"menu-entry menu-entry--info flex flex--row flex--align-center"},[_c('div',{staticClass:"menu-entry__icon menu-entry__icon--image"},[_c('icon-provider',{attrs:{"provider-id":_vm.currentWorkspace.providerId}})],1),_vm._v(" "),(_vm.currentWorkspace.providerId === 'googleDriveAppData')?_c('span',[_c('b',[_vm._v(_vm._s(_vm.currentWorkspace.name))]),_vm._v(" synced with your Google Drive app data folder.\n      ")]):(_vm.currentWorkspace.providerId === 'googleDriveWorkspace')?_c('span',[_c('b',[_vm._v(_vm._s(_vm.currentWorkspace.name))]),_vm._v(" synced with a "),_c('a',{attrs:{"href":_vm.workspaceLocationUrl,"target":"_blank"}},[_vm._v("Google Drive folder")]),_vm._v(".\n      ")]):(_vm.currentWorkspace.providerId === 'couchdbWorkspace')?_c('span',[_c('b',[_vm._v(_vm._s(_vm.currentWorkspace.name))]),_vm._v(" synced with a "),_c('a',{attrs:{"href":_vm.workspaceLocationUrl,"target":"_blank"}},[_vm._v("CouchDB database")]),_vm._v(".\n      ")]):(_vm.currentWorkspace.providerId === 'githubWorkspace')?_c('span',[_c('b',[_vm._v(_vm._s(_vm.currentWorkspace.name))]),_vm._v(" synced with a "),_c('a',{attrs:{"href":_vm.workspaceLocationUrl,"target":"_blank"}},[_vm._v("GitHub repo")]),_vm._v(".\n      ")]):(_vm.currentWorkspace.providerId === 'gitlabWorkspace')?_c('span',[_c('b',[_vm._v(_vm._s(_vm.currentWorkspace.name))]),_vm._v(" synced with a "),_c('a',{attrs:{"href":_vm.workspaceLocationUrl,"target":"_blank"}},[_vm._v("GitLab project")]),_vm._v(".\n      ")]):_vm._e()]):_c('div',{staticClass:"menu-entry menu-entry--info flex flex--row flex--align-center"},[_c('div',{staticClass:"menu-entry__icon menu-entry__icon--disabled"},[_c('icon-sync-off')],1),_vm._v(" "),_c('span',[_c('b',[_vm._v(_vm._s(_vm.currentWorkspace.name))]),_vm._v(" not synced.")])])]),_vm._v(" "),(!_vm.loginToken)?_c('menu-entry',{nativeOn:{"click":function($event){return _vm.signin($event)}}},[_c('icon-login',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("Sign in with Google")]),_vm._v(" "),_c('span',[_vm._v("Sync your main workspace and unlock functionalities.")])],1):_vm._e(),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){_vm.setPanel('workspaces')}}},[_c('icon-database',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v(" "),_c('div',[(_vm.workspaceCount)?_c('div',{staticClass:"menu-entry__label menu-entry__label--count"},[_vm._v(_vm._s(_vm.workspaceCount))]):_vm._e(),_vm._v(" Workspaces")]),_vm._v(" "),_c('span',[_vm._v("Switch to another workspace.")])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){_vm.setPanel('sync')}}},[_c('icon-sync',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v(" "),_c('div',[(_vm.syncLocationCount)?_c('div',{staticClass:"menu-entry__label menu-entry__label--count"},[_vm._v(_vm._s(_vm.syncLocationCount))]):_vm._e(),_vm._v(" Synchronize")]),_vm._v(" "),_c('span',[_vm._v("Sync your files in the Cloud.")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){_vm.setPanel('publish')}}},[_c('icon-upload',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v(" "),_c('div',[(_vm.publishLocationCount)?_c('div',{staticClass:"menu-entry__label menu-entry__label--count"},[_vm._v(_vm._s(_vm.publishLocationCount))]):_vm._e(),_vm._v("Publish")]),_vm._v(" "),_c('span',[_vm._v("Export your files to the web.")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){_vm.setPanel('history')}}},[_c('icon-history',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("History")]),_vm._v(" "),_c('span',[_vm._v("Track and restore file revisions.")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.fileProperties($event)}}},[_c('icon-view-list',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("File properties")]),_vm._v(" "),_c('span',[_vm._v("Add metadata and configure extensions.")])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){_vm.setPanel('toc')}}},[_c('icon-toc',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v("\n    Table of contents\n  ")],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){_vm.setPanel('help')}}},[_c('icon-help-circle',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v("\n    Markdown cheat sheet\n  ")],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){_vm.setPanel('importExport')}}},[_c('icon-content-save',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v("\n    Import/export\n  ")],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.print($event)}}},[_c('icon-printer',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v("\n    Print\n  ")],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.badges($event)}}},[_c('icon-seal',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v(" "),_c('div',[_c('div',{staticClass:"menu-entry__label menu-entry__label--count"},[_vm._v(_vm._s(_vm.badgeCount)+"/"+_vm._s(_vm.featureCount))]),_vm._v(" Badges")]),_vm._v(" "),_c('span',[_vm._v("List application features and earned badges.")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.accounts($event)}}},[_c('icon-key',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v(" "),_c('div',[_c('div',{staticClass:"menu-entry__label menu-entry__label--count"},[_vm._v(_vm._s(_vm.accountCount))]),_vm._v(" Accounts")]),_vm._v(" "),_c('span',[_vm._v("Manage access to your external accounts.")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.templates($event)}}},[_c('icon-code-braces',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v(" "),_c('div',[_c('div',{staticClass:"menu-entry__label menu-entry__label--count"},[_vm._v(_vm._s(_vm.templateCount))]),_vm._v(" Templates")]),_vm._v(" "),_c('span',[_vm._v("Configure Handlebars templates for your exports.")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.settings($event)}}},[_c('icon-settings',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("Settings")]),_vm._v(" "),_c('span',[_vm._v("Tweak application and keyboard shortcuts.")])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){_vm.setPanel('workspaceBackups')}}},[_c('icon-content-save',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v("\n    Workspace backups\n  ")],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.reset($event)}}},[_c('icon-logout',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v("\n    Reset application\n  ")],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.about($event)}}},[_c('icon-help-circle',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v("\n    About StackEdit\n  ")],1)],1)}
var staticRenderFns = []



/***/ }),
/* 2543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-bar__panel side-bar__panel--menu"},[(_vm.isCurrentTemp)?_c('div',{staticClass:"side-bar__info"},[_c('p',[_vm._v(_vm._s(_vm.currentFileName)+" can't be published as it's a temporary file.")])]):_c('div',[(_vm.publishLocations.length)?_c('div',{staticClass:"side-bar__info"},[_c('p',[_vm._v(_vm._s(_vm.currentFileName)+" is already published.")]),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.requestPublish($event)}}},[_c('icon-upload',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("Publish now")]),_vm._v(" "),_c('span',[_vm._v("Update publications for "+_vm._s(_vm.currentFileName)+".")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.managePublish($event)}}},[_c('icon-view-list',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v(" "),_c('div',[_c('div',{staticClass:"menu-entry__label menu-entry__label--count"},[_vm._v(_vm._s(_vm.locationCount))]),_vm._v(" File publication")]),_vm._v(" "),_c('span',[_vm._v("Manage publication locations for "+_vm._s(_vm.currentFileName)+".")])],1)],1):(_vm.noToken)?_c('div',{staticClass:"side-bar__info"},[_c('p',[_vm._v("You have to link an account to start publishing files.")])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.bloggerTokens),function(token){return _c('div',{key:'blogger-' + token.sub},[_c('menu-entry',{nativeOn:{"click":function($event){_vm.publishBlogger(token)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"blogger"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("Publish to Blogger")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(token.name))])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){_vm.publishBloggerPage(token)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"bloggerPage"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("Publish to Blogger Page")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(token.name))])],1)],1)}),_vm._v(" "),_vm._l((_vm.dropboxTokens),function(token){return _c('div',{key:token.sub},[_c('menu-entry',{nativeOn:{"click":function($event){_vm.publishDropbox(token)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"dropbox"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("Publish to Dropbox")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(token.name))])],1)],1)}),_vm._v(" "),_vm._l((_vm.githubTokens),function(token){return _c('div',{key:token.sub},[_c('menu-entry',{nativeOn:{"click":function($event){_vm.publishGist(token)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"gist"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("Publish to Gist")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(token.name))])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){_vm.publishGithub(token)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"github"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("Publish to GitHub")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(token.name))])],1)],1)}),_vm._v(" "),_vm._l((_vm.gitlabTokens),function(token){return _c('div',{key:token.sub},[_c('menu-entry',{nativeOn:{"click":function($event){_vm.publishGitlab(token)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"gitlab"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("Publish to GitLab")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(token.name))])],1)],1)}),_vm._v(" "),_vm._l((_vm.googleDriveTokens),function(token){return _c('div',{key:token.sub},[_c('menu-entry',{nativeOn:{"click":function($event){_vm.publishGoogleDrive(token)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"googleDrive"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("Publish to Google Drive")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(token.name))])],1)],1)}),_vm._v(" "),_vm._l((_vm.wordpressTokens),function(token){return _c('div',{key:token.sub},[_c('menu-entry',{nativeOn:{"click":function($event){_vm.publishWordpress(token)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"wordpress"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("Publish to WordPress")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(token.name))])],1)],1)}),_vm._v(" "),_vm._l((_vm.zendeskTokens),function(token){return _c('div',{key:token.sub},[_c('menu-entry',{nativeOn:{"click":function($event){_vm.publishZendesk(token)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"zendesk"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("Publish to Zendesk Help Center")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(token.name)+" — "+_vm._s(token.subdomain))])],1)],1)}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.addBloggerAccount($event)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"blogger"},slot:"icon"}),_vm._v(" "),_c('span',[_vm._v("Add Blogger account")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.addDropboxAccount($event)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"dropbox"},slot:"icon"}),_vm._v(" "),_c('span',[_vm._v("Add Dropbox account")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.addGithubAccount($event)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"github"},slot:"icon"}),_vm._v(" "),_c('span',[_vm._v("Add GitHub account")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.addGitlabAccount($event)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"gitlab"},slot:"icon"}),_vm._v(" "),_c('span',[_vm._v("Add GitLab account")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.addGoogleDriveAccount($event)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"googleDrive"},slot:"icon"}),_vm._v(" "),_c('span',[_vm._v("Add Google Drive account")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.addWordpressAccount($event)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"wordpress"},slot:"icon"}),_vm._v(" "),_c('span',[_vm._v("Add WordPress account")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.addZendeskAccount($event)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"zendesk"},slot:"icon"}),_vm._v(" "),_c('span',[_vm._v("Add Zendesk account")])],1)],2)])}
var staticRenderFns = []



/***/ }),
/* 2544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-bar__panel side-bar__panel--menu"},[(_vm.isCurrentTemp)?_c('div',{staticClass:"side-bar__info"},[_c('p',[_vm._v(_vm._s(_vm.currentFileName)+" can't be synced as it's a temporary file.")])]):_c('div',[(_vm.syncLocations.length)?_c('div',{staticClass:"side-bar__info"},[_c('p',[_vm._v(_vm._s(_vm.currentFileName)+" is already synchronized.")]),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.requestSync($event)}}},[_c('icon-sync',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("Synchronize now")]),_vm._v(" "),_c('span',[_vm._v("Download / upload file changes.")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.manageSync($event)}}},[_c('icon-view-list',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v(" "),_c('div',[_c('div',{staticClass:"menu-entry__label menu-entry__label--count"},[_vm._v(_vm._s(_vm.locationCount))]),_vm._v(" File synchronization")]),_vm._v(" "),_c('span',[_vm._v("Manage synchronized locations for "+_vm._s(_vm.currentFileName)+".")])],1)],1):(_vm.noToken)?_c('div',{staticClass:"side-bar__info"},[_c('p',[_vm._v("You have to link an account to start syncing files.")])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.dropboxTokens),function(token){return _c('div',{key:token.sub},[_c('menu-entry',{nativeOn:{"click":function($event){_vm.openDropbox(token)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"dropbox"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("Open from Dropbox")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(token.name))])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){_vm.saveDropbox(token)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"dropbox"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("Save on Dropbox")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(token.name))])],1)],1)}),_vm._v(" "),_vm._l((_vm.githubTokens),function(token){return _c('div',{key:token.sub},[_c('menu-entry',{nativeOn:{"click":function($event){_vm.openGithub(token)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"github"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("Open from GitHub")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(token.name))])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){_vm.saveGithub(token)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"github"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("Save on GitHub")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(token.name))])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){_vm.saveGist(token)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"gist"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("Save on Gist")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(token.name))])],1)],1)}),_vm._v(" "),_vm._l((_vm.gitlabTokens),function(token){return _c('div',{key:token.sub},[_c('menu-entry',{nativeOn:{"click":function($event){_vm.openGitlab(token)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"gitlab"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("Open from GitLab")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(token.name))])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){_vm.saveGitlab(token)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"gitlab"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("Save on GitLab")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(token.name))])],1)],1)}),_vm._v(" "),_vm._l((_vm.googleDriveTokens),function(token){return _c('div',{key:token.sub},[_c('menu-entry',{nativeOn:{"click":function($event){_vm.openGoogleDrive(token)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"googleDrive"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("Open from Google Drive")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(token.name))])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){_vm.saveGoogleDrive(token)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"googleDrive"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("Save on Google Drive")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(token.name))])],1)],1)}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.addDropboxAccount($event)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"dropbox"},slot:"icon"}),_vm._v(" "),_c('span',[_vm._v("Add Dropbox account")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.addGithubAccount($event)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"github"},slot:"icon"}),_vm._v(" "),_c('span',[_vm._v("Add GitHub account")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.addGitlabAccount($event)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"gitlab"},slot:"icon"}),_vm._v(" "),_c('span',[_vm._v("Add GitLab account")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.addGoogleDriveAccount($event)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"googleDrive"},slot:"icon"}),_vm._v(" "),_c('span',[_vm._v("Add Google Drive account")])],1)],2)])}
var staticRenderFns = []



/***/ }),
/* 2545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-bar__panel side-bar__panel--menu"},[_c('input',{staticClass:"hidden-file",attrs:{"id":"import-backup-file-input","type":"file"},on:{"change":_vm.onImportBackup}}),_vm._v(" "),_c('label',{staticClass:"menu-entry button flex flex--row flex--align-center",attrs:{"for":"import-backup-file-input"}},[_c('div',{staticClass:"menu-entry__icon flex flex--column flex--center"},[_c('icon-content-save')],1),_vm._v(" "),_c('div',{staticClass:"flex flex--column"},[_vm._v("\n      Import workspace backup\n    ")])]),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.exportWorkspace($event)}}},[_c('icon-content-save',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v("\n    Export workspace backup\n  ")],1)],1)}
var staticRenderFns = []



/***/ }),
/* 2546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-bar__panel side-bar__panel--menu"},[_c('menu-entry',{nativeOn:{"click":function($event){return _vm.manageWorkspaces($event)}}},[_c('icon-database',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v(" "),_c('div',[_c('div',{staticClass:"menu-entry__label menu-entry__label--count"},[_vm._v(_vm._s(_vm.workspaceCount))]),_vm._v(" Manage workspaces")]),_vm._v(" "),_c('span',[_vm._v("List, rename, remove workspaces")])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.workspacesById),function(workspace,id){return _c('div',{key:id,staticClass:"workspace"},[_c('menu-entry',{attrs:{"href":workspace.url,"target":"_blank"}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":workspace.providerId},slot:"icon"}),_vm._v(" "),_c('div',{staticClass:"workspace__name"},[(_vm.currentWorkspace === workspace)?_c('div',{staticClass:"menu-entry__label"},[_vm._v("current")]):_vm._e(),_vm._v(_vm._s(workspace.name))])],1)],1)}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.addCouchdbWorkspace($event)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"couchdbWorkspace"},slot:"icon"}),_vm._v(" "),_c('span',[_vm._v("Add a "),_c('b',[_vm._v("CouchDB")]),_vm._v(" workspace")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.addGithubWorkspace($event)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"githubWorkspace"},slot:"icon"}),_vm._v(" "),_c('span',[_vm._v("Add a "),_c('b',[_vm._v("GitHub")]),_vm._v(" workspace")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.addGitlabWorkspace($event)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"gitlabWorkspace"},slot:"icon"}),_vm._v(" "),_c('span',[_vm._v("Add a "),_c('b',[_vm._v("GitLab")]),_vm._v(" workspace")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.addGoogleDriveWorkspace($event)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"googleDriveWorkspace"},slot:"icon"}),_vm._v(" "),_c('span',[_vm._v("Add a "),_c('b',[_vm._v("Google Drive")]),_vm._v(" workspace")])],1)],2)}
var staticRenderFns = []



/***/ }),
/* 2547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"menu-entry button flex flex--row flex--align-center",attrs:{"href":"javascript:void(0)"}},[_c('div',{staticClass:"menu-entry__icon flex flex--column flex--center"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"menu-entry__text flex flex--column"},[_vm._t("default")],2)])}
var staticRenderFns = []



/***/ }),
/* 2548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{staticClass:"modal__inner-1--about-modal",attrs:{"aria-label":"About"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"logo-background"}),_vm._v("\n    StackEdit on "),_c('a',{attrs:{"target":"_blank","href":"https://github.com/benweet/stackedit/"}},[_vm._v("GitHub")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://github.com/benweet/stackedit/issues"}},[_vm._v("Issue tracker")]),_vm._v(" — "),_c('a',{attrs:{"target":"_blank","href":"https://github.com/benweet/stackedit/releases"}},[_vm._v("Changelog")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://chrome.google.com/webstore/detail/iiooodelglhkcpgbajoejffhijaclcdg"}},[_vm._v("Chrome app")]),_vm._v(" — "),_c('a',{attrs:{"target":"_blank","href":"https://chrome.google.com/webstore/detail/ajehldoplanpchfokmeempkekhnhmoha"}},[_vm._v("Chrome extension")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://community.stackedit.io/"}},[_vm._v("Community")]),_vm._v(" — "),_c('a',{attrs:{"target":"_blank","href":"https://community.stackedit.io/c/how-to"}},[_vm._v("Tutos and How To")]),_vm._v(" "),_c('br'),_vm._v("\n    StackEdit on "),_c('a',{attrs:{"target":"_blank","href":"https://twitter.com/stackedit/"}},[_vm._v("Twitter")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('small',[_vm._v("© 2013-2019 Dock5 Software Ltd."),_c('br'),_vm._v("v"+_vm._s(_vm.version))]),_vm._v(" "),_c('h3',[_vm._v("FAQ")]),_vm._v(" "),_c('div',{staticClass:"faq",domProps:{"innerHTML":_vm._s(_vm.faq)}}),_vm._v(" "),_c('div',{staticClass:"modal__info"},[_vm._v("\n      For commercial support or custom development, please "),_c('a',{attrs:{"href":"mailto:stackedit.project@gmail.com"}},[_vm._v("contact us")]),_vm._v(".\n    ")]),_vm._v("\n    Licensed under an\n    "),_c('a',{attrs:{"target":"_blank","href":"http://www.apache.org/licenses/LICENSE-2.0"}},[_vm._v("Apache License")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"privacy_policy.html"}},[_vm._v("Privacy Policy")])]),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.config.resolve()}}},[_vm._v("Close")])])])}
var staticRenderFns = []



/***/ }),
/* 2549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{staticClass:"modal__inner-1--account-management",attrs:{"aria-label":"Manage external accounts"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-key')],1),_vm._v(" "),(_vm.entries.length)?_c('p',[_vm._v("StackEdit has access to the following external accounts:")]):_c('p',[_vm._v("StackEdit has no access to any external account yet.")]),_vm._v(" "),_c('div',_vm._l((_vm.entries),function(entry){return _c('div',{key:entry.token.sub,staticClass:"account-entry flex flex--column"},[_c('div',{staticClass:"account-entry__header flex flex--row flex--align-center"},[_c('div',{staticClass:"account-entry__icon flex flex--column flex--center"},[_c('icon-provider',{attrs:{"provider-id":entry.providerId}})],1),_vm._v(" "),_c('div',{staticClass:"account-entry__description"},[_vm._v("\n            "+_vm._s(entry.name)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"account-entry__buttons flex flex--row flex--center"},[_c('button',{directives:[{name:"title",rawName:"v-title",value:('Remove access'),expression:"'Remove access'"}],staticClass:"account-entry__button button",on:{"click":function($event){_vm.remove(entry)}}},[_c('icon-delete')],1)])]),_vm._v(" "),_c('div',{staticClass:"account-entry__row"},[(entry.userId)?_c('span',{staticClass:"account-entry__field"},[_c('b',[_vm._v("User ID:")]),_vm._v("\n            "+_vm._s(entry.userId)+"\n          ")]):_vm._e(),_vm._v(" "),(entry.url)?_c('span',{staticClass:"account-entry__field"},[_c('b',[_vm._v("URL:")]),_vm._v("\n            "+_vm._s(entry.url)+"\n          ")]):_vm._e(),_vm._v(" "),(entry.scopes)?_c('span',{staticClass:"account-entry__field"},[_c('b',[_vm._v("Scopes:")]),_vm._v("\n            "+_vm._s(entry.scopes.join(', '))+"\n          ")]):_vm._e()])])})),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.addBloggerAccount($event)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"blogger"},slot:"icon"}),_vm._v(" "),_c('span',[_vm._v("Add Blogger account")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.addDropboxAccount($event)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"dropbox"},slot:"icon"}),_vm._v(" "),_c('span',[_vm._v("Add Dropbox account")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.addGithubAccount($event)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"github"},slot:"icon"}),_vm._v(" "),_c('span',[_vm._v("Add GitHub account")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.addGitlabAccount($event)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"gitlab"},slot:"icon"}),_vm._v(" "),_c('span',[_vm._v("Add GitLab account")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.addGoogleDriveAccount($event)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"googleDrive"},slot:"icon"}),_vm._v(" "),_c('span',[_vm._v("Add Google Drive account")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.addGooglePhotosAccount($event)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"googlePhotos"},slot:"icon"}),_vm._v(" "),_c('span',[_vm._v("Add Google Photos account")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.addWordpressAccount($event)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"wordpress"},slot:"icon"}),_vm._v(" "),_c('span',[_vm._v("Add WordPress account")])],1),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.addZendeskAccount($event)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"zendesk"},slot:"icon"}),_vm._v(" "),_c('span',[_vm._v("Add Zendesk account")])],1)],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.config.resolve()}}},[_vm._v("Close")])])])}
var staticRenderFns = []



/***/ }),
/* 2550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{staticClass:"modal__inner-1--badge-management",attrs:{"aria-label":"Manage badges"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-seal')],1),_vm._v(" "),(_vm.badgeCount > 1)?_c('p',[_vm._v(_vm._s(_vm.badgeCount)+" badges earned")]):_c('p',[_vm._v(_vm._s(_vm.badgeCount)+" badge earned")]),_vm._v(" "),_vm._l((_vm.badgeTree),function(badge){return _c('div',{key:badge.featureId,staticClass:"badge-entry"},[_c('div',{staticClass:"flex flex--row"},[_c('icon-seal',{staticClass:"badge-entry__icon",class:{'badge-entry__icon--earned': badge.isEarned, 'badge-entry__icon--some-earned': badge.hasSomeEarned}}),_vm._v(" "),_c('div',[_c('span',{staticClass:"badge-entry__name",class:{'badge-entry__name--earned': badge.isEarned, 'badge-entry__name--some-earned': badge.hasSomeEarned}},[_vm._v(_vm._s(badge.name))]),_vm._v(" "),_c('span',{staticClass:"badge-entry__description"},[_vm._v("— "+_vm._s(badge.description))]),_vm._v(" "),(!_vm.shown[badge.featureId])?_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.show(badge.featureId)}}},[_vm._v("Show")]):_vm._l((badge.children),function(child){return _c('div',{key:child.featureId,staticClass:"badge-entry"},[_c('div',{staticClass:"flex flex--row"},[_c('icon-seal',{staticClass:"badge-entry__icon",class:{'badge-entry__icon--earned': child.isEarned}}),_vm._v(" "),_c('div',[_c('span',{staticClass:"badge-entry__name",class:{'badge-entry__name--earned': child.isEarned}},[_vm._v(_vm._s(child.name))]),_vm._v(" "),_c('span',{staticClass:"badge-entry__description"},[_vm._v("— "+_vm._s(child.description))])])],1)])})],2)],1)])})],2),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.config.resolve()}}},[_vm._v("Close")])])])}
var staticRenderFns = []



/***/ }),
/* 2551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{staticClass:"modal__inner-1--file-properties",attrs:{"aria-label":"File properties"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"tabs flex flex--row"},[_c('tab',{attrs:{"active":_vm.tab === 'simple'},on:{"click":function($event){_vm.setSimpleTab()}}},[_vm._v("\n          Simple properties\n        ")]),_vm._v(" "),_c('tab',{attrs:{"active":_vm.tab === 'yaml'},on:{"click":function($event){_vm.setYamlTab()}}},[_vm._v("\n          YAML properties\n        ")])],1),_vm._v(" "),(_vm.tab === 'simple')?_c('div',[_c('div',{staticClass:"modal__title"},[_vm._v("Extensions")]),_vm._v(" "),_c('div',{staticClass:"modal__sub-title"},[_vm._v("Configure the Markdown engine.")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Preset"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.preset),expression:"preset"}],staticClass:"textfield",attrs:{"slot":"field"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.preset=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}},slot:"field"},_vm._l((_vm.presets),function(preset,id){return _c('option',{key:id,domProps:{"value":preset}},[_vm._v("\n              "+_vm._s(preset)+"\n            ")])}))]),_vm._v(" "),_c('div',{staticClass:"modal__title"},[_vm._v("Metadata")]),_vm._v(" "),_c('div',{staticClass:"modal__sub-title"},[_vm._v("Add info to your publications (Wordpress, Blogger...).")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Title"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.title),expression:"title",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.title)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"})]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Author"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.author),expression:"author",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.author)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.author=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"})]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Tags","info":"comma-separated"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.tags),expression:"tags",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.tags)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.tags=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"})]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Categories","info":"comma-separated"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.categories),expression:"categories",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.categories)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.categories=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"})]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Excerpt"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.excerpt),expression:"excerpt",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.excerpt)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.excerpt=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"})]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Featured image"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.featuredImage),expression:"featuredImage",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.featuredImage)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.featuredImage=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"})]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Status"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.status),expression:"status",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.status)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.status=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_c('b',[_vm._v("Example:")]),_vm._v(" draft\n          ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Date","info":"YYYY-MM-DD"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.date),expression:"date",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.date)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.date=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"})])],1):_vm._e(),_vm._v(" "),(_vm.tab === 'yaml')?_c('div',[_c('div',{staticClass:"form-entry",attrs:{"role":"tabpanel","aria-label":"YAML properties"}},[_c('label',{staticClass:"form-entry__label"},[_vm._v("YAML")]),_vm._v(" "),_c('div',{staticClass:"form-entry__field"},[_c('code-editor',{key:"custom-properties",attrs:{"lang":"yaml","value":_vm.yamlProperties},on:{"changed":_vm.setYamlProperties}})],1)]),_vm._v(" "),_c('div',{staticClass:"modal__error modal__error--file-properties"},[_vm._v(_vm._s(_vm.error))]),_vm._v(" "),_c('div',{staticClass:"modal__info modal__info--multiline"},[_c('p',[_c('strong',[_vm._v("ProTip:")]),_vm._v(" You can manually toggle extensions:")]),_vm._v(" "),_c('pre',{staticClass:" language-yaml"},[_c('code',{staticClass:"prism  language-yaml"},[_c('span',{staticClass:"token key atrule"},[_vm._v("extensions")]),_c('span',{staticClass:"token punctuation"},[_vm._v(":")]),_vm._v("\n  "),_c('span',{staticClass:"token key atrule"},[_vm._v("emoji")]),_c('span',{staticClass:"token punctuation"},[_vm._v(":")]),_vm._v("\n    "),_c('span',{staticClass:"token comment"},[_vm._v("# Enable emoji shortcuts like :) :-(")]),_vm._v("\n    "),_c('span',{staticClass:"token key atrule"},[_vm._v("shortcuts")]),_c('span',{staticClass:"token punctuation"},[_vm._v(":")]),_vm._v(" "),_c('span',{staticClass:"token boolean important"},[_vm._v("true")]),_vm._v("\n")])]),_vm._v(" "),_c('p',[_vm._v("Use preset "),_c('code',[_vm._v("zero")]),_vm._v(" to make your own configuration:")]),_vm._v(" "),_c('pre',{staticClass:" language-yaml"},[_c('code',{staticClass:"prism  language-yaml"},[_c('span',{staticClass:"token key atrule"},[_vm._v("extensions")]),_c('span',{staticClass:"token punctuation"},[_vm._v(":")]),_vm._v("\n  "),_c('span',{staticClass:"token key atrule"},[_vm._v("preset")]),_c('span',{staticClass:"token punctuation"},[_vm._v(":")]),_vm._v(" zero\n  "),_c('span',{staticClass:"token key atrule"},[_vm._v("markdown")]),_c('span',{staticClass:"token punctuation"},[_vm._v(":")]),_vm._v("\n    "),_c('span',{staticClass:"token key atrule"},[_vm._v("table")]),_c('span',{staticClass:"token punctuation"},[_vm._v(":")]),_vm._v(" "),_c('span',{staticClass:"token boolean important"},[_vm._v("true")]),_vm._v("\n  "),_c('span',{staticClass:"token key atrule"},[_vm._v("katex")]),_c('span',{staticClass:"token punctuation"},[_vm._v(":")]),_vm._v("\n    "),_c('span',{staticClass:"token key atrule"},[_vm._v("enabled")]),_c('span',{staticClass:"token punctuation"},[_vm._v(":")]),_vm._v(" "),_c('span',{staticClass:"token boolean important"},[_vm._v("true")]),_vm._v("\n")])]),_vm._v(" "),_c('p',[_vm._v("For the full list of options, see "),_c('a',{attrs:{"href":"https://github.com/benweet/stackedit/blob/master/src/data/presets.js","target":"_blank"}},[_vm._v("here")]),_vm._v(".")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Export to HTML"}},[_c('div',{staticClass:"modal__content"},[_c('p',[_vm._v("Please choose a template for your "),_c('b',[_vm._v("HTML export")]),_vm._v(".")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Template"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTemplate),expression:"selectedTemplate"}],staticClass:"textfield",attrs:{"slot":"field"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedTemplate=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}},slot:"field"},_vm._l((_vm.allTemplatesById),function(template,id){return _c('option',{key:id,domProps:{"value":id}},[_vm._v("\n          "+_vm._s(template.name)+"\n        ")])})),_vm._v(" "),_c('div',{staticClass:"form-entry__actions"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.configureTemplates}},[_vm._v("Configure templates")])])])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{directives:[{name:"clipboard",rawName:"v-clipboard",value:(_vm.result),expression:"result"}],staticClass:"button button--copy",on:{"click":function($event){_vm.info('HTML copied to clipboard!')}}},[_vm._v("Copy")]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Insert image"}},[_c('div',{staticClass:"modal__content"},[_c('p',[_vm._v("Please provide a "),_c('b',[_vm._v("URL")]),_vm._v(" for your image.")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"URL","error":"url"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.url),expression:"url",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.url)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.resolve($event)},"input":function($event){if($event.target.composing){ return; }_vm.url=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"})]),_vm._v(" "),_vm._l((_vm.googlePhotosTokens),function(token){return _c('menu-entry',{key:token.sub,nativeOn:{"click":function($event){_vm.openGooglePhotos(token)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"googlePhotos"},slot:"icon"}),_vm._v(" "),_c('div',[_vm._v("Open from Google Photos")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(token.name))])],1)}),_vm._v(" "),_c('menu-entry',{nativeOn:{"click":function($event){return _vm.addGooglePhotosAccount($event)}}},[_c('icon-provider',{attrs:{"slot":"icon","provider-id":"googlePhotos"},slot:"icon"}),_vm._v(" "),_c('span',[_vm._v("Add Google Photos account")])],1)],2),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":_vm.resolve}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Insert link"}},[_c('div',{staticClass:"modal__content"},[_c('p',[_vm._v("Please provide a "),_c('b',[_vm._v("URL")]),_vm._v(" for your link.")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"URL","error":"url"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.url),expression:"url",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.url)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.resolve($event)},"input":function($event){if($event.target.composing){ return; }_vm.url=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"})])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":_vm.resolve}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Export with Pandoc"}},[_c('div',{staticClass:"modal__content"},[_c('p',[_vm._v("Please choose a format for your "),_c('b',[_vm._v("Pandoc export")]),_vm._v(".")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Template"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedFormat),expression:"selectedFormat"}],staticClass:"textfield",attrs:{"slot":"field"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedFormat=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}},slot:"field"},[_c('option',{attrs:{"value":"asciidoc"}},[_vm._v("AsciiDoc")]),_vm._v(" "),_c('option',{attrs:{"value":"context"}},[_vm._v("ConTeXt")]),_vm._v(" "),_c('option',{attrs:{"value":"epub"}},[_vm._v("EPUB")]),_vm._v(" "),_c('option',{attrs:{"value":"epub3"}},[_vm._v("EPUB v3")]),_vm._v(" "),_c('option',{attrs:{"value":"latex"}},[_vm._v("LaTeX")]),_vm._v(" "),_c('option',{attrs:{"value":"odt"}},[_vm._v("OpenOffice")]),_vm._v(" "),_c('option',{attrs:{"value":"pdf"}},[_vm._v("PDF")]),_vm._v(" "),_c('option',{attrs:{"value":"rst"}},[_vm._v("reStructuredText")]),_vm._v(" "),_c('option',{attrs:{"value":"rtf"}},[_vm._v("Rich Text Format")]),_vm._v(" "),_c('option',{attrs:{"value":"textile"}},[_vm._v("Textile")]),_vm._v(" "),_c('option',{attrs:{"value":"docx"}},[_vm._v("Word")])])])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Export to PDF"}},[_c('div',{staticClass:"modal__content"},[_c('p',[_vm._v("Please choose a template for your "),_c('b',[_vm._v("PDF export")]),_vm._v(".")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Template"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTemplate),expression:"selectedTemplate"}],staticClass:"textfield",attrs:{"slot":"field"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedTemplate=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}},slot:"field"},_vm._l((_vm.allTemplatesById),function(template,id){return _c('option',{key:id,domProps:{"value":id}},[_vm._v("\n          "+_vm._s(template.name)+"\n        ")])})),_vm._v(" "),_c('div',{staticClass:"form-entry__actions"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.configureTemplates}},[_vm._v("Configure templates")])])])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{staticClass:"modal__inner-1--publish-management",attrs:{"aria-label":"Manage publication locations"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-upload')],1),_vm._v(" "),(_vm.publishLocations.length)?_c('p',[_c('b',[_vm._v(_vm._s(_vm.currentFileName))]),_vm._v(" is published to the following location(s):")]):_c('p',[_c('b',[_vm._v(_vm._s(_vm.currentFileName))]),_vm._v(" is not published yet.")]),_vm._v(" "),_c('div',_vm._l((_vm.publishLocations),function(location){return _c('div',{key:location.id,staticClass:"publish-entry flex flex--column"},[_c('div',{staticClass:"publish-entry__header flex flex--row flex--align-center"},[_c('div',{staticClass:"publish-entry__icon flex flex--column flex--center"},[_c('icon-provider',{attrs:{"provider-id":location.providerId}})],1),_vm._v(" "),_c('div',{staticClass:"publish-entry__description"},[_vm._v("\n            "+_vm._s(location.description)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"publish-entry__buttons flex flex--row flex--center"},[_c('button',{directives:[{name:"title",rawName:"v-title",value:('Remove location'),expression:"'Remove location'"}],staticClass:"publish-entry__button button",on:{"click":function($event){_vm.remove(location)}}},[_c('icon-delete')],1)])]),_vm._v(" "),_c('div',{staticClass:"publish-entry__row flex flex--row flex--align-center"},[_c('div',{staticClass:"publish-entry__url"},[_vm._v("\n            "+_vm._s(location.url)+"\n          ")]),_vm._v(" "),(location.url)?_c('div',{staticClass:"publish-entry__buttons flex flex--row flex--center"},[_c('button',{directives:[{name:"clipboard",rawName:"v-clipboard",value:(location.url),expression:"location.url"},{name:"title",rawName:"v-title",value:('Copy URL'),expression:"'Copy URL'"}],staticClass:"publish-entry__button button",on:{"click":function($event){_vm.info('Location URL copied to clipboard!')}}},[_c('icon-content-copy')],1),_vm._v(" "),(location.url)?_c('a',{directives:[{name:"title",rawName:"v-title",value:('Open location'),expression:"'Open location'"}],staticClass:"publish-entry__button button",attrs:{"href":location.url,"target":"_blank"}},[_c('icon-open-in-new')],1):_vm._e()]):_vm._e()])])})),_vm._v(" "),(_vm.publishLocations.length)?_c('div',{staticClass:"modal__info"},[_c('b',[_vm._v("Tip:")]),_vm._v(" Removing a location won't delete any file.\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.config.resolve()}}},[_vm._v("Close")])])])}
var staticRenderFns = []



/***/ }),
/* 2558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{staticClass:"modal__inner-1--settings",attrs:{"aria-label":"Settings"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"tabs flex flex--row"},[_c('tab',{attrs:{"active":_vm.tab === 'custom'},on:{"click":function($event){_vm.tab = 'custom'}}},[_vm._v("\n        Custom settings\n      ")]),_vm._v(" "),_c('tab',{attrs:{"active":_vm.tab === 'default'},on:{"click":function($event){_vm.tab = 'default'}}},[_vm._v("\n        Default settings\n      ")])],1),_vm._v(" "),(_vm.tab === 'custom')?_c('div',{staticClass:"form-entry",attrs:{"role":"tabpanel","aria-label":"Custom settings"}},[_c('label',{staticClass:"form-entry__label"},[_vm._v("YAML")]),_vm._v(" "),_c('div',{staticClass:"form-entry__field form-entry__field--code-editor"},[_c('code-editor',{key:"custom-settings",attrs:{"lang":"yaml","value":_vm.customSettings},on:{"changed":_vm.setCustomSettings}})],1)]):(_vm.tab === 'default')?_c('div',{staticClass:"form-entry",attrs:{"role":"tabpanel","aria-label":"Default settings"}},[_c('label',{staticClass:"form-entry__label"},[_vm._v("YAML")]),_vm._v(" "),_c('div',{staticClass:"form-entry__field form-entry__field--code-editor"},[_c('code-editor',{key:"default-settings",attrs:{"lang":"yaml","value":_vm.defaultSettings,"disabled":"true"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal__error modal__error--settings"},[_vm._v(_vm._s(_vm.error))])]),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":_vm.resolve}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{staticClass:"modal__inner-1--sponsor",attrs:{"aria-label":"Sponsor"}},[_c('div',{staticClass:"modal__content"},[_c('p',[_vm._v("Please choose a "),_c('b',[_vm._v("PayPal")]),_vm._v(" option:")]),_vm._v(" "),_vm._l((_vm.buttons),function(button){return _c('a',{key:button.id,staticClass:"paypal-option button flex flex--row flex--center",attrs:{"href":button.link}},[_c('div',{staticClass:"flex flex--column"},[_c('div',[_vm._v(_vm._s(button.price)),(button.offer)?_c('div',{staticClass:"paypal-option__offer"},[_vm._v(_vm._s(button.offer))]):_vm._e()]),_vm._v(" "),_c('span',[_vm._v(_vm._s(button.description))])])])})],2),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")])])])}
var staticRenderFns = []



/***/ }),
/* 2560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{staticClass:"modal__inner-1--sync-management",attrs:{"aria-label":"Manage synchronized locations"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-sync')],1),_vm._v(" "),(_vm.syncLocations.length)?_c('p',[_c('b',[_vm._v(_vm._s(_vm.currentFileName))]),_vm._v(" is synchronized with the following location(s):")]):_c('p',[_c('b',[_vm._v(_vm._s(_vm.currentFileName))]),_vm._v(" is not synchronized yet.")]),_vm._v(" "),_c('div',_vm._l((_vm.syncLocations),function(location){return _c('div',{key:location.id,staticClass:"sync-entry flex flex--column"},[_c('div',{staticClass:"sync-entry__header flex flex--row flex--align-center"},[_c('div',{staticClass:"sync-entry__icon flex flex--column flex--center"},[_c('icon-provider',{attrs:{"provider-id":location.providerId}})],1),_vm._v(" "),_c('div',{staticClass:"sync-entry__description"},[_vm._v("\n            "+_vm._s(location.description)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"sync-entry__buttons flex flex--row flex--center"},[_c('button',{directives:[{name:"title",rawName:"v-title",value:('Remove location'),expression:"'Remove location'"}],staticClass:"sync-entry__button button",on:{"click":function($event){_vm.remove(location)}}},[_c('icon-delete')],1)])]),_vm._v(" "),_c('div',{staticClass:"sync-entry__row flex flex--row flex--align-center"},[_c('div',{staticClass:"sync-entry__url"},[_vm._v("\n            "+_vm._s(location.url || 'Google Drive app data')+"\n          ")]),_vm._v(" "),(location.url)?_c('div',{staticClass:"sync-entry__buttons flex flex--row flex--center"},[_c('button',{directives:[{name:"clipboard",rawName:"v-clipboard",value:(location.url),expression:"location.url"},{name:"title",rawName:"v-title",value:('Copy URL'),expression:"'Copy URL'"}],staticClass:"sync-entry__button button",on:{"click":function($event){_vm.info('Location URL copied to clipboard!')}}},[_c('icon-content-copy')],1),_vm._v(" "),(location.url)?_c('a',{directives:[{name:"title",rawName:"v-title",value:('Open location'),expression:"'Open location'"}],staticClass:"sync-entry__button button",attrs:{"href":location.url,"target":"_blank"}},[_c('icon-open-in-new')],1):_vm._e()]):_vm._e()])])})),_vm._v(" "),(_vm.syncLocations.length)?_c('div',{staticClass:"modal__info"},[_c('b',[_vm._v("Tip:")]),_vm._v(" Removing a location won't delete any file.\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.config.resolve()}}},[_vm._v("Close")])])])}
var staticRenderFns = []



/***/ }),
/* 2561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{staticClass:"modal__inner-1--templates",attrs:{"aria-label":"Manage templates"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"form-entry"},[_c('label',{staticClass:"form-entry__label",attrs:{"for":"template"}},[_vm._v("Template")]),_vm._v(" "),_c('div',{staticClass:"form-entry__field"},[(_vm.isEditing)?_c('input',{directives:[{name:"focus",rawName:"v-focus"},{name:"model",rawName:"v-model",value:(_vm.editingName),expression:"editingName"}],staticClass:"textfield",attrs:{"id":"template","type":"text"},domProps:{"value":(_vm.editingName)},on:{"blur":function($event){_vm.submitEdit()},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.submitEdit()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }$event.stopPropagation();_vm.submitEdit(true)}],"input":function($event){if($event.target.composing){ return; }_vm.editingName=$event.target.value}}}):_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedId),expression:"selectedId"}],staticClass:"textfield",attrs:{"id":"template"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.templates),function(template,id){return _c('option',{key:id,domProps:{"value":id}},[_vm._v("\n            "+_vm._s(template.name)+"\n          ")])}))]),_vm._v(" "),_c('div',{staticClass:"form-entry__actions flex flex--row flex--end"},[_c('button',{directives:[{name:"title",rawName:"v-title",value:('New template'),expression:"'New template'"}],staticClass:"form-entry__button button",on:{"click":_vm.create}},[_c('icon-file-plus')],1),_vm._v(" "),_c('button',{directives:[{name:"title",rawName:"v-title",value:('Copy template'),expression:"'Copy template'"}],staticClass:"form-entry__button button",on:{"click":_vm.copy}},[_c('icon-file-multiple')],1),_vm._v(" "),(!_vm.isReadOnly)?_c('button',{directives:[{name:"title",rawName:"v-title",value:('Rename template'),expression:"'Rename template'"}],staticClass:"form-entry__button button",on:{"click":function($event){_vm.isEditing = true}}},[_c('icon-pen')],1):_vm._e(),_vm._v(" "),(!_vm.isReadOnly)?_c('button',{directives:[{name:"title",rawName:"v-title",value:('Remove template'),expression:"'Remove template'"}],staticClass:"form-entry__button button",on:{"click":_vm.remove}},[_c('icon-delete')],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-entry"},[_c('label',{staticClass:"form-entry__label"},[_vm._v("Value")]),_vm._v(" "),_vm._l((_vm.templates),function(template,id){return (id === _vm.selectedId)?_c('div',{key:id,staticClass:"form-entry__field"},[_c('code-editor',{attrs:{"lang":"handlebars","value":template.value,"disabled":_vm.isReadOnly},on:{"changed":function($event){template.value = $event}}})],1):_vm._e()})],2),_vm._v(" "),(!_vm.isReadOnly)?_c('div',[(!_vm.showHelpers)?_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.showHelpers = true}}},[_vm._v("Add helpers")]):_c('div',{staticClass:"form-entry"},[_c('br'),_vm._v(" "),_c('label',{staticClass:"form-entry__label"},[_vm._v("Helpers")]),_vm._v(" "),_vm._l((_vm.templates),function(template,id){return (id === _vm.selectedId)?_c('div',{key:id,staticClass:"form-entry__field"},[_c('code-editor',{attrs:{"lang":"javascript","value":template.helpers},on:{"changed":function($event){template.helpers = $event}}})],1):_vm._e()})],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{staticClass:"modal__inner-1--workspace-management",attrs:{"aria-label":"Manage workspaces"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-database')],1),_vm._v(" "),_c('p',[_vm._v("The following workspaces are accessible:")]),_vm._v(" "),_vm._l((_vm.workspacesById),function(workspace,id){return _c('div',{key:id,staticClass:"workspace-entry flex flex--column"},[_c('div',{staticClass:"flex flex--column"},[_c('div',{staticClass:"workspace-entry__header flex flex--row flex--align-center"},[_c('div',{staticClass:"workspace-entry__icon"},[_c('icon-provider',{attrs:{"provider-id":workspace.providerId}})],1),_vm._v(" "),(_vm.editedId === id)?_c('input',{directives:[{name:"focus",rawName:"v-focus"},{name:"model",rawName:"v-model",value:(_vm.editingName),expression:"editingName"}],staticClass:"text-input",attrs:{"type":"text"},domProps:{"value":(_vm.editingName)},on:{"blur":function($event){_vm.submitEdit()},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.submitEdit()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }$event.stopPropagation();_vm.submitEdit(true)}],"input":function($event){if($event.target.composing){ return; }_vm.editingName=$event.target.value}}}):_c('div',{staticClass:"workspace-entry__name"},[_vm._v(_vm._s(workspace.name))]),_vm._v(" "),_c('div',{staticClass:"workspace-entry__buttons flex flex--row"},[_c('button',{directives:[{name:"title",rawName:"v-title",value:('Edit name'),expression:"'Edit name'"}],staticClass:"workspace-entry__button button",on:{"click":function($event){_vm.edit(id)}}},[_c('icon-pen')],1),_vm._v(" "),_c('button',{directives:[{name:"title",rawName:"v-title",value:('Remove'),expression:"'Remove'"}],staticClass:"workspace-entry__button button",on:{"click":function($event){_vm.remove(id)}}},[_c('icon-delete')],1)])]),_vm._v(" "),_c('div',{staticClass:"workspace-entry__row flex flex--row flex--align-center"},[_c('div',{staticClass:"workspace-entry__url"},[_vm._v("\n            "+_vm._s(workspace.url)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"workspace-entry__buttons flex flex--row"},[_c('button',{directives:[{name:"clipboard",rawName:"v-clipboard",value:(workspace.url),expression:"workspace.url"},{name:"title",rawName:"v-title",value:('Copy URL'),expression:"'Copy URL'"}],staticClass:"workspace-entry__button button",on:{"click":function($event){_vm.info('Workspace URL copied to clipboard!')}}},[_c('icon-content-copy')],1),_vm._v(" "),_c('a',{directives:[{name:"title",rawName:"v-title",value:('Open workspace'),expression:"'Open workspace'"}],staticClass:"workspace-entry__button button",attrs:{"href":workspace.url,"target":"_blank"}},[_c('icon-open-in-new')],1)])]),_vm._v(" "),(workspace.locationUrl)?_c('div',{staticClass:"workspace-entry__row flex flex--row flex--align-center"},[_c('div',{staticClass:"workspace-entry__url"},[_vm._v("\n            "+_vm._s(workspace.locationUrl)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"workspace-entry__buttons flex flex--row"},[_c('button',{directives:[{name:"clipboard",rawName:"v-clipboard",value:(workspace.locationUrl),expression:"workspace.locationUrl"},{name:"title",rawName:"v-title",value:('Copy URL'),expression:"'Copy URL'"}],staticClass:"workspace-entry__button button",on:{"click":function($event){_vm.info('Workspace URL copied to clipboard!')}}},[_c('icon-content-copy')],1),_vm._v(" "),_c('a',{directives:[{name:"title",rawName:"v-title",value:('Open workspace location'),expression:"'Open workspace location'"}],staticClass:"workspace-entry__button button",attrs:{"href":workspace.locationUrl,"target":"_blank"}},[_c('icon-open-in-new')],1)])]):_vm._e(),_vm._v(" "),_c('div',[(_vm.availableOffline[id])?_c('span',{staticClass:"workspace-entry__offline"},[_vm._v("\n            available offline\n          ")]):_vm._e()])])])})],2),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.config.resolve()}}},[_vm._v("Close")])])])}
var staticRenderFns = []



/***/ }),
/* 2563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-entry",attrs:{"error":_vm.error}},[_c('label',{staticClass:"form-entry__label",attrs:{"for":_vm.uid}},[_vm._v(_vm._s(_vm.label)),(_vm.info)?_c('span',{staticClass:"form-entry__label-info"},[_vm._v(" — "+_vm._s(_vm.info))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-entry__field"},[_vm._t("field")],2),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []



/***/ }),
/* 2564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal__inner-1",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal__inner-2"},[_c('button',{directives:[{name:"title",rawName:"v-title",value:('Close modal'),expression:"'Close modal'"}],staticClass:"modal__close-button button not-tabbable",on:{"click":function($event){_vm.config.reject()}}},[_c('icon-close')],1),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []



/***/ }),
/* 2565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs__tab flex flex--row",class:{'tabs__tab--active': _vm.active},attrs:{"role":"tab"}},[_c('a',{staticClass:"flex flex--column flex--center",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.$emit('click')}}},[_vm._t("default")],2)])}
var staticRenderFns = []



/***/ }),
/* 2566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Publish to Blogger Page"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"bloggerPage"}})],1),_vm._v(" "),_c('p',[_vm._v("Publish "),_c('b',[_vm._v(_vm._s(_vm.currentFileName))]),_vm._v(" to your "),_c('b',[_vm._v("Blogger Page")]),_vm._v(".")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Blog URL","error":"blogUrl"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.blogUrl),expression:"blogUrl",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.blogUrl)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.blogUrl=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_c('b',[_vm._v("Example:")]),_vm._v(" http://example.blogger.com/\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Existing page ID","info":"optional"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.pageId),expression:"pageId",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.pageId)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.pageId=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"})]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Template"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTemplate),expression:"selectedTemplate"}],staticClass:"textfield",attrs:{"slot":"field"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedTemplate=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}},slot:"field"},_vm._l((_vm.allTemplatesById),function(template,id){return _c('option',{key:id,domProps:{"value":id}},[_vm._v("\n          "+_vm._s(template.name)+"\n        ")])})),_vm._v(" "),_c('div',{staticClass:"form-entry__actions"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.configureTemplates}},[_vm._v("Configure templates")])])]),_vm._v(" "),_c('div',{staticClass:"modal__info"},[_c('b',[_vm._v("ProTip:")]),_vm._v(" You can provide a value for "),_c('code',[_vm._v("title")]),_vm._v(" in the "),_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.openFileProperties}},[_vm._v("file properties")]),_vm._v(".\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Publish to Blogger"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"blogger"}})],1),_vm._v(" "),_c('p',[_vm._v("Publish "),_c('b',[_vm._v(_vm._s(_vm.currentFileName))]),_vm._v(" to your "),_c('b',[_vm._v("Blogger")]),_vm._v(" site.")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Blog URL","error":"blogUrl"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.blogUrl),expression:"blogUrl",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.blogUrl)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.blogUrl=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_c('b',[_vm._v("Example:")]),_vm._v(" http://example.blogger.com/\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Existing post ID","info":"optional"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.postId),expression:"postId",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.postId)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.postId=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"})]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Template"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTemplate),expression:"selectedTemplate"}],staticClass:"textfield",attrs:{"slot":"field"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedTemplate=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}},slot:"field"},_vm._l((_vm.allTemplatesById),function(template,id){return _c('option',{key:id,domProps:{"value":id}},[_vm._v("\n          "+_vm._s(template.name)+"\n        ")])})),_vm._v(" "),_c('div',{staticClass:"form-entry__actions"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.configureTemplates}},[_vm._v("Configure templates")])])]),_vm._v(" "),_c('div',{staticClass:"modal__info"},[_c('b',[_vm._v("ProTip:")]),_vm._v(" You can provide values for "),_c('code',[_vm._v("title")]),_vm._v(", "),_c('code',[_vm._v("tags")]),_vm._v(",\n      "),_c('code',[_vm._v("status")]),_vm._v(" and "),_c('code',[_vm._v("date")]),_vm._v(" in the "),_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.openFileProperties}},[_vm._v("file properties")]),_vm._v(".\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Insert image"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"couchdb"}})],1),_vm._v(" "),_c('p',[_vm._v("Please provide your credentials to login to "),_c('b',[_vm._v("CouchDB")]),_vm._v(".")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Name","error":"name"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.name),expression:"name",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.name)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"})]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Password","error":"password"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.password),expression:"password",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"password"},domProps:{"value":(_vm.password)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"})])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Add CouchDB workspace"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"couchdb"}})],1),_vm._v(" "),_c('p',[_vm._v("Create a workspace synced with a "),_c('b',[_vm._v("CouchDB")]),_vm._v(" database.")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Database URL","error":"dbUrl"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.dbUrl),expression:"dbUrl",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.dbUrl)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.dbUrl=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_c('b',[_vm._v("Example:")]),_vm._v(" https://instance.smileupps.com/stackedit-workspace\n      ")]),_vm._v(" "),_c('div',{staticClass:"form-entry__actions"},[_c('a',{attrs:{"href":"https://community.stackedit.io/t/couchdb-workspace-setup/","target":"_blank"}},[_vm._v("How to setup?")])])])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Link Dropbox account"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"dropbox"}})],1),_vm._v(" "),_c('p',[_vm._v("Link your "),_c('b',[_vm._v("Dropbox")]),_vm._v(" account to "),_c('b',[_vm._v("StackEdit")]),_vm._v(".")]),_vm._v(" "),_c('div',{staticClass:"form-entry"},[_c('div',{staticClass:"form-entry__checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.restrictedAccess),expression:"restrictedAccess"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.restrictedAccess)?_vm._i(_vm.restrictedAccess,null)>-1:(_vm.restrictedAccess)},on:{"change":function($event){var $$a=_vm.restrictedAccess,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.restrictedAccess=$$a.concat([$$v]))}else{$$i>-1&&(_vm.restrictedAccess=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.restrictedAccess=$$c}}}}),_vm._v(" Restrict access\n        ")]),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_vm._v("\n          If checked, access will be restricted to the "),_c('b',[_vm._v("/Applications/StackEdit (restricted)")]),_vm._v(" folder.\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.config.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Publish to Dropbox"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"dropbox"}})],1),_vm._v(" "),_c('p',[_vm._v("Publish "),_c('b',[_vm._v(_vm._s(_vm.currentFileName))]),_vm._v(" to your "),_c('b',[_vm._v("Dropbox")]),_vm._v(".")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"File path","error":"path"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.path),expression:"path",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.path)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.path=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_c('b',[_vm._v("Example:")]),_vm._v(" "+_vm._s(_vm.config.token.fullAccess ? '' : '/Applications/StackEdit (restricted)')+"/path/to/My Document.html"),_c('br'),_vm._v("\n        If the file exists, it will be overwritten.\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Template"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTemplate),expression:"selectedTemplate"}],staticClass:"textfield",attrs:{"slot":"field"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedTemplate=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}},slot:"field"},_vm._l((_vm.allTemplatesById),function(template,id){return _c('option',{key:id,domProps:{"value":id}},[_vm._v("\n          "+_vm._s(template.name)+"\n        ")])})),_vm._v(" "),_c('div',{staticClass:"form-entry__actions"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.configureTemplates}},[_vm._v("Configure templates")])])])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Synchronize with Dropbox"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"dropbox"}})],1),_vm._v(" "),_c('p',[_vm._v("Save "),_c('b',[_vm._v(_vm._s(_vm.currentFileName))]),_vm._v(" to your "),_c('b',[_vm._v("Dropbox")]),_vm._v(" and keep it synced.")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"File path","error":"path"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.path),expression:"path",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.path)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.path=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_c('b',[_vm._v("Example:")]),_vm._v(" "+_vm._s(_vm.config.token.fullAccess ? '' : '/Applications/StackEdit (restricted)')+"/path/to/My Document.md"),_c('br'),_vm._v("\n        If the file exists, it will be overwritten.\n      ")])])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Publish to Gist"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"gist"}})],1),_vm._v(" "),_c('p',[_vm._v("Publish "),_c('b',[_vm._v(_vm._s(_vm.currentFileName))]),_vm._v(" to a "),_c('b',[_vm._v("Gist")]),_vm._v(".")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Filename","error":"filename"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.filename),expression:"filename",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.filename)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.filename=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"})]),_vm._v(" "),_c('div',{staticClass:"form-entry"},[_c('div',{staticClass:"form-entry__checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isPublic),expression:"isPublic"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isPublic)?_vm._i(_vm.isPublic,null)>-1:(_vm.isPublic)},on:{"change":function($event){var $$a=_vm.isPublic,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isPublic=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isPublic=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isPublic=$$c}}}}),_vm._v(" Public\n        ")])])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Existing Gist ID","info":"optional"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.gistId),expression:"gistId",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.gistId)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.gistId=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_vm._v("\n        If the file exists in the Gist, it will be overwritten.\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Template"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTemplate),expression:"selectedTemplate"}],staticClass:"textfield",attrs:{"slot":"field"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedTemplate=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}},slot:"field"},_vm._l((_vm.allTemplatesById),function(template,id){return _c('option',{key:id,domProps:{"value":id}},[_vm._v("\n          "+_vm._s(template.name)+"\n        ")])})),_vm._v(" "),_c('div',{staticClass:"form-entry__actions"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.configureTemplates}},[_vm._v("Configure templates")])])]),_vm._v(" "),_c('div',{staticClass:"modal__info"},[_c('b',[_vm._v("ProTip:")]),_vm._v(" You can provide a value for "),_c('code',[_vm._v("title")]),_vm._v(" in the "),_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.openFileProperties}},[_vm._v("file properties")]),_vm._v(".\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Synchronize with Gist"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"gist"}})],1),_vm._v(" "),_c('p',[_vm._v("Save "),_c('b',[_vm._v(_vm._s(_vm.currentFileName))]),_vm._v(" to a "),_c('b',[_vm._v("Gist")]),_vm._v(" and keep it synced.")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Filename","error":"filename"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.filename),expression:"filename",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.filename)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.filename=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"})]),_vm._v(" "),_c('div',{staticClass:"form-entry"},[_c('div',{staticClass:"form-entry__checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isPublic),expression:"isPublic"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isPublic)?_vm._i(_vm.isPublic,null)>-1:(_vm.isPublic)},on:{"change":function($event){var $$a=_vm.isPublic,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isPublic=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isPublic=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isPublic=$$c}}}}),_vm._v(" Public\n        ")])])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Existing Gist ID","info":"optional"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.gistId),expression:"gistId",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.gistId)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.gistId=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_vm._v("\n        If the file exists in the Gist, it will be overwritten.\n      ")])])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Link GitHub account"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"github"}})],1),_vm._v(" "),_c('p',[_vm._v("Link your "),_c('b',[_vm._v("GitHub")]),_vm._v(" account to "),_c('b',[_vm._v("StackEdit")]),_vm._v(".")]),_vm._v(" "),_c('div',{staticClass:"form-entry"},[_c('div',{staticClass:"form-entry__checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.repoFullAccess),expression:"repoFullAccess"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.repoFullAccess)?_vm._i(_vm.repoFullAccess,null)>-1:(_vm.repoFullAccess)},on:{"change":function($event){var $$a=_vm.repoFullAccess,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.repoFullAccess=$$a.concat([$$v]))}else{$$i>-1&&(_vm.repoFullAccess=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.repoFullAccess=$$c}}}}),_vm._v(" Grant access to your private repositories\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.config.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Synchronize with GitHub"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"github"}})],1),_vm._v(" "),_c('p',[_vm._v("Open a file from your "),_c('b',[_vm._v("GitHub")]),_vm._v(" repository and keep it synced.")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Repository URL","error":"repoUrl"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.repoUrl),expression:"repoUrl",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.repoUrl)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.repoUrl=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_c('b',[_vm._v("Example:")]),_vm._v(" https://github.com/owner/my-repo\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"File path","error":"path"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.path),expression:"path",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.path)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.path=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_c('b',[_vm._v("Example:")]),_vm._v(" path/to/README.md\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Branch","info":"optional"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.branch),expression:"branch",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.branch)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.branch=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_vm._v("\n        If not supplied, the "),_c('code',[_vm._v("master")]),_vm._v(" branch will be used.\n      ")])])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Publish to GitHub"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"github"}})],1),_vm._v(" "),_c('p',[_vm._v("Publish "),_c('b',[_vm._v(_vm._s(_vm.currentFileName))]),_vm._v(" to your "),_c('b',[_vm._v("GitHub")]),_vm._v(" repository.")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Repository URL","error":"repoUrl"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.repoUrl),expression:"repoUrl",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.repoUrl)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.repoUrl=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_c('b',[_vm._v("Example:")]),_vm._v(" https://github.com/owner/my-repo\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"File path","error":"path"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.path),expression:"path",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.path)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.path=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_c('b',[_vm._v("Example:")]),_vm._v(" path/to/README.md"),_c('br'),_vm._v("\n        If the file exists, it will be overwritten.\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Branch","info":"optional"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.branch),expression:"branch",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.branch)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.branch=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_vm._v("\n        If not supplied, the "),_c('code',[_vm._v("master")]),_vm._v(" branch will be used.\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Template"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTemplate),expression:"selectedTemplate"}],staticClass:"textfield",attrs:{"slot":"field"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedTemplate=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}},slot:"field"},_vm._l((_vm.allTemplatesById),function(template,id){return _c('option',{key:id,domProps:{"value":id}},[_vm._v("\n          "+_vm._s(template.name)+"\n        ")])})),_vm._v(" "),_c('div',{staticClass:"form-entry__actions"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.configureTemplates}},[_vm._v("Configure templates")])])])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Synchronize with GitHub"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"github"}})],1),_vm._v(" "),_c('p',[_vm._v("Save "),_c('b',[_vm._v(_vm._s(_vm.currentFileName))]),_vm._v(" to your "),_c('b',[_vm._v("GitHub")]),_vm._v(" repository and keep it synced.")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Repository URL","error":"repoUrl"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.repoUrl),expression:"repoUrl",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.repoUrl)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.repoUrl=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_c('b',[_vm._v("Example:")]),_vm._v(" https://github.com/owner/my-repo\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"File path","error":"path"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.path),expression:"path",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.path)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.path=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_c('b',[_vm._v("Example:")]),_vm._v(" path/to/README.md"),_c('br'),_vm._v("\n        If the file exists, it will be overwritten.\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Branch","info":"optional"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.branch),expression:"branch",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.branch)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.branch=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_vm._v("\n        If not supplied, the "),_c('code',[_vm._v("master")]),_vm._v(" branch will be used.\n      ")])])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Synchronize with GitHub"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"github"}})],1),_vm._v(" "),_c('p',[_vm._v("Create a workspace synced with a "),_c('b',[_vm._v("GitHub")]),_vm._v(" repository folder.")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Repository URL","error":"repoUrl"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.repoUrl),expression:"repoUrl",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.repoUrl)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.repoUrl=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_c('b',[_vm._v("Example:")]),_vm._v(" https://github.com/owner/my-repo\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Folder path","info":"optional"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.path),expression:"path",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.path)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.path=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_vm._v("\n        If not supplied, the root folder will be used.\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Branch","info":"optional"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.branch),expression:"branch",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.branch)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.branch=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_vm._v("\n        If not supplied, the "),_c('code',[_vm._v("master")]),_vm._v(" branch will be used.\n      ")])])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"GitLab account"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"gitlab"}})],1),_vm._v(" "),_c('p',[_vm._v("Link your "),_c('b',[_vm._v("GitLab")]),_vm._v(" account to "),_c('b',[_vm._v("StackEdit")]),_vm._v(".")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"GitLab URL","error":"serverUrl"}},[(_vm.config.forceServerUrl)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.config.forceServerUrl),expression:"config.forceServerUrl"}],staticClass:"textfield",attrs:{"slot":"field","type":"text","disabled":"disabled"},domProps:{"value":(_vm.config.forceServerUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.config, "forceServerUrl", $event.target.value)}},slot:"field"}):_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.serverUrl),expression:"serverUrl",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.serverUrl)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.serverUrl=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_c('b',[_vm._v("Example:")]),_vm._v(" https://gitlab.example.com/\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Application ID","error":"applicationId"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.applicationId),expression:"applicationId",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.applicationId)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.applicationId=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_vm._v("\n        You have to configure an OAuth2 Application with redirect URL "),_c('b',[_vm._v(_vm._s(_vm.redirectUrl))])]),_vm._v(" "),_c('div',{staticClass:"form-entry__actions"},[_c('a',{attrs:{"href":"https://docs.gitlab.com/ee/integration/oauth_provider.html","target":"_blank"}},[_vm._v("More info")])])])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Synchronize with GitLab"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"gitlab"}})],1),_vm._v(" "),_c('p',[_vm._v("Open a file from your "),_c('b',[_vm._v("GitLab")]),_vm._v(" project and keep it synced.")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Project URL","error":"projectUrl"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.projectUrl),expression:"projectUrl",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.projectUrl)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.projectUrl=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_c('b',[_vm._v("Example:")]),_vm._v(" "+_vm._s(_vm.config.token.serverUrl)+"/path/to/project\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"File path","error":"path"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.path),expression:"path",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.path)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.path=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_c('b',[_vm._v("Example:")]),_vm._v(" path/to/README.md\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Branch","info":"optional"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.branch),expression:"branch",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.branch)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.branch=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_vm._v("\n        If not supplied, the "),_c('code',[_vm._v("master")]),_vm._v(" branch will be used.\n      ")])])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Publish to GitLab"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"gitlab"}})],1),_vm._v(" "),_c('p',[_vm._v("Publish "),_c('b',[_vm._v(_vm._s(_vm.currentFileName))]),_vm._v(" to your "),_c('b',[_vm._v("GitLab")]),_vm._v(" project.")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Project URL","error":"projectUrl"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.projectUrl),expression:"projectUrl",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.projectUrl)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.projectUrl=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_c('b',[_vm._v("Example:")]),_vm._v(" "+_vm._s(_vm.config.token.serverUrl)+"/path/to/project\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"File path","error":"path"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.path),expression:"path",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.path)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.path=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_c('b',[_vm._v("Example:")]),_vm._v(" path/to/README.md"),_c('br'),_vm._v("\n        If the file exists, it will be overwritten.\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Branch","info":"optional"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.branch),expression:"branch",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.branch)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.branch=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_vm._v("\n        If not supplied, the "),_c('code',[_vm._v("master")]),_vm._v(" branch will be used.\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Template"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTemplate),expression:"selectedTemplate"}],staticClass:"textfield",attrs:{"slot":"field"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedTemplate=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}},slot:"field"},_vm._l((_vm.allTemplatesById),function(template,id){return _c('option',{key:id,domProps:{"value":id}},[_vm._v("\n          "+_vm._s(template.name)+"\n        ")])})),_vm._v(" "),_c('div',{staticClass:"form-entry__actions"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.configureTemplates}},[_vm._v("Configure templates")])])])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Synchronize with GitLab"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"gitlab"}})],1),_vm._v(" "),_c('p',[_vm._v("Save "),_c('b',[_vm._v(_vm._s(_vm.currentFileName))]),_vm._v(" to your "),_c('b',[_vm._v("GitLab")]),_vm._v(" project and keep it synced.")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Project URL","error":"projectUrl"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.projectUrl),expression:"projectUrl",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.projectUrl)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.projectUrl=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_c('b',[_vm._v("Example:")]),_vm._v(" "+_vm._s(_vm.config.token.serverUrl)+"/path/to/project\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"File path","error":"path"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.path),expression:"path",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.path)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.path=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_c('b',[_vm._v("Example:")]),_vm._v(" path/to/README.md"),_c('br'),_vm._v("\n        If the file exists, it will be overwritten.\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Branch","info":"optional"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.branch),expression:"branch",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.branch)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.branch=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_vm._v("\n        If not supplied, the "),_c('code',[_vm._v("master")]),_vm._v(" branch will be used.\n      ")])])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Synchronize with GitLab"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"gitlab"}})],1),_vm._v(" "),_c('p',[_vm._v("Create a workspace synced with a "),_c('b',[_vm._v("GitLab")]),_vm._v(" project folder.")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Project URL","error":"projectUrl"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.projectUrl),expression:"projectUrl",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.projectUrl)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.projectUrl=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_c('b',[_vm._v("Example:")]),_vm._v(" "+_vm._s(_vm.config.token.serverUrl)+"/path/to/project\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Folder path","info":"optional"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.path),expression:"path",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.path)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.path=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_vm._v("\n        If not supplied, the root folder will be used.\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Branch","info":"optional"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.branch),expression:"branch",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.branch)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.branch=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_vm._v("\n        If not supplied, the "),_c('code',[_vm._v("master")]),_vm._v(" branch will be used.\n      ")])])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Link Google Drive account"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"googleDrive"}})],1),_vm._v(" "),_c('p',[_vm._v("Link your "),_c('b',[_vm._v("Google Drive")]),_vm._v(" account to "),_c('b',[_vm._v("StackEdit")]),_vm._v(".")]),_vm._v(" "),_c('div',{staticClass:"form-entry"},[_c('div',{staticClass:"form-entry__checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.restrictedAccess),expression:"restrictedAccess"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.restrictedAccess)?_vm._i(_vm.restrictedAccess,null)>-1:(_vm.restrictedAccess)},on:{"change":function($event){var $$a=_vm.restrictedAccess,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.restrictedAccess=$$a.concat([$$v]))}else{$$i>-1&&(_vm.restrictedAccess=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.restrictedAccess=$$c}}}}),_vm._v(" Restrict access\n        ")]),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_vm._v("\n          If checked, access will be restricted to files that you have opened or created with "),_c('b',[_vm._v("StackEdit")]),_vm._v(".\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.config.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Publish to Google Drive"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"googleDrive"}})],1),_vm._v(" "),_c('p',[_vm._v("Publish "),_c('b',[_vm._v(_vm._s(_vm.currentFileName))]),_vm._v(" to your "),_c('b',[_vm._v("Google Drive")]),_vm._v(" account.")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Folder ID","info":"optional"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.folderId),expression:"folderId",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.folderId)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.folderId=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_vm._v("\n        If not supplied, the file will be created in your Drive root folder.\n      ")]),_vm._v(" "),_c('div',{staticClass:"form-entry__actions"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.openFolder}},[_vm._v("Choose folder")])])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Existing file ID","info":"optional"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.fileId),expression:"fileId",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.fileId)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.fileId=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_vm._v("\n        This will overwrite the file on the server.\n      ")])]),_vm._v(" "),_c('div',{staticClass:"form-entry"},[_c('div',{staticClass:"form-entry__radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.format),expression:"format"}],attrs:{"type":"radio","value":"markdown"},domProps:{"checked":_vm._q(_vm.format,"markdown")},on:{"change":function($event){_vm.format="markdown"}}}),_vm._v(" Export Markdown\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-entry__radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.format),expression:"format"}],attrs:{"type":"radio","value":"html"},domProps:{"checked":_vm._q(_vm.format,"html")},on:{"change":function($event){_vm.format="html"}}}),_vm._v(" Export HTML\n        ")])])]),_vm._v(" "),(_vm.format === 'html')?_c('form-entry',{attrs:{"label":"Template"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTemplate),expression:"selectedTemplate"}],staticClass:"textfield",attrs:{"slot":"field"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedTemplate=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}},slot:"field"},_vm._l((_vm.allTemplatesById),function(template,id){return _c('option',{key:id,domProps:{"value":id}},[_vm._v("\n          "+_vm._s(template.name)+"\n        ")])})),_vm._v(" "),_c('div',{staticClass:"form-entry__actions"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.configureTemplates}},[_vm._v("Configure templates")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal__info"},[_c('b',[_vm._v("ProTip:")]),_vm._v(" You can provide a value for "),_c('code',[_vm._v("title")]),_vm._v(" in the "),_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.openFileProperties}},[_vm._v("file properties")]),_vm._v(".\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Synchronize with Google Drive"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"googleDrive"}})],1),_vm._v(" "),_c('p',[_vm._v("Save "),_c('b',[_vm._v(_vm._s(_vm.currentFileName))]),_vm._v(" to your "),_c('b',[_vm._v("Google Drive")]),_vm._v(" account and keep it synced.")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Folder ID","info":"optional"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.folderId),expression:"folderId",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.folderId)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.folderId=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_vm._v("\n        If not supplied, the file will be created in your Drive root folder.\n      ")]),_vm._v(" "),_c('div',{staticClass:"form-entry__actions"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.openFolder}},[_vm._v("Choose folder")])])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Existing file ID","info":"optional"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.fileId),expression:"fileId",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.fileId)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.fileId=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_vm._v("\n        This will overwrite the file on the server.\n      ")])])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Add Google Drive workspace"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"googleDrive"}})],1),_vm._v(" "),_c('p',[_vm._v("Create a workspace synced with a "),_c('b',[_vm._v("Google Drive")]),_vm._v(" folder.")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Folder ID","info":"optional"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.folderId),expression:"folderId",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.folderId)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.folderId=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_vm._v("\n        If not supplied, a new workspace folder will be created in your Drive root folder.\n      ")]),_vm._v(" "),_c('div',{staticClass:"form-entry__actions"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.openFolder}},[_vm._v("Choose folder")])])])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{staticClass:"modal__inner-1--google-photo",attrs:{"aria-label":"Import Google Photo"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"google-photo__tumbnail",style:({backgroundImage: _vm.thumbnailUrl})}),_vm._v(" "),_c('form-entry',{attrs:{"label":"Title","info":"optional"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.title),expression:"title",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.title)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"})]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Size limit","info":"optional"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.size),expression:"size",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.size)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.size=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"})])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Publish to WordPress"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"wordpress"}})],1),_vm._v(" "),_c('p',[_vm._v("Publish "),_c('b',[_vm._v(_vm._s(_vm.currentFileName))]),_vm._v(" to your "),_c('b',[_vm._v("WordPress")]),_vm._v(" site.")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Site domain","error":"domain"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.domain),expression:"domain",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.domain)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.domain=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_c('b',[_vm._v("Example:")]),_vm._v(" example.wordpress.com"),_c('br'),_vm._v(" "),_c('b',[_vm._v("Note:")]),_vm._v(" Jetpack is required for self-hosted sites.\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Existing post ID","info":"optional"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.postId),expression:"postId",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.postId)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.postId=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"})]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Template"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTemplate),expression:"selectedTemplate"}],staticClass:"textfield",attrs:{"slot":"field"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedTemplate=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}},slot:"field"},_vm._l((_vm.allTemplatesById),function(template,id){return _c('option',{key:id,domProps:{"value":id}},[_vm._v("\n          "+_vm._s(template.name)+"\n        ")])})),_vm._v(" "),_c('div',{staticClass:"form-entry__actions"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.configureTemplates}},[_vm._v("Configure templates")])])]),_vm._v(" "),_c('div',{staticClass:"modal__info"},[_c('b',[_vm._v("ProTip:")]),_vm._v(" You can provide values for "),_c('code',[_vm._v("title")]),_vm._v(", "),_c('code',[_vm._v("tags")]),_vm._v(",\n      "),_c('code',[_vm._v("categories")]),_vm._v(", "),_c('code',[_vm._v("excerpt")]),_vm._v(", "),_c('code',[_vm._v("author")]),_vm._v(", "),_c('code',[_vm._v("featuredImage")]),_vm._v(",\n      "),_c('code',[_vm._v("status")]),_vm._v(" and "),_c('code',[_vm._v("date")]),_vm._v(" in the "),_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.openFileProperties}},[_vm._v("file properties")]),_vm._v(".\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Link Zendesk account"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"zendesk"}})],1),_vm._v(" "),_c('p',[_vm._v("Link your "),_c('b',[_vm._v("Zendesk")]),_vm._v(" account to "),_c('b',[_vm._v("StackEdit")]),_vm._v(".")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Site URL","error":"siteUrl"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.siteUrl),expression:"siteUrl",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.siteUrl)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.siteUrl=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_c('b',[_vm._v("Example:")]),_vm._v(" https://example.zendesk.com/\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Client Unique Identifier","error":"clientId"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.clientId),expression:"clientId",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.clientId)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.clientId=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_vm._v("\n        You have to configure an OAuth Client with redirect URL "),_c('b',[_vm._v(_vm._s(_vm.redirectUrl))])]),_vm._v(" "),_c('div',{staticClass:"form-entry__actions"},[_c('a',{attrs:{"href":"https://support.zendesk.com/hc/en-us/articles/203663836","target":"_blank"}},[_vm._v("More info")])])])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-inner',{attrs:{"aria-label":"Publish to Zendesk"}},[_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"modal__image"},[_c('icon-provider',{attrs:{"provider-id":"zendesk"}})],1),_vm._v(" "),_c('p',[_vm._v("Publish "),_c('b',[_vm._v(_vm._s(_vm.currentFileName))]),_vm._v(" to your "),_c('b',[_vm._v("Zendesk Help Center")]),_vm._v(".")]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Section ID","error":"sectionId"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sectionId),expression:"sectionId",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.sectionId)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.sectionId=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_vm._v("\n        https://example.zendesk.com/hc/en-us/sections/"),_c('b',[_vm._v("21857469")]),_vm._v("-Section-name\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Existing article ID","info":"optional"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.articleId),expression:"articleId",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.articleId)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.articleId=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"})]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Locale","info":"optional"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.locale),expression:"locale",modifiers:{"trim":true}}],staticClass:"textfield",attrs:{"slot":"field","type":"text"},domProps:{"value":(_vm.locale)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"input":function($event){if($event.target.composing){ return; }_vm.locale=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}},slot:"field"}),_vm._v(" "),_c('div',{staticClass:"form-entry__info"},[_c('b',[_vm._v("Default:")]),_vm._v(" en-us\n      ")])]),_vm._v(" "),_c('form-entry',{attrs:{"label":"Template"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTemplate),expression:"selectedTemplate"}],staticClass:"textfield",attrs:{"slot":"field"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.resolve()},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedTemplate=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}},slot:"field"},_vm._l((_vm.allTemplatesById),function(template,id){return _c('option',{key:id,domProps:{"value":id}},[_vm._v("\n          "+_vm._s(template.name)+"\n        ")])})),_vm._v(" "),_c('div',{staticClass:"form-entry__actions"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.configureTemplates}},[_vm._v("Configure templates")])])]),_vm._v(" "),_c('div',{staticClass:"modal__info"},[_c('b',[_vm._v("ProTip:")]),_vm._v(" You can provide values for "),_c('code',[_vm._v("title")]),_vm._v(", "),_c('code',[_vm._v("tags")]),_vm._v(" and\n      "),_c('code',[_vm._v("status")]),_vm._v(" in the "),_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.openFileProperties}},[_vm._v("file properties")]),_vm._v(".\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"modal__button-bar"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.config.reject()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button button--resolve",on:{"click":function($event){_vm.resolve()}}},[_vm._v("Ok")])])])}
var staticRenderFns = []



/***/ }),
/* 2593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M 13,14L 11,14L 11,9.99998L 13,9.99998M 13,18L 11,18L 11,16L 13,16M 1,21L 23,21L 12,1.99998L 1,21 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M 20,11L 20,13L 7.98958,13L 13.4948,18.5052L 12.0806,19.9194L 4.16116,12L 12.0806,4.08058L 13.4948,5.49479L 7.98958,11L 20,11 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M 12,2C 17.5228,2 22,6.47716 22,12C 22,17.5228 17.5228,22 12,22C 6.47715,22 2,17.5228 2,12C 2,6.47716 6.47715,2 12,2 Z M 10.9999,16.5019L 17.9999,9.50193L 16.5859,8.08794L 10.9999,13.6739L 7.91391,10.5879L 6.49991,12.0019L 10.9999,16.5019 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"}})])}
var staticRenderFns = []



/***/ }),
/* 2597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M 8,3C 6.89543,3 6,3.89539 6,5L 6,9C 6,10.1046 5.10457,11 4,11L 3,11L 3,13L 4,13C 5.10457,13 6,13.8954 6,15L 6,19C 6,20.1046 6.92841,20.7321 8,21L 10,21L 10,19L 8,19L 8,14C 8,12.8954 7.10457,12 6,12C 7.10457,12 8,11.1046 8,10L 8,5L 10,5L 10,3M 16,3C 17.1046,3 18,3.89539 18,5L 18,9C 18,10.1046 18.8954,11 20,11L 21,11L 21,13L 20,13C 18.8954,13 18,13.8954 18,15L 18,19C 18,20.1046 17.0716,20.7321 16,21L 14,21L 14,19L 16,19L 16,14C 16,12.8954 16.8954,12 18,12C 16.8954,12 16,11.1046 16,10L 16,5L 14,5L 14,3L 16,3 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"2 2 20 20"}},[_c('path',{attrs:{"d":"M 14.6,16.6L 19.2,12L 14.6,7.4L 16,6L 22,12L 16,18L 14.6,16.6 Z M 9.4,16.6L 4.8,12L 9.4,7.4L 8,6L 2,12L 8,18L 9.4,16.6 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M 19,21L 8,21L 8,7L 19,7M 19,5L 8,5C 6.9,5 6,5.9 6,7L 6,21C 6,22.1 6.9,23 8,23L 19,23C 20.1,23 21,22.1 21,21L 21,7C 21,5.9 20.1,5 19,5 Z M 16,1L 4,1C 2.9,1 2,1.9 2,3L 2,17L 4,17L 4,3L 16,3L 16,1 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M15,9H5V5H15M12,19C10.34,19 9,17.66 9,16C9,14.34 10.34,13 12,13C13.66,13 15,14.34 15,16C15,17.66 13.66,19 12,19M17,3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V7L17,3Z"}})])}
var staticRenderFns = []



/***/ }),
/* 2601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12,3C7.58,3 4,4.79 4,7C4,9.21 7.58,11 12,11C16.42,11 20,9.21 20,7C20,4.79 16.42,3 12,3M4,9V12C4,14.21 7.58,16 12,16C16.42,16 20,14.21 20,12V9C20,11.21 16.42,13 12,13C7.58,13 4,11.21 4,9M4,14V17C4,19.21 7.58,21 12,21C16.42,21 20,19.21 20,17V14C20,16.21 16.42,18 12,18C7.58,18 4,16.21 4,14Z"}})])}
var staticRenderFns = []



/***/ }),
/* 2602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19C6,20.1 6.9,21 8,21H16C17.1,21 18,20.1 18,19V7H6V19Z"}})])}
var staticRenderFns = []



/***/ }),
/* 2603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M 16,12C 16,10.8954 16.8954,10 18,10C 19.1046,10 20,10.8954 20,12C 20,13.1046 19.1046,14 18,14C 16.8954,14 16,13.1046 16,12 Z M 10,12C 10,10.8954 10.8954,10 12,10C 13.1046,10 14,10.8954 14,12C 14,13.1046 13.1046,14 12,14C 10.8954,14 10,13.1046 10,12 Z M 4,12C 4,10.8954 4.89543,10 6,10C 7.10457,10 8,10.8954 8,12C 8,13.1046 7.10457,14 6,14C 4.89543,14 4,13.1046 4,12 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M 4.9994,19.9981L 18.9994,19.9981L 18.9994,17.9981L 4.9994,17.9981M 18.9994,8.99807L 14.9994,8.99807L 14.9994,2.99807L 8.9994,2.99807L 8.9994,8.99807L 4.9994,8.99807L 11.9994,15.9981L 18.9994,8.99807 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M 11.9994,8.99813C 10.3424,8.99813 8.99941,10.3411 8.99941,11.9981C 8.99941,13.6551 10.3424,14.9981 11.9994,14.9981C 13.6564,14.9981 14.9994,13.6551 14.9994,11.9981C 14.9994,10.3411 13.6564,8.99813 11.9994,8.99813 Z M 11.9994,16.9981C 9.23841,16.9981 6.99941,14.7591 6.99941,11.9981C 6.99941,9.23714 9.23841,6.99813 11.9994,6.99813C 14.7604,6.99813 16.9994,9.23714 16.9994,11.9981C 16.9994,14.7591 14.7604,16.9981 11.9994,16.9981 Z M 11.9994,4.49813C 6.99741,4.49813 2.72741,7.60915 0.99941,11.9981C 2.72741,16.3871 6.99741,19.4981 11.9994,19.4981C 17.0024,19.4981 21.2714,16.3871 22.9994,11.9981C 21.2714,7.60915 17.0024,4.49813 11.9994,4.49813 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M 12.9994,8.99807L 18.4994,8.99807L 12.9994,3.49807L 12.9994,8.99807 Z M 5.99938,1.99809L 13.9994,1.99809L 19.9994,7.99808L 19.9994,19.9981C 19.9994,21.1021 19.1034,21.9981 17.9994,21.9981L 5.98937,21.9981C 4.88537,21.9981 3.99939,21.1021 3.99939,19.9981L 4.0094,3.99808C 4.0094,2.89407 4.89437,1.99809 5.99938,1.99809 Z M 6,20L 15,20L 18,20L 18,12L 14,16L 12,14L 6,20 Z M 8,9C 6.89543,9 6,9.89543 6,11C 6,12.1046 6.89543,13 8,13C 9.10457,13 10,12.1046 10,11C 10,9.89543 9.10457,9 8,9 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 26 26"}},[_c('path',{attrs:{"d":"M15,7H20.5L15,1.5V7M8,0H16L22,6V18C22,19.1 21.1,20 20,20H8C6.89,20 6,19.1 6,18V2C6,0.9 6.9,0 8,0M4,4V22H20V24H4C2.9,24 2,23.1 2,22V4H4Z"}})])}
var staticRenderFns = []



/***/ }),
/* 2608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M11,15V12H9V15H6V17H9V20H11V17H14V15H11Z"}})])}
var staticRenderFns = []



/***/ }),
/* 2609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M10,4H4C2.89,4 2,4.89 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V8C22,6.89 21.1,6 20,6H12L10,4Z"}})])}
var staticRenderFns = []



/***/ }),
/* 2610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M10,4L12,6H20C21.1,6 22,6.9 22,8V18C22,19.1 21.1,20 20,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4H10M15,9V12H12V14H15V17H17V14H20V12H17V9H15Z"}})])}
var staticRenderFns = []



/***/ }),
/* 2611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{staticStyle:{"fill-rule":"nonzero"},attrs:{"d":"M13.35,17.401l-4.201,0l0,-3.601l4.201,0c0.997,0 1.801,0.805 1.801,1.801c0,0.996 -0.804,1.8 -1.801,1.8m-4.201,-10.802l3.601,0c0.996,0 1.801,0.804 1.801,1.8c0,0.996 -0.805,1.801 -1.801,1.801l-3.601,0m6.722,1.548c1.164,-0.816 1.98,-2.149 1.98,-3.349c0,-2.712 -2.1,-4.801 -4.801,-4.801l-7.502,0l0,16.804l8.45,0c2.521,0 4.454,-2.04 4.454,-4.549c0,-1.825 -1.033,-3.385 -2.581,-4.105Z"}})])}
var staticRenderFns = []



/***/ }),
/* 2612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{staticStyle:{"fill-rule":"nonzero"},attrs:{"d":"M8.617,3.658l0,3.575l2.633,0l-2.075,9.534l-3.325,0l0,3.575l9.533,0l0,-3.575l-2.633,0l2.075,-9.534l3.325,0l0,-3.575l-9.533,0Z"}})])}
var staticRenderFns = []



/***/ }),
/* 2613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{staticStyle:{"fill-rule":"nonzero"},attrs:{"d":"M7.043,4.695l14.61,0l0,2.087l-14.61,0l0,-2.087m0,8.349l0,-2.088l14.61,0l0,2.088l-14.61,0m-3.131,-8.871c0.866,0 1.566,0.699 1.566,1.565c0,0.867 -0.7,1.566 -1.566,1.566c-0.866,0 -1.565,-0.699 -1.565,-1.566c0,-0.866 0.699,-1.565 1.565,-1.565m0,6.262c0.866,0 1.566,0.699 1.566,1.565c0,0.866 -0.7,1.565 -1.566,1.565c-0.866,0 -1.565,-0.699 -1.565,-1.565c0,-0.866 0.699,-1.565 1.565,-1.565m3.131,8.87l0,-2.087l14.61,0l0,2.087l-14.61,0m-3.131,-2.609c0.866,0 1.566,0.699 1.566,1.566c0,0.866 -0.7,1.565 -1.566,1.565c-0.866,0 -1.565,-0.699 -1.565,-1.565c0,-0.867 0.699,-1.566 1.565,-1.566Z"}})])}
var staticRenderFns = []



/***/ }),
/* 2614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M3,5H9V11H3V5M5,7V9H7V7H5M11,7H21V9H11V7M11,15H21V17H11V15M5,20L1.5,16.5L2.91,15.09L5,17.17L9.59,12.59L11,14L5,20Z"}})])}
var staticRenderFns = []



/***/ }),
/* 2615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{staticStyle:{"fill-rule":"nonzero"},attrs:{"d":"M7.235,13.059l14.825,0l0,-2.118l-14.825,0m0,8.471l14.825,0l0,-2.117l-14.825,0m0,-10.59l14.825,0l0,-2.117l-14.825,0m-5.295,6.353l1.906,0l-1.906,2.224l0,0.953l3.177,0l0,-1.059l-1.906,0l1.906,-2.224l0,-0.953l-3.177,0m1.059,-2.118l1.059,0l0,-4.235l-2.118,0l0,1.059l1.059,0m-1.059,12.707l2.118,0l0,0.529l-1.059,0l0,1.059l1.059,0l0,0.529l-2.118,0l0,1.059l3.177,0l0,-4.235l-3.177,0l0,1.059Z"}})])}
var staticRenderFns = []



/***/ }),
/* 2616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{staticStyle:{"fill-rule":"nonzero"},attrs:{"d":"M14.446,18.235l2.92,0l1.946,-4.988l0,-7.482l-5.839,0l0,7.482l2.92,0m-10.732,4.988l2.919,0l1.947,-4.988l0,-7.482l-5.839,0l0,7.482l2.919,0l-1.946,4.988Z"}})])}
var staticRenderFns = []



/***/ }),
/* 2617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{staticStyle:{"fill-rule":"nonzero"},attrs:{"d":"M2.007,12.526l3.156,0l0,7.363l3.155,0l0,-7.363l3.156,0l0,-3.156l-9.467,0m6.311,-5.259l0,3.155l5.26,0l0,12.623l3.156,0l0,-12.623l5.259,0l0,-3.155l-13.675,0Z"}})])}
var staticRenderFns = []



/***/ }),
/* 2618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{staticStyle:{"fill-rule":"nonzero"},attrs:{"d":"M20.874,12.059l0,1.729l-3.541,0c0.806,1.851 0.766,6.918 -5.026,6.918c-6.721,0.043 -6.463,-5.621 -6.463,-5.621l3.203,0.044c0.024,2.914 2.55,2.914 3.05,2.879c0.516,-0.043 2.444,-0.034 2.598,-2.058c0.064,-0.942 -0.823,-1.66 -1.791,-2.162l-9.778,0l0,-1.729l17.748,0m-2.896,-3.554l-3.211,-0.026c0,0 0.137,-2.395 -2.646,-2.404c-2.783,-0.017 -2.541,1.902 -2.541,2.144c0.032,0.243 0.274,1.436 2.42,2.007l-5.074,0c0,0 -2.816,-5.82 4.057,-6.814c7.027,-1.038 7.011,5.11 6.995,5.093Z"}})])}
var staticRenderFns = []



/***/ }),
/* 2619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M 15.0661,11.2518L 14.1711,12.1697C 13.4471,12.8937 12.9991,13.4977 12.9991,14.9977L 10.9991,14.9977L 10.9991,14.4977C 10.9991,13.3937 11.4471,12.3937 12.1711,11.6697L 13.4141,10.4117C 13.7751,10.0497 13.9991,9.54974 13.9991,8.99774C 13.9991,7.89374 13.1041,6.99774 11.9991,6.99774C 10.8951,6.99774 9.99908,7.89374 9.99908,8.99774L 7.99908,8.99774C 7.99908,6.78876 9.7901,4.99774 11.9991,4.99774C 14.2091,4.99774 15.9991,6.78876 15.9991,8.99774C 15.9991,9.87775 15.6431,10.6747 15.0661,11.2518 Z M 12.9991,18.9977L 10.9991,18.9977L 10.9991,16.9977L 12.9991,16.9977M 11.9991,1.99774C 6.4761,1.99774 1.99908,6.47473 1.99908,11.9977C 1.99908,17.5217 6.4761,21.9977 11.9991,21.9977C 17.5231,21.9977 21.9991,17.5217 21.9991,11.9977C 21.9991,6.47473 17.5231,1.99774 11.9991,1.99774 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M11,7V12.11L15.71,14.9L16.5,13.62L12.5,11.25V7M12.5,2C8.97,2 5.91,3.92 4.27,6.77L2,4.5V11H8.5L5.75,8.25C6.96,5.73 9.5,4 12.5,4C16.64,4 20,7.36 20,11.5C20,15.64 16.64,19 12.5,19C9.23,19 6.47,16.91 5.44,14H3.34C4.44,18.03 8.11,21 12.5,21C17.74,21 22,16.75 22,11.5C22,6.25 17.75,2 12.5,2Z"}})])}
var staticRenderFns = []



/***/ }),
/* 2621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M 12.9994,8.99805L 10.9994,8.99805L 10.9994,6.99805L 12.9994,6.99805M 12.9994,16.998L 10.9994,16.998L 10.9994,10.998L 12.9994,10.998M 11.9994,1.99805C 6.47642,1.99805 1.99943,6.47504 1.99943,11.998C 1.99943,17.5211 6.47642,21.998 11.9994,21.998C 17.5224,21.998 21.9994,17.5211 21.9994,11.998C 21.9994,6.47504 17.5224,1.99805 11.9994,1.99805 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M 7,14C 5.9,14 5,13.1 5,12C 5,10.9 5.9,10 7,10C 8.1,10 9,10.9 9,12C 9,13.1 8.1,14 7,14 Z M 12.65,10C 11.83,7.67 9.61,6 7,6C 3.69,6 1,8.69 1,12C 1,15.31 3.69,18 7,18C 9.61,18 11.83,16.33 12.65,14L 17,14L 17,18L 21,18L 21,14L 23,14L 23,10L 12.65,10 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M 10.5858,13.4142C 10.9763,13.8047 10.9763,14.4379 10.5858,14.8284C 10.1952,15.2189 9.56207,15.2189 9.17154,14.8284C 7.21892,12.8758 7.21892,9.70995 9.17154,7.75733L 9.17157,7.75736L 12.707,4.2219C 14.6596,2.26928 17.8255,2.26929 19.7781,4.2219C 21.7307,6.17452 21.7307,9.34034 19.7781,11.293L 18.2925,12.7785C 18.3008,11.9583 18.1659,11.1368 17.8876,10.355L 18.3639,9.87865C 19.5355,8.70708 19.5355,6.80759 18.3639,5.63602C 17.1923,4.46445 15.2929,4.46445 14.1213,5.63602L 10.5858,9.17155C 9.41419,10.3431 9.41419,12.2426 10.5858,13.4142 Z M 13.4142,9.17155C 13.8047,8.78103 14.4379,8.78103 14.8284,9.17155C 16.781,11.1242 16.781,14.29 14.8284,16.2426L 14.8284,16.2426L 11.2929,19.7782C 9.34026,21.7308 6.17444,21.7308 4.22182,19.7782C 2.26921,17.8255 2.2692,14.6597 4.22182,12.7071L 5.70744,11.2215C 5.69913,12.0417 5.8341,12.8631 6.11234,13.645L 5.63601,14.1213C 4.46444,15.2929 4.46444,17.1924 5.63601,18.3639C 6.80758,19.5355 8.70708,19.5355 9.87865,18.3639L 13.4142,14.8284C 14.5858,13.6568 14.5858,11.7573 13.4142,10.5858C 13.0237,10.1952 13.0237,9.56207 13.4142,9.17155 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#000000","fill-opacity":"1","stroke-width":"0.2","stroke-linejoin":"round","d":"M 10,17.25L 10,14L 3.00002,14L 3.00002,10L 10,10L 10,6.75L 15.25,12L 10,17.25 Z M 7.99999,2.00003L 17,2.00005C 18.1045,2.00005 19,2.89546 19,4.00003L 19,20C 19,21.1046 18.1045,22 17,22L 7.99999,22C 6.89542,22 5.99999,21.1046 5.99999,20L 6,16L 7.99999,16L 7.99999,20L 17,20L 17,4.00003L 7.99999,4.00002L 7.99999,8.00001L 6,8.00001L 5.99999,4.00002C 5.99999,2.89545 6.89542,2.00003 7.99999,2.00003 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#000000","fill-opacity":"1","stroke-width":"0.2","stroke-linejoin":"round","d":"M 16.9999,17.25L 16.9999,14L 9.99998,14L 9.99998,10L 16.9999,10L 16.9999,6.75L 22.2499,12L 16.9999,17.25 Z M 13,2.00002C 14.1046,2.00002 15,2.89545 15,4.00002L 15,8L 13,8L 13,4.00002L 4,4.00004L 4,20L 13,20L 13,16L 15,16L 15,20C 15,21.1046 14.1046,22 13,22L 4,22C 2.89543,22 2,21.1046 2,20L 2,4.00004C 2,2.89547 2.89543,2.00006 4,2.00006L 13,2.00002 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M 9.5,3C 13.0899,3 16,5.91015 16,9.5C 16,11.1149 15.411,12.5923 14.4362,13.7291L 14.7071,14L 15.5,14L 20.5,19L 19,20.5L 14,15.5L 14,14.7071L 13.7291,14.4362C 12.5923,15.411 11.1149,16 9.5,16C 5.91015,16 3,13.0899 3,9.5C 3,5.91015 5.91015,3 9.5,3 Z M 9.5,5.00001C 7.01472,5.00001 5,7.01473 5,9.50001C 5,11.9853 7.01472,14 9.5,14C 11.9853,14 14,11.9853 14,9.50001C 14,7.01473 11.9853,5.00001 9.5,5.00001 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M 21.9891,3.99805C 21.9891,2.89404 21.1031,1.99805 19.9991,1.99805L 3.99913,1.99805C 2.89512,1.99805 1.99913,2.89404 1.99913,3.99805L 1.99913,15.998C 1.99913,17.1021 2.89512,17.998 3.99913,17.998L 17.9991,17.998L 21.9991,21.998L 21.9891,3.99805 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M19,8.977l-14,0l0,10l14,0m0,2l-14,0c-1.104,0 -2,-0.896 -2,-2l0,-10c0,-1.105 0.896,-2 2,-2l14,0c1.105,0 2,0.895 2,2l0,10c0,1.104 -0.895,2 -2,2Z"}}),_vm._v(" "),_c('rect',{attrs:{"x":"3","y":"3.023","width":"18","height":"2"}})])}
var staticRenderFns = []



/***/ }),
/* 2629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M 14,3L 14,5L 17.59,5L 7.76,14.83L 9.17,16.24L 19,6.41L 19,10L 21,10L 21,3M 19,19L 5,19L 5,5L 12,5L 12,3L 5,3C 3.89,3 3,3.9 3,5L 3,19C 3,20.1 3.89,21 5,21L 19,21C 20.1,21 21,20.1 21,19L 21,12L 19,12L 19,19 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M 16.8363,2.73375C 16.45,2.73375 16.0688,2.88125 15.7712,3.17375L 13.6525,5.2925L 18.955,10.5962L 21.0737,8.47625C 21.665,7.89 21.665,6.94375 21.0737,6.3575L 17.895,3.17375C 17.6025,2.88125 17.2163,2.73375 16.8363,2.73375 Z M 12.9437,6.00125L 4.84375,14.1062L 7.4025,14.39L 7.57875,16.675L 9.85875,16.85L 10.1462,19.4088L 18.2475,11.3038M 4.2475,15.0437L 2.515,21.7337L 9.19875,19.9412L 8.955,17.7838L 6.645,17.6075L 6.465,15.2925"}})])}
var staticRenderFns = []



/***/ }),
/* 2631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M18,3H6V7H18M19,12C18.45,12 18,11.55 18,11C18,10.45 18.45,10 19,10C19.55,10 20,10.45 20,11C20,11.55 19.55,12 19,12M16,19H8V14H16M19,8H5C3.34,8 2,9.34 2,11V17H6V21H18V17H22V11C22,9.34 20.66,8 19,8Z"}})])}
var staticRenderFns = []



/***/ }),
/* 2632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-provider",class:'icon-provider--' + _vm.classState},[(!_vm.classState)?_c('icon-sync-off'):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 2633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M18.4,10.6C16.55,9 14.15,8 11.5,8C6.85,8 2.92,11.03 1.54,15.22L3.9,16C4.95,12.81 7.95,10.5 11.5,10.5C13.45,10.5 15.23,11.22 16.62,12.38L13,16H22V7L18.4,10.6Z"}})])}
var staticRenderFns = []



/***/ }),
/* 2634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M9,18l3,0l-4,4l-4,-4l3,0l0,-3l2,0l0,3Zm8,0l3,0l-4,4l-4,-4l3,0l0,-3l2,0l0,3Zm0.055,-5l-10.11,0l0,-2l10.11,0l0,2Zm-8.055,-4l-2,0l0,-3l-3,0l4,-4l4,4l4,-4l4,4l-3,0l0,3l-2,0l0,-3l-6,0l0,3Z"}})])}
var staticRenderFns = []



/***/ }),
/* 2635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"1 1 23 23"}},[_c('path',{attrs:{"d":"M 20.3943,19.3706L 16.3828,17.9893L 15.0016,22.0008L 11.9248,15.9996L 8.99895,21.9986L 7.61768,17.9871L 3.60619,19.3683L 6.53159,13.3704C 5.57315,12.1727 5,10.6533 5,9C 5,5.13401 8.13401,2 12,2C 15.866,2 19,5.13401 19,9C 19,10.6535 18.4267,12.1731 17.468,13.3708L 20.3943,19.3706 Z M 7,9.00001L 9.68578,10.3429L 9.50615,13.3356L 12.012,11.6811L 14.514,13.333L 14.334,10.3356L 17.0156,8.9948L 14.323,7.64851L 14.5017,4.6727L 12.0162,6.31371L 9.49384,4.64828L 9.67477,7.66262L 7,9.00001 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M 11.9994,15.498C 10.0664,15.498 8.49939,13.931 8.49939,11.998C 8.49939,10.0651 10.0664,8.49805 11.9994,8.49805C 13.9324,8.49805 15.4994,10.0651 15.4994,11.998C 15.4994,13.931 13.9324,15.498 11.9994,15.498 Z M 19.4284,12.9741C 19.4704,12.6531 19.4984,12.329 19.4984,11.998C 19.4984,11.6671 19.4704,11.343 19.4284,11.022L 21.5414,9.36804C 21.7294,9.21606 21.7844,8.94604 21.6594,8.73004L 19.6594,5.26605C 19.5354,5.05005 19.2734,4.96204 19.0474,5.04907L 16.5584,6.05206C 16.0424,5.65607 15.4774,5.32104 14.8684,5.06903L 14.4934,2.41907C 14.4554,2.18103 14.2484,1.99805 13.9994,1.99805L 9.99939,1.99805C 9.74939,1.99805 9.5434,2.18103 9.5054,2.41907L 9.1304,5.06805C 8.52039,5.32104 7.95538,5.65607 7.43939,6.05206L 4.95139,5.04907C 4.7254,4.96204 4.46338,5.05005 4.33939,5.26605L 2.33939,8.73004C 2.21439,8.94604 2.26938,9.21606 2.4574,9.36804L 4.5694,11.022C 4.5274,11.342 4.49939,11.6671 4.49939,11.998C 4.49939,12.329 4.5274,12.6541 4.5694,12.9741L 2.4574,14.6271C 2.26938,14.78 2.21439,15.05 2.33939,15.2661L 4.33939,18.73C 4.46338,18.946 4.7254,19.0341 4.95139,18.947L 7.4404,17.944C 7.95639,18.34 8.52139,18.675 9.1304,18.9271L 9.5054,21.577C 9.5434,21.8151 9.74939,21.998 9.99939,21.998L 13.9994,21.998C 14.2484,21.998 14.4554,21.8151 14.4934,21.577L 14.8684,18.9271C 15.4764,18.6741 16.0414,18.34 16.5574,17.9431L 19.0474,18.947C 19.2734,19.0341 19.5354,18.946 19.6594,18.73L 21.6594,15.2661C 21.7844,15.05 21.7294,14.78 21.5414,14.6271L 19.4284,12.9741 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M11,20.977l-6,0c-1.104,0 -2,-0.896 -2,-2l0,-14c0,-1.105 0.896,-2 2,-2l14,0c1.105,0 2,0.895 2,2l0,14c0,1.104 -0.895,2 -2,2l-6,0l0,0.023l-2,0l0,-0.023Zm0,-2l0,-14l-6,0l0,14l6,0Zm8,-14l-6,0l0,14l6,0l0,-14Z"}})])}
var staticRenderFns = []



/***/ }),
/* 2638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M 18,3L 18,16.1777L 21,19.1777L 21,3L 18,3 Z M 4.27734,5L 3,6.2676L 10.7324,14L 8,14L 8,21L 11,21L 11,14.2676L 13,16.2676L 13,21L 16,21L 16,19.2676L 19.7324,23L 21,21.7227L 4.27734,5 Z M 13,9L 13,11.1777L 16,14.1777L 16,9L 13,9 Z M 3,18L 3,21L 6,21L 6,18L 3,18 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M19,15.023l-14,0l0,-10l14,0m0,-2l-14,0c-1.104,0 -2,0.896 -2,2l0,10c0,1.105 0.896,2 2,2l14,0c1.105,0 2,-0.895 2,-2l0,-10c0,-1.104 -0.895,-2 -2,-2Z"}}),_vm._v(" "),_c('rect',{attrs:{"x":"3","y":"18.977","width":"18","height":"2"}})])}
var staticRenderFns = []



/***/ }),
/* 2640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12,18C8.69,18 6,15.31 6,12C6,11 6.25,10.03 6.7,9.2L5.24,7.74C4.46,8.97 4,10.43 4,12C4,16.42 7.58,20 12,20V23L16,19L12,15M12,4V1L8,5L12,9V6C15.31,6 18,8.69 18,12C18,13 17.75,13.97 17.3,14.8L18.76,16.26C19.54,15.03 20,13.57 20,12C20,7.58 16.42,4 12,4Z"}})])}
var staticRenderFns = []



/***/ }),
/* 2641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M20,4H14V10L16.24,7.76C17.32,8.85 18,10.34 18,12C18,13 17.75,13.94 17.32,14.77L18.78,16.23C19.55,15 20,13.56 20,12C20,9.79 19.09,7.8 17.64,6.36L20,4M2.86,5.41L5.22,7.77C4.45,9 4,10.44 4,12C4,14.21 4.91,16.2 6.36,17.64L4,20H10V14L7.76,16.24C6.68,15.15 6,13.66 6,12C6,11 6.25,10.06 6.68,9.23L14.76,17.31C14.5,17.44 14.26,17.56 14,17.65V19.74C14.79,19.53 15.54,19.2 16.22,18.78L18.58,21.14L19.85,19.87L4.14,4.14L2.86,5.41M10,6.35V4.26C9.2,4.47 8.45,4.8 7.77,5.22L9.23,6.68C9.5,6.56 9.73,6.44 10,6.35Z"}})])}
var staticRenderFns = []



/***/ }),
/* 2642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M 5,4L 19,4C 20.1046,4 21,4.89543 21,6L 21,18C 21,19.1046 20.1046,20 19,20L 5,20C 3.89543,20 3,19.1046 3,18L 3,6C 3,4.89543 3.89543,4 5,4 Z M 5,8L 5,12L 11,12L 11,8L 5,8 Z M 13,8L 13,12L 19,12L 19,8L 13,8 Z M 5,14L 5,18L 11,18L 11,14L 5,14 Z M 13,14L 13,18L 19,18L 19,14L 13,14 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M 11.0013,2.0025L 11.0013,4.0725C 7.3825,4.53125 4.53125,7.3825 4.0725,11.0012L 2.0025,11.0012L 2.0025,12.9975L 4.0725,12.9975C 4.53125,16.6213 7.3825,19.4675 11.0013,19.9262L 11.0013,22.0025L 12.9975,22.0025L 12.9975,19.9313C 16.6212,19.4675 19.4675,16.6213 19.9263,12.9975L 22.0025,12.9975L 22.0025,11.0012L 19.9312,11.0012C 19.4675,7.3825 16.6212,4.53125 12.9975,4.0725L 12.9975,2.0025M 11.0013,6.08375L 11.0013,7.9975L 12.9975,7.9975L 12.9975,6.08875C 15.5175,6.51375 17.485,8.48625 17.915,11.0012L 16.0012,11.0012L 16.0012,12.9975L 17.91,12.9975C 17.485,15.5175 15.5125,17.485 12.9975,17.915L 12.9975,16.0012L 11.0013,16.0012L 11.0013,17.91C 8.48625,17.485 6.51375,15.5125 6.08375,12.9975L 7.9975,12.9975L 7.9975,11.0012L 6.08875,11.0012C 6.51375,8.48625 8.48625,6.51375 11.0013,6.08375 Z M 12.0025,11.0012C 11.445,11.0012 11.0013,11.445 11.0013,12.0025C 11.0013,12.5538 11.445,12.9975 12.0025,12.9975C 12.5537,12.9975 12.9975,12.5538 12.9975,12.0025C 12.9975,11.445 12.5537,11.0012 12.0025,11.0012 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M3 9h14V7H3v2zm0 4h14v-2H3v2zm0 4h14v-2H3v2zm16 0h2v-2h-2v2zm0-10v2h2V7h-2zm0 6h2v-2h-2v2z"}})])}
var staticRenderFns = []



/***/ }),
/* 2645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12.5,8C9.85,8 7.45,9 5.6,10.6L2,7V16H11L7.38,12.38C8.77,11.22 10.54,10.5 12.5,10.5C16.04,10.5 19.05,12.81 20.1,16L22.47,15.22C21.08,11.03 17.15,8 12.5,8Z"}})])}
var staticRenderFns = []



/***/ }),
/* 2646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M 8.99939,15.998L 8.99939,9.99805L 4.99939,9.99805L 11.9994,2.99805L 18.9994,9.99805L 14.9994,9.99805L 14.9994,15.998L 8.99939,15.998 Z M 4.99937,19.9981L 4.99937,17.9981L 18.9994,17.9981L 18.9994,19.9981L 4.99937,19.9981 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M 9,5L 9,9L 21,9L 21,5M 9,19L 21,19L 21,15L 9,15M 9,14L 21,14L 21,10L 9,10M 4,9L 8,9L 8,5L 4,5M 4,19L 8,19L 8,15L 4,15M 4,14L 8,14L 8,10L 4,10L 4,14 Z "}})])}
var staticRenderFns = []



/***/ }),
/* 2648 */,
/* 2649 */,
/* 2650 */,
/* 2651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function() {
  return new Worker(__webpack_require__.p + "1a700eddfc7d0f89cc6b.worker.js");
};

/***/ })
],[988]);


// WEBPACK FOOTER //
// static/js/app.d39fd2582912f11d86dc.js